/*! For license information please see bundle.js.LICENSE.txt */
!(function(e) {
  var t = {};
  function r(i) {
    if (t[i]) return t[i].exports;
    var n = (t[i] = { i: i, l: !1, exports: {} });
    return e[i].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
  }
  (r.m = e),
    (r.c = t),
    (r.d = function(e, t, i) {
      r.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
    }),
    (r.r = function(e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (r.t = function(e, t) {
      if ((1 & t && (e = r(e)), 8 & t)) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var i = Object.create(null);
      if ((r.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
        for (var n in e)
          r.d(
            i,
            n,
            function(t) {
              return e[t];
            }.bind(null, n)
          );
      return i;
    }),
    (r.n = function(e) {
      var t =
        e && e.__esModule
          ? function() {
              return e.default;
            }
          : function() {
              return e;
            };
      return r.d(t, "a", t), t;
    }),
    (r.o = function(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (r.p = ""),
    r((r.s = 30));
})([
  function(e, t, r) {
    var i;
    "undefined" != typeof window &&
      ((i = function() {
        return (function(e) {
          var t = {};
          function r(i) {
            if (t[i]) return t[i].exports;
            var n = (t[i] = { i: i, l: !1, exports: {} });
            return e[i].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
          }
          return (
            (r.m = e),
            (r.c = t),
            (r.d = function(e, t, i) {
              r.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
            }),
            (r.r = function(e) {
              "undefined" != typeof Symbol &&
                Symbol.toStringTag &&
                Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
                Object.defineProperty(e, "__esModule", { value: !0 });
            }),
            (r.t = function(e, t) {
              if ((1 & t && (e = r(e)), 8 & t)) return e;
              if (4 & t && "object" == typeof e && e && e.__esModule) return e;
              var i = Object.create(null);
              if (
                (r.r(i),
                Object.defineProperty(i, "default", { enumerable: !0, value: e }),
                2 & t && "string" != typeof e)
              )
                for (var n in e)
                  r.d(
                    i,
                    n,
                    function(t) {
                      return e[t];
                    }.bind(null, n)
                  );
              return i;
            }),
            (r.n = function(e) {
              var t =
                e && e.__esModule
                  ? function() {
                      return e.default;
                    }
                  : function() {
                      return e;
                    };
              return r.d(t, "a", t), t;
            }),
            (r.o = function(e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }),
            (r.p = "/dist/"),
            r((r.s = "./src/hls.ts"))
          );
        })({
          "./node_modules/eventemitter3/index.js": function(e, t, r) {
            "use strict";
            var i = Object.prototype.hasOwnProperty,
              n = "~";
            function s() {}
            function a(e, t, r) {
              (this.fn = e), (this.context = t), (this.once = r || !1);
            }
            function o(e, t, r, i, s) {
              if ("function" != typeof r) throw new TypeError("The listener must be a function");
              var o = new a(r, i || e, s),
                l = n ? n + t : t;
              return (
                e._events[l]
                  ? e._events[l].fn
                    ? (e._events[l] = [e._events[l], o])
                    : e._events[l].push(o)
                  : ((e._events[l] = o), e._eventsCount++),
                e
              );
            }
            function l(e, t) {
              0 == --e._eventsCount ? (e._events = new s()) : delete e._events[t];
            }
            function u() {
              (this._events = new s()), (this._eventsCount = 0);
            }
            Object.create && ((s.prototype = Object.create(null)), new s().__proto__ || (n = !1)),
              (u.prototype.eventNames = function() {
                var e,
                  t,
                  r = [];
                if (0 === this._eventsCount) return r;
                for (t in (e = this._events)) i.call(e, t) && r.push(n ? t.slice(1) : t);
                return Object.getOwnPropertySymbols ? r.concat(Object.getOwnPropertySymbols(e)) : r;
              }),
              (u.prototype.listeners = function(e) {
                var t = n ? n + e : e,
                  r = this._events[t];
                if (!r) return [];
                if (r.fn) return [r.fn];
                for (var i = 0, s = r.length, a = new Array(s); i < s; i++) a[i] = r[i].fn;
                return a;
              }),
              (u.prototype.listenerCount = function(e) {
                var t = n ? n + e : e,
                  r = this._events[t];
                return r ? (r.fn ? 1 : r.length) : 0;
              }),
              (u.prototype.emit = function(e, t, r, i, s, a) {
                var o = n ? n + e : e;
                if (!this._events[o]) return !1;
                var l,
                  u,
                  d = this._events[o],
                  c = arguments.length;
                if (d.fn) {
                  switch ((d.once && this.removeListener(e, d.fn, void 0, !0), c)) {
                    case 1:
                      return d.fn.call(d.context), !0;
                    case 2:
                      return d.fn.call(d.context, t), !0;
                    case 3:
                      return d.fn.call(d.context, t, r), !0;
                    case 4:
                      return d.fn.call(d.context, t, r, i), !0;
                    case 5:
                      return d.fn.call(d.context, t, r, i, s), !0;
                    case 6:
                      return d.fn.call(d.context, t, r, i, s, a), !0;
                  }
                  for (u = 1, l = new Array(c - 1); u < c; u++) l[u - 1] = arguments[u];
                  d.fn.apply(d.context, l);
                } else {
                  var h,
                    f = d.length;
                  for (u = 0; u < f; u++)
                    switch ((d[u].once && this.removeListener(e, d[u].fn, void 0, !0), c)) {
                      case 1:
                        d[u].fn.call(d[u].context);
                        break;
                      case 2:
                        d[u].fn.call(d[u].context, t);
                        break;
                      case 3:
                        d[u].fn.call(d[u].context, t, r);
                        break;
                      case 4:
                        d[u].fn.call(d[u].context, t, r, i);
                        break;
                      default:
                        if (!l) for (h = 1, l = new Array(c - 1); h < c; h++) l[h - 1] = arguments[h];
                        d[u].fn.apply(d[u].context, l);
                    }
                }
                return !0;
              }),
              (u.prototype.on = function(e, t, r) {
                return o(this, e, t, r, !1);
              }),
              (u.prototype.once = function(e, t, r) {
                return o(this, e, t, r, !0);
              }),
              (u.prototype.removeListener = function(e, t, r, i) {
                var s = n ? n + e : e;
                if (!this._events[s]) return this;
                if (!t) return l(this, s), this;
                var a = this._events[s];
                if (a.fn) a.fn !== t || (i && !a.once) || (r && a.context !== r) || l(this, s);
                else {
                  for (var o = 0, u = [], d = a.length; o < d; o++)
                    (a[o].fn !== t || (i && !a[o].once) || (r && a[o].context !== r)) && u.push(a[o]);
                  u.length ? (this._events[s] = 1 === u.length ? u[0] : u) : l(this, s);
                }
                return this;
              }),
              (u.prototype.removeAllListeners = function(e) {
                var t;
                return (
                  e
                    ? ((t = n ? n + e : e), this._events[t] && l(this, t))
                    : ((this._events = new s()), (this._eventsCount = 0)),
                  this
                );
              }),
              (u.prototype.off = u.prototype.removeListener),
              (u.prototype.addListener = u.prototype.on),
              (u.prefixed = n),
              (u.EventEmitter = u),
              (e.exports = u);
          },
          "./node_modules/url-toolkit/src/url-toolkit.js": function(e, t, r) {
            var i, n, s, a, o;
            (i = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/?#]*\/)*[^;?#]*)?(;[^?#]*)?(\?[^#]*)?(#[^]*)?$/),
              (n = /^([^\/?#]*)([^]*)$/),
              (s = /(?:\/|^)\.(?=\/)/g),
              (a = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g),
              (o = {
                buildAbsoluteURL: function(e, t, r) {
                  if (((r = r || {}), (e = e.trim()), !(t = t.trim()))) {
                    if (!r.alwaysNormalize) return e;
                    var i = o.parseURL(e);
                    if (!i) throw new Error("Error trying to parse base URL.");
                    return (i.path = o.normalizePath(i.path)), o.buildURLFromParts(i);
                  }
                  var s = o.parseURL(t);
                  if (!s) throw new Error("Error trying to parse relative URL.");
                  if (s.scheme)
                    return r.alwaysNormalize ? ((s.path = o.normalizePath(s.path)), o.buildURLFromParts(s)) : t;
                  var a = o.parseURL(e);
                  if (!a) throw new Error("Error trying to parse base URL.");
                  if (!a.netLoc && a.path && "/" !== a.path[0]) {
                    var l = n.exec(a.path);
                    (a.netLoc = l[1]), (a.path = l[2]);
                  }
                  a.netLoc && !a.path && (a.path = "/");
                  var u = {
                    scheme: a.scheme,
                    netLoc: s.netLoc,
                    path: null,
                    params: s.params,
                    query: s.query,
                    fragment: s.fragment
                  };
                  if (!s.netLoc && ((u.netLoc = a.netLoc), "/" !== s.path[0]))
                    if (s.path) {
                      var d = a.path,
                        c = d.substring(0, d.lastIndexOf("/") + 1) + s.path;
                      u.path = o.normalizePath(c);
                    } else (u.path = a.path), s.params || ((u.params = a.params), s.query || (u.query = a.query));
                  return (
                    null === u.path && (u.path = r.alwaysNormalize ? o.normalizePath(s.path) : s.path),
                    o.buildURLFromParts(u)
                  );
                },
                parseURL: function(e) {
                  var t = i.exec(e);
                  return t
                    ? {
                        scheme: t[1] || "",
                        netLoc: t[2] || "",
                        path: t[3] || "",
                        params: t[4] || "",
                        query: t[5] || "",
                        fragment: t[6] || ""
                      }
                    : null;
                },
                normalizePath: function(e) {
                  for (
                    e = e
                      .split("")
                      .reverse()
                      .join("")
                      .replace(s, "");
                    e.length !== (e = e.replace(a, "")).length;

                  );
                  return e
                    .split("")
                    .reverse()
                    .join("");
                },
                buildURLFromParts: function(e) {
                  return e.scheme + e.netLoc + e.path + e.params + e.query + e.fragment;
                }
              }),
              (e.exports = o);
          },
          "./node_modules/webworkify-webpack/index.js": function(e, t, r) {
            function i(e) {
              var t = {};
              function r(i) {
                if (t[i]) return t[i].exports;
                var n = (t[i] = { i: i, l: !1, exports: {} });
                return e[i].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
              }
              (r.m = e),
                (r.c = t),
                (r.i = function(e) {
                  return e;
                }),
                (r.d = function(e, t, i) {
                  r.o(e, t) || Object.defineProperty(e, t, { configurable: !1, enumerable: !0, get: i });
                }),
                (r.r = function(e) {
                  Object.defineProperty(e, "__esModule", { value: !0 });
                }),
                (r.n = function(e) {
                  var t =
                    e && e.__esModule
                      ? function() {
                          return e.default;
                        }
                      : function() {
                          return e;
                        };
                  return r.d(t, "a", t), t;
                }),
                (r.o = function(e, t) {
                  return Object.prototype.hasOwnProperty.call(e, t);
                }),
                (r.p = "/"),
                (r.oe = function(e) {
                  throw (console.error(e), e);
                });
              var i = r((r.s = ENTRY_MODULE));
              return i.default || i;
            }
            var n = "[\\.|\\-|\\+|\\w|/|@]+",
              s = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)";
            function a(e) {
              return (e + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
            }
            function o(e, t, i) {
              var o = {};
              o[i] = [];
              var l = t.toString(),
                u = l.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
              if (!u) return o;
              for (var d, c = u[1], h = new RegExp("(\\\\n|\\W)" + a(c) + s, "g"); (d = h.exec(l)); )
                "dll-reference" !== d[3] && o[i].push(d[3]);
              for (
                h = new RegExp("\\(" + a(c) + '\\("(dll-reference\\s(' + n + '))"\\)\\)' + s, "g");
                (d = h.exec(l));

              )
                e[d[2]] || (o[i].push(d[1]), (e[d[2]] = r(d[1]).m)), (o[d[2]] = o[d[2]] || []), o[d[2]].push(d[4]);
              for (var f, p = Object.keys(o), v = 0; v < p.length; v++)
                for (var g = 0; g < o[p[v]].length; g++)
                  (f = o[p[v]][g]), isNaN(1 * f) || (o[p[v]][g] = 1 * o[p[v]][g]);
              return o;
            }
            function l(e) {
              return Object.keys(e).reduce(function(t, r) {
                return t || e[r].length > 0;
              }, !1);
            }
            e.exports = function(e, t) {
              t = t || {};
              var n = { main: r.m },
                s = t.all
                  ? { main: Object.keys(n.main) }
                  : (function(e, t) {
                      for (var r = { main: [t] }, i = { main: [] }, n = { main: {} }; l(r); )
                        for (var s = Object.keys(r), a = 0; a < s.length; a++) {
                          var u = s[a],
                            d = r[u].pop();
                          if (((n[u] = n[u] || {}), !n[u][d] && e[u][d])) {
                            (n[u][d] = !0), (i[u] = i[u] || []), i[u].push(d);
                            for (var c = o(e, e[u][d], u), h = Object.keys(c), f = 0; f < h.length; f++)
                              (r[h[f]] = r[h[f]] || []), (r[h[f]] = r[h[f]].concat(c[h[f]]));
                          }
                        }
                      return i;
                    })(n, e),
                a = "";
              Object.keys(s)
                .filter(function(e) {
                  return "main" !== e;
                })
                .forEach(function(e) {
                  for (var t = 0; s[e][t]; ) t++;
                  s[e].push(t),
                    (n[e][t] =
                      "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })"),
                    (a =
                      a +
                      "var " +
                      e +
                      " = (" +
                      i.toString().replace("ENTRY_MODULE", JSON.stringify(t)) +
                      ")({" +
                      s[e]
                        .map(function(t) {
                          return JSON.stringify(t) + ": " + n[e][t].toString();
                        })
                        .join(",") +
                      "});\n");
                }),
                (a =
                  a +
                  "new ((" +
                  i.toString().replace("ENTRY_MODULE", JSON.stringify(e)) +
                  ")({" +
                  s.main
                    .map(function(e) {
                      return JSON.stringify(e) + ": " + n.main[e].toString();
                    })
                    .join(",") +
                  "}))(self);");
              var u = new window.Blob([a], { type: "text/javascript" });
              if (t.bare) return u;
              var d = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(u),
                c = new window.Worker(d);
              return (c.objectURL = d), c;
            };
          },
          "./src/config.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "hlsDefaultConfig", function() {
                return k;
              }),
              r.d(t, "mergeConfig", function() {
                return A;
              }),
              r.d(t, "enableStreamingMode", function() {
                return w;
              });
            var i = r("./src/controller/abr-controller.ts"),
              n = r("./src/controller/audio-stream-controller.ts"),
              s = r("./src/controller/audio-track-controller.ts"),
              a = r("./src/controller/subtitle-stream-controller.ts"),
              o = r("./src/controller/subtitle-track-controller.ts"),
              l = r("./src/controller/buffer-controller.ts"),
              u = r("./src/controller/timeline-controller.ts"),
              d = r("./src/controller/cap-level-controller.ts"),
              c = r("./src/controller/fps-controller.ts"),
              h = r("./src/controller/eme-controller.ts"),
              f = r("./src/controller/cmcd-controller.ts"),
              p = r("./src/utils/xhr-loader.ts"),
              v = r("./src/utils/fetch-loader.ts"),
              g = r("./src/utils/cues.ts"),
              m = r("./src/utils/mediakeys-helper.ts"),
              y = r("./src/utils/logger.ts");
            function E() {
              return (E =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            function T(e, t) {
              var r = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                t &&
                  (i = i.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  r.push.apply(r, i);
              }
              return r;
            }
            function b(e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? T(Object(r), !0).forEach(function(t) {
                      S(e, t, r[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
                    : T(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                      });
              }
              return e;
            }
            function S(e, t, r) {
              return (
                t in e
                  ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 })
                  : (e[t] = r),
                e
              );
            }
            var k = b(
              b(
                {
                  autoStartLoad: !0,
                  startPosition: -1,
                  defaultAudioCodec: void 0,
                  debug: !1,
                  capLevelOnFPSDrop: !1,
                  capLevelToPlayerSize: !1,
                  initialLiveManifestSize: 1,
                  maxBufferLength: 30,
                  backBufferLength: 1 / 0,
                  maxBufferSize: 6e7,
                  maxBufferHole: 0.1,
                  highBufferWatchdogPeriod: 2,
                  nudgeOffset: 0.1,
                  nudgeMaxRetry: 3,
                  maxFragLookUpTolerance: 0.25,
                  liveSyncDurationCount: 3,
                  liveMaxLatencyDurationCount: 1 / 0,
                  liveSyncDuration: void 0,
                  liveMaxLatencyDuration: void 0,
                  maxLiveSyncPlaybackRate: 1,
                  liveDurationInfinity: !1,
                  liveBackBufferLength: null,
                  maxMaxBufferLength: 600,
                  enableWorker: !0,
                  enableSoftwareAES: !0,
                  manifestLoadingTimeOut: 1e4,
                  manifestLoadingMaxRetry: 1,
                  manifestLoadingRetryDelay: 1e3,
                  manifestLoadingMaxRetryTimeout: 64e3,
                  startLevel: void 0,
                  levelLoadingTimeOut: 1e4,
                  levelLoadingMaxRetry: 4,
                  levelLoadingRetryDelay: 1e3,
                  levelLoadingMaxRetryTimeout: 64e3,
                  fragLoadingTimeOut: 2e4,
                  fragLoadingMaxRetry: 6,
                  fragLoadingRetryDelay: 1e3,
                  fragLoadingMaxRetryTimeout: 64e3,
                  startFragPrefetch: !1,
                  fpsDroppedMonitoringPeriod: 5e3,
                  fpsDroppedMonitoringThreshold: 0.2,
                  appendErrorMaxRetry: 3,
                  loader: p.default,
                  fLoader: void 0,
                  pLoader: void 0,
                  xhrSetup: void 0,
                  licenseXhrSetup: void 0,
                  licenseResponseCallback: void 0,
                  abrController: i.default,
                  bufferController: l.default,
                  capLevelController: d.default,
                  fpsController: c.default,
                  stretchShortVideoTrack: !1,
                  maxAudioFramesDrift: 1,
                  forceKeyFrameOnDiscontinuity: !0,
                  abrEwmaFastLive: 3,
                  abrEwmaSlowLive: 9,
                  abrEwmaFastVoD: 3,
                  abrEwmaSlowVoD: 9,
                  abrEwmaDefaultEstimate: 5e5,
                  abrBandWidthFactor: 0.95,
                  abrBandWidthUpFactor: 0.7,
                  abrMaxWithRealBitrate: !1,
                  maxStarvationDelay: 4,
                  maxLoadingDelay: 4,
                  minAutoBitrate: 0,
                  emeEnabled: !1,
                  widevineLicenseUrl: void 0,
                  drmSystemOptions: {},
                  requestMediaKeySystemAccessFunc: m.requestMediaKeySystemAccess,
                  testBandwidth: !0,
                  progressive: !1,
                  lowLatencyMode: !0,
                  cmcd: void 0
                },
                {
                  cueHandler: g.default,
                  enableCEA708Captions: !0,
                  enableWebVTT: !0,
                  enableIMSC1: !0,
                  captionsTextTrack1Label: "English",
                  captionsTextTrack1LanguageCode: "en",
                  captionsTextTrack2Label: "Spanish",
                  captionsTextTrack2LanguageCode: "es",
                  captionsTextTrack3Label: "Unknown CC",
                  captionsTextTrack3LanguageCode: "",
                  captionsTextTrack4Label: "Unknown CC",
                  captionsTextTrack4LanguageCode: "",
                  renderTextTracksNatively: !0
                }
              ),
              {},
              {
                subtitleStreamController: a.SubtitleStreamController,
                subtitleTrackController: o.default,
                timelineController: u.TimelineController,
                audioStreamController: n.default,
                audioTrackController: s.default,
                emeController: h.default,
                cmcdController: f.default
              }
            );
            function A(e, t) {
              if (
                (t.liveSyncDurationCount || t.liveMaxLatencyDurationCount) &&
                (t.liveSyncDuration || t.liveMaxLatencyDuration)
              )
                throw new Error(
                  "Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration"
                );
              if (
                void 0 !== t.liveMaxLatencyDurationCount &&
                (void 0 === t.liveSyncDurationCount || t.liveMaxLatencyDurationCount <= t.liveSyncDurationCount)
              )
                throw new Error(
                  'Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"'
                );
              if (
                void 0 !== t.liveMaxLatencyDuration &&
                (void 0 === t.liveSyncDuration || t.liveMaxLatencyDuration <= t.liveSyncDuration)
              )
                throw new Error(
                  'Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"'
                );
              return E({}, e, t);
            }
            function w(e) {
              var t = e.loader;
              t !== v.default && t !== p.default
                ? (y.logger.log("[config]: Custom loader detected, cannot enable progressive streaming"),
                  (e.progressive = !1))
                : Object(v.fetchSupported)() &&
                  ((e.loader = v.default),
                  (e.progressive = !0),
                  (e.enableSoftwareAES = !0),
                  y.logger.log("[config]: Progressive streaming enabled, using FetchLoader"));
            }
          },
          "./src/controller/abr-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/utils/ewma-bandwidth-estimator.ts"),
              s = r("./src/events.ts"),
              a = r("./src/utils/buffer-helper.ts"),
              o = r("./src/errors.ts"),
              l = r("./src/types/loader.ts"),
              u = r("./src/utils/logger.ts");
            function d(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var c = (function() {
              function e(e) {
                (this.hls = void 0),
                  (this.lastLoadedFragLevel = 0),
                  (this._nextAutoLevel = -1),
                  (this.timer = void 0),
                  (this.onCheck = this._abandonRulesCheck.bind(this)),
                  (this.fragCurrent = null),
                  (this.partCurrent = null),
                  (this.bitrateTestDelay = 0),
                  (this.bwEstimator = void 0),
                  (this.hls = e);
                var t = e.config;
                (this.bwEstimator = new n.default(t.abrEwmaSlowVoD, t.abrEwmaFastVoD, t.abrEwmaDefaultEstimate)),
                  this.registerListeners();
              }
              var t,
                r,
                c,
                h = e.prototype;
              return (
                (h.registerListeners = function() {
                  var e = this.hls;
                  e.on(s.Events.FRAG_LOADING, this.onFragLoading, this),
                    e.on(s.Events.FRAG_LOADED, this.onFragLoaded, this),
                    e.on(s.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                    e.on(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.on(s.Events.ERROR, this.onError, this);
                }),
                (h.unregisterListeners = function() {
                  var e = this.hls;
                  e.off(s.Events.FRAG_LOADING, this.onFragLoading, this),
                    e.off(s.Events.FRAG_LOADED, this.onFragLoaded, this),
                    e.off(s.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                    e.off(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.off(s.Events.ERROR, this.onError, this);
                }),
                (h.destroy = function() {
                  this.unregisterListeners(),
                    this.clearTimer(),
                    (this.hls = this.onCheck = null),
                    (this.fragCurrent = this.partCurrent = null);
                }),
                (h.onFragLoading = function(e, t) {
                  var r,
                    i = t.frag;
                  i.type === l.PlaylistLevelType.MAIN &&
                    (this.timer ||
                      ((this.fragCurrent = i),
                      (this.partCurrent = null != (r = t.part) ? r : null),
                      (this.timer = self.setInterval(this.onCheck, 100))));
                }),
                (h.onLevelLoaded = function(e, t) {
                  var r = this.hls.config;
                  t.details.live
                    ? this.bwEstimator.update(r.abrEwmaSlowLive, r.abrEwmaFastLive)
                    : this.bwEstimator.update(r.abrEwmaSlowVoD, r.abrEwmaFastVoD);
                }),
                (h._abandonRulesCheck = function() {
                  var e = this.fragCurrent,
                    t = this.partCurrent,
                    r = this.hls,
                    n = r.autoLevelEnabled,
                    o = r.config,
                    l = r.media;
                  if (e && l) {
                    var d = t ? t.stats : e.stats,
                      c = t ? t.duration : e.duration;
                    if (d.aborted)
                      return (
                        u.logger.warn("frag loader destroy or aborted, disarm abandonRules"),
                        this.clearTimer(),
                        void (this._nextAutoLevel = -1)
                      );
                    if (n && !l.paused && l.playbackRate && l.readyState) {
                      var h = performance.now() - d.loading.start,
                        f = Math.abs(l.playbackRate);
                      if (!(h <= (500 * c) / f)) {
                        var p = r.levels,
                          v = r.minAutoLevel,
                          g = p[e.level],
                          m = d.total || Math.max(d.loaded, Math.round((c * g.maxBitrate) / 8)),
                          y = Math.max(1, d.bwEstimate ? d.bwEstimate / 8 : (1e3 * d.loaded) / h),
                          E = (m - d.loaded) / y,
                          T = l.currentTime,
                          b = (a.BufferHelper.bufferInfo(l, T, o.maxBufferHole).end - T) / f;
                        if (!(b >= (2 * c) / f || E <= b)) {
                          var S,
                            k = Number.POSITIVE_INFINITY;
                          for (S = e.level - 1; S > v && !((k = (c * p[S].maxBitrate) / (6.4 * y)) < b); S--);
                          if (!(k >= E)) {
                            var A = this.bwEstimator.getEstimate();
                            u.logger.warn(
                              "Fragment " +
                                e.sn +
                                (t ? " part " + t.index : "") +
                                " of level " +
                                e.level +
                                " is loading too slowly and will cause an underbuffer; aborting and switching to level " +
                                S +
                                "\n      Current BW estimate: " +
                                (Object(i.isFiniteNumber)(A) ? (A / 1024).toFixed(3) : "Unknown") +
                                " Kb/s\n      Estimated load time for current fragment: " +
                                E.toFixed(3) +
                                " s\n      Estimated load time for the next fragment: " +
                                k.toFixed(3) +
                                " s\n      Time to underbuffer: " +
                                b.toFixed(3) +
                                " s"
                            ),
                              (r.nextLoadLevel = S),
                              this.bwEstimator.sample(h, d.loaded),
                              this.clearTimer(),
                              e.loader && ((this.fragCurrent = this.partCurrent = null), e.loader.abort()),
                              r.trigger(s.Events.FRAG_LOAD_EMERGENCY_ABORTED, { frag: e, part: t, stats: d });
                          }
                        }
                      }
                    }
                  }
                }),
                (h.onFragLoaded = function(e, t) {
                  var r = t.frag,
                    n = t.part;
                  if (r.type === l.PlaylistLevelType.MAIN && Object(i.isFiniteNumber)(r.sn)) {
                    var a = n ? n.stats : r.stats,
                      o = n ? n.duration : r.duration;
                    if (
                      (this.clearTimer(),
                      (this.lastLoadedFragLevel = r.level),
                      (this._nextAutoLevel = -1),
                      this.hls.config.abrMaxWithRealBitrate)
                    ) {
                      var u = this.hls.levels[r.level],
                        d = (u.loaded ? u.loaded.bytes : 0) + a.loaded,
                        c = (u.loaded ? u.loaded.duration : 0) + o;
                      (u.loaded = { bytes: d, duration: c }), (u.realBitrate = Math.round((8 * d) / c));
                    }
                    if (r.bitrateTest) {
                      var h = { stats: a, frag: r, part: n, id: r.type };
                      this.onFragBuffered(s.Events.FRAG_BUFFERED, h), (r.bitrateTest = !1);
                    }
                  }
                }),
                (h.onFragBuffered = function(e, t) {
                  var r = t.frag,
                    i = t.part,
                    n = i ? i.stats : r.stats;
                  if (!n.aborted && r.type === l.PlaylistLevelType.MAIN && "initSegment" !== r.sn) {
                    var s = n.parsing.end - n.loading.start;
                    this.bwEstimator.sample(s, n.loaded),
                      (n.bwEstimate = this.bwEstimator.getEstimate()),
                      r.bitrateTest ? (this.bitrateTestDelay = s / 1e3) : (this.bitrateTestDelay = 0);
                  }
                }),
                (h.onError = function(e, t) {
                  switch (t.details) {
                    case o.ErrorDetails.FRAG_LOAD_ERROR:
                    case o.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      this.clearTimer();
                  }
                }),
                (h.clearTimer = function() {
                  self.clearInterval(this.timer), (this.timer = void 0);
                }),
                (h.getNextABRAutoLevel = function() {
                  var e = this.fragCurrent,
                    t = this.partCurrent,
                    r = this.hls,
                    i = r.maxAutoLevel,
                    n = r.config,
                    s = r.minAutoLevel,
                    o = r.media,
                    l = t ? t.duration : e ? e.duration : 0,
                    d = o ? o.currentTime : 0,
                    c = o && 0 !== o.playbackRate ? Math.abs(o.playbackRate) : 1,
                    h = this.bwEstimator ? this.bwEstimator.getEstimate() : n.abrEwmaDefaultEstimate,
                    f = (a.BufferHelper.bufferInfo(o, d, n.maxBufferHole).end - d) / c,
                    p = this.findBestLevel(h, s, i, f, n.abrBandWidthFactor, n.abrBandWidthUpFactor);
                  if (p >= 0) return p;
                  u.logger.trace((f ? "rebuffering expected" : "buffer is empty") + ", finding optimal quality level");
                  var v = l ? Math.min(l, n.maxStarvationDelay) : n.maxStarvationDelay,
                    g = n.abrBandWidthFactor,
                    m = n.abrBandWidthUpFactor;
                  if (!f) {
                    var y = this.bitrateTestDelay;
                    y &&
                      ((v = (l ? Math.min(l, n.maxLoadingDelay) : n.maxLoadingDelay) - y),
                      u.logger.trace(
                        "bitrate test took " +
                          Math.round(1e3 * y) +
                          "ms, set first fragment max fetchDuration to " +
                          Math.round(1e3 * v) +
                          " ms"
                      ),
                      (g = m = 1));
                  }
                  return (p = this.findBestLevel(h, s, i, f + v, g, m)), Math.max(p, 0);
                }),
                (h.findBestLevel = function(e, t, r, i, n, s) {
                  for (
                    var a,
                      o = this.fragCurrent,
                      l = this.partCurrent,
                      d = this.lastLoadedFragLevel,
                      c = this.hls.levels,
                      h = c[d],
                      f = !(null == h || null === (a = h.details) || void 0 === a || !a.live),
                      p = null == h ? void 0 : h.codecSet,
                      v = l ? l.duration : o ? o.duration : 0,
                      g = r;
                    g >= t;
                    g--
                  ) {
                    var m = c[g];
                    if (m && (!p || m.codecSet === p)) {
                      var y = m.details,
                        E =
                          (l ? (null == y ? void 0 : y.partTarget) : null == y ? void 0 : y.averagetargetduration) || v,
                        T = void 0;
                      T = g <= d ? n * e : s * e;
                      var b = c[g].maxBitrate,
                        S = (b * E) / T;
                      if (
                        (u.logger.trace(
                          "level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " +
                            g +
                            "/" +
                            Math.round(T) +
                            "/" +
                            b +
                            "/" +
                            E +
                            "/" +
                            i +
                            "/" +
                            S
                        ),
                        T > b && (!S || (f && !this.bitrateTestDelay) || S < i))
                      )
                        return g;
                    }
                  }
                  return -1;
                }),
                (t = e),
                (r = [
                  {
                    key: "nextAutoLevel",
                    get: function() {
                      var e = this._nextAutoLevel,
                        t = this.bwEstimator;
                      if (!(-1 === e || (t && t.canEstimate()))) return e;
                      var r = this.getNextABRAutoLevel();
                      return -1 !== e && (r = Math.min(e, r)), r;
                    },
                    set: function(e) {
                      this._nextAutoLevel = e;
                    }
                  }
                ]) && d(t.prototype, r),
                c && d(t, c),
                e
              );
            })();
            t.default = c;
          },
          "./src/controller/audio-stream-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/controller/base-stream-controller.ts"),
              s = r("./src/events.ts"),
              a = r("./src/utils/buffer-helper.ts"),
              o = r("./src/controller/fragment-tracker.ts"),
              l = r("./src/types/level.ts"),
              u = r("./src/types/loader.ts"),
              d = r("./src/loader/fragment.ts"),
              c = r("./src/demux/chunk-cache.ts"),
              h = r("./src/demux/transmuxer-interface.ts"),
              f = r("./src/types/transmuxer.ts"),
              p = r("./src/controller/fragment-finders.ts"),
              v = r("./src/utils/discontinuities.ts"),
              g = r("./src/errors.ts"),
              m = r("./src/utils/logger.ts");
            function y() {
              return (y =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            function E(e, t) {
              return (E =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var T = (function(e) {
              var t, r;
              function T(t, r) {
                var i;
                return (
                  ((i = e.call(this, t, r, "[audio-stream-controller]") || this).videoBuffer = null),
                  (i.videoTrackCC = -1),
                  (i.waitingVideoCC = -1),
                  (i.audioSwitch = !1),
                  (i.trackId = -1),
                  (i.waitingData = null),
                  (i.mainDetails = null),
                  (i.bufferFlushed = !1),
                  i._registerListeners(),
                  i
                );
              }
              (r = e), ((t = T).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), E(t, r);
              var b = T.prototype;
              return (
                (b.onHandlerDestroying = function() {
                  this._unregisterListeners(), (this.mainDetails = null);
                }),
                (b._registerListeners = function() {
                  var e = this.hls;
                  e.on(s.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.on(s.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.on(s.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.on(s.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this),
                    e.on(s.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                    e.on(s.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                    e.on(s.Events.ERROR, this.onError, this),
                    e.on(s.Events.BUFFER_RESET, this.onBufferReset, this),
                    e.on(s.Events.BUFFER_CREATED, this.onBufferCreated, this),
                    e.on(s.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                    e.on(s.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                    e.on(s.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }),
                (b._unregisterListeners = function() {
                  var e = this.hls;
                  e.off(s.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.off(s.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.off(s.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.off(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.off(s.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this),
                    e.off(s.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                    e.off(s.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                    e.off(s.Events.ERROR, this.onError, this),
                    e.off(s.Events.BUFFER_RESET, this.onBufferReset, this),
                    e.off(s.Events.BUFFER_CREATED, this.onBufferCreated, this),
                    e.off(s.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                    e.off(s.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                    e.off(s.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }),
                (b.onInitPtsFound = function(e, t) {
                  var r = t.frag,
                    i = t.id,
                    s = t.initPTS;
                  if ("main" === i) {
                    var a = r.cc;
                    (this.initPTS[r.cc] = s),
                      this.log("InitPTS for cc: " + a + " found from main: " + s),
                      (this.videoTrackCC = a),
                      this.state === n.State.WAITING_INIT_PTS && this.tick();
                  }
                }),
                (b.startLoad = function(e) {
                  if (!this.levels) return (this.startPosition = e), void (this.state = n.State.STOPPED);
                  var t = this.lastCurrentTime;
                  this.stopLoad(),
                    this.setInterval(100),
                    (this.fragLoadError = 0),
                    t > 0 && -1 === e
                      ? (this.log("Override startPosition with lastCurrentTime @" + t.toFixed(3)),
                        (this.state = n.State.IDLE))
                      : ((this.loadedmetadata = !1), (this.state = n.State.WAITING_TRACK)),
                    (this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e),
                    this.tick();
                }),
                (b.doTick = function() {
                  switch (this.state) {
                    case n.State.IDLE:
                      this.doTickIdle();
                      break;
                    case n.State.WAITING_TRACK:
                      var t,
                        r = this.levels,
                        i = this.trackId,
                        s = null == r || null === (t = r[i]) || void 0 === t ? void 0 : t.details;
                      if (s) {
                        if (this.waitForCdnTuneIn(s)) break;
                        this.state = n.State.WAITING_INIT_PTS;
                      }
                      break;
                    case n.State.FRAG_LOADING_WAITING_RETRY:
                      var o,
                        l = performance.now(),
                        u = this.retryDate;
                      (!u || l >= u || (null !== (o = this.media) && void 0 !== o && o.seeking)) &&
                        (this.log("RetryDate reached, switch back to IDLE state"), (this.state = n.State.IDLE));
                      break;
                    case n.State.WAITING_INIT_PTS:
                      var d = this.waitingData;
                      if (d) {
                        var c = d.frag,
                          h = d.part,
                          f = d.cache,
                          v = d.complete;
                        if (void 0 !== this.initPTS[c.cc]) {
                          (this.waitingData = null), (this.waitingVideoCC = -1), (this.state = n.State.FRAG_LOADING);
                          var g = { frag: c, part: h, payload: f.flush(), networkDetails: null };
                          this._handleFragmentLoadProgress(g),
                            v && e.prototype._handleFragmentLoadComplete.call(this, g);
                        } else if (this.videoTrackCC !== this.waitingVideoCC)
                          m.logger.log(
                            "Waiting fragment cc (" + c.cc + ") cancelled because video is at cc " + this.videoTrackCC
                          ),
                            this.clearWaitingFragment();
                        else {
                          var y = this.getLoadPosition(),
                            E = a.BufferHelper.bufferInfo(this.mediaBuffer, y, this.config.maxBufferHole);
                          Object(p.fragmentWithinToleranceTest)(E.end, this.config.maxFragLookUpTolerance, c) < 0 &&
                            (m.logger.log(
                              "Waiting fragment cc (" +
                                c.cc +
                                ") @ " +
                                c.start +
                                " cancelled because another fragment at " +
                                E.end +
                                " is needed"
                            ),
                            this.clearWaitingFragment());
                        }
                      } else this.state = n.State.IDLE;
                  }
                  this.onTickEnd();
                }),
                (b.clearWaitingFragment = function() {
                  var e = this.waitingData;
                  e &&
                    (this.fragmentTracker.removeFragment(e.frag),
                    (this.waitingData = null),
                    (this.waitingVideoCC = -1),
                    (this.state = n.State.IDLE));
                }),
                (b.onTickEnd = function() {
                  var e = this.media;
                  if (e && e.readyState) {
                    var t = (this.mediaBuffer ? this.mediaBuffer : e).buffered;
                    !this.loadedmetadata && t.length && (this.loadedmetadata = !0),
                      (this.lastCurrentTime = e.currentTime);
                  }
                }),
                (b.doTickIdle = function() {
                  var e,
                    t,
                    r = this.hls,
                    i = this.levels,
                    a = this.media,
                    o = this.trackId,
                    l = r.config;
                  if (i && i[o] && (a || (!this.startFragRequested && l.startFragPrefetch))) {
                    var c = i[o].details;
                    if (!c || (c.live && this.levelLastLoaded !== o) || this.waitForCdnTuneIn(c))
                      this.state = n.State.WAITING_TRACK;
                    else {
                      this.bufferFlushed &&
                        ((this.bufferFlushed = !1),
                        this.afterBufferFlushed(
                          this.mediaBuffer ? this.mediaBuffer : this.media,
                          d.ElementaryStreamTypes.AUDIO,
                          u.PlaylistLevelType.AUDIO
                        ));
                      var h = this.getFwdBufferInfo(
                        this.mediaBuffer ? this.mediaBuffer : this.media,
                        u.PlaylistLevelType.AUDIO
                      );
                      if (null !== h) {
                        var f = h.len,
                          p = this.getMaxBufferLength(),
                          v = this.audioSwitch;
                        if (!(f >= p) || v) {
                          if (!v && this._streamEnded(h, c))
                            return r.trigger(s.Events.BUFFER_EOS, { type: "audio" }), void (this.state = n.State.ENDED);
                          var g = c.fragments[0].start,
                            m = h.end;
                          if (v) {
                            var y = this.getLoadPosition();
                            (m = y),
                              c.PTSKnown &&
                                y < g &&
                                (h.end > g || h.nextStart) &&
                                (this.log("Alt audio track ahead of main track, seek to start of alt audio track"),
                                (a.currentTime = g + 0.05));
                          }
                          var E = this.getNextFragment(m, c);
                          E
                            ? "identity" !== (null === (e = E.decryptdata) || void 0 === e ? void 0 : e.keyFormat) ||
                              (null !== (t = E.decryptdata) && void 0 !== t && t.key)
                              ? this.loadFragment(E, c, m)
                              : this.loadKey(E, c)
                            : (this.bufferFlushed = !0);
                        }
                      }
                    }
                  }
                }),
                (b.getMaxBufferLength = function() {
                  var t = e.prototype.getMaxBufferLength.call(this),
                    r = this.getFwdBufferInfo(
                      this.videoBuffer ? this.videoBuffer : this.media,
                      u.PlaylistLevelType.MAIN
                    );
                  return null === r ? t : Math.max(t, r.len);
                }),
                (b.onMediaDetaching = function() {
                  (this.videoBuffer = null), e.prototype.onMediaDetaching.call(this);
                }),
                (b.onAudioTracksUpdated = function(e, t) {
                  var r = t.audioTracks;
                  this.resetTransmuxer(),
                    (this.levels = r.map(function(e) {
                      return new l.Level(e);
                    }));
                }),
                (b.onAudioTrackSwitching = function(e, t) {
                  var r = !!t.url;
                  this.trackId = t.id;
                  var i = this.fragCurrent;
                  null != i && i.loader && i.loader.abort(),
                    (this.fragCurrent = null),
                    this.clearWaitingFragment(),
                    r ? this.setInterval(100) : this.resetTransmuxer(),
                    r ? ((this.audioSwitch = !0), (this.state = n.State.IDLE)) : (this.state = n.State.STOPPED),
                    this.tick();
                }),
                (b.onManifestLoading = function() {
                  (this.mainDetails = null),
                    this.fragmentTracker.removeAllFragments(),
                    (this.startPosition = this.lastCurrentTime = 0),
                    (this.bufferFlushed = !1);
                }),
                (b.onLevelLoaded = function(e, t) {
                  this.mainDetails = t.details;
                }),
                (b.onAudioTrackLoaded = function(e, t) {
                  var r,
                    i = this.levels,
                    s = t.details,
                    a = t.id;
                  if (i) {
                    this.log("Track " + a + " loaded [" + s.startSN + "," + s.endSN + "],duration:" + s.totalduration);
                    var o = i[a],
                      l = 0;
                    if (s.live || (null !== (r = o.details) && void 0 !== r && r.live)) {
                      var u = this.mainDetails;
                      if ((s.fragments[0] || (s.deltaUpdateFailed = !0), s.deltaUpdateFailed || !u)) return;
                      !o.details && s.hasProgramDateTime && u.hasProgramDateTime
                        ? (Object(v.alignMediaPlaylistByPDT)(s, u), (l = s.fragments[0].start))
                        : (l = this.alignPlaylists(s, o.details));
                    }
                    (o.details = s),
                      (this.levelLastLoaded = a),
                      this.startFragRequested || (!this.mainDetails && s.live) || this.setStartPosition(o.details, l),
                      this.state !== n.State.WAITING_TRACK || this.waitForCdnTuneIn(s) || (this.state = n.State.IDLE),
                      this.tick();
                  } else this.warn("Audio tracks were reset while loading level " + a);
                }),
                (b._handleFragmentLoadProgress = function(e) {
                  var t,
                    r = e.frag,
                    i = e.part,
                    s = e.payload,
                    a = this.config,
                    o = this.trackId,
                    l = this.levels;
                  if (l) {
                    var d = l[o];
                    console.assert(d, "Audio track is defined on fragment load progress");
                    var p = d.details;
                    console.assert(p, "Audio track details are defined on fragment load progress");
                    var v = a.defaultAudioCodec || d.audioCodec || "mp4a.40.2",
                      g = this.transmuxer;
                    g ||
                      (g = this.transmuxer = new h.default(
                        this.hls,
                        u.PlaylistLevelType.AUDIO,
                        this._handleTransmuxComplete.bind(this),
                        this._handleTransmuxerFlush.bind(this)
                      ));
                    var y = this.initPTS[r.cc],
                      E = null === (t = r.initSegment) || void 0 === t ? void 0 : t.data;
                    if (void 0 !== y) {
                      var T = i ? i.index : -1,
                        b = -1 !== T,
                        S = new f.ChunkMetadata(r.level, r.sn, r.stats.chunkCount, s.byteLength, T, b);
                      g.push(s, E, v, "", r, i, p.totalduration, !1, S, y);
                    } else
                      m.logger.log(
                        "Unknown video PTS for cc " +
                          r.cc +
                          ", waiting for video PTS before demuxing audio frag " +
                          r.sn +
                          " of [" +
                          p.startSN +
                          " ," +
                          p.endSN +
                          "],track " +
                          o
                      ),
                        (this.waitingData = this.waitingData || {
                          frag: r,
                          part: i,
                          cache: new c.default(),
                          complete: !1
                        }).cache.push(new Uint8Array(s)),
                        (this.waitingVideoCC = this.videoTrackCC),
                        (this.state = n.State.WAITING_INIT_PTS);
                  } else
                    this.warn(
                      "Audio tracks were reset while fragment load was in progress. Fragment " +
                        r.sn +
                        " of level " +
                        r.level +
                        " will not be buffered"
                    );
                }),
                (b._handleFragmentLoadComplete = function(t) {
                  this.waitingData
                    ? (this.waitingData.complete = !0)
                    : e.prototype._handleFragmentLoadComplete.call(this, t);
                }),
                (b.onBufferReset = function() {
                  (this.mediaBuffer = this.videoBuffer = null), (this.loadedmetadata = !1);
                }),
                (b.onBufferCreated = function(e, t) {
                  var r = t.tracks.audio;
                  r && (this.mediaBuffer = r.buffer), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer);
                }),
                (b.onFragBuffered = function(e, t) {
                  var r = t.frag,
                    i = t.part;
                  r.type === u.PlaylistLevelType.AUDIO &&
                    (this.fragContextChanged(r)
                      ? this.warn(
                          "Fragment " +
                            r.sn +
                            (i ? " p: " + i.index : "") +
                            " of level " +
                            r.level +
                            " finished buffering, but was aborted. state: " +
                            this.state +
                            ", audioSwitch: " +
                            this.audioSwitch
                        )
                      : ("initSegment" !== r.sn &&
                          ((this.fragPrevious = r),
                          this.audioSwitch &&
                            ((this.audioSwitch = !1),
                            this.hls.trigger(s.Events.AUDIO_TRACK_SWITCHED, { id: this.trackId }))),
                        this.fragBufferedComplete(r, i)));
                }),
                (b.onError = function(t, r) {
                  switch (r.details) {
                    case g.ErrorDetails.FRAG_LOAD_ERROR:
                    case g.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case g.ErrorDetails.KEY_LOAD_ERROR:
                    case g.ErrorDetails.KEY_LOAD_TIMEOUT:
                      this.onFragmentOrKeyLoadError(u.PlaylistLevelType.AUDIO, r);
                      break;
                    case g.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                    case g.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                      this.state !== n.State.ERROR &&
                        this.state !== n.State.STOPPED &&
                        ((this.state = r.fatal ? n.State.ERROR : n.State.IDLE),
                        this.warn(r.details + " while loading frag, switching to " + this.state + " state"));
                      break;
                    case g.ErrorDetails.BUFFER_FULL_ERROR:
                      if ("audio" === r.parent && (this.state === n.State.PARSING || this.state === n.State.PARSED)) {
                        var i = !0,
                          s = this.getFwdBufferInfo(this.mediaBuffer, u.PlaylistLevelType.AUDIO);
                        s && s.len > 0.5 && (i = !this.reduceMaxBufferLength(s.len)),
                          i &&
                            (this.warn("Buffer full error also media.currentTime is not buffered, flush audio buffer"),
                            (this.fragCurrent = null),
                            e.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")),
                          this.resetLoadingState();
                      }
                  }
                }),
                (b.onBufferFlushed = function(e, t) {
                  t.type === d.ElementaryStreamTypes.AUDIO && (this.bufferFlushed = !0);
                }),
                (b._handleTransmuxComplete = function(e) {
                  var t,
                    r = "audio",
                    i = this.hls,
                    a = e.remuxResult,
                    o = e.chunkMeta,
                    l = this.getCurrentContext(o);
                  if (!l)
                    return (
                      this.warn(
                        "The loading context changed while buffering fragment " +
                          o.sn +
                          " of level " +
                          o.level +
                          ". This chunk will not be buffered."
                      ),
                      void this.resetLiveStartWhenNotLoaded(o.level)
                    );
                  var u = l.frag,
                    c = l.part,
                    h = a.audio,
                    f = a.text,
                    p = a.id3,
                    v = a.initSegment;
                  if (!this.fragContextChanged(u)) {
                    if (
                      ((this.state = n.State.PARSING),
                      this.audioSwitch && h && this.completeAudioSwitch(),
                      null != v &&
                        v.tracks &&
                        (this._bufferInitSegment(v.tracks, u, o),
                        i.trigger(s.Events.FRAG_PARSING_INIT_SEGMENT, { frag: u, id: r, tracks: v.tracks })),
                      h)
                    ) {
                      var g = h.startPTS,
                        m = h.endPTS,
                        E = h.startDTS,
                        T = h.endDTS;
                      c &&
                        (c.elementaryStreams[d.ElementaryStreamTypes.AUDIO] = {
                          startPTS: g,
                          endPTS: m,
                          startDTS: E,
                          endDTS: T
                        }),
                        u.setElementaryStreamInfo(d.ElementaryStreamTypes.AUDIO, g, m, E, T),
                        this.bufferFragmentData(h, u, c, o);
                    }
                    if (null != p && null !== (t = p.samples) && void 0 !== t && t.length) {
                      var b = y({ frag: u, id: r }, p);
                      i.trigger(s.Events.FRAG_PARSING_METADATA, b);
                    }
                    if (f) {
                      var S = y({ frag: u, id: r }, f);
                      i.trigger(s.Events.FRAG_PARSING_USERDATA, S);
                    }
                  }
                }),
                (b._bufferInitSegment = function(e, t, r) {
                  if (this.state === n.State.PARSING) {
                    e.video && delete e.video;
                    var i = e.audio;
                    if (i) {
                      (i.levelCodec = i.codec),
                        (i.id = "audio"),
                        this.log("Init audio buffer, container:" + i.container + ", codecs[parsed]=[" + i.codec + "]"),
                        this.hls.trigger(s.Events.BUFFER_CODECS, e);
                      var a = i.initSegment;
                      if (null != a && a.byteLength) {
                        var o = { type: "audio", frag: t, part: null, chunkMeta: r, parent: t.type, data: a };
                        this.hls.trigger(s.Events.BUFFER_APPENDING, o);
                      }
                      this.tick();
                    }
                  }
                }),
                (b.loadFragment = function(t, r, s) {
                  var a = this.fragmentTracker.getState(t);
                  (this.fragCurrent = t),
                    (this.audioSwitch || a === o.FragmentState.NOT_LOADED || a === o.FragmentState.PARTIAL) &&
                      ("initSegment" === t.sn
                        ? this._loadInitSegment(t)
                        : r.live && !Object(i.isFiniteNumber)(this.initPTS[t.cc])
                          ? (this.log(
                              "Waiting for video PTS in continuity counter " +
                                t.cc +
                                " of live stream before loading audio fragment " +
                                t.sn +
                                " of level " +
                                this.trackId
                            ),
                            (this.state = n.State.WAITING_INIT_PTS))
                          : ((this.startFragRequested = !0), e.prototype.loadFragment.call(this, t, r, s)));
                }),
                (b.completeAudioSwitch = function() {
                  var t = this.hls,
                    r = this.media,
                    i = this.trackId;
                  r &&
                    (this.log("Switching audio track : flushing all audio"),
                    e.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")),
                    (this.audioSwitch = !1),
                    t.trigger(s.Events.AUDIO_TRACK_SWITCHED, { id: i });
                }),
                T
              );
            })(n.default);
            t.default = T;
          },
          "./src/controller/audio-track-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/events.ts"),
              n = r("./src/errors.ts"),
              s = r("./src/controller/base-playlist-controller.ts"),
              a = r("./src/types/loader.ts");
            function o(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function l(e, t) {
              return (l =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var u = (function(e) {
              var t, r;
              function s(t) {
                var r;
                return (
                  ((r = e.call(this, t, "[audio-track-controller]") || this).tracks = []),
                  (r.groupId = null),
                  (r.tracksInGroup = []),
                  (r.trackId = -1),
                  (r.trackName = ""),
                  (r.selectDefaultTrack = !0),
                  r.registerListeners(),
                  r
                );
              }
              (r = e), ((t = s).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), l(t, r);
              var u,
                d,
                c,
                h = s.prototype;
              return (
                (h.registerListeners = function() {
                  var e = this.hls;
                  e.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.on(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.on(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                    e.on(i.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                    e.on(i.Events.ERROR, this.onError, this);
                }),
                (h.unregisterListeners = function() {
                  var e = this.hls;
                  e.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.off(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.off(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                    e.off(i.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                    e.off(i.Events.ERROR, this.onError, this);
                }),
                (h.destroy = function() {
                  this.unregisterListeners(),
                    (this.tracks.length = 0),
                    (this.tracksInGroup.length = 0),
                    e.prototype.destroy.call(this);
                }),
                (h.onManifestLoading = function() {
                  (this.tracks = []),
                    (this.groupId = null),
                    (this.tracksInGroup = []),
                    (this.trackId = -1),
                    (this.trackName = ""),
                    (this.selectDefaultTrack = !0);
                }),
                (h.onManifestParsed = function(e, t) {
                  this.tracks = t.audioTracks || [];
                }),
                (h.onAudioTrackLoaded = function(e, t) {
                  var r = t.id,
                    i = t.details,
                    n = this.tracksInGroup[r];
                  if (n) {
                    var s = n.details;
                    (n.details = t.details),
                      this.log("audioTrack " + r + " loaded [" + i.startSN + "-" + i.endSN + "]"),
                      r === this.trackId && ((this.retryCount = 0), this.playlistLoaded(r, t, s));
                  } else this.warn("Invalid audio track id " + r);
                }),
                (h.onLevelLoading = function(e, t) {
                  this.switchLevel(t.level);
                }),
                (h.onLevelSwitching = function(e, t) {
                  this.switchLevel(t.level);
                }),
                (h.switchLevel = function(e) {
                  var t = this.hls.levels[e];
                  if (null != t && t.audioGroupIds) {
                    var r = t.audioGroupIds[t.urlId];
                    if (this.groupId !== r) {
                      this.groupId = r;
                      var n = this.tracks.filter(function(e) {
                        return !r || e.groupId === r;
                      });
                      this.selectDefaultTrack &&
                        !n.some(function(e) {
                          return e.default;
                        }) &&
                        (this.selectDefaultTrack = !1),
                        (this.tracksInGroup = n);
                      var s = { audioTracks: n };
                      this.log("Updating audio tracks, " + n.length + ' track(s) found in "' + r + '" group-id'),
                        this.hls.trigger(i.Events.AUDIO_TRACKS_UPDATED, s),
                        this.selectInitialTrack();
                    }
                  }
                }),
                (h.onError = function(t, r) {
                  e.prototype.onError.call(this, t, r),
                    !r.fatal &&
                      r.context &&
                      r.context.type === a.PlaylistContextType.AUDIO_TRACK &&
                      r.context.id === this.trackId &&
                      r.context.groupId === this.groupId &&
                      this.retryLoadingOrFail(r);
                }),
                (h.setAudioTrack = function(e) {
                  var t = this.tracksInGroup;
                  if (e < 0 || e >= t.length) this.warn("Invalid id passed to audio-track controller");
                  else {
                    this.clearTimer();
                    var r = t[this.trackId];
                    this.log("Now switching to audio-track index " + e);
                    var n = t[e],
                      s = n.id,
                      a = n.groupId,
                      o = void 0 === a ? "" : a,
                      l = n.name,
                      u = n.type,
                      d = n.url;
                    if (
                      ((this.trackId = e),
                      (this.trackName = l),
                      (this.selectDefaultTrack = !1),
                      this.hls.trigger(i.Events.AUDIO_TRACK_SWITCHING, { id: s, groupId: o, name: l, type: u, url: d }),
                      !n.details || n.details.live)
                    ) {
                      var c = this.switchParams(n.url, null == r ? void 0 : r.details);
                      this.loadPlaylist(c);
                    }
                  }
                }),
                (h.selectInitialTrack = function() {
                  var e = this.tracksInGroup;
                  console.assert(e.length, "Initial audio track should be selected when tracks are known");
                  var t = this.trackName,
                    r = this.findTrackId(t) || this.findTrackId();
                  -1 !== r
                    ? this.setAudioTrack(r)
                    : (this.warn("No track found for running audio group-ID: " + this.groupId),
                      this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.MEDIA_ERROR,
                        details: n.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                        fatal: !0
                      }));
                }),
                (h.findTrackId = function(e) {
                  for (var t = this.tracksInGroup, r = 0; r < t.length; r++) {
                    var i = t[r];
                    if ((!this.selectDefaultTrack || i.default) && (!e || e === i.name)) return i.id;
                  }
                  return -1;
                }),
                (h.loadPlaylist = function(e) {
                  var t = this.tracksInGroup[this.trackId];
                  if (this.shouldLoadTrack(t)) {
                    var r = t.id,
                      n = t.groupId,
                      s = t.url;
                    if (e)
                      try {
                        s = e.addDirectives(s);
                      } catch (e) {
                        this.warn("Could not construct new URL with HLS Delivery Directives: " + e);
                      }
                    this.log("loading audio-track playlist for id: " + r),
                      this.clearTimer(),
                      this.hls.trigger(i.Events.AUDIO_TRACK_LOADING, {
                        url: s,
                        id: r,
                        groupId: n,
                        deliveryDirectives: e || null
                      });
                  }
                }),
                (u = s),
                (d = [
                  {
                    key: "audioTracks",
                    get: function() {
                      return this.tracksInGroup;
                    }
                  },
                  {
                    key: "audioTrack",
                    get: function() {
                      return this.trackId;
                    },
                    set: function(e) {
                      (this.selectDefaultTrack = !1), this.setAudioTrack(e);
                    }
                  }
                ]) && o(u.prototype, d),
                c && o(u, c),
                s
              );
            })(s.default);
            t.default = u;
          },
          "./src/controller/base-playlist-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return l;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/types/level.ts"),
              s = r("./src/controller/level-helper.ts"),
              a = r("./src/utils/logger.ts"),
              o = r("./src/errors.ts"),
              l = (function() {
                function e(e, t) {
                  (this.hls = void 0),
                    (this.timer = -1),
                    (this.canLoad = !1),
                    (this.retryCount = 0),
                    (this.log = void 0),
                    (this.warn = void 0),
                    (this.log = a.logger.log.bind(a.logger, t + ":")),
                    (this.warn = a.logger.warn.bind(a.logger, t + ":")),
                    (this.hls = e);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    this.clearTimer(), (this.hls = this.log = this.warn = null);
                  }),
                  (t.onError = function(e, t) {
                    t.fatal && t.type === o.ErrorTypes.NETWORK_ERROR && this.clearTimer();
                  }),
                  (t.clearTimer = function() {
                    clearTimeout(this.timer), (this.timer = -1);
                  }),
                  (t.startLoad = function() {
                    (this.canLoad = !0), (this.retryCount = 0), this.loadPlaylist();
                  }),
                  (t.stopLoad = function() {
                    (this.canLoad = !1), this.clearTimer();
                  }),
                  (t.switchParams = function(e, t) {
                    var r = null == t ? void 0 : t.renditionReports;
                    if (r)
                      for (var s = 0; s < r.length; s++) {
                        var a = r[s],
                          o = "" + a.URI;
                        if (o === e.substr(-o.length)) {
                          var l = parseInt(a["LAST-MSN"]),
                            u = parseInt(a["LAST-PART"]);
                          if (t && this.hls.config.lowLatencyMode) {
                            var d = Math.min(t.age - t.partTarget, t.targetduration);
                            void 0 !== u && d > t.partTarget && (u += 1);
                          }
                          if (Object(i.isFiniteNumber)(l))
                            return new n.HlsUrlParameters(l, Object(i.isFiniteNumber)(u) ? u : void 0, n.HlsSkip.No);
                        }
                      }
                  }),
                  (t.loadPlaylist = function(e) {}),
                  (t.shouldLoadTrack = function(e) {
                    return this.canLoad && e && !!e.url && (!e.details || e.details.live);
                  }),
                  (t.playlistLoaded = function(e, t, r) {
                    var i = this,
                      n = t.details,
                      a = t.stats,
                      o = a.loading.end ? Math.max(0, self.performance.now() - a.loading.end) : 0;
                    if (((n.advancedDateTime = Date.now() - o), n.live || (null != r && r.live))) {
                      if (
                        (n.reloaded(r),
                        r &&
                          this.log(
                            "live playlist " +
                              e +
                              " " +
                              (n.advanced ? "REFRESHED " + n.lastPartSn + "-" + n.lastPartIndex : "MISSED")
                          ),
                        r && n.fragments.length > 0 && Object(s.mergeDetails)(r, n),
                        !this.canLoad || !n.live)
                      )
                        return;
                      var l,
                        u = void 0,
                        d = void 0;
                      if (n.canBlockReload && n.endSN && n.advanced) {
                        var c = this.hls.config.lowLatencyMode,
                          h = n.lastPartSn,
                          f = n.endSN,
                          p = n.lastPartIndex,
                          v = h === f;
                        -1 !== p ? ((u = v ? f + 1 : h), (d = v ? (c ? 0 : p) : p + 1)) : (u = f + 1);
                        var g = n.age,
                          m = g + n.ageHeader,
                          y = Math.min(m - n.partTarget, 1.5 * n.targetduration);
                        if (y > 0) {
                          if (r && y > r.tuneInGoal)
                            this.warn(
                              "CDN Tune-in goal increased from: " +
                                r.tuneInGoal +
                                " to: " +
                                y +
                                " with playlist age: " +
                                n.age
                            ),
                              (y = 0);
                          else {
                            var E = Math.floor(y / n.targetduration);
                            (u += E),
                              void 0 !== d && (d += Math.round((y % n.targetduration) / n.partTarget)),
                              this.log(
                                "CDN Tune-in age: " +
                                  n.ageHeader +
                                  "s last advanced " +
                                  g.toFixed(2) +
                                  "s goal: " +
                                  y +
                                  " skip sn " +
                                  E +
                                  " to part " +
                                  d
                              );
                          }
                          n.tuneInGoal = y;
                        }
                        if (((l = this.getDeliveryDirectives(n, t.deliveryDirectives, u, d)), c || !v))
                          return void this.loadPlaylist(l);
                      } else l = this.getDeliveryDirectives(n, t.deliveryDirectives, u, d);
                      var T = Object(s.computeReloadInterval)(n, a);
                      void 0 !== u && n.canBlockReload && (T -= n.partTarget || 1),
                        this.log("reload live playlist " + e + " in " + Math.round(T) + " ms"),
                        (this.timer = self.setTimeout(function() {
                          return i.loadPlaylist(l);
                        }, T));
                    } else this.clearTimer();
                  }),
                  (t.getDeliveryDirectives = function(e, t, r, i) {
                    var s = Object(n.getSkipValue)(e, r);
                    return (
                      null != t && t.skip && e.deltaUpdateFailed && ((r = t.msn), (i = t.part), (s = n.HlsSkip.No)),
                      new n.HlsUrlParameters(r, i, s)
                    );
                  }),
                  (t.retryLoadingOrFail = function(e) {
                    var t,
                      r = this,
                      i = this.hls.config,
                      n = this.retryCount < i.levelLoadingMaxRetry;
                    if (n)
                      if (
                        (this.retryCount++,
                        e.details.indexOf("LoadTimeOut") > -1 &&
                          null !== (t = e.context) &&
                          void 0 !== t &&
                          t.deliveryDirectives)
                      )
                        this.warn("retry playlist loading #" + this.retryCount + ' after "' + e.details + '"'),
                          this.loadPlaylist();
                      else {
                        var s = Math.min(
                          Math.pow(2, this.retryCount) * i.levelLoadingRetryDelay,
                          i.levelLoadingMaxRetryTimeout
                        );
                        (this.timer = self.setTimeout(function() {
                          return r.loadPlaylist();
                        }, s)),
                          this.warn(
                            "retry playlist loading #" + this.retryCount + " in " + s + ' ms after "' + e.details + '"'
                          );
                      }
                    else this.warn('cannot recover from error "' + e.details + '"'), this.clearTimer(), (e.fatal = !0);
                    return n;
                  }),
                  e
                );
              })();
          },
          "./src/controller/base-stream-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "State", function() {
                return b;
              }),
              r.d(t, "default", function() {
                return S;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/task-loop.ts"),
              s = r("./src/controller/fragment-tracker.ts"),
              a = r("./src/utils/buffer-helper.ts"),
              o = r("./src/utils/logger.ts"),
              l = r("./src/events.ts"),
              u = r("./src/errors.ts"),
              d = r("./src/types/transmuxer.ts"),
              c = r("./src/utils/mp4-tools.ts"),
              h = r("./src/utils/discontinuities.ts"),
              f = r("./src/controller/fragment-finders.ts"),
              p = r("./src/controller/level-helper.ts"),
              v = r("./src/loader/fragment-loader.ts"),
              g = r("./src/crypt/decrypter.ts"),
              m = r("./src/utils/time-ranges.ts"),
              y = r("./src/types/loader.ts");
            function E(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function T(e, t) {
              return (T =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var b = {
                STOPPED: "STOPPED",
                IDLE: "IDLE",
                KEY_LOADING: "KEY_LOADING",
                FRAG_LOADING: "FRAG_LOADING",
                FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                WAITING_TRACK: "WAITING_TRACK",
                PARSING: "PARSING",
                PARSED: "PARSED",
                BACKTRACKING: "BACKTRACKING",
                ENDED: "ENDED",
                ERROR: "ERROR",
                WAITING_INIT_PTS: "WAITING_INIT_PTS",
                WAITING_LEVEL: "WAITING_LEVEL"
              },
              S = (function(e) {
                var t, r;
                function n(t, r, i) {
                  var n;
                  return (
                    ((n = e.call(this) || this).hls = void 0),
                    (n.fragPrevious = null),
                    (n.fragCurrent = null),
                    (n.fragmentTracker = void 0),
                    (n.transmuxer = null),
                    (n._state = b.STOPPED),
                    (n.media = void 0),
                    (n.mediaBuffer = void 0),
                    (n.config = void 0),
                    (n.bitrateTest = !1),
                    (n.lastCurrentTime = 0),
                    (n.nextLoadPosition = 0),
                    (n.startPosition = 0),
                    (n.loadedmetadata = !1),
                    (n.fragLoadError = 0),
                    (n.retryDate = 0),
                    (n.levels = null),
                    (n.fragmentLoader = void 0),
                    (n.levelLastLoaded = null),
                    (n.startFragRequested = !1),
                    (n.decrypter = void 0),
                    (n.initPTS = []),
                    (n.onvseeking = null),
                    (n.onvended = null),
                    (n.logPrefix = ""),
                    (n.log = void 0),
                    (n.warn = void 0),
                    (n.logPrefix = i),
                    (n.log = o.logger.log.bind(o.logger, i + ":")),
                    (n.warn = o.logger.warn.bind(o.logger, i + ":")),
                    (n.hls = t),
                    (n.fragmentLoader = new v.default(t.config)),
                    (n.fragmentTracker = r),
                    (n.config = t.config),
                    (n.decrypter = new g.default(t, t.config)),
                    t.on(
                      l.Events.KEY_LOADED,
                      n.onKeyLoaded,
                      (function(e) {
                        if (void 0 === e)
                          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                      })(n)
                    ),
                    n
                  );
                }
                (r = e), ((t = n).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), T(t, r);
                var S,
                  k,
                  A,
                  w = n.prototype;
                return (
                  (w.doTick = function() {
                    this.onTickEnd();
                  }),
                  (w.onTickEnd = function() {}),
                  (w.startLoad = function(e) {}),
                  (w.stopLoad = function() {
                    this.fragmentLoader.abort();
                    var e = this.fragCurrent;
                    e && this.fragmentTracker.removeFragment(e),
                      this.resetTransmuxer(),
                      (this.fragCurrent = null),
                      (this.fragPrevious = null),
                      this.clearInterval(),
                      this.clearNextTick(),
                      (this.state = b.STOPPED);
                  }),
                  (w._streamEnded = function(e, t) {
                    var r = this.fragCurrent,
                      i = this.fragmentTracker;
                    if (!t.live && r && r.sn >= t.endSN && !e.nextStart) {
                      var n = t.partList;
                      if (null != n && n.length) {
                        var o = n[n.length - 1];
                        return a.BufferHelper.isBuffered(this.media, o.start + o.duration / 2);
                      }
                      var l = i.getState(r);
                      return l === s.FragmentState.PARTIAL || l === s.FragmentState.OK;
                    }
                    return !1;
                  }),
                  (w.onMediaAttached = function(e, t) {
                    var r = (this.media = this.mediaBuffer = t.media);
                    (this.onvseeking = this.onMediaSeeking.bind(this)),
                      (this.onvended = this.onMediaEnded.bind(this)),
                      r.addEventListener("seeking", this.onvseeking),
                      r.addEventListener("ended", this.onvended);
                    var i = this.config;
                    this.levels && i.autoStartLoad && this.state === b.STOPPED && this.startLoad(i.startPosition);
                  }),
                  (w.onMediaDetaching = function() {
                    var e = this.media;
                    null != e &&
                      e.ended &&
                      (this.log("MSE detaching and video ended, reset startPosition"),
                      (this.startPosition = this.lastCurrentTime = 0)),
                      e &&
                        (e.removeEventListener("seeking", this.onvseeking),
                        e.removeEventListener("ended", this.onvended),
                        (this.onvseeking = this.onvended = null)),
                      (this.media = this.mediaBuffer = null),
                      (this.loadedmetadata = !1),
                      this.fragmentTracker.removeAllFragments(),
                      this.stopLoad();
                  }),
                  (w.onMediaSeeking = function() {
                    var e = this.config,
                      t = this.fragCurrent,
                      r = this.media,
                      n = this.mediaBuffer,
                      s = this.state,
                      o = r ? r.currentTime : 0,
                      l = a.BufferHelper.bufferInfo(n || r, o, e.maxBufferHole);
                    if (
                      (this.log(
                        "media seeking to " + (Object(i.isFiniteNumber)(o) ? o.toFixed(3) : o) + ", state: " + s
                      ),
                      s === b.ENDED)
                    )
                      this.resetLoadingState();
                    else if (t && !l.len) {
                      var u = e.maxFragLookUpTolerance,
                        d = t.start - u,
                        c = o > t.start + t.duration + u;
                      (o < d || c) &&
                        (c &&
                          t.loader &&
                          (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"),
                          t.loader.abort()),
                        this.resetLoadingState());
                    }
                    r && (this.lastCurrentTime = o),
                      this.loadedmetadata || l.len || (this.nextLoadPosition = this.startPosition = o),
                      this.tickImmediate();
                  }),
                  (w.onMediaEnded = function() {
                    this.startPosition = this.lastCurrentTime = 0;
                  }),
                  (w.onKeyLoaded = function(e, t) {
                    if (this.state === b.KEY_LOADING && t.frag === this.fragCurrent && this.levels) {
                      this.state = b.IDLE;
                      var r = this.levels[t.frag.level].details;
                      r && this.loadFragment(t.frag, r, t.frag.start);
                    }
                  }),
                  (w.onHandlerDestroying = function() {
                    this.stopLoad(), e.prototype.onHandlerDestroying.call(this);
                  }),
                  (w.onHandlerDestroyed = function() {
                    (this.state = b.STOPPED),
                      this.hls.off(l.Events.KEY_LOADED, this.onKeyLoaded, this),
                      this.fragmentLoader && this.fragmentLoader.destroy(),
                      this.decrypter && this.decrypter.destroy(),
                      (this.hls = this.log = this.warn = this.decrypter = this.fragmentLoader = this.fragmentTracker = null),
                      e.prototype.onHandlerDestroyed.call(this);
                  }),
                  (w.loadKey = function(e, t) {
                    this.log(
                      "Loading key for " +
                        e.sn +
                        " of [" +
                        t.startSN +
                        "-" +
                        t.endSN +
                        "], " +
                        ("[stream-controller]" === this.logPrefix ? "level" : "track") +
                        " " +
                        e.level
                    ),
                      (this.state = b.KEY_LOADING),
                      (this.fragCurrent = e),
                      this.hls.trigger(l.Events.KEY_LOADING, { frag: e });
                  }),
                  (w.loadFragment = function(e, t, r) {
                    this._loadFragForPlayback(e, t, r);
                  }),
                  (w._loadFragForPlayback = function(e, t, r) {
                    var i = this;
                    this._doFragLoad(e, t, r, function(t) {
                      if (i.fragContextChanged(e))
                        return (
                          i.warn(
                            "Fragment " +
                              e.sn +
                              (t.part ? " p: " + t.part.index : "") +
                              " of level " +
                              e.level +
                              " was dropped during download."
                          ),
                          void i.fragmentTracker.removeFragment(e)
                        );
                      e.stats.chunkCount++, i._handleFragmentLoadProgress(t);
                    })
                      .then(function(t) {
                        if (t) {
                          i.fragLoadError = 0;
                          var r = i.state;
                          if (!i.fragContextChanged(e))
                            return "payload" in t &&
                              (i.log("Loaded fragment " + e.sn + " of level " + e.level),
                              i.hls.trigger(l.Events.FRAG_LOADED, t),
                              i.state === b.BACKTRACKING)
                              ? (i.fragmentTracker.backtrack(e, t), void i.resetFragmentLoading(e))
                              : void i._handleFragmentLoadComplete(t);
                          (r === b.FRAG_LOADING || r === b.BACKTRACKING || (!i.fragCurrent && r === b.PARSING)) &&
                            (i.fragmentTracker.removeFragment(e), (i.state = b.IDLE));
                        }
                      })
                      .catch(function(t) {
                        i.warn(t), i.resetFragmentLoading(e);
                      });
                  }),
                  (w.flushMainBuffer = function(e, t, r) {
                    if ((void 0 === r && (r = null), e - t)) {
                      var i = { startOffset: e, endOffset: t, type: r };
                      (this.fragLoadError = 0), this.hls.trigger(l.Events.BUFFER_FLUSHING, i);
                    }
                  }),
                  (w._loadInitSegment = function(e) {
                    var t = this;
                    this._doFragLoad(e)
                      .then(function(r) {
                        if (!r || t.fragContextChanged(e) || !t.levels) throw new Error("init load aborted");
                        return r;
                      })
                      .then(function(r) {
                        var i = t.hls,
                          n = r.payload,
                          s = e.decryptdata;
                        if (n && n.byteLength > 0 && s && s.key && s.iv && "AES-128" === s.method) {
                          var a = self.performance.now();
                          return t.decrypter
                            .webCryptoDecrypt(new Uint8Array(n), s.key.buffer, s.iv.buffer)
                            .then(function(t) {
                              var n = self.performance.now();
                              return (
                                i.trigger(l.Events.FRAG_DECRYPTED, {
                                  frag: e,
                                  payload: t,
                                  stats: { tstart: a, tdecrypt: n }
                                }),
                                (r.payload = t),
                                r
                              );
                            });
                        }
                        return r;
                      })
                      .then(function(r) {
                        var i = t.fragCurrent,
                          n = t.hls,
                          s = t.levels;
                        if (!s) throw new Error("init load aborted, missing levels");
                        var a = s[e.level].details;
                        console.assert(a, "Level details are defined when init segment is loaded");
                        var o = e.stats;
                        (t.state = b.IDLE),
                          (t.fragLoadError = 0),
                          (e.data = new Uint8Array(r.payload)),
                          (o.parsing.start = o.buffering.start = self.performance.now()),
                          (o.parsing.end = o.buffering.end = self.performance.now()),
                          r.frag === i &&
                            n.trigger(l.Events.FRAG_BUFFERED, { stats: o, frag: i, part: null, id: e.type }),
                          t.tick();
                      })
                      .catch(function(r) {
                        t.warn(r), t.resetFragmentLoading(e);
                      });
                  }),
                  (w.fragContextChanged = function(e) {
                    var t = this.fragCurrent;
                    return !e || !t || e.level !== t.level || e.sn !== t.sn || e.urlId !== t.urlId;
                  }),
                  (w.fragBufferedComplete = function(e, t) {
                    var r = this.mediaBuffer ? this.mediaBuffer : this.media;
                    this.log(
                      "Buffered " +
                        e.type +
                        " sn: " +
                        e.sn +
                        (t ? " part: " + t.index : "") +
                        " of " +
                        ("[stream-controller]" === this.logPrefix ? "level" : "track") +
                        " " +
                        e.level +
                        " " +
                        m.default.toString(a.BufferHelper.getBuffered(r))
                    ),
                      (this.state = b.IDLE),
                      this.tick();
                  }),
                  (w._handleFragmentLoadComplete = function(e) {
                    var t = this.transmuxer;
                    if (t) {
                      var r = e.frag,
                        i = e.part,
                        n = e.partsLoaded,
                        s =
                          !n ||
                          0 === n.length ||
                          n.some(function(e) {
                            return !e;
                          }),
                        a = new d.ChunkMetadata(r.level, r.sn, r.stats.chunkCount + 1, 0, i ? i.index : -1, !s);
                      t.flush(a);
                    }
                  }),
                  (w._handleFragmentLoadProgress = function(e) {}),
                  (w._doFragLoad = function(e, t, r, n) {
                    var s = this;
                    if ((void 0 === r && (r = null), !this.levels))
                      throw new Error("frag load aborted, missing levels");
                    if (((r = Math.max(e.start, r || 0)), this.config.lowLatencyMode && t)) {
                      var a = t.partList;
                      if (a && n) {
                        r > e.end && t.fragmentHint && (e = t.fragmentHint);
                        var o = this.getNextPart(a, e, r);
                        if (o > -1) {
                          var u = a[o];
                          return (
                            this.log(
                              "Loading part sn: " +
                                e.sn +
                                " p: " +
                                u.index +
                                " cc: " +
                                e.cc +
                                " of playlist [" +
                                t.startSN +
                                "-" +
                                t.endSN +
                                "] parts [0-" +
                                o +
                                "-" +
                                (a.length - 1) +
                                "] " +
                                ("[stream-controller]" === this.logPrefix ? "level" : "track") +
                                ": " +
                                e.level +
                                ", target: " +
                                parseFloat(r.toFixed(3))
                            ),
                            (this.nextLoadPosition = u.start + u.duration),
                            (this.state = b.FRAG_LOADING),
                            this.hls.trigger(l.Events.FRAG_LOADING, { frag: e, part: a[o], targetBufferTime: r }),
                            this.doFragPartsLoad(e, a, o, n).catch(function(e) {
                              return s.handleFragLoadError(e);
                            })
                          );
                        }
                        if (!e.url || this.loadedEndOfParts(a, r)) return Promise.resolve(null);
                      }
                    }
                    return (
                      this.log(
                        "Loading fragment " +
                          e.sn +
                          " cc: " +
                          e.cc +
                          " " +
                          (t ? "of [" + t.startSN + "-" + t.endSN + "] " : "") +
                          ("[stream-controller]" === this.logPrefix ? "level" : "track") +
                          ": " +
                          e.level +
                          ", target: " +
                          parseFloat(r.toFixed(3))
                      ),
                      Object(i.isFiniteNumber)(e.sn) &&
                        !this.bitrateTest &&
                        (this.nextLoadPosition = e.start + e.duration),
                      (this.state = b.FRAG_LOADING),
                      this.hls.trigger(l.Events.FRAG_LOADING, { frag: e, targetBufferTime: r }),
                      this.fragmentLoader.load(e, n).catch(function(e) {
                        return s.handleFragLoadError(e);
                      })
                    );
                  }),
                  (w.doFragPartsLoad = function(e, t, r, i) {
                    var n = this;
                    return new Promise(function(s, a) {
                      var o = [];
                      !(function r(u) {
                        var d = t[u];
                        n.fragmentLoader
                          .loadPart(e, d, i)
                          .then(function(i) {
                            o[d.index] = i;
                            var a = i.part;
                            n.hls.trigger(l.Events.FRAG_LOADED, i);
                            var c = t[u + 1];
                            if (!c || c.fragment !== e) return s({ frag: e, part: a, partsLoaded: o });
                            r(u + 1);
                          })
                          .catch(a);
                      })(r);
                    });
                  }),
                  (w.handleFragLoadError = function(e) {
                    var t = e.data;
                    return (
                      t && t.details === u.ErrorDetails.INTERNAL_ABORTED
                        ? this.handleFragLoadAborted(t.frag, t.part)
                        : this.hls.trigger(l.Events.ERROR, t),
                      null
                    );
                  }),
                  (w._handleTransmuxerFlush = function(e) {
                    var t = this.getCurrentContext(e);
                    if (t && this.state === b.PARSING) {
                      var r = t.frag,
                        i = t.part,
                        n = t.level,
                        s = self.performance.now();
                      (r.stats.parsing.end = s),
                        i && (i.stats.parsing.end = s),
                        this.updateLevelTiming(r, i, n, e.partial);
                    } else this.fragCurrent || (this.state = b.IDLE);
                  }),
                  (w.getCurrentContext = function(e) {
                    var t = this.levels,
                      r = e.level,
                      i = e.sn,
                      n = e.part;
                    if (!t || !t[r])
                      return (
                        this.warn(
                          "Levels object was unset while buffering fragment " +
                            i +
                            " of level " +
                            r +
                            ". The current chunk will not be buffered."
                        ),
                        null
                      );
                    var s = t[r],
                      a = n > -1 ? Object(p.getPartWith)(s, i, n) : null,
                      o = a ? a.fragment : Object(p.getFragmentWithSN)(s, i, this.fragCurrent);
                    return o ? { frag: o, part: a, level: s } : null;
                  }),
                  (w.bufferFragmentData = function(e, t, r, i) {
                    if (e && this.state === b.PARSING) {
                      var n = e.data1,
                        s = e.data2,
                        a = n;
                      if ((n && s && (a = Object(c.appendUint8Array)(n, s)), a && a.length)) {
                        var o = { type: e.type, frag: t, part: r, chunkMeta: i, parent: t.type, data: a };
                        this.hls.trigger(l.Events.BUFFER_APPENDING, o),
                          e.dropped && e.independent && !r && this.flushBufferGap(t);
                      }
                    }
                  }),
                  (w.flushBufferGap = function(e) {
                    var t = this.media;
                    if (t)
                      if (a.BufferHelper.isBuffered(t, t.currentTime)) {
                        var r = t.currentTime,
                          i = a.BufferHelper.bufferInfo(t, r, 0),
                          n = e.duration,
                          s = Math.min(2 * this.config.maxFragLookUpTolerance, 0.25 * n),
                          o = Math.max(Math.min(e.start - s, i.end - s), r + s);
                        e.start - o > s && this.flushMainBuffer(o, e.start);
                      } else this.flushMainBuffer(0, e.start);
                  }),
                  (w.getFwdBufferInfo = function(e, t) {
                    var r = this.config,
                      n = this.getLoadPosition();
                    if (!Object(i.isFiniteNumber)(n)) return null;
                    var s = a.BufferHelper.bufferInfo(e, n, r.maxBufferHole);
                    if (0 === s.len && void 0 !== s.nextStart) {
                      var o = this.fragmentTracker.getBufferedFrag(n, t);
                      if (o && s.nextStart < o.end)
                        return a.BufferHelper.bufferInfo(e, n, Math.max(s.nextStart, r.maxBufferHole));
                    }
                    return s;
                  }),
                  (w.getMaxBufferLength = function(e) {
                    var t,
                      r = this.config;
                    return (
                      (t = e ? Math.max((8 * r.maxBufferSize) / e, r.maxBufferLength) : r.maxBufferLength),
                      Math.min(t, r.maxMaxBufferLength)
                    );
                  }),
                  (w.reduceMaxBufferLength = function(e) {
                    var t = this.config,
                      r = e || t.maxBufferLength;
                    return (
                      t.maxMaxBufferLength >= r &&
                      ((t.maxMaxBufferLength /= 2),
                      this.warn("Reduce max buffer length to " + t.maxMaxBufferLength + "s"),
                      !0)
                    );
                  }),
                  (w.getNextFragment = function(e, t) {
                    var r,
                      i,
                      n = t.fragments,
                      s = n.length;
                    if (!s) return null;
                    var a,
                      o = this.config,
                      l = n[0].start;
                    if (t.live) {
                      var u = o.initialLiveManifestSize;
                      if (s < u)
                        return (
                          this.warn("Not enough fragments to start playback (have: " + s + ", need: " + u + ")"), null
                        );
                      t.PTSKnown ||
                        this.startFragRequested ||
                        -1 !== this.startPosition ||
                        ((a = this.getInitialLiveFragment(t, n)),
                        (this.startPosition = a ? this.hls.liveSyncPosition || a.start : e));
                    } else e <= l && (a = n[0]);
                    if (!a) {
                      var d = o.lowLatencyMode ? t.partEnd : t.fragmentEnd;
                      a = this.getFragmentAtPosition(e, d, t);
                    }
                    return (
                      null === (r = a) ||
                        void 0 === r ||
                        !r.initSegment ||
                        (null !== (i = a) && void 0 !== i && i.initSegment.data) ||
                        this.bitrateTest ||
                        (a = a.initSegment),
                      a
                    );
                  }),
                  (w.getNextPart = function(e, t, r) {
                    for (var i = -1, n = !1, s = !0, a = 0, o = e.length; a < o; a++) {
                      var l = e[a];
                      if (((s = s && !l.independent), i > -1 && r < l.start)) break;
                      var u = l.loaded;
                      !u && (n || l.independent || s) && l.fragment === t && (i = a), (n = u);
                    }
                    return i;
                  }),
                  (w.loadedEndOfParts = function(e, t) {
                    var r = e[e.length - 1];
                    return r && t > r.start && r.loaded;
                  }),
                  (w.getInitialLiveFragment = function(e, t) {
                    var r = this.fragPrevious,
                      i = null;
                    if (r) {
                      if (
                        (e.hasProgramDateTime &&
                          (this.log("Live playlist, switching playlist, load frag with same PDT: " + r.programDateTime),
                          (i = Object(f.findFragmentByPDT)(
                            t,
                            r.endProgramDateTime,
                            this.config.maxFragLookUpTolerance
                          ))),
                        !i)
                      ) {
                        var n = r.sn + 1;
                        if (n >= e.startSN && n <= e.endSN) {
                          var s = t[n - e.startSN];
                          r.cc === s.cc &&
                            ((i = s), this.log("Live playlist, switching playlist, load frag with next SN: " + i.sn));
                        }
                        i ||
                          ((i = Object(f.findFragWithCC)(t, r.cc)) &&
                            this.log("Live playlist, switching playlist, load frag with same CC: " + i.sn));
                      }
                    } else {
                      var a = this.hls.liveSyncPosition;
                      null !== a && (i = this.getFragmentAtPosition(a, this.bitrateTest ? e.fragmentEnd : e.edge, e));
                    }
                    return i;
                  }),
                  (w.getFragmentAtPosition = function(e, t, r) {
                    var i,
                      n = this.config,
                      a = this.fragPrevious,
                      o = r.fragments,
                      l = r.endSN,
                      u = r.fragmentHint,
                      d = n.maxFragLookUpTolerance,
                      c = !!(n.lowLatencyMode && r.partList && u);
                    if ((c && u && !this.bitrateTest && ((o = o.concat(u)), (l = u.sn)), e < t)) {
                      var h = e > t - d ? 0 : d;
                      i = Object(f.findFragmentByPTS)(a, o, e, h);
                    } else i = o[o.length - 1];
                    if (i) {
                      var p = i.sn - r.startSN,
                        v = a && i.level === a.level,
                        g = o[p + 1];
                      if (this.fragmentTracker.getState(i) === s.FragmentState.BACKTRACKED) {
                        i = null;
                        for (var m = p; o[m] && this.fragmentTracker.getState(o[m]) === s.FragmentState.BACKTRACKED; )
                          i = a ? o[m--] : o[--m];
                        i || (i = g);
                      } else
                        a &&
                          i.sn === a.sn &&
                          !c &&
                          v &&
                          (i.sn < l && this.fragmentTracker.getState(g) !== s.FragmentState.OK
                            ? (this.log("SN " + i.sn + " just loaded, load next one: " + g.sn), (i = g))
                            : (i = null));
                    }
                    return i;
                  }),
                  (w.synchronizeToLiveEdge = function(e) {
                    var t = this.config,
                      r = this.media;
                    if (r) {
                      var i = this.hls.liveSyncPosition,
                        n = r.currentTime,
                        s = e.fragments[0].start,
                        a = e.edge,
                        o = n >= s - t.maxFragLookUpTolerance && n <= a;
                      if (null !== i && r.duration > i && (n < i || !o)) {
                        var l =
                          void 0 !== t.liveMaxLatencyDuration
                            ? t.liveMaxLatencyDuration
                            : t.liveMaxLatencyDurationCount * e.targetduration;
                        ((!o && r.readyState < 4) || n < a - l) &&
                          (this.loadedmetadata || (this.nextLoadPosition = i),
                          r.readyState &&
                            (this.warn(
                              "Playback: " +
                                n.toFixed(3) +
                                " is located too far from the end of live sliding playlist: " +
                                a +
                                ", reset currentTime to : " +
                                i.toFixed(3)
                            ),
                            (r.currentTime = i)));
                      }
                    }
                  }),
                  (w.alignPlaylists = function(e, t) {
                    var r = this.levels,
                      n = this.levelLastLoaded,
                      s = this.fragPrevious,
                      a = null !== n ? r[n] : null,
                      o = e.fragments.length;
                    if (!o) return this.warn("No fragments in live playlist"), 0;
                    var l = e.fragments[0].start,
                      u = !t,
                      d = e.alignedSliding && Object(i.isFiniteNumber)(l);
                    if (u || (!d && !l)) {
                      Object(h.alignStream)(s, a, e);
                      var c = e.fragments[0].start;
                      return (
                        this.log(
                          "Live playlist sliding: " +
                            c.toFixed(2) +
                            " start-sn: " +
                            (t ? t.startSN : "na") +
                            "->" +
                            e.startSN +
                            " prev-sn: " +
                            (s ? s.sn : "na") +
                            " fragments: " +
                            o
                        ),
                        c
                      );
                    }
                    return l;
                  }),
                  (w.waitForCdnTuneIn = function(e) {
                    return e.live && e.canBlockReload && e.tuneInGoal > Math.max(e.partHoldBack, 3 * e.partTarget);
                  }),
                  (w.setStartPosition = function(e, t) {
                    var r = this.startPosition;
                    if ((r < t && (r = -1), -1 === r || -1 === this.lastCurrentTime)) {
                      var n = e.startTimeOffset;
                      Object(i.isFiniteNumber)(n)
                        ? ((r = t + n),
                          n < 0 && (r += e.totalduration),
                          (r = Math.min(Math.max(t, r), t + e.totalduration)),
                          this.log("Start time offset " + n + " found in playlist, adjust startPosition to " + r),
                          (this.startPosition = r))
                        : e.live
                          ? (r = this.hls.liveSyncPosition || t)
                          : (this.startPosition = r = 0),
                        (this.lastCurrentTime = r);
                    }
                    this.nextLoadPosition = r;
                  }),
                  (w.getLoadPosition = function() {
                    var e = this.media,
                      t = 0;
                    return (
                      this.loadedmetadata && e
                        ? (t = e.currentTime)
                        : this.nextLoadPosition && (t = this.nextLoadPosition),
                      t
                    );
                  }),
                  (w.handleFragLoadAborted = function(e, t) {
                    this.transmuxer &&
                      "initSegment" !== e.sn &&
                      e.stats.aborted &&
                      (this.warn(
                        "Fragment " + e.sn + (t ? " part" + t.index : "") + " of level " + e.level + " was aborted"
                      ),
                      this.resetFragmentLoading(e));
                  }),
                  (w.resetFragmentLoading = function(e) {
                    (this.fragCurrent && this.fragContextChanged(e)) || (this.state = b.IDLE);
                  }),
                  (w.onFragmentOrKeyLoadError = function(e, t) {
                    if (!t.fatal) {
                      var r = t.frag;
                      if (r && r.type === e) {
                        var i = this.fragCurrent;
                        console.assert(
                          i && r.sn === i.sn && r.level === i.level && r.urlId === i.urlId,
                          "Frag load error must match current frag to retry"
                        );
                        var n = this.config;
                        if (this.fragLoadError + 1 <= n.fragLoadingMaxRetry) {
                          if (this.resetLiveStartWhenNotLoaded(r.level)) return;
                          var s = Math.min(
                            Math.pow(2, this.fragLoadError) * n.fragLoadingRetryDelay,
                            n.fragLoadingMaxRetryTimeout
                          );
                          this.warn(
                            "Fragment " + r.sn + " of " + e + " " + r.level + " failed to load, retrying in " + s + "ms"
                          ),
                            (this.retryDate = self.performance.now() + s),
                            this.fragLoadError++,
                            (this.state = b.FRAG_LOADING_WAITING_RETRY);
                        } else
                          t.levelRetry
                            ? (e === y.PlaylistLevelType.AUDIO && (this.fragCurrent = null),
                              (this.fragLoadError = 0),
                              (this.state = b.IDLE))
                            : (o.logger.error(t.details + " reaches max retry, redispatch as fatal ..."),
                              (t.fatal = !0),
                              this.hls.stopLoad(),
                              (this.state = b.ERROR));
                      }
                    }
                  }),
                  (w.afterBufferFlushed = function(e, t, r) {
                    if (e) {
                      var i = a.BufferHelper.getBuffered(e);
                      this.fragmentTracker.detectEvictedFragments(t, i, r),
                        this.state === b.ENDED && this.resetLoadingState();
                    }
                  }),
                  (w.resetLoadingState = function() {
                    (this.fragCurrent = null), (this.fragPrevious = null), (this.state = b.IDLE);
                  }),
                  (w.resetLiveStartWhenNotLoaded = function(e) {
                    if (!this.loadedmetadata) {
                      this.startFragRequested = !1;
                      var t = this.levels ? this.levels[e].details : null;
                      if (null != t && t.live)
                        return (this.startPosition = -1), this.setStartPosition(t, 0), this.resetLoadingState(), !0;
                      this.nextLoadPosition = this.startPosition;
                    }
                    return !1;
                  }),
                  (w.updateLevelTiming = function(e, t, r, i) {
                    var n = this,
                      s = r.details;
                    console.assert(!!s, "level.details must be defined"),
                      Object.keys(e.elementaryStreams).reduce(function(t, a) {
                        var o = e.elementaryStreams[a];
                        if (o) {
                          var u = o.endPTS - o.startPTS;
                          if (u <= 0)
                            return (
                              n.warn(
                                "Could not parse fragment " +
                                  e.sn +
                                  " " +
                                  a +
                                  " duration reliably (" +
                                  u +
                                  ") resetting transmuxer to fallback to playlist timing"
                              ),
                              n.resetTransmuxer(),
                              t || !1
                            );
                          var d = i ? 0 : Object(p.updateFragPTSDTS)(s, e, o.startPTS, o.endPTS, o.startDTS, o.endDTS);
                          return (
                            n.hls.trigger(l.Events.LEVEL_PTS_UPDATED, {
                              details: s,
                              level: r,
                              drift: d,
                              type: a,
                              frag: e,
                              start: o.startPTS,
                              end: o.endPTS
                            }),
                            !0
                          );
                        }
                        return t;
                      }, !1)
                        ? ((this.state = b.PARSED), this.hls.trigger(l.Events.FRAG_PARSED, { frag: e, part: t }))
                        : this.resetLoadingState();
                  }),
                  (w.resetTransmuxer = function() {
                    this.transmuxer && (this.transmuxer.destroy(), (this.transmuxer = null));
                  }),
                  (S = n),
                  (k = [
                    {
                      key: "state",
                      get: function() {
                        return this._state;
                      },
                      set: function(e) {
                        var t = this._state;
                        t !== e && ((this._state = e), this.log(t + "->" + e));
                      }
                    }
                  ]) && E(S.prototype, k),
                  A && E(S, A),
                  n
                );
              })(n.default);
          },
          "./src/controller/buffer-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return f;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/events.ts"),
              s = r("./src/utils/logger.ts"),
              a = r("./src/errors.ts"),
              o = r("./src/utils/buffer-helper.ts"),
              l = r("./src/utils/mediasource-helper.ts"),
              u = r("./src/loader/fragment.ts"),
              d = r("./src/controller/buffer-operation-queue.ts"),
              c = Object(l.getMediaSource)(),
              h = /([ha]vc.)(?:\.[^.,]+)+/,
              f = (function() {
                function e(e) {
                  var t = this;
                  (this.details = null),
                    (this._objectUrl = null),
                    (this.operationQueue = void 0),
                    (this.listeners = void 0),
                    (this.hls = void 0),
                    (this.bufferCodecEventsExpected = 0),
                    (this._bufferCodecEventsTotal = 0),
                    (this.media = null),
                    (this.mediaSource = null),
                    (this.appendError = 0),
                    (this.tracks = {}),
                    (this.pendingTracks = {}),
                    (this.sourceBuffer = void 0),
                    (this._onMediaSourceOpen = function() {
                      var e = t.hls,
                        r = t.media,
                        i = t.mediaSource;
                      s.logger.log("[buffer-controller]: Media source opened"),
                        r && (t.updateMediaElementDuration(), e.trigger(n.Events.MEDIA_ATTACHED, { media: r })),
                        i && i.removeEventListener("sourceopen", t._onMediaSourceOpen),
                        t.checkPendingTracks();
                    }),
                    (this._onMediaSourceClose = function() {
                      s.logger.log("[buffer-controller]: Media source closed");
                    }),
                    (this._onMediaSourceEnded = function() {
                      s.logger.log("[buffer-controller]: Media source ended");
                    }),
                    (this.hls = e),
                    this._initSourceBuffer(),
                    this.registerListeners();
                }
                var t = e.prototype;
                return (
                  (t.hasSourceTypes = function() {
                    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
                  }),
                  (t.destroy = function() {
                    this.unregisterListeners(), (this.details = null);
                  }),
                  (t.registerListeners = function() {
                    var e = this.hls;
                    e.on(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                      e.on(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      e.on(n.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      e.on(n.Events.BUFFER_RESET, this.onBufferReset, this),
                      e.on(n.Events.BUFFER_APPENDING, this.onBufferAppending, this),
                      e.on(n.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                      e.on(n.Events.BUFFER_EOS, this.onBufferEos, this),
                      e.on(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this),
                      e.on(n.Events.LEVEL_UPDATED, this.onLevelUpdated, this),
                      e.on(n.Events.FRAG_PARSED, this.onFragParsed, this),
                      e.on(n.Events.FRAG_CHANGED, this.onFragChanged, this);
                  }),
                  (t.unregisterListeners = function() {
                    var e = this.hls;
                    e.off(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                      e.off(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      e.off(n.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      e.off(n.Events.BUFFER_RESET, this.onBufferReset, this),
                      e.off(n.Events.BUFFER_APPENDING, this.onBufferAppending, this),
                      e.off(n.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                      e.off(n.Events.BUFFER_EOS, this.onBufferEos, this),
                      e.off(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this),
                      e.off(n.Events.LEVEL_UPDATED, this.onLevelUpdated, this),
                      e.off(n.Events.FRAG_PARSED, this.onFragParsed, this),
                      e.off(n.Events.FRAG_CHANGED, this.onFragChanged, this);
                  }),
                  (t._initSourceBuffer = function() {
                    (this.sourceBuffer = {}),
                      (this.operationQueue = new d.default(this.sourceBuffer)),
                      (this.listeners = { audio: [], video: [], audiovideo: [] });
                  }),
                  (t.onManifestParsed = function(e, t) {
                    var r = 2;
                    ((t.audio && !t.video) || !t.altAudio) && (r = 1),
                      (this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = r),
                      (this.details = null),
                      s.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
                  }),
                  (t.onMediaAttaching = function(e, t) {
                    var r = (this.media = t.media);
                    if (r && c) {
                      var i = (this.mediaSource = new c());
                      i.addEventListener("sourceopen", this._onMediaSourceOpen),
                        i.addEventListener("sourceended", this._onMediaSourceEnded),
                        i.addEventListener("sourceclose", this._onMediaSourceClose),
                        (r.src = self.URL.createObjectURL(i)),
                        (this._objectUrl = r.src);
                    }
                  }),
                  (t.onMediaDetaching = function() {
                    var e = this.media,
                      t = this.mediaSource,
                      r = this._objectUrl;
                    if (t) {
                      if ((s.logger.log("[buffer-controller]: media source detaching"), "open" === t.readyState))
                        try {
                          t.endOfStream();
                        } catch (e) {
                          s.logger.warn(
                            "[buffer-controller]: onMediaDetaching: " + e.message + " while calling endOfStream"
                          );
                        }
                      this.onBufferReset(),
                        t.removeEventListener("sourceopen", this._onMediaSourceOpen),
                        t.removeEventListener("sourceended", this._onMediaSourceEnded),
                        t.removeEventListener("sourceclose", this._onMediaSourceClose),
                        e &&
                          (r && self.URL.revokeObjectURL(r),
                          e.src === r
                            ? (e.removeAttribute("src"), e.load())
                            : s.logger.warn(
                                "[buffer-controller]: media.src was changed by a third party - skip cleanup"
                              )),
                        (this.mediaSource = null),
                        (this.media = null),
                        (this._objectUrl = null),
                        (this.bufferCodecEventsExpected = this._bufferCodecEventsTotal),
                        (this.pendingTracks = {}),
                        (this.tracks = {});
                    }
                    this.hls.trigger(n.Events.MEDIA_DETACHED, void 0);
                  }),
                  (t.onBufferReset = function() {
                    var e = this;
                    this.getSourceBufferTypes().forEach(function(t) {
                      var r = e.sourceBuffer[t];
                      try {
                        r &&
                          (e.removeBufferListeners(t),
                          e.mediaSource && e.mediaSource.removeSourceBuffer(r),
                          (e.sourceBuffer[t] = void 0));
                      } catch (e) {
                        s.logger.warn("[buffer-controller]: Failed to reset the " + t + " buffer", e);
                      }
                    }),
                      this._initSourceBuffer();
                  }),
                  (t.onBufferCodecs = function(e, t) {
                    var r = this,
                      i = this.getSourceBufferTypes().length;
                    Object.keys(t).forEach(function(e) {
                      if (i) {
                        var n = r.tracks[e];
                        if (n && "function" == typeof n.buffer.changeType) {
                          var s = t[e],
                            a = s.codec,
                            o = s.levelCodec,
                            l = s.container;
                          if ((n.levelCodec || n.codec).replace(h, "$1") !== (o || a).replace(h, "$1")) {
                            var u = l + ";codecs=" + (o || a);
                            r.appendChangeType(e, u);
                          }
                        }
                      } else r.pendingTracks[e] = t[e];
                    }),
                      i ||
                        ((this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0)),
                        this.mediaSource && "open" === this.mediaSource.readyState && this.checkPendingTracks());
                  }),
                  (t.appendChangeType = function(e, t) {
                    var r = this,
                      i = this.operationQueue,
                      n = {
                        execute: function() {
                          var n = r.sourceBuffer[e];
                          n &&
                            (s.logger.log("[buffer-controller]: changing " + e + " sourceBuffer type to " + t),
                            n.changeType(t)),
                            i.shiftAndExecuteNext(e);
                        },
                        onStart: function() {},
                        onComplete: function() {},
                        onError: function(t) {
                          s.logger.warn("[buffer-controller]: Failed to change " + e + " SourceBuffer type", t);
                        }
                      };
                    i.append(n, e);
                  }),
                  (t.onBufferAppending = function(e, t) {
                    var r = this,
                      i = this.hls,
                      l = this.operationQueue,
                      u = this.tracks,
                      d = t.data,
                      c = t.type,
                      h = t.frag,
                      f = t.part,
                      p = t.chunkMeta,
                      v = p.buffering[c],
                      g = self.performance.now();
                    v.start = g;
                    var m = h.stats.buffering,
                      y = f ? f.stats.buffering : null;
                    0 === m.start && (m.start = g), y && 0 === y.start && (y.start = g);
                    var E = u.audio,
                      T = "audio" === c && 1 === p.id && "audio/mpeg" === (null == E ? void 0 : E.container),
                      b = {
                        execute: function() {
                          if (((v.executeStart = self.performance.now()), T)) {
                            var e = r.sourceBuffer[c];
                            if (e) {
                              var t = h.start - e.timestampOffset;
                              Math.abs(t) >= 0.1 &&
                                (s.logger.log(
                                  "[buffer-controller]: Updating audio SourceBuffer timestampOffset to " +
                                    h.start +
                                    " (delta: " +
                                    t +
                                    ") sn: " +
                                    h.sn +
                                    ")"
                                ),
                                (e.timestampOffset = h.start));
                            }
                          }
                          r.appendExecutor(d, c);
                        },
                        onStart: function() {},
                        onComplete: function() {
                          var e = self.performance.now();
                          (v.executeEnd = v.end = e),
                            0 === m.first && (m.first = e),
                            y && 0 === y.first && (y.first = e);
                          var t = r.sourceBuffer,
                            i = {};
                          for (var s in t) i[s] = o.BufferHelper.getBuffered(t[s]);
                          (r.appendError = 0),
                            r.hls.trigger(n.Events.BUFFER_APPENDED, {
                              type: c,
                              frag: h,
                              part: f,
                              chunkMeta: p,
                              parent: h.type,
                              timeRanges: i
                            });
                        },
                        onError: function(e) {
                          s.logger.error(
                            "[buffer-controller]: Error encountered while trying to append to the " +
                              c +
                              " SourceBuffer",
                            e
                          );
                          var t = {
                            type: a.ErrorTypes.MEDIA_ERROR,
                            parent: h.type,
                            details: a.ErrorDetails.BUFFER_APPEND_ERROR,
                            err: e,
                            fatal: !1
                          };
                          e.code === DOMException.QUOTA_EXCEEDED_ERR
                            ? (t.details = a.ErrorDetails.BUFFER_FULL_ERROR)
                            : (r.appendError++,
                              (t.details = a.ErrorDetails.BUFFER_APPEND_ERROR),
                              r.appendError > i.config.appendErrorMaxRetry &&
                                (s.logger.error(
                                  "[buffer-controller]: Failed " +
                                    i.config.appendErrorMaxRetry +
                                    " times to append segment in sourceBuffer"
                                ),
                                (t.fatal = !0))),
                            i.trigger(n.Events.ERROR, t);
                        }
                      };
                    l.append(b, c);
                  }),
                  (t.onBufferFlushing = function(e, t) {
                    var r = this,
                      i = this.operationQueue,
                      a = function(e) {
                        return {
                          execute: r.removeExecutor.bind(r, e, t.startOffset, t.endOffset),
                          onStart: function() {},
                          onComplete: function() {
                            r.hls.trigger(n.Events.BUFFER_FLUSHED, { type: e });
                          },
                          onError: function(t) {
                            s.logger.warn("[buffer-controller]: Failed to remove from " + e + " SourceBuffer", t);
                          }
                        };
                      };
                    t.type
                      ? i.append(a(t.type), t.type)
                      : this.getSourceBufferTypes().forEach(function(e) {
                          i.append(a(e), e);
                        });
                  }),
                  (t.onFragParsed = function(e, t) {
                    var r = this,
                      i = t.frag,
                      a = t.part,
                      o = [],
                      l = a ? a.elementaryStreams : i.elementaryStreams;
                    l[u.ElementaryStreamTypes.AUDIOVIDEO]
                      ? o.push("audiovideo")
                      : (l[u.ElementaryStreamTypes.AUDIO] && o.push("audio"),
                        l[u.ElementaryStreamTypes.VIDEO] && o.push("video")),
                      0 === o.length &&
                        s.logger.warn(
                          "Fragments must have at least one ElementaryStreamType set. type: " +
                            i.type +
                            " level: " +
                            i.level +
                            " sn: " +
                            i.sn
                        ),
                      this.blockBuffers(function() {
                        var e = self.performance.now();
                        (i.stats.buffering.end = e), a && (a.stats.buffering.end = e);
                        var t = a ? a.stats : i.stats;
                        r.hls.trigger(n.Events.FRAG_BUFFERED, { frag: i, part: a, stats: t, id: i.type });
                      }, o);
                  }),
                  (t.onFragChanged = function(e, t) {
                    this.flushBackBuffer();
                  }),
                  (t.onBufferEos = function(e, t) {
                    var r = this;
                    this.getSourceBufferTypes().reduce(function(e, i) {
                      var n = r.sourceBuffer[i];
                      return (
                        (t.type && t.type !== i) ||
                          (n &&
                            !n.ended &&
                            ((n.ended = !0), s.logger.log("[buffer-controller]: " + i + " sourceBuffer now EOS"))),
                        e && !(n && !n.ended)
                      );
                    }, !0) &&
                      this.blockBuffers(function() {
                        var e = r.mediaSource;
                        e && "open" === e.readyState && e.endOfStream();
                      });
                  }),
                  (t.onLevelUpdated = function(e, t) {
                    var r = t.details;
                    r.fragments.length &&
                      ((this.details = r),
                      this.getSourceBufferTypes().length
                        ? this.blockBuffers(this.updateMediaElementDuration.bind(this))
                        : this.updateMediaElementDuration());
                  }),
                  (t.flushBackBuffer = function() {
                    var e = this.hls,
                      t = this.details,
                      r = this.media,
                      s = this.sourceBuffer;
                    if (r && null !== t) {
                      var a = this.getSourceBufferTypes();
                      if (a.length) {
                        var l =
                          t.live && null !== e.config.liveBackBufferLength
                            ? e.config.liveBackBufferLength
                            : e.config.backBufferLength;
                        if (Object(i.isFiniteNumber)(l) && !(l < 0)) {
                          var u = r.currentTime,
                            d = t.levelTargetDuration,
                            c = Math.max(l, d),
                            h = Math.floor(u / d) * d - c;
                          a.forEach(function(r) {
                            var i = s[r];
                            if (i) {
                              var a = o.BufferHelper.getBuffered(i);
                              a.length > 0 &&
                                h > a.start(0) &&
                                (e.trigger(n.Events.BACK_BUFFER_REACHED, { bufferEnd: h }),
                                t.live && e.trigger(n.Events.LIVE_BACK_BUFFER_REACHED, { bufferEnd: h }),
                                e.trigger(n.Events.BUFFER_FLUSHING, { startOffset: 0, endOffset: h, type: r }));
                            }
                          });
                        }
                      }
                    }
                  }),
                  (t.updateMediaElementDuration = function() {
                    if (this.details && this.media && this.mediaSource && "open" === this.mediaSource.readyState) {
                      var e = this.details,
                        t = this.hls,
                        r = this.media,
                        n = this.mediaSource,
                        a = e.fragments[0].start + e.totalduration,
                        o = r.duration,
                        l = Object(i.isFiniteNumber)(n.duration) ? n.duration : 0;
                      e.live && t.config.liveDurationInfinity
                        ? (s.logger.log("[buffer-controller]: Media Source duration is set to Infinity"),
                          (n.duration = 1 / 0),
                          this.updateSeekableRange(e))
                        : ((a > l && a > o) || !Object(i.isFiniteNumber)(o)) &&
                          (s.logger.log("[buffer-controller]: Updating Media Source duration to " + a.toFixed(3)),
                          (n.duration = a));
                    }
                  }),
                  (t.updateSeekableRange = function(e) {
                    var t = this.mediaSource,
                      r = e.fragments;
                    if (r.length && e.live && null != t && t.setLiveSeekableRange) {
                      var i = Math.max(0, r[0].start),
                        n = Math.max(i, i + e.totalduration);
                      t.setLiveSeekableRange(i, n);
                    }
                  }),
                  (t.checkPendingTracks = function() {
                    var e = this.bufferCodecEventsExpected,
                      t = this.operationQueue,
                      r = this.pendingTracks,
                      i = Object.keys(r).length;
                    if ((i && !e) || 2 === i) {
                      this.createSourceBuffers(r), (this.pendingTracks = {});
                      var s = this.getSourceBufferTypes();
                      if (0 === s.length)
                        return void this.hls.trigger(n.Events.ERROR, {
                          type: a.ErrorTypes.MEDIA_ERROR,
                          details: a.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                          fatal: !0,
                          reason: "could not create source buffer for media codec(s)"
                        });
                      s.forEach(function(e) {
                        t.executeNext(e);
                      });
                    }
                  }),
                  (t.createSourceBuffers = function(e) {
                    var t = this.sourceBuffer,
                      r = this.mediaSource;
                    if (!r) throw Error("createSourceBuffers called when mediaSource was null");
                    var i = 0;
                    for (var o in e)
                      if (!t[o]) {
                        var l = e[o];
                        if (!l) throw Error("source buffer exists for track " + o + ", however track does not");
                        var u = l.levelCodec || l.codec,
                          d = l.container + ";codecs=" + u;
                        s.logger.log("[buffer-controller]: creating sourceBuffer(" + d + ")");
                        try {
                          var c = (t[o] = r.addSourceBuffer(d)),
                            h = o;
                          this.addBufferListener(h, "updatestart", this._onSBUpdateStart),
                            this.addBufferListener(h, "updateend", this._onSBUpdateEnd),
                            this.addBufferListener(h, "error", this._onSBUpdateError),
                            (this.tracks[o] = {
                              buffer: c,
                              codec: u,
                              container: l.container,
                              levelCodec: l.levelCodec,
                              id: l.id
                            }),
                            i++;
                        } catch (e) {
                          s.logger.error("[buffer-controller]: error while trying to add sourceBuffer: " + e.message),
                            this.hls.trigger(n.Events.ERROR, {
                              type: a.ErrorTypes.MEDIA_ERROR,
                              details: a.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                              fatal: !1,
                              error: e,
                              mimeType: d
                            });
                        }
                      }
                    i && this.hls.trigger(n.Events.BUFFER_CREATED, { tracks: this.tracks });
                  }),
                  (t._onSBUpdateStart = function(e) {
                    this.operationQueue.current(e).onStart();
                  }),
                  (t._onSBUpdateEnd = function(e) {
                    var t = this.operationQueue;
                    t.current(e).onComplete(), t.shiftAndExecuteNext(e);
                  }),
                  (t._onSBUpdateError = function(e, t) {
                    s.logger.error("[buffer-controller]: " + e + " SourceBuffer error", t),
                      this.hls.trigger(n.Events.ERROR, {
                        type: a.ErrorTypes.MEDIA_ERROR,
                        details: a.ErrorDetails.BUFFER_APPENDING_ERROR,
                        fatal: !1
                      });
                    var r = this.operationQueue.current(e);
                    r && r.onError(t);
                  }),
                  (t.removeExecutor = function(e, t, r) {
                    var n = this.media,
                      a = this.mediaSource,
                      o = this.operationQueue,
                      l = this.sourceBuffer[e];
                    if (!n || !a || !l)
                      return (
                        s.logger.warn(
                          "[buffer-controller]: Attempting to remove from the " +
                            e +
                            " SourceBuffer, but it does not exist"
                        ),
                        void o.shiftAndExecuteNext(e)
                      );
                    var u = Object(i.isFiniteNumber)(n.duration) ? n.duration : 1 / 0,
                      d = Object(i.isFiniteNumber)(a.duration) ? a.duration : 1 / 0,
                      c = Math.max(0, t),
                      h = Math.min(r, u, d);
                    h > c
                      ? (s.logger.log(
                          "[buffer-controller]: Removing [" + c + "," + h + "] from the " + e + " SourceBuffer"
                        ),
                        console.assert(!l.updating, e + " sourceBuffer must not be updating"),
                        l.remove(c, h))
                      : o.shiftAndExecuteNext(e);
                  }),
                  (t.appendExecutor = function(e, t) {
                    var r = this.operationQueue,
                      i = this.sourceBuffer[t];
                    if (!i)
                      return (
                        s.logger.warn(
                          "[buffer-controller]: Attempting to append to the " +
                            t +
                            " SourceBuffer, but it does not exist"
                        ),
                        void r.shiftAndExecuteNext(t)
                      );
                    (i.ended = !1),
                      console.assert(!i.updating, t + " sourceBuffer must not be updating"),
                      i.appendBuffer(e);
                  }),
                  (t.blockBuffers = function(e, t) {
                    var r = this;
                    if ((void 0 === t && (t = this.getSourceBufferTypes()), !t.length))
                      return (
                        s.logger.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"),
                        void Promise.resolve(e)
                      );
                    var i = this.operationQueue,
                      n = t.map(function(e) {
                        return i.appendBlocker(e);
                      });
                    Promise.all(n).then(function() {
                      e(),
                        t.forEach(function(e) {
                          var t = r.sourceBuffer[e];
                          (t && t.updating) || i.shiftAndExecuteNext(e);
                        });
                    });
                  }),
                  (t.getSourceBufferTypes = function() {
                    return Object.keys(this.sourceBuffer);
                  }),
                  (t.addBufferListener = function(e, t, r) {
                    var i = this.sourceBuffer[e];
                    if (i) {
                      var n = r.bind(this, e);
                      this.listeners[e].push({ event: t, listener: n }), i.addEventListener(t, n);
                    }
                  }),
                  (t.removeBufferListeners = function(e) {
                    var t = this.sourceBuffer[e];
                    t &&
                      this.listeners[e].forEach(function(e) {
                        t.removeEventListener(e.event, e.listener);
                      });
                  }),
                  e
                );
              })();
          },
          "./src/controller/buffer-operation-queue.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return n;
              });
            var i = r("./src/utils/logger.ts"),
              n = (function() {
                function e(e) {
                  (this.buffers = void 0), (this.queues = { video: [], audio: [], audiovideo: [] }), (this.buffers = e);
                }
                var t = e.prototype;
                return (
                  (t.append = function(e, t) {
                    var r = this.queues[t];
                    r.push(e), 1 === r.length && this.buffers[t] && this.executeNext(t);
                  }),
                  (t.insertAbort = function(e, t) {
                    this.queues[t].unshift(e), this.executeNext(t);
                  }),
                  (t.appendBlocker = function(e) {
                    var t,
                      r = new Promise(function(e) {
                        t = e;
                      }),
                      i = { execute: t, onStart: function() {}, onComplete: function() {}, onError: function() {} };
                    return this.append(i, e), r;
                  }),
                  (t.executeNext = function(e) {
                    var t = this.buffers,
                      r = this.queues,
                      n = t[e],
                      s = r[e];
                    if (s.length) {
                      var a = s[0];
                      try {
                        a.execute();
                      } catch (t) {
                        i.logger.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"),
                          a.onError(t),
                          (n && n.updating) || (s.shift(), this.executeNext(e));
                      }
                    }
                  }),
                  (t.shiftAndExecuteNext = function(e) {
                    this.queues[e].shift(), this.executeNext(e);
                  }),
                  (t.current = function(e) {
                    return this.queues[e][0];
                  }),
                  e
                );
              })();
          },
          "./src/controller/cap-level-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/events.ts");
            function n(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var s = (function() {
              function e(e) {
                (this.autoLevelCapping = void 0),
                  (this.firstLevel = void 0),
                  (this.media = void 0),
                  (this.restrictedLevels = void 0),
                  (this.timer = void 0),
                  (this.hls = void 0),
                  (this.streamController = void 0),
                  (this.clientRect = void 0),
                  (this.hls = e),
                  (this.autoLevelCapping = Number.POSITIVE_INFINITY),
                  (this.firstLevel = -1),
                  (this.media = null),
                  (this.restrictedLevels = []),
                  (this.timer = void 0),
                  (this.clientRect = null),
                  this.registerListeners();
              }
              var t,
                r,
                s,
                a = e.prototype;
              return (
                (a.setStreamController = function(e) {
                  this.streamController = e;
                }),
                (a.destroy = function() {
                  this.unregisterListener(),
                    this.hls.config.capLevelToPlayerSize && this.stopCapping(),
                    (this.media = null),
                    (this.clientRect = null),
                    (this.hls = this.streamController = null);
                }),
                (a.registerListeners = function() {
                  var e = this.hls;
                  e.on(i.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this),
                    e.on(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                    e.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.on(i.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                    e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                }),
                (a.unregisterListener = function() {
                  var e = this.hls;
                  e.off(i.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this),
                    e.off(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                    e.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.off(i.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                    e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                }),
                (a.onFpsDropLevelCapping = function(t, r) {
                  e.isLevelAllowed(r.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(r.droppedLevel);
                }),
                (a.onMediaAttaching = function(e, t) {
                  this.media = t.media instanceof HTMLVideoElement ? t.media : null;
                }),
                (a.onManifestParsed = function(e, t) {
                  var r = this.hls;
                  (this.restrictedLevels = []),
                    (this.firstLevel = t.firstLevel),
                    r.config.capLevelToPlayerSize && t.video && this.startCapping();
                }),
                (a.onBufferCodecs = function(e, t) {
                  this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
                }),
                (a.onMediaDetaching = function() {
                  this.stopCapping();
                }),
                (a.detectPlayerSize = function() {
                  if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
                    var e = this.hls.levels;
                    if (e.length) {
                      var t = this.hls;
                      (t.autoLevelCapping = this.getMaxLevel(e.length - 1)),
                        t.autoLevelCapping > this.autoLevelCapping &&
                          this.streamController &&
                          this.streamController.nextLevelSwitch(),
                        (this.autoLevelCapping = t.autoLevelCapping);
                    }
                  }
                }),
                (a.getMaxLevel = function(t) {
                  var r = this,
                    i = this.hls.levels;
                  if (!i.length) return -1;
                  var n = i.filter(function(i, n) {
                    return e.isLevelAllowed(n, r.restrictedLevels) && n <= t;
                  });
                  return (this.clientRect = null), e.getMaxLevelByMediaSize(n, this.mediaWidth, this.mediaHeight);
                }),
                (a.startCapping = function() {
                  this.timer ||
                    ((this.autoLevelCapping = Number.POSITIVE_INFINITY),
                    (this.hls.firstLevel = this.getMaxLevel(this.firstLevel)),
                    self.clearInterval(this.timer),
                    (this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3)),
                    this.detectPlayerSize());
                }),
                (a.stopCapping = function() {
                  (this.restrictedLevels = []),
                    (this.firstLevel = -1),
                    (this.autoLevelCapping = Number.POSITIVE_INFINITY),
                    this.timer && (self.clearInterval(this.timer), (this.timer = void 0));
                }),
                (a.getDimensions = function() {
                  if (this.clientRect) return this.clientRect;
                  var e = this.media,
                    t = { width: 0, height: 0 };
                  if (e) {
                    var r = e.getBoundingClientRect();
                    (t.width = r.width),
                      (t.height = r.height),
                      t.width ||
                        t.height ||
                        ((t.width = r.right - r.left || e.width || 0), (t.height = r.bottom - r.top || e.height || 0));
                  }
                  return (this.clientRect = t), t;
                }),
                (e.isLevelAllowed = function(e, t) {
                  return void 0 === t && (t = []), -1 === t.indexOf(e);
                }),
                (e.getMaxLevelByMediaSize = function(e, t, r) {
                  if (!e || !e.length) return -1;
                  for (var i, n, s = e.length - 1, a = 0; a < e.length; a += 1) {
                    var o = e[a];
                    if (
                      (o.width >= t || o.height >= r) &&
                      ((i = o), !(n = e[a + 1]) || i.width !== n.width || i.height !== n.height)
                    ) {
                      s = a;
                      break;
                    }
                  }
                  return s;
                }),
                (t = e),
                (s = [
                  {
                    key: "contentScaleFactor",
                    get: function() {
                      var e = 1;
                      try {
                        e = self.devicePixelRatio;
                      } catch (e) {}
                      return e;
                    }
                  }
                ]),
                (r = [
                  {
                    key: "mediaWidth",
                    get: function() {
                      return this.getDimensions().width * e.contentScaleFactor;
                    }
                  },
                  {
                    key: "mediaHeight",
                    get: function() {
                      return this.getDimensions().height * e.contentScaleFactor;
                    }
                  }
                ]) && n(t.prototype, r),
                s && n(t, s),
                e
              );
            })();
            t.default = s;
          },
          "./src/controller/cmcd-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return h;
              });
            var i = r("./src/events.ts"),
              n = r("./src/types/cmcd.ts"),
              s = r("./src/utils/buffer-helper.ts"),
              a = r("./src/utils/logger.ts");
            function o(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function l(e, t, r) {
              return t && o(e.prototype, t), r && o(e, r), e;
            }
            function u(e, t) {
              var r = ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
              if (r) return (r = r.call(e)).next.bind(r);
              if (
                Array.isArray(e) ||
                (r = (function(e, t) {
                  if (e) {
                    if ("string" == typeof e) return d(e, t);
                    var r = Object.prototype.toString.call(e).slice(8, -1);
                    return (
                      "Object" === r && e.constructor && (r = e.constructor.name),
                      "Map" === r || "Set" === r
                        ? Array.from(e)
                        : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                          ? d(e, t)
                          : void 0
                    );
                  }
                })(e)) ||
                (t && e && "number" == typeof e.length)
              ) {
                r && (e = r);
                var i = 0;
                return function() {
                  return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
                };
              }
              throw new TypeError(
                "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            }
            function d(e, t) {
              (null == t || t > e.length) && (t = e.length);
              for (var r = 0, i = new Array(t); r < t; r++) i[r] = e[r];
              return i;
            }
            function c() {
              return (c =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var h = (function() {
              function e(t) {
                var r = this;
                (this.hls = void 0),
                  (this.config = void 0),
                  (this.media = void 0),
                  (this.sid = void 0),
                  (this.cid = void 0),
                  (this.useHeaders = !1),
                  (this.initialized = !1),
                  (this.starved = !1),
                  (this.buffering = !0),
                  (this.audioBuffer = void 0),
                  (this.videoBuffer = void 0),
                  (this.onWaiting = function() {
                    r.initialized && (r.starved = !0), (r.buffering = !0);
                  }),
                  (this.onPlaying = function() {
                    r.initialized || (r.initialized = !0), (r.buffering = !1);
                  }),
                  (this.applyPlaylistData = function(e) {
                    try {
                      r.apply(e, { ot: n.CMCDObjectType.MANIFEST, su: !r.initialized });
                    } catch (e) {
                      a.logger.warn("Could not generate manifest CMCD data.", e);
                    }
                  }),
                  (this.applyFragmentData = function(e) {
                    try {
                      var t = e.frag,
                        i = r.hls.levels[t.level],
                        s = r.getObjectType(t),
                        o = { d: 1e3 * t.duration, ot: s };
                      (s !== n.CMCDObjectType.VIDEO && s !== n.CMCDObjectType.AUDIO && s != n.CMCDObjectType.MUXED) ||
                        ((o.br = i.bitrate / 1e3), (o.tb = r.getTopBandwidth(s) / 1e3), (o.bl = r.getBufferLength(s))),
                        r.apply(e, o);
                    } catch (e) {
                      a.logger.warn("Could not generate segment CMCD data.", e);
                    }
                  }),
                  (this.hls = t);
                var i = (this.config = t.config),
                  s = i.cmcd;
                null != s &&
                  ((i.pLoader = this.createPlaylistLoader()),
                  (i.fLoader = this.createFragmentLoader()),
                  (this.sid = s.sessionId || e.uuid()),
                  (this.cid = s.contentId),
                  (this.useHeaders = !0 === s.useHeaders),
                  this.registerListeners());
              }
              var t = e.prototype;
              return (
                (t.registerListeners = function() {
                  var e = this.hls;
                  e.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.on(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                    e.on(i.Events.BUFFER_CREATED, this.onBufferCreated, this);
                }),
                (t.unregisterListeners = function() {
                  var e = this.hls;
                  e.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.off(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                    e.off(i.Events.BUFFER_CREATED, this.onBufferCreated, this),
                    this.onMediaDetached();
                }),
                (t.destroy = function() {
                  this.unregisterListeners(), (this.hls = this.config = this.audioBuffer = this.videoBuffer = null);
                }),
                (t.onMediaAttached = function(e, t) {
                  (this.media = t.media),
                    this.media.addEventListener("waiting", this.onWaiting),
                    this.media.addEventListener("playing", this.onPlaying);
                }),
                (t.onMediaDetached = function() {
                  this.media &&
                    (this.media.removeEventListener("waiting", this.onWaiting),
                    this.media.removeEventListener("playing", this.onPlaying),
                    (this.media = null));
                }),
                (t.onBufferCreated = function(e, t) {
                  var r, i;
                  (this.audioBuffer = null === (r = t.tracks.audio) || void 0 === r ? void 0 : r.buffer),
                    (this.videoBuffer = null === (i = t.tracks.video) || void 0 === i ? void 0 : i.buffer);
                }),
                (t.createData = function() {
                  var e;
                  return {
                    v: n.CMCDVersion,
                    sf: n.CMCDStreamingFormat.HLS,
                    sid: this.sid,
                    cid: this.cid,
                    pr: null === (e = this.media) || void 0 === e ? void 0 : e.playbackRate,
                    mtp: this.hls.bandwidthEstimate / 1e3
                  };
                }),
                (t.apply = function(t, r) {
                  void 0 === r && (r = {}), c(r, this.createData());
                  var i =
                    r.ot === n.CMCDObjectType.INIT ||
                    r.ot === n.CMCDObjectType.VIDEO ||
                    r.ot === n.CMCDObjectType.MUXED;
                  if (
                    (this.starved && i && ((r.bs = !0), (r.su = !0), (this.starved = !1)),
                    null == r.su && (r.su = this.buffering),
                    this.useHeaders)
                  ) {
                    var s = e.toHeaders(r);
                    if (!Object.keys(s).length) return;
                    t.headers || (t.headers = {}), c(t.headers, s);
                  } else {
                    var a = e.toQuery(r);
                    if (!a) return;
                    t.url = e.appendQueryToUri(t.url, a);
                  }
                }),
                (t.getObjectType = function(e) {
                  var t = e.type;
                  return "subtitle" === t
                    ? n.CMCDObjectType.TIMED_TEXT
                    : "initSegment" === e.sn
                      ? n.CMCDObjectType.INIT
                      : "audio" === t
                        ? n.CMCDObjectType.AUDIO
                        : "main" === t
                          ? this.hls.audioTracks.length
                            ? n.CMCDObjectType.VIDEO
                            : n.CMCDObjectType.MUXED
                          : void 0;
                }),
                (t.getTopBandwidth = function(e) {
                  var t,
                    r = 0,
                    i = this.hls;
                  if (e === n.CMCDObjectType.AUDIO) t = i.audioTracks;
                  else {
                    var s = i.maxAutoLevel,
                      a = s > -1 ? s + 1 : i.levels.length;
                    t = i.levels.slice(0, a);
                  }
                  for (var o, l = u(t); !(o = l()).done; ) {
                    var d = o.value;
                    d.bitrate > r && (r = d.bitrate);
                  }
                  return r > 0 ? r : NaN;
                }),
                (t.getBufferLength = function(e) {
                  var t = this.hls.media,
                    r = e === n.CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
                  return r && t
                    ? 1e3 * s.BufferHelper.bufferInfo(r, t.currentTime, this.config.maxBufferHole).len
                    : NaN;
                }),
                (t.createPlaylistLoader = function() {
                  var e = this.config.pLoader,
                    t = this.applyPlaylistData,
                    r = e || this.config.loader;
                  return (function() {
                    function e(e) {
                      (this.loader = void 0), (this.loader = new r(e));
                    }
                    var i = e.prototype;
                    return (
                      (i.destroy = function() {
                        this.loader.destroy();
                      }),
                      (i.abort = function() {
                        this.loader.abort();
                      }),
                      (i.load = function(e, r, i) {
                        t(e), this.loader.load(e, r, i);
                      }),
                      l(e, [
                        {
                          key: "stats",
                          get: function() {
                            return this.loader.stats;
                          }
                        },
                        {
                          key: "context",
                          get: function() {
                            return this.loader.context;
                          }
                        }
                      ]),
                      e
                    );
                  })();
                }),
                (t.createFragmentLoader = function() {
                  var e = this.config.fLoader,
                    t = this.applyFragmentData,
                    r = e || this.config.loader;
                  return (function() {
                    function e(e) {
                      (this.loader = void 0), (this.loader = new r(e));
                    }
                    var i = e.prototype;
                    return (
                      (i.destroy = function() {
                        this.loader.destroy();
                      }),
                      (i.abort = function() {
                        this.loader.abort();
                      }),
                      (i.load = function(e, r, i) {
                        t(e), this.loader.load(e, r, i);
                      }),
                      l(e, [
                        {
                          key: "stats",
                          get: function() {
                            return this.loader.stats;
                          }
                        },
                        {
                          key: "context",
                          get: function() {
                            return this.loader.context;
                          }
                        }
                      ]),
                      e
                    );
                  })();
                }),
                (e.uuid = function() {
                  var e = URL.createObjectURL(new Blob()),
                    t = e.toString();
                  return URL.revokeObjectURL(e), t.substr(t.lastIndexOf("/") + 1);
                }),
                (e.serialize = function(e) {
                  for (
                    var t,
                      r = [],
                      i = function(e) {
                        return !Number.isNaN(e) && null != e && "" !== e && !1 !== e;
                      },
                      n = function(e) {
                        return Math.round(e);
                      },
                      s = function(e) {
                        return 100 * n(e / 100);
                      },
                      a = {
                        br: n,
                        d: n,
                        bl: s,
                        dl: s,
                        mtp: s,
                        nor: function(e) {
                          return encodeURIComponent(e);
                        },
                        rtp: s,
                        tb: n
                      },
                      o = u(Object.keys(e || {}).sort());
                    !(t = o()).done;

                  ) {
                    var l = t.value,
                      d = e[l];
                    if (i(d) && !(("v" === l && 1 === d) || ("pr" == l && 1 === d))) {
                      var c = a[l];
                      c && (d = c(d));
                      var h = typeof d,
                        f = void 0;
                      (f =
                        "ot" === l || "sf" === l || "st" === l
                          ? l + "=" + d
                          : "boolean" === h
                            ? l
                            : "number" === h
                              ? l + "=" + d
                              : l + "=" + JSON.stringify(d)),
                        r.push(f);
                    }
                  }
                  return r.join(",");
                }),
                (e.toHeaders = function(t) {
                  for (
                    var r = {},
                      i = ["Object", "Request", "Session", "Status"],
                      n = [{}, {}, {}, {}],
                      s = {
                        br: 0,
                        d: 0,
                        ot: 0,
                        tb: 0,
                        bl: 1,
                        dl: 1,
                        mtp: 1,
                        nor: 1,
                        nrr: 1,
                        su: 1,
                        cid: 2,
                        pr: 2,
                        sf: 2,
                        sid: 2,
                        st: 2,
                        v: 2,
                        bs: 3,
                        rtp: 3
                      },
                      a = 0,
                      o = Object.keys(t);
                    a < o.length;
                    a++
                  ) {
                    var l = o[a];
                    n[null != s[l] ? s[l] : 1][l] = t[l];
                  }
                  for (var u = 0; u < n.length; u++) {
                    var d = e.serialize(n[u]);
                    d && (r["CMCD-" + i[u]] = d);
                  }
                  return r;
                }),
                (e.toQuery = function(t) {
                  return "CMCD=" + encodeURIComponent(e.serialize(t));
                }),
                (e.appendQueryToUri = function(e, t) {
                  if (!t) return e;
                  var r = e.includes("?") ? "&" : "?";
                  return "" + e + r + t;
                }),
                e
              );
            })();
          },
          "./src/controller/eme-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/events.ts"),
              n = r("./src/errors.ts"),
              s = r("./src/utils/logger.ts"),
              a = r("./src/utils/mediakeys-helper.ts");
            function o(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var l = (function() {
              function e(e) {
                (this.hls = void 0),
                  (this._widevineLicenseUrl = void 0),
                  (this._licenseXhrSetup = void 0),
                  (this._licenseResponseCallback = void 0),
                  (this._emeEnabled = void 0),
                  (this._requestMediaKeySystemAccess = void 0),
                  (this._drmSystemOptions = void 0),
                  (this._config = void 0),
                  (this._mediaKeysList = []),
                  (this._media = null),
                  (this._hasSetMediaKeys = !1),
                  (this._requestLicenseFailureCount = 0),
                  (this.mediaKeysPromise = null),
                  (this._onMediaEncrypted = this.onMediaEncrypted.bind(this)),
                  (this.hls = e),
                  (this._config = e.config),
                  (this._widevineLicenseUrl = this._config.widevineLicenseUrl),
                  (this._licenseXhrSetup = this._config.licenseXhrSetup),
                  (this._licenseResponseCallback = this._config.licenseResponseCallback),
                  (this._emeEnabled = this._config.emeEnabled),
                  (this._requestMediaKeySystemAccess = this._config.requestMediaKeySystemAccessFunc),
                  (this._drmSystemOptions = this._config.drmSystemOptions),
                  this._registerListeners();
              }
              var t,
                r,
                l,
                u = e.prototype;
              return (
                (u.destroy = function() {
                  this._unregisterListeners(),
                    (this.hls = this._onMediaEncrypted = null),
                    (this._requestMediaKeySystemAccess = null);
                }),
                (u._registerListeners = function() {
                  this.hls.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    this.hls.on(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                    this.hls.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                }),
                (u._unregisterListeners = function() {
                  this.hls.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    this.hls.off(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                    this.hls.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                }),
                (u.getLicenseServerUrl = function(e) {
                  switch (e) {
                    case a.KeySystems.WIDEVINE:
                      if (!this._widevineLicenseUrl) break;
                      return this._widevineLicenseUrl;
                  }
                  throw new Error('no license server URL configured for key-system "' + e + '"');
                }),
                (u._attemptKeySystemAccess = function(e, t, r) {
                  var i = this,
                    n = (function(e, t, r, i) {
                      switch (e) {
                        case a.KeySystems.WIDEVINE:
                          return (function(e, t, r) {
                            var i = { audioCapabilities: [], videoCapabilities: [] };
                            return (
                              e.forEach(function(e) {
                                i.audioCapabilities.push({
                                  contentType: 'audio/mp4; codecs="' + e + '"',
                                  robustness: r.audioRobustness || ""
                                });
                              }),
                              t.forEach(function(e) {
                                i.videoCapabilities.push({
                                  contentType: 'video/mp4; codecs="' + e + '"',
                                  robustness: r.videoRobustness || ""
                                });
                              }),
                              [i]
                            );
                          })(t, r, i);
                        default:
                          throw new Error("Unknown key-system: " + e);
                      }
                    })(e, t, r, this._drmSystemOptions);
                  s.logger.log("Requesting encrypted media key-system access");
                  var o = this.requestMediaKeySystemAccess(e, n);
                  (this.mediaKeysPromise = o.then(function(t) {
                    return i._onMediaKeySystemAccessObtained(e, t);
                  })),
                    o.catch(function(t) {
                      s.logger.error('Failed to obtain key-system "' + e + '" access:', t);
                    });
                }),
                (u._onMediaKeySystemAccessObtained = function(e, t) {
                  var r = this;
                  s.logger.log('Access for key-system "' + e + '" obtained');
                  var i = { mediaKeysSessionInitialized: !1, mediaKeySystemAccess: t, mediaKeySystemDomain: e };
                  this._mediaKeysList.push(i);
                  var n = Promise.resolve()
                    .then(function() {
                      return t.createMediaKeys();
                    })
                    .then(function(t) {
                      return (
                        (i.mediaKeys = t),
                        s.logger.log('Media-keys created for key-system "' + e + '"'),
                        r._onMediaKeysCreated(),
                        t
                      );
                    });
                  return (
                    n.catch(function(e) {
                      s.logger.error("Failed to create media-keys:", e);
                    }),
                    n
                  );
                }),
                (u._onMediaKeysCreated = function() {
                  var e = this;
                  this._mediaKeysList.forEach(function(t) {
                    t.mediaKeysSession ||
                      ((t.mediaKeysSession = t.mediaKeys.createSession()), e._onNewMediaKeySession(t.mediaKeysSession));
                  });
                }),
                (u._onNewMediaKeySession = function(e) {
                  var t = this;
                  s.logger.log("New key-system session " + e.sessionId),
                    e.addEventListener(
                      "message",
                      function(r) {
                        t._onKeySessionMessage(e, r.message);
                      },
                      !1
                    );
                }),
                (u._onKeySessionMessage = function(e, t) {
                  s.logger.log("Got EME message event, creating license request"),
                    this._requestLicense(t, function(t) {
                      s.logger.log(
                        "Received license data (length: " + (t ? t.byteLength : t) + "), updating key-session"
                      ),
                        e.update(t);
                    });
                }),
                (u.onMediaEncrypted = function(e) {
                  var t = this;
                  if (
                    (s.logger.log('Media is encrypted using "' + e.initDataType + '" init data type'),
                    !this.mediaKeysPromise)
                  )
                    return (
                      s.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been requested"),
                      void this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: n.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                        fatal: !0
                      })
                    );
                  var r = function(r) {
                    t._media &&
                      (t._attemptSetMediaKeys(r),
                      t._generateRequestWithPreferredKeySession(e.initDataType, e.initData));
                  };
                  this.mediaKeysPromise.then(r).catch(r);
                }),
                (u._attemptSetMediaKeys = function(e) {
                  if (!this._media)
                    throw new Error("Attempted to set mediaKeys without first attaching a media element");
                  if (!this._hasSetMediaKeys) {
                    var t = this._mediaKeysList[0];
                    if (!t || !t.mediaKeys)
                      return (
                        s.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"),
                        void this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                          fatal: !0
                        })
                      );
                    s.logger.log("Setting keys for encrypted media"),
                      this._media.setMediaKeys(t.mediaKeys),
                      (this._hasSetMediaKeys = !0);
                  }
                }),
                (u._generateRequestWithPreferredKeySession = function(e, t) {
                  var r = this,
                    a = this._mediaKeysList[0];
                  if (!a)
                    return (
                      s.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"),
                      void this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: n.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                        fatal: !0
                      })
                    );
                  if (a.mediaKeysSessionInitialized)
                    s.logger.warn("Key-Session already initialized but requested again");
                  else {
                    var o = a.mediaKeysSession;
                    if (!o)
                      return (
                        s.logger.error("Fatal: Media is encrypted but no key-session existing"),
                        void this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                          fatal: !0
                        })
                      );
                    if (!t)
                      return (
                        s.logger.warn("Fatal: initData required for generating a key session is null"),
                        void this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                          fatal: !0
                        })
                      );
                    s.logger.log('Generating key-session request for "' + e + '" init data type'),
                      (a.mediaKeysSessionInitialized = !0),
                      o
                        .generateRequest(e, t)
                        .then(function() {
                          s.logger.debug("Key-session generation succeeded");
                        })
                        .catch(function(e) {
                          s.logger.error("Error generating key-session request:", e),
                            r.hls.trigger(i.Events.ERROR, {
                              type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                              details: n.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                              fatal: !1
                            });
                        });
                  }
                }),
                (u._createLicenseXhr = function(e, t, r) {
                  var i = new XMLHttpRequest();
                  (i.responseType = "arraybuffer"),
                    (i.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, i, e, t, r));
                  var n = this._licenseXhrSetup;
                  if (n)
                    try {
                      n.call(this.hls, i, e), (n = void 0);
                    } catch (e) {
                      s.logger.error(e);
                    }
                  try {
                    i.readyState || i.open("POST", e, !0), n && n.call(this.hls, i, e);
                  } catch (e) {
                    throw new Error("issue setting up KeySystem license XHR " + e);
                  }
                  return i;
                }),
                (u._onLicenseRequestReadyStageChange = function(e, t, r, a) {
                  switch (e.readyState) {
                    case 4:
                      if (200 === e.status) {
                        (this._requestLicenseFailureCount = 0), s.logger.log("License request succeeded");
                        var o = e.response,
                          l = this._licenseResponseCallback;
                        if (l)
                          try {
                            o = l.call(this.hls, e, t);
                          } catch (e) {
                            s.logger.error(e);
                          }
                        a(o);
                      } else {
                        if (
                          (s.logger.error(
                            "License Request XHR failed (" + t + "). Status: " + e.status + " (" + e.statusText + ")"
                          ),
                          this._requestLicenseFailureCount++,
                          this._requestLicenseFailureCount > 3)
                        )
                          return void this.hls.trigger(i.Events.ERROR, {
                            type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: n.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: !0
                          });
                        var u = 3 - this._requestLicenseFailureCount + 1;
                        s.logger.warn("Retrying license request, " + u + " attempts left"), this._requestLicense(r, a);
                      }
                  }
                }),
                (u._generateLicenseRequestChallenge = function(e, t) {
                  switch (e.mediaKeySystemDomain) {
                    case a.KeySystems.WIDEVINE:
                      return t;
                  }
                  throw new Error("unsupported key-system: " + e.mediaKeySystemDomain);
                }),
                (u._requestLicense = function(e, t) {
                  s.logger.log("Requesting content license for key-system");
                  var r = this._mediaKeysList[0];
                  if (!r)
                    return (
                      s.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"),
                      void this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: n.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                        fatal: !0
                      })
                    );
                  try {
                    var a = this.getLicenseServerUrl(r.mediaKeySystemDomain),
                      o = this._createLicenseXhr(a, e, t);
                    s.logger.log("Sending license request to URL: " + a);
                    var l = this._generateLicenseRequestChallenge(r, e);
                    o.send(l);
                  } catch (e) {
                    s.logger.error("Failure requesting DRM license: " + e),
                      this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: n.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                        fatal: !0
                      });
                  }
                }),
                (u.onMediaAttached = function(e, t) {
                  if (this._emeEnabled) {
                    var r = t.media;
                    (this._media = r), r.addEventListener("encrypted", this._onMediaEncrypted);
                  }
                }),
                (u.onMediaDetached = function() {
                  var e = this._media,
                    t = this._mediaKeysList;
                  e &&
                    (e.removeEventListener("encrypted", this._onMediaEncrypted),
                    (this._media = null),
                    (this._mediaKeysList = []),
                    Promise.all(
                      t.map(function(e) {
                        if (e.mediaKeysSession) return e.mediaKeysSession.close().catch(function() {});
                      })
                    )
                      .then(function() {
                        return e.setMediaKeys(null);
                      })
                      .catch(function() {}));
                }),
                (u.onManifestParsed = function(e, t) {
                  if (this._emeEnabled) {
                    var r = t.levels
                        .map(function(e) {
                          return e.audioCodec;
                        })
                        .filter(function(e) {
                          return !!e;
                        }),
                      i = t.levels
                        .map(function(e) {
                          return e.videoCodec;
                        })
                        .filter(function(e) {
                          return !!e;
                        });
                    this._attemptKeySystemAccess(a.KeySystems.WIDEVINE, r, i);
                  }
                }),
                (t = e),
                (r = [
                  {
                    key: "requestMediaKeySystemAccess",
                    get: function() {
                      if (!this._requestMediaKeySystemAccess)
                        throw new Error("No requestMediaKeySystemAccess function configured");
                      return this._requestMediaKeySystemAccess;
                    }
                  }
                ]) && o(t.prototype, r),
                l && o(t, l),
                e
              );
            })();
            t.default = l;
          },
          "./src/controller/fps-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/events.ts"),
              n = r("./src/utils/logger.ts"),
              s = (function() {
                function e(e) {
                  (this.hls = void 0),
                    (this.isVideoPlaybackQualityAvailable = !1),
                    (this.timer = void 0),
                    (this.media = null),
                    (this.lastTime = void 0),
                    (this.lastDroppedFrames = 0),
                    (this.lastDecodedFrames = 0),
                    (this.streamController = void 0),
                    (this.hls = e),
                    this.registerListeners();
                }
                var t = e.prototype;
                return (
                  (t.setStreamController = function(e) {
                    this.streamController = e;
                  }),
                  (t.registerListeners = function() {
                    this.hls.on(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
                  }),
                  (t.unregisterListeners = function() {
                    this.hls.off(i.Events.MEDIA_ATTACHING, this.onMediaAttaching);
                  }),
                  (t.destroy = function() {
                    this.timer && clearInterval(this.timer),
                      this.unregisterListeners(),
                      (this.isVideoPlaybackQualityAvailable = !1),
                      (this.media = null);
                  }),
                  (t.onMediaAttaching = function(e, t) {
                    var r = this.hls.config;
                    if (r.capLevelOnFPSDrop) {
                      var i = t.media instanceof self.HTMLVideoElement ? t.media : null;
                      (this.media = i),
                        i &&
                          "function" == typeof i.getVideoPlaybackQuality &&
                          (this.isVideoPlaybackQualityAvailable = !0),
                        self.clearInterval(this.timer),
                        (this.timer = self.setInterval(this.checkFPSInterval.bind(this), r.fpsDroppedMonitoringPeriod));
                    }
                  }),
                  (t.checkFPS = function(e, t, r) {
                    var s = performance.now();
                    if (t) {
                      if (this.lastTime) {
                        var a = s - this.lastTime,
                          o = r - this.lastDroppedFrames,
                          l = t - this.lastDecodedFrames,
                          u = (1e3 * o) / a,
                          d = this.hls;
                        if (
                          (d.trigger(i.Events.FPS_DROP, {
                            currentDropped: o,
                            currentDecoded: l,
                            totalDroppedFrames: r
                          }),
                          u > 0 && o > d.config.fpsDroppedMonitoringThreshold * l)
                        ) {
                          var c = d.currentLevel;
                          n.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + c),
                            c > 0 &&
                              (-1 === d.autoLevelCapping || d.autoLevelCapping >= c) &&
                              ((c -= 1),
                              d.trigger(i.Events.FPS_DROP_LEVEL_CAPPING, { level: c, droppedLevel: d.currentLevel }),
                              (d.autoLevelCapping = c),
                              this.streamController.nextLevelSwitch());
                        }
                      }
                      (this.lastTime = s), (this.lastDroppedFrames = r), (this.lastDecodedFrames = t);
                    }
                  }),
                  (t.checkFPSInterval = function() {
                    var e = this.media;
                    if (e)
                      if (this.isVideoPlaybackQualityAvailable) {
                        var t = e.getVideoPlaybackQuality();
                        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
                      } else this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
                  }),
                  e
                );
              })();
            t.default = s;
          },
          "./src/controller/fragment-finders.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "findFragmentByPDT", function() {
                return s;
              }),
              r.d(t, "findFragmentByPTS", function() {
                return a;
              }),
              r.d(t, "fragmentWithinToleranceTest", function() {
                return o;
              }),
              r.d(t, "pdtWithinToleranceTest", function() {
                return l;
              }),
              r.d(t, "findFragWithCC", function() {
                return u;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/utils/binary-search.ts");
            function s(e, t, r) {
              if (null === t || !Array.isArray(e) || !e.length || !Object(i.isFiniteNumber)(t)) return null;
              if (t < (e[0].programDateTime || 0)) return null;
              if (t >= (e[e.length - 1].endProgramDateTime || 0)) return null;
              r = r || 0;
              for (var n = 0; n < e.length; ++n) {
                var s = e[n];
                if (l(t, r, s)) return s;
              }
              return null;
            }
            function a(e, t, r, i) {
              void 0 === r && (r = 0), void 0 === i && (i = 0);
              var s = null;
              if (
                (e ? (s = t[e.sn - t[0].sn + 1] || null) : 0 === r && 0 === t[0].start && (s = t[0]),
                s && 0 === o(r, i, s))
              )
                return s;
              var a = n.default.search(t, o.bind(null, r, i));
              return a || s;
            }
            function o(e, t, r) {
              void 0 === e && (e = 0), void 0 === t && (t = 0);
              var i = Math.min(t, r.duration + (r.deltaPTS ? r.deltaPTS : 0));
              return r.start + r.duration - i <= e ? 1 : r.start - i > e && r.start ? -1 : 0;
            }
            function l(e, t, r) {
              var i = 1e3 * Math.min(t, r.duration + (r.deltaPTS ? r.deltaPTS : 0));
              return (r.endProgramDateTime || 0) - i > e;
            }
            function u(e, t) {
              return n.default.search(e, function(e) {
                return e.cc < t ? 1 : e.cc > t ? -1 : 0;
              });
            }
          },
          "./src/controller/fragment-tracker.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "FragmentState", function() {
                return i;
              }),
              r.d(t, "FragmentTracker", function() {
                return a;
              });
            var i,
              n = r("./src/events.ts"),
              s = r("./src/types/loader.ts");
            !(function(e) {
              (e.NOT_LOADED = "NOT_LOADED"),
                (e.BACKTRACKED = "BACKTRACKED"),
                (e.APPENDING = "APPENDING"),
                (e.PARTIAL = "PARTIAL"),
                (e.OK = "OK");
            })(i || (i = {}));
            var a = (function() {
              function e(e) {
                (this.activeFragment = null),
                  (this.activeParts = null),
                  (this.fragments = Object.create(null)),
                  (this.timeRanges = Object.create(null)),
                  (this.bufferPadding = 0.2),
                  (this.hls = void 0),
                  (this.hls = e),
                  this._registerListeners();
              }
              var t = e.prototype;
              return (
                (t._registerListeners = function() {
                  var e = this.hls;
                  e.on(n.Events.BUFFER_APPENDED, this.onBufferAppended, this),
                    e.on(n.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                    e.on(n.Events.FRAG_LOADED, this.onFragLoaded, this);
                }),
                (t._unregisterListeners = function() {
                  var e = this.hls;
                  e.off(n.Events.BUFFER_APPENDED, this.onBufferAppended, this),
                    e.off(n.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                    e.off(n.Events.FRAG_LOADED, this.onFragLoaded, this);
                }),
                (t.destroy = function() {
                  this._unregisterListeners(), (this.fragments = this.timeRanges = null);
                }),
                (t.getAppendedFrag = function(e, t) {
                  if (t === s.PlaylistLevelType.MAIN) {
                    var r = this.activeFragment,
                      i = this.activeParts;
                    if (!r) return null;
                    if (i)
                      for (var n = i.length; n--; ) {
                        var a = i[n],
                          o = a ? a.end : r.appendedPTS;
                        if (a.start <= e && void 0 !== o && e <= o)
                          return n > 9 && (this.activeParts = i.slice(n - 9)), a;
                      }
                    else if (r.start <= e && void 0 !== r.appendedPTS && e <= r.appendedPTS) return r;
                  }
                  return this.getBufferedFrag(e, t);
                }),
                (t.getBufferedFrag = function(e, t) {
                  for (var r = this.fragments, i = Object.keys(r), n = i.length; n--; ) {
                    var s = r[i[n]];
                    if ((null == s ? void 0 : s.body.type) === t && s.buffered) {
                      var a = s.body;
                      if (a.start <= e && e <= a.end) return a;
                    }
                  }
                  return null;
                }),
                (t.detectEvictedFragments = function(e, t, r) {
                  var i = this;
                  Object.keys(this.fragments).forEach(function(n) {
                    var s = i.fragments[n];
                    if (s)
                      if (s.buffered) {
                        var a = s.range[e];
                        a &&
                          a.time.some(function(e) {
                            var r = !i.isTimeBuffered(e.startPTS, e.endPTS, t);
                            return r && i.removeFragment(s.body), r;
                          });
                      } else s.body.type === r && i.removeFragment(s.body);
                  });
                }),
                (t.detectPartialFragments = function(e) {
                  var t = this,
                    r = this.timeRanges,
                    i = e.frag,
                    n = e.part;
                  if (r && "initSegment" !== i.sn) {
                    var s = l(i),
                      a = this.fragments[s];
                    a &&
                      (Object.keys(r).forEach(function(e) {
                        var s = i.elementaryStreams[e];
                        if (s) {
                          var o = r[e],
                            l = null !== n || !0 === s.partial;
                          a.range[e] = t.getBufferedTimes(i, n, l, o);
                        }
                      }),
                      (a.backtrack = a.loaded = null),
                      Object.keys(a.range).length ? (a.buffered = !0) : this.removeFragment(a.body));
                  }
                }),
                (t.fragBuffered = function(e) {
                  var t = l(e),
                    r = this.fragments[t];
                  r && ((r.backtrack = r.loaded = null), (r.buffered = !0));
                }),
                (t.getBufferedTimes = function(e, t, r, i) {
                  for (
                    var n = { time: [], partial: r },
                      s = t ? t.start : e.start,
                      a = t ? t.end : e.end,
                      o = e.minEndPTS || a,
                      l = e.maxStartPTS || s,
                      u = 0;
                    u < i.length;
                    u++
                  ) {
                    var d = i.start(u) - this.bufferPadding,
                      c = i.end(u) + this.bufferPadding;
                    if (l >= d && o <= c) {
                      n.time.push({ startPTS: Math.max(s, i.start(u)), endPTS: Math.min(a, i.end(u)) });
                      break;
                    }
                    if (s < c && a > d)
                      (n.partial = !0),
                        n.time.push({ startPTS: Math.max(s, i.start(u)), endPTS: Math.min(a, i.end(u)) });
                    else if (a <= d) break;
                  }
                  return n;
                }),
                (t.getPartialFragment = function(e) {
                  var t,
                    r,
                    i,
                    n = null,
                    s = 0,
                    a = this.bufferPadding,
                    l = this.fragments;
                  return (
                    Object.keys(l).forEach(function(u) {
                      var d = l[u];
                      d &&
                        o(d) &&
                        ((r = d.body.start - a),
                        (i = d.body.end + a),
                        e >= r && e <= i && ((t = Math.min(e - r, i - e)), s <= t && ((n = d.body), (s = t))));
                    }),
                    n
                  );
                }),
                (t.getState = function(e) {
                  var t = l(e),
                    r = this.fragments[t];
                  return r
                    ? r.buffered
                      ? o(r)
                        ? i.PARTIAL
                        : i.OK
                      : r.backtrack
                        ? i.BACKTRACKED
                        : i.APPENDING
                    : i.NOT_LOADED;
                }),
                (t.backtrack = function(e, t) {
                  var r = l(e),
                    i = this.fragments[r];
                  if (!i || i.backtrack) return null;
                  var n = (i.backtrack = t || i.loaded);
                  return (i.loaded = null), n;
                }),
                (t.getBacktrackData = function(e) {
                  var t = l(e),
                    r = this.fragments[t];
                  if (r) {
                    var i,
                      n = r.backtrack;
                    if (null != n && null !== (i = n.payload) && void 0 !== i && i.byteLength) return n;
                    this.removeFragment(e);
                  }
                  return null;
                }),
                (t.isTimeBuffered = function(e, t, r) {
                  for (var i, n, s = 0; s < r.length; s++) {
                    if (((i = r.start(s) - this.bufferPadding), (n = r.end(s) + this.bufferPadding), e >= i && t <= n))
                      return !0;
                    if (t <= i) return !1;
                  }
                  return !1;
                }),
                (t.onFragLoaded = function(e, t) {
                  var r = t.frag,
                    i = t.part;
                  if ("initSegment" !== r.sn && !r.bitrateTest && !i) {
                    var n = l(r);
                    this.fragments[n] = {
                      body: r,
                      loaded: t,
                      backtrack: null,
                      buffered: !1,
                      range: Object.create(null)
                    };
                  }
                }),
                (t.onBufferAppended = function(e, t) {
                  var r = this,
                    i = t.frag,
                    n = t.part,
                    a = t.timeRanges;
                  if (i.type === s.PlaylistLevelType.MAIN)
                    if (((this.activeFragment = i), n)) {
                      var o = this.activeParts;
                      o || (this.activeParts = o = []), o.push(n);
                    } else this.activeParts = null;
                  (this.timeRanges = a),
                    Object.keys(a).forEach(function(e) {
                      var t = a[e];
                      if ((r.detectEvictedFragments(e, t), !n))
                        for (var s = 0; s < t.length; s++) i.appendedPTS = Math.max(t.end(s), i.appendedPTS || 0);
                    });
                }),
                (t.onFragBuffered = function(e, t) {
                  this.detectPartialFragments(t);
                }),
                (t.hasFragment = function(e) {
                  var t = l(e);
                  return !!this.fragments[t];
                }),
                (t.removeFragmentsInRange = function(e, t, r) {
                  var i = this;
                  Object.keys(this.fragments).forEach(function(n) {
                    var s = i.fragments[n];
                    if (s && s.buffered) {
                      var a = s.body;
                      a.type === r && a.start < t && a.end > e && i.removeFragment(a);
                    }
                  });
                }),
                (t.removeFragment = function(e) {
                  var t = l(e);
                  (e.stats.loaded = 0), e.clearElementaryStreamInfo(), delete this.fragments[t];
                }),
                (t.removeAllFragments = function() {
                  (this.fragments = Object.create(null)), (this.activeFragment = null), (this.activeParts = null);
                }),
                e
              );
            })();
            function o(e) {
              var t, r;
              return (
                e.buffered &&
                ((null === (t = e.range.video) || void 0 === t ? void 0 : t.partial) ||
                  (null === (r = e.range.audio) || void 0 === r ? void 0 : r.partial))
              );
            }
            function l(e) {
              return e.type + "_" + e.level + "_" + e.urlId + "_" + e.sn;
            }
          },
          "./src/controller/gap-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "STALL_MINIMUM_DURATION_MS", function() {
                return o;
              }),
              r.d(t, "MAX_START_GAP_JUMP", function() {
                return l;
              }),
              r.d(t, "SKIP_BUFFER_HOLE_STEP_SECONDS", function() {
                return u;
              }),
              r.d(t, "SKIP_BUFFER_RANGE_START", function() {
                return d;
              }),
              r.d(t, "default", function() {
                return c;
              });
            var i = r("./src/utils/buffer-helper.ts"),
              n = r("./src/errors.ts"),
              s = r("./src/events.ts"),
              a = r("./src/utils/logger.ts"),
              o = 250,
              l = 2,
              u = 0.1,
              d = 0.05,
              c = (function() {
                function e(e, t, r, i) {
                  (this.config = void 0),
                    (this.media = void 0),
                    (this.fragmentTracker = void 0),
                    (this.hls = void 0),
                    (this.nudgeRetry = 0),
                    (this.stallReported = !1),
                    (this.stalled = null),
                    (this.moved = !1),
                    (this.seeking = !1),
                    (this.config = e),
                    (this.media = t),
                    (this.fragmentTracker = r),
                    (this.hls = i);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    this.hls = this.fragmentTracker = this.media = null;
                  }),
                  (t.poll = function(e) {
                    var t = this.config,
                      r = this.media,
                      n = this.stalled,
                      s = r.currentTime,
                      u = r.seeking,
                      d = this.seeking && !u,
                      c = !this.seeking && u;
                    if (((this.seeking = u), s === e)) {
                      if (
                        ((c || d) && (this.stalled = null),
                        !r.paused && !r.ended && 0 !== r.playbackRate && i.BufferHelper.getBuffered(r).length)
                      ) {
                        var h = i.BufferHelper.bufferInfo(r, s, 0),
                          f = h.len > 0,
                          p = h.nextStart || 0;
                        if (f || p) {
                          if (u) {
                            var v = h.len > l,
                              g = !p || (p - s > l && !this.fragmentTracker.getPartialFragment(s));
                            if (v || g) return;
                            this.moved = !1;
                          }
                          if (!this.moved && null !== this.stalled) {
                            var m,
                              y = Math.max(p, h.start || 0) - s,
                              E = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null,
                              T = (null == E || null === (m = E.details) || void 0 === m
                              ? void 0
                              : m.live)
                                ? 2 * E.details.targetduration
                                : l;
                            if (y > 0 && y <= T) return void this._trySkipBufferHole(null);
                          }
                          var b = self.performance.now();
                          if (null !== n) {
                            var S = b - n;
                            !u && S >= o && this._reportStall(h.len);
                            var k = i.BufferHelper.bufferInfo(r, s, t.maxBufferHole);
                            this._tryFixBufferStall(k, S);
                          } else this.stalled = b;
                        }
                      }
                    } else if (((this.moved = !0), null !== n)) {
                      if (this.stallReported) {
                        var A = self.performance.now() - n;
                        a.logger.warn("playback not stuck anymore @" + s + ", after " + Math.round(A) + "ms"),
                          (this.stallReported = !1);
                      }
                      (this.stalled = null), (this.nudgeRetry = 0);
                    }
                  }),
                  (t._tryFixBufferStall = function(e, t) {
                    var r = this.config,
                      i = this.fragmentTracker,
                      n = this.media.currentTime,
                      s = i.getPartialFragment(n);
                    (s && this._trySkipBufferHole(s)) ||
                      (e.len > r.maxBufferHole &&
                        t > 1e3 * r.highBufferWatchdogPeriod &&
                        (a.logger.warn("Trying to nudge playhead over buffer-hole"),
                        (this.stalled = null),
                        this._tryNudgeBuffer()));
                  }),
                  (t._reportStall = function(e) {
                    var t = this.hls,
                      r = this.media;
                    this.stallReported ||
                      ((this.stallReported = !0),
                      a.logger.warn("Playback stalling at @" + r.currentTime + " due to low buffer (buffer=" + e + ")"),
                      t.trigger(s.Events.ERROR, {
                        type: n.ErrorTypes.MEDIA_ERROR,
                        details: n.ErrorDetails.BUFFER_STALLED_ERROR,
                        fatal: !1,
                        buffer: e
                      }));
                  }),
                  (t._trySkipBufferHole = function(e) {
                    for (
                      var t = this.config,
                        r = this.hls,
                        o = this.media,
                        l = o.currentTime,
                        c = 0,
                        h = i.BufferHelper.getBuffered(o),
                        f = 0;
                      f < h.length;
                      f++
                    ) {
                      var p = h.start(f);
                      if (l + t.maxBufferHole >= c && l < p) {
                        var v = Math.max(p + d, o.currentTime + u);
                        return (
                          a.logger.warn("skipping hole, adjusting currentTime from " + l + " to " + v),
                          (this.moved = !0),
                          (this.stalled = null),
                          (o.currentTime = v),
                          e &&
                            r.trigger(s.Events.ERROR, {
                              type: n.ErrorTypes.MEDIA_ERROR,
                              details: n.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                              fatal: !1,
                              reason: "fragment loaded with buffer holes, seeking from " + l + " to " + v,
                              frag: e
                            }),
                          v
                        );
                      }
                      c = h.end(f);
                    }
                    return 0;
                  }),
                  (t._tryNudgeBuffer = function() {
                    var e = this.config,
                      t = this.hls,
                      r = this.media,
                      i = r.currentTime,
                      o = (this.nudgeRetry || 0) + 1;
                    if (((this.nudgeRetry = o), o < e.nudgeMaxRetry)) {
                      var l = i + o * e.nudgeOffset;
                      a.logger.warn("Nudging 'currentTime' from " + i + " to " + l),
                        (r.currentTime = l),
                        t.trigger(s.Events.ERROR, {
                          type: n.ErrorTypes.MEDIA_ERROR,
                          details: n.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                          fatal: !1
                        });
                    } else
                      a.logger.error(
                        "Playhead still not moving while enough data buffered @" +
                          i +
                          " after " +
                          e.nudgeMaxRetry +
                          " nudges"
                      ),
                        t.trigger(s.Events.ERROR, {
                          type: n.ErrorTypes.MEDIA_ERROR,
                          details: n.ErrorDetails.BUFFER_STALLED_ERROR,
                          fatal: !0
                        });
                  }),
                  e
                );
              })();
          },
          "./src/controller/id3-track-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/events.ts"),
              n = r("./src/utils/texttrack-utils.ts"),
              s = r("./src/demux/id3.ts"),
              a = (function() {
                function e(e) {
                  (this.hls = void 0),
                    (this.id3Track = null),
                    (this.media = null),
                    (this.hls = e),
                    this._registerListeners();
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    this._unregisterListeners();
                  }),
                  (t._registerListeners = function() {
                    var e = this.hls;
                    e.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      e.on(i.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this),
                      e.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                  }),
                  (t._unregisterListeners = function() {
                    var e = this.hls;
                    e.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      e.off(i.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this),
                      e.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                  }),
                  (t.onMediaAttached = function(e, t) {
                    this.media = t.media;
                  }),
                  (t.onMediaDetaching = function() {
                    this.id3Track &&
                      (Object(n.clearCurrentCues)(this.id3Track), (this.id3Track = null), (this.media = null));
                  }),
                  (t.getID3Track = function(e) {
                    if (this.media) {
                      for (var t = 0; t < e.length; t++) {
                        var r = e[t];
                        if ("metadata" === r.kind && "id3" === r.label)
                          return Object(n.sendAddTrackEvent)(r, this.media), r;
                      }
                      return this.media.addTextTrack("metadata", "id3");
                    }
                  }),
                  (t.onFragParsingMetadata = function(e, t) {
                    if (this.media) {
                      var r = t.frag,
                        i = t.samples;
                      this.id3Track ||
                        ((this.id3Track = this.getID3Track(this.media.textTracks)), (this.id3Track.mode = "hidden"));
                      for (var n = self.WebKitDataCue || self.VTTCue || self.TextTrackCue, a = 0; a < i.length; a++) {
                        var o = s.getID3Frames(i[a].data);
                        if (o) {
                          var l = i[a].pts,
                            u = a < i.length - 1 ? i[a + 1].pts : r.end;
                          u - l <= 0 && (u = l + 0.25);
                          for (var d = 0; d < o.length; d++) {
                            var c = o[d];
                            if (!s.isTimeStampFrame(c)) {
                              var h = new n(l, u, "");
                              (h.value = c), this.id3Track.addCue(h);
                            }
                          }
                        }
                      }
                    }
                  }),
                  (t.onBufferFlushing = function(e, t) {
                    var r = t.startOffset,
                      i = t.endOffset,
                      s = t.type;
                    if (!s || "audio" === s) {
                      var a = this.id3Track;
                      a && Object(n.removeCuesInRange)(a, r, i);
                    }
                  }),
                  e
                );
              })();
            t.default = a;
          },
          "./src/controller/latency-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return o;
              });
            var i = r("./src/errors.ts"),
              n = r("./src/events.ts"),
              s = r("./src/utils/logger.ts");
            function a(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var o = (function() {
              function e(e) {
                var t = this;
                (this.hls = void 0),
                  (this.config = void 0),
                  (this.media = null),
                  (this.levelDetails = null),
                  (this.currentTime = 0),
                  (this.stallCount = 0),
                  (this._latency = null),
                  (this.timeupdateHandler = function() {
                    return t.timeupdate();
                  }),
                  (this.hls = e),
                  (this.config = e.config),
                  this.registerListeners();
              }
              var t,
                r,
                o,
                l = e.prototype;
              return (
                (l.destroy = function() {
                  this.unregisterListeners(),
                    this.onMediaDetaching(),
                    (this.levelDetails = null),
                    (this.hls = this.timeupdateHandler = null);
                }),
                (l.registerListeners = function() {
                  this.hls.on(n.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    this.hls.on(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    this.hls.on(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    this.hls.on(n.Events.LEVEL_UPDATED, this.onLevelUpdated, this),
                    this.hls.on(n.Events.ERROR, this.onError, this);
                }),
                (l.unregisterListeners = function() {
                  this.hls.off(n.Events.MEDIA_ATTACHED, this.onMediaAttached),
                    this.hls.off(n.Events.MEDIA_DETACHING, this.onMediaDetaching),
                    this.hls.off(n.Events.MANIFEST_LOADING, this.onManifestLoading),
                    this.hls.off(n.Events.LEVEL_UPDATED, this.onLevelUpdated),
                    this.hls.off(n.Events.ERROR, this.onError);
                }),
                (l.onMediaAttached = function(e, t) {
                  (this.media = t.media), this.media.addEventListener("timeupdate", this.timeupdateHandler);
                }),
                (l.onMediaDetaching = function() {
                  this.media &&
                    (this.media.removeEventListener("timeupdate", this.timeupdateHandler), (this.media = null));
                }),
                (l.onManifestLoading = function() {
                  (this.levelDetails = null), (this._latency = null), (this.stallCount = 0);
                }),
                (l.onLevelUpdated = function(e, t) {
                  var r = t.details;
                  (this.levelDetails = r),
                    r.advanced && this.timeupdate(),
                    !r.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
                }),
                (l.onError = function(e, t) {
                  t.details === i.ErrorDetails.BUFFER_STALLED_ERROR &&
                    (this.stallCount++,
                    s.logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
                }),
                (l.timeupdate = function() {
                  var e = this.media,
                    t = this.levelDetails;
                  if (e && t) {
                    this.currentTime = e.currentTime;
                    var r = this.computeLatency();
                    if (null !== r) {
                      this._latency = r;
                      var i = this.config,
                        n = i.lowLatencyMode,
                        s = i.maxLiveSyncPlaybackRate;
                      if (n && 1 !== s) {
                        var a = this.targetLatency;
                        if (null !== a) {
                          var o = r - a,
                            l = o < Math.min(this.maxLatency, a + t.targetduration);
                          if (t.live && l && o > 0.05 && this.forwardBufferLength > 1) {
                            var u = Math.min(2, Math.max(1, s)),
                              d = Math.round((2 / (1 + Math.exp(-0.75 * o - this.edgeStalled))) * 20) / 20;
                            e.playbackRate = Math.min(u, Math.max(1, d));
                          } else 1 !== e.playbackRate && 0 !== e.playbackRate && (e.playbackRate = 1);
                        }
                      }
                    }
                  }
                }),
                (l.estimateLiveEdge = function() {
                  var e = this.levelDetails;
                  return null === e ? null : e.edge + e.age;
                }),
                (l.computeLatency = function() {
                  var e = this.estimateLiveEdge();
                  return null === e ? null : e - this.currentTime;
                }),
                (t = e),
                (r = [
                  {
                    key: "latency",
                    get: function() {
                      return this._latency || 0;
                    }
                  },
                  {
                    key: "maxLatency",
                    get: function() {
                      var e = this.config,
                        t = this.levelDetails;
                      return void 0 !== e.liveMaxLatencyDuration
                        ? e.liveMaxLatencyDuration
                        : t
                          ? e.liveMaxLatencyDurationCount * t.targetduration
                          : 0;
                    }
                  },
                  {
                    key: "targetLatency",
                    get: function() {
                      var e = this.levelDetails;
                      if (null === e) return null;
                      var t = e.holdBack,
                        r = e.partHoldBack,
                        i = e.targetduration,
                        n = this.config,
                        s = n.liveSyncDuration,
                        a = n.liveSyncDurationCount,
                        o = n.lowLatencyMode,
                        l = this.hls.userConfig,
                        u = (o && r) || t;
                      (l.liveSyncDuration || l.liveSyncDurationCount || 0 === u) && (u = void 0 !== s ? s : a * i);
                      var d = i;
                      return u + Math.min(1 * this.stallCount, d);
                    }
                  },
                  {
                    key: "liveSyncPosition",
                    get: function() {
                      var e = this.estimateLiveEdge(),
                        t = this.targetLatency,
                        r = this.levelDetails;
                      if (null === e || null === t || null === r) return null;
                      var i = r.edge,
                        n = e - t - this.edgeStalled,
                        s = i - r.totalduration,
                        a = i - ((this.config.lowLatencyMode && r.partTarget) || r.targetduration);
                      return Math.min(Math.max(s, n), a);
                    }
                  },
                  {
                    key: "drift",
                    get: function() {
                      var e = this.levelDetails;
                      return null === e ? 1 : e.drift;
                    }
                  },
                  {
                    key: "edgeStalled",
                    get: function() {
                      var e = this.levelDetails;
                      if (null === e) return 0;
                      var t = 3 * ((this.config.lowLatencyMode && e.partTarget) || e.targetduration);
                      return Math.max(e.age - t, 0);
                    }
                  },
                  {
                    key: "forwardBufferLength",
                    get: function() {
                      var e = this.media,
                        t = this.levelDetails;
                      if (!e || !t) return 0;
                      var r = e.buffered.length;
                      return r ? e.buffered.end(r - 1) : t.edge - this.currentTime;
                    }
                  }
                ]) && a(t.prototype, r),
                o && a(t, o),
                e
              );
            })();
          },
          "./src/controller/level-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return p;
              });
            var i = r("./src/types/level.ts"),
              n = r("./src/events.ts"),
              s = r("./src/errors.ts"),
              a = r("./src/utils/codecs.ts"),
              o = r("./src/controller/level-helper.ts"),
              l = r("./src/controller/base-playlist-controller.ts"),
              u = r("./src/types/loader.ts");
            function d() {
              return (d =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            function c(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function h(e, t) {
              return (h =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var f = /chrome|firefox/.test(navigator.userAgent.toLowerCase()),
              p = (function(e) {
                var t, r;
                function l(t) {
                  var r;
                  return (
                    ((r = e.call(this, t, "[level-controller]") || this)._levels = []),
                    (r._firstLevel = -1),
                    (r._startLevel = void 0),
                    (r.currentLevelIndex = -1),
                    (r.manualLevelIndex = -1),
                    (r.onParsedComplete = void 0),
                    r._registerListeners(),
                    r
                  );
                }
                (r = e), ((t = l).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), h(t, r);
                var p,
                  v,
                  g,
                  m = l.prototype;
                return (
                  (m._registerListeners = function() {
                    var e = this.hls;
                    e.on(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                      e.on(n.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      e.on(n.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                      e.on(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                      e.on(n.Events.ERROR, this.onError, this);
                  }),
                  (m._unregisterListeners = function() {
                    var e = this.hls;
                    e.off(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                      e.off(n.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      e.off(n.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                      e.off(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                      e.off(n.Events.ERROR, this.onError, this);
                  }),
                  (m.destroy = function() {
                    this._unregisterListeners(),
                      (this.manualLevelIndex = -1),
                      (this._levels.length = 0),
                      e.prototype.destroy.call(this);
                  }),
                  (m.startLoad = function() {
                    this._levels.forEach(function(e) {
                      e.loadError = 0;
                    }),
                      e.prototype.startLoad.call(this);
                  }),
                  (m.onManifestLoaded = function(e, t) {
                    var r,
                      l,
                      u = [],
                      d = [],
                      c = [],
                      h = {},
                      p = !1,
                      v = !1,
                      g = !1;
                    if (
                      (t.levels.forEach(function(e) {
                        var t = e.attrs;
                        (p = p || !(!e.width || !e.height)),
                          (v = v || !!e.videoCodec),
                          (g = g || !!e.audioCodec),
                          f && e.audioCodec && -1 !== e.audioCodec.indexOf("mp4a.40.34") && (e.audioCodec = void 0);
                        var r = e.bitrate + "-" + e.attrs.RESOLUTION + "-" + e.attrs.CODECS;
                        (l = h[r]) ? l.url.push(e.url) : ((l = new i.Level(e)), (h[r] = l), u.push(l)),
                          t &&
                            (t.AUDIO && Object(o.addGroupId)(l, "audio", t.AUDIO),
                            t.SUBTITLES && Object(o.addGroupId)(l, "text", t.SUBTITLES));
                      }),
                      (p || v) &&
                        g &&
                        (u = u.filter(function(e) {
                          var t = e.videoCodec,
                            r = e.width,
                            i = e.height;
                          return !!t || !(!r || !i);
                        })),
                      (u = u.filter(function(e) {
                        var t = e.audioCodec,
                          r = e.videoCodec;
                        return (
                          (!t || Object(a.isCodecSupportedInMp4)(t, "audio")) &&
                          (!r || Object(a.isCodecSupportedInMp4)(r, "video"))
                        );
                      })),
                      t.audioTracks &&
                        ((d = t.audioTracks.filter(function(e) {
                          return !e.audioCodec || Object(a.isCodecSupportedInMp4)(e.audioCodec, "audio");
                        })),
                        Object(o.assignTrackIdsByGroup)(d)),
                      t.subtitles && ((c = t.subtitles), Object(o.assignTrackIdsByGroup)(c)),
                      u.length > 0)
                    ) {
                      (r = u[0].bitrate),
                        u.sort(function(e, t) {
                          return e.bitrate - t.bitrate;
                        }),
                        (this._levels = u);
                      for (var m = 0; m < u.length; m++)
                        if (u[m].bitrate === r) {
                          (this._firstLevel = m),
                            this.log("manifest loaded, " + u.length + " level(s) found, first bitrate: " + r);
                          break;
                        }
                      var y = g && !v,
                        E = {
                          levels: u,
                          audioTracks: d,
                          subtitleTracks: c,
                          firstLevel: this._firstLevel,
                          stats: t.stats,
                          audio: g,
                          video: v,
                          altAudio:
                            !y &&
                            d.some(function(e) {
                              return !!e.url;
                            })
                        };
                      this.hls.trigger(n.Events.MANIFEST_PARSED, E),
                        (this.hls.config.autoStartLoad || this.hls.forceStartLoad) &&
                          this.hls.startLoad(this.hls.config.startPosition);
                    } else
                      this.hls.trigger(n.Events.ERROR, {
                        type: s.ErrorTypes.MEDIA_ERROR,
                        details: s.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                        fatal: !0,
                        url: t.url,
                        reason: "no level with compatible codecs found in manifest"
                      });
                  }),
                  (m.onError = function(t, r) {
                    if ((e.prototype.onError.call(this, t, r), !r.fatal)) {
                      var i = r.context,
                        n = this._levels[this.currentLevelIndex];
                      if (
                        i &&
                        ((i.type === u.PlaylistContextType.AUDIO_TRACK &&
                          n.audioGroupIds &&
                          i.groupId === n.audioGroupIds[n.urlId]) ||
                          (i.type === u.PlaylistContextType.SUBTITLE_TRACK &&
                            n.textGroupIds &&
                            i.groupId === n.textGroupIds[n.urlId]))
                      )
                        this.redundantFailover(this.currentLevelIndex);
                      else {
                        var a,
                          o = !1,
                          l = !0;
                        switch (r.details) {
                          case s.ErrorDetails.FRAG_LOAD_ERROR:
                          case s.ErrorDetails.FRAG_LOAD_TIMEOUT:
                          case s.ErrorDetails.KEY_LOAD_ERROR:
                          case s.ErrorDetails.KEY_LOAD_TIMEOUT:
                            if (r.frag) {
                              var d = this._levels[r.frag.level];
                              d
                                ? (d.fragmentError++,
                                  d.fragmentError > this.hls.config.fragLoadingMaxRetry && (a = r.frag.level))
                                : (a = r.frag.level);
                            }
                            break;
                          case s.ErrorDetails.LEVEL_LOAD_ERROR:
                          case s.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                            i && (i.deliveryDirectives && (l = !1), (a = i.level)), (o = !0);
                            break;
                          case s.ErrorDetails.REMUX_ALLOC_ERROR:
                            (a = r.level), (o = !0);
                        }
                        void 0 !== a && this.recoverLevel(r, a, o, l);
                      }
                    }
                  }),
                  (m.recoverLevel = function(e, t, r, i) {
                    var n = e.details,
                      s = this._levels[t];
                    if ((s.loadError++, r)) {
                      if (!this.retryLoadingOrFail(e)) return void (this.currentLevelIndex = -1);
                      e.levelRetry = !0;
                    }
                    if (i) {
                      var a = s.url.length;
                      if (a > 1 && s.loadError < a) (e.levelRetry = !0), this.redundantFailover(t);
                      else if (-1 === this.manualLevelIndex) {
                        var o = 0 === t ? this._levels.length - 1 : t - 1;
                        this.currentLevelIndex !== o &&
                          0 === this._levels[o].loadError &&
                          (this.warn(n + ": switch to " + o), (e.levelRetry = !0), (this.hls.nextAutoLevel = o));
                      }
                    }
                  }),
                  (m.redundantFailover = function(e) {
                    var t = this._levels[e],
                      r = t.url.length;
                    if (r > 1) {
                      var i = (t.urlId + 1) % r;
                      this.warn("Switching to redundant URL-id " + i),
                        this._levels.forEach(function(e) {
                          e.urlId = i;
                        }),
                        (this.level = e);
                    }
                  }),
                  (m.onFragLoaded = function(e, t) {
                    var r = t.frag;
                    if (void 0 !== r && r.type === u.PlaylistLevelType.MAIN) {
                      var i = this._levels[r.level];
                      void 0 !== i && ((i.fragmentError = 0), (i.loadError = 0));
                    }
                  }),
                  (m.onLevelLoaded = function(e, t) {
                    var r,
                      i,
                      n = t.level,
                      s = t.details,
                      a = this._levels[n];
                    if (!a)
                      return (
                        this.warn("Invalid level index " + n),
                        void (
                          null !== (i = t.deliveryDirectives) &&
                          void 0 !== i &&
                          i.skip &&
                          (s.deltaUpdateFailed = !0)
                        )
                      );
                    n === this.currentLevelIndex
                      ? (0 === a.fragmentError && ((a.loadError = 0), (this.retryCount = 0)),
                        this.playlistLoaded(n, t, a.details))
                      : null !== (r = t.deliveryDirectives) && void 0 !== r && r.skip && (s.deltaUpdateFailed = !0);
                  }),
                  (m.onAudioTrackSwitched = function(e, t) {
                    var r = this.hls.levels[this.currentLevelIndex];
                    if (r && r.audioGroupIds) {
                      for (var i = -1, n = this.hls.audioTracks[t.id].groupId, s = 0; s < r.audioGroupIds.length; s++)
                        if (r.audioGroupIds[s] === n) {
                          i = s;
                          break;
                        }
                      i !== r.urlId && ((r.urlId = i), this.startLoad());
                    }
                  }),
                  (m.loadPlaylist = function(e) {
                    var t = this.currentLevelIndex,
                      r = this._levels[t];
                    if (this.canLoad && r && r.url.length > 0) {
                      var i = r.urlId,
                        s = r.url[i];
                      if (e)
                        try {
                          s = e.addDirectives(s);
                        } catch (e) {
                          this.warn("Could not construct new URL with HLS Delivery Directives: " + e);
                        }
                      this.log(
                        "Attempt loading level index " +
                          t +
                          (e ? " at sn " + e.msn + " part " + e.part : "") +
                          " with URL-id " +
                          i +
                          " " +
                          s
                      ),
                        this.clearTimer(),
                        this.hls.trigger(n.Events.LEVEL_LOADING, {
                          url: s,
                          level: t,
                          id: i,
                          deliveryDirectives: e || null
                        });
                    }
                  }),
                  (m.removeLevel = function(e, t) {
                    var r = function(e, r) {
                        return r !== t;
                      },
                      i = this._levels
                        .filter(function(i, n) {
                          return (
                            n !== e ||
                            (i.url.length > 1 &&
                              void 0 !== t &&
                              ((i.url = i.url.filter(r)),
                              i.audioGroupIds && (i.audioGroupIds = i.audioGroupIds.filter(r)),
                              i.textGroupIds && (i.textGroupIds = i.textGroupIds.filter(r)),
                              (i.urlId = 0),
                              !0))
                          );
                        })
                        .map(function(e, t) {
                          var r = e.details;
                          return (
                            null != r &&
                              r.fragments &&
                              r.fragments.forEach(function(e) {
                                e.level = t;
                              }),
                            e
                          );
                        });
                    (this._levels = i), this.hls.trigger(n.Events.LEVELS_UPDATED, { levels: i });
                  }),
                  (p = l),
                  (v = [
                    {
                      key: "levels",
                      get: function() {
                        return 0 === this._levels.length ? null : this._levels;
                      }
                    },
                    {
                      key: "level",
                      get: function() {
                        return this.currentLevelIndex;
                      },
                      set: function(e) {
                        var t,
                          r = this._levels;
                        if (
                          0 !== r.length &&
                          (this.currentLevelIndex !== e || null === (t = r[e]) || void 0 === t || !t.details)
                        ) {
                          if (e < 0 || e >= r.length) {
                            var i = e < 0;
                            if (
                              (this.hls.trigger(n.Events.ERROR, {
                                type: s.ErrorTypes.OTHER_ERROR,
                                details: s.ErrorDetails.LEVEL_SWITCH_ERROR,
                                level: e,
                                fatal: i,
                                reason: "invalid level idx"
                              }),
                              i)
                            )
                              return;
                            e = Math.min(e, r.length - 1);
                          }
                          this.clearTimer();
                          var a = this.currentLevelIndex,
                            o = r[a],
                            l = r[e];
                          this.log("switching to level " + e + " from " + a), (this.currentLevelIndex = e);
                          var u = d({}, l, { level: e, maxBitrate: l.maxBitrate, uri: l.uri, urlId: l.urlId });
                          delete u._urlId, this.hls.trigger(n.Events.LEVEL_SWITCHING, u);
                          var c = l.details;
                          if (!c || c.live) {
                            var h = this.switchParams(l.uri, null == o ? void 0 : o.details);
                            this.loadPlaylist(h);
                          }
                        }
                      }
                    },
                    {
                      key: "manualLevel",
                      get: function() {
                        return this.manualLevelIndex;
                      },
                      set: function(e) {
                        (this.manualLevelIndex = e),
                          void 0 === this._startLevel && (this._startLevel = e),
                          -1 !== e && (this.level = e);
                      }
                    },
                    {
                      key: "firstLevel",
                      get: function() {
                        return this._firstLevel;
                      },
                      set: function(e) {
                        this._firstLevel = e;
                      }
                    },
                    {
                      key: "startLevel",
                      get: function() {
                        if (void 0 === this._startLevel) {
                          var e = this.hls.config.startLevel;
                          return void 0 !== e ? e : this._firstLevel;
                        }
                        return this._startLevel;
                      },
                      set: function(e) {
                        this._startLevel = e;
                      }
                    },
                    {
                      key: "nextLoadLevel",
                      get: function() {
                        return -1 !== this.manualLevelIndex ? this.manualLevelIndex : this.hls.nextAutoLevel;
                      },
                      set: function(e) {
                        (this.level = e), -1 === this.manualLevelIndex && (this.hls.nextAutoLevel = e);
                      }
                    }
                  ]) && c(p.prototype, v),
                  g && c(p, g),
                  l
                );
              })(l.default);
          },
          "./src/controller/level-helper.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "addGroupId", function() {
                return s;
              }),
              r.d(t, "assignTrackIdsByGroup", function() {
                return a;
              }),
              r.d(t, "updatePTS", function() {
                return o;
              }),
              r.d(t, "updateFragPTSDTS", function() {
                return u;
              }),
              r.d(t, "mergeDetails", function() {
                return d;
              }),
              r.d(t, "mapPartIntersection", function() {
                return c;
              }),
              r.d(t, "mapFragmentIntersection", function() {
                return h;
              }),
              r.d(t, "adjustSliding", function() {
                return f;
              }),
              r.d(t, "addSliding", function() {
                return p;
              }),
              r.d(t, "computeReloadInterval", function() {
                return v;
              }),
              r.d(t, "getFragmentWithSN", function() {
                return g;
              }),
              r.d(t, "getPartWith", function() {
                return m;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/utils/logger.ts");
            function s(e, t, r) {
              switch (t) {
                case "audio":
                  e.audioGroupIds || (e.audioGroupIds = []), e.audioGroupIds.push(r);
                  break;
                case "text":
                  e.textGroupIds || (e.textGroupIds = []), e.textGroupIds.push(r);
              }
            }
            function a(e) {
              var t = {};
              e.forEach(function(e) {
                var r = e.groupId || "";
                (e.id = t[r] = t[r] || 0), t[r]++;
              });
            }
            function o(e, t, r) {
              l(e[t], e[r]);
            }
            function l(e, t) {
              var r = t.startPTS;
              if (Object(i.isFiniteNumber)(r)) {
                var n,
                  s = 0;
                t.sn > e.sn ? ((s = r - e.start), (n = e)) : ((s = e.start - r), (n = t)),
                  n.duration !== s && (n.duration = s);
              } else
                t.sn > e.sn
                  ? e.cc === t.cc && e.minEndPTS
                    ? (t.start = e.start + (e.minEndPTS - e.start))
                    : (t.start = e.start + e.duration)
                  : (t.start = Math.max(e.start - t.duration, 0));
            }
            function u(e, t, r, s, a, o) {
              s - r <= 0 &&
                (n.logger.warn("Fragment should have a positive duration", t),
                (s = r + t.duration),
                (o = a + t.duration));
              var u = r,
                d = s,
                c = t.startPTS,
                h = t.endPTS;
              if (Object(i.isFiniteNumber)(c)) {
                var f = Math.abs(c - r);
                Object(i.isFiniteNumber)(t.deltaPTS) ? (t.deltaPTS = Math.max(f, t.deltaPTS)) : (t.deltaPTS = f),
                  (u = Math.max(r, c)),
                  (r = Math.min(r, c)),
                  (a = Math.min(a, t.startDTS)),
                  (d = Math.min(s, h)),
                  (s = Math.max(s, h)),
                  (o = Math.max(o, t.endDTS));
              }
              t.duration = s - r;
              var p = r - t.start;
              (t.appendedPTS = s),
                (t.start = t.startPTS = r),
                (t.maxStartPTS = u),
                (t.startDTS = a),
                (t.endPTS = s),
                (t.minEndPTS = d),
                (t.endDTS = o);
              var v,
                g = t.sn;
              if (!e || g < e.startSN || g > e.endSN) return 0;
              var m = g - e.startSN,
                y = e.fragments;
              for (y[m] = t, v = m; v > 0; v--) l(y[v], y[v - 1]);
              for (v = m; v < y.length - 1; v++) l(y[v], y[v + 1]);
              return e.fragmentHint && l(y[y.length - 1], e.fragmentHint), (e.PTSKnown = e.alignedSliding = !0), p;
            }
            function d(e, t) {
              for (var r = null, s = e.fragments, a = s.length - 1; a >= 0; a--) {
                var o = s[a].initSegment;
                if (o) {
                  r = o;
                  break;
                }
              }
              e.fragmentHint && delete e.fragmentHint.endPTS;
              var l,
                d = 0;
              if (
                (h(e, t, function(e, n) {
                  e.relurl && (d = e.cc - n.cc),
                    Object(i.isFiniteNumber)(e.startPTS) &&
                      Object(i.isFiniteNumber)(e.endPTS) &&
                      ((n.start = n.startPTS = e.startPTS),
                      (n.startDTS = e.startDTS),
                      (n.appendedPTS = e.appendedPTS),
                      (n.maxStartPTS = e.maxStartPTS),
                      (n.endPTS = e.endPTS),
                      (n.endDTS = e.endDTS),
                      (n.minEndPTS = e.minEndPTS),
                      (n.duration = e.endPTS - e.startPTS),
                      n.duration && (l = n),
                      (t.PTSKnown = t.alignedSliding = !0)),
                    (n.elementaryStreams = e.elementaryStreams),
                    (n.loader = e.loader),
                    (n.stats = e.stats),
                    (n.urlId = e.urlId),
                    e.initSegment && ((n.initSegment = e.initSegment), (r = e.initSegment));
                }),
                r &&
                  (t.fragmentHint ? t.fragments.concat(t.fragmentHint) : t.fragments).forEach(function(e) {
                    var t;
                    (e.initSegment &&
                      e.initSegment.relurl !== (null === (t = r) || void 0 === t ? void 0 : t.relurl)) ||
                      (e.initSegment = r);
                  }),
                t.skippedSegments &&
                  ((t.deltaUpdateFailed = t.fragments.some(function(e) {
                    return !e;
                  })),
                  t.deltaUpdateFailed))
              ) {
                n.logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
                for (var p = t.skippedSegments; p--; ) t.fragments.shift();
                (t.startSN = t.fragments[0].sn), (t.startCC = t.fragments[0].cc);
              }
              var v = t.fragments;
              if (d) {
                n.logger.warn("discontinuity sliding from playlist, take drift into account");
                for (var g = 0; g < v.length; g++) v[g].cc += d;
              }
              t.skippedSegments && (t.startCC = t.fragments[0].cc),
                c(e.partList, t.partList, function(e, t) {
                  (t.elementaryStreams = e.elementaryStreams), (t.stats = e.stats);
                }),
                l ? u(t, l, l.startPTS, l.endPTS, l.startDTS, l.endDTS) : f(e, t),
                v.length && (t.totalduration = t.edge - v[0].start),
                (t.driftStartTime = e.driftStartTime),
                (t.driftStart = e.driftStart);
              var m = t.advancedDateTime;
              if (t.advanced && m) {
                var y = t.edge;
                t.driftStart || ((t.driftStartTime = m), (t.driftStart = y)), (t.driftEndTime = m), (t.driftEnd = y);
              } else
                (t.driftEndTime = e.driftEndTime), (t.driftEnd = e.driftEnd), (t.advancedDateTime = e.advancedDateTime);
            }
            function c(e, t, r) {
              if (e && t)
                for (var i = 0, n = 0, s = e.length; n <= s; n++) {
                  var a = e[n],
                    o = t[n + i];
                  a && o && a.index === o.index && a.fragment.sn === o.fragment.sn ? r(a, o) : i--;
                }
            }
            function h(e, t, r) {
              for (
                var i = t.skippedSegments,
                  n = Math.max(e.startSN, t.startSN) - t.startSN,
                  s = (e.fragmentHint ? 1 : 0) + (i ? t.endSN : Math.min(e.endSN, t.endSN)) - t.startSN,
                  a = t.startSN - e.startSN,
                  o = t.fragmentHint ? t.fragments.concat(t.fragmentHint) : t.fragments,
                  l = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments,
                  u = n;
                u <= s;
                u++
              ) {
                var d = l[a + u],
                  c = o[u];
                i && !c && u < i && (c = t.fragments[u] = d), d && c && r(d, c);
              }
            }
            function f(e, t) {
              var r = t.startSN + t.skippedSegments - e.startSN,
                i = e.fragments;
              r < 0 || r >= i.length || p(t, i[r].start);
            }
            function p(e, t) {
              if (t) {
                for (var r = e.fragments, i = e.skippedSegments; i < r.length; i++) r[i].start += t;
                e.fragmentHint && (e.fragmentHint.start += t);
              }
            }
            function v(e, t) {
              var r,
                i = 1e3 * e.levelTargetDuration,
                n = i / 2,
                s = e.age,
                a = s > 0 && s < 3 * i,
                o = t.loading.end - t.loading.start,
                l = e.availabilityDelay;
              if (!1 === e.updated)
                if (a) {
                  var u = 333 * e.misses;
                  (r = Math.max(Math.min(n, 2 * o), u)), (e.availabilityDelay = (e.availabilityDelay || 0) + r);
                } else r = n;
              else a ? ((l = Math.min(l || i / 2, s)), (e.availabilityDelay = l), (r = l + i - s)) : (r = i - o);
              return Math.round(r);
            }
            function g(e, t, r) {
              if (!e || !e.details) return null;
              var i = e.details,
                n = i.fragments[t - i.startSN];
              return n || ((n = i.fragmentHint) && n.sn === t ? n : t < i.startSN && r && r.sn === t ? r : null);
            }
            function m(e, t, r) {
              if (!e || !e.details) return null;
              var i = e.details.partList;
              if (i)
                for (var n = i.length; n--; ) {
                  var s = i[n];
                  if (s.index === r && s.fragment.sn === t) return s;
                }
              return null;
            }
          },
          "./src/controller/stream-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return y;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/controller/base-stream-controller.ts"),
              s = r("./src/is-supported.ts"),
              a = r("./src/events.ts"),
              o = r("./src/utils/buffer-helper.ts"),
              l = r("./src/controller/fragment-tracker.ts"),
              u = r("./src/types/loader.ts"),
              d = r("./src/loader/fragment.ts"),
              c = r("./src/demux/transmuxer-interface.ts"),
              h = r("./src/types/transmuxer.ts"),
              f = r("./src/controller/gap-controller.ts"),
              p = r("./src/errors.ts"),
              v = r("./src/utils/logger.ts");
            function g(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function m(e, t) {
              return (m =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var y = (function(e) {
              var t, r;
              function y(t, r) {
                var i;
                return (
                  ((i = e.call(this, t, r, "[stream-controller]") || this).audioCodecSwap = !1),
                  (i.gapController = null),
                  (i.level = -1),
                  (i._forceStartLoad = !1),
                  (i.altAudio = !1),
                  (i.audioOnly = !1),
                  (i.fragPlaying = null),
                  (i.onvplaying = null),
                  (i.onvseeked = null),
                  (i.fragLastKbps = 0),
                  (i.stalled = !1),
                  (i.couldBacktrack = !1),
                  (i.audioCodecSwitch = !1),
                  (i.videoBuffer = null),
                  i._registerListeners(),
                  i
                );
              }
              (r = e), ((t = y).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), m(t, r);
              var E,
                T,
                b,
                S = y.prototype;
              return (
                (S._registerListeners = function() {
                  var e = this.hls;
                  e.on(a.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.on(a.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.on(a.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(a.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.on(a.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.on(a.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.on(a.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this),
                    e.on(a.Events.ERROR, this.onError, this),
                    e.on(a.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                    e.on(a.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                    e.on(a.Events.BUFFER_CREATED, this.onBufferCreated, this),
                    e.on(a.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                    e.on(a.Events.LEVELS_UPDATED, this.onLevelsUpdated, this),
                    e.on(a.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }),
                (S._unregisterListeners = function() {
                  var e = this.hls;
                  e.off(a.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.off(a.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.off(a.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.off(a.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.off(a.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.off(a.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this),
                    e.off(a.Events.ERROR, this.onError, this),
                    e.off(a.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                    e.off(a.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                    e.off(a.Events.BUFFER_CREATED, this.onBufferCreated, this),
                    e.off(a.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                    e.off(a.Events.LEVELS_UPDATED, this.onLevelsUpdated, this),
                    e.off(a.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }),
                (S.onHandlerDestroying = function() {
                  this._unregisterListeners(), this.onMediaDetaching();
                }),
                (S.startLoad = function(e) {
                  if (this.levels) {
                    var t = this.lastCurrentTime,
                      r = this.hls;
                    if (
                      (this.stopLoad(),
                      this.setInterval(100),
                      (this.level = -1),
                      (this.fragLoadError = 0),
                      !this.startFragRequested)
                    ) {
                      var i = r.startLevel;
                      -1 === i && (r.config.testBandwidth ? ((i = 0), (this.bitrateTest = !0)) : (i = r.nextAutoLevel)),
                        (this.level = r.nextLoadLevel = i),
                        (this.loadedmetadata = !1);
                    }
                    t > 0 &&
                      -1 === e &&
                      (this.log("Override startPosition with lastCurrentTime @" + t.toFixed(3)), (e = t)),
                      (this.state = n.State.IDLE),
                      (this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e),
                      this.tick();
                  } else (this._forceStartLoad = !0), (this.state = n.State.STOPPED);
                }),
                (S.stopLoad = function() {
                  (this._forceStartLoad = !1), e.prototype.stopLoad.call(this);
                }),
                (S.doTick = function() {
                  switch (this.state) {
                    case n.State.IDLE:
                      this.doTickIdle();
                      break;
                    case n.State.WAITING_LEVEL:
                      var e,
                        t = this.levels,
                        r = this.level,
                        i = null == t || null === (e = t[r]) || void 0 === e ? void 0 : e.details;
                      if (i && (!i.live || this.levelLastLoaded === this.level)) {
                        if (this.waitForCdnTuneIn(i)) break;
                        this.state = n.State.IDLE;
                        break;
                      }
                      break;
                    case n.State.FRAG_LOADING_WAITING_RETRY:
                      var s,
                        a = self.performance.now(),
                        o = this.retryDate;
                      (!o || a >= o || (null !== (s = this.media) && void 0 !== s && s.seeking)) &&
                        (this.log("retryDate reached, switch back to IDLE state"), (this.state = n.State.IDLE));
                  }
                  this.onTickEnd();
                }),
                (S.onTickEnd = function() {
                  e.prototype.onTickEnd.call(this), this.checkBuffer(), this.checkFragmentChanged();
                }),
                (S.doTickIdle = function() {
                  var e,
                    t,
                    r = this.hls,
                    i = this.levelLastLoaded,
                    s = this.levels,
                    o = this.media,
                    c = r.config,
                    h = r.nextLoadLevel;
                  if (
                    null !== i &&
                    (o || (!this.startFragRequested && c.startFragPrefetch)) &&
                    (!this.altAudio || !this.audioOnly) &&
                    s &&
                    s[h]
                  ) {
                    var f = s[h];
                    this.level = r.nextLoadLevel = h;
                    var p = f.details;
                    if (!p || this.state === n.State.WAITING_LEVEL || (p.live && this.levelLastLoaded !== h))
                      this.state = n.State.WAITING_LEVEL;
                    else {
                      var v = this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : o, u.PlaylistLevelType.MAIN);
                      if (null !== v && !(v.len >= this.getMaxBufferLength(f.maxBitrate))) {
                        if (this._streamEnded(v, p)) {
                          var g = {};
                          return (
                            this.altAudio && (g.type = "video"),
                            this.hls.trigger(a.Events.BUFFER_EOS, g),
                            void (this.state = n.State.ENDED)
                          );
                        }
                        var m = v.end,
                          y = this.getNextFragment(m, p);
                        if (this.couldBacktrack && !this.fragPrevious && y && "initSegment" !== y.sn) {
                          var E = y.sn - p.startSN;
                          E > 1 && ((y = p.fragments[E - 1]), this.fragmentTracker.removeFragment(y));
                        }
                        if (y && this.fragmentTracker.getState(y) === l.FragmentState.OK && this.nextLoadPosition > m) {
                          var T =
                            this.audioOnly && !this.altAudio
                              ? d.ElementaryStreamTypes.AUDIO
                              : d.ElementaryStreamTypes.VIDEO;
                          this.afterBufferFlushed(o, T, u.PlaylistLevelType.MAIN),
                            (y = this.getNextFragment(this.nextLoadPosition, p));
                        }
                        y &&
                          (!y.initSegment || y.initSegment.data || this.bitrateTest || (y = y.initSegment),
                          "identity" !== (null === (e = y.decryptdata) || void 0 === e ? void 0 : e.keyFormat) ||
                          (null !== (t = y.decryptdata) && void 0 !== t && t.key)
                            ? this.loadFragment(y, p, m)
                            : this.loadKey(y, p));
                      }
                    }
                  }
                }),
                (S.loadFragment = function(t, r, i) {
                  var n,
                    s = this.fragmentTracker.getState(t);
                  if (((this.fragCurrent = t), s === l.FragmentState.BACKTRACKED)) {
                    var a = this.fragmentTracker.getBacktrackData(t);
                    if (a) return this._handleFragmentLoadProgress(a), void this._handleFragmentLoadComplete(a);
                    s = l.FragmentState.NOT_LOADED;
                  }
                  s === l.FragmentState.NOT_LOADED || s === l.FragmentState.PARTIAL
                    ? "initSegment" === t.sn
                      ? this._loadInitSegment(t)
                      : this.bitrateTest
                        ? ((t.bitrateTest = !0),
                          this.log(
                            "Fragment " +
                              t.sn +
                              " of level " +
                              t.level +
                              " is being downloaded to test bitrate and will not be buffered"
                          ),
                          this._loadBitrateTestFrag(t))
                        : ((this.startFragRequested = !0), e.prototype.loadFragment.call(this, t, r, i))
                    : s === l.FragmentState.APPENDING
                      ? this.reduceMaxBufferLength(t.duration) && this.fragmentTracker.removeFragment(t)
                      : 0 === (null === (n = this.media) || void 0 === n ? void 0 : n.buffered.length) &&
                        this.fragmentTracker.removeAllFragments();
                }),
                (S.getAppendedFrag = function(e) {
                  var t = this.fragmentTracker.getAppendedFrag(e, u.PlaylistLevelType.MAIN);
                  return t && "fragment" in t ? t.fragment : t;
                }),
                (S.getBufferedFrag = function(e) {
                  return this.fragmentTracker.getBufferedFrag(e, u.PlaylistLevelType.MAIN);
                }),
                (S.followingBufferedFrag = function(e) {
                  return e ? this.getBufferedFrag(e.end + 0.5) : null;
                }),
                (S.immediateLevelSwitch = function() {
                  this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                }),
                (S.nextLevelSwitch = function() {
                  var e = this.levels,
                    t = this.media;
                  if (null != t && t.readyState) {
                    var r,
                      i = this.getAppendedFrag(t.currentTime);
                    if ((i && i.start > 1 && this.flushMainBuffer(0, i.start - 1), !t.paused && e)) {
                      var n = e[this.hls.nextLoadLevel],
                        s = this.fragLastKbps;
                      r = s && this.fragCurrent ? (this.fragCurrent.duration * n.maxBitrate) / (1e3 * s) + 1 : 0;
                    } else r = 0;
                    var a = this.getBufferedFrag(t.currentTime + r);
                    if (a) {
                      var o = this.followingBufferedFrag(a);
                      if (o) {
                        this.abortCurrentFrag();
                        var l = o.maxStartPTS ? o.maxStartPTS : o.start,
                          u = o.duration,
                          d = Math.max(
                            a.end,
                            l + Math.min(Math.max(u - this.config.maxFragLookUpTolerance, 0.5 * u), 0.75 * u)
                          );
                        this.flushMainBuffer(d, Number.POSITIVE_INFINITY);
                      }
                    }
                  }
                }),
                (S.abortCurrentFrag = function() {
                  var e = this.fragCurrent;
                  (this.fragCurrent = null),
                    null != e && e.loader && e.loader.abort(),
                    this.state === n.State.KEY_LOADING && (this.state = n.State.IDLE),
                    (this.nextLoadPosition = this.getLoadPosition());
                }),
                (S.flushMainBuffer = function(t, r) {
                  e.prototype.flushMainBuffer.call(this, t, r, this.altAudio ? "video" : null);
                }),
                (S.onMediaAttached = function(t, r) {
                  e.prototype.onMediaAttached.call(this, t, r);
                  var i = r.media;
                  (this.onvplaying = this.onMediaPlaying.bind(this)),
                    (this.onvseeked = this.onMediaSeeked.bind(this)),
                    i.addEventListener("playing", this.onvplaying),
                    i.addEventListener("seeked", this.onvseeked),
                    (this.gapController = new f.default(this.config, i, this.fragmentTracker, this.hls));
                }),
                (S.onMediaDetaching = function() {
                  var t = this.media;
                  t &&
                    (t.removeEventListener("playing", this.onvplaying),
                    t.removeEventListener("seeked", this.onvseeked),
                    (this.onvplaying = this.onvseeked = null),
                    (this.videoBuffer = null)),
                    (this.fragPlaying = null),
                    this.gapController && (this.gapController.destroy(), (this.gapController = null)),
                    e.prototype.onMediaDetaching.call(this);
                }),
                (S.onMediaPlaying = function() {
                  this.tick();
                }),
                (S.onMediaSeeked = function() {
                  var e = this.media,
                    t = e ? e.currentTime : null;
                  Object(i.isFiniteNumber)(t) && this.log("Media seeked to " + t.toFixed(3)), this.tick();
                }),
                (S.onManifestLoading = function() {
                  this.log("Trigger BUFFER_RESET"),
                    this.hls.trigger(a.Events.BUFFER_RESET, void 0),
                    this.fragmentTracker.removeAllFragments(),
                    (this.couldBacktrack = this.stalled = !1),
                    (this.startPosition = this.lastCurrentTime = 0),
                    (this.fragPlaying = null);
                }),
                (S.onManifestParsed = function(e, t) {
                  var r,
                    i = !1,
                    n = !1;
                  t.levels.forEach(function(e) {
                    (r = e.audioCodec) &&
                      (-1 !== r.indexOf("mp4a.40.2") && (i = !0), -1 !== r.indexOf("mp4a.40.5") && (n = !0));
                  }),
                    (this.audioCodecSwitch = i && n && !Object(s.changeTypeSupported)()),
                    this.audioCodecSwitch &&
                      this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"),
                    (this.levels = t.levels),
                    (this.startFragRequested = !1);
                }),
                (S.onLevelLoading = function(e, t) {
                  var r = this.levels;
                  if (r && this.state === n.State.IDLE) {
                    var i = r[t.level];
                    (!i.details ||
                      (i.details.live && this.levelLastLoaded !== t.level) ||
                      this.waitForCdnTuneIn(i.details)) &&
                      (this.state = n.State.WAITING_LEVEL);
                  }
                }),
                (S.onLevelLoaded = function(e, t) {
                  var r,
                    i = this.levels,
                    s = t.level,
                    o = t.details,
                    l = o.totalduration;
                  if (i) {
                    this.log(
                      "Level " +
                        s +
                        " loaded [" +
                        o.startSN +
                        "," +
                        o.endSN +
                        "], cc [" +
                        o.startCC +
                        ", " +
                        o.endCC +
                        "] duration:" +
                        l
                    );
                    var u = this.fragCurrent;
                    !u ||
                      (this.state !== n.State.FRAG_LOADING && this.state !== n.State.FRAG_LOADING_WAITING_RETRY) ||
                      (u.level !== t.level && u.loader && ((this.state = n.State.IDLE), u.loader.abort()));
                    var d = i[s],
                      c = 0;
                    if (o.live || (null !== (r = d.details) && void 0 !== r && r.live)) {
                      if ((o.fragments[0] || (o.deltaUpdateFailed = !0), o.deltaUpdateFailed)) return;
                      c = this.alignPlaylists(o, d.details);
                    }
                    if (
                      ((d.details = o),
                      (this.levelLastLoaded = s),
                      this.hls.trigger(a.Events.LEVEL_UPDATED, { details: o, level: s }),
                      this.state === n.State.WAITING_LEVEL)
                    ) {
                      if (this.waitForCdnTuneIn(o)) return;
                      this.state = n.State.IDLE;
                    }
                    this.startFragRequested ? o.live && this.synchronizeToLiveEdge(o) : this.setStartPosition(o, c),
                      this.tick();
                  } else this.warn("Levels were reset while loading level " + s);
                }),
                (S._handleFragmentLoadProgress = function(e) {
                  var t,
                    r = e.frag,
                    i = e.part,
                    n = e.payload,
                    s = this.levels;
                  if (s) {
                    var a = s[r.level],
                      o = a.details;
                    if (o) {
                      var l = a.videoCodec,
                        d = o.PTSKnown || !o.live,
                        f = null === (t = r.initSegment) || void 0 === t ? void 0 : t.data,
                        p = this._getAudioCodec(a),
                        v = (this.transmuxer =
                          this.transmuxer ||
                          new c.default(
                            this.hls,
                            u.PlaylistLevelType.MAIN,
                            this._handleTransmuxComplete.bind(this),
                            this._handleTransmuxerFlush.bind(this)
                          )),
                        g = i ? i.index : -1,
                        m = -1 !== g,
                        y = new h.ChunkMetadata(r.level, r.sn, r.stats.chunkCount, n.byteLength, g, m),
                        E = this.initPTS[r.cc];
                      v.push(n, f, p, l, r, i, o.totalduration, d, y, E);
                    } else
                      this.warn(
                        "Dropping fragment " + r.sn + " of level " + r.level + " after level details were reset"
                      );
                  } else
                    this.warn(
                      "Levels were reset while fragment load was in progress. Fragment " +
                        r.sn +
                        " of level " +
                        r.level +
                        " will not be buffered"
                    );
                }),
                (S.onAudioTrackSwitching = function(e, t) {
                  var r = this.altAudio,
                    i = !!t.url,
                    n = t.id;
                  if (!i) {
                    if (this.mediaBuffer !== this.media) {
                      this.log("Switching on main audio, use media.buffered to schedule main fragment loading"),
                        (this.mediaBuffer = this.media);
                      var s = this.fragCurrent;
                      null != s &&
                        s.loader &&
                        (this.log("Switching to main audio track, cancel main fragment load"), s.loader.abort()),
                        this.resetTransmuxer(),
                        this.resetLoadingState();
                    } else this.audioOnly && this.resetTransmuxer();
                    var o = this.hls;
                    r &&
                      o.trigger(a.Events.BUFFER_FLUSHING, {
                        startOffset: 0,
                        endOffset: Number.POSITIVE_INFINITY,
                        type: "audio"
                      }),
                      o.trigger(a.Events.AUDIO_TRACK_SWITCHED, { id: n });
                  }
                }),
                (S.onAudioTrackSwitched = function(e, t) {
                  var r = t.id,
                    i = !!this.hls.audioTracks[r].url;
                  if (i) {
                    var n = this.videoBuffer;
                    n &&
                      this.mediaBuffer !== n &&
                      (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"),
                      (this.mediaBuffer = n));
                  }
                  (this.altAudio = i), this.tick();
                }),
                (S.onBufferCreated = function(e, t) {
                  var r,
                    i,
                    n = t.tracks,
                    s = !1;
                  for (var a in n) {
                    var o = n[a];
                    if ("main" === o.id) {
                      if (((i = a), (r = o), "video" === a)) {
                        var l = n[a];
                        l && (this.videoBuffer = l.buffer);
                      }
                    } else s = !0;
                  }
                  s && r
                    ? (this.log("Alternate track found, use " + i + ".buffered to schedule main fragment loading"),
                      (this.mediaBuffer = r.buffer))
                    : (this.mediaBuffer = this.media);
                }),
                (S.onFragBuffered = function(e, t) {
                  var r = t.frag,
                    i = t.part;
                  if (!r || r.type === u.PlaylistLevelType.MAIN) {
                    if (this.fragContextChanged(r))
                      return (
                        this.warn(
                          "Fragment " +
                            r.sn +
                            (i ? " p: " + i.index : "") +
                            " of level " +
                            r.level +
                            " finished buffering, but was aborted. state: " +
                            this.state
                        ),
                        void (this.state === n.State.PARSED && (this.state = n.State.IDLE))
                      );
                    var s = i ? i.stats : r.stats;
                    (this.fragLastKbps = Math.round((8 * s.total) / (s.buffering.end - s.loading.first))),
                      "initSegment" !== r.sn && (this.fragPrevious = r),
                      this.fragBufferedComplete(r, i);
                  }
                }),
                (S.onError = function(e, t) {
                  switch (t.details) {
                    case p.ErrorDetails.FRAG_LOAD_ERROR:
                    case p.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case p.ErrorDetails.KEY_LOAD_ERROR:
                    case p.ErrorDetails.KEY_LOAD_TIMEOUT:
                      this.onFragmentOrKeyLoadError(u.PlaylistLevelType.MAIN, t);
                      break;
                    case p.ErrorDetails.LEVEL_LOAD_ERROR:
                    case p.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                      this.state !== n.State.ERROR &&
                        (t.fatal
                          ? (this.warn("" + t.details), (this.state = n.State.ERROR))
                          : t.levelRetry || this.state !== n.State.WAITING_LEVEL || (this.state = n.State.IDLE));
                      break;
                    case p.ErrorDetails.BUFFER_FULL_ERROR:
                      if ("main" === t.parent && (this.state === n.State.PARSING || this.state === n.State.PARSED)) {
                        var r = !0,
                          i = this.getFwdBufferInfo(this.media, u.PlaylistLevelType.MAIN);
                        i && i.len > 0.5 && (r = !this.reduceMaxBufferLength(i.len)),
                          r &&
                            (this.warn("buffer full error also media.currentTime is not buffered, flush main"),
                            this.immediateLevelSwitch()),
                          this.resetLoadingState();
                      }
                  }
                }),
                (S.checkBuffer = function() {
                  var e = this.media,
                    t = this.gapController;
                  if (e && t && e.readyState) {
                    var r = o.BufferHelper.getBuffered(e);
                    !this.loadedmetadata && r.length
                      ? ((this.loadedmetadata = !0), this.seekToStartPos())
                      : t.poll(this.lastCurrentTime),
                      (this.lastCurrentTime = e.currentTime);
                  }
                }),
                (S.onFragLoadEmergencyAborted = function() {
                  (this.state = n.State.IDLE),
                    this.loadedmetadata ||
                      ((this.startFragRequested = !1), (this.nextLoadPosition = this.startPosition)),
                    this.tickImmediate();
                }),
                (S.onBufferFlushed = function(e, t) {
                  var r = t.type;
                  if (r !== d.ElementaryStreamTypes.AUDIO || (this.audioOnly && !this.altAudio)) {
                    var i = (r === d.ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                    this.afterBufferFlushed(i, r, u.PlaylistLevelType.MAIN);
                  }
                }),
                (S.onLevelsUpdated = function(e, t) {
                  this.levels = t.levels;
                }),
                (S.swapAudioCodec = function() {
                  this.audioCodecSwap = !this.audioCodecSwap;
                }),
                (S.seekToStartPos = function() {
                  var e = this.media,
                    t = e.currentTime,
                    r = this.startPosition;
                  if (r >= 0 && t < r) {
                    if (e.seeking) return void v.logger.log("could not seek to " + r + ", already seeking at " + t);
                    var i = o.BufferHelper.getBuffered(e),
                      n = (i.length ? i.start(0) : 0) - r;
                    n > 0 &&
                      (n < this.config.maxBufferHole || n < this.config.maxFragLookUpTolerance) &&
                      (v.logger.log("adjusting start position by " + n + " to match buffer start"),
                      (r += n),
                      (this.startPosition = r)),
                      this.log("seek to target start position " + r + " from current time " + t),
                      (e.currentTime = r);
                  }
                }),
                (S._getAudioCodec = function(e) {
                  var t = this.config.defaultAudioCodec || e.audioCodec;
                  return (
                    this.audioCodecSwap &&
                      t &&
                      (this.log("Swapping audio codec"),
                      (t = -1 !== t.indexOf("mp4a.40.5") ? "mp4a.40.2" : "mp4a.40.5")),
                    t
                  );
                }),
                (S._loadBitrateTestFrag = function(e) {
                  var t = this;
                  this._doFragLoad(e).then(function(r) {
                    var i = t.hls;
                    if (r && !i.nextLoadLevel && !t.fragContextChanged(e)) {
                      (t.fragLoadError = 0),
                        (t.state = n.State.IDLE),
                        (t.startFragRequested = !1),
                        (t.bitrateTest = !1);
                      var s = e.stats;
                      (s.parsing.start = s.parsing.end = s.buffering.start = s.buffering.end = self.performance.now()),
                        i.trigger(a.Events.FRAG_LOADED, r);
                    }
                  });
                }),
                (S._handleTransmuxComplete = function(e) {
                  var t,
                    r = "main",
                    s = this.hls,
                    o = e.remuxResult,
                    l = e.chunkMeta,
                    u = this.getCurrentContext(l);
                  if (!u)
                    return (
                      this.warn(
                        "The loading context changed while buffering fragment " +
                          l.sn +
                          " of level " +
                          l.level +
                          ". This chunk will not be buffered."
                      ),
                      void this.resetLiveStartWhenNotLoaded(l.level)
                    );
                  var c = u.frag,
                    h = u.part,
                    f = u.level,
                    p = o.video,
                    v = o.text,
                    g = o.id3,
                    m = o.initSegment,
                    y = this.altAudio ? void 0 : o.audio;
                  if (!this.fragContextChanged(c)) {
                    if (((this.state = n.State.PARSING), m)) {
                      m.tracks &&
                        (this._bufferInitSegment(f, m.tracks, c, l),
                        s.trigger(a.Events.FRAG_PARSING_INIT_SEGMENT, { frag: c, id: r, tracks: m.tracks }));
                      var E = m.initPTS,
                        T = m.timescale;
                      Object(i.isFiniteNumber)(E) &&
                        ((this.initPTS[c.cc] = E),
                        s.trigger(a.Events.INIT_PTS_FOUND, { frag: c, id: r, initPTS: E, timescale: T }));
                    }
                    if (p && !1 !== o.independent) {
                      if (f.details) {
                        var b = p.startPTS,
                          S = p.endPTS,
                          k = p.startDTS,
                          A = p.endDTS;
                        if (h) h.elementaryStreams[p.type] = { startPTS: b, endPTS: S, startDTS: k, endDTS: A };
                        else if (
                          (p.firstKeyFrame && p.independent && (this.couldBacktrack = !0), p.dropped && p.independent)
                        ) {
                          if (this.getLoadPosition() + this.config.maxBufferHole < b) return void this.backtrack(c);
                          c.setElementaryStreamInfo(p.type, c.start, S, c.start, A, !0);
                        }
                        c.setElementaryStreamInfo(p.type, b, S, k, A), this.bufferFragmentData(p, c, h, l);
                      }
                    } else if (!1 === o.independent) return void this.backtrack(c);
                    if (y) {
                      var w = y.startPTS,
                        R = y.endPTS,
                        C = y.startDTS,
                        L = y.endDTS;
                      h &&
                        (h.elementaryStreams[d.ElementaryStreamTypes.AUDIO] = {
                          startPTS: w,
                          endPTS: R,
                          startDTS: C,
                          endDTS: L
                        }),
                        c.setElementaryStreamInfo(d.ElementaryStreamTypes.AUDIO, w, R, C, L),
                        this.bufferFragmentData(y, c, h, l);
                    }
                    if (null != g && null !== (t = g.samples) && void 0 !== t && t.length) {
                      var D = { frag: c, id: r, samples: g.samples };
                      s.trigger(a.Events.FRAG_PARSING_METADATA, D);
                    }
                    if (v) {
                      var _ = { frag: c, id: r, samples: v.samples };
                      s.trigger(a.Events.FRAG_PARSING_USERDATA, _);
                    }
                  }
                }),
                (S._bufferInitSegment = function(e, t, r, i) {
                  var s = this;
                  if (this.state === n.State.PARSING) {
                    (this.audioOnly = !!t.audio && !t.video), this.altAudio && !this.audioOnly && delete t.audio;
                    var o = t.audio,
                      l = t.video,
                      u = t.audiovideo;
                    if (o) {
                      var d = e.audioCodec,
                        c = navigator.userAgent.toLowerCase();
                      this.audioCodecSwitch &&
                        (d && (d = -1 !== d.indexOf("mp4a.40.5") ? "mp4a.40.2" : "mp4a.40.5"),
                        1 !== o.metadata.channelCount && -1 === c.indexOf("firefox") && (d = "mp4a.40.5")),
                        -1 !== c.indexOf("android") &&
                          "audio/mpeg" !== o.container &&
                          ((d = "mp4a.40.2"), this.log("Android: force audio codec to " + d)),
                        e.audioCodec &&
                          e.audioCodec !== d &&
                          this.log('Swapping manifest audio codec "' + e.audioCodec + '" for "' + d + '"'),
                        (o.levelCodec = d),
                        (o.id = "main"),
                        this.log(
                          "Init audio buffer, container:" +
                            o.container +
                            ", codecs[selected/level/parsed]=[" +
                            (d || "") +
                            "/" +
                            (e.audioCodec || "") +
                            "/" +
                            o.codec +
                            "]"
                        );
                    }
                    l &&
                      ((l.levelCodec = e.videoCodec),
                      (l.id = "main"),
                      this.log(
                        "Init video buffer, container:" +
                          l.container +
                          ", codecs[level/parsed]=[" +
                          (e.videoCodec || "") +
                          "/" +
                          l.codec +
                          "]"
                      )),
                      u &&
                        this.log(
                          "Init audiovideo buffer, container:" +
                            u.container +
                            ", codecs[level/parsed]=[" +
                            (e.attrs.CODECS || "") +
                            "/" +
                            u.codec +
                            "]"
                        ),
                      this.hls.trigger(a.Events.BUFFER_CODECS, t),
                      Object.keys(t).forEach(function(e) {
                        var n = t[e].initSegment;
                        null != n &&
                          n.byteLength &&
                          s.hls.trigger(a.Events.BUFFER_APPENDING, {
                            type: e,
                            data: n,
                            frag: r,
                            part: null,
                            chunkMeta: i,
                            parent: r.type
                          });
                      }),
                      this.tick();
                  }
                }),
                (S.backtrack = function(e) {
                  (this.couldBacktrack = !0), this.resetTransmuxer(), this.flushBufferGap(e);
                  var t = this.fragmentTracker.backtrack(e);
                  (this.fragPrevious = null),
                    (this.nextLoadPosition = e.start),
                    t ? this.resetFragmentLoading(e) : (this.state = n.State.BACKTRACKING);
                }),
                (S.checkFragmentChanged = function() {
                  var e = this.media,
                    t = null;
                  if (e && e.readyState > 1 && !1 === e.seeking) {
                    var r = e.currentTime;
                    if (
                      (o.BufferHelper.isBuffered(e, r)
                        ? (t = this.getAppendedFrag(r))
                        : o.BufferHelper.isBuffered(e, r + 0.1) && (t = this.getAppendedFrag(r + 0.1)),
                      t)
                    ) {
                      var i = this.fragPlaying,
                        n = t.level;
                      (i && t.sn === i.sn && i.level === n && t.urlId === i.urlId) ||
                        (this.hls.trigger(a.Events.FRAG_CHANGED, { frag: t }),
                        (i && i.level === n) || this.hls.trigger(a.Events.LEVEL_SWITCHED, { level: n }),
                        (this.fragPlaying = t));
                    }
                  }
                }),
                (E = y),
                (T = [
                  {
                    key: "nextLevel",
                    get: function() {
                      var e = this.nextBufferedFrag;
                      return e ? e.level : -1;
                    }
                  },
                  {
                    key: "currentLevel",
                    get: function() {
                      var e = this.media;
                      if (e) {
                        var t = this.getAppendedFrag(e.currentTime);
                        if (t) return t.level;
                      }
                      return -1;
                    }
                  },
                  {
                    key: "nextBufferedFrag",
                    get: function() {
                      var e = this.media;
                      if (e) {
                        var t = this.getAppendedFrag(e.currentTime);
                        return this.followingBufferedFrag(t);
                      }
                      return null;
                    }
                  },
                  {
                    key: "forceStartLoad",
                    get: function() {
                      return this._forceStartLoad;
                    }
                  }
                ]) && g(E.prototype, T),
                b && g(E, b),
                y
              );
            })(n.default);
          },
          "./src/controller/subtitle-stream-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "SubtitleStreamController", function() {
                return p;
              });
            var i = r("./src/events.ts"),
              n = r("./src/utils/buffer-helper.ts"),
              s = r("./src/controller/fragment-finders.ts"),
              a = r("./src/utils/discontinuities.ts"),
              o = r("./src/controller/level-helper.ts"),
              l = r("./src/controller/fragment-tracker.ts"),
              u = r("./src/controller/base-stream-controller.ts"),
              d = r("./src/types/loader.ts"),
              c = r("./src/types/level.ts");
            function h(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function f(e, t) {
              return (f =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var p = (function(e) {
              var t, r;
              function p(t, r) {
                var i;
                return (
                  ((i = e.call(this, t, r, "[subtitle-stream-controller]") || this).levels = []),
                  (i.currentTrackId = -1),
                  (i.tracksBuffered = []),
                  (i.mainDetails = null),
                  i._registerListeners(),
                  i
                );
              }
              (r = e), ((t = p).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), f(t, r);
              var v,
                g,
                m,
                y = p.prototype;
              return (
                (y.onHandlerDestroying = function() {
                  this._unregisterListeners(), (this.mainDetails = null);
                }),
                (y._registerListeners = function() {
                  var e = this.hls;
                  e.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(i.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.on(i.Events.ERROR, this.onError, this),
                    e.on(i.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                    e.on(i.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this),
                    e.on(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                    e.on(i.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this),
                    e.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }),
                (y._unregisterListeners = function() {
                  var e = this.hls;
                  e.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.off(i.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                    e.off(i.Events.ERROR, this.onError, this),
                    e.off(i.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                    e.off(i.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this),
                    e.off(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                    e.off(i.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this),
                    e.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }),
                (y.startLoad = function() {
                  this.stopLoad(), (this.state = u.State.IDLE), this.setInterval(500), this.tick();
                }),
                (y.onManifestLoading = function() {
                  (this.mainDetails = null), this.fragmentTracker.removeAllFragments();
                }),
                (y.onLevelLoaded = function(e, t) {
                  this.mainDetails = t.details;
                }),
                (y.onSubtitleFragProcessed = function(e, t) {
                  var r = t.frag,
                    i = t.success;
                  if (((this.fragPrevious = r), (this.state = u.State.IDLE), i)) {
                    var n = this.tracksBuffered[this.currentTrackId];
                    if (n) {
                      for (var s, a = r.start, o = 0; o < n.length; o++)
                        if (a >= n[o].start && a <= n[o].end) {
                          s = n[o];
                          break;
                        }
                      var l = r.start + r.duration;
                      s ? (s.end = l) : ((s = { start: a, end: l }), n.push(s)), this.fragmentTracker.fragBuffered(r);
                    }
                  }
                }),
                (y.onBufferFlushing = function(e, t) {
                  var r = t.startOffset,
                    i = t.endOffset;
                  if (0 === r && i !== Number.POSITIVE_INFINITY) {
                    var n = this.currentTrackId,
                      s = this.levels;
                    if (!s.length || !s[n] || !s[n].details) return;
                    var a = i - s[n].details.targetduration;
                    if (a <= 0) return;
                    (t.endOffsetSubtitles = Math.max(0, a)),
                      this.tracksBuffered.forEach(function(e) {
                        for (var t = 0; t < e.length; )
                          if (e[t].end <= a) e.shift();
                          else {
                            if (!(e[t].start < a)) break;
                            (e[t].start = a), t++;
                          }
                      }),
                      this.fragmentTracker.removeFragmentsInRange(r, a, d.PlaylistLevelType.SUBTITLE);
                  }
                }),
                (y.onError = function(e, t) {
                  var r,
                    i = t.frag;
                  i &&
                    i.type === d.PlaylistLevelType.SUBTITLE &&
                    (null !== (r = this.fragCurrent) && void 0 !== r && r.loader && this.fragCurrent.loader.abort(),
                    (this.state = u.State.IDLE));
                }),
                (y.onSubtitleTracksUpdated = function(e, t) {
                  var r = this,
                    i = t.subtitleTracks;
                  (this.tracksBuffered = []),
                    (this.levels = i.map(function(e) {
                      return new c.Level(e);
                    })),
                    this.fragmentTracker.removeAllFragments(),
                    (this.fragPrevious = null),
                    this.levels.forEach(function(e) {
                      r.tracksBuffered[e.id] = [];
                    }),
                    (this.mediaBuffer = null);
                }),
                (y.onSubtitleTrackSwitch = function(e, t) {
                  if (((this.currentTrackId = t.id), this.levels.length && -1 !== this.currentTrackId)) {
                    var r = this.levels[this.currentTrackId];
                    null != r && r.details
                      ? (this.mediaBuffer = this.mediaBufferTimeRanges)
                      : (this.mediaBuffer = null),
                      r && this.setInterval(500);
                  } else this.clearInterval();
                }),
                (y.onSubtitleTrackLoaded = function(e, t) {
                  var r,
                    i = t.details,
                    n = t.id,
                    l = this.currentTrackId,
                    d = this.levels;
                  if (d.length) {
                    var c = d[l];
                    if (!(n >= d.length || n !== l) && c) {
                      if (
                        ((this.mediaBuffer = this.mediaBufferTimeRanges),
                        i.live || (null !== (r = c.details) && void 0 !== r && r.live))
                      ) {
                        var h = this.mainDetails;
                        if (i.deltaUpdateFailed || !h) return;
                        var f = h.fragments[0];
                        c.details
                          ? 0 === this.alignPlaylists(i, c.details) && f && Object(o.addSliding)(i, f.start)
                          : i.hasProgramDateTime && h.hasProgramDateTime
                            ? Object(a.alignMediaPlaylistByPDT)(i, h)
                            : f && Object(o.addSliding)(i, f.start);
                      }
                      (c.details = i),
                        (this.levelLastLoaded = n),
                        this.tick(),
                        i.live &&
                          !this.fragCurrent &&
                          this.media &&
                          this.state === u.State.IDLE &&
                          (Object(s.findFragmentByPTS)(null, i.fragments, this.media.currentTime, 0) ||
                            (this.warn("Subtitle playlist not aligned with playback"), (c.details = void 0)));
                    }
                  }
                }),
                (y._handleFragmentLoadComplete = function(e) {
                  var t = e.frag,
                    r = e.payload,
                    n = t.decryptdata,
                    s = this.hls;
                  if (
                    !this.fragContextChanged(t) &&
                    r &&
                    r.byteLength > 0 &&
                    n &&
                    n.key &&
                    n.iv &&
                    "AES-128" === n.method
                  ) {
                    var a = performance.now();
                    this.decrypter.webCryptoDecrypt(new Uint8Array(r), n.key.buffer, n.iv.buffer).then(function(e) {
                      var r = performance.now();
                      s.trigger(i.Events.FRAG_DECRYPTED, { frag: t, payload: e, stats: { tstart: a, tdecrypt: r } });
                    });
                  }
                }),
                (y.doTick = function() {
                  if (this.media) {
                    if (this.state === u.State.IDLE) {
                      var e,
                        t = this.currentTrackId,
                        r = this.levels;
                      if (!r.length || !r[t] || !r[t].details) return;
                      var i = r[t].details,
                        a = i.targetduration,
                        o = this.config,
                        d = this.media,
                        c = n.BufferHelper.bufferedInfo(this.mediaBufferTimeRanges, d.currentTime - a, o.maxBufferHole),
                        h = c.end;
                      if (c.len > this.getMaxBufferLength() + a) return;
                      console.assert(i, "Subtitle track details are defined on idle subtitle stream controller tick");
                      var f,
                        p = i.fragments,
                        v = p.length,
                        g = i.edge,
                        m = this.fragPrevious;
                      if (h < g) {
                        var y = o.maxFragLookUpTolerance;
                        !(f = Object(s.findFragmentByPTS)(m, p, h, y)) && m && m.start < p[0].start && (f = p[0]);
                      } else f = p[v - 1];
                      null !== (e = f) && void 0 !== e && e.encrypted
                        ? this.loadKey(f, i)
                        : f &&
                          this.fragmentTracker.getState(f) === l.FragmentState.NOT_LOADED &&
                          this.loadFragment(f, i, h);
                    }
                  } else this.state = u.State.IDLE;
                }),
                (y.loadFragment = function(t, r, i) {
                  (this.fragCurrent = t), e.prototype.loadFragment.call(this, t, r, i);
                }),
                (v = p),
                (g = [
                  {
                    key: "mediaBufferTimeRanges",
                    get: function() {
                      return this.tracksBuffered[this.currentTrackId] || [];
                    }
                  }
                ]) && h(v.prototype, g),
                m && h(v, m),
                p
              );
            })(u.default);
          },
          "./src/controller/subtitle-track-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/events.ts"),
              n = r("./src/utils/texttrack-utils.ts"),
              s = r("./src/controller/base-playlist-controller.ts"),
              a = r("./src/types/loader.ts");
            function o(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function l(e, t) {
              return (l =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var u = (function(e) {
              var t, r;
              function s(t) {
                var r;
                return (
                  ((r = e.call(this, t, "[subtitle-track-controller]") || this).media = null),
                  (r.tracks = []),
                  (r.groupId = null),
                  (r.tracksInGroup = []),
                  (r.trackId = -1),
                  (r.selectDefaultTrack = !0),
                  (r.queuedDefaultTrack = -1),
                  (r.trackChangeListener = function() {
                    return r.onTextTracksChanged();
                  }),
                  (r.asyncPollTrackChange = function() {
                    return r.pollTrackChange(0);
                  }),
                  (r.useTextTrackPolling = !1),
                  (r.subtitlePollingInterval = -1),
                  (r.subtitleDisplay = !0),
                  r.registerListeners(),
                  r
                );
              }
              (r = e), ((t = s).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), l(t, r);
              var u,
                c,
                h,
                f = s.prototype;
              return (
                (f.destroy = function() {
                  this.unregisterListeners(),
                    (this.tracks.length = 0),
                    (this.tracksInGroup.length = 0),
                    (this.trackChangeListener = this.asyncPollTrackChange = null),
                    e.prototype.destroy.call(this);
                }),
                (f.registerListeners = function() {
                  var e = this.hls;
                  e.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.on(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.on(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                    e.on(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                    e.on(i.Events.ERROR, this.onError, this);
                }),
                (f.unregisterListeners = function() {
                  var e = this.hls;
                  e.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                    e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                    e.off(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.off(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                    e.off(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                    e.off(i.Events.ERROR, this.onError, this);
                }),
                (f.onMediaAttached = function(e, t) {
                  (this.media = t.media),
                    this.media &&
                      (this.queuedDefaultTrack > -1 &&
                        ((this.subtitleTrack = this.queuedDefaultTrack), (this.queuedDefaultTrack = -1)),
                      (this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks)),
                      this.useTextTrackPolling
                        ? this.pollTrackChange(500)
                        : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
                }),
                (f.pollTrackChange = function(e) {
                  self.clearInterval(this.subtitlePollingInterval),
                    (this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, e));
                }),
                (f.onMediaDetaching = function() {
                  this.media &&
                    (self.clearInterval(this.subtitlePollingInterval),
                    this.useTextTrackPolling ||
                      this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange),
                    this.trackId > -1 && (this.queuedDefaultTrack = this.trackId),
                    d(this.media.textTracks).forEach(function(e) {
                      Object(n.clearCurrentCues)(e);
                    }),
                    (this.subtitleTrack = -1),
                    (this.media = null));
                }),
                (f.onManifestLoading = function() {
                  (this.tracks = []),
                    (this.groupId = null),
                    (this.tracksInGroup = []),
                    (this.trackId = -1),
                    (this.selectDefaultTrack = !0);
                }),
                (f.onManifestParsed = function(e, t) {
                  this.tracks = t.subtitleTracks;
                }),
                (f.onSubtitleTrackLoaded = function(e, t) {
                  var r = t.id,
                    i = t.details,
                    n = this.trackId,
                    s = this.tracksInGroup[n];
                  if (s) {
                    var a = s.details;
                    (s.details = t.details),
                      this.log("subtitle track " + r + " loaded [" + i.startSN + "-" + i.endSN + "]"),
                      r === this.trackId && ((this.retryCount = 0), this.playlistLoaded(r, t, a));
                  } else this.warn("Invalid subtitle track id " + r);
                }),
                (f.onLevelLoading = function(e, t) {
                  this.switchLevel(t.level);
                }),
                (f.onLevelSwitching = function(e, t) {
                  this.switchLevel(t.level);
                }),
                (f.switchLevel = function(e) {
                  var t = this.hls.levels[e];
                  if (null != t && t.textGroupIds) {
                    var r = t.textGroupIds[t.urlId];
                    if (this.groupId !== r) {
                      var n = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0,
                        s = this.tracks.filter(function(e) {
                          return !r || e.groupId === r;
                        });
                      this.tracksInGroup = s;
                      var a = this.findTrackId(null == n ? void 0 : n.name) || this.findTrackId();
                      this.groupId = r;
                      var o = { subtitleTracks: s };
                      this.log("Updating subtitle tracks, " + s.length + ' track(s) found in "' + r + '" group-id'),
                        this.hls.trigger(i.Events.SUBTITLE_TRACKS_UPDATED, o),
                        -1 !== a && this.setSubtitleTrack(a, n);
                    }
                  }
                }),
                (f.findTrackId = function(e) {
                  for (var t = this.tracksInGroup, r = 0; r < t.length; r++) {
                    var i = t[r];
                    if ((!this.selectDefaultTrack || i.default) && (!e || e === i.name)) return i.id;
                  }
                  return -1;
                }),
                (f.onError = function(t, r) {
                  e.prototype.onError.call(this, t, r),
                    !r.fatal &&
                      r.context &&
                      r.context.type === a.PlaylistContextType.SUBTITLE_TRACK &&
                      r.context.id === this.trackId &&
                      r.context.groupId === this.groupId &&
                      this.retryLoadingOrFail(r);
                }),
                (f.loadPlaylist = function(e) {
                  var t = this.tracksInGroup[this.trackId];
                  if (this.shouldLoadTrack(t)) {
                    var r = t.id,
                      n = t.groupId,
                      s = t.url;
                    if (e)
                      try {
                        s = e.addDirectives(s);
                      } catch (e) {
                        this.warn("Could not construct new URL with HLS Delivery Directives: " + e);
                      }
                    this.log("Loading subtitle playlist for id " + r),
                      this.hls.trigger(i.Events.SUBTITLE_TRACK_LOADING, {
                        url: s,
                        id: r,
                        groupId: n,
                        deliveryDirectives: e || null
                      });
                  }
                }),
                (f.toggleTrackModes = function(e) {
                  var t = this,
                    r = this.media,
                    i = this.subtitleDisplay,
                    n = this.trackId;
                  if (r) {
                    var s = d(r.textTracks),
                      a = s.filter(function(e) {
                        return e.groupId === t.groupId;
                      });
                    if (-1 === e)
                      [].slice.call(s).forEach(function(e) {
                        e.mode = "disabled";
                      });
                    else {
                      var o = a[n];
                      o && (o.mode = "disabled");
                    }
                    var l = a[e];
                    l && (l.mode = i ? "showing" : "hidden");
                  }
                }),
                (f.setSubtitleTrack = function(e, t) {
                  var r,
                    n = this.tracksInGroup;
                  if (this.media) {
                    if (
                      (this.trackId !== e && this.toggleTrackModes(e),
                      !(
                        (this.trackId === e && (-1 === e || (null !== (r = n[e]) && void 0 !== r && r.details))) ||
                        e < -1 ||
                        e >= n.length
                      ))
                    ) {
                      this.clearTimer();
                      var s = n[e];
                      if ((this.log("Switching to subtitle track " + e), (this.trackId = e), s)) {
                        var a = s.id,
                          o = s.groupId,
                          l = void 0 === o ? "" : o,
                          u = s.name,
                          d = s.type,
                          c = s.url;
                        this.hls.trigger(i.Events.SUBTITLE_TRACK_SWITCH, {
                          id: a,
                          groupId: l,
                          name: u,
                          type: d,
                          url: c
                        });
                        var h = this.switchParams(s.url, null == t ? void 0 : t.details);
                        this.loadPlaylist(h);
                      } else this.hls.trigger(i.Events.SUBTITLE_TRACK_SWITCH, { id: e });
                    }
                  } else this.queuedDefaultTrack = e;
                }),
                (f.onTextTracksChanged = function() {
                  if (
                    (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval),
                    this.media && this.hls.config.renderTextTracksNatively)
                  ) {
                    for (var e = -1, t = d(this.media.textTracks), r = 0; r < t.length; r++)
                      if ("hidden" === t[r].mode) e = r;
                      else if ("showing" === t[r].mode) {
                        e = r;
                        break;
                      }
                    this.subtitleTrack !== e && (this.subtitleTrack = e);
                  }
                }),
                (u = s),
                (c = [
                  {
                    key: "subtitleTracks",
                    get: function() {
                      return this.tracksInGroup;
                    }
                  },
                  {
                    key: "subtitleTrack",
                    get: function() {
                      return this.trackId;
                    },
                    set: function(e) {
                      this.selectDefaultTrack = !1;
                      var t = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
                      this.setSubtitleTrack(e, t);
                    }
                  }
                ]) && o(u.prototype, c),
                h && o(u, h),
                s
              );
            })(s.default);
            function d(e) {
              for (var t = [], r = 0; r < e.length; r++) {
                var i = e[r];
                "subtitles" === i.kind && i.label && t.push(e[r]);
              }
              return t;
            }
            t.default = u;
          },
          "./src/controller/timeline-controller.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "TimelineController", function() {
                return h;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/events.ts"),
              s = r("./src/utils/cea-608-parser.ts"),
              a = r("./src/utils/output-filter.ts"),
              o = r("./src/utils/webvtt-parser.ts"),
              l = r("./src/utils/texttrack-utils.ts"),
              u = r("./src/utils/imsc1-ttml-parser.ts"),
              d = r("./src/types/loader.ts"),
              c = r("./src/utils/logger.ts"),
              h = (function() {
                function e(e) {
                  if (
                    ((this.hls = void 0),
                    (this.media = null),
                    (this.config = void 0),
                    (this.enabled = !0),
                    (this.Cues = void 0),
                    (this.textTracks = []),
                    (this.tracks = []),
                    (this.initPTS = []),
                    (this.timescale = []),
                    (this.unparsedVttFrags = []),
                    (this.captionsTracks = {}),
                    (this.nonNativeCaptionsTracks = {}),
                    (this.cea608Parser1 = void 0),
                    (this.cea608Parser2 = void 0),
                    (this.lastSn = -1),
                    (this.lastPartIndex = -1),
                    (this.prevCC = -1),
                    (this.vttCCs = { ccOffset: 0, presentationOffset: 0, 0: { start: 0, prevCC: -1, new: !1 } }),
                    (this.captionsProperties = void 0),
                    (this.hls = e),
                    (this.config = e.config),
                    (this.Cues = e.config.cueHandler),
                    (this.captionsProperties = {
                      textTrack1: {
                        label: this.config.captionsTextTrack1Label,
                        languageCode: this.config.captionsTextTrack1LanguageCode
                      },
                      textTrack2: {
                        label: this.config.captionsTextTrack2Label,
                        languageCode: this.config.captionsTextTrack2LanguageCode
                      },
                      textTrack3: {
                        label: this.config.captionsTextTrack3Label,
                        languageCode: this.config.captionsTextTrack3LanguageCode
                      },
                      textTrack4: {
                        label: this.config.captionsTextTrack4Label,
                        languageCode: this.config.captionsTextTrack4LanguageCode
                      }
                    }),
                    this.config.enableCEA708Captions)
                  ) {
                    var t = new a.default(this, "textTrack1"),
                      r = new a.default(this, "textTrack2"),
                      i = new a.default(this, "textTrack3"),
                      o = new a.default(this, "textTrack4");
                    (this.cea608Parser1 = new s.default(1, t, r)), (this.cea608Parser2 = new s.default(3, i, o));
                  }
                  e.on(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                    e.on(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                    e.on(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                    e.on(n.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                    e.on(n.Events.FRAG_LOADING, this.onFragLoading, this),
                    e.on(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                    e.on(n.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this),
                    e.on(n.Events.FRAG_DECRYPTED, this.onFragDecrypted, this),
                    e.on(n.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                    e.on(n.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this),
                    e.on(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    var e = this.hls;
                    e.off(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                      e.off(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      e.off(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      e.off(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                      e.off(n.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                      e.off(n.Events.FRAG_LOADING, this.onFragLoading, this),
                      e.off(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                      e.off(n.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this),
                      e.off(n.Events.FRAG_DECRYPTED, this.onFragDecrypted, this),
                      e.off(n.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                      e.off(n.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this),
                      e.off(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this),
                      (this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null);
                  }),
                  (t.addCues = function(e, t, r, i, s) {
                    for (var a, o, l, u, d = !1, c = s.length; c--; ) {
                      var h = s[c],
                        f = ((a = h[0]), (o = h[1]), (l = t), (u = r), Math.min(o, u) - Math.max(a, l));
                      if (
                        f >= 0 &&
                        ((h[0] = Math.min(h[0], t)), (h[1] = Math.max(h[1], r)), (d = !0), f / (r - t) > 0.5)
                      )
                        return;
                    }
                    if ((d || s.push([t, r]), this.config.renderTextTracksNatively)) {
                      var p = this.captionsTracks[e];
                      this.Cues.newCue(p, t, r, i);
                    } else {
                      var v = this.Cues.newCue(null, t, r, i);
                      this.hls.trigger(n.Events.CUES_PARSED, { type: "captions", cues: v, track: e });
                    }
                  }),
                  (t.onInitPtsFound = function(e, t) {
                    var r = this,
                      i = t.frag,
                      s = t.id,
                      a = t.initPTS,
                      o = t.timescale,
                      l = this.unparsedVttFrags;
                    "main" === s && ((this.initPTS[i.cc] = a), (this.timescale[i.cc] = o)),
                      l.length &&
                        ((this.unparsedVttFrags = []),
                        l.forEach(function(e) {
                          r.onFragLoaded(n.Events.FRAG_LOADED, e);
                        }));
                  }),
                  (t.getExistingTrack = function(e) {
                    var t = this.media;
                    if (t)
                      for (var r = 0; r < t.textTracks.length; r++) {
                        var i = t.textTracks[r];
                        if (i[e]) return i;
                      }
                    return null;
                  }),
                  (t.createCaptionsTrack = function(e) {
                    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
                  }),
                  (t.createNativeTrack = function(e) {
                    if (!this.captionsTracks[e]) {
                      var t = this.captionsProperties,
                        r = this.captionsTracks,
                        i = this.media,
                        n = t[e],
                        s = n.label,
                        a = n.languageCode,
                        o = this.getExistingTrack(e);
                      if (o) (r[e] = o), Object(l.clearCurrentCues)(r[e]), Object(l.sendAddTrackEvent)(r[e], i);
                      else {
                        var u = this.createTextTrack("captions", s, a);
                        u && ((u[e] = !0), (r[e] = u));
                      }
                    }
                  }),
                  (t.createNonNativeTrack = function(e) {
                    if (!this.nonNativeCaptionsTracks[e]) {
                      var t = this.captionsProperties[e];
                      if (t) {
                        var r = {
                          _id: e,
                          label: t.label,
                          kind: "captions",
                          default: !!t.media && !!t.media.default,
                          closedCaptions: t.media
                        };
                        (this.nonNativeCaptionsTracks[e] = r),
                          this.hls.trigger(n.Events.NON_NATIVE_TEXT_TRACKS_FOUND, { tracks: [r] });
                      }
                    }
                  }),
                  (t.createTextTrack = function(e, t, r) {
                    var i = this.media;
                    if (i) return i.addTextTrack(e, t, r);
                  }),
                  (t.onMediaAttaching = function(e, t) {
                    (this.media = t.media), this._cleanTracks();
                  }),
                  (t.onMediaDetaching = function() {
                    var e = this.captionsTracks;
                    Object.keys(e).forEach(function(t) {
                      Object(l.clearCurrentCues)(e[t]), delete e[t];
                    }),
                      (this.nonNativeCaptionsTracks = {});
                  }),
                  (t.onManifestLoading = function() {
                    (this.lastSn = -1),
                      (this.lastPartIndex = -1),
                      (this.prevCC = -1),
                      (this.vttCCs = { ccOffset: 0, presentationOffset: 0, 0: { start: 0, prevCC: -1, new: !1 } }),
                      this._cleanTracks(),
                      (this.tracks = []),
                      (this.captionsTracks = {}),
                      (this.nonNativeCaptionsTracks = {}),
                      (this.textTracks = []),
                      (this.unparsedVttFrags = this.unparsedVttFrags || []),
                      (this.initPTS = []),
                      (this.timescale = []),
                      this.cea608Parser1 &&
                        this.cea608Parser2 &&
                        (this.cea608Parser1.reset(), this.cea608Parser2.reset());
                  }),
                  (t._cleanTracks = function() {
                    var e = this.media;
                    if (e) {
                      var t = e.textTracks;
                      if (t) for (var r = 0; r < t.length; r++) Object(l.clearCurrentCues)(t[r]);
                    }
                  }),
                  (t.onSubtitleTracksUpdated = function(e, t) {
                    var r = this;
                    this.textTracks = [];
                    var i = t.subtitleTracks || [],
                      s = i.some(function(e) {
                        return e.textCodec === u.IMSC1_CODEC;
                      });
                    if (this.config.enableWebVTT || (s && this.config.enableIMSC1)) {
                      var a = this.tracks && i && this.tracks.length === i.length;
                      if (((this.tracks = i || []), this.config.renderTextTracksNatively)) {
                        var o = this.media ? this.media.textTracks : [];
                        this.tracks.forEach(function(e, t) {
                          var i;
                          if (t < o.length) {
                            for (var n = null, s = 0; s < o.length; s++)
                              if (f(o[s], e)) {
                                n = o[s];
                                break;
                              }
                            n && (i = n);
                          }
                          i
                            ? Object(l.clearCurrentCues)(i)
                            : (i = r.createTextTrack("subtitles", e.name, e.lang)) && (i.mode = "disabled"),
                            i && ((i.groupId = e.groupId), r.textTracks.push(i));
                        });
                      } else if (!a && this.tracks && this.tracks.length) {
                        var d = this.tracks.map(function(e) {
                          return { label: e.name, kind: e.type.toLowerCase(), default: e.default, subtitleTrack: e };
                        });
                        this.hls.trigger(n.Events.NON_NATIVE_TEXT_TRACKS_FOUND, { tracks: d });
                      }
                    }
                  }),
                  (t.onManifestLoaded = function(e, t) {
                    var r = this;
                    this.config.enableCEA708Captions &&
                      t.captions &&
                      t.captions.forEach(function(e) {
                        var t = /(?:CC|SERVICE)([1-4])/.exec(e.instreamId);
                        if (t) {
                          var i = "textTrack" + t[1],
                            n = r.captionsProperties[i];
                          n && ((n.label = e.name), e.lang && (n.languageCode = e.lang), (n.media = e));
                        }
                      });
                  }),
                  (t.onFragLoading = function(e, t) {
                    var r = this.cea608Parser1,
                      i = this.cea608Parser2,
                      n = this.lastSn,
                      s = this.lastPartIndex;
                    if (this.enabled && r && i && t.frag.type === d.PlaylistLevelType.MAIN) {
                      var a,
                        o,
                        l = t.frag.sn,
                        u =
                          null != (a = null == t || null === (o = t.part) || void 0 === o ? void 0 : o.index) ? a : -1;
                      l === n + 1 || (l === n && u === s + 1) || (r.reset(), i.reset()),
                        (this.lastSn = l),
                        (this.lastPartIndex = u);
                    }
                  }),
                  (t.onFragLoaded = function(e, t) {
                    var r = t.frag,
                      s = t.payload,
                      a = this.initPTS,
                      o = this.unparsedVttFrags;
                    if (r.type === d.PlaylistLevelType.SUBTITLE)
                      if (s.byteLength) {
                        if (!Object(i.isFiniteNumber)(a[r.cc]))
                          return (
                            o.push(t),
                            void (
                              a.length &&
                              this.hls.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, {
                                success: !1,
                                frag: r,
                                error: new Error("Missing initial subtitle PTS")
                              })
                            )
                          );
                        var l = r.decryptdata,
                          c = "stats" in t;
                        if (null == l || null == l.key || "AES-128" !== l.method || c) {
                          var h = this.tracks[r.level],
                            f = this.vttCCs;
                          f[r.cc] ||
                            ((f[r.cc] = { start: r.start, prevCC: this.prevCC, new: !0 }), (this.prevCC = r.cc)),
                            h && h.textCodec === u.IMSC1_CODEC ? this._parseIMSC1(r, s) : this._parseVTTs(r, s, f);
                        }
                      } else
                        this.hls.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, {
                          success: !1,
                          frag: r,
                          error: new Error("Empty subtitle payload")
                        });
                  }),
                  (t._parseIMSC1 = function(e, t) {
                    var r = this,
                      i = this.hls;
                    Object(u.parseIMSC1)(
                      t,
                      this.initPTS[e.cc],
                      this.timescale[e.cc],
                      function(t) {
                        r._appendCues(t, e.level),
                          i.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !0, frag: e });
                      },
                      function(t) {
                        c.logger.log("Failed to parse IMSC1: " + t),
                          i.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: e, error: t });
                      }
                    );
                  }),
                  (t._parseVTTs = function(e, t, r) {
                    var i = this,
                      s = this.hls;
                    Object(o.parseWebVTT)(
                      t,
                      this.initPTS[e.cc],
                      this.timescale[e.cc],
                      r,
                      e.cc,
                      e.start,
                      function(t) {
                        i._appendCues(t, e.level),
                          s.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !0, frag: e });
                      },
                      function(r) {
                        i._fallbackToIMSC1(e, t),
                          c.logger.log("Failed to parse VTT cue: " + r),
                          s.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: e, error: r });
                      }
                    );
                  }),
                  (t._fallbackToIMSC1 = function(e, t) {
                    var r = this,
                      i = this.tracks[e.level];
                    i.textCodec ||
                      Object(u.parseIMSC1)(
                        t,
                        this.initPTS[e.cc],
                        this.timescale[e.cc],
                        function() {
                          (i.textCodec = u.IMSC1_CODEC), r._parseIMSC1(e, t);
                        },
                        function() {
                          i.textCodec = "wvtt";
                        }
                      );
                  }),
                  (t._appendCues = function(e, t) {
                    var r = this.hls;
                    if (this.config.renderTextTracksNatively) {
                      var i = this.textTracks[t];
                      if ("disabled" === i.mode) return;
                      e.forEach(function(e) {
                        return Object(l.addCueToTrack)(i, e);
                      });
                    } else {
                      var s = this.tracks[t].default ? "default" : "subtitles" + t;
                      r.trigger(n.Events.CUES_PARSED, { type: "subtitles", cues: e, track: s });
                    }
                  }),
                  (t.onFragDecrypted = function(e, t) {
                    var r = t.frag;
                    if (r.type === d.PlaylistLevelType.SUBTITLE) {
                      if (!Object(i.isFiniteNumber)(this.initPTS[r.cc])) return void this.unparsedVttFrags.push(t);
                      this.onFragLoaded(n.Events.FRAG_LOADED, t);
                    }
                  }),
                  (t.onSubtitleTracksCleared = function() {
                    (this.tracks = []), (this.captionsTracks = {});
                  }),
                  (t.onFragParsingUserdata = function(e, t) {
                    var r = this.cea608Parser1,
                      i = this.cea608Parser2;
                    if (this.enabled && r && i)
                      for (var n = 0; n < t.samples.length; n++) {
                        var s = t.samples[n].bytes;
                        if (s) {
                          var a = this.extractCea608Data(s);
                          r.addData(t.samples[n].pts, a[0]), i.addData(t.samples[n].pts, a[1]);
                        }
                      }
                  }),
                  (t.onBufferFlushing = function(e, t) {
                    var r = t.startOffset,
                      i = t.endOffset,
                      n = t.endOffsetSubtitles,
                      s = t.type,
                      a = this.media;
                    if (a && !(a.currentTime < i)) {
                      if (!s || "video" === s) {
                        var o = this.captionsTracks;
                        Object.keys(o).forEach(function(e) {
                          return Object(l.removeCuesInRange)(o[e], r, i);
                        });
                      }
                      if (this.config.renderTextTracksNatively && 0 === r && void 0 !== n) {
                        var u = this.textTracks;
                        Object.keys(u).forEach(function(e) {
                          return Object(l.removeCuesInRange)(u[e], r, n);
                        });
                      }
                    }
                  }),
                  (t.extractCea608Data = function(e) {
                    for (var t = 31 & e[0], r = 2, i = [[], []], n = 0; n < t; n++) {
                      var s = e[r++],
                        a = 127 & e[r++],
                        o = 127 & e[r++],
                        l = 3 & s;
                      (0 === a && 0 === o) || (0 != (4 & s) && ((0 !== l && 1 !== l) || (i[l].push(a), i[l].push(o))));
                    }
                    return i;
                  }),
                  e
                );
              })();
            function f(e, t) {
              return e && e.label === t.name && !(e.textTrack1 || e.textTrack2);
            }
          },
          "./src/crypt/aes-crypto.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return i;
              });
            var i = (function() {
              function e(e, t) {
                (this.subtle = void 0), (this.aesIV = void 0), (this.subtle = e), (this.aesIV = t);
              }
              return (
                (e.prototype.decrypt = function(e, t) {
                  return this.subtle.decrypt({ name: "AES-CBC", iv: this.aesIV }, t, e);
                }),
                e
              );
            })();
          },
          "./src/crypt/aes-decryptor.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "removePadding", function() {
                return n;
              }),
              r.d(t, "default", function() {
                return s;
              });
            var i = r("./src/utils/typed-array.ts");
            function n(e) {
              var t = e.byteLength,
                r = t && new DataView(e.buffer).getUint8(t - 1);
              return r ? Object(i.sliceUint8)(e, 0, t - r) : e;
            }
            var s = (function() {
              function e() {
                (this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54]),
                  (this.subMix = [
                    new Uint32Array(256),
                    new Uint32Array(256),
                    new Uint32Array(256),
                    new Uint32Array(256)
                  ]),
                  (this.invSubMix = [
                    new Uint32Array(256),
                    new Uint32Array(256),
                    new Uint32Array(256),
                    new Uint32Array(256)
                  ]),
                  (this.sBox = new Uint32Array(256)),
                  (this.invSBox = new Uint32Array(256)),
                  (this.key = new Uint32Array(0)),
                  (this.ksRows = 0),
                  (this.keySize = 0),
                  (this.keySchedule = void 0),
                  (this.invKeySchedule = void 0),
                  this.initTable();
              }
              var t = e.prototype;
              return (
                (t.uint8ArrayToUint32Array_ = function(e) {
                  for (var t = new DataView(e), r = new Uint32Array(4), i = 0; i < 4; i++) r[i] = t.getUint32(4 * i);
                  return r;
                }),
                (t.initTable = function() {
                  var e = this.sBox,
                    t = this.invSBox,
                    r = this.subMix,
                    i = r[0],
                    n = r[1],
                    s = r[2],
                    a = r[3],
                    o = this.invSubMix,
                    l = o[0],
                    u = o[1],
                    d = o[2],
                    c = o[3],
                    h = new Uint32Array(256),
                    f = 0,
                    p = 0,
                    v = 0;
                  for (v = 0; v < 256; v++) h[v] = v < 128 ? v << 1 : (v << 1) ^ 283;
                  for (v = 0; v < 256; v++) {
                    var g = p ^ (p << 1) ^ (p << 2) ^ (p << 3) ^ (p << 4);
                    (g = (g >>> 8) ^ (255 & g) ^ 99), (e[f] = g), (t[g] = f);
                    var m = h[f],
                      y = h[m],
                      E = h[y],
                      T = (257 * h[g]) ^ (16843008 * g);
                    (i[f] = (T << 24) | (T >>> 8)),
                      (n[f] = (T << 16) | (T >>> 16)),
                      (s[f] = (T << 8) | (T >>> 24)),
                      (a[f] = T),
                      (T = (16843009 * E) ^ (65537 * y) ^ (257 * m) ^ (16843008 * f)),
                      (l[g] = (T << 24) | (T >>> 8)),
                      (u[g] = (T << 16) | (T >>> 16)),
                      (d[g] = (T << 8) | (T >>> 24)),
                      (c[g] = T),
                      f ? ((f = m ^ h[h[h[E ^ m]]]), (p ^= h[h[p]])) : (f = p = 1);
                  }
                }),
                (t.expandKey = function(e) {
                  for (var t = this.uint8ArrayToUint32Array_(e), r = !0, i = 0; i < t.length && r; )
                    (r = t[i] === this.key[i]), i++;
                  if (!r) {
                    this.key = t;
                    var n = (this.keySize = t.length);
                    if (4 !== n && 6 !== n && 8 !== n) throw new Error("Invalid aes key size=" + n);
                    var s,
                      a,
                      o,
                      l,
                      u = (this.ksRows = 4 * (n + 6 + 1)),
                      d = (this.keySchedule = new Uint32Array(u)),
                      c = (this.invKeySchedule = new Uint32Array(u)),
                      h = this.sBox,
                      f = this.rcon,
                      p = this.invSubMix,
                      v = p[0],
                      g = p[1],
                      m = p[2],
                      y = p[3];
                    for (s = 0; s < u; s++)
                      s < n
                        ? (o = d[s] = t[s])
                        : ((l = o),
                          s % n == 0
                            ? ((l =
                                (h[(l = (l << 8) | (l >>> 24)) >>> 24] << 24) |
                                (h[(l >>> 16) & 255] << 16) |
                                (h[(l >>> 8) & 255] << 8) |
                                h[255 & l]),
                              (l ^= f[(s / n) | 0] << 24))
                            : n > 6 &&
                              s % n == 4 &&
                              (l =
                                (h[l >>> 24] << 24) |
                                (h[(l >>> 16) & 255] << 16) |
                                (h[(l >>> 8) & 255] << 8) |
                                h[255 & l]),
                          (d[s] = o = (d[s - n] ^ l) >>> 0));
                    for (a = 0; a < u; a++)
                      (s = u - a),
                        (l = 3 & a ? d[s] : d[s - 4]),
                        (c[a] =
                          a < 4 || s <= 4
                            ? l
                            : v[h[l >>> 24]] ^ g[h[(l >>> 16) & 255]] ^ m[h[(l >>> 8) & 255]] ^ y[h[255 & l]]),
                        (c[a] = c[a] >>> 0);
                  }
                }),
                (t.networkToHostOrderSwap = function(e) {
                  return (e << 24) | ((65280 & e) << 8) | ((16711680 & e) >> 8) | (e >>> 24);
                }),
                (t.decrypt = function(e, t, r) {
                  for (
                    var i,
                      n,
                      s,
                      a,
                      o,
                      l,
                      u,
                      d,
                      c,
                      h,
                      f,
                      p,
                      v,
                      g,
                      m = this.keySize + 6,
                      y = this.invKeySchedule,
                      E = this.invSBox,
                      T = this.invSubMix,
                      b = T[0],
                      S = T[1],
                      k = T[2],
                      A = T[3],
                      w = this.uint8ArrayToUint32Array_(r),
                      R = w[0],
                      C = w[1],
                      L = w[2],
                      D = w[3],
                      _ = new Int32Array(e),
                      I = new Int32Array(_.length),
                      x = this.networkToHostOrderSwap;
                    t < _.length;

                  ) {
                    for (
                      c = x(_[t]),
                        h = x(_[t + 1]),
                        f = x(_[t + 2]),
                        p = x(_[t + 3]),
                        o = c ^ y[0],
                        l = p ^ y[1],
                        u = f ^ y[2],
                        d = h ^ y[3],
                        v = 4,
                        g = 1;
                      g < m;
                      g++
                    )
                      (i = b[o >>> 24] ^ S[(l >> 16) & 255] ^ k[(u >> 8) & 255] ^ A[255 & d] ^ y[v]),
                        (n = b[l >>> 24] ^ S[(u >> 16) & 255] ^ k[(d >> 8) & 255] ^ A[255 & o] ^ y[v + 1]),
                        (s = b[u >>> 24] ^ S[(d >> 16) & 255] ^ k[(o >> 8) & 255] ^ A[255 & l] ^ y[v + 2]),
                        (a = b[d >>> 24] ^ S[(o >> 16) & 255] ^ k[(l >> 8) & 255] ^ A[255 & u] ^ y[v + 3]),
                        (o = i),
                        (l = n),
                        (u = s),
                        (d = a),
                        (v += 4);
                    (i =
                      (E[o >>> 24] << 24) ^ (E[(l >> 16) & 255] << 16) ^ (E[(u >> 8) & 255] << 8) ^ E[255 & d] ^ y[v]),
                      (n =
                        (E[l >>> 24] << 24) ^
                        (E[(u >> 16) & 255] << 16) ^
                        (E[(d >> 8) & 255] << 8) ^
                        E[255 & o] ^
                        y[v + 1]),
                      (s =
                        (E[u >>> 24] << 24) ^
                        (E[(d >> 16) & 255] << 16) ^
                        (E[(o >> 8) & 255] << 8) ^
                        E[255 & l] ^
                        y[v + 2]),
                      (a =
                        (E[d >>> 24] << 24) ^
                        (E[(o >> 16) & 255] << 16) ^
                        (E[(l >> 8) & 255] << 8) ^
                        E[255 & u] ^
                        y[v + 3]),
                      (I[t] = x(i ^ R)),
                      (I[t + 1] = x(a ^ C)),
                      (I[t + 2] = x(s ^ L)),
                      (I[t + 3] = x(n ^ D)),
                      (R = c),
                      (C = h),
                      (L = f),
                      (D = p),
                      (t += 4);
                  }
                  return I.buffer;
                }),
                e
              );
            })();
          },
          "./src/crypt/decrypter.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return u;
              });
            var i = r("./src/crypt/aes-crypto.ts"),
              n = r("./src/crypt/fast-aes-key.ts"),
              s = r("./src/crypt/aes-decryptor.ts"),
              a = r("./src/utils/logger.ts"),
              o = r("./src/utils/mp4-tools.ts"),
              l = r("./src/utils/typed-array.ts"),
              u = (function() {
                function e(e, t, r) {
                  var i = (void 0 === r ? {} : r).removePKCS7Padding,
                    n = void 0 === i || i;
                  if (
                    ((this.logEnabled = !0),
                    (this.observer = void 0),
                    (this.config = void 0),
                    (this.removePKCS7Padding = void 0),
                    (this.subtle = null),
                    (this.softwareDecrypter = null),
                    (this.key = null),
                    (this.fastAesKey = null),
                    (this.remainderData = null),
                    (this.currentIV = null),
                    (this.currentResult = null),
                    (this.observer = e),
                    (this.config = t),
                    (this.removePKCS7Padding = n),
                    n)
                  )
                    try {
                      var s = self.crypto;
                      s && (this.subtle = s.subtle || s.webkitSubtle);
                    } catch (e) {}
                  null === this.subtle && (this.config.enableSoftwareAES = !0);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    this.observer = null;
                  }),
                  (t.isSync = function() {
                    return this.config.enableSoftwareAES;
                  }),
                  (t.flush = function() {
                    var e = this.currentResult;
                    if (e) {
                      var t = new Uint8Array(e);
                      return this.reset(), this.removePKCS7Padding ? Object(s.removePadding)(t) : t;
                    }
                    this.reset();
                  }),
                  (t.reset = function() {
                    (this.currentResult = null),
                      (this.currentIV = null),
                      (this.remainderData = null),
                      this.softwareDecrypter && (this.softwareDecrypter = null);
                  }),
                  (t.decrypt = function(e, t, r, i) {
                    if (this.config.enableSoftwareAES) {
                      this.softwareDecrypt(new Uint8Array(e), t, r);
                      var n = this.flush();
                      n && i(n.buffer);
                    } else this.webCryptoDecrypt(new Uint8Array(e), t, r).then(i);
                  }),
                  (t.softwareDecrypt = function(e, t, r) {
                    var i = this.currentIV,
                      n = this.currentResult,
                      a = this.remainderData;
                    this.logOnce("JS AES decrypt"),
                      a && ((e = Object(o.appendUint8Array)(a, e)), (this.remainderData = null));
                    var u = this.getValidChunk(e);
                    if (!u.length) return null;
                    i && (r = i);
                    var d = this.softwareDecrypter;
                    d || (d = this.softwareDecrypter = new s.default()), d.expandKey(t);
                    var c = n;
                    return (
                      (this.currentResult = d.decrypt(u.buffer, 0, r)),
                      (this.currentIV = Object(l.sliceUint8)(u, -16).buffer),
                      c || null
                    );
                  }),
                  (t.webCryptoDecrypt = function(e, t, r) {
                    var s = this,
                      a = this.subtle;
                    return (
                      (this.key === t && this.fastAesKey) || ((this.key = t), (this.fastAesKey = new n.default(a, t))),
                      this.fastAesKey
                        .expandKey()
                        .then(function(t) {
                          return a
                            ? new i.default(a, r).decrypt(e.buffer, t)
                            : Promise.reject(new Error("web crypto not initialized"));
                        })
                        .catch(function(i) {
                          return s.onWebCryptoError(i, e, t, r);
                        })
                    );
                  }),
                  (t.onWebCryptoError = function(e, t, r, i) {
                    return (
                      a.logger.warn("[decrypter.ts]: WebCrypto Error, disable WebCrypto API:", e),
                      (this.config.enableSoftwareAES = !0),
                      (this.logEnabled = !0),
                      this.softwareDecrypt(t, r, i)
                    );
                  }),
                  (t.getValidChunk = function(e) {
                    var t = e,
                      r = e.length - (e.length % 16);
                    return (
                      r !== e.length &&
                        ((t = Object(l.sliceUint8)(e, 0, r)), (this.remainderData = Object(l.sliceUint8)(e, r))),
                      t
                    );
                  }),
                  (t.logOnce = function(e) {
                    this.logEnabled && (a.logger.log("[decrypter.ts]: " + e), (this.logEnabled = !1));
                  }),
                  e
                );
              })();
          },
          "./src/crypt/fast-aes-key.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return i;
              });
            var i = (function() {
              function e(e, t) {
                (this.subtle = void 0), (this.key = void 0), (this.subtle = e), (this.key = t);
              }
              return (
                (e.prototype.expandKey = function() {
                  return this.subtle.importKey("raw", this.key, { name: "AES-CBC" }, !1, ["encrypt", "decrypt"]);
                }),
                e
              );
            })();
          },
          "./src/demux/aacdemuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/demux/base-audio-demuxer.ts"),
              n = r("./src/demux/adts.ts"),
              s = r("./src/utils/logger.ts"),
              a = r("./src/demux/id3.ts");
            function o(e, t) {
              return (o =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var l = (function(e) {
              var t, r;
              function i(t, r) {
                var i;
                return (
                  ((i = e.call(this) || this).observer = void 0),
                  (i.config = void 0),
                  (i.observer = t),
                  (i.config = r),
                  i
                );
              }
              (r = e), ((t = i).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), o(t, r);
              var l = i.prototype;
              return (
                (l.resetInitSegment = function(t, r, i) {
                  e.prototype.resetInitSegment.call(this, t, r, i),
                    (this._audioTrack = {
                      container: "audio/adts",
                      type: "audio",
                      id: 2,
                      pid: -1,
                      sequenceNumber: 0,
                      isAAC: !0,
                      samples: [],
                      manifestCodec: t,
                      duration: i,
                      inputTimeScale: 9e4,
                      dropped: 0
                    });
                }),
                (i.probe = function(e) {
                  if (!e) return !1;
                  for (var t = (a.getID3Data(e, 0) || []).length, r = e.length; t < r; t++)
                    if (n.probe(e, t)) return s.logger.log("ADTS sync word found !"), !0;
                  return !1;
                }),
                (l.canParse = function(e, t) {
                  return n.canParse(e, t);
                }),
                (l.appendFrame = function(e, t, r) {
                  n.initTrackConfig(e, this.observer, t, r, e.manifestCodec);
                  var i = n.appendFrame(e, t, r, this.initPTS, this.frameIndex);
                  if (i && 0 === i.missing) return i;
                }),
                i
              );
            })(i.default);
            (l.minProbeByteLength = 9), (t.default = l);
          },
          "./src/demux/adts.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "getAudioConfig", function() {
                return a;
              }),
              r.d(t, "isHeaderPattern", function() {
                return o;
              }),
              r.d(t, "getHeaderLength", function() {
                return l;
              }),
              r.d(t, "getFullFrameLength", function() {
                return u;
              }),
              r.d(t, "canGetFrameLength", function() {
                return d;
              }),
              r.d(t, "isHeader", function() {
                return c;
              }),
              r.d(t, "canParse", function() {
                return h;
              }),
              r.d(t, "probe", function() {
                return f;
              }),
              r.d(t, "initTrackConfig", function() {
                return p;
              }),
              r.d(t, "getFrameDuration", function() {
                return v;
              }),
              r.d(t, "parseFrameHeader", function() {
                return g;
              }),
              r.d(t, "appendFrame", function() {
                return m;
              });
            var i = r("./src/utils/logger.ts"),
              n = r("./src/errors.ts"),
              s = r("./src/events.ts");
            function a(e, t, r, a) {
              var o,
                l,
                u,
                d,
                c = navigator.userAgent.toLowerCase(),
                h = a,
                f = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
              o = 1 + ((192 & t[r + 2]) >>> 6);
              var p = (60 & t[r + 2]) >>> 2;
              if (!(p > f.length - 1))
                return (
                  (u = (1 & t[r + 2]) << 2),
                  (u |= (192 & t[r + 3]) >>> 6),
                  i.logger.log("manifest codec:" + a + ", ADTS type:" + o + ", samplingIndex:" + p),
                  /firefox/i.test(c)
                    ? p >= 6
                      ? ((o = 5), (d = new Array(4)), (l = p - 3))
                      : ((o = 2), (d = new Array(2)), (l = p))
                    : -1 !== c.indexOf("android")
                      ? ((o = 2), (d = new Array(2)), (l = p))
                      : ((o = 5),
                        (d = new Array(4)),
                        (a && (-1 !== a.indexOf("mp4a.40.29") || -1 !== a.indexOf("mp4a.40.5"))) || (!a && p >= 6)
                          ? (l = p - 3)
                          : (((a && -1 !== a.indexOf("mp4a.40.2") && ((p >= 6 && 1 === u) || /vivaldi/i.test(c))) ||
                              (!a && 1 === u)) &&
                              ((o = 2), (d = new Array(2))),
                            (l = p))),
                  (d[0] = o << 3),
                  (d[0] |= (14 & p) >> 1),
                  (d[1] |= (1 & p) << 7),
                  (d[1] |= u << 3),
                  5 === o && ((d[1] |= (14 & l) >> 1), (d[2] = (1 & l) << 7), (d[2] |= 8), (d[3] = 0)),
                  { config: d, samplerate: f[p], channelCount: u, codec: "mp4a.40." + o, manifestCodec: h }
                );
              e.trigger(s.Events.ERROR, {
                type: n.ErrorTypes.MEDIA_ERROR,
                details: n.ErrorDetails.FRAG_PARSING_ERROR,
                fatal: !0,
                reason: "invalid ADTS sampling index:" + p
              });
            }
            function o(e, t) {
              return 255 === e[t] && 240 == (246 & e[t + 1]);
            }
            function l(e, t) {
              return 1 & e[t + 1] ? 7 : 9;
            }
            function u(e, t) {
              return ((3 & e[t + 3]) << 11) | (e[t + 4] << 3) | ((224 & e[t + 5]) >>> 5);
            }
            function d(e, t) {
              return t + 5 < e.length;
            }
            function c(e, t) {
              return t + 1 < e.length && o(e, t);
            }
            function h(e, t) {
              return d(e, t) && o(e, t) && u(e, t) <= e.length - t;
            }
            function f(e, t) {
              if (c(e, t)) {
                var r = l(e, t);
                if (t + r >= e.length) return !1;
                var i = u(e, t);
                if (i <= r) return !1;
                var n = t + i;
                return n === e.length || c(e, n);
              }
              return !1;
            }
            function p(e, t, r, n, s) {
              if (!e.samplerate) {
                var o = a(t, r, n, s);
                if (!o) return;
                (e.config = o.config),
                  (e.samplerate = o.samplerate),
                  (e.channelCount = o.channelCount),
                  (e.codec = o.codec),
                  (e.manifestCodec = o.manifestCodec),
                  i.logger.log("parsed codec:" + e.codec + ", rate:" + o.samplerate + ", channels:" + o.channelCount);
              }
            }
            function v(e) {
              return 9216e4 / e;
            }
            function g(e, t, r, i, n) {
              var s = l(e, t),
                a = u(e, t);
              if ((a -= s) > 0) return { headerLength: s, frameLength: a, stamp: r + i * n };
            }
            function m(e, t, r, i, n) {
              var s = g(t, r, i, n, v(e.samplerate));
              if (s) {
                var a,
                  o = s.frameLength,
                  l = s.headerLength,
                  u = s.stamp,
                  d = l + o,
                  c = Math.max(0, r + d - t.length);
                c ? (a = new Uint8Array(d - l)).set(t.subarray(r + l, t.length), 0) : (a = t.subarray(r + l, r + d));
                var h = { unit: a, pts: u };
                return c || e.samples.push(h), { sample: h, length: d, missing: c };
              }
            }
          },
          "./src/demux/base-audio-demuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "initPTSFn", function() {
                return u;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/demux/id3.ts"),
              s = r("./src/demux/dummy-demuxed-track.ts"),
              a = r("./src/utils/mp4-tools.ts"),
              o = r("./src/utils/typed-array.ts"),
              l = (function() {
                function e() {
                  (this._audioTrack = void 0),
                    (this._id3Track = void 0),
                    (this.frameIndex = 0),
                    (this.cachedData = null),
                    (this.initPTS = null);
                }
                var t = e.prototype;
                return (
                  (t.resetInitSegment = function(e, t, r) {
                    this._id3Track = {
                      type: "id3",
                      id: 3,
                      pid: -1,
                      inputTimeScale: 9e4,
                      sequenceNumber: 0,
                      samples: [],
                      dropped: 0
                    };
                  }),
                  (t.resetTimeStamp = function() {}),
                  (t.resetContiguity = function() {}),
                  (t.canParse = function(e, t) {
                    return !1;
                  }),
                  (t.appendFrame = function(e, t, r) {}),
                  (t.demux = function(e, t) {
                    this.cachedData && ((e = Object(a.appendUint8Array)(this.cachedData, e)), (this.cachedData = null));
                    var r,
                      i,
                      l = n.getID3Data(e, 0),
                      d = l ? l.length : 0,
                      c = this._audioTrack,
                      h = this._id3Track,
                      f = l ? n.getTimeStamp(l) : void 0,
                      p = e.length;
                    for (
                      (0 !== this.frameIndex && null !== this.initPTS) || (this.initPTS = u(f, t)),
                        l && l.length > 0 && h.samples.push({ pts: this.initPTS, dts: this.initPTS, data: l }),
                        i = this.initPTS;
                      d < p;

                    ) {
                      if (this.canParse(e, d)) {
                        var v = this.appendFrame(c, e, d);
                        v ? (this.frameIndex++, (i = v.sample.pts), (r = d += v.length)) : (d = p);
                      } else
                        n.canParse(e, d)
                          ? ((l = n.getID3Data(e, d)), h.samples.push({ pts: i, dts: i, data: l }), (r = d += l.length))
                          : d++;
                      if (d === p && r !== p) {
                        var g = Object(o.sliceUint8)(e, r);
                        this.cachedData
                          ? (this.cachedData = Object(a.appendUint8Array)(this.cachedData, g))
                          : (this.cachedData = g);
                      }
                    }
                    return {
                      audioTrack: c,
                      avcTrack: Object(s.dummyTrack)(),
                      id3Track: h,
                      textTrack: Object(s.dummyTrack)()
                    };
                  }),
                  (t.demuxSampleAes = function(e, t, r) {
                    return Promise.reject(
                      new Error("[" + this + "] This demuxer does not support Sample-AES decryption")
                    );
                  }),
                  (t.flush = function(e) {
                    var t = this.cachedData;
                    return (
                      t && ((this.cachedData = null), this.demux(t, 0)),
                      (this.frameIndex = 0),
                      {
                        audioTrack: this._audioTrack,
                        avcTrack: Object(s.dummyTrack)(),
                        id3Track: this._id3Track,
                        textTrack: Object(s.dummyTrack)()
                      }
                    );
                  }),
                  (t.destroy = function() {}),
                  e
                );
              })(),
              u = function(e, t) {
                return Object(i.isFiniteNumber)(e) ? 90 * e : 9e4 * t;
              };
            t.default = l;
          },
          "./src/demux/chunk-cache.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return i;
              });
            var i = (function() {
              function e() {
                (this.chunks = []), (this.dataLength = 0);
              }
              var t = e.prototype;
              return (
                (t.push = function(e) {
                  this.chunks.push(e), (this.dataLength += e.length);
                }),
                (t.flush = function() {
                  var e,
                    t = this.chunks,
                    r = this.dataLength;
                  return t.length
                    ? ((e =
                        1 === t.length
                          ? t[0]
                          : (function(e, t) {
                              for (var r = new Uint8Array(t), i = 0, n = 0; n < e.length; n++) {
                                var s = e[n];
                                r.set(s, i), (i += s.length);
                              }
                              return r;
                            })(t, r)),
                      this.reset(),
                      e)
                    : new Uint8Array(0);
                }),
                (t.reset = function() {
                  (this.chunks.length = 0), (this.dataLength = 0);
                }),
                e
              );
            })();
          },
          "./src/demux/dummy-demuxed-track.ts": function(e, t, r) {
            "use strict";
            function i() {
              return { type: "", id: -1, pid: -1, inputTimeScale: 9e4, sequenceNumber: -1, samples: [], dropped: 0 };
            }
            r.r(t),
              r.d(t, "dummyTrack", function() {
                return i;
              });
          },
          "./src/demux/exp-golomb.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/utils/logger.ts"),
              n = (function() {
                function e(e) {
                  (this.data = void 0),
                    (this.bytesAvailable = void 0),
                    (this.word = void 0),
                    (this.bitsAvailable = void 0),
                    (this.data = e),
                    (this.bytesAvailable = e.byteLength),
                    (this.word = 0),
                    (this.bitsAvailable = 0);
                }
                var t = e.prototype;
                return (
                  (t.loadWord = function() {
                    var e = this.data,
                      t = this.bytesAvailable,
                      r = e.byteLength - t,
                      i = new Uint8Array(4),
                      n = Math.min(4, t);
                    if (0 === n) throw new Error("no bytes available");
                    i.set(e.subarray(r, r + n)),
                      (this.word = new DataView(i.buffer).getUint32(0)),
                      (this.bitsAvailable = 8 * n),
                      (this.bytesAvailable -= n);
                  }),
                  (t.skipBits = function(e) {
                    var t;
                    this.bitsAvailable > e
                      ? ((this.word <<= e), (this.bitsAvailable -= e))
                      : ((e -= this.bitsAvailable),
                        (e -= (t = e >> 3) >> 3),
                        (this.bytesAvailable -= t),
                        this.loadWord(),
                        (this.word <<= e),
                        (this.bitsAvailable -= e));
                  }),
                  (t.readBits = function(e) {
                    var t = Math.min(this.bitsAvailable, e),
                      r = this.word >>> (32 - t);
                    return (
                      e > 32 && i.logger.error("Cannot read more than 32 bits at a time"),
                      (this.bitsAvailable -= t),
                      this.bitsAvailable > 0 ? (this.word <<= t) : this.bytesAvailable > 0 && this.loadWord(),
                      (t = e - t) > 0 && this.bitsAvailable ? (r << t) | this.readBits(t) : r
                    );
                  }),
                  (t.skipLZ = function() {
                    var e;
                    for (e = 0; e < this.bitsAvailable; ++e)
                      if (0 != (this.word & (2147483648 >>> e))) return (this.word <<= e), (this.bitsAvailable -= e), e;
                    return this.loadWord(), e + this.skipLZ();
                  }),
                  (t.skipUEG = function() {
                    this.skipBits(1 + this.skipLZ());
                  }),
                  (t.skipEG = function() {
                    this.skipBits(1 + this.skipLZ());
                  }),
                  (t.readUEG = function() {
                    var e = this.skipLZ();
                    return this.readBits(e + 1) - 1;
                  }),
                  (t.readEG = function() {
                    var e = this.readUEG();
                    return 1 & e ? (1 + e) >>> 1 : -1 * (e >>> 1);
                  }),
                  (t.readBoolean = function() {
                    return 1 === this.readBits(1);
                  }),
                  (t.readUByte = function() {
                    return this.readBits(8);
                  }),
                  (t.readUShort = function() {
                    return this.readBits(16);
                  }),
                  (t.readUInt = function() {
                    return this.readBits(32);
                  }),
                  (t.skipScalingList = function(e) {
                    for (var t = 8, r = 8, i = 0; i < e; i++)
                      0 !== r && (r = (t + this.readEG() + 256) % 256), (t = 0 === r ? t : r);
                  }),
                  (t.readSPS = function() {
                    var e,
                      t,
                      r,
                      i = 0,
                      n = 0,
                      s = 0,
                      a = 0,
                      o = this.readUByte.bind(this),
                      l = this.readBits.bind(this),
                      u = this.readUEG.bind(this),
                      d = this.readBoolean.bind(this),
                      c = this.skipBits.bind(this),
                      h = this.skipEG.bind(this),
                      f = this.skipUEG.bind(this),
                      p = this.skipScalingList.bind(this);
                    o();
                    var v = o();
                    if (
                      (l(5),
                      c(3),
                      o(),
                      f(),
                      100 === v ||
                        110 === v ||
                        122 === v ||
                        244 === v ||
                        44 === v ||
                        83 === v ||
                        86 === v ||
                        118 === v ||
                        128 === v)
                    ) {
                      var g = u();
                      if ((3 === g && c(1), f(), f(), c(1), d()))
                        for (t = 3 !== g ? 8 : 12, r = 0; r < t; r++) d() && p(r < 6 ? 16 : 64);
                    }
                    f();
                    var m = u();
                    if (0 === m) u();
                    else if (1 === m) for (c(1), h(), h(), e = u(), r = 0; r < e; r++) h();
                    f(), c(1);
                    var y = u(),
                      E = u(),
                      T = l(1);
                    0 === T && c(1), c(1), d() && ((i = u()), (n = u()), (s = u()), (a = u()));
                    var b = [1, 1];
                    if (d() && d())
                      switch (o()) {
                        case 1:
                          b = [1, 1];
                          break;
                        case 2:
                          b = [12, 11];
                          break;
                        case 3:
                          b = [10, 11];
                          break;
                        case 4:
                          b = [16, 11];
                          break;
                        case 5:
                          b = [40, 33];
                          break;
                        case 6:
                          b = [24, 11];
                          break;
                        case 7:
                          b = [20, 11];
                          break;
                        case 8:
                          b = [32, 11];
                          break;
                        case 9:
                          b = [80, 33];
                          break;
                        case 10:
                          b = [18, 11];
                          break;
                        case 11:
                          b = [15, 11];
                          break;
                        case 12:
                          b = [64, 33];
                          break;
                        case 13:
                          b = [160, 99];
                          break;
                        case 14:
                          b = [4, 3];
                          break;
                        case 15:
                          b = [3, 2];
                          break;
                        case 16:
                          b = [2, 1];
                          break;
                        case 255:
                          b = [(o() << 8) | o(), (o() << 8) | o()];
                      }
                    return {
                      width: Math.ceil(16 * (y + 1) - 2 * i - 2 * n),
                      height: (2 - T) * (E + 1) * 16 - (T ? 2 : 4) * (s + a),
                      pixelRatio: b
                    };
                  }),
                  (t.readSliceType = function() {
                    return this.readUByte(), this.readUEG(), this.readUEG();
                  }),
                  e
                );
              })();
            t.default = n;
          },
          "./src/demux/id3.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "isHeader", function() {
                return n;
              }),
              r.d(t, "isFooter", function() {
                return s;
              }),
              r.d(t, "getID3Data", function() {
                return a;
              }),
              r.d(t, "canParse", function() {
                return l;
              }),
              r.d(t, "getTimeStamp", function() {
                return u;
              }),
              r.d(t, "isTimeStampFrame", function() {
                return d;
              }),
              r.d(t, "getID3Frames", function() {
                return h;
              }),
              r.d(t, "decodeFrame", function() {
                return f;
              }),
              r.d(t, "utf8ArrayToStr", function() {
                return y;
              }),
              r.d(t, "testables", function() {
                return E;
              });
            var i,
              n = function(e, t) {
                return (
                  t + 10 <= e.length &&
                  73 === e[t] &&
                  68 === e[t + 1] &&
                  51 === e[t + 2] &&
                  e[t + 3] < 255 &&
                  e[t + 4] < 255 &&
                  e[t + 6] < 128 &&
                  e[t + 7] < 128 &&
                  e[t + 8] < 128 &&
                  e[t + 9] < 128
                );
              },
              s = function(e, t) {
                return (
                  t + 10 <= e.length &&
                  51 === e[t] &&
                  68 === e[t + 1] &&
                  73 === e[t + 2] &&
                  e[t + 3] < 255 &&
                  e[t + 4] < 255 &&
                  e[t + 6] < 128 &&
                  e[t + 7] < 128 &&
                  e[t + 8] < 128 &&
                  e[t + 9] < 128
                );
              },
              a = function(e, t) {
                for (var r = t, i = 0; n(e, t); ) (i += 10), (i += o(e, t + 6)), s(e, t + 10) && (i += 10), (t += i);
                if (i > 0) return e.subarray(r, r + i);
              },
              o = function(e, t) {
                var r = 0;
                return (
                  (r = (127 & e[t]) << 21),
                  (r |= (127 & e[t + 1]) << 14),
                  (r |= (127 & e[t + 2]) << 7),
                  (r |= 127 & e[t + 3])
                );
              },
              l = function(e, t) {
                return n(e, t) && o(e, t + 6) + 10 <= e.length - t;
              },
              u = function(e) {
                for (var t = h(e), r = 0; r < t.length; r++) {
                  var i = t[r];
                  if (d(i)) return m(i);
                }
              },
              d = function(e) {
                return e && "PRIV" === e.key && "com.apple.streaming.transportStreamTimestamp" === e.info;
              },
              c = function(e) {
                var t = String.fromCharCode(e[0], e[1], e[2], e[3]),
                  r = o(e, 4);
                return { type: t, size: r, data: e.subarray(10, 10 + r) };
              },
              h = function(e) {
                for (var t = 0, r = []; n(e, t); ) {
                  for (var i = o(e, t + 6), a = (t += 10) + i; t + 8 < a; ) {
                    var l = c(e.subarray(t)),
                      u = f(l);
                    u && r.push(u), (t += l.size + 10);
                  }
                  s(e, t) && (t += 10);
                }
                return r;
              },
              f = function(e) {
                return "PRIV" === e.type ? p(e) : "W" === e.type[0] ? g(e) : v(e);
              },
              p = function(e) {
                if (!(e.size < 2)) {
                  var t = y(e.data, !0),
                    r = new Uint8Array(e.data.subarray(t.length + 1));
                  return { key: e.type, info: t, data: r.buffer };
                }
              },
              v = function(e) {
                if (!(e.size < 2)) {
                  if ("TXXX" === e.type) {
                    var t = 1,
                      r = y(e.data.subarray(t), !0);
                    t += r.length + 1;
                    var i = y(e.data.subarray(t));
                    return { key: e.type, info: r, data: i };
                  }
                  var n = y(e.data.subarray(1));
                  return { key: e.type, data: n };
                }
              },
              g = function(e) {
                if ("WXXX" === e.type) {
                  if (e.size < 2) return;
                  var t = 1,
                    r = y(e.data.subarray(t), !0);
                  t += r.length + 1;
                  var i = y(e.data.subarray(t));
                  return { key: e.type, info: r, data: i };
                }
                var n = y(e.data);
                return { key: e.type, data: n };
              },
              m = function(e) {
                if (8 === e.data.byteLength) {
                  var t = new Uint8Array(e.data),
                    r = 1 & t[3],
                    i = (t[4] << 23) + (t[5] << 15) + (t[6] << 7) + t[7];
                  return (i /= 45), r && (i += 47721858.84), Math.round(i);
                }
              },
              y = function(e, t) {
                void 0 === t && (t = !1);
                var r = T();
                if (r) {
                  var i = r.decode(e);
                  if (t) {
                    var n = i.indexOf("\0");
                    return -1 !== n ? i.substring(0, n) : i;
                  }
                  return i.replace(/\0/g, "");
                }
                for (var s, a, o, l = e.length, u = "", d = 0; d < l; ) {
                  if (0 === (s = e[d++]) && t) return u;
                  if (0 !== s && 3 !== s)
                    switch (s >> 4) {
                      case 0:
                      case 1:
                      case 2:
                      case 3:
                      case 4:
                      case 5:
                      case 6:
                      case 7:
                        u += String.fromCharCode(s);
                        break;
                      case 12:
                      case 13:
                        (a = e[d++]), (u += String.fromCharCode(((31 & s) << 6) | (63 & a)));
                        break;
                      case 14:
                        (a = e[d++]),
                          (o = e[d++]),
                          (u += String.fromCharCode(((15 & s) << 12) | ((63 & a) << 6) | ((63 & o) << 0)));
                    }
                }
                return u;
              },
              E = { decodeTextFrame: v };
            function T() {
              return i || void 0 === self.TextDecoder || (i = new self.TextDecoder("utf-8")), i;
            }
          },
          "./src/demux/mp3demuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/demux/base-audio-demuxer.ts"),
              n = r("./src/demux/id3.ts"),
              s = r("./src/utils/logger.ts"),
              a = r("./src/demux/mpegaudio.ts");
            function o(e, t) {
              return (o =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            var l = (function(e) {
              var t, r;
              function i() {
                return e.apply(this, arguments) || this;
              }
              (r = e), ((t = i).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), o(t, r);
              var l = i.prototype;
              return (
                (l.resetInitSegment = function(t, r, i) {
                  e.prototype.resetInitSegment.call(this, t, r, i),
                    (this._audioTrack = {
                      container: "audio/mpeg",
                      type: "audio",
                      id: 2,
                      pid: -1,
                      sequenceNumber: 0,
                      isAAC: !1,
                      samples: [],
                      manifestCodec: t,
                      duration: i,
                      inputTimeScale: 9e4,
                      dropped: 0
                    });
                }),
                (i.probe = function(e) {
                  if (!e) return !1;
                  for (var t = (n.getID3Data(e, 0) || []).length, r = e.length; t < r; t++)
                    if (a.probe(e, t)) return s.logger.log("MPEG Audio sync word found !"), !0;
                  return !1;
                }),
                (l.canParse = function(e, t) {
                  return a.canParse(e, t);
                }),
                (l.appendFrame = function(e, t, r) {
                  if (null !== this.initPTS) return a.appendFrame(e, t, r, this.initPTS, this.frameIndex);
                }),
                i
              );
            })(i.default);
            (l.minProbeByteLength = 4), (t.default = l);
          },
          "./src/demux/mp4demuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/utils/mp4-tools.ts"),
              n = r("./src/demux/dummy-demuxed-track.ts"),
              s = (function() {
                function e(e, t) {
                  (this.remainderData = null), (this.config = void 0), (this.config = t);
                }
                var t = e.prototype;
                return (
                  (t.resetTimeStamp = function() {}),
                  (t.resetInitSegment = function() {}),
                  (t.resetContiguity = function() {}),
                  (e.probe = function(e) {
                    return (
                      Object(i.findBox)({ data: e, start: 0, end: Math.min(e.length, 16384) }, ["moof"]).length > 0
                    );
                  }),
                  (t.demux = function(e) {
                    var t = e,
                      r = Object(n.dummyTrack)();
                    if (this.config.progressive) {
                      this.remainderData && (t = Object(i.appendUint8Array)(this.remainderData, e));
                      var s = Object(i.segmentValidRange)(t);
                      (this.remainderData = s.remainder), (r.samples = s.valid || new Uint8Array());
                    } else r.samples = t;
                    return {
                      audioTrack: Object(n.dummyTrack)(),
                      avcTrack: r,
                      id3Track: Object(n.dummyTrack)(),
                      textTrack: Object(n.dummyTrack)()
                    };
                  }),
                  (t.flush = function() {
                    var e = Object(n.dummyTrack)();
                    return (
                      (e.samples = this.remainderData || new Uint8Array()),
                      (this.remainderData = null),
                      {
                        audioTrack: Object(n.dummyTrack)(),
                        avcTrack: e,
                        id3Track: Object(n.dummyTrack)(),
                        textTrack: Object(n.dummyTrack)()
                      }
                    );
                  }),
                  (t.demuxSampleAes = function(e, t, r) {
                    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
                  }),
                  (t.destroy = function() {}),
                  e
                );
              })();
            (s.minProbeByteLength = 1024), (t.default = s);
          },
          "./src/demux/mpegaudio.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "appendFrame", function() {
                return l;
              }),
              r.d(t, "parseHeader", function() {
                return u;
              }),
              r.d(t, "isHeaderPattern", function() {
                return d;
              }),
              r.d(t, "isHeader", function() {
                return c;
              }),
              r.d(t, "canParse", function() {
                return h;
              }),
              r.d(t, "probe", function() {
                return f;
              });
            var i = null,
              n = [
                32,
                64,
                96,
                128,
                160,
                192,
                224,
                256,
                288,
                320,
                352,
                384,
                416,
                448,
                32,
                48,
                56,
                64,
                80,
                96,
                112,
                128,
                160,
                192,
                224,
                256,
                320,
                384,
                32,
                40,
                48,
                56,
                64,
                80,
                96,
                112,
                128,
                160,
                192,
                224,
                256,
                320,
                32,
                48,
                56,
                64,
                80,
                96,
                112,
                128,
                144,
                160,
                176,
                192,
                224,
                256,
                8,
                16,
                24,
                32,
                40,
                48,
                56,
                64,
                80,
                96,
                112,
                128,
                144,
                160
              ],
              s = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3],
              a = [[0, 72, 144, 12], [0, 0, 0, 0], [0, 72, 144, 12], [0, 144, 144, 12]],
              o = [0, 1, 1, 4];
            function l(e, t, r, i, n) {
              if (!(r + 24 > t.length)) {
                var s = u(t, r);
                if (s && r + s.frameLength <= t.length) {
                  var a = i + n * ((9e4 * s.samplesPerFrame) / s.sampleRate),
                    o = { unit: t.subarray(r, r + s.frameLength), pts: a, dts: a };
                  return (
                    (e.config = []),
                    (e.channelCount = s.channelCount),
                    (e.samplerate = s.sampleRate),
                    e.samples.push(o),
                    { sample: o, length: s.frameLength, missing: 0 }
                  );
                }
              }
            }
            function u(e, t) {
              var r = (e[t + 1] >> 3) & 3,
                l = (e[t + 1] >> 1) & 3,
                u = (e[t + 2] >> 4) & 15,
                d = (e[t + 2] >> 2) & 3;
              if (1 !== r && 0 !== u && 15 !== u && 3 !== d) {
                var c = (e[t + 2] >> 1) & 1,
                  h = e[t + 3] >> 6,
                  f = 1e3 * n[14 * (3 === r ? 3 - l : 3 === l ? 3 : 4) + u - 1],
                  p = s[3 * (3 === r ? 0 : 2 === r ? 1 : 2) + d],
                  v = 3 === h ? 1 : 2,
                  g = a[r][l],
                  m = o[l],
                  y = 8 * g * m,
                  E = Math.floor((g * f) / p + c) * m;
                if (null === i) {
                  var T = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                  i = T ? parseInt(T[1]) : 0;
                }
                return (
                  !!i && i <= 87 && 2 === l && f >= 224e3 && 0 === h && (e[t + 3] = 128 | e[t + 3]),
                  { sampleRate: p, channelCount: v, frameLength: E, samplesPerFrame: y }
                );
              }
            }
            function d(e, t) {
              return 255 === e[t] && 224 == (224 & e[t + 1]) && 0 != (6 & e[t + 1]);
            }
            function c(e, t) {
              return t + 1 < e.length && d(e, t);
            }
            function h(e, t) {
              return d(e, t) && 4 <= e.length - t;
            }
            function f(e, t) {
              if (t + 1 < e.length && d(e, t)) {
                var r = u(e, t),
                  i = 4;
                null != r && r.frameLength && (i = r.frameLength);
                var n = t + i;
                return n === e.length || c(e, n);
              }
              return !1;
            }
          },
          "./src/demux/sample-aes.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/crypt/decrypter.ts"),
              n = r("./src/demux/tsdemuxer.ts"),
              s = (function() {
                function e(e, t, r) {
                  (this.keyData = void 0),
                    (this.decrypter = void 0),
                    (this.keyData = r),
                    (this.decrypter = new i.default(e, t, { removePKCS7Padding: !1 }));
                }
                var t = e.prototype;
                return (
                  (t.decryptBuffer = function(e, t) {
                    this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer, t);
                  }),
                  (t.decryptAacSample = function(e, t, r, i) {
                    var n = e[t].unit,
                      s = n.subarray(16, n.length - (n.length % 16)),
                      a = s.buffer.slice(s.byteOffset, s.byteOffset + s.length),
                      o = this;
                    this.decryptBuffer(a, function(s) {
                      var a = new Uint8Array(s);
                      n.set(a, 16), i || o.decryptAacSamples(e, t + 1, r);
                    });
                  }),
                  (t.decryptAacSamples = function(e, t, r) {
                    for (; ; t++) {
                      if (t >= e.length) return void r();
                      if (!(e[t].unit.length < 32)) {
                        var i = this.decrypter.isSync();
                        if ((this.decryptAacSample(e, t, r, i), !i)) return;
                      }
                    }
                  }),
                  (t.getAvcEncryptedData = function(e) {
                    for (
                      var t = 16 * Math.floor((e.length - 48) / 160) + 16, r = new Int8Array(t), i = 0, n = 32;
                      n < e.length - 16;
                      n += 160, i += 16
                    )
                      r.set(e.subarray(n, n + 16), i);
                    return r;
                  }),
                  (t.getAvcDecryptedUnit = function(e, t) {
                    for (var r = new Uint8Array(t), i = 0, n = 32; n < e.length - 16; n += 160, i += 16)
                      e.set(r.subarray(i, i + 16), n);
                    return e;
                  }),
                  (t.decryptAvcSample = function(e, t, r, i, s, a) {
                    var o = Object(n.discardEPB)(s.data),
                      l = this.getAvcEncryptedData(o),
                      u = this;
                    this.decryptBuffer(l.buffer, function(n) {
                      (s.data = u.getAvcDecryptedUnit(o, n)), a || u.decryptAvcSamples(e, t, r + 1, i);
                    });
                  }),
                  (t.decryptAvcSamples = function(e, t, r, i) {
                    if (e instanceof Uint8Array) throw new Error("Cannot decrypt samples of type Uint8Array");
                    for (; ; t++, r = 0) {
                      if (t >= e.length) return void i();
                      for (var n = e[t].units; !(r >= n.length); r++) {
                        var s = n[r];
                        if (!(s.data.length <= 48 || (1 !== s.type && 5 !== s.type))) {
                          var a = this.decrypter.isSync();
                          if ((this.decryptAvcSample(e, t, r, i, s, a), !a)) return;
                        }
                      }
                    }
                  }),
                  e
                );
              })();
            t.default = s;
          },
          "./src/demux/transmuxer-interface.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return c;
              });
            var i = r("./node_modules/webworkify-webpack/index.js"),
              n = r("./src/events.ts"),
              s = r("./src/demux/transmuxer.ts"),
              a = r("./src/utils/logger.ts"),
              o = r("./src/errors.ts"),
              l = r("./src/utils/mediasource-helper.ts"),
              u = r("./node_modules/eventemitter3/index.js"),
              d = Object(l.getMediaSource)() || {
                isTypeSupported: function() {
                  return !1;
                }
              },
              c = (function() {
                function e(e, t, r, l) {
                  var c = this;
                  (this.hls = void 0),
                    (this.id = void 0),
                    (this.observer = void 0),
                    (this.frag = null),
                    (this.part = null),
                    (this.worker = void 0),
                    (this.onwmsg = void 0),
                    (this.transmuxer = null),
                    (this.onTransmuxComplete = void 0),
                    (this.onFlush = void 0),
                    (this.hls = e),
                    (this.id = t),
                    (this.onTransmuxComplete = r),
                    (this.onFlush = l);
                  var h = e.config,
                    f = function(t, r) {
                      ((r = r || {}).frag = c.frag), (r.id = c.id), e.trigger(t, r);
                    };
                  (this.observer = new u.EventEmitter()),
                    this.observer.on(n.Events.FRAG_DECRYPTED, f),
                    this.observer.on(n.Events.ERROR, f);
                  var p = {
                      mp4: d.isTypeSupported("video/mp4"),
                      mpeg: d.isTypeSupported("audio/mpeg"),
                      mp3: d.isTypeSupported('audio/mp4; codecs="mp3"')
                    },
                    v = navigator.vendor;
                  if (h.enableWorker && "undefined" != typeof Worker) {
                    var g;
                    a.logger.log("demuxing in webworker");
                    try {
                      (g = this.worker = i("./src/demux/transmuxer-worker.ts")),
                        (this.onwmsg = this.onWorkerMessage.bind(this)),
                        g.addEventListener("message", this.onwmsg),
                        (g.onerror = function(t) {
                          e.trigger(n.Events.ERROR, {
                            type: o.ErrorTypes.OTHER_ERROR,
                            details: o.ErrorDetails.INTERNAL_EXCEPTION,
                            fatal: !0,
                            event: "demuxerWorker",
                            error: new Error(t.message + "  (" + t.filename + ":" + t.lineno + ")")
                          });
                        }),
                        g.postMessage({ cmd: "init", typeSupported: p, vendor: v, id: t, config: JSON.stringify(h) });
                    } catch (e) {
                      a.logger.warn("Error in worker:", e),
                        a.logger.error("Error while initializing DemuxerWorker, fallback to inline"),
                        g && self.URL.revokeObjectURL(g.objectURL),
                        (this.transmuxer = new s.default(this.observer, p, h, v, t)),
                        (this.worker = null);
                    }
                  } else this.transmuxer = new s.default(this.observer, p, h, v, t);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    var e = this.worker;
                    if (e) e.removeEventListener("message", this.onwmsg), e.terminate(), (this.worker = null);
                    else {
                      var t = this.transmuxer;
                      t && (t.destroy(), (this.transmuxer = null));
                    }
                    var r = this.observer;
                    r && r.removeAllListeners(), (this.observer = null);
                  }),
                  (t.push = function(e, t, r, i, n, o, l, u, d, c) {
                    var h,
                      f,
                      p = this;
                    d.transmuxing.start = self.performance.now();
                    var v = this.transmuxer,
                      g = this.worker,
                      m = o ? o.start : n.start,
                      y = n.decryptdata,
                      E = this.frag,
                      T = !(E && n.cc === E.cc),
                      b = !(E && d.level === E.level),
                      S = E ? d.sn - E.sn : -1,
                      k = this.part ? d.part - this.part.index : 1,
                      A = !b && (1 === S || (0 === S && 1 === k)),
                      w = self.performance.now();
                    (b || S || 0 === n.stats.parsing.start) && (n.stats.parsing.start = w),
                      !o || (!k && A) || (o.stats.parsing.start = w);
                    var R = !(
                        E &&
                        (null === (h = n.initSegment) || void 0 === h ? void 0 : h.url) ===
                          (null === (f = E.initSegment) || void 0 === f ? void 0 : f.url)
                      ),
                      C = new s.TransmuxState(T, A, u, b, m, R);
                    if (!A || T || R) {
                      a.logger.log(
                        "[transmuxer-interface, " +
                          n.type +
                          "]: Starting new transmux session for sn: " +
                          d.sn +
                          " p: " +
                          d.part +
                          " level: " +
                          d.level +
                          " id: " +
                          d.id +
                          "\n        discontinuity: " +
                          T +
                          "\n        trackSwitch: " +
                          b +
                          "\n        contiguous: " +
                          A +
                          "\n        accurateTimeOffset: " +
                          u +
                          "\n        timeOffset: " +
                          m +
                          "\n        initSegmentChange: " +
                          R
                      );
                      var L = new s.TransmuxConfig(r, i, t, l, c);
                      this.configureTransmuxer(L);
                    }
                    if (((this.frag = n), (this.part = o), g))
                      g.postMessage(
                        { cmd: "demux", data: e, decryptdata: y, chunkMeta: d, state: C },
                        e instanceof ArrayBuffer ? [e] : []
                      );
                    else if (v) {
                      var D = v.push(e, y, d, C);
                      Object(s.isPromise)(D)
                        ? D.then(function(e) {
                            p.handleTransmuxComplete(e);
                          })
                        : this.handleTransmuxComplete(D);
                    }
                  }),
                  (t.flush = function(e) {
                    var t = this;
                    e.transmuxing.start = self.performance.now();
                    var r = this.transmuxer,
                      i = this.worker;
                    if (i) i.postMessage({ cmd: "flush", chunkMeta: e });
                    else if (r) {
                      var n = r.flush(e);
                      Object(s.isPromise)(n)
                        ? n.then(function(r) {
                            t.handleFlushResult(r, e);
                          })
                        : this.handleFlushResult(n, e);
                    }
                  }),
                  (t.handleFlushResult = function(e, t) {
                    var r = this;
                    e.forEach(function(e) {
                      r.handleTransmuxComplete(e);
                    }),
                      this.onFlush(t);
                  }),
                  (t.onWorkerMessage = function(e) {
                    var t = e.data,
                      r = this.hls;
                    switch (t.event) {
                      case "init":
                        self.URL.revokeObjectURL(this.worker.objectURL);
                        break;
                      case "transmuxComplete":
                        this.handleTransmuxComplete(t.data);
                        break;
                      case "flush":
                        this.onFlush(t.data);
                        break;
                      default:
                        (t.data = t.data || {}),
                          (t.data.frag = this.frag),
                          (t.data.id = this.id),
                          r.trigger(t.event, t.data);
                    }
                  }),
                  (t.configureTransmuxer = function(e) {
                    var t = this.worker,
                      r = this.transmuxer;
                    t ? t.postMessage({ cmd: "configure", config: e }) : r && r.configure(e);
                  }),
                  (t.handleTransmuxComplete = function(e) {
                    (e.chunkMeta.transmuxing.end = self.performance.now()), this.onTransmuxComplete(e);
                  }),
                  e
                );
              })();
          },
          "./src/demux/transmuxer-worker.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return o;
              });
            var i = r("./src/demux/transmuxer.ts"),
              n = r("./src/events.ts"),
              s = r("./src/utils/logger.ts"),
              a = r("./node_modules/eventemitter3/index.js");
            function o(e) {
              var t = new a.EventEmitter(),
                r = function(t, r) {
                  e.postMessage({ event: t, data: r });
                };
              t.on(n.Events.FRAG_DECRYPTED, r),
                t.on(n.Events.ERROR, r),
                e.addEventListener("message", function(n) {
                  var a = n.data;
                  switch (a.cmd) {
                    case "init":
                      var o = JSON.parse(a.config);
                      (e.transmuxer = new i.default(t, a.typeSupported, o, a.vendor, a.id)),
                        Object(s.enableLogs)(o.debug),
                        r("init", null);
                      break;
                    case "configure":
                      e.transmuxer.configure(a.config);
                      break;
                    case "demux":
                      var u = e.transmuxer.push(a.data, a.decryptdata, a.chunkMeta, a.state);
                      Object(i.isPromise)(u)
                        ? u.then(function(t) {
                            l(e, t);
                          })
                        : l(e, u);
                      break;
                    case "flush":
                      var c = a.chunkMeta,
                        h = e.transmuxer.flush(c);
                      Object(i.isPromise)(h)
                        ? h.then(function(t) {
                            d(e, t, c);
                          })
                        : d(e, h, c);
                  }
                });
            }
            function l(e, t) {
              if ((r = t.remuxResult).audio || r.video || r.text || r.id3 || r.initSegment) {
                var r,
                  i = [],
                  n = t.remuxResult,
                  s = n.audio,
                  a = n.video;
                s && u(i, s), a && u(i, a), e.postMessage({ event: "transmuxComplete", data: t }, i);
              }
            }
            function u(e, t) {
              t.data1 && e.push(t.data1.buffer), t.data2 && e.push(t.data2.buffer);
            }
            function d(e, t, r) {
              t.forEach(function(t) {
                l(e, t);
              }),
                e.postMessage({ event: "flush", data: r });
            }
          },
          "./src/demux/transmuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return y;
              }),
              r.d(t, "isPromise", function() {
                return T;
              }),
              r.d(t, "TransmuxConfig", function() {
                return b;
              }),
              r.d(t, "TransmuxState", function() {
                return S;
              });
            var i,
              n = r("./src/events.ts"),
              s = r("./src/errors.ts"),
              a = r("./src/crypt/decrypter.ts"),
              o = r("./src/demux/aacdemuxer.ts"),
              l = r("./src/demux/mp4demuxer.ts"),
              u = r("./src/demux/tsdemuxer.ts"),
              d = r("./src/demux/mp3demuxer.ts"),
              c = r("./src/remux/mp4-remuxer.ts"),
              h = r("./src/remux/passthrough-remuxer.ts"),
              f = r("./src/demux/chunk-cache.ts"),
              p = r("./src/utils/mp4-tools.ts"),
              v = r("./src/utils/logger.ts");
            try {
              i = self.performance.now.bind(self.performance);
            } catch (e) {
              v.logger.debug("Unable to use Performance API on this environment"), (i = self.Date.now);
            }
            var g = [
                { demux: u.default, remux: c.default },
                { demux: l.default, remux: h.default },
                { demux: o.default, remux: c.default },
                { demux: d.default, remux: c.default }
              ],
              m = 1024;
            g.forEach(function(e) {
              var t = e.demux;
              m = Math.max(m, t.minProbeByteLength);
            });
            var y = (function() {
                function e(e, t, r, i, n) {
                  (this.observer = void 0),
                    (this.typeSupported = void 0),
                    (this.config = void 0),
                    (this.vendor = void 0),
                    (this.id = void 0),
                    (this.demuxer = void 0),
                    (this.remuxer = void 0),
                    (this.decrypter = void 0),
                    (this.probe = void 0),
                    (this.decryptionPromise = null),
                    (this.transmuxConfig = void 0),
                    (this.currentTransmuxState = void 0),
                    (this.cache = new f.default()),
                    (this.observer = e),
                    (this.typeSupported = t),
                    (this.config = r),
                    (this.vendor = i),
                    (this.id = n);
                }
                var t = e.prototype;
                return (
                  (t.configure = function(e) {
                    (this.transmuxConfig = e), this.decrypter && this.decrypter.reset();
                  }),
                  (t.push = function(e, t, r, n) {
                    var s = this,
                      a = r.transmuxing;
                    a.executeStart = i();
                    var o = new Uint8Array(e),
                      l = this.cache,
                      u = this.config,
                      d = this.currentTransmuxState,
                      c = this.transmuxConfig;
                    n && (this.currentTransmuxState = n);
                    var h = (function(e, t) {
                      var r = null;
                      return (
                        e.byteLength > 0 && null != t && null != t.key && null !== t.iv && null != t.method && (r = t),
                        r
                      );
                    })(o, t);
                    if (h && "AES-128" === h.method) {
                      var f = this.getDecrypter();
                      if (!u.enableSoftwareAES)
                        return (
                          (this.decryptionPromise = f.webCryptoDecrypt(o, h.key.buffer, h.iv.buffer).then(function(e) {
                            var t = s.push(e, null, r);
                            return (s.decryptionPromise = null), t;
                          })),
                          this.decryptionPromise
                        );
                      var v = f.softwareDecrypt(o, h.key.buffer, h.iv.buffer);
                      if (!v) return (a.executeEnd = i()), E(r);
                      o = new Uint8Array(v);
                    }
                    var g = n || d,
                      m = g.contiguous,
                      y = g.discontinuity,
                      T = g.trackSwitch,
                      b = g.accurateTimeOffset,
                      S = g.timeOffset,
                      k = g.initSegmentChange,
                      A = c.audioCodec,
                      w = c.videoCodec,
                      R = c.defaultInitPts,
                      C = c.duration,
                      L = c.initSegmentData;
                    if (
                      ((y || T || k) && this.resetInitSegment(L, A, w, C),
                      (y || k) && this.resetInitialTimestamp(R),
                      m || this.resetContiguity(),
                      this.needsProbing(o, y, T))
                    ) {
                      if (l.dataLength) {
                        var D = l.flush();
                        o = Object(p.appendUint8Array)(D, o);
                      }
                      this.configureTransmuxer(o, c);
                    }
                    var _ = this.transmux(o, h, S, b, r),
                      I = this.currentTransmuxState;
                    return (I.contiguous = !0), (I.discontinuity = !1), (I.trackSwitch = !1), (a.executeEnd = i()), _;
                  }),
                  (t.flush = function(e) {
                    var t = this,
                      r = e.transmuxing;
                    r.executeStart = i();
                    var a = this.decrypter,
                      o = this.cache,
                      l = this.currentTransmuxState,
                      u = this.decryptionPromise;
                    if (u)
                      return u.then(function() {
                        return t.flush(e);
                      });
                    var d = [],
                      c = l.timeOffset;
                    if (a) {
                      var h = a.flush();
                      h && d.push(this.push(h, null, e));
                    }
                    var f = o.dataLength;
                    o.reset();
                    var p = this.demuxer,
                      v = this.remuxer;
                    if (!p || !v)
                      return (
                        f >= m &&
                          this.observer.emit(n.Events.ERROR, n.Events.ERROR, {
                            type: s.ErrorTypes.MEDIA_ERROR,
                            details: s.ErrorDetails.FRAG_PARSING_ERROR,
                            fatal: !0,
                            reason: "no demux matching with content found"
                          }),
                        (r.executeEnd = i()),
                        [E(e)]
                      );
                    var g = p.flush(c);
                    return T(g)
                      ? g.then(function(r) {
                          return t.flushRemux(d, r, e), d;
                        })
                      : (this.flushRemux(d, g, e), d);
                  }),
                  (t.flushRemux = function(e, t, r) {
                    var n = t.audioTrack,
                      s = t.avcTrack,
                      a = t.id3Track,
                      o = t.textTrack,
                      l = this.currentTransmuxState,
                      u = l.accurateTimeOffset,
                      d = l.timeOffset;
                    v.logger.log(
                      "[transmuxer.ts]: Flushed fragment " +
                        r.sn +
                        (r.part > -1 ? " p: " + r.part : "") +
                        " of level " +
                        r.level
                    );
                    var c = this.remuxer.remux(n, s, a, o, d, u, !0, this.id);
                    e.push({ remuxResult: c, chunkMeta: r }), (r.transmuxing.executeEnd = i());
                  }),
                  (t.resetInitialTimestamp = function(e) {
                    var t = this.demuxer,
                      r = this.remuxer;
                    t && r && (t.resetTimeStamp(e), r.resetTimeStamp(e));
                  }),
                  (t.resetContiguity = function() {
                    var e = this.demuxer,
                      t = this.remuxer;
                    e && t && (e.resetContiguity(), t.resetNextTimestamp());
                  }),
                  (t.resetInitSegment = function(e, t, r, i) {
                    var n = this.demuxer,
                      s = this.remuxer;
                    n && s && (n.resetInitSegment(t, r, i), s.resetInitSegment(e, t, r));
                  }),
                  (t.destroy = function() {
                    this.demuxer && (this.demuxer.destroy(), (this.demuxer = void 0)),
                      this.remuxer && (this.remuxer.destroy(), (this.remuxer = void 0));
                  }),
                  (t.transmux = function(e, t, r, i, n) {
                    return t && "SAMPLE-AES" === t.method
                      ? this.transmuxSampleAes(e, t, r, i, n)
                      : this.transmuxUnencrypted(e, r, i, n);
                  }),
                  (t.transmuxUnencrypted = function(e, t, r, i) {
                    var n = this.demuxer.demux(e, t, !1, !this.config.progressive),
                      s = n.audioTrack,
                      a = n.avcTrack,
                      o = n.id3Track,
                      l = n.textTrack;
                    return { remuxResult: this.remuxer.remux(s, a, o, l, t, r, !1, this.id), chunkMeta: i };
                  }),
                  (t.transmuxSampleAes = function(e, t, r, i, n) {
                    var s = this;
                    return this.demuxer.demuxSampleAes(e, t, r).then(function(e) {
                      return {
                        remuxResult: s.remuxer.remux(e.audioTrack, e.avcTrack, e.id3Track, e.textTrack, r, i, !1, s.id),
                        chunkMeta: n
                      };
                    });
                  }),
                  (t.configureTransmuxer = function(e, t) {
                    for (
                      var r,
                        i = this.config,
                        n = this.observer,
                        s = this.typeSupported,
                        a = this.vendor,
                        o = t.audioCodec,
                        u = t.defaultInitPts,
                        d = t.duration,
                        c = t.initSegmentData,
                        f = t.videoCodec,
                        p = 0,
                        m = g.length;
                      p < m;
                      p++
                    )
                      if (g[p].demux.probe(e)) {
                        r = g[p];
                        break;
                      }
                    r ||
                      (v.logger.warn("Failed to find demuxer by probing frag, treating as mp4 passthrough"),
                      (r = { demux: l.default, remux: h.default }));
                    var y = this.demuxer,
                      E = this.remuxer,
                      T = r.remux,
                      b = r.demux;
                    (E && E instanceof T) || (this.remuxer = new T(n, i, s, a)),
                      (y && y instanceof b) || ((this.demuxer = new b(n, i, s)), (this.probe = b.probe)),
                      this.resetInitSegment(c, o, f, d),
                      this.resetInitialTimestamp(u);
                  }),
                  (t.needsProbing = function(e, t, r) {
                    return !this.demuxer || !this.remuxer || t || r;
                  }),
                  (t.getDecrypter = function() {
                    var e = this.decrypter;
                    return e || (e = this.decrypter = new a.default(this.observer, this.config)), e;
                  }),
                  e
                );
              })(),
              E = function(e) {
                return { remuxResult: {}, chunkMeta: e };
              };
            function T(e) {
              return "then" in e && e.then instanceof Function;
            }
            var b = function(e, t, r, i, n) {
                (this.audioCodec = void 0),
                  (this.videoCodec = void 0),
                  (this.initSegmentData = void 0),
                  (this.duration = void 0),
                  (this.defaultInitPts = void 0),
                  (this.audioCodec = e),
                  (this.videoCodec = t),
                  (this.initSegmentData = r),
                  (this.duration = i),
                  (this.defaultInitPts = n);
              },
              S = function(e, t, r, i, n, s) {
                (this.discontinuity = void 0),
                  (this.contiguous = void 0),
                  (this.accurateTimeOffset = void 0),
                  (this.trackSwitch = void 0),
                  (this.timeOffset = void 0),
                  (this.initSegmentChange = void 0),
                  (this.discontinuity = e),
                  (this.contiguous = t),
                  (this.accurateTimeOffset = r),
                  (this.trackSwitch = i),
                  (this.timeOffset = n),
                  (this.initSegmentChange = s);
              };
          },
          "./src/demux/tsdemuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "discardEPB", function() {
                return T;
              });
            var i = r("./src/demux/adts.ts"),
              n = r("./src/demux/mpegaudio.ts"),
              s = r("./src/demux/exp-golomb.ts"),
              a = r("./src/demux/id3.ts"),
              o = r("./src/demux/sample-aes.ts"),
              l = r("./src/events.ts"),
              u = r("./src/utils/mp4-tools.ts"),
              d = r("./src/utils/logger.ts"),
              c = r("./src/errors.ts"),
              h = { video: 1, audio: 2, id3: 3, text: 4 },
              f = (function() {
                function e(e, t, r) {
                  (this.observer = void 0),
                    (this.config = void 0),
                    (this.typeSupported = void 0),
                    (this.sampleAes = null),
                    (this.pmtParsed = !1),
                    (this.audioCodec = void 0),
                    (this.videoCodec = void 0),
                    (this._duration = 0),
                    (this.aacLastPTS = null),
                    (this._initPTS = null),
                    (this._initDTS = null),
                    (this._pmtId = -1),
                    (this._avcTrack = void 0),
                    (this._audioTrack = void 0),
                    (this._id3Track = void 0),
                    (this._txtTrack = void 0),
                    (this.aacOverFlow = null),
                    (this.avcSample = null),
                    (this.remainderData = null),
                    (this.observer = e),
                    (this.config = t),
                    (this.typeSupported = r);
                }
                (e.probe = function(t) {
                  var r = e.syncOffset(t);
                  return !(
                    r < 0 ||
                    (r && d.logger.warn("MPEG2-TS detected but first sync word found @ offset " + r + ", junk ahead ?"),
                    0)
                  );
                }),
                  (e.syncOffset = function(e) {
                    for (var t = Math.min(1e3, e.length - 564), r = 0; r < t; ) {
                      if (71 === e[r] && 71 === e[r + 188] && 71 === e[r + 376]) return r;
                      r++;
                    }
                    return -1;
                  }),
                  (e.createTrack = function(e, t) {
                    return {
                      container: "video" === e || "audio" === e ? "video/mp2t" : void 0,
                      type: e,
                      id: h[e],
                      pid: -1,
                      inputTimeScale: 9e4,
                      sequenceNumber: 0,
                      samples: [],
                      dropped: 0,
                      duration: "audio" === e ? t : void 0
                    };
                  });
                var t = e.prototype;
                return (
                  (t.resetInitSegment = function(t, r, i) {
                    (this.pmtParsed = !1),
                      (this._pmtId = -1),
                      (this._avcTrack = e.createTrack("video", i)),
                      (this._audioTrack = e.createTrack("audio", i)),
                      (this._id3Track = e.createTrack("id3", i)),
                      (this._txtTrack = e.createTrack("text", i)),
                      (this._audioTrack.isAAC = !0),
                      (this.aacOverFlow = null),
                      (this.aacLastPTS = null),
                      (this.avcSample = null),
                      (this.audioCodec = t),
                      (this.videoCodec = r),
                      (this._duration = i);
                  }),
                  (t.resetTimeStamp = function() {}),
                  (t.resetContiguity = function() {
                    var e = this._audioTrack,
                      t = this._avcTrack,
                      r = this._id3Track;
                    e && (e.pesData = null),
                      t && (t.pesData = null),
                      r && (r.pesData = null),
                      (this.aacOverFlow = null),
                      (this.aacLastPTS = null);
                  }),
                  (t.demux = function(t, r, i, n) {
                    var s;
                    void 0 === i && (i = !1), void 0 === n && (n = !1), i || (this.sampleAes = null);
                    var a = this._avcTrack,
                      o = this._audioTrack,
                      h = this._id3Track,
                      f = a.pid,
                      p = a.pesData,
                      y = o.pid,
                      E = h.pid,
                      T = o.pesData,
                      b = h.pesData,
                      S = !1,
                      k = this.pmtParsed,
                      A = this._pmtId,
                      w = t.length;
                    if (
                      (this.remainderData &&
                        ((w = (t = Object(u.appendUint8Array)(this.remainderData, t)).length),
                        (this.remainderData = null)),
                      w < 188 && !n)
                    )
                      return (
                        (this.remainderData = t), { audioTrack: o, avcTrack: a, id3Track: h, textTrack: this._txtTrack }
                      );
                    var R = Math.max(0, e.syncOffset(t));
                    (w -= (w + R) % 188) < t.byteLength &&
                      !n &&
                      (this.remainderData = new Uint8Array(t.buffer, w, t.buffer.byteLength - w));
                    for (var C = 0, L = R; L < w; L += 188)
                      if (71 === t[L]) {
                        var D = !!(64 & t[L + 1]),
                          _ = ((31 & t[L + 1]) << 8) + t[L + 2],
                          I = void 0;
                        if ((48 & t[L + 3]) >> 4 > 1) {
                          if ((I = L + 5 + t[L + 4]) === L + 188) continue;
                        } else I = L + 4;
                        switch (_) {
                          case f:
                            D && (p && (s = m(p)) && this.parseAVCPES(s, !1), (p = { data: [], size: 0 })),
                              p && (p.data.push(t.subarray(I, L + 188)), (p.size += L + 188 - I));
                            break;
                          case y:
                            D &&
                              (T && (s = m(T)) && (o.isAAC ? this.parseAACPES(s) : this.parseMPEGPES(s)),
                              (T = { data: [], size: 0 })),
                              T && (T.data.push(t.subarray(I, L + 188)), (T.size += L + 188 - I));
                            break;
                          case E:
                            D && (b && (s = m(b)) && this.parseID3PES(s), (b = { data: [], size: 0 })),
                              b && (b.data.push(t.subarray(I, L + 188)), (b.size += L + 188 - I));
                            break;
                          case 0:
                            D && (I += t[I] + 1), (A = this._pmtId = v(t, I));
                            break;
                          case A:
                            D && (I += t[I] + 1);
                            var x = g(t, I, !0 === this.typeSupported.mpeg || !0 === this.typeSupported.mp3, i);
                            (f = x.avc) > 0 && (a.pid = f),
                              (y = x.audio) > 0 && ((o.pid = y), (o.isAAC = x.isAAC)),
                              (E = x.id3) > 0 && (h.pid = E),
                              S && !k && (d.logger.log("reparse from beginning"), (S = !1), (L = R - 188)),
                              (k = this.pmtParsed = !0);
                            break;
                          case 17:
                          case 8191:
                            break;
                          default:
                            S = !0;
                        }
                      } else C++;
                    C > 0 &&
                      this.observer.emit(l.Events.ERROR, l.Events.ERROR, {
                        type: c.ErrorTypes.MEDIA_ERROR,
                        details: c.ErrorDetails.FRAG_PARSING_ERROR,
                        fatal: !1,
                        reason: "Found " + C + " TS packet/s that do not start with 0x47"
                      }),
                      (a.pesData = p),
                      (o.pesData = T),
                      (h.pesData = b);
                    var O = { audioTrack: o, avcTrack: a, id3Track: h, textTrack: this._txtTrack };
                    return n && this.extractRemainingSamples(O), O;
                  }),
                  (t.flush = function() {
                    var e,
                      t = this.remainderData;
                    return (
                      (this.remainderData = null),
                      (e = t
                        ? this.demux(t, -1, !1, !0)
                        : {
                            audioTrack: this._audioTrack,
                            avcTrack: this._avcTrack,
                            textTrack: this._txtTrack,
                            id3Track: this._id3Track
                          }),
                      this.extractRemainingSamples(e),
                      this.sampleAes ? this.decrypt(e, this.sampleAes) : e
                    );
                  }),
                  (t.extractRemainingSamples = function(e) {
                    var t,
                      r = e.audioTrack,
                      i = e.avcTrack,
                      n = e.id3Track,
                      s = i.pesData,
                      a = r.pesData,
                      o = n.pesData;
                    s && (t = m(s)) ? (this.parseAVCPES(t, !0), (i.pesData = null)) : (i.pesData = s),
                      a && (t = m(a))
                        ? (r.isAAC ? this.parseAACPES(t) : this.parseMPEGPES(t), (r.pesData = null))
                        : (null != a &&
                            a.size &&
                            d.logger.log("last AAC PES packet truncated,might overlap between fragments"),
                          (r.pesData = a)),
                      o && (t = m(o)) ? (this.parseID3PES(t), (n.pesData = null)) : (n.pesData = o);
                  }),
                  (t.demuxSampleAes = function(e, t, r) {
                    var i = this.demux(e, r, !0, !this.config.progressive),
                      n = (this.sampleAes = new o.default(this.observer, this.config, t));
                    return this.decrypt(i, n);
                  }),
                  (t.decrypt = function(e, t) {
                    return new Promise(function(r) {
                      var i = e.audioTrack,
                        n = e.avcTrack;
                      i.samples && i.isAAC
                        ? t.decryptAacSamples(i.samples, 0, function() {
                            n.samples
                              ? t.decryptAvcSamples(n.samples, 0, 0, function() {
                                  r(e);
                                })
                              : r(e);
                          })
                        : n.samples &&
                          t.decryptAvcSamples(n.samples, 0, 0, function() {
                            r(e);
                          });
                    });
                  }),
                  (t.destroy = function() {
                    (this._initPTS = this._initDTS = null), (this._duration = 0);
                  }),
                  (t.parseAVCPES = function(e, t) {
                    var r,
                      i = this,
                      n = this._avcTrack,
                      o = this.parseAVCNALu(e.data),
                      l = this.avcSample,
                      u = !1;
                    (e.data = null),
                      l && o.length && !n.audFound && (y(l, n), (l = this.avcSample = p(!1, e.pts, e.dts, ""))),
                      o.forEach(function(t) {
                        switch (t.type) {
                          case 1:
                            (r = !0), l || (l = i.avcSample = p(!0, e.pts, e.dts, "")), (l.frame = !0);
                            var o = t.data;
                            if (u && o.length > 4) {
                              var d = new s.default(o).readSliceType();
                              (2 !== d && 4 !== d && 7 !== d && 9 !== d) || (l.key = !0);
                            }
                            break;
                          case 5:
                            (r = !0), l || (l = i.avcSample = p(!0, e.pts, e.dts, "")), (l.key = !0), (l.frame = !0);
                            break;
                          case 6:
                            r = !0;
                            var c = new s.default(T(t.data));
                            c.readUByte();
                            for (var h = 0, f = 0, v = !1, g = 0; !v && c.bytesAvailable > 1; ) {
                              h = 0;
                              do {
                                h += g = c.readUByte();
                              } while (255 === g);
                              f = 0;
                              do {
                                f += g = c.readUByte();
                              } while (255 === g);
                              if (4 === h && 0 !== c.bytesAvailable) {
                                if (
                                  ((v = !0),
                                  181 === c.readUByte() &&
                                    49 === c.readUShort() &&
                                    1195456820 === c.readUInt() &&
                                    3 === c.readUByte())
                                ) {
                                  for (var m = c.readUByte(), b = 31 & m, S = [m, c.readUByte()], k = 0; k < b; k++)
                                    S.push(c.readUByte()), S.push(c.readUByte()), S.push(c.readUByte());
                                  E(i._txtTrack.samples, { type: 3, pts: e.pts, bytes: S });
                                }
                              } else if (5 === h && 0 !== c.bytesAvailable) {
                                if (((v = !0), f > 16)) {
                                  for (var A = [], w = 0; w < 16; w++)
                                    A.push(c.readUByte().toString(16)),
                                      (3 !== w && 5 !== w && 7 !== w && 9 !== w) || A.push("-");
                                  for (var R = f - 16, C = new Uint8Array(R), L = 0; L < R; L++) C[L] = c.readUByte();
                                  E(i._txtTrack.samples, {
                                    pts: e.pts,
                                    payloadType: h,
                                    uuid: A.join(""),
                                    userData: Object(a.utf8ArrayToStr)(C),
                                    userDataBytes: C
                                  });
                                }
                              } else if (f < c.bytesAvailable) for (var D = 0; D < f; D++) c.readUByte();
                            }
                            break;
                          case 7:
                            if (((r = !0), (u = !0), !n.sps)) {
                              var _ = new s.default(t.data).readSPS();
                              (n.width = _.width),
                                (n.height = _.height),
                                (n.pixelRatio = _.pixelRatio),
                                (n.sps = [t.data]),
                                (n.duration = i._duration);
                              for (var I = t.data.subarray(1, 4), x = "avc1.", O = 0; O < 3; O++) {
                                var P = I[O].toString(16);
                                P.length < 2 && (P = "0" + P), (x += P);
                              }
                              n.codec = x;
                            }
                            break;
                          case 8:
                            (r = !0), n.pps || (n.pps = [t.data]);
                            break;
                          case 9:
                            (r = !1), (n.audFound = !0), l && y(l, n), (l = i.avcSample = p(!1, e.pts, e.dts, ""));
                            break;
                          case 12:
                            r = !1;
                            break;
                          default:
                            (r = !1), l && (l.debug += "unknown NAL " + t.type + " ");
                        }
                        l && r && l.units.push(t);
                      }),
                      t && l && (y(l, n), (this.avcSample = null));
                  }),
                  (t.getLastNalUnit = function() {
                    var e,
                      t,
                      r = this.avcSample;
                    if (!r || 0 === r.units.length) {
                      var i = this._avcTrack.samples;
                      r = i[i.length - 1];
                    }
                    if (null !== (e = r) && void 0 !== e && e.units) {
                      var n = r.units;
                      t = n[n.length - 1];
                    }
                    return t;
                  }),
                  (t.parseAVCNALu = function(e) {
                    var t,
                      r,
                      i = e.byteLength,
                      n = this._avcTrack,
                      s = n.naluState || 0,
                      a = s,
                      o = [],
                      l = 0,
                      u = -1,
                      d = 0;
                    for (-1 === s && ((u = 0), (d = 31 & e[0]), (s = 0), (l = 1)); l < i; )
                      if (((t = e[l++]), s))
                        if (1 !== s)
                          if (t)
                            if (1 === t) {
                              if (u >= 0) {
                                var c = { data: e.subarray(u, l - s - 1), type: d };
                                o.push(c);
                              } else {
                                var h = this.getLastNalUnit();
                                if (
                                  h &&
                                  (a && l <= 4 - a && h.state && (h.data = h.data.subarray(0, h.data.byteLength - a)),
                                  (r = l - s - 1) > 0)
                                ) {
                                  var f = new Uint8Array(h.data.byteLength + r);
                                  f.set(h.data, 0),
                                    f.set(e.subarray(0, r), h.data.byteLength),
                                    (h.data = f),
                                    (h.state = 0);
                                }
                              }
                              l < i ? ((u = l), (d = 31 & e[l]), (s = 0)) : (s = -1);
                            } else s = 0;
                          else s = 3;
                        else s = t ? 0 : 2;
                      else s = t ? 0 : 1;
                    if (u >= 0 && s >= 0) {
                      var p = { data: e.subarray(u, i), type: d, state: s };
                      o.push(p);
                    }
                    if (0 === o.length) {
                      var v = this.getLastNalUnit();
                      if (v) {
                        var g = new Uint8Array(v.data.byteLength + e.byteLength);
                        g.set(v.data, 0), g.set(e, v.data.byteLength), (v.data = g);
                      }
                    }
                    return (n.naluState = s), o;
                  }),
                  (t.parseAACPES = function(e) {
                    var t,
                      r,
                      n,
                      s,
                      a,
                      o = 0,
                      u = this._audioTrack,
                      h = this.aacOverFlow,
                      f = e.data;
                    if (h) {
                      this.aacOverFlow = null;
                      var p = h.sample.unit.byteLength,
                        v = Math.min(h.missing, p),
                        g = p - v;
                      h.sample.unit.set(f.subarray(0, v), g), u.samples.push(h.sample), (o = h.missing);
                    }
                    for (t = o, r = f.length; t < r - 1 && !i.isHeader(f, t); t++);
                    if (
                      t === o ||
                      (t < r - 1
                        ? ((n = "AAC PES did not start with ADTS header,offset:" + t), (s = !1))
                        : ((n = "no ADTS header found in AAC PES"), (s = !0)),
                      d.logger.warn("parsing error:" + n),
                      this.observer.emit(l.Events.ERROR, l.Events.ERROR, {
                        type: c.ErrorTypes.MEDIA_ERROR,
                        details: c.ErrorDetails.FRAG_PARSING_ERROR,
                        fatal: s,
                        reason: n
                      }),
                      !s)
                    ) {
                      if ((i.initTrackConfig(u, this.observer, f, t, this.audioCodec), void 0 !== e.pts)) a = e.pts;
                      else {
                        if (!h) return void d.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
                        var m = i.getFrameDuration(u.samplerate);
                        a = h.sample.pts + m;
                      }
                      for (var y = 0; t < r; ) {
                        if (i.isHeader(f, t)) {
                          if (t + 5 < r) {
                            var E = i.appendFrame(u, f, t, a, y);
                            if (E) {
                              if (!E.missing) {
                                (t += E.length), y++;
                                continue;
                              }
                              this.aacOverFlow = E;
                            }
                          }
                          break;
                        }
                        t++;
                      }
                    }
                  }),
                  (t.parseMPEGPES = function(e) {
                    var t = e.data,
                      r = t.length,
                      i = 0,
                      s = 0,
                      a = e.pts;
                    if (void 0 !== a)
                      for (; s < r; )
                        if (n.isHeader(t, s)) {
                          var o = n.appendFrame(this._audioTrack, t, s, a, i);
                          if (!o) break;
                          (s += o.length), i++;
                        } else s++;
                    else d.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
                  }),
                  (t.parseID3PES = function(e) {
                    void 0 !== e.pts
                      ? this._id3Track.samples.push(e)
                      : d.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
                  }),
                  e
                );
              })();
            function p(e, t, r, i) {
              return { key: e, frame: !1, pts: t, dts: r, units: [], debug: i, length: 0 };
            }
            function v(e, t) {
              return ((31 & e[t + 10]) << 8) | e[t + 11];
            }
            function g(e, t, r, i) {
              var n = { audio: -1, avc: -1, id3: -1, isAAC: !0 },
                s = t + 3 + (((15 & e[t + 1]) << 8) | e[t + 2]) - 4;
              for (t += 12 + (((15 & e[t + 10]) << 8) | e[t + 11]); t < s; ) {
                var a = ((31 & e[t + 1]) << 8) | e[t + 2];
                switch (e[t]) {
                  case 207:
                    if (!i) {
                      d.logger.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                      break;
                    }
                  case 15:
                    -1 === n.audio && (n.audio = a);
                    break;
                  case 21:
                    -1 === n.id3 && (n.id3 = a);
                    break;
                  case 219:
                    if (!i) {
                      d.logger.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                      break;
                    }
                  case 27:
                    -1 === n.avc && (n.avc = a);
                    break;
                  case 3:
                  case 4:
                    r
                      ? -1 === n.audio && ((n.audio = a), (n.isAAC = !1))
                      : d.logger.log("MPEG audio found, not supported in this browser");
                    break;
                  case 36:
                    d.logger.warn("Unsupported HEVC stream type found");
                }
                t += 5 + (((15 & e[t + 3]) << 8) | e[t + 4]);
              }
              return n;
            }
            function m(e) {
              var t,
                r,
                i,
                n,
                s,
                a = 0,
                o = e.data;
              if (!e || 0 === e.size) return null;
              for (; o[0].length < 19 && o.length > 1; ) {
                var l = new Uint8Array(o[0].length + o[1].length);
                l.set(o[0]), l.set(o[1], o[0].length), (o[0] = l), o.splice(1, 1);
              }
              if (1 === ((t = o[0])[0] << 16) + (t[1] << 8) + t[2]) {
                if ((r = (t[4] << 8) + t[5]) && r > e.size - 6) return null;
                var u = t[7];
                192 & u &&
                  ((n =
                    536870912 * (14 & t[9]) +
                    4194304 * (255 & t[10]) +
                    16384 * (254 & t[11]) +
                    128 * (255 & t[12]) +
                    (254 & t[13]) / 2),
                  64 & u
                    ? n -
                        (s =
                          536870912 * (14 & t[14]) +
                          4194304 * (255 & t[15]) +
                          16384 * (254 & t[16]) +
                          128 * (255 & t[17]) +
                          (254 & t[18]) / 2) >
                        54e5 &&
                      (d.logger.warn(Math.round((n - s) / 9e4) + "s delta between PTS and DTS, align them"), (n = s))
                    : (s = n));
                var c = (i = t[8]) + 9;
                if (e.size <= c) return null;
                e.size -= c;
                for (var h = new Uint8Array(e.size), f = 0, p = o.length; f < p; f++) {
                  var v = (t = o[f]).byteLength;
                  if (c) {
                    if (c > v) {
                      c -= v;
                      continue;
                    }
                    (t = t.subarray(c)), (v -= c), (c = 0);
                  }
                  h.set(t, a), (a += v);
                }
                return r && (r -= i + 3), { data: h, pts: n, dts: s, len: r };
              }
              return null;
            }
            function y(e, t) {
              if (e.units.length && e.frame) {
                if (void 0 === e.pts) {
                  var r = t.samples,
                    i = r.length;
                  if (!i) return void t.dropped++;
                  var n = r[i - 1];
                  (e.pts = n.pts), (e.dts = n.dts);
                }
                t.samples.push(e);
              }
              e.debug.length && d.logger.log(e.pts + "/" + e.dts + ":" + e.debug);
            }
            function E(e, t) {
              var r = e.length;
              if (r > 0) {
                if (t.pts >= e[r - 1].pts) e.push(t);
                else
                  for (var i = r - 1; i >= 0; i--)
                    if (t.pts < e[i].pts) {
                      e.splice(i, 0, t);
                      break;
                    }
              } else e.push(t);
            }
            function T(e) {
              for (var t = e.byteLength, r = [], i = 1; i < t - 2; )
                0 === e[i] && 0 === e[i + 1] && 3 === e[i + 2] ? (r.push(i + 2), (i += 2)) : i++;
              if (0 === r.length) return e;
              var n = t - r.length,
                s = new Uint8Array(n),
                a = 0;
              for (i = 0; i < n; a++, i++) a === r[0] && (a++, r.shift()), (s[i] = e[a]);
              return s;
            }
            (f.minProbeByteLength = 188), (t.default = f);
          },
          "./src/errors.ts": function(e, t, r) {
            "use strict";
            var i, n;
            r.r(t),
              r.d(t, "ErrorTypes", function() {
                return i;
              }),
              r.d(t, "ErrorDetails", function() {
                return n;
              }),
              (function(e) {
                (e.NETWORK_ERROR = "networkError"),
                  (e.MEDIA_ERROR = "mediaError"),
                  (e.KEY_SYSTEM_ERROR = "keySystemError"),
                  (e.MUX_ERROR = "muxError"),
                  (e.OTHER_ERROR = "otherError");
              })(i || (i = {})),
              (function(e) {
                (e.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys"),
                  (e.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess"),
                  (e.KEY_SYSTEM_NO_SESSION = "keySystemNoSession"),
                  (e.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed"),
                  (e.KEY_SYSTEM_NO_INIT_DATA = "keySystemNoInitData"),
                  (e.MANIFEST_LOAD_ERROR = "manifestLoadError"),
                  (e.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut"),
                  (e.MANIFEST_PARSING_ERROR = "manifestParsingError"),
                  (e.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError"),
                  (e.LEVEL_EMPTY_ERROR = "levelEmptyError"),
                  (e.LEVEL_LOAD_ERROR = "levelLoadError"),
                  (e.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut"),
                  (e.LEVEL_SWITCH_ERROR = "levelSwitchError"),
                  (e.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError"),
                  (e.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut"),
                  (e.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError"),
                  (e.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut"),
                  (e.FRAG_LOAD_ERROR = "fragLoadError"),
                  (e.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut"),
                  (e.FRAG_DECRYPT_ERROR = "fragDecryptError"),
                  (e.FRAG_PARSING_ERROR = "fragParsingError"),
                  (e.REMUX_ALLOC_ERROR = "remuxAllocError"),
                  (e.KEY_LOAD_ERROR = "keyLoadError"),
                  (e.KEY_LOAD_TIMEOUT = "keyLoadTimeOut"),
                  (e.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError"),
                  (e.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError"),
                  (e.BUFFER_APPEND_ERROR = "bufferAppendError"),
                  (e.BUFFER_APPENDING_ERROR = "bufferAppendingError"),
                  (e.BUFFER_STALLED_ERROR = "bufferStalledError"),
                  (e.BUFFER_FULL_ERROR = "bufferFullError"),
                  (e.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole"),
                  (e.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall"),
                  (e.INTERNAL_EXCEPTION = "internalException"),
                  (e.INTERNAL_ABORTED = "aborted"),
                  (e.UNKNOWN = "unknown");
              })(n || (n = {}));
          },
          "./src/events.ts": function(e, t, r) {
            "use strict";
            var i;
            r.r(t),
              r.d(t, "Events", function() {
                return i;
              }),
              (function(e) {
                (e.MEDIA_ATTACHING = "hlsMediaAttaching"),
                  (e.MEDIA_ATTACHED = "hlsMediaAttached"),
                  (e.MEDIA_DETACHING = "hlsMediaDetaching"),
                  (e.MEDIA_DETACHED = "hlsMediaDetached"),
                  (e.BUFFER_RESET = "hlsBufferReset"),
                  (e.BUFFER_CODECS = "hlsBufferCodecs"),
                  (e.BUFFER_CREATED = "hlsBufferCreated"),
                  (e.BUFFER_APPENDING = "hlsBufferAppending"),
                  (e.BUFFER_APPENDED = "hlsBufferAppended"),
                  (e.BUFFER_EOS = "hlsBufferEos"),
                  (e.BUFFER_FLUSHING = "hlsBufferFlushing"),
                  (e.BUFFER_FLUSHED = "hlsBufferFlushed"),
                  (e.MANIFEST_LOADING = "hlsManifestLoading"),
                  (e.MANIFEST_LOADED = "hlsManifestLoaded"),
                  (e.MANIFEST_PARSED = "hlsManifestParsed"),
                  (e.LEVEL_SWITCHING = "hlsLevelSwitching"),
                  (e.LEVEL_SWITCHED = "hlsLevelSwitched"),
                  (e.LEVEL_LOADING = "hlsLevelLoading"),
                  (e.LEVEL_LOADED = "hlsLevelLoaded"),
                  (e.LEVEL_UPDATED = "hlsLevelUpdated"),
                  (e.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated"),
                  (e.LEVELS_UPDATED = "hlsLevelsUpdated"),
                  (e.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated"),
                  (e.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching"),
                  (e.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched"),
                  (e.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading"),
                  (e.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded"),
                  (e.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated"),
                  (e.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared"),
                  (e.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch"),
                  (e.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading"),
                  (e.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded"),
                  (e.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed"),
                  (e.CUES_PARSED = "hlsCuesParsed"),
                  (e.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound"),
                  (e.INIT_PTS_FOUND = "hlsInitPtsFound"),
                  (e.FRAG_LOADING = "hlsFragLoading"),
                  (e.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted"),
                  (e.FRAG_LOADED = "hlsFragLoaded"),
                  (e.FRAG_DECRYPTED = "hlsFragDecrypted"),
                  (e.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment"),
                  (e.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata"),
                  (e.FRAG_PARSING_METADATA = "hlsFragParsingMetadata"),
                  (e.FRAG_PARSED = "hlsFragParsed"),
                  (e.FRAG_BUFFERED = "hlsFragBuffered"),
                  (e.FRAG_CHANGED = "hlsFragChanged"),
                  (e.FPS_DROP = "hlsFpsDrop"),
                  (e.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping"),
                  (e.ERROR = "hlsError"),
                  (e.DESTROYING = "hlsDestroying"),
                  (e.KEY_LOADING = "hlsKeyLoading"),
                  (e.KEY_LOADED = "hlsKeyLoaded"),
                  (e.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached"),
                  (e.BACK_BUFFER_REACHED = "hlsBackBufferReached");
              })(i || (i = {}));
          },
          "./src/hls.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return y;
              });
            var i = r("./node_modules/url-toolkit/src/url-toolkit.js"),
              n = r("./src/loader/playlist-loader.ts"),
              s = r("./src/loader/key-loader.ts"),
              a = r("./src/controller/id3-track-controller.ts"),
              o = r("./src/controller/latency-controller.ts"),
              l = r("./src/controller/level-controller.ts"),
              u = r("./src/controller/fragment-tracker.ts"),
              d = r("./src/controller/stream-controller.ts"),
              c = r("./src/is-supported.ts"),
              h = r("./src/utils/logger.ts"),
              f = r("./src/config.ts"),
              p = r("./node_modules/eventemitter3/index.js"),
              v = r("./src/events.ts"),
              g = r("./src/errors.ts");
            function m(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var y = (function() {
              function e(t) {
                void 0 === t && (t = {}),
                  (this.config = void 0),
                  (this.userConfig = void 0),
                  (this.coreComponents = void 0),
                  (this.networkControllers = void 0),
                  (this._emitter = new p.EventEmitter()),
                  (this._autoLevelCapping = void 0),
                  (this.abrController = void 0),
                  (this.bufferController = void 0),
                  (this.capLevelController = void 0),
                  (this.latencyController = void 0),
                  (this.levelController = void 0),
                  (this.streamController = void 0),
                  (this.audioTrackController = void 0),
                  (this.subtitleTrackController = void 0),
                  (this.emeController = void 0),
                  (this.cmcdController = void 0),
                  (this._media = null),
                  (this.url = null);
                var r = (this.config = Object(f.mergeConfig)(e.DefaultConfig, t));
                (this.userConfig = t),
                  Object(h.enableLogs)(r.debug),
                  (this._autoLevelCapping = -1),
                  r.progressive && Object(f.enableStreamingMode)(r);
                var i = r.abrController,
                  c = r.bufferController,
                  v = r.capLevelController,
                  g = r.fpsController,
                  m = (this.abrController = new i(this)),
                  y = (this.bufferController = new c(this)),
                  E = (this.capLevelController = new v(this)),
                  T = new g(this),
                  b = new n.default(this),
                  S = new s.default(this),
                  k = new a.default(this),
                  A = (this.levelController = new l.default(this)),
                  w = new u.FragmentTracker(this),
                  R = (this.streamController = new d.default(this, w));
                E.setStreamController(R), T.setStreamController(R);
                var C = [A, R];
                this.networkControllers = C;
                var L = [b, S, m, y, E, T, k, w];
                (this.audioTrackController = this.createController(r.audioTrackController, null, C)),
                  this.createController(r.audioStreamController, w, C),
                  (this.subtitleTrackController = this.createController(r.subtitleTrackController, null, C)),
                  this.createController(r.subtitleStreamController, w, C),
                  this.createController(r.timelineController, null, L),
                  (this.emeController = this.createController(r.emeController, null, L)),
                  (this.cmcdController = this.createController(r.cmcdController, null, L)),
                  (this.latencyController = this.createController(o.default, null, L)),
                  (this.coreComponents = L);
              }
              e.isSupported = function() {
                return Object(c.isSupported)();
              };
              var t,
                r,
                y,
                E = e.prototype;
              return (
                (E.createController = function(e, t, r) {
                  if (e) {
                    var i = t ? new e(this, t) : new e(this);
                    return r && r.push(i), i;
                  }
                  return null;
                }),
                (E.on = function(e, t, r) {
                  void 0 === r && (r = this), this._emitter.on(e, t, r);
                }),
                (E.once = function(e, t, r) {
                  void 0 === r && (r = this), this._emitter.once(e, t, r);
                }),
                (E.removeAllListeners = function(e) {
                  this._emitter.removeAllListeners(e);
                }),
                (E.off = function(e, t, r, i) {
                  void 0 === r && (r = this), this._emitter.off(e, t, r, i);
                }),
                (E.listeners = function(e) {
                  return this._emitter.listeners(e);
                }),
                (E.emit = function(e, t, r) {
                  return this._emitter.emit(e, t, r);
                }),
                (E.trigger = function(e, t) {
                  if (this.config.debug) return this.emit(e, e, t);
                  try {
                    return this.emit(e, e, t);
                  } catch (t) {
                    h.logger.error(
                      "An internal error happened while handling event " +
                        e +
                        '. Error message: "' +
                        t.message +
                        '". Here is a stacktrace:',
                      t
                    ),
                      this.trigger(v.Events.ERROR, {
                        type: g.ErrorTypes.OTHER_ERROR,
                        details: g.ErrorDetails.INTERNAL_EXCEPTION,
                        fatal: !1,
                        event: e,
                        error: t
                      });
                  }
                  return !1;
                }),
                (E.listenerCount = function(e) {
                  return this._emitter.listenerCount(e);
                }),
                (E.destroy = function() {
                  h.logger.log("destroy"),
                    this.trigger(v.Events.DESTROYING, void 0),
                    this.detachMedia(),
                    this.removeAllListeners(),
                    (this._autoLevelCapping = -1),
                    (this.url = null),
                    this.networkControllers.forEach(function(e) {
                      return e.destroy();
                    }),
                    (this.networkControllers.length = 0),
                    this.coreComponents.forEach(function(e) {
                      return e.destroy();
                    }),
                    (this.coreComponents.length = 0);
                }),
                (E.attachMedia = function(e) {
                  h.logger.log("attachMedia"), (this._media = e), this.trigger(v.Events.MEDIA_ATTACHING, { media: e });
                }),
                (E.detachMedia = function() {
                  h.logger.log("detachMedia"), this.trigger(v.Events.MEDIA_DETACHING, void 0), (this._media = null);
                }),
                (E.loadSource = function(e) {
                  this.stopLoad();
                  var t = this.media,
                    r = this.url,
                    n = (this.url = i.buildAbsoluteURL(self.location.href, e, { alwaysNormalize: !0 }));
                  h.logger.log("loadSource:" + n),
                    t &&
                      r &&
                      r !== n &&
                      this.bufferController.hasSourceTypes() &&
                      (this.detachMedia(), this.attachMedia(t)),
                    this.trigger(v.Events.MANIFEST_LOADING, { url: e });
                }),
                (E.startLoad = function(e) {
                  void 0 === e && (e = -1),
                    h.logger.log("startLoad(" + e + ")"),
                    this.networkControllers.forEach(function(t) {
                      t.startLoad(e);
                    });
                }),
                (E.stopLoad = function() {
                  h.logger.log("stopLoad"),
                    this.networkControllers.forEach(function(e) {
                      e.stopLoad();
                    });
                }),
                (E.swapAudioCodec = function() {
                  h.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
                }),
                (E.recoverMediaError = function() {
                  h.logger.log("recoverMediaError");
                  var e = this._media;
                  this.detachMedia(), e && this.attachMedia(e);
                }),
                (E.removeLevel = function(e, t) {
                  void 0 === t && (t = 0), this.levelController.removeLevel(e, t);
                }),
                (t = e),
                (y = [
                  {
                    key: "version",
                    get: function() {
                      return "1.1.5";
                    }
                  },
                  {
                    key: "Events",
                    get: function() {
                      return v.Events;
                    }
                  },
                  {
                    key: "ErrorTypes",
                    get: function() {
                      return g.ErrorTypes;
                    }
                  },
                  {
                    key: "ErrorDetails",
                    get: function() {
                      return g.ErrorDetails;
                    }
                  },
                  {
                    key: "DefaultConfig",
                    get: function() {
                      return e.defaultConfig ? e.defaultConfig : f.hlsDefaultConfig;
                    },
                    set: function(t) {
                      e.defaultConfig = t;
                    }
                  }
                ]),
                (r = [
                  {
                    key: "levels",
                    get: function() {
                      var e = this.levelController.levels;
                      return e || [];
                    }
                  },
                  {
                    key: "currentLevel",
                    get: function() {
                      return this.streamController.currentLevel;
                    },
                    set: function(e) {
                      h.logger.log("set currentLevel:" + e),
                        (this.loadLevel = e),
                        this.abrController.clearTimer(),
                        this.streamController.immediateLevelSwitch();
                    }
                  },
                  {
                    key: "nextLevel",
                    get: function() {
                      return this.streamController.nextLevel;
                    },
                    set: function(e) {
                      h.logger.log("set nextLevel:" + e),
                        (this.levelController.manualLevel = e),
                        this.streamController.nextLevelSwitch();
                    }
                  },
                  {
                    key: "loadLevel",
                    get: function() {
                      return this.levelController.level;
                    },
                    set: function(e) {
                      h.logger.log("set loadLevel:" + e), (this.levelController.manualLevel = e);
                    }
                  },
                  {
                    key: "nextLoadLevel",
                    get: function() {
                      return this.levelController.nextLoadLevel;
                    },
                    set: function(e) {
                      this.levelController.nextLoadLevel = e;
                    }
                  },
                  {
                    key: "firstLevel",
                    get: function() {
                      return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                    },
                    set: function(e) {
                      h.logger.log("set firstLevel:" + e), (this.levelController.firstLevel = e);
                    }
                  },
                  {
                    key: "startLevel",
                    get: function() {
                      return this.levelController.startLevel;
                    },
                    set: function(e) {
                      h.logger.log("set startLevel:" + e),
                        -1 !== e && (e = Math.max(e, this.minAutoLevel)),
                        (this.levelController.startLevel = e);
                    }
                  },
                  {
                    key: "capLevelToPlayerSize",
                    get: function() {
                      return this.config.capLevelToPlayerSize;
                    },
                    set: function(e) {
                      var t = !!e;
                      t !== this.config.capLevelToPlayerSize &&
                        (t
                          ? this.capLevelController.startCapping()
                          : (this.capLevelController.stopCapping(),
                            (this.autoLevelCapping = -1),
                            this.streamController.nextLevelSwitch()),
                        (this.config.capLevelToPlayerSize = t));
                    }
                  },
                  {
                    key: "autoLevelCapping",
                    get: function() {
                      return this._autoLevelCapping;
                    },
                    set: function(e) {
                      this._autoLevelCapping !== e &&
                        (h.logger.log("set autoLevelCapping:" + e), (this._autoLevelCapping = e));
                    }
                  },
                  {
                    key: "bandwidthEstimate",
                    get: function() {
                      var e = this.abrController.bwEstimator;
                      return e ? e.getEstimate() : NaN;
                    }
                  },
                  {
                    key: "autoLevelEnabled",
                    get: function() {
                      return -1 === this.levelController.manualLevel;
                    }
                  },
                  {
                    key: "manualLevel",
                    get: function() {
                      return this.levelController.manualLevel;
                    }
                  },
                  {
                    key: "minAutoLevel",
                    get: function() {
                      var e = this.levels,
                        t = this.config.minAutoBitrate;
                      if (!e) return 0;
                      for (var r = e.length, i = 0; i < r; i++) if (e[i].maxBitrate > t) return i;
                      return 0;
                    }
                  },
                  {
                    key: "maxAutoLevel",
                    get: function() {
                      var e = this.levels,
                        t = this.autoLevelCapping;
                      return -1 === t && e && e.length ? e.length - 1 : t;
                    }
                  },
                  {
                    key: "nextAutoLevel",
                    get: function() {
                      return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
                    },
                    set: function(e) {
                      this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, e);
                    }
                  },
                  {
                    key: "audioTracks",
                    get: function() {
                      var e = this.audioTrackController;
                      return e ? e.audioTracks : [];
                    }
                  },
                  {
                    key: "audioTrack",
                    get: function() {
                      var e = this.audioTrackController;
                      return e ? e.audioTrack : -1;
                    },
                    set: function(e) {
                      var t = this.audioTrackController;
                      t && (t.audioTrack = e);
                    }
                  },
                  {
                    key: "subtitleTracks",
                    get: function() {
                      var e = this.subtitleTrackController;
                      return e ? e.subtitleTracks : [];
                    }
                  },
                  {
                    key: "subtitleTrack",
                    get: function() {
                      var e = this.subtitleTrackController;
                      return e ? e.subtitleTrack : -1;
                    },
                    set: function(e) {
                      var t = this.subtitleTrackController;
                      t && (t.subtitleTrack = e);
                    }
                  },
                  {
                    key: "media",
                    get: function() {
                      return this._media;
                    }
                  },
                  {
                    key: "subtitleDisplay",
                    get: function() {
                      var e = this.subtitleTrackController;
                      return !!e && e.subtitleDisplay;
                    },
                    set: function(e) {
                      var t = this.subtitleTrackController;
                      t && (t.subtitleDisplay = e);
                    }
                  },
                  {
                    key: "lowLatencyMode",
                    get: function() {
                      return this.config.lowLatencyMode;
                    },
                    set: function(e) {
                      this.config.lowLatencyMode = e;
                    }
                  },
                  {
                    key: "liveSyncPosition",
                    get: function() {
                      return this.latencyController.liveSyncPosition;
                    }
                  },
                  {
                    key: "latency",
                    get: function() {
                      return this.latencyController.latency;
                    }
                  },
                  {
                    key: "maxLatency",
                    get: function() {
                      return this.latencyController.maxLatency;
                    }
                  },
                  {
                    key: "targetLatency",
                    get: function() {
                      return this.latencyController.targetLatency;
                    }
                  },
                  {
                    key: "drift",
                    get: function() {
                      return this.latencyController.drift;
                    }
                  },
                  {
                    key: "forceStartLoad",
                    get: function() {
                      return this.streamController.forceStartLoad;
                    }
                  }
                ]) && m(t.prototype, r),
                y && m(t, y),
                e
              );
            })();
            y.defaultConfig = void 0;
          },
          "./src/is-supported.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "isSupported", function() {
                return s;
              }),
              r.d(t, "changeTypeSupported", function() {
                return a;
              });
            var i = r("./src/utils/mediasource-helper.ts");
            function n() {
              return self.SourceBuffer || self.WebKitSourceBuffer;
            }
            function s() {
              var e = Object(i.getMediaSource)();
              if (!e) return !1;
              var t = n(),
                r =
                  e &&
                  "function" == typeof e.isTypeSupported &&
                  e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),
                s =
                  !t ||
                  (t.prototype &&
                    "function" == typeof t.prototype.appendBuffer &&
                    "function" == typeof t.prototype.remove);
              return !!r && !!s;
            }
            function a() {
              var e,
                t = n();
              return (
                "function" == typeof (null == t || null === (e = t.prototype) || void 0 === e ? void 0 : e.changeType)
              );
            }
          },
          "./src/loader/fragment-loader.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return c;
              }),
              r.d(t, "LoadError", function() {
                return f;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/errors.ts");
            function s(e) {
              var t = "function" == typeof Map ? new Map() : void 0;
              return (s = function(e) {
                if (null === e || ((r = e), -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
                var r;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                  if (t.has(e)) return t.get(e);
                  t.set(e, i);
                }
                function i() {
                  return a(e, arguments, u(this).constructor);
                }
                return (
                  (i.prototype = Object.create(e.prototype, {
                    constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 }
                  })),
                  l(i, e)
                );
              })(e);
            }
            function a(e, t, r) {
              return (a = o()
                ? Reflect.construct
                : function(e, t, r) {
                    var i = [null];
                    i.push.apply(i, t);
                    var n = new (Function.bind.apply(e, i))();
                    return r && l(n, r.prototype), n;
                  }).apply(null, arguments);
            }
            function o() {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
              } catch (e) {
                return !1;
              }
            }
            function l(e, t) {
              return (l =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            function u(e) {
              return (u = Object.setPrototypeOf
                ? Object.getPrototypeOf
                : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                  })(e);
            }
            var d = Math.pow(2, 17),
              c = (function() {
                function e(e) {
                  (this.config = void 0), (this.loader = null), (this.partLoadTimeout = -1), (this.config = e);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    this.loader && (this.loader.destroy(), (this.loader = null));
                  }),
                  (t.abort = function() {
                    this.loader && this.loader.abort();
                  }),
                  (t.load = function(e, t) {
                    var r = this,
                      i = e.url;
                    if (!i)
                      return Promise.reject(
                        new f(
                          {
                            type: n.ErrorTypes.NETWORK_ERROR,
                            details: n.ErrorDetails.FRAG_LOAD_ERROR,
                            fatal: !1,
                            frag: e,
                            networkDetails: null
                          },
                          "Fragment does not have a " + (i ? "part list" : "url")
                        )
                      );
                    this.abort();
                    var s = this.config,
                      a = s.fLoader,
                      o = s.loader;
                    return new Promise(function(i, l) {
                      r.loader && r.loader.destroy();
                      var u = (r.loader = e.loader = a ? new a(s) : new o(s)),
                        c = h(e),
                        p = {
                          timeout: s.fragLoadingTimeOut,
                          maxRetry: 0,
                          retryDelay: 0,
                          maxRetryDelay: s.fragLoadingMaxRetryTimeout,
                          highWaterMark: d
                        };
                      (e.stats = u.stats),
                        u.load(c, p, {
                          onSuccess: function(t, n, s, a) {
                            r.resetLoader(e, u), i({ frag: e, part: null, payload: t.data, networkDetails: a });
                          },
                          onError: function(t, i, s) {
                            r.resetLoader(e, u),
                              l(
                                new f({
                                  type: n.ErrorTypes.NETWORK_ERROR,
                                  details: n.ErrorDetails.FRAG_LOAD_ERROR,
                                  fatal: !1,
                                  frag: e,
                                  response: t,
                                  networkDetails: s
                                })
                              );
                          },
                          onAbort: function(t, i, s) {
                            r.resetLoader(e, u),
                              l(
                                new f({
                                  type: n.ErrorTypes.NETWORK_ERROR,
                                  details: n.ErrorDetails.INTERNAL_ABORTED,
                                  fatal: !1,
                                  frag: e,
                                  networkDetails: s
                                })
                              );
                          },
                          onTimeout: function(t, i, s) {
                            r.resetLoader(e, u),
                              l(
                                new f({
                                  type: n.ErrorTypes.NETWORK_ERROR,
                                  details: n.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                  fatal: !1,
                                  frag: e,
                                  networkDetails: s
                                })
                              );
                          },
                          onProgress: function(r, i, n, s) {
                            t && t({ frag: e, part: null, payload: n, networkDetails: s });
                          }
                        });
                    });
                  }),
                  (t.loadPart = function(e, t, r) {
                    var i = this;
                    this.abort();
                    var s = this.config,
                      a = s.fLoader,
                      o = s.loader;
                    return new Promise(function(l, u) {
                      i.loader && i.loader.destroy();
                      var c = (i.loader = e.loader = a ? new a(s) : new o(s)),
                        p = h(e, t),
                        v = {
                          timeout: s.fragLoadingTimeOut,
                          maxRetry: 0,
                          retryDelay: 0,
                          maxRetryDelay: s.fragLoadingMaxRetryTimeout,
                          highWaterMark: d
                        };
                      (t.stats = c.stats),
                        c.load(p, v, {
                          onSuccess: function(n, s, a, o) {
                            i.resetLoader(e, c), i.updateStatsFromPart(e, t);
                            var u = { frag: e, part: t, payload: n.data, networkDetails: o };
                            r(u), l(u);
                          },
                          onError: function(r, s, a) {
                            i.resetLoader(e, c),
                              u(
                                new f({
                                  type: n.ErrorTypes.NETWORK_ERROR,
                                  details: n.ErrorDetails.FRAG_LOAD_ERROR,
                                  fatal: !1,
                                  frag: e,
                                  part: t,
                                  response: r,
                                  networkDetails: a
                                })
                              );
                          },
                          onAbort: function(r, s, a) {
                            (e.stats.aborted = t.stats.aborted),
                              i.resetLoader(e, c),
                              u(
                                new f({
                                  type: n.ErrorTypes.NETWORK_ERROR,
                                  details: n.ErrorDetails.INTERNAL_ABORTED,
                                  fatal: !1,
                                  frag: e,
                                  part: t,
                                  networkDetails: a
                                })
                              );
                          },
                          onTimeout: function(r, s, a) {
                            i.resetLoader(e, c),
                              u(
                                new f({
                                  type: n.ErrorTypes.NETWORK_ERROR,
                                  details: n.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                  fatal: !1,
                                  frag: e,
                                  part: t,
                                  networkDetails: a
                                })
                              );
                          }
                        });
                    });
                  }),
                  (t.updateStatsFromPart = function(e, t) {
                    var r = e.stats,
                      i = t.stats,
                      n = i.total;
                    if (((r.loaded += i.loaded), n)) {
                      var s = Math.round(e.duration / t.duration),
                        a = Math.min(Math.round(r.loaded / n), s),
                        o = (s - a) * Math.round(r.loaded / a);
                      r.total = r.loaded + o;
                    } else r.total = Math.max(r.loaded, r.total);
                    var l = r.loading,
                      u = i.loading;
                    l.start ? (l.first += u.first - u.start) : ((l.start = u.start), (l.first = u.first)),
                      (l.end = u.end);
                  }),
                  (t.resetLoader = function(e, t) {
                    (e.loader = null),
                      this.loader === t && (self.clearTimeout(this.partLoadTimeout), (this.loader = null)),
                      t.destroy();
                  }),
                  e
                );
              })();
            function h(e, t) {
              void 0 === t && (t = null);
              var r = t || e,
                n = {
                  frag: e,
                  part: t,
                  responseType: "arraybuffer",
                  url: r.url,
                  headers: {},
                  rangeStart: 0,
                  rangeEnd: 0
                },
                s = r.byteRangeStartOffset,
                a = r.byteRangeEndOffset;
              return (
                Object(i.isFiniteNumber)(s) && Object(i.isFiniteNumber)(a) && ((n.rangeStart = s), (n.rangeEnd = a)), n
              );
            }
            var f = (function(e) {
              var t, r;
              function i(t) {
                for (var r, i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
                  n[s - 1] = arguments[s];
                return ((r = e.call.apply(e, [this].concat(n)) || this).data = void 0), (r.data = t), r;
              }
              return (
                (r = e), ((t = i).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), l(t, r), i
              );
            })(s(Error));
          },
          "./src/loader/fragment.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "ElementaryStreamTypes", function() {
                return i;
              }),
              r.d(t, "BaseSegment", function() {
                return f;
              }),
              r.d(t, "Fragment", function() {
                return p;
              }),
              r.d(t, "Part", function() {
                return v;
              });
            var i,
              n = r("./src/polyfills/number.ts"),
              s = r("./node_modules/url-toolkit/src/url-toolkit.js"),
              a = r("./src/utils/logger.ts"),
              o = r("./src/loader/level-key.ts"),
              l = r("./src/loader/load-stats.ts");
            function u(e, t) {
              (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), d(e, t);
            }
            function d(e, t) {
              return (d =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            function c(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            function h(e, t, r) {
              return t && c(e.prototype, t), r && c(e, r), e;
            }
            !(function(e) {
              (e.AUDIO = "audio"), (e.VIDEO = "video"), (e.AUDIOVIDEO = "audiovideo");
            })(i || (i = {}));
            var f = (function() {
                function e(e) {
                  var t;
                  (this._byteRange = null),
                    (this._url = null),
                    (this.baseurl = void 0),
                    (this.relurl = void 0),
                    (this.elementaryStreams = (((t = {})[i.AUDIO] = null),
                    (t[i.VIDEO] = null),
                    (t[i.AUDIOVIDEO] = null),
                    t)),
                    (this.baseurl = e);
                }
                return (
                  (e.prototype.setByteRange = function(e, t) {
                    var r = e.split("@", 2),
                      i = [];
                    1 === r.length ? (i[0] = t ? t.byteRangeEndOffset : 0) : (i[0] = parseInt(r[1])),
                      (i[1] = parseInt(r[0]) + i[0]),
                      (this._byteRange = i);
                  }),
                  h(e, [
                    {
                      key: "byteRange",
                      get: function() {
                        return this._byteRange ? this._byteRange : [];
                      }
                    },
                    {
                      key: "byteRangeStartOffset",
                      get: function() {
                        return this.byteRange[0];
                      }
                    },
                    {
                      key: "byteRangeEndOffset",
                      get: function() {
                        return this.byteRange[1];
                      }
                    },
                    {
                      key: "url",
                      get: function() {
                        return (
                          !this._url &&
                            this.baseurl &&
                            this.relurl &&
                            (this._url = Object(s.buildAbsoluteURL)(this.baseurl, this.relurl, {
                              alwaysNormalize: !0
                            })),
                          this._url || ""
                        );
                      },
                      set: function(e) {
                        this._url = e;
                      }
                    }
                  ]),
                  e
                );
              })(),
              p = (function(e) {
                function t(t, r) {
                  var i;
                  return (
                    ((i = e.call(this, r) || this)._decryptdata = null),
                    (i.rawProgramDateTime = null),
                    (i.programDateTime = null),
                    (i.tagList = []),
                    (i.duration = 0),
                    (i.sn = 0),
                    (i.levelkey = void 0),
                    (i.type = void 0),
                    (i.loader = null),
                    (i.level = -1),
                    (i.cc = 0),
                    (i.startPTS = void 0),
                    (i.endPTS = void 0),
                    (i.appendedPTS = void 0),
                    (i.startDTS = void 0),
                    (i.endDTS = void 0),
                    (i.start = 0),
                    (i.deltaPTS = void 0),
                    (i.maxStartPTS = void 0),
                    (i.minEndPTS = void 0),
                    (i.stats = new l.LoadStats()),
                    (i.urlId = 0),
                    (i.data = void 0),
                    (i.bitrateTest = !1),
                    (i.title = null),
                    (i.initSegment = null),
                    (i.type = t),
                    i
                  );
                }
                u(t, e);
                var r = t.prototype;
                return (
                  (r.createInitializationVector = function(e) {
                    for (var t = new Uint8Array(16), r = 12; r < 16; r++) t[r] = (e >> (8 * (15 - r))) & 255;
                    return t;
                  }),
                  (r.setDecryptDataFromLevelKey = function(e, t) {
                    var r = e;
                    return (
                      "AES-128" === (null == e ? void 0 : e.method) &&
                        e.uri &&
                        !e.iv &&
                        (((r = o.LevelKey.fromURI(e.uri)).method = e.method),
                        (r.iv = this.createInitializationVector(t)),
                        (r.keyFormat = "identity")),
                      r
                    );
                  }),
                  (r.setElementaryStreamInfo = function(e, t, r, i, n, s) {
                    void 0 === s && (s = !1);
                    var a = this.elementaryStreams,
                      o = a[e];
                    o
                      ? ((o.startPTS = Math.min(o.startPTS, t)),
                        (o.endPTS = Math.max(o.endPTS, r)),
                        (o.startDTS = Math.min(o.startDTS, i)),
                        (o.endDTS = Math.max(o.endDTS, n)))
                      : (a[e] = { startPTS: t, endPTS: r, startDTS: i, endDTS: n, partial: s });
                  }),
                  (r.clearElementaryStreamInfo = function() {
                    var e = this.elementaryStreams;
                    (e[i.AUDIO] = null), (e[i.VIDEO] = null), (e[i.AUDIOVIDEO] = null);
                  }),
                  h(t, [
                    {
                      key: "decryptdata",
                      get: function() {
                        if (!this.levelkey && !this._decryptdata) return null;
                        if (!this._decryptdata && this.levelkey) {
                          var e = this.sn;
                          "number" != typeof e &&
                            (this.levelkey &&
                              "AES-128" === this.levelkey.method &&
                              !this.levelkey.iv &&
                              a.logger.warn(
                                'missing IV for initialization segment with method="' +
                                  this.levelkey.method +
                                  '" - compliance issue'
                              ),
                            (e = 0)),
                            (this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, e));
                        }
                        return this._decryptdata;
                      }
                    },
                    {
                      key: "end",
                      get: function() {
                        return this.start + this.duration;
                      }
                    },
                    {
                      key: "endProgramDateTime",
                      get: function() {
                        if (null === this.programDateTime) return null;
                        if (!Object(n.isFiniteNumber)(this.programDateTime)) return null;
                        var e = Object(n.isFiniteNumber)(this.duration) ? this.duration : 0;
                        return this.programDateTime + 1e3 * e;
                      }
                    },
                    {
                      key: "encrypted",
                      get: function() {
                        var e;
                        return !(
                          null === (e = this.decryptdata) ||
                          void 0 === e ||
                          !e.keyFormat ||
                          !this.decryptdata.uri
                        );
                      }
                    }
                  ]),
                  t
                );
              })(f),
              v = (function(e) {
                function t(t, r, i, n, s) {
                  var a;
                  ((a = e.call(this, i) || this).fragOffset = 0),
                    (a.duration = 0),
                    (a.gap = !1),
                    (a.independent = !1),
                    (a.relurl = void 0),
                    (a.fragment = void 0),
                    (a.index = void 0),
                    (a.stats = new l.LoadStats()),
                    (a.duration = t.decimalFloatingPoint("DURATION")),
                    (a.gap = t.bool("GAP")),
                    (a.independent = t.bool("INDEPENDENT")),
                    (a.relurl = t.enumeratedString("URI")),
                    (a.fragment = r),
                    (a.index = n);
                  var o = t.enumeratedString("BYTERANGE");
                  return o && a.setByteRange(o, s), s && (a.fragOffset = s.fragOffset + s.duration), a;
                }
                return (
                  u(t, e),
                  h(t, [
                    {
                      key: "start",
                      get: function() {
                        return this.fragment.start + this.fragOffset;
                      }
                    },
                    {
                      key: "end",
                      get: function() {
                        return this.start + this.duration;
                      }
                    },
                    {
                      key: "loaded",
                      get: function() {
                        var e = this.elementaryStreams;
                        return !!(e.audio || e.video || e.audiovideo);
                      }
                    }
                  ]),
                  t
                );
              })(f);
          },
          "./src/loader/key-loader.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return a;
              });
            var i = r("./src/events.ts"),
              n = r("./src/errors.ts"),
              s = r("./src/utils/logger.ts"),
              a = (function() {
                function e(e) {
                  (this.hls = void 0),
                    (this.loaders = {}),
                    (this.decryptkey = null),
                    (this.decrypturl = null),
                    (this.hls = e),
                    this._registerListeners();
                }
                var t = e.prototype;
                return (
                  (t._registerListeners = function() {
                    this.hls.on(i.Events.KEY_LOADING, this.onKeyLoading, this);
                  }),
                  (t._unregisterListeners = function() {
                    this.hls.off(i.Events.KEY_LOADING, this.onKeyLoading);
                  }),
                  (t.destroy = function() {
                    for (var e in (this._unregisterListeners(), this.loaders)) {
                      var t = this.loaders[e];
                      t && t.destroy();
                    }
                    this.loaders = {};
                  }),
                  (t.onKeyLoading = function(e, t) {
                    var r = t.frag,
                      n = r.type,
                      a = this.loaders[n];
                    if (r.decryptdata) {
                      var o = r.decryptdata.uri;
                      if (o !== this.decrypturl || null === this.decryptkey) {
                        var l = this.hls.config;
                        if ((a && (s.logger.warn("abort previous key loader for type:" + n), a.abort()), !o))
                          return void s.logger.warn("key uri is falsy");
                        var u = l.loader,
                          d = (r.loader = this.loaders[n] = new u(l));
                        (this.decrypturl = o), (this.decryptkey = null);
                        var c = { url: o, frag: r, responseType: "arraybuffer" },
                          h = {
                            timeout: l.fragLoadingTimeOut,
                            maxRetry: 0,
                            retryDelay: l.fragLoadingRetryDelay,
                            maxRetryDelay: l.fragLoadingMaxRetryTimeout,
                            highWaterMark: 0
                          },
                          f = {
                            onSuccess: this.loadsuccess.bind(this),
                            onError: this.loaderror.bind(this),
                            onTimeout: this.loadtimeout.bind(this)
                          };
                        d.load(c, h, f);
                      } else
                        this.decryptkey &&
                          ((r.decryptdata.key = this.decryptkey), this.hls.trigger(i.Events.KEY_LOADED, { frag: r }));
                    } else s.logger.warn("Missing decryption data on fragment in onKeyLoading");
                  }),
                  (t.loadsuccess = function(e, t, r) {
                    var n = r.frag;
                    n.decryptdata
                      ? ((this.decryptkey = n.decryptdata.key = new Uint8Array(e.data)),
                        (n.loader = null),
                        delete this.loaders[n.type],
                        this.hls.trigger(i.Events.KEY_LOADED, { frag: n }))
                      : s.logger.error("after key load, decryptdata unset");
                  }),
                  (t.loaderror = function(e, t) {
                    var r = t.frag,
                      s = r.loader;
                    s && s.abort(),
                      delete this.loaders[r.type],
                      this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.NETWORK_ERROR,
                        details: n.ErrorDetails.KEY_LOAD_ERROR,
                        fatal: !1,
                        frag: r,
                        response: e
                      });
                  }),
                  (t.loadtimeout = function(e, t) {
                    var r = t.frag,
                      s = r.loader;
                    s && s.abort(),
                      delete this.loaders[r.type],
                      this.hls.trigger(i.Events.ERROR, {
                        type: n.ErrorTypes.NETWORK_ERROR,
                        details: n.ErrorDetails.KEY_LOAD_TIMEOUT,
                        fatal: !1,
                        frag: r
                      });
                  }),
                  e
                );
              })();
          },
          "./src/loader/level-details.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "LevelDetails", function() {
                return s;
              });
            var i = r("./src/polyfills/number.ts");
            function n(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var s = (function() {
              function e(e) {
                (this.PTSKnown = !1),
                  (this.alignedSliding = !1),
                  (this.averagetargetduration = void 0),
                  (this.endCC = 0),
                  (this.endSN = 0),
                  (this.fragments = void 0),
                  (this.fragmentHint = void 0),
                  (this.partList = null),
                  (this.live = !0),
                  (this.ageHeader = 0),
                  (this.advancedDateTime = void 0),
                  (this.updated = !0),
                  (this.advanced = !0),
                  (this.availabilityDelay = void 0),
                  (this.misses = 0),
                  (this.needSidxRanges = !1),
                  (this.startCC = 0),
                  (this.startSN = 0),
                  (this.startTimeOffset = null),
                  (this.targetduration = 0),
                  (this.totalduration = 0),
                  (this.type = null),
                  (this.url = void 0),
                  (this.m3u8 = ""),
                  (this.version = null),
                  (this.canBlockReload = !1),
                  (this.canSkipUntil = 0),
                  (this.canSkipDateRanges = !1),
                  (this.skippedSegments = 0),
                  (this.recentlyRemovedDateranges = void 0),
                  (this.partHoldBack = 0),
                  (this.holdBack = 0),
                  (this.partTarget = 0),
                  (this.preloadHint = void 0),
                  (this.renditionReports = void 0),
                  (this.tuneInGoal = 0),
                  (this.deltaUpdateFailed = void 0),
                  (this.driftStartTime = 0),
                  (this.driftEndTime = 0),
                  (this.driftStart = 0),
                  (this.driftEnd = 0),
                  (this.fragments = []),
                  (this.url = e);
              }
              var t, r, s;
              return (
                (e.prototype.reloaded = function(e) {
                  if (!e) return (this.advanced = !0), void (this.updated = !0);
                  var t = this.lastPartSn - e.lastPartSn,
                    r = this.lastPartIndex - e.lastPartIndex;
                  (this.updated = this.endSN !== e.endSN || !!r || !!t),
                    (this.advanced = this.endSN > e.endSN || t > 0 || (0 === t && r > 0)),
                    this.updated || this.advanced
                      ? (this.misses = Math.floor(0.6 * e.misses))
                      : (this.misses = e.misses + 1),
                    (this.availabilityDelay = e.availabilityDelay);
                }),
                (t = e),
                (r = [
                  {
                    key: "hasProgramDateTime",
                    get: function() {
                      return (
                        !!this.fragments.length &&
                        Object(i.isFiniteNumber)(this.fragments[this.fragments.length - 1].programDateTime)
                      );
                    }
                  },
                  {
                    key: "levelTargetDuration",
                    get: function() {
                      return this.averagetargetduration || this.targetduration || 10;
                    }
                  },
                  {
                    key: "drift",
                    get: function() {
                      var e = this.driftEndTime - this.driftStartTime;
                      return e > 0 ? (1e3 * (this.driftEnd - this.driftStart)) / e : 1;
                    }
                  },
                  {
                    key: "edge",
                    get: function() {
                      return this.partEnd || this.fragmentEnd;
                    }
                  },
                  {
                    key: "partEnd",
                    get: function() {
                      var e;
                      return null !== (e = this.partList) && void 0 !== e && e.length
                        ? this.partList[this.partList.length - 1].end
                        : this.fragmentEnd;
                    }
                  },
                  {
                    key: "fragmentEnd",
                    get: function() {
                      var e;
                      return null !== (e = this.fragments) && void 0 !== e && e.length
                        ? this.fragments[this.fragments.length - 1].end
                        : 0;
                    }
                  },
                  {
                    key: "age",
                    get: function() {
                      return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
                    }
                  },
                  {
                    key: "lastPartIndex",
                    get: function() {
                      var e;
                      return null !== (e = this.partList) && void 0 !== e && e.length
                        ? this.partList[this.partList.length - 1].index
                        : -1;
                    }
                  },
                  {
                    key: "lastPartSn",
                    get: function() {
                      var e;
                      return null !== (e = this.partList) && void 0 !== e && e.length
                        ? this.partList[this.partList.length - 1].fragment.sn
                        : this.endSN;
                    }
                  }
                ]) && n(t.prototype, r),
                s && n(t, s),
                e
              );
            })();
          },
          "./src/loader/level-key.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "LevelKey", function() {
                return s;
              });
            var i = r("./node_modules/url-toolkit/src/url-toolkit.js");
            function n(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var s = (function() {
              function e(e, t) {
                (this._uri = null),
                  (this.method = null),
                  (this.keyFormat = null),
                  (this.keyFormatVersions = null),
                  (this.keyID = null),
                  (this.key = null),
                  (this.iv = null),
                  (this._uri = t ? Object(i.buildAbsoluteURL)(e, t, { alwaysNormalize: !0 }) : e);
              }
              var t, r, s;
              return (
                (e.fromURL = function(t, r) {
                  return new e(t, r);
                }),
                (e.fromURI = function(t) {
                  return new e(t);
                }),
                (t = e),
                (r = [
                  {
                    key: "uri",
                    get: function() {
                      return this._uri;
                    }
                  }
                ]) && n(t.prototype, r),
                s && n(t, s),
                e
              );
            })();
          },
          "./src/loader/load-stats.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "LoadStats", function() {
                return i;
              });
            var i = function() {
              (this.aborted = !1),
                (this.loaded = 0),
                (this.retry = 0),
                (this.total = 0),
                (this.chunkCount = 0),
                (this.bwEstimate = 0),
                (this.loading = { start: 0, first: 0, end: 0 }),
                (this.parsing = { start: 0, end: 0 }),
                (this.buffering = { start: 0, first: 0, end: 0 });
            };
          },
          "./src/loader/m3u8-parser.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return g;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./node_modules/url-toolkit/src/url-toolkit.js"),
              s = r("./src/loader/fragment.ts"),
              a = r("./src/loader/level-details.ts"),
              o = r("./src/loader/level-key.ts"),
              l = r("./src/utils/attr-list.ts"),
              u = r("./src/utils/logger.ts"),
              d = r("./src/utils/codecs.ts"),
              c = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g,
              h = /#EXT-X-MEDIA:(.*)/g,
              f = new RegExp(
                [
                  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                  /(?!#) *(\S[\S ]*)/.source,
                  /#EXT-X-BYTERANGE:*(.+)/.source,
                  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                  /#.*/.source
                ].join("|"),
                "g"
              ),
              p = new RegExp(
                [
                  /#(EXTM3U)/.source,
                  /#EXT-X-(PLAYLIST-TYPE):(.+)/.source,
                  /#EXT-X-(MEDIA-SEQUENCE): *(\d+)/.source,
                  /#EXT-X-(SKIP):(.+)/.source,
                  /#EXT-X-(TARGETDURATION): *(\d+)/.source,
                  /#EXT-X-(KEY):(.+)/.source,
                  /#EXT-X-(START):(.+)/.source,
                  /#EXT-X-(ENDLIST)/.source,
                  /#EXT-X-(DISCONTINUITY-SEQ)UENCE: *(\d+)/.source,
                  /#EXT-X-(DIS)CONTINUITY/.source,
                  /#EXT-X-(VERSION):(\d+)/.source,
                  /#EXT-X-(MAP):(.+)/.source,
                  /#EXT-X-(SERVER-CONTROL):(.+)/.source,
                  /#EXT-X-(PART-INF):(.+)/.source,
                  /#EXT-X-(GAP)/.source,
                  /#EXT-X-(BITRATE):\s*(\d+)/.source,
                  /#EXT-X-(PART):(.+)/.source,
                  /#EXT-X-(PRELOAD-HINT):(.+)/.source,
                  /#EXT-X-(RENDITION-REPORT):(.+)/.source,
                  /(#)([^:]*):(.*)/.source,
                  /(#)(.*)(?:.*)\r?\n?/.source
                ].join("|")
              ),
              v = /\.(mp4|m4s|m4v|m4a)$/i,
              g = (function() {
                function e() {}
                return (
                  (e.findGroup = function(e, t) {
                    for (var r = 0; r < e.length; r++) {
                      var i = e[r];
                      if (i.id === t) return i;
                    }
                  }),
                  (e.convertAVC1ToAVCOTI = function(e) {
                    var t = e.split(".");
                    if (t.length > 2) {
                      var r = t.shift() + ".";
                      return (
                        (r += parseInt(t.shift()).toString(16)),
                        (r += ("000" + parseInt(t.shift()).toString(16)).substr(-4))
                      );
                    }
                    return e;
                  }),
                  (e.resolve = function(e, t) {
                    return n.buildAbsoluteURL(t, e, { alwaysNormalize: !0 });
                  }),
                  (e.parseMasterPlaylist = function(t, r) {
                    var i,
                      n = [],
                      s = {},
                      a = !1;
                    for (c.lastIndex = 0; null != (i = c.exec(t)); )
                      if (i[1]) {
                        var o = new l.AttrList(i[1]),
                          u = {
                            attrs: o,
                            bitrate: o.decimalInteger("AVERAGE-BANDWIDTH") || o.decimalInteger("BANDWIDTH"),
                            name: o.NAME,
                            url: e.resolve(i[2], r)
                          },
                          d = o.decimalResolution("RESOLUTION");
                        d && ((u.width = d.width), (u.height = d.height)),
                          m(
                            (o.CODECS || "").split(/[ ,]+/).filter(function(e) {
                              return e;
                            }),
                            u
                          ),
                          u.videoCodec &&
                            -1 !== u.videoCodec.indexOf("avc1") &&
                            (u.videoCodec = e.convertAVC1ToAVCOTI(u.videoCodec)),
                          n.push(u);
                      } else if (i[3]) {
                        var h = new l.AttrList(i[3]);
                        h["DATA-ID"] && ((a = !0), (s[h["DATA-ID"]] = h));
                      }
                    return { levels: n, sessionData: a ? s : null };
                  }),
                  (e.parseMasterPlaylistMedia = function(t, r, i, n) {
                    var s;
                    void 0 === n && (n = []);
                    var a = [],
                      o = 0;
                    for (h.lastIndex = 0; null !== (s = h.exec(t)); ) {
                      var u = new l.AttrList(s[1]);
                      if (u.TYPE === i) {
                        var d = {
                          attrs: u,
                          bitrate: 0,
                          id: o++,
                          groupId: u["GROUP-ID"],
                          instreamId: u["INSTREAM-ID"],
                          name: u.NAME || u.LANGUAGE || "",
                          type: i,
                          default: u.bool("DEFAULT"),
                          autoselect: u.bool("AUTOSELECT"),
                          forced: u.bool("FORCED"),
                          lang: u.LANGUAGE,
                          url: u.URI ? e.resolve(u.URI, r) : ""
                        };
                        if (n.length) {
                          var c = e.findGroup(n, d.groupId) || n[0];
                          y(d, c, "audioCodec"), y(d, c, "textCodec");
                        }
                        a.push(d);
                      }
                    }
                    return a;
                  }),
                  (e.parseLevelPlaylist = function(e, t, r, d, c) {
                    var h,
                      g,
                      m,
                      y = new a.LevelDetails(t),
                      T = y.fragments,
                      b = null,
                      S = 0,
                      k = 0,
                      A = 0,
                      w = 0,
                      R = null,
                      C = new s.Fragment(d, t),
                      L = -1,
                      D = !1;
                    for (f.lastIndex = 0, y.m3u8 = e; null !== (h = f.exec(e)); ) {
                      D &&
                        ((D = !1),
                        ((C = new s.Fragment(d, t)).start = A),
                        (C.sn = S),
                        (C.cc = w),
                        (C.level = r),
                        b && ((C.initSegment = b), (C.rawProgramDateTime = b.rawProgramDateTime)));
                      var _ = h[1];
                      if (_) {
                        C.duration = parseFloat(_);
                        var I = (" " + h[2]).slice(1);
                        (C.title = I || null), C.tagList.push(I ? ["INF", _, I] : ["INF", _]);
                      } else if (h[3])
                        Object(i.isFiniteNumber)(C.duration) &&
                          ((C.start = A),
                          m && (C.levelkey = m),
                          (C.sn = S),
                          (C.level = r),
                          (C.cc = w),
                          (C.urlId = c),
                          T.push(C),
                          (C.relurl = (" " + h[3]).slice(1)),
                          E(C, R),
                          (R = C),
                          (A += C.duration),
                          S++,
                          (k = 0),
                          (D = !0));
                      else if (h[4]) {
                        var x = (" " + h[4]).slice(1);
                        R ? C.setByteRange(x, R) : C.setByteRange(x);
                      } else if (h[5])
                        (C.rawProgramDateTime = (" " + h[5]).slice(1)),
                          C.tagList.push(["PROGRAM-DATE-TIME", C.rawProgramDateTime]),
                          -1 === L && (L = T.length);
                      else {
                        if (!(h = h[0].match(p))) {
                          u.logger.warn("No matches on slow regex match for level playlist!");
                          continue;
                        }
                        for (g = 1; g < h.length && void 0 === h[g]; g++);
                        var O = (" " + h[g]).slice(1),
                          P = (" " + h[g + 1]).slice(1),
                          M = h[g + 2] ? (" " + h[g + 2]).slice(1) : "";
                        switch (O) {
                          case "PLAYLIST-TYPE":
                            y.type = P.toUpperCase();
                            break;
                          case "MEDIA-SEQUENCE":
                            S = y.startSN = parseInt(P);
                            break;
                          case "SKIP":
                            var F = new l.AttrList(P),
                              N = F.decimalInteger("SKIPPED-SEGMENTS");
                            if (Object(i.isFiniteNumber)(N)) {
                              y.skippedSegments = N;
                              for (var B = N; B--; ) T.unshift(null);
                              S += N;
                            }
                            var U = F.enumeratedString("RECENTLY-REMOVED-DATERANGES");
                            U && (y.recentlyRemovedDateranges = U.split("\t"));
                            break;
                          case "TARGETDURATION":
                            y.targetduration = parseFloat(P);
                            break;
                          case "VERSION":
                            y.version = parseInt(P);
                            break;
                          case "EXTM3U":
                            break;
                          case "ENDLIST":
                            y.live = !1;
                            break;
                          case "#":
                            (P || M) && C.tagList.push(M ? [P, M] : [P]);
                            break;
                          case "DIS":
                            w++;
                          case "GAP":
                            C.tagList.push([O]);
                            break;
                          case "BITRATE":
                            C.tagList.push([O, P]);
                            break;
                          case "DISCONTINUITY-SEQ":
                            w = parseInt(P);
                            break;
                          case "KEY":
                            var H,
                              V = new l.AttrList(P),
                              K = V.enumeratedString("METHOD"),
                              W = V.URI,
                              G = V.hexadecimalInteger("IV"),
                              j = V.enumeratedString("KEYFORMATVERSIONS"),
                              Y = V.enumeratedString("KEYID"),
                              q = null != (H = V.enumeratedString("KEYFORMAT")) ? H : "identity";
                            if (
                              [
                                "com.apple.streamingkeydelivery",
                                "com.microsoft.playready",
                                "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",
                                "com.widevine"
                              ].indexOf(q) > -1
                            ) {
                              u.logger.warn("Keyformat " + q + " is not supported from the manifest");
                              continue;
                            }
                            if ("identity" !== q) continue;
                            K &&
                              ((m = o.LevelKey.fromURL(t, W)),
                              W &&
                                ["AES-128", "SAMPLE-AES", "SAMPLE-AES-CENC"].indexOf(K) >= 0 &&
                                ((m.method = K),
                                (m.keyFormat = q),
                                Y && (m.keyID = Y),
                                j && (m.keyFormatVersions = j),
                                (m.iv = G)));
                            break;
                          case "START":
                            var z = new l.AttrList(P).decimalFloatingPoint("TIME-OFFSET");
                            Object(i.isFiniteNumber)(z) && (y.startTimeOffset = z);
                            break;
                          case "MAP":
                            var X = new l.AttrList(P);
                            (C.relurl = X.URI),
                              X.BYTERANGE && C.setByteRange(X.BYTERANGE),
                              (C.level = r),
                              (C.sn = "initSegment"),
                              m && (C.levelkey = m),
                              (C.initSegment = null),
                              (b = C),
                              (D = !0);
                            break;
                          case "SERVER-CONTROL":
                            var Q = new l.AttrList(P);
                            (y.canBlockReload = Q.bool("CAN-BLOCK-RELOAD")),
                              (y.canSkipUntil = Q.optionalFloat("CAN-SKIP-UNTIL", 0)),
                              (y.canSkipDateRanges = y.canSkipUntil > 0 && Q.bool("CAN-SKIP-DATERANGES")),
                              (y.partHoldBack = Q.optionalFloat("PART-HOLD-BACK", 0)),
                              (y.holdBack = Q.optionalFloat("HOLD-BACK", 0));
                            break;
                          case "PART-INF":
                            var J = new l.AttrList(P);
                            y.partTarget = J.decimalFloatingPoint("PART-TARGET");
                            break;
                          case "PART":
                            var $ = y.partList;
                            $ || ($ = y.partList = []);
                            var Z = k > 0 ? $[$.length - 1] : void 0,
                              ee = k++,
                              te = new s.Part(new l.AttrList(P), C, t, ee, Z);
                            $.push(te), (C.duration += te.duration);
                            break;
                          case "PRELOAD-HINT":
                            var re = new l.AttrList(P);
                            y.preloadHint = re;
                            break;
                          case "RENDITION-REPORT":
                            var ie = new l.AttrList(P);
                            (y.renditionReports = y.renditionReports || []), y.renditionReports.push(ie);
                            break;
                          default:
                            u.logger.warn("line parsed but not handled: " + h);
                        }
                      }
                    }
                    R && !R.relurl
                      ? (T.pop(), (A -= R.duration), y.partList && (y.fragmentHint = R))
                      : y.partList && (E(C, R), (C.cc = w), (y.fragmentHint = C));
                    var ne = T.length,
                      se = T[0],
                      ae = T[ne - 1];
                    if ((A += y.skippedSegments * y.targetduration) > 0 && ne && ae) {
                      y.averagetargetduration = A / ne;
                      var oe = ae.sn;
                      (y.endSN = "initSegment" !== oe ? oe : 0),
                        se &&
                          ((y.startCC = se.cc),
                          se.initSegment ||
                            (y.fragments.every(function(e) {
                              return (
                                e.relurl &&
                                ((t = e.relurl),
                                v.test(
                                  null != (r = null === (i = n.parseURL(t)) || void 0 === i ? void 0 : i.path) ? r : ""
                                ))
                              );
                              var t, r, i;
                            }) &&
                              (u.logger.warn(
                                "MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"
                              ),
                              ((C = new s.Fragment(d, t)).relurl = ae.relurl),
                              (C.level = r),
                              (C.sn = "initSegment"),
                              (se.initSegment = C),
                              (y.needSidxRanges = !0))));
                    } else (y.endSN = 0), (y.startCC = 0);
                    return (
                      y.fragmentHint && (A += y.fragmentHint.duration),
                      (y.totalduration = A),
                      (y.endCC = w),
                      L > 0 &&
                        (function(e, t) {
                          for (var r = e[t], i = t; i--; ) {
                            var n = e[i];
                            if (!n) return;
                            (n.programDateTime = r.programDateTime - 1e3 * n.duration), (r = n);
                          }
                        })(T, L),
                      y
                    );
                  }),
                  e
                );
              })();
            function m(e, t) {
              ["video", "audio", "text"].forEach(function(r) {
                var i = e.filter(function(e) {
                  return Object(d.isCodecType)(e, r);
                });
                if (i.length) {
                  var n = i.filter(function(e) {
                    return 0 === e.lastIndexOf("avc1", 0) || 0 === e.lastIndexOf("mp4a", 0);
                  });
                  (t[r + "Codec"] = n.length > 0 ? n[0] : i[0]),
                    (e = e.filter(function(e) {
                      return -1 === i.indexOf(e);
                    }));
                }
              }),
                (t.unknownCodecs = e);
            }
            function y(e, t, r) {
              var i = t[r];
              i && (e[r] = i);
            }
            function E(e, t) {
              e.rawProgramDateTime
                ? (e.programDateTime = Date.parse(e.rawProgramDateTime))
                : null != t && t.programDateTime && (e.programDateTime = t.endProgramDateTime),
                Object(i.isFiniteNumber)(e.programDateTime) ||
                  ((e.programDateTime = null), (e.rawProgramDateTime = null));
            }
          },
          "./src/loader/playlist-loader.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/events.ts"),
              s = r("./src/errors.ts"),
              a = r("./src/utils/logger.ts"),
              o = r("./src/utils/mp4-tools.ts"),
              l = r("./src/loader/m3u8-parser.ts"),
              u = r("./src/types/loader.ts"),
              d = r("./src/utils/attr-list.ts");
            function c(e, t) {
              var r = e.url;
              return (void 0 !== r && 0 !== r.indexOf("data:")) || (r = t.url), r;
            }
            var h = (function() {
              function e(e) {
                (this.hls = void 0), (this.loaders = Object.create(null)), (this.hls = e), this.registerListeners();
              }
              var t = e.prototype;
              return (
                (t.registerListeners = function() {
                  var e = this.hls;
                  e.on(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.on(n.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.on(n.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this),
                    e.on(n.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                }),
                (t.unregisterListeners = function() {
                  var e = this.hls;
                  e.off(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                    e.off(n.Events.LEVEL_LOADING, this.onLevelLoading, this),
                    e.off(n.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this),
                    e.off(n.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                }),
                (t.createInternalLoader = function(e) {
                  var t = this.hls.config,
                    r = t.pLoader,
                    i = t.loader,
                    n = new (r || i)(t);
                  return (e.loader = n), (this.loaders[e.type] = n), n;
                }),
                (t.getInternalLoader = function(e) {
                  return this.loaders[e.type];
                }),
                (t.resetInternalLoader = function(e) {
                  this.loaders[e] && delete this.loaders[e];
                }),
                (t.destroyInternalLoaders = function() {
                  for (var e in this.loaders) {
                    var t = this.loaders[e];
                    t && t.destroy(), this.resetInternalLoader(e);
                  }
                }),
                (t.destroy = function() {
                  this.unregisterListeners(), this.destroyInternalLoaders();
                }),
                (t.onManifestLoading = function(e, t) {
                  var r = t.url;
                  this.load({
                    id: null,
                    groupId: null,
                    level: 0,
                    responseType: "text",
                    type: u.PlaylistContextType.MANIFEST,
                    url: r,
                    deliveryDirectives: null
                  });
                }),
                (t.onLevelLoading = function(e, t) {
                  var r = t.id,
                    i = t.level,
                    n = t.url,
                    s = t.deliveryDirectives;
                  this.load({
                    id: r,
                    groupId: null,
                    level: i,
                    responseType: "text",
                    type: u.PlaylistContextType.LEVEL,
                    url: n,
                    deliveryDirectives: s
                  });
                }),
                (t.onAudioTrackLoading = function(e, t) {
                  var r = t.id,
                    i = t.groupId,
                    n = t.url,
                    s = t.deliveryDirectives;
                  this.load({
                    id: r,
                    groupId: i,
                    level: null,
                    responseType: "text",
                    type: u.PlaylistContextType.AUDIO_TRACK,
                    url: n,
                    deliveryDirectives: s
                  });
                }),
                (t.onSubtitleTrackLoading = function(e, t) {
                  var r = t.id,
                    i = t.groupId,
                    n = t.url,
                    s = t.deliveryDirectives;
                  this.load({
                    id: r,
                    groupId: i,
                    level: null,
                    responseType: "text",
                    type: u.PlaylistContextType.SUBTITLE_TRACK,
                    url: n,
                    deliveryDirectives: s
                  });
                }),
                (t.load = function(e) {
                  var t,
                    r,
                    i,
                    n,
                    s,
                    o,
                    l = this.hls.config,
                    d = this.getInternalLoader(e);
                  if (d) {
                    var c = d.context;
                    if (c && c.url === e.url) return void a.logger.trace("[playlist-loader]: playlist request ongoing");
                    a.logger.log("[playlist-loader]: aborting previous loader for type: " + e.type), d.abort();
                  }
                  switch (e.type) {
                    case u.PlaylistContextType.MANIFEST:
                      (r = l.manifestLoadingMaxRetry),
                        (i = l.manifestLoadingTimeOut),
                        (n = l.manifestLoadingRetryDelay),
                        (s = l.manifestLoadingMaxRetryTimeout);
                      break;
                    case u.PlaylistContextType.LEVEL:
                    case u.PlaylistContextType.AUDIO_TRACK:
                    case u.PlaylistContextType.SUBTITLE_TRACK:
                      (r = 0), (i = l.levelLoadingTimeOut);
                      break;
                    default:
                      (r = l.levelLoadingMaxRetry),
                        (i = l.levelLoadingTimeOut),
                        (n = l.levelLoadingRetryDelay),
                        (s = l.levelLoadingMaxRetryTimeout);
                  }
                  if (
                    ((d = this.createInternalLoader(e)),
                    null !== (t = e.deliveryDirectives) &&
                      void 0 !== t &&
                      t.part &&
                      (e.type === u.PlaylistContextType.LEVEL && null !== e.level
                        ? (o = this.hls.levels[e.level].details)
                        : e.type === u.PlaylistContextType.AUDIO_TRACK && null !== e.id
                          ? (o = this.hls.audioTracks[e.id].details)
                          : e.type === u.PlaylistContextType.SUBTITLE_TRACK &&
                            null !== e.id &&
                            (o = this.hls.subtitleTracks[e.id].details),
                      o))
                  ) {
                    var h = o.partTarget,
                      f = o.targetduration;
                    h && f && (i = Math.min(1e3 * Math.max(3 * h, 0.8 * f), i));
                  }
                  var p = { timeout: i, maxRetry: r, retryDelay: n, maxRetryDelay: s, highWaterMark: 0 },
                    v = {
                      onSuccess: this.loadsuccess.bind(this),
                      onError: this.loaderror.bind(this),
                      onTimeout: this.loadtimeout.bind(this)
                    };
                  d.load(e, p, v);
                }),
                (t.loadsuccess = function(e, t, r, i) {
                  if ((void 0 === i && (i = null), r.isSidxRequest))
                    return this.handleSidxRequest(e, r), void this.handlePlaylistLoaded(e, t, r, i);
                  this.resetInternalLoader(r.type);
                  var n = e.data;
                  0 === n.indexOf("#EXTM3U")
                    ? ((t.parsing.start = performance.now()),
                      n.indexOf("#EXTINF:") > 0 || n.indexOf("#EXT-X-TARGETDURATION:") > 0
                        ? this.handleTrackOrLevelPlaylist(e, t, r, i)
                        : this.handleMasterPlaylist(e, t, r, i))
                    : this.handleManifestParsingError(e, r, "no EXTM3U delimiter", i);
                }),
                (t.loaderror = function(e, t, r) {
                  void 0 === r && (r = null), this.handleNetworkError(t, r, !1, e);
                }),
                (t.loadtimeout = function(e, t, r) {
                  void 0 === r && (r = null), this.handleNetworkError(t, r, !0);
                }),
                (t.handleMasterPlaylist = function(e, t, r, i) {
                  var s = this.hls,
                    o = e.data,
                    u = c(e, r),
                    h = l.default.parseMasterPlaylist(o, u),
                    f = h.levels,
                    p = h.sessionData;
                  if (f.length) {
                    var v = f.map(function(e) {
                        return { id: e.attrs.AUDIO, audioCodec: e.audioCodec };
                      }),
                      g = f.map(function(e) {
                        return { id: e.attrs.SUBTITLES, textCodec: e.textCodec };
                      }),
                      m = l.default.parseMasterPlaylistMedia(o, u, "AUDIO", v),
                      y = l.default.parseMasterPlaylistMedia(o, u, "SUBTITLES", g),
                      E = l.default.parseMasterPlaylistMedia(o, u, "CLOSED-CAPTIONS");
                    m.length &&
                      (m.some(function(e) {
                        return !e.url;
                      }) ||
                        !f[0].audioCodec ||
                        f[0].attrs.AUDIO ||
                        (a.logger.log(
                          "[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"
                        ),
                        m.unshift({
                          type: "main",
                          name: "main",
                          default: !1,
                          autoselect: !1,
                          forced: !1,
                          id: -1,
                          attrs: new d.AttrList({}),
                          bitrate: 0,
                          url: ""
                        }))),
                      s.trigger(n.Events.MANIFEST_LOADED, {
                        levels: f,
                        audioTracks: m,
                        subtitles: y,
                        captions: E,
                        url: u,
                        stats: t,
                        networkDetails: i,
                        sessionData: p
                      });
                  } else this.handleManifestParsingError(e, r, "no level found in manifest", i);
                }),
                (t.handleTrackOrLevelPlaylist = function(e, t, r, a) {
                  var o = this.hls,
                    h = r.id,
                    f = r.level,
                    p = r.type,
                    v = c(e, r),
                    g = Object(i.isFiniteNumber)(h) ? h : 0,
                    m = Object(i.isFiniteNumber)(f) ? f : g,
                    y = (function(e) {
                      switch (e.type) {
                        case u.PlaylistContextType.AUDIO_TRACK:
                          return u.PlaylistLevelType.AUDIO;
                        case u.PlaylistContextType.SUBTITLE_TRACK:
                          return u.PlaylistLevelType.SUBTITLE;
                        default:
                          return u.PlaylistLevelType.MAIN;
                      }
                    })(r),
                    E = l.default.parseLevelPlaylist(e.data, v, m, y, g);
                  if (E.fragments.length) {
                    if (p === u.PlaylistContextType.MANIFEST) {
                      var T = { attrs: new d.AttrList({}), bitrate: 0, details: E, name: "", url: v };
                      o.trigger(n.Events.MANIFEST_LOADED, {
                        levels: [T],
                        audioTracks: [],
                        url: v,
                        stats: t,
                        networkDetails: a,
                        sessionData: null
                      });
                    }
                    if (((t.parsing.end = performance.now()), E.needSidxRanges)) {
                      var b,
                        S = null === (b = E.fragments[0].initSegment) || void 0 === b ? void 0 : b.url;
                      this.load({
                        url: S,
                        isSidxRequest: !0,
                        type: p,
                        level: f,
                        levelDetails: E,
                        id: h,
                        groupId: null,
                        rangeStart: 0,
                        rangeEnd: 2048,
                        responseType: "arraybuffer",
                        deliveryDirectives: null
                      });
                    } else (r.levelDetails = E), this.handlePlaylistLoaded(e, t, r, a);
                  } else
                    o.trigger(n.Events.ERROR, {
                      type: s.ErrorTypes.NETWORK_ERROR,
                      details: s.ErrorDetails.LEVEL_EMPTY_ERROR,
                      fatal: !1,
                      url: v,
                      reason: "no fragments found in level",
                      level: "number" == typeof r.level ? r.level : void 0
                    });
                }),
                (t.handleSidxRequest = function(e, t) {
                  var r = Object(o.parseSegmentIndex)(new Uint8Array(e.data));
                  if (r) {
                    var i = r.references,
                      n = t.levelDetails;
                    i.forEach(function(e, t) {
                      var i = e.info,
                        s = n.fragments[t];
                      0 === s.byteRange.length && s.setByteRange(String(1 + i.end - i.start) + "@" + String(i.start)),
                        s.initSegment && s.initSegment.setByteRange(String(r.moovEndOffset) + "@0");
                    });
                  }
                }),
                (t.handleManifestParsingError = function(e, t, r, i) {
                  this.hls.trigger(n.Events.ERROR, {
                    type: s.ErrorTypes.NETWORK_ERROR,
                    details: s.ErrorDetails.MANIFEST_PARSING_ERROR,
                    fatal: t.type === u.PlaylistContextType.MANIFEST,
                    url: e.url,
                    reason: r,
                    response: e,
                    context: t,
                    networkDetails: i
                  });
                }),
                (t.handleNetworkError = function(e, t, r, i) {
                  void 0 === r && (r = !1),
                    a.logger.warn(
                      "[playlist-loader]: A network " +
                        (r ? "timeout" : "error") +
                        " occurred while loading " +
                        e.type +
                        " level: " +
                        e.level +
                        " id: " +
                        e.id +
                        ' group-id: "' +
                        e.groupId +
                        '"'
                    );
                  var o = s.ErrorDetails.UNKNOWN,
                    l = !1,
                    d = this.getInternalLoader(e);
                  switch (e.type) {
                    case u.PlaylistContextType.MANIFEST:
                      (o = r ? s.ErrorDetails.MANIFEST_LOAD_TIMEOUT : s.ErrorDetails.MANIFEST_LOAD_ERROR), (l = !0);
                      break;
                    case u.PlaylistContextType.LEVEL:
                      (o = r ? s.ErrorDetails.LEVEL_LOAD_TIMEOUT : s.ErrorDetails.LEVEL_LOAD_ERROR), (l = !1);
                      break;
                    case u.PlaylistContextType.AUDIO_TRACK:
                      (o = r ? s.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : s.ErrorDetails.AUDIO_TRACK_LOAD_ERROR),
                        (l = !1);
                      break;
                    case u.PlaylistContextType.SUBTITLE_TRACK:
                      (o = r ? s.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : s.ErrorDetails.SUBTITLE_LOAD_ERROR),
                        (l = !1);
                  }
                  d && this.resetInternalLoader(e.type);
                  var c = {
                    type: s.ErrorTypes.NETWORK_ERROR,
                    details: o,
                    fatal: l,
                    url: e.url,
                    loader: d,
                    context: e,
                    networkDetails: t
                  };
                  i && (c.response = i), this.hls.trigger(n.Events.ERROR, c);
                }),
                (t.handlePlaylistLoaded = function(e, t, r, i) {
                  var s = r.type,
                    a = r.level,
                    o = r.id,
                    l = r.groupId,
                    d = r.loader,
                    c = r.levelDetails,
                    h = r.deliveryDirectives;
                  if (null != c && c.targetduration) {
                    if (d)
                      switch (
                        (c.live &&
                          (d.getCacheAge && (c.ageHeader = d.getCacheAge() || 0),
                          (d.getCacheAge && !isNaN(c.ageHeader)) || (c.ageHeader = 0)),
                        s)
                      ) {
                        case u.PlaylistContextType.MANIFEST:
                        case u.PlaylistContextType.LEVEL:
                          this.hls.trigger(n.Events.LEVEL_LOADED, {
                            details: c,
                            level: a || 0,
                            id: o || 0,
                            stats: t,
                            networkDetails: i,
                            deliveryDirectives: h
                          });
                          break;
                        case u.PlaylistContextType.AUDIO_TRACK:
                          this.hls.trigger(n.Events.AUDIO_TRACK_LOADED, {
                            details: c,
                            id: o || 0,
                            groupId: l || "",
                            stats: t,
                            networkDetails: i,
                            deliveryDirectives: h
                          });
                          break;
                        case u.PlaylistContextType.SUBTITLE_TRACK:
                          this.hls.trigger(n.Events.SUBTITLE_TRACK_LOADED, {
                            details: c,
                            id: o || 0,
                            groupId: l || "",
                            stats: t,
                            networkDetails: i,
                            deliveryDirectives: h
                          });
                      }
                  } else this.handleManifestParsingError(e, r, "invalid target duration", i);
                }),
                e
              );
            })();
            t.default = h;
          },
          "./src/polyfills/number.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "isFiniteNumber", function() {
                return i;
              }),
              r.d(t, "MAX_SAFE_INTEGER", function() {
                return n;
              });
            var i =
                Number.isFinite ||
                function(e) {
                  return "number" == typeof e && isFinite(e);
                },
              n = Number.MAX_SAFE_INTEGER || 9007199254740991;
          },
          "./src/remux/aac-helper.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = (function() {
              function e() {}
              return (
                (e.getSilentFrame = function(e, t) {
                  switch (e) {
                    case "mp4a.40.2":
                      if (1 === t) return new Uint8Array([0, 200, 0, 128, 35, 128]);
                      if (2 === t) return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                      if (3 === t) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                      if (4 === t)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                      if (5 === t)
                        return new Uint8Array([
                          0,
                          200,
                          0,
                          128,
                          32,
                          132,
                          1,
                          38,
                          64,
                          8,
                          100,
                          0,
                          130,
                          48,
                          4,
                          153,
                          0,
                          33,
                          144,
                          2,
                          56
                        ]);
                      if (6 === t)
                        return new Uint8Array([
                          0,
                          200,
                          0,
                          128,
                          32,
                          132,
                          1,
                          38,
                          64,
                          8,
                          100,
                          0,
                          130,
                          48,
                          4,
                          153,
                          0,
                          33,
                          144,
                          2,
                          0,
                          178,
                          0,
                          32,
                          8,
                          224
                        ]);
                      break;
                    default:
                      if (1 === t)
                        return new Uint8Array([
                          1,
                          64,
                          34,
                          128,
                          163,
                          78,
                          230,
                          128,
                          186,
                          8,
                          0,
                          0,
                          0,
                          28,
                          6,
                          241,
                          193,
                          10,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          94
                        ]);
                      if (2 === t)
                        return new Uint8Array([
                          1,
                          64,
                          34,
                          128,
                          163,
                          94,
                          230,
                          128,
                          186,
                          8,
                          0,
                          0,
                          0,
                          0,
                          149,
                          0,
                          6,
                          241,
                          161,
                          10,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          94
                        ]);
                      if (3 === t)
                        return new Uint8Array([
                          1,
                          64,
                          34,
                          128,
                          163,
                          94,
                          230,
                          128,
                          186,
                          8,
                          0,
                          0,
                          0,
                          0,
                          149,
                          0,
                          6,
                          241,
                          161,
                          10,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          90,
                          94
                        ]);
                  }
                }),
                e
              );
            })();
            t.default = i;
          },
          "./src/remux/mp4-generator.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = Math.pow(2, 32) - 1,
              n = (function() {
                function e() {}
                return (
                  (e.init = function() {
                    var t;
                    for (t in ((e.types = {
                      avc1: [],
                      avcC: [],
                      btrt: [],
                      dinf: [],
                      dref: [],
                      esds: [],
                      ftyp: [],
                      hdlr: [],
                      mdat: [],
                      mdhd: [],
                      mdia: [],
                      mfhd: [],
                      minf: [],
                      moof: [],
                      moov: [],
                      mp4a: [],
                      ".mp3": [],
                      mvex: [],
                      mvhd: [],
                      pasp: [],
                      sdtp: [],
                      stbl: [],
                      stco: [],
                      stsc: [],
                      stsd: [],
                      stsz: [],
                      stts: [],
                      tfdt: [],
                      tfhd: [],
                      traf: [],
                      trak: [],
                      trun: [],
                      trex: [],
                      tkhd: [],
                      vmhd: [],
                      smhd: []
                    }),
                    e.types))
                      e.types.hasOwnProperty(t) &&
                        (e.types[t] = [t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3)]);
                    var r = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        118,
                        105,
                        100,
                        101,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        86,
                        105,
                        100,
                        101,
                        111,
                        72,
                        97,
                        110,
                        100,
                        108,
                        101,
                        114,
                        0
                      ]),
                      i = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        115,
                        111,
                        117,
                        110,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        83,
                        111,
                        117,
                        110,
                        100,
                        72,
                        97,
                        110,
                        100,
                        108,
                        101,
                        114,
                        0
                      ]);
                    e.HDLR_TYPES = { video: r, audio: i };
                    var n = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1]),
                      s = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
                    (e.STTS = e.STSC = e.STCO = s),
                      (e.STSZ = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                      (e.VMHD = new Uint8Array([0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0])),
                      (e.SMHD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0])),
                      (e.STSD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]));
                    var a = new Uint8Array([105, 115, 111, 109]),
                      o = new Uint8Array([97, 118, 99, 49]),
                      l = new Uint8Array([0, 0, 0, 1]);
                    (e.FTYP = e.box(e.types.ftyp, a, l, a, o)), (e.DINF = e.box(e.types.dinf, e.box(e.types.dref, n)));
                  }),
                  (e.box = function(e) {
                    for (var t = 8, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
                      i[n - 1] = arguments[n];
                    for (var s = i.length, a = s; s--; ) t += i[s].byteLength;
                    var o = new Uint8Array(t);
                    for (
                      o[0] = (t >> 24) & 255,
                        o[1] = (t >> 16) & 255,
                        o[2] = (t >> 8) & 255,
                        o[3] = 255 & t,
                        o.set(e, 4),
                        s = 0,
                        t = 8;
                      s < a;
                      s++
                    )
                      o.set(i[s], t), (t += i[s].byteLength);
                    return o;
                  }),
                  (e.hdlr = function(t) {
                    return e.box(e.types.hdlr, e.HDLR_TYPES[t]);
                  }),
                  (e.mdat = function(t) {
                    return e.box(e.types.mdat, t);
                  }),
                  (e.mdhd = function(t, r) {
                    r *= t;
                    var n = Math.floor(r / (i + 1)),
                      s = Math.floor(r % (i + 1));
                    return e.box(
                      e.types.mdhd,
                      new Uint8Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        (t >> 24) & 255,
                        (t >> 16) & 255,
                        (t >> 8) & 255,
                        255 & t,
                        n >> 24,
                        (n >> 16) & 255,
                        (n >> 8) & 255,
                        255 & n,
                        s >> 24,
                        (s >> 16) & 255,
                        (s >> 8) & 255,
                        255 & s,
                        85,
                        196,
                        0,
                        0
                      ])
                    );
                  }),
                  (e.mdia = function(t) {
                    return e.box(e.types.mdia, e.mdhd(t.timescale, t.duration), e.hdlr(t.type), e.minf(t));
                  }),
                  (e.mfhd = function(t) {
                    return e.box(
                      e.types.mfhd,
                      new Uint8Array([0, 0, 0, 0, t >> 24, (t >> 16) & 255, (t >> 8) & 255, 255 & t])
                    );
                  }),
                  (e.minf = function(t) {
                    return "audio" === t.type
                      ? e.box(e.types.minf, e.box(e.types.smhd, e.SMHD), e.DINF, e.stbl(t))
                      : e.box(e.types.minf, e.box(e.types.vmhd, e.VMHD), e.DINF, e.stbl(t));
                  }),
                  (e.moof = function(t, r, i) {
                    return e.box(e.types.moof, e.mfhd(t), e.traf(i, r));
                  }),
                  (e.moov = function(t) {
                    for (var r = t.length, i = []; r--; ) i[r] = e.trak(t[r]);
                    return e.box.apply(
                      null,
                      [e.types.moov, e.mvhd(t[0].timescale, t[0].duration)].concat(i).concat(e.mvex(t))
                    );
                  }),
                  (e.mvex = function(t) {
                    for (var r = t.length, i = []; r--; ) i[r] = e.trex(t[r]);
                    return e.box.apply(null, [e.types.mvex].concat(i));
                  }),
                  (e.mvhd = function(t, r) {
                    r *= t;
                    var n = Math.floor(r / (i + 1)),
                      s = Math.floor(r % (i + 1)),
                      a = new Uint8Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        (t >> 24) & 255,
                        (t >> 16) & 255,
                        (t >> 8) & 255,
                        255 & t,
                        n >> 24,
                        (n >> 16) & 255,
                        (n >> 8) & 255,
                        255 & n,
                        s >> 24,
                        (s >> 16) & 255,
                        (s >> 8) & 255,
                        255 & s,
                        0,
                        1,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        64,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        255,
                        255,
                        255,
                        255
                      ]);
                    return e.box(e.types.mvhd, a);
                  }),
                  (e.sdtp = function(t) {
                    var r,
                      i,
                      n = t.samples || [],
                      s = new Uint8Array(4 + n.length);
                    for (r = 0; r < n.length; r++)
                      (i = n[r].flags), (s[r + 4] = (i.dependsOn << 4) | (i.isDependedOn << 2) | i.hasRedundancy);
                    return e.box(e.types.sdtp, s);
                  }),
                  (e.stbl = function(t) {
                    return e.box(
                      e.types.stbl,
                      e.stsd(t),
                      e.box(e.types.stts, e.STTS),
                      e.box(e.types.stsc, e.STSC),
                      e.box(e.types.stsz, e.STSZ),
                      e.box(e.types.stco, e.STCO)
                    );
                  }),
                  (e.avc1 = function(t) {
                    var r,
                      i,
                      n,
                      s = [],
                      a = [];
                    for (r = 0; r < t.sps.length; r++)
                      (n = (i = t.sps[r]).byteLength),
                        s.push((n >>> 8) & 255),
                        s.push(255 & n),
                        (s = s.concat(Array.prototype.slice.call(i)));
                    for (r = 0; r < t.pps.length; r++)
                      (n = (i = t.pps[r]).byteLength),
                        a.push((n >>> 8) & 255),
                        a.push(255 & n),
                        (a = a.concat(Array.prototype.slice.call(i)));
                    var o = e.box(
                        e.types.avcC,
                        new Uint8Array(
                          [1, s[3], s[4], s[5], 255, 224 | t.sps.length]
                            .concat(s)
                            .concat([t.pps.length])
                            .concat(a)
                        )
                      ),
                      l = t.width,
                      u = t.height,
                      d = t.pixelRatio[0],
                      c = t.pixelRatio[1];
                    return e.box(
                      e.types.avc1,
                      new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        (l >> 8) & 255,
                        255 & l,
                        (u >> 8) & 255,
                        255 & u,
                        0,
                        72,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        18,
                        100,
                        97,
                        105,
                        108,
                        121,
                        109,
                        111,
                        116,
                        105,
                        111,
                        110,
                        47,
                        104,
                        108,
                        115,
                        46,
                        106,
                        115,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        17,
                        17
                      ]),
                      o,
                      e.box(e.types.btrt, new Uint8Array([0, 28, 156, 128, 0, 45, 198, 192, 0, 45, 198, 192])),
                      e.box(
                        e.types.pasp,
                        new Uint8Array([
                          d >> 24,
                          (d >> 16) & 255,
                          (d >> 8) & 255,
                          255 & d,
                          c >> 24,
                          (c >> 16) & 255,
                          (c >> 8) & 255,
                          255 & c
                        ])
                      )
                    );
                  }),
                  (e.esds = function(e) {
                    var t = e.config.length;
                    return new Uint8Array(
                      [0, 0, 0, 0, 3, 23 + t, 0, 1, 0, 4, 15 + t, 64, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5]
                        .concat([t])
                        .concat(e.config)
                        .concat([6, 1, 2])
                    );
                  }),
                  (e.mp4a = function(t) {
                    var r = t.samplerate;
                    return e.box(
                      e.types.mp4a,
                      new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        t.channelCount,
                        0,
                        16,
                        0,
                        0,
                        0,
                        0,
                        (r >> 8) & 255,
                        255 & r,
                        0,
                        0
                      ]),
                      e.box(e.types.esds, e.esds(t))
                    );
                  }),
                  (e.mp3 = function(t) {
                    var r = t.samplerate;
                    return e.box(
                      e.types[".mp3"],
                      new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        t.channelCount,
                        0,
                        16,
                        0,
                        0,
                        0,
                        0,
                        (r >> 8) & 255,
                        255 & r,
                        0,
                        0
                      ])
                    );
                  }),
                  (e.stsd = function(t) {
                    return "audio" === t.type
                      ? t.isAAC || "mp3" !== t.codec
                        ? e.box(e.types.stsd, e.STSD, e.mp4a(t))
                        : e.box(e.types.stsd, e.STSD, e.mp3(t))
                      : e.box(e.types.stsd, e.STSD, e.avc1(t));
                  }),
                  (e.tkhd = function(t) {
                    var r = t.id,
                      n = t.duration * t.timescale,
                      s = t.width,
                      a = t.height,
                      o = Math.floor(n / (i + 1)),
                      l = Math.floor(n % (i + 1));
                    return e.box(
                      e.types.tkhd,
                      new Uint8Array([
                        1,
                        0,
                        0,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        (r >> 24) & 255,
                        (r >> 16) & 255,
                        (r >> 8) & 255,
                        255 & r,
                        0,
                        0,
                        0,
                        0,
                        o >> 24,
                        (o >> 16) & 255,
                        (o >> 8) & 255,
                        255 & o,
                        l >> 24,
                        (l >> 16) & 255,
                        (l >> 8) & 255,
                        255 & l,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        64,
                        0,
                        0,
                        0,
                        (s >> 8) & 255,
                        255 & s,
                        0,
                        0,
                        (a >> 8) & 255,
                        255 & a,
                        0,
                        0
                      ])
                    );
                  }),
                  (e.traf = function(t, r) {
                    var n = e.sdtp(t),
                      s = t.id,
                      a = Math.floor(r / (i + 1)),
                      o = Math.floor(r % (i + 1));
                    return e.box(
                      e.types.traf,
                      e.box(
                        e.types.tfhd,
                        new Uint8Array([0, 0, 0, 0, s >> 24, (s >> 16) & 255, (s >> 8) & 255, 255 & s])
                      ),
                      e.box(
                        e.types.tfdt,
                        new Uint8Array([
                          1,
                          0,
                          0,
                          0,
                          a >> 24,
                          (a >> 16) & 255,
                          (a >> 8) & 255,
                          255 & a,
                          o >> 24,
                          (o >> 16) & 255,
                          (o >> 8) & 255,
                          255 & o
                        ])
                      ),
                      e.trun(t, n.length + 16 + 20 + 8 + 16 + 8 + 8),
                      n
                    );
                  }),
                  (e.trak = function(t) {
                    return (t.duration = t.duration || 4294967295), e.box(e.types.trak, e.tkhd(t), e.mdia(t));
                  }),
                  (e.trex = function(t) {
                    var r = t.id;
                    return e.box(
                      e.types.trex,
                      new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        r >> 24,
                        (r >> 16) & 255,
                        (r >> 8) & 255,
                        255 & r,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        1
                      ])
                    );
                  }),
                  (e.trun = function(t, r) {
                    var i,
                      n,
                      s,
                      a,
                      o,
                      l,
                      u = t.samples || [],
                      d = u.length,
                      c = 12 + 16 * d,
                      h = new Uint8Array(c);
                    for (
                      r += 8 + c,
                        h.set(
                          [
                            0,
                            0,
                            15,
                            1,
                            (d >>> 24) & 255,
                            (d >>> 16) & 255,
                            (d >>> 8) & 255,
                            255 & d,
                            (r >>> 24) & 255,
                            (r >>> 16) & 255,
                            (r >>> 8) & 255,
                            255 & r
                          ],
                          0
                        ),
                        i = 0;
                      i < d;
                      i++
                    )
                      (s = (n = u[i]).duration),
                        (a = n.size),
                        (o = n.flags),
                        (l = n.cts),
                        h.set(
                          [
                            (s >>> 24) & 255,
                            (s >>> 16) & 255,
                            (s >>> 8) & 255,
                            255 & s,
                            (a >>> 24) & 255,
                            (a >>> 16) & 255,
                            (a >>> 8) & 255,
                            255 & a,
                            (o.isLeading << 2) | o.dependsOn,
                            (o.isDependedOn << 6) | (o.hasRedundancy << 4) | (o.paddingValue << 1) | o.isNonSync,
                            61440 & o.degradPrio,
                            15 & o.degradPrio,
                            (l >>> 24) & 255,
                            (l >>> 16) & 255,
                            (l >>> 8) & 255,
                            255 & l
                          ],
                          12 + 16 * i
                        );
                    return e.box(e.types.trun, h);
                  }),
                  (e.initSegment = function(t) {
                    e.types || e.init();
                    var r = e.moov(t),
                      i = new Uint8Array(e.FTYP.byteLength + r.byteLength);
                    return i.set(e.FTYP), i.set(r, e.FTYP.byteLength), i;
                  }),
                  e
                );
              })();
            (n.types = void 0),
              (n.HDLR_TYPES = void 0),
              (n.STTS = void 0),
              (n.STSC = void 0),
              (n.STCO = void 0),
              (n.STSZ = void 0),
              (n.VMHD = void 0),
              (n.SMHD = void 0),
              (n.STSD = void 0),
              (n.FTYP = void 0),
              (n.DINF = void 0),
              (t.default = n);
          },
          "./src/remux/mp4-remuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return v;
              }),
              r.d(t, "normalizePts", function() {
                return g;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/remux/aac-helper.ts"),
              s = r("./src/remux/mp4-generator.ts"),
              a = r("./src/events.ts"),
              o = r("./src/errors.ts"),
              l = r("./src/utils/logger.ts"),
              u = r("./src/types/loader.ts"),
              d = r("./src/utils/timescale-conversion.ts");
            function c() {
              return (c =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var h = null,
              f = null,
              p = !1,
              v = (function() {
                function e(e, t, r, i) {
                  if (
                    (void 0 === i && (i = ""),
                    (this.observer = void 0),
                    (this.config = void 0),
                    (this.typeSupported = void 0),
                    (this.ISGenerated = !1),
                    (this._initPTS = void 0),
                    (this._initDTS = void 0),
                    (this.nextAvcDts = null),
                    (this.nextAudioPts = null),
                    (this.isAudioContiguous = !1),
                    (this.isVideoContiguous = !1),
                    (this.observer = e),
                    (this.config = t),
                    (this.typeSupported = r),
                    (this.ISGenerated = !1),
                    null === h)
                  ) {
                    var n = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                    h = n ? parseInt(n[1]) : 0;
                  }
                  if (null === f) {
                    var s = navigator.userAgent.match(/Safari\/(\d+)/i);
                    f = s ? parseInt(s[1]) : 0;
                  }
                  p = (!!h && h < 75) || (!!f && f < 600);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {}),
                  (t.resetTimeStamp = function(e) {
                    l.logger.log("[mp4-remuxer]: initPTS & initDTS reset"), (this._initPTS = this._initDTS = e);
                  }),
                  (t.resetNextTimestamp = function() {
                    l.logger.log("[mp4-remuxer]: reset next timestamp"),
                      (this.isVideoContiguous = !1),
                      (this.isAudioContiguous = !1);
                  }),
                  (t.resetInitSegment = function() {
                    l.logger.log("[mp4-remuxer]: ISGenerated flag reset"), (this.ISGenerated = !1);
                  }),
                  (t.getVideoStartPts = function(e) {
                    var t = !1,
                      r = e.reduce(function(e, r) {
                        var i = r.pts - e;
                        return i < -4294967296 ? ((t = !0), g(e, r.pts)) : i > 0 ? e : r.pts;
                      }, e[0].pts);
                    return t && l.logger.debug("PTS rollover detected"), r;
                  }),
                  (t.remux = function(e, t, r, i, n, s, a, o) {
                    var d,
                      c,
                      h,
                      f,
                      p,
                      v,
                      m = n,
                      y = n,
                      E = e.pid > -1,
                      T = t.pid > -1,
                      b = t.samples.length,
                      S = e.samples.length > 0,
                      k = b > 1;
                    if (((!E || S) && (!T || k)) || this.ISGenerated || a) {
                      this.ISGenerated || (h = this.generateIS(e, t, n));
                      var A = this.isVideoContiguous,
                        w = -1;
                      if (
                        k &&
                        ((w = (function(e) {
                          for (var t = 0; t < e.length; t++) if (e[t].key) return t;
                          return -1;
                        })(t.samples)),
                        !A && this.config.forceKeyFrameOnDiscontinuity)
                      )
                        if (((v = !0), w > 0)) {
                          l.logger.warn(
                            "[mp4-remuxer]: Dropped " + w + " out of " + b + " video samples due to a missing keyframe"
                          );
                          var R = this.getVideoStartPts(t.samples);
                          (t.samples = t.samples.slice(w)),
                            (t.dropped += w),
                            (y += (t.samples[0].pts - R) / (t.timescale || 9e4));
                        } else
                          -1 === w &&
                            (l.logger.warn("[mp4-remuxer]: No keyframe found out of " + b + " video samples"),
                            (v = !1));
                      if (this.ISGenerated) {
                        if (S && k) {
                          var C = this.getVideoStartPts(t.samples),
                            L = (g(e.samples[0].pts, C) - C) / t.inputTimeScale;
                          (m += Math.max(0, L)), (y += Math.max(0, -L));
                        }
                        if (S) {
                          if (
                            (e.samplerate ||
                              (l.logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"),
                              (h = this.generateIS(e, t, n))),
                            (c = this.remuxAudio(
                              e,
                              m,
                              this.isAudioContiguous,
                              s,
                              T || k || o === u.PlaylistLevelType.AUDIO ? y : void 0
                            )),
                            k)
                          ) {
                            var D = c ? c.endPTS - c.startPTS : 0;
                            t.inputTimeScale ||
                              (l.logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected"),
                              (h = this.generateIS(e, t, n))),
                              (d = this.remuxVideo(t, y, A, D));
                          }
                        } else k && (d = this.remuxVideo(t, y, A, 0));
                        d && ((d.firstKeyFrame = w), (d.independent = -1 !== w));
                      }
                    }
                    return (
                      this.ISGenerated &&
                        (r.samples.length && (p = this.remuxID3(r, n)), i.samples.length && (f = this.remuxText(i, n))),
                      { audio: c, video: d, initSegment: h, independent: v, text: f, id3: p }
                    );
                  }),
                  (t.generateIS = function(e, t, r) {
                    var n,
                      a,
                      o,
                      l = e.samples,
                      u = t.samples,
                      d = this.typeSupported,
                      c = {},
                      h = !Object(i.isFiniteNumber)(this._initPTS),
                      f = "audio/mp4";
                    if (
                      (h && (n = a = 1 / 0),
                      e.config &&
                        l.length &&
                        ((e.timescale = e.samplerate),
                        e.isAAC || (d.mpeg ? ((f = "audio/mpeg"), (e.codec = "")) : d.mp3 && (e.codec = "mp3")),
                        (c.audio = {
                          id: "audio",
                          container: f,
                          codec: e.codec,
                          initSegment: !e.isAAC && d.mpeg ? new Uint8Array(0) : s.default.initSegment([e]),
                          metadata: { channelCount: e.channelCount }
                        }),
                        h && ((o = e.inputTimeScale), (n = a = l[0].pts - Math.round(o * r)))),
                      t.sps &&
                        t.pps &&
                        u.length &&
                        ((t.timescale = t.inputTimeScale),
                        (c.video = {
                          id: "main",
                          container: "video/mp4",
                          codec: t.codec,
                          initSegment: s.default.initSegment([t]),
                          metadata: { width: t.width, height: t.height }
                        }),
                        h))
                    ) {
                      o = t.inputTimeScale;
                      var p = this.getVideoStartPts(u),
                        v = Math.round(o * r);
                      (a = Math.min(a, g(u[0].dts, p) - v)), (n = Math.min(n, p - v));
                    }
                    if (Object.keys(c).length)
                      return (
                        (this.ISGenerated = !0),
                        h && ((this._initPTS = n), (this._initDTS = a)),
                        { tracks: c, initPTS: n, timescale: o }
                      );
                  }),
                  (t.remuxVideo = function(e, t, r, i) {
                    var n,
                      u,
                      f,
                      v = e.inputTimeScale,
                      y = e.samples,
                      E = [],
                      T = y.length,
                      b = this._initPTS,
                      S = this.nextAvcDts,
                      k = 8,
                      A = Number.POSITIVE_INFINITY,
                      w = Number.NEGATIVE_INFINITY,
                      R = 0,
                      C = !1;
                    (r && null !== S) || (S = t * v - (y[0].pts - g(y[0].dts, y[0].pts)));
                    for (var L = 0; L < T; L++) {
                      var D = y[L];
                      (D.pts = g(D.pts - b, S)),
                        (D.dts = g(D.dts - b, S)),
                        D.dts > D.pts && (R = Math.max(Math.min(R, D.pts - D.dts), -18e3)),
                        D.dts < y[L > 0 ? L - 1 : L].dts && (C = !0);
                    }
                    C &&
                      y.sort(function(e, t) {
                        var r = e.dts - t.dts,
                          i = e.pts - t.pts;
                        return r || i;
                      }),
                      (u = y[0].dts),
                      (f = y[y.length - 1].dts);
                    var _ = Math.round((f - u) / (T - 1));
                    if (R < 0) {
                      if (R < -2 * _) {
                        l.logger.warn(
                          "PTS < DTS detected in video samples, offsetting DTS from PTS by " +
                            Object(d.toMsFromMpegTsClock)(-_, !0) +
                            " ms"
                        );
                        for (var I = R, x = 0; x < T; x++)
                          (y[x].dts = I = Math.max(I, y[x].pts - _)), (y[x].pts = Math.max(I, y[x].pts));
                      } else {
                        l.logger.warn(
                          "PTS < DTS detected in video samples, shifting DTS by " +
                            Object(d.toMsFromMpegTsClock)(R, !0) +
                            " ms to overcome this issue"
                        );
                        for (var O = 0; O < T; O++) y[O].dts = y[O].dts + R;
                      }
                      u = y[0].dts;
                    }
                    if (r) {
                      var P = u - S,
                        M = P > _;
                      if (M || P < -1) {
                        M
                          ? l.logger.warn(
                              "AVC: " +
                                Object(d.toMsFromMpegTsClock)(P, !0) +
                                " ms (" +
                                P +
                                "dts) hole between fragments detected, filling it"
                            )
                          : l.logger.warn(
                              "AVC: " +
                                Object(d.toMsFromMpegTsClock)(-P, !0) +
                                " ms (" +
                                P +
                                "dts) overlapping between fragments detected"
                            ),
                          (u = S);
                        var F = y[0].pts - P;
                        (y[0].dts = u),
                          (y[0].pts = F),
                          l.logger.log(
                            "Video: First PTS/DTS adjusted: " +
                              Object(d.toMsFromMpegTsClock)(F, !0) +
                              "/" +
                              Object(d.toMsFromMpegTsClock)(u, !0) +
                              ", delta: " +
                              Object(d.toMsFromMpegTsClock)(P, !0) +
                              " ms"
                          );
                      }
                    }
                    p && (u = Math.max(0, u));
                    for (var N = 0, B = 0, U = 0; U < T; U++) {
                      for (var H = y[U], V = H.units, K = V.length, W = 0, G = 0; G < K; G++) W += V[G].data.length;
                      (B += W),
                        (N += K),
                        (H.length = W),
                        (H.dts = Math.max(H.dts, u)),
                        (H.pts = Math.max(H.pts, H.dts, 0)),
                        (A = Math.min(H.pts, A)),
                        (w = Math.max(H.pts, w));
                    }
                    f = y[T - 1].dts;
                    var j,
                      Y = B + 4 * N + 8;
                    try {
                      j = new Uint8Array(Y);
                    } catch (e) {
                      return void this.observer.emit(a.Events.ERROR, a.Events.ERROR, {
                        type: o.ErrorTypes.MUX_ERROR,
                        details: o.ErrorDetails.REMUX_ALLOC_ERROR,
                        fatal: !1,
                        bytes: Y,
                        reason: "fail allocating video mdat " + Y
                      });
                    }
                    var q = new DataView(j.buffer);
                    q.setUint32(0, Y), j.set(s.default.types.mdat, 4);
                    for (var z = 0; z < T; z++) {
                      for (var X = y[z], Q = X.units, J = 0, $ = 0, Z = Q.length; $ < Z; $++) {
                        var ee = Q[$],
                          te = ee.data,
                          re = ee.data.byteLength;
                        q.setUint32(k, re), (k += 4), j.set(te, k), (k += re), (J += 4 + re);
                      }
                      if (z < T - 1) n = y[z + 1].dts - X.dts;
                      else {
                        var ie = this.config,
                          ne = X.dts - y[z > 0 ? z - 1 : z].dts;
                        if (ie.stretchShortVideoTrack && null !== this.nextAudioPts) {
                          var se = Math.floor(ie.maxBufferHole * v),
                            ae = (i ? A + i * v : this.nextAudioPts) - X.pts;
                          ae > se
                            ? ((n = ae - ne) < 0 && (n = ne),
                              l.logger.log(
                                "[mp4-remuxer]: It is approximately " +
                                  ae / 90 +
                                  " ms to the next segment; using duration " +
                                  n / 90 +
                                  " ms for the last video frame."
                              ))
                            : (n = ne);
                        } else n = ne;
                      }
                      var oe = Math.round(X.pts - X.dts);
                      E.push(new m(X.key, n, J, oe));
                    }
                    if (E.length && h && h < 70) {
                      var le = E[0].flags;
                      (le.dependsOn = 2), (le.isNonSync = 0);
                    }
                    console.assert(void 0 !== n, "mp4SampleDuration must be computed"),
                      (this.nextAvcDts = S = f + n),
                      (this.isVideoContiguous = !0);
                    var ue = {
                      data1: s.default.moof(e.sequenceNumber++, u, c({}, e, { samples: E })),
                      data2: j,
                      startPTS: A / v,
                      endPTS: (w + n) / v,
                      startDTS: u / v,
                      endDTS: S / v,
                      type: "video",
                      hasAudio: !1,
                      hasVideo: !0,
                      nb: E.length,
                      dropped: e.dropped
                    };
                    return (
                      (e.samples = []), (e.dropped = 0), console.assert(j.length, "MDAT length must not be zero"), ue
                    );
                  }),
                  (t.remuxAudio = function(e, t, r, i, u) {
                    var d = e.inputTimeScale,
                      h = d / (e.samplerate ? e.samplerate : d),
                      f = e.isAAC ? 1024 : 1152,
                      p = f * h,
                      v = this._initPTS,
                      y = !e.isAAC && this.typeSupported.mpeg,
                      E = [],
                      T = e.samples,
                      b = y ? 0 : 8,
                      S = this.nextAudioPts || -1,
                      k = t * d;
                    if (
                      ((this.isAudioContiguous = r =
                        r ||
                        (T.length &&
                          S > 0 &&
                          ((i && Math.abs(k - S) < 9e3) || Math.abs(g(T[0].pts - v, k) - S) < 20 * p))),
                      T.forEach(function(e) {
                        e.pts = g(e.pts - v, k);
                      }),
                      !r || S < 0)
                    ) {
                      if (
                        !(T = T.filter(function(e) {
                          return e.pts >= 0;
                        })).length
                      )
                        return;
                      S = 0 === u ? 0 : i ? Math.max(0, k) : T[0].pts;
                    }
                    if (e.isAAC)
                      for (var A = void 0 !== u, w = this.config.maxAudioFramesDrift, R = 0, C = S; R < T.length; R++) {
                        var L = T[R],
                          D = L.pts,
                          _ = D - C,
                          I = Math.abs((1e3 * _) / d);
                        if (_ <= -w * p && A)
                          0 === R &&
                            (l.logger.warn(
                              "Audio frame @ " +
                                (D / d).toFixed(3) +
                                "s overlaps nextAudioPts by " +
                                Math.round((1e3 * _) / d) +
                                " ms."
                            ),
                            (this.nextAudioPts = S = C = D));
                        else if (_ >= w * p && I < 1e4 && A) {
                          var x = Math.round(_ / p);
                          (C = D - x * p) < 0 && (x--, (C += p)),
                            0 === R && (this.nextAudioPts = S = C),
                            l.logger.warn(
                              "[mp4-remuxer]: Injecting " +
                                x +
                                " audio frame @ " +
                                (C / d).toFixed(3) +
                                "s due to " +
                                Math.round((1e3 * _) / d) +
                                " ms gap."
                            );
                          for (var O = 0; O < x; O++) {
                            var P = Math.max(C, 0),
                              M = n.default.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
                            M ||
                              (l.logger.log(
                                "[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."
                              ),
                              (M = L.unit.subarray())),
                              T.splice(R, 0, { unit: M, pts: P }),
                              (C += p),
                              R++;
                          }
                        }
                        (L.pts = C), (C += p);
                      }
                    for (var F, N = null, B = null, U = 0, H = T.length; H--; ) U += T[H].unit.byteLength;
                    for (var V = 0, K = T.length; V < K; V++) {
                      var W = T[V],
                        G = W.unit,
                        j = W.pts;
                      if (null !== B) E[V - 1].duration = Math.round((j - B) / h);
                      else {
                        if ((r && e.isAAC && (j = S), (N = j), !(U > 0))) return;
                        U += b;
                        try {
                          F = new Uint8Array(U);
                        } catch (e) {
                          return void this.observer.emit(a.Events.ERROR, a.Events.ERROR, {
                            type: o.ErrorTypes.MUX_ERROR,
                            details: o.ErrorDetails.REMUX_ALLOC_ERROR,
                            fatal: !1,
                            bytes: U,
                            reason: "fail allocating audio mdat " + U
                          });
                        }
                        y || (new DataView(F.buffer).setUint32(0, U), F.set(s.default.types.mdat, 4));
                      }
                      F.set(G, b);
                      var Y = G.byteLength;
                      (b += Y), E.push(new m(!0, f, Y, 0)), (B = j);
                    }
                    var q = E.length;
                    if (q) {
                      var z = E[E.length - 1];
                      this.nextAudioPts = S = B + h * z.duration;
                      var X = y
                        ? new Uint8Array(0)
                        : s.default.moof(e.sequenceNumber++, N / h, c({}, e, { samples: E }));
                      e.samples = [];
                      var Q = N / d,
                        J = S / d,
                        $ = {
                          data1: X,
                          data2: F,
                          startPTS: Q,
                          endPTS: J,
                          startDTS: Q,
                          endDTS: J,
                          type: "audio",
                          hasAudio: !0,
                          hasVideo: !1,
                          nb: q
                        };
                      return (this.isAudioContiguous = !0), console.assert(F.length, "MDAT length must not be zero"), $;
                    }
                  }),
                  (t.remuxEmptyAudio = function(e, t, r, i) {
                    var s = e.inputTimeScale,
                      a = s / (e.samplerate ? e.samplerate : s),
                      o = this.nextAudioPts,
                      u = (null !== o ? o : i.startDTS * s) + this._initDTS,
                      d = i.endDTS * s + this._initDTS,
                      c = 1024 * a,
                      h = Math.ceil((d - u) / c),
                      f = n.default.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
                    if ((l.logger.warn("[mp4-remuxer]: remux empty Audio"), f)) {
                      for (var p = [], v = 0; v < h; v++) {
                        var g = u + v * c;
                        p.push({ unit: f, pts: g, dts: g });
                      }
                      return (e.samples = p), this.remuxAudio(e, t, r, !1);
                    }
                    l.logger.trace(
                      "[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec"
                    );
                  }),
                  (t.remuxID3 = function(e, t) {
                    var r = e.samples.length;
                    if (r) {
                      for (var i = e.inputTimeScale, n = this._initPTS, s = this._initDTS, a = 0; a < r; a++) {
                        var o = e.samples[a];
                        (o.pts = g(o.pts - n, t * i) / i), (o.dts = g(o.dts - s, t * i) / i);
                      }
                      var l = e.samples;
                      return (e.samples = []), { samples: l };
                    }
                  }),
                  (t.remuxText = function(e, t) {
                    var r = e.samples.length;
                    if (r) {
                      for (var i = e.inputTimeScale, n = this._initPTS, s = 0; s < r; s++) {
                        var a = e.samples[s];
                        a.pts = g(a.pts - n, t * i) / i;
                      }
                      e.samples.sort(function(e, t) {
                        return e.pts - t.pts;
                      });
                      var o = e.samples;
                      return (e.samples = []), { samples: o };
                    }
                  }),
                  e
                );
              })();
            function g(e, t) {
              var r;
              if (null === t) return e;
              for (r = t < e ? -8589934592 : 8589934592; Math.abs(e - t) > 4294967296; ) e += r;
              return e;
            }
            var m = function(e, t, r, i) {
                (this.size = void 0),
                  (this.duration = void 0),
                  (this.cts = void 0),
                  (this.flags = void 0),
                  (this.duration = t),
                  (this.size = r),
                  (this.cts = i),
                  (this.flags = new y(e));
              },
              y = function(e) {
                (this.isLeading = 0),
                  (this.isDependedOn = 0),
                  (this.hasRedundancy = 0),
                  (this.degradPrio = 0),
                  (this.dependsOn = 1),
                  (this.isNonSync = 1),
                  (this.dependsOn = e ? 2 : 1),
                  (this.isNonSync = e ? 0 : 1);
              };
          },
          "./src/remux/passthrough-remuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/utils/mp4-tools.ts"),
              s = r("./src/loader/fragment.ts"),
              a = r("./src/utils/logger.ts"),
              o = (function() {
                function e() {
                  (this.emitInitSegment = !1),
                    (this.audioCodec = void 0),
                    (this.videoCodec = void 0),
                    (this.initData = void 0),
                    (this.initPTS = void 0),
                    (this.initTracks = void 0),
                    (this.lastEndDTS = null);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {}),
                  (t.resetTimeStamp = function(e) {
                    (this.initPTS = e), (this.lastEndDTS = null);
                  }),
                  (t.resetNextTimestamp = function() {
                    this.lastEndDTS = null;
                  }),
                  (t.resetInitSegment = function(e, t, r) {
                    (this.audioCodec = t),
                      (this.videoCodec = r),
                      this.generateInitSegment(e),
                      (this.emitInitSegment = !0);
                  }),
                  (t.generateInitSegment = function(e) {
                    var t = this.audioCodec,
                      r = this.videoCodec;
                    if (!e || !e.byteLength) return (this.initTracks = void 0), void (this.initData = void 0);
                    var i = (this.initData = Object(n.parseInitSegment)(e));
                    t || (t = u(i.audio, s.ElementaryStreamTypes.AUDIO)),
                      r || (r = u(i.video, s.ElementaryStreamTypes.VIDEO));
                    var o = {};
                    i.audio && i.video
                      ? (o.audiovideo = { container: "video/mp4", codec: t + "," + r, initSegment: e, id: "main" })
                      : i.audio
                        ? (o.audio = { container: "audio/mp4", codec: t, initSegment: e, id: "audio" })
                        : i.video
                          ? (o.video = { container: "video/mp4", codec: r, initSegment: e, id: "main" })
                          : a.logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."),
                      (this.initTracks = o);
                  }),
                  (t.remux = function(e, t, r, s, o) {
                    var u = this.initPTS,
                      d = this.lastEndDTS,
                      c = { audio: void 0, video: void 0, text: s, id3: r, initSegment: void 0 };
                    Object(i.isFiniteNumber)(d) || (d = this.lastEndDTS = o || 0);
                    var h = t.samples;
                    if (!h || !h.length) return c;
                    var f = { initPTS: void 0, timescale: 1 },
                      p = this.initData;
                    if (((p && p.length) || (this.generateInitSegment(h), (p = this.initData)), !p || !p.length))
                      return a.logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), c;
                    this.emitInitSegment && ((f.tracks = this.initTracks), (this.emitInitSegment = !1)),
                      Object(i.isFiniteNumber)(u) || (this.initPTS = f.initPTS = u = l(p, h, d));
                    var v = Object(n.getDuration)(h, p),
                      g = d,
                      m = v + g;
                    Object(n.offsetStartDTS)(p, h, u),
                      v > 0
                        ? (this.lastEndDTS = m)
                        : (a.logger.warn("Duration parsed from mp4 should be greater than zero"),
                          this.resetNextTimestamp());
                    var y = !!p.audio,
                      E = !!p.video,
                      T = "";
                    y && (T += "audio"), E && (T += "video");
                    var b = {
                      data1: h,
                      startPTS: g,
                      startDTS: g,
                      endPTS: m,
                      endDTS: m,
                      type: T,
                      hasAudio: y,
                      hasVideo: E,
                      nb: 1,
                      dropped: 0
                    };
                    return (
                      (c.audio = "audio" === b.type ? b : void 0),
                      (c.video = "audio" !== b.type ? b : void 0),
                      (c.text = s),
                      (c.id3 = r),
                      (c.initSegment = f),
                      c
                    );
                  }),
                  e
                );
              })(),
              l = function(e, t, r) {
                return Object(n.getStartDTS)(e, t) - r;
              };
            function u(e, t) {
              var r = null == e ? void 0 : e.codec;
              return r && r.length > 4
                ? r
                : "hvc1" === r
                  ? "hvc1.1.c.L120.90"
                  : "av01" === r
                    ? "av01.0.04M.08"
                    : "avc1" === r || t === s.ElementaryStreamTypes.VIDEO
                      ? "avc1.42e01e"
                      : "mp4a.40.5";
            }
            t.default = o;
          },
          "./src/task-loop.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return i;
              });
            var i = (function() {
              function e() {
                (this._boundTick = void 0),
                  (this._tickTimer = null),
                  (this._tickInterval = null),
                  (this._tickCallCount = 0),
                  (this._boundTick = this.tick.bind(this));
              }
              var t = e.prototype;
              return (
                (t.destroy = function() {
                  this.onHandlerDestroying(), this.onHandlerDestroyed();
                }),
                (t.onHandlerDestroying = function() {
                  this.clearNextTick(), this.clearInterval();
                }),
                (t.onHandlerDestroyed = function() {}),
                (t.hasInterval = function() {
                  return !!this._tickInterval;
                }),
                (t.hasNextTick = function() {
                  return !!this._tickTimer;
                }),
                (t.setInterval = function(e) {
                  return !this._tickInterval && ((this._tickInterval = self.setInterval(this._boundTick, e)), !0);
                }),
                (t.clearInterval = function() {
                  return (
                    !!this._tickInterval && (self.clearInterval(this._tickInterval), (this._tickInterval = null), !0)
                  );
                }),
                (t.clearNextTick = function() {
                  return !!this._tickTimer && (self.clearTimeout(this._tickTimer), (this._tickTimer = null), !0);
                }),
                (t.tick = function() {
                  this._tickCallCount++,
                    1 === this._tickCallCount &&
                      (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), (this._tickCallCount = 0));
                }),
                (t.tickImmediate = function() {
                  this.clearNextTick(), (this._tickTimer = self.setTimeout(this._boundTick, 0));
                }),
                (t.doTick = function() {}),
                e
              );
            })();
          },
          "./src/types/cmcd.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "CMCDVersion", function() {
                return a;
              }),
              r.d(t, "CMCDObjectType", function() {
                return i;
              }),
              r.d(t, "CMCDStreamingFormat", function() {
                return n;
              }),
              r.d(t, "CMCDStreamType", function() {
                return s;
              });
            var i,
              n,
              s,
              a = 1;
            !(function(e) {
              (e.MANIFEST = "m"),
                (e.AUDIO = "a"),
                (e.VIDEO = "v"),
                (e.MUXED = "av"),
                (e.INIT = "i"),
                (e.CAPTION = "c"),
                (e.TIMED_TEXT = "tt"),
                (e.KEY = "k"),
                (e.OTHER = "o");
            })(i || (i = {})),
              (function(e) {
                (e.DASH = "d"), (e.HLS = "h"), (e.SMOOTH = "s"), (e.OTHER = "o");
              })(n || (n = {})),
              (function(e) {
                (e.VOD = "v"), (e.LIVE = "l");
              })(s || (s = {}));
          },
          "./src/types/level.ts": function(e, t, r) {
            "use strict";
            function i(e, t) {
              for (var r = 0; r < t.length; r++) {
                var i = t[r];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            var n;
            function s(e, t) {
              var r = e.canSkipUntil,
                i = e.canSkipDateRanges,
                s = e.endSN;
              return r && (void 0 !== t ? t - s : 0) < r ? (i ? n.v2 : n.Yes) : n.No;
            }
            r.r(t),
              r.d(t, "HlsSkip", function() {
                return n;
              }),
              r.d(t, "getSkipValue", function() {
                return s;
              }),
              r.d(t, "HlsUrlParameters", function() {
                return a;
              }),
              r.d(t, "Level", function() {
                return o;
              }),
              (function(e) {
                (e.No = ""), (e.Yes = "YES"), (e.v2 = "v2");
              })(n || (n = {}));
            var a = (function() {
                function e(e, t, r) {
                  (this.msn = void 0),
                    (this.part = void 0),
                    (this.skip = void 0),
                    (this.msn = e),
                    (this.part = t),
                    (this.skip = r);
                }
                return (
                  (e.prototype.addDirectives = function(e) {
                    var t = new self.URL(e);
                    return (
                      void 0 !== this.msn && t.searchParams.set("_HLS_msn", this.msn.toString()),
                      void 0 !== this.part && t.searchParams.set("_HLS_part", this.part.toString()),
                      this.skip && t.searchParams.set("_HLS_skip", this.skip),
                      t.toString()
                    );
                  }),
                  e
                );
              })(),
              o = (function() {
                function e(e) {
                  (this.attrs = void 0),
                    (this.audioCodec = void 0),
                    (this.bitrate = void 0),
                    (this.codecSet = void 0),
                    (this.height = void 0),
                    (this.id = void 0),
                    (this.name = void 0),
                    (this.videoCodec = void 0),
                    (this.width = void 0),
                    (this.unknownCodecs = void 0),
                    (this.audioGroupIds = void 0),
                    (this.details = void 0),
                    (this.fragmentError = 0),
                    (this.loadError = 0),
                    (this.loaded = void 0),
                    (this.realBitrate = 0),
                    (this.textGroupIds = void 0),
                    (this.url = void 0),
                    (this._urlId = 0),
                    (this.url = [e.url]),
                    (this.attrs = e.attrs),
                    (this.bitrate = e.bitrate),
                    e.details && (this.details = e.details),
                    (this.id = e.id || 0),
                    (this.name = e.name),
                    (this.width = e.width || 0),
                    (this.height = e.height || 0),
                    (this.audioCodec = e.audioCodec),
                    (this.videoCodec = e.videoCodec),
                    (this.unknownCodecs = e.unknownCodecs),
                    (this.codecSet = [e.videoCodec, e.audioCodec]
                      .filter(function(e) {
                        return e;
                      })
                      .join(",")
                      .replace(/\.[^.,]+/g, ""));
                }
                var t, r, n;
                return (
                  (t = e),
                  (r = [
                    {
                      key: "maxBitrate",
                      get: function() {
                        return Math.max(this.realBitrate, this.bitrate);
                      }
                    },
                    {
                      key: "uri",
                      get: function() {
                        return this.url[this._urlId] || "";
                      }
                    },
                    {
                      key: "urlId",
                      get: function() {
                        return this._urlId;
                      },
                      set: function(e) {
                        var t = e % this.url.length;
                        this._urlId !== t && ((this.details = void 0), (this._urlId = t));
                      }
                    }
                  ]) && i(t.prototype, r),
                  n && i(t, n),
                  e
                );
              })();
          },
          "./src/types/loader.ts": function(e, t, r) {
            "use strict";
            var i, n;
            r.r(t),
              r.d(t, "PlaylistContextType", function() {
                return i;
              }),
              r.d(t, "PlaylistLevelType", function() {
                return n;
              }),
              (function(e) {
                (e.MANIFEST = "manifest"),
                  (e.LEVEL = "level"),
                  (e.AUDIO_TRACK = "audioTrack"),
                  (e.SUBTITLE_TRACK = "subtitleTrack");
              })(i || (i = {})),
              (function(e) {
                (e.MAIN = "main"), (e.AUDIO = "audio"), (e.SUBTITLE = "subtitle");
              })(n || (n = {}));
          },
          "./src/types/transmuxer.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "ChunkMetadata", function() {
                return i;
              });
            var i = function(e, t, r, i, n, s) {
              void 0 === i && (i = 0),
                void 0 === n && (n = -1),
                void 0 === s && (s = !1),
                (this.level = void 0),
                (this.sn = void 0),
                (this.part = void 0),
                (this.id = void 0),
                (this.size = void 0),
                (this.partial = void 0),
                (this.transmuxing = { start: 0, executeStart: 0, executeEnd: 0, end: 0 }),
                (this.buffering = {
                  audio: { start: 0, executeStart: 0, executeEnd: 0, end: 0 },
                  video: { start: 0, executeStart: 0, executeEnd: 0, end: 0 },
                  audiovideo: { start: 0, executeStart: 0, executeEnd: 0, end: 0 }
                }),
                (this.level = e),
                (this.sn = t),
                (this.id = r),
                (this.size = i),
                (this.part = n),
                (this.partial = s);
            };
          },
          "./src/utils/attr-list.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "AttrList", function() {
                return s;
              });
            var i = /^(\d+)x(\d+)$/,
              n = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,
              s = (function() {
                function e(t) {
                  for (var r in ("string" == typeof t && (t = e.parseAttrList(t)), t))
                    t.hasOwnProperty(r) && (this[r] = t[r]);
                }
                var t = e.prototype;
                return (
                  (t.decimalInteger = function(e) {
                    var t = parseInt(this[e], 10);
                    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
                  }),
                  (t.hexadecimalInteger = function(e) {
                    if (this[e]) {
                      var t = (this[e] || "0x").slice(2);
                      t = (1 & t.length ? "0" : "") + t;
                      for (var r = new Uint8Array(t.length / 2), i = 0; i < t.length / 2; i++)
                        r[i] = parseInt(t.slice(2 * i, 2 * i + 2), 16);
                      return r;
                    }
                    return null;
                  }),
                  (t.hexadecimalIntegerAsNumber = function(e) {
                    var t = parseInt(this[e], 16);
                    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
                  }),
                  (t.decimalFloatingPoint = function(e) {
                    return parseFloat(this[e]);
                  }),
                  (t.optionalFloat = function(e, t) {
                    var r = this[e];
                    return r ? parseFloat(r) : t;
                  }),
                  (t.enumeratedString = function(e) {
                    return this[e];
                  }),
                  (t.bool = function(e) {
                    return "YES" === this[e];
                  }),
                  (t.decimalResolution = function(e) {
                    var t = i.exec(this[e]);
                    if (null !== t) return { width: parseInt(t[1], 10), height: parseInt(t[2], 10) };
                  }),
                  (e.parseAttrList = function(e) {
                    var t,
                      r = {};
                    for (n.lastIndex = 0; null !== (t = n.exec(e)); ) {
                      var i = t[2];
                      0 === i.indexOf('"') && i.lastIndexOf('"') === i.length - 1 && (i = i.slice(1, -1)),
                        (r[t[1]] = i);
                    }
                    return r;
                  }),
                  e
                );
              })();
          },
          "./src/utils/binary-search.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              (t.default = {
                search: function(e, t) {
                  for (var r = 0, i = e.length - 1, n = null, s = null; r <= i; ) {
                    var a = t((s = e[(n = ((r + i) / 2) | 0)]));
                    if (a > 0) r = n + 1;
                    else {
                      if (!(a < 0)) return s;
                      i = n - 1;
                    }
                  }
                  return null;
                }
              });
          },
          "./src/utils/buffer-helper.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "BufferHelper", function() {
                return s;
              });
            var i = r("./src/utils/logger.ts"),
              n = {
                length: 0,
                start: function() {
                  return 0;
                },
                end: function() {
                  return 0;
                }
              },
              s = (function() {
                function e() {}
                return (
                  (e.isBuffered = function(t, r) {
                    try {
                      if (t)
                        for (var i = e.getBuffered(t), n = 0; n < i.length; n++)
                          if (r >= i.start(n) && r <= i.end(n)) return !0;
                    } catch (e) {}
                    return !1;
                  }),
                  (e.bufferInfo = function(t, r, i) {
                    try {
                      if (t) {
                        var n,
                          s = e.getBuffered(t),
                          a = [];
                        for (n = 0; n < s.length; n++) a.push({ start: s.start(n), end: s.end(n) });
                        return this.bufferedInfo(a, r, i);
                      }
                    } catch (e) {}
                    return { len: 0, start: r, end: r, nextStart: void 0 };
                  }),
                  (e.bufferedInfo = function(e, t, r) {
                    (t = Math.max(0, t)),
                      e.sort(function(e, t) {
                        var r = e.start - t.start;
                        return r || t.end - e.end;
                      });
                    var i = [];
                    if (r)
                      for (var n = 0; n < e.length; n++) {
                        var s = i.length;
                        if (s) {
                          var a = i[s - 1].end;
                          e[n].start - a < r ? e[n].end > a && (i[s - 1].end = e[n].end) : i.push(e[n]);
                        } else i.push(e[n]);
                      }
                    else i = e;
                    for (var o, l = 0, u = t, d = t, c = 0; c < i.length; c++) {
                      var h = i[c].start,
                        f = i[c].end;
                      if (t + r >= h && t < f) (u = h), (l = (d = f) - t);
                      else if (t + r < h) {
                        o = h;
                        break;
                      }
                    }
                    return { len: l, start: u || 0, end: d || 0, nextStart: o };
                  }),
                  (e.getBuffered = function(e) {
                    try {
                      return e.buffered;
                    } catch (e) {
                      return i.logger.log("failed to get media.buffered", e), n;
                    }
                  }),
                  e
                );
              })();
          },
          "./src/utils/cea-608-parser.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "Row", function() {
                return y;
              }),
              r.d(t, "CaptionScreen", function() {
                return E;
              });
            var i,
              n = r("./src/utils/logger.ts"),
              s = {
                42: 225,
                92: 233,
                94: 237,
                95: 243,
                96: 250,
                123: 231,
                124: 247,
                125: 209,
                126: 241,
                127: 9608,
                128: 174,
                129: 176,
                130: 189,
                131: 191,
                132: 8482,
                133: 162,
                134: 163,
                135: 9834,
                136: 224,
                137: 32,
                138: 232,
                139: 226,
                140: 234,
                141: 238,
                142: 244,
                143: 251,
                144: 193,
                145: 201,
                146: 211,
                147: 218,
                148: 220,
                149: 252,
                150: 8216,
                151: 161,
                152: 42,
                153: 8217,
                154: 9473,
                155: 169,
                156: 8480,
                157: 8226,
                158: 8220,
                159: 8221,
                160: 192,
                161: 194,
                162: 199,
                163: 200,
                164: 202,
                165: 203,
                166: 235,
                167: 206,
                168: 207,
                169: 239,
                170: 212,
                171: 217,
                172: 249,
                173: 219,
                174: 171,
                175: 187,
                176: 195,
                177: 227,
                178: 205,
                179: 204,
                180: 236,
                181: 210,
                182: 242,
                183: 213,
                184: 245,
                185: 123,
                186: 125,
                187: 92,
                188: 94,
                189: 95,
                190: 124,
                191: 8764,
                192: 196,
                193: 228,
                194: 214,
                195: 246,
                196: 223,
                197: 165,
                198: 164,
                199: 9475,
                200: 197,
                201: 229,
                202: 216,
                203: 248,
                204: 9487,
                205: 9491,
                206: 9495,
                207: 9499
              },
              a = function(e) {
                var t = e;
                return s.hasOwnProperty(e) && (t = s[e]), String.fromCharCode(t);
              },
              o = 15,
              l = 100,
              u = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 },
              d = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 },
              c = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 },
              h = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 },
              f = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
            !(function(e) {
              (e[(e.ERROR = 0)] = "ERROR"),
                (e[(e.TEXT = 1)] = "TEXT"),
                (e[(e.WARNING = 2)] = "WARNING"),
                (e[(e.INFO = 2)] = "INFO"),
                (e[(e.DEBUG = 3)] = "DEBUG"),
                (e[(e.DATA = 3)] = "DATA");
            })(i || (i = {}));
            var p = (function() {
                function e() {
                  (this.time = null), (this.verboseLevel = i.ERROR);
                }
                return (
                  (e.prototype.log = function(e, t) {
                    this.verboseLevel >= e && n.logger.log(this.time + " [" + e + "] " + t);
                  }),
                  e
                );
              })(),
              v = function(e) {
                for (var t = [], r = 0; r < e.length; r++) t.push(e[r].toString(16));
                return t;
              },
              g = (function() {
                function e(e, t, r, i, n) {
                  (this.foreground = void 0),
                    (this.underline = void 0),
                    (this.italics = void 0),
                    (this.background = void 0),
                    (this.flash = void 0),
                    (this.foreground = e || "white"),
                    (this.underline = t || !1),
                    (this.italics = r || !1),
                    (this.background = i || "black"),
                    (this.flash = n || !1);
                }
                var t = e.prototype;
                return (
                  (t.reset = function() {
                    (this.foreground = "white"),
                      (this.underline = !1),
                      (this.italics = !1),
                      (this.background = "black"),
                      (this.flash = !1);
                  }),
                  (t.setStyles = function(e) {
                    for (
                      var t = ["foreground", "underline", "italics", "background", "flash"], r = 0;
                      r < t.length;
                      r++
                    ) {
                      var i = t[r];
                      e.hasOwnProperty(i) && (this[i] = e[i]);
                    }
                  }),
                  (t.isDefault = function() {
                    return (
                      "white" === this.foreground &&
                      !this.underline &&
                      !this.italics &&
                      "black" === this.background &&
                      !this.flash
                    );
                  }),
                  (t.equals = function(e) {
                    return (
                      this.foreground === e.foreground &&
                      this.underline === e.underline &&
                      this.italics === e.italics &&
                      this.background === e.background &&
                      this.flash === e.flash
                    );
                  }),
                  (t.copy = function(e) {
                    (this.foreground = e.foreground),
                      (this.underline = e.underline),
                      (this.italics = e.italics),
                      (this.background = e.background),
                      (this.flash = e.flash);
                  }),
                  (t.toString = function() {
                    return (
                      "color=" +
                      this.foreground +
                      ", underline=" +
                      this.underline +
                      ", italics=" +
                      this.italics +
                      ", background=" +
                      this.background +
                      ", flash=" +
                      this.flash
                    );
                  }),
                  e
                );
              })(),
              m = (function() {
                function e(e, t, r, i, n, s) {
                  (this.uchar = void 0),
                    (this.penState = void 0),
                    (this.uchar = e || " "),
                    (this.penState = new g(t, r, i, n, s));
                }
                var t = e.prototype;
                return (
                  (t.reset = function() {
                    (this.uchar = " "), this.penState.reset();
                  }),
                  (t.setChar = function(e, t) {
                    (this.uchar = e), this.penState.copy(t);
                  }),
                  (t.setPenState = function(e) {
                    this.penState.copy(e);
                  }),
                  (t.equals = function(e) {
                    return this.uchar === e.uchar && this.penState.equals(e.penState);
                  }),
                  (t.copy = function(e) {
                    (this.uchar = e.uchar), this.penState.copy(e.penState);
                  }),
                  (t.isEmpty = function() {
                    return " " === this.uchar && this.penState.isDefault();
                  }),
                  e
                );
              })(),
              y = (function() {
                function e(e) {
                  (this.chars = void 0),
                    (this.pos = void 0),
                    (this.currPenState = void 0),
                    (this.cueStartTime = void 0),
                    (this.logger = void 0),
                    (this.chars = []);
                  for (var t = 0; t < l; t++) this.chars.push(new m());
                  (this.logger = e), (this.pos = 0), (this.currPenState = new g());
                }
                var t = e.prototype;
                return (
                  (t.equals = function(e) {
                    for (var t = !0, r = 0; r < l; r++)
                      if (!this.chars[r].equals(e.chars[r])) {
                        t = !1;
                        break;
                      }
                    return t;
                  }),
                  (t.copy = function(e) {
                    for (var t = 0; t < l; t++) this.chars[t].copy(e.chars[t]);
                  }),
                  (t.isEmpty = function() {
                    for (var e = !0, t = 0; t < l; t++)
                      if (!this.chars[t].isEmpty()) {
                        e = !1;
                        break;
                      }
                    return e;
                  }),
                  (t.setCursor = function(e) {
                    this.pos !== e && (this.pos = e),
                      this.pos < 0
                        ? (this.logger.log(i.DEBUG, "Negative cursor position " + this.pos), (this.pos = 0))
                        : this.pos > l &&
                          (this.logger.log(i.DEBUG, "Too large cursor position " + this.pos), (this.pos = l));
                  }),
                  (t.moveCursor = function(e) {
                    var t = this.pos + e;
                    if (e > 1) for (var r = this.pos + 1; r < t + 1; r++) this.chars[r].setPenState(this.currPenState);
                    this.setCursor(t);
                  }),
                  (t.backSpace = function() {
                    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                  }),
                  (t.insertChar = function(e) {
                    e >= 144 && this.backSpace();
                    var t = a(e);
                    this.pos >= l
                      ? this.logger.log(
                          i.ERROR,
                          "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!"
                        )
                      : (this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1));
                  }),
                  (t.clearFromPos = function(e) {
                    var t;
                    for (t = e; t < l; t++) this.chars[t].reset();
                  }),
                  (t.clear = function() {
                    this.clearFromPos(0), (this.pos = 0), this.currPenState.reset();
                  }),
                  (t.clearToEndOfRow = function() {
                    this.clearFromPos(this.pos);
                  }),
                  (t.getTextString = function() {
                    for (var e = [], t = !0, r = 0; r < l; r++) {
                      var i = this.chars[r].uchar;
                      " " !== i && (t = !1), e.push(i);
                    }
                    return t ? "" : e.join("");
                  }),
                  (t.setPenStyles = function(e) {
                    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
                  }),
                  e
                );
              })(),
              E = (function() {
                function e(e) {
                  (this.rows = void 0),
                    (this.currRow = void 0),
                    (this.nrRollUpRows = void 0),
                    (this.lastOutputScreen = void 0),
                    (this.logger = void 0),
                    (this.rows = []);
                  for (var t = 0; t < o; t++) this.rows.push(new y(e));
                  (this.logger = e),
                    (this.currRow = 14),
                    (this.nrRollUpRows = null),
                    (this.lastOutputScreen = null),
                    this.reset();
                }
                var t = e.prototype;
                return (
                  (t.reset = function() {
                    for (var e = 0; e < o; e++) this.rows[e].clear();
                    this.currRow = 14;
                  }),
                  (t.equals = function(e) {
                    for (var t = !0, r = 0; r < o; r++)
                      if (!this.rows[r].equals(e.rows[r])) {
                        t = !1;
                        break;
                      }
                    return t;
                  }),
                  (t.copy = function(e) {
                    for (var t = 0; t < o; t++) this.rows[t].copy(e.rows[t]);
                  }),
                  (t.isEmpty = function() {
                    for (var e = !0, t = 0; t < o; t++)
                      if (!this.rows[t].isEmpty()) {
                        e = !1;
                        break;
                      }
                    return e;
                  }),
                  (t.backSpace = function() {
                    this.rows[this.currRow].backSpace();
                  }),
                  (t.clearToEndOfRow = function() {
                    this.rows[this.currRow].clearToEndOfRow();
                  }),
                  (t.insertChar = function(e) {
                    this.rows[this.currRow].insertChar(e);
                  }),
                  (t.setPen = function(e) {
                    this.rows[this.currRow].setPenStyles(e);
                  }),
                  (t.moveCursor = function(e) {
                    this.rows[this.currRow].moveCursor(e);
                  }),
                  (t.setCursor = function(e) {
                    this.logger.log(i.INFO, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
                  }),
                  (t.setPAC = function(e) {
                    this.logger.log(i.INFO, "pacData = " + JSON.stringify(e));
                    var t = e.row - 1;
                    if (
                      (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1),
                      this.nrRollUpRows && this.currRow !== t)
                    ) {
                      for (var r = 0; r < o; r++) this.rows[r].clear();
                      var n = this.currRow + 1 - this.nrRollUpRows,
                        s = this.lastOutputScreen;
                      if (s) {
                        var a = s.rows[n].cueStartTime,
                          l = this.logger.time;
                        if (a && null !== l && a < l)
                          for (var u = 0; u < this.nrRollUpRows; u++)
                            this.rows[t - this.nrRollUpRows + u + 1].copy(s.rows[n + u]);
                      }
                    }
                    this.currRow = t;
                    var d = this.rows[this.currRow];
                    if (null !== e.indent) {
                      var c = e.indent,
                        h = Math.max(c - 1, 0);
                      d.setCursor(e.indent), (e.color = d.chars[h].penState.foreground);
                    }
                    var f = {
                      foreground: e.color,
                      underline: e.underline,
                      italics: e.italics,
                      background: "black",
                      flash: !1
                    };
                    this.setPen(f);
                  }),
                  (t.setBkgData = function(e) {
                    this.logger.log(i.INFO, "bkgData = " + JSON.stringify(e)),
                      this.backSpace(),
                      this.setPen(e),
                      this.insertChar(32);
                  }),
                  (t.setRollUpRows = function(e) {
                    this.nrRollUpRows = e;
                  }),
                  (t.rollUp = function() {
                    if (null !== this.nrRollUpRows) {
                      this.logger.log(i.TEXT, this.getDisplayText());
                      var e = this.currRow + 1 - this.nrRollUpRows,
                        t = this.rows.splice(e, 1)[0];
                      t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(i.INFO, "Rolling up");
                    } else this.logger.log(i.DEBUG, "roll_up but nrRollUpRows not set yet");
                  }),
                  (t.getDisplayText = function(e) {
                    e = e || !1;
                    for (var t = [], r = "", i = -1, n = 0; n < o; n++) {
                      var s = this.rows[n].getTextString();
                      s && ((i = n + 1), e ? t.push("Row " + i + ": '" + s + "'") : t.push(s.trim()));
                    }
                    return t.length > 0 && (r = e ? "[" + t.join(" | ") + "]" : t.join("\n")), r;
                  }),
                  (t.getTextAndFormat = function() {
                    return this.rows;
                  }),
                  e
                );
              })(),
              T = (function() {
                function e(e, t, r) {
                  (this.chNr = void 0),
                    (this.outputFilter = void 0),
                    (this.mode = void 0),
                    (this.verbose = void 0),
                    (this.displayedMemory = void 0),
                    (this.nonDisplayedMemory = void 0),
                    (this.lastOutputScreen = void 0),
                    (this.currRollUpRow = void 0),
                    (this.writeScreen = void 0),
                    (this.cueStartTime = void 0),
                    (this.logger = void 0),
                    (this.chNr = e),
                    (this.outputFilter = t),
                    (this.mode = null),
                    (this.verbose = 0),
                    (this.displayedMemory = new E(r)),
                    (this.nonDisplayedMemory = new E(r)),
                    (this.lastOutputScreen = new E(r)),
                    (this.currRollUpRow = this.displayedMemory.rows[14]),
                    (this.writeScreen = this.displayedMemory),
                    (this.mode = null),
                    (this.cueStartTime = null),
                    (this.logger = r);
                }
                var t = e.prototype;
                return (
                  (t.reset = function() {
                    (this.mode = null),
                      this.displayedMemory.reset(),
                      this.nonDisplayedMemory.reset(),
                      this.lastOutputScreen.reset(),
                      this.outputFilter.reset(),
                      (this.currRollUpRow = this.displayedMemory.rows[14]),
                      (this.writeScreen = this.displayedMemory),
                      (this.mode = null),
                      (this.cueStartTime = null);
                  }),
                  (t.getHandler = function() {
                    return this.outputFilter;
                  }),
                  (t.setHandler = function(e) {
                    this.outputFilter = e;
                  }),
                  (t.setPAC = function(e) {
                    this.writeScreen.setPAC(e);
                  }),
                  (t.setBkgData = function(e) {
                    this.writeScreen.setBkgData(e);
                  }),
                  (t.setMode = function(e) {
                    e !== this.mode &&
                      ((this.mode = e),
                      this.logger.log(i.INFO, "MODE=" + e),
                      "MODE_POP-ON" === this.mode
                        ? (this.writeScreen = this.nonDisplayedMemory)
                        : ((this.writeScreen = this.displayedMemory), this.writeScreen.reset()),
                      "MODE_ROLL-UP" !== this.mode &&
                        ((this.displayedMemory.nrRollUpRows = null), (this.nonDisplayedMemory.nrRollUpRows = null)),
                      (this.mode = e));
                  }),
                  (t.insertChars = function(e) {
                    for (var t = 0; t < e.length; t++) this.writeScreen.insertChar(e[t]);
                    var r = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                    this.logger.log(i.INFO, r + ": " + this.writeScreen.getDisplayText(!0)),
                      ("MODE_PAINT-ON" !== this.mode && "MODE_ROLL-UP" !== this.mode) ||
                        (this.logger.log(i.TEXT, "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)),
                        this.outputDataUpdate());
                  }),
                  (t.ccRCL = function() {
                    this.logger.log(i.INFO, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                  }),
                  (t.ccBS = function() {
                    this.logger.log(i.INFO, "BS - BackSpace"),
                      "MODE_TEXT" !== this.mode &&
                        (this.writeScreen.backSpace(),
                        this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                  }),
                  (t.ccAOF = function() {}),
                  (t.ccAON = function() {}),
                  (t.ccDER = function() {
                    this.logger.log(i.INFO, "DER- Delete to End of Row"),
                      this.writeScreen.clearToEndOfRow(),
                      this.outputDataUpdate();
                  }),
                  (t.ccRU = function(e) {
                    this.logger.log(i.INFO, "RU(" + e + ") - Roll Up"),
                      (this.writeScreen = this.displayedMemory),
                      this.setMode("MODE_ROLL-UP"),
                      this.writeScreen.setRollUpRows(e);
                  }),
                  (t.ccFON = function() {
                    this.logger.log(i.INFO, "FON - Flash On"), this.writeScreen.setPen({ flash: !0 });
                  }),
                  (t.ccRDC = function() {
                    this.logger.log(i.INFO, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                  }),
                  (t.ccTR = function() {
                    this.logger.log(i.INFO, "TR"), this.setMode("MODE_TEXT");
                  }),
                  (t.ccRTD = function() {
                    this.logger.log(i.INFO, "RTD"), this.setMode("MODE_TEXT");
                  }),
                  (t.ccEDM = function() {
                    this.logger.log(i.INFO, "EDM - Erase Displayed Memory"),
                      this.displayedMemory.reset(),
                      this.outputDataUpdate(!0);
                  }),
                  (t.ccCR = function() {
                    this.logger.log(i.INFO, "CR - Carriage Return"),
                      this.writeScreen.rollUp(),
                      this.outputDataUpdate(!0);
                  }),
                  (t.ccENM = function() {
                    this.logger.log(i.INFO, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                  }),
                  (t.ccEOC = function() {
                    if ((this.logger.log(i.INFO, "EOC - End Of Caption"), "MODE_POP-ON" === this.mode)) {
                      var e = this.displayedMemory;
                      (this.displayedMemory = this.nonDisplayedMemory),
                        (this.nonDisplayedMemory = e),
                        (this.writeScreen = this.nonDisplayedMemory),
                        this.logger.log(i.TEXT, "DISP: " + this.displayedMemory.getDisplayText());
                    }
                    this.outputDataUpdate(!0);
                  }),
                  (t.ccTO = function(e) {
                    this.logger.log(i.INFO, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
                  }),
                  (t.ccMIDROW = function(e) {
                    var t = { flash: !1 };
                    if (((t.underline = e % 2 == 1), (t.italics = e >= 46), t.italics)) t.foreground = "white";
                    else {
                      var r = Math.floor(e / 2) - 16;
                      t.foreground = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"][r];
                    }
                    this.logger.log(i.INFO, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
                  }),
                  (t.outputDataUpdate = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.logger.time;
                    null !== t &&
                      this.outputFilter &&
                      (null !== this.cueStartTime || this.displayedMemory.isEmpty()
                        ? this.displayedMemory.equals(this.lastOutputScreen) ||
                          (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen),
                          e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(),
                          (this.cueStartTime = this.displayedMemory.isEmpty() ? null : t))
                        : (this.cueStartTime = t),
                      this.lastOutputScreen.copy(this.displayedMemory));
                  }),
                  (t.cueSplitAtTime = function(e) {
                    this.outputFilter &&
                      (this.displayedMemory.isEmpty() ||
                        (this.outputFilter.newCue &&
                          this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory),
                        (this.cueStartTime = e)));
                  }),
                  e
                );
              })(),
              b = (function() {
                function e(e, t, r) {
                  (this.channels = void 0),
                    (this.currentChannel = 0),
                    (this.cmdHistory = void 0),
                    (this.logger = void 0);
                  var i = new p();
                  (this.channels = [null, new T(e, t, i), new T(e + 1, r, i)]),
                    (this.cmdHistory = { a: null, b: null }),
                    (this.logger = i);
                }
                var t = e.prototype;
                return (
                  (t.getHandler = function(e) {
                    return this.channels[e].getHandler();
                  }),
                  (t.setHandler = function(e, t) {
                    this.channels[e].setHandler(t);
                  }),
                  (t.addData = function(e, t) {
                    var r,
                      n,
                      s,
                      a = !1;
                    this.logger.time = e;
                    for (var o = 0; o < t.length; o += 2)
                      if (((n = 127 & t[o]), (s = 127 & t[o + 1]), 0 !== n || 0 !== s)) {
                        if (
                          (this.logger.log(i.DATA, "[" + v([t[o], t[o + 1]]) + "] -> (" + v([n, s]) + ")"),
                          (r = this.parseCmd(n, s)) || (r = this.parseMidrow(n, s)),
                          r || (r = this.parsePAC(n, s)),
                          r || (r = this.parseBackgroundAttributes(n, s)),
                          !r && (a = this.parseChars(n, s)))
                        ) {
                          var l = this.currentChannel;
                          l && l > 0
                            ? this.channels[l].insertChars(a)
                            : this.logger.log(i.WARNING, "No channel found yet. TEXT-MODE?");
                        }
                        r ||
                          a ||
                          this.logger.log(
                            i.WARNING,
                            "Couldn't parse cleaned data " + v([n, s]) + " orig: " + v([t[o], t[o + 1]])
                          );
                      }
                  }),
                  (t.parseCmd = function(e, t) {
                    var r = this.cmdHistory;
                    if (
                      !(
                        ((20 === e || 28 === e || 21 === e || 29 === e) && t >= 32 && t <= 47) ||
                        ((23 === e || 31 === e) && t >= 33 && t <= 35)
                      )
                    )
                      return !1;
                    if (k(e, t, r))
                      return (
                        S(null, null, r),
                        this.logger.log(i.DEBUG, "Repeated command (" + v([e, t]) + ") is dropped"),
                        !0
                      );
                    var n = 20 === e || 21 === e || 23 === e ? 1 : 2,
                      s = this.channels[n];
                    return (
                      20 === e || 21 === e || 28 === e || 29 === e
                        ? 32 === t
                          ? s.ccRCL()
                          : 33 === t
                            ? s.ccBS()
                            : 34 === t
                              ? s.ccAOF()
                              : 35 === t
                                ? s.ccAON()
                                : 36 === t
                                  ? s.ccDER()
                                  : 37 === t
                                    ? s.ccRU(2)
                                    : 38 === t
                                      ? s.ccRU(3)
                                      : 39 === t
                                        ? s.ccRU(4)
                                        : 40 === t
                                          ? s.ccFON()
                                          : 41 === t
                                            ? s.ccRDC()
                                            : 42 === t
                                              ? s.ccTR()
                                              : 43 === t
                                                ? s.ccRTD()
                                                : 44 === t
                                                  ? s.ccEDM()
                                                  : 45 === t
                                                    ? s.ccCR()
                                                    : 46 === t
                                                      ? s.ccENM()
                                                      : 47 === t && s.ccEOC()
                        : s.ccTO(t - 32),
                      S(e, t, r),
                      (this.currentChannel = n),
                      !0
                    );
                  }),
                  (t.parseMidrow = function(e, t) {
                    var r = 0;
                    if ((17 === e || 25 === e) && t >= 32 && t <= 47) {
                      if ((r = 17 === e ? 1 : 2) !== this.currentChannel)
                        return this.logger.log(i.ERROR, "Mismatch channel in midrow parsing"), !1;
                      var n = this.channels[r];
                      return !!n && (n.ccMIDROW(t), this.logger.log(i.DEBUG, "MIDROW (" + v([e, t]) + ")"), !0);
                    }
                    return !1;
                  }),
                  (t.parsePAC = function(e, t) {
                    var r,
                      i = this.cmdHistory;
                    if (
                      !(
                        (((e >= 17 && e <= 23) || (e >= 25 && e <= 31)) && t >= 64 && t <= 127) ||
                        ((16 === e || 24 === e) && t >= 64 && t <= 95)
                      )
                    )
                      return !1;
                    if (k(e, t, i)) return S(null, null, i), !0;
                    var n = e <= 23 ? 1 : 2;
                    r = t >= 64 && t <= 95 ? (1 === n ? u[e] : c[e]) : 1 === n ? d[e] : h[e];
                    var s = this.channels[n];
                    return !!s && (s.setPAC(this.interpretPAC(r, t)), S(e, t, i), (this.currentChannel = n), !0);
                  }),
                  (t.interpretPAC = function(e, t) {
                    var r,
                      i = { color: null, italics: !1, indent: null, underline: !1, row: e };
                    return (
                      (r = t > 95 ? t - 96 : t - 64),
                      (i.underline = 1 == (1 & r)),
                      r <= 13
                        ? (i.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][
                            Math.floor(r / 2)
                          ])
                        : r <= 15
                          ? ((i.italics = !0), (i.color = "white"))
                          : (i.indent = 4 * Math.floor((r - 16) / 2)),
                      i
                    );
                  }),
                  (t.parseChars = function(e, t) {
                    var r,
                      n,
                      s = null,
                      o = null;
                    if (
                      (e >= 25 ? ((r = 2), (o = e - 8)) : ((r = 1), (o = e)),
                      o >= 17 && o <= 19
                        ? ((n = 17 === o ? t + 80 : 18 === o ? t + 112 : t + 144),
                          this.logger.log(i.INFO, "Special char '" + a(n) + "' in channel " + r),
                          (s = [n]))
                        : e >= 32 && e <= 127 && (s = 0 === t ? [e] : [e, t]),
                      s)
                    ) {
                      var l = v(s);
                      this.logger.log(i.DEBUG, "Char codes =  " + l.join(",")), S(e, t, this.cmdHistory);
                    }
                    return s;
                  }),
                  (t.parseBackgroundAttributes = function(e, t) {
                    var r;
                    if (
                      !(
                        ((16 === e || 24 === e) && t >= 32 && t <= 47) ||
                        ((23 === e || 31 === e) && t >= 45 && t <= 47)
                      )
                    )
                      return !1;
                    var i = {};
                    16 === e || 24 === e
                      ? ((r = Math.floor((t - 32) / 2)),
                        (i.background = f[r]),
                        t % 2 == 1 && (i.background = i.background + "_semi"))
                      : 45 === t
                        ? (i.background = "transparent")
                        : ((i.foreground = "black"), 47 === t && (i.underline = !0));
                    var n = e <= 23 ? 1 : 2;
                    return this.channels[n].setBkgData(i), S(e, t, this.cmdHistory), !0;
                  }),
                  (t.reset = function() {
                    for (var e = 0; e < Object.keys(this.channels).length; e++) {
                      var t = this.channels[e];
                      t && t.reset();
                    }
                    this.cmdHistory = { a: null, b: null };
                  }),
                  (t.cueSplitAtTime = function(e) {
                    for (var t = 0; t < this.channels.length; t++) {
                      var r = this.channels[t];
                      r && r.cueSplitAtTime(e);
                    }
                  }),
                  e
                );
              })();
            function S(e, t, r) {
              (r.a = e), (r.b = t);
            }
            function k(e, t, r) {
              return r.a === e && r.b === t;
            }
            t.default = b;
          },
          "./src/utils/codecs.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "isCodecType", function() {
                return n;
              }),
              r.d(t, "isCodecSupportedInMp4", function() {
                return s;
              });
            var i = {
              audio: {
                a3ds: !0,
                "ac-3": !0,
                "ac-4": !0,
                alac: !0,
                alaw: !0,
                dra1: !0,
                "dts+": !0,
                "dts-": !0,
                dtsc: !0,
                dtse: !0,
                dtsh: !0,
                "ec-3": !0,
                enca: !0,
                g719: !0,
                g726: !0,
                m4ae: !0,
                mha1: !0,
                mha2: !0,
                mhm1: !0,
                mhm2: !0,
                mlpa: !0,
                mp4a: !0,
                "raw ": !0,
                Opus: !0,
                samr: !0,
                sawb: !0,
                sawp: !0,
                sevc: !0,
                sqcp: !0,
                ssmv: !0,
                twos: !0,
                ulaw: !0
              },
              video: {
                avc1: !0,
                avc2: !0,
                avc3: !0,
                avc4: !0,
                avcp: !0,
                av01: !0,
                drac: !0,
                dvav: !0,
                dvhe: !0,
                encv: !0,
                hev1: !0,
                hvc1: !0,
                mjp2: !0,
                mp4v: !0,
                mvc1: !0,
                mvc2: !0,
                mvc3: !0,
                mvc4: !0,
                resv: !0,
                rv60: !0,
                s263: !0,
                svc1: !0,
                svc2: !0,
                "vc-1": !0,
                vp08: !0,
                vp09: !0
              },
              text: { stpp: !0, wvtt: !0 }
            };
            function n(e, t) {
              var r = i[t];
              return !!r && !0 === r[e.slice(0, 4)];
            }
            function s(e, t) {
              return MediaSource.isTypeSupported((t || "video") + '/mp4;codecs="' + e + '"');
            }
          },
          "./src/utils/cues.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/utils/vttparser.ts"),
              n = r("./src/utils/webvtt-parser.ts"),
              s = r("./src/utils/texttrack-utils.ts"),
              a = /\s/,
              o = {
                newCue: function(e, t, r, o) {
                  for (var l, u, d, c, h, f = [], p = self.VTTCue || self.TextTrackCue, v = 0; v < o.rows.length; v++)
                    if (((d = !0), (c = 0), (h = ""), !(l = o.rows[v]).isEmpty())) {
                      for (var g = 0; g < l.chars.length; g++)
                        a.test(l.chars[g].uchar) && d ? c++ : ((h += l.chars[g].uchar), (d = !1));
                      (l.cueStartTime = t), t === r && (r += 1e-4), c >= 16 ? c-- : c++;
                      var m = Object(i.fixLineBreaks)(h.trim()),
                        y = Object(n.generateCueId)(t, r, m);
                      (e && e.cues && e.cues.getCueById(y)) ||
                        (((u = new p(t, r, m)).id = y),
                        (u.line = v + 1),
                        (u.align = "left"),
                        (u.position = 10 + Math.min(80, 10 * Math.floor((8 * c) / 32))),
                        f.push(u));
                    }
                  return (
                    e &&
                      f.length &&
                      (f.sort(function(e, t) {
                        return "auto" === e.line || "auto" === t.line
                          ? 0
                          : e.line > 8 && t.line > 8
                            ? t.line - e.line
                            : e.line - t.line;
                      }),
                      f.forEach(function(t) {
                        return Object(s.addCueToTrack)(e, t);
                      })),
                    f
                  );
                }
              };
            t.default = o;
          },
          "./src/utils/discontinuities.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "findFirstFragWithCC", function() {
                return a;
              }),
              r.d(t, "shouldAlignOnDiscontinuities", function() {
                return o;
              }),
              r.d(t, "findDiscontinuousReferenceFrag", function() {
                return l;
              }),
              r.d(t, "adjustSlidingStart", function() {
                return d;
              }),
              r.d(t, "alignStream", function() {
                return c;
              }),
              r.d(t, "alignPDT", function() {
                return h;
              }),
              r.d(t, "alignFragmentByPDTDelta", function() {
                return f;
              }),
              r.d(t, "alignMediaPlaylistByPDT", function() {
                return p;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/utils/logger.ts"),
              s = r("./src/controller/level-helper.ts");
            function a(e, t) {
              for (var r = null, i = 0, n = e.length; i < n; i++) {
                var s = e[i];
                if (s && s.cc === t) {
                  r = s;
                  break;
                }
              }
              return r;
            }
            function o(e, t, r) {
              return !(!t.details || !(r.endCC > r.startCC || (e && e.cc < r.startCC)));
            }
            function l(e, t) {
              var r = e.fragments,
                i = t.fragments;
              if (i.length && r.length) {
                var s = a(r, i[0].cc);
                if (s && (!s || s.startPTS)) return s;
                n.logger.log("No frag in previous level to align on");
              } else n.logger.log("No fragments to align");
            }
            function u(e, t) {
              if (e) {
                var r = e.start + t;
                (e.start = e.startPTS = r), (e.endPTS = r + e.duration);
              }
            }
            function d(e, t) {
              for (var r = t.fragments, i = 0, n = r.length; i < n; i++) u(r[i], e);
              t.fragmentHint && u(t.fragmentHint, e), (t.alignedSliding = !0);
            }
            function c(e, t, r) {
              t &&
                ((function(e, t, r) {
                  if (o(e, r, t)) {
                    var s = l(r.details, t);
                    s &&
                      Object(i.isFiniteNumber)(s.start) &&
                      (n.logger.log("Adjusting PTS using last level due to CC increase within current level " + t.url),
                      d(s.start, t));
                  }
                })(e, r, t),
                !r.alignedSliding && t.details && h(r, t.details),
                r.alignedSliding || !t.details || r.skippedSegments || Object(s.adjustSliding)(t.details, r));
            }
            function h(e, t) {
              if (t.fragments.length && e.hasProgramDateTime && t.hasProgramDateTime) {
                var r = t.fragments[0].programDateTime,
                  s = e.fragments[0].programDateTime,
                  a = (s - r) / 1e3 + t.fragments[0].start;
                a &&
                  Object(i.isFiniteNumber)(a) &&
                  (n.logger.log(
                    "Adjusting PTS using programDateTime delta " +
                      (s - r) +
                      "ms, sliding:" +
                      a.toFixed(3) +
                      " " +
                      e.url +
                      " "
                  ),
                  d(a, e));
              }
            }
            function f(e, t) {
              var r = e.programDateTime;
              if (r) {
                var i = (r - t) / 1e3;
                (e.start = e.startPTS = i), (e.endPTS = i + e.duration);
              }
            }
            function p(e, t) {
              if (t.fragments.length && e.hasProgramDateTime && t.hasProgramDateTime) {
                var r = t.fragments[0].programDateTime - 1e3 * t.fragments[0].start;
                e.fragments.forEach(function(e) {
                  f(e, r);
                }),
                  e.fragmentHint && f(e.fragmentHint, r),
                  (e.alignedSliding = !0);
              }
            }
          },
          "./src/utils/ewma-bandwidth-estimator.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/utils/ewma.ts"),
              n = (function() {
                function e(e, t, r) {
                  (this.defaultEstimate_ = void 0),
                    (this.minWeight_ = void 0),
                    (this.minDelayMs_ = void 0),
                    (this.slow_ = void 0),
                    (this.fast_ = void 0),
                    (this.defaultEstimate_ = r),
                    (this.minWeight_ = 0.001),
                    (this.minDelayMs_ = 50),
                    (this.slow_ = new i.default(e)),
                    (this.fast_ = new i.default(t));
                }
                var t = e.prototype;
                return (
                  (t.update = function(e, t) {
                    var r = this.slow_,
                      n = this.fast_;
                    this.slow_.halfLife !== e && (this.slow_ = new i.default(e, r.getEstimate(), r.getTotalWeight())),
                      this.fast_.halfLife !== t && (this.fast_ = new i.default(t, n.getEstimate(), n.getTotalWeight()));
                  }),
                  (t.sample = function(e, t) {
                    var r = (e = Math.max(e, this.minDelayMs_)) / 1e3,
                      i = (8 * t) / r;
                    this.fast_.sample(r, i), this.slow_.sample(r, i);
                  }),
                  (t.canEstimate = function() {
                    var e = this.fast_;
                    return e && e.getTotalWeight() >= this.minWeight_;
                  }),
                  (t.getEstimate = function() {
                    return this.canEstimate()
                      ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate())
                      : this.defaultEstimate_;
                  }),
                  (t.destroy = function() {}),
                  e
                );
              })();
            t.default = n;
          },
          "./src/utils/ewma.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = (function() {
              function e(e, t, r) {
                void 0 === t && (t = 0),
                  void 0 === r && (r = 0),
                  (this.halfLife = void 0),
                  (this.alpha_ = void 0),
                  (this.estimate_ = void 0),
                  (this.totalWeight_ = void 0),
                  (this.halfLife = e),
                  (this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0),
                  (this.estimate_ = t),
                  (this.totalWeight_ = r);
              }
              var t = e.prototype;
              return (
                (t.sample = function(e, t) {
                  var r = Math.pow(this.alpha_, e);
                  (this.estimate_ = t * (1 - r) + r * this.estimate_), (this.totalWeight_ += e);
                }),
                (t.getTotalWeight = function() {
                  return this.totalWeight_;
                }),
                (t.getEstimate = function() {
                  if (this.alpha_) {
                    var e = 1 - Math.pow(this.alpha_, this.totalWeight_);
                    if (e) return this.estimate_ / e;
                  }
                  return this.estimate_;
                }),
                e
              );
            })();
            t.default = i;
          },
          "./src/utils/fetch-loader.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "fetchSupported", function() {
                return h;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/loader/load-stats.ts"),
              s = r("./src/demux/chunk-cache.ts");
            function a(e) {
              var t = "function" == typeof Map ? new Map() : void 0;
              return (a = function(e) {
                if (null === e || ((r = e), -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
                var r;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                  if (t.has(e)) return t.get(e);
                  t.set(e, i);
                }
                function i() {
                  return o(e, arguments, d(this).constructor);
                }
                return (
                  (i.prototype = Object.create(e.prototype, {
                    constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 }
                  })),
                  u(i, e)
                );
              })(e);
            }
            function o(e, t, r) {
              return (o = l()
                ? Reflect.construct
                : function(e, t, r) {
                    var i = [null];
                    i.push.apply(i, t);
                    var n = new (Function.bind.apply(e, i))();
                    return r && u(n, r.prototype), n;
                  }).apply(null, arguments);
            }
            function l() {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
              } catch (e) {
                return !1;
              }
            }
            function u(e, t) {
              return (u =
                Object.setPrototypeOf ||
                function(e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            function d(e) {
              return (d = Object.setPrototypeOf
                ? Object.getPrototypeOf
                : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                  })(e);
            }
            function c() {
              return (c =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            function h() {
              if (self.fetch && self.AbortController && self.ReadableStream && self.Request)
                try {
                  return new self.ReadableStream({}), !0;
                } catch (e) {}
              return !1;
            }
            var f = (function() {
              function e(e) {
                (this.fetchSetup = void 0),
                  (this.requestTimeout = void 0),
                  (this.request = void 0),
                  (this.response = void 0),
                  (this.controller = void 0),
                  (this.context = void 0),
                  (this.config = null),
                  (this.callbacks = null),
                  (this.stats = void 0),
                  (this.loader = null),
                  (this.fetchSetup = e.fetchSetup || p),
                  (this.controller = new self.AbortController()),
                  (this.stats = new n.LoadStats());
              }
              var t = e.prototype;
              return (
                (t.destroy = function() {
                  (this.loader = this.callbacks = null), this.abortInternal();
                }),
                (t.abortInternal = function() {
                  var e = this.response;
                  (e && e.ok) || ((this.stats.aborted = !0), this.controller.abort());
                }),
                (t.abort = function() {
                  var e;
                  this.abortInternal(),
                    null !== (e = this.callbacks) &&
                      void 0 !== e &&
                      e.onAbort &&
                      this.callbacks.onAbort(this.stats, this.context, this.response);
                }),
                (t.load = function(e, t, r) {
                  var n = this,
                    s = this.stats;
                  if (s.loading.start) throw new Error("Loader can only be used once.");
                  s.loading.start = self.performance.now();
                  var a = (function(e, t) {
                      var r = {
                        method: "GET",
                        mode: "cors",
                        credentials: "same-origin",
                        signal: t,
                        headers: new self.Headers(c({}, e.headers))
                      };
                      return (
                        e.rangeEnd && r.headers.set("Range", "bytes=" + e.rangeStart + "-" + String(e.rangeEnd - 1)), r
                      );
                    })(e, this.controller.signal),
                    o = r.onProgress,
                    l = "arraybuffer" === e.responseType,
                    u = l ? "byteLength" : "length";
                  (this.context = e),
                    (this.config = t),
                    (this.callbacks = r),
                    (this.request = this.fetchSetup(e, a)),
                    self.clearTimeout(this.requestTimeout),
                    (this.requestTimeout = self.setTimeout(function() {
                      n.abortInternal(), r.onTimeout(s, e, n.response);
                    }, t.timeout)),
                    self
                      .fetch(this.request)
                      .then(function(r) {
                        if (((n.response = n.loader = r), !r.ok)) {
                          var a = r.status,
                            u = r.statusText;
                          throw new v(u || "fetch, bad network response", a, r);
                        }
                        return (
                          (s.loading.first = Math.max(self.performance.now(), s.loading.start)),
                          (s.total = parseInt(r.headers.get("Content-Length") || "0")),
                          o && Object(i.isFiniteNumber)(t.highWaterMark)
                            ? n.loadProgressively(r, s, e, t.highWaterMark, o)
                            : l
                              ? r.arrayBuffer()
                              : r.text()
                        );
                      })
                      .then(function(a) {
                        var l = n.response;
                        self.clearTimeout(n.requestTimeout),
                          (s.loading.end = Math.max(self.performance.now(), s.loading.first)),
                          (s.loaded = s.total = a[u]);
                        var d = { url: l.url, data: a };
                        o && !Object(i.isFiniteNumber)(t.highWaterMark) && o(s, e, a, l), r.onSuccess(d, s, e, l);
                      })
                      .catch(function(t) {
                        if ((self.clearTimeout(n.requestTimeout), !s.aborted)) {
                          var i = t.code || 0;
                          r.onError({ code: i, text: t.message }, e, t.details);
                        }
                      });
                }),
                (t.getCacheAge = function() {
                  var e = null;
                  if (this.response) {
                    var t = this.response.headers.get("age");
                    e = t ? parseFloat(t) : null;
                  }
                  return e;
                }),
                (t.loadProgressively = function(e, t, r, i, n) {
                  void 0 === i && (i = 0);
                  var a = new s.default(),
                    o = e.body.getReader();
                  return (function s() {
                    return o
                      .read()
                      .then(function(o) {
                        if (o.done) return a.dataLength && n(t, r, a.flush(), e), Promise.resolve(new ArrayBuffer(0));
                        var l = o.value,
                          u = l.length;
                        return (
                          (t.loaded += u),
                          u < i || a.dataLength
                            ? (a.push(l), a.dataLength >= i && n(t, r, a.flush(), e))
                            : n(t, r, l, e),
                          s()
                        );
                      })
                      .catch(function() {
                        return Promise.reject();
                      });
                  })();
                }),
                e
              );
            })();
            function p(e, t) {
              return new self.Request(e.url, t);
            }
            var v = (function(e) {
              var t, r;
              function i(t, r, i) {
                var n;
                return (
                  ((n = e.call(this, t) || this).code = void 0), (n.details = void 0), (n.code = r), (n.details = i), n
                );
              }
              return (
                (r = e), ((t = i).prototype = Object.create(r.prototype)), (t.prototype.constructor = t), u(t, r), i
              );
            })(a(Error));
            t.default = f;
          },
          "./src/utils/imsc1-ttml-parser.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "IMSC1_CODEC", function() {
                return d;
              }),
              r.d(t, "parseIMSC1", function() {
                return p;
              });
            var i = r("./src/utils/mp4-tools.ts"),
              n = r("./src/utils/vttparser.ts"),
              s = r("./src/utils/vttcue.ts"),
              a = r("./src/demux/id3.ts"),
              o = r("./src/utils/timescale-conversion.ts"),
              l = r("./src/utils/webvtt-parser.ts");
            function u() {
              return (u =
                Object.assign ||
                function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var d = "stpp.ttml.im1t",
              c = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,
              h = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/,
              f = { left: "start", center: "center", right: "end", start: "start", end: "end" };
            function p(e, t, r, n, d) {
              var c = Object(i.findBox)(new Uint8Array(e), ["mdat"]);
              if (0 !== c.length) {
                var h = c[0],
                  p = Object(a.utf8ArrayToStr)(new Uint8Array(e, h.start, h.end - h.start)),
                  b = Object(o.toTimescaleFromScale)(t, 1, r);
                try {
                  n(
                    (function(e, t) {
                      var r = new DOMParser().parseFromString(e, "text/xml").getElementsByTagName("tt")[0];
                      if (!r) throw new Error("Invalid ttml");
                      var i = { frameRate: 30, subFrameRate: 1, frameRateMultiplier: 0, tickRate: 0 },
                        n = Object.keys(i).reduce(function(e, t) {
                          return (e[t] = r.getAttribute("ttp:" + t) || i[t]), e;
                        }, {}),
                        a = "preserve" !== r.getAttribute("xml:space"),
                        o = g(v(r, "styling", "style")),
                        d = g(v(r, "layout", "region")),
                        c = v(r, "body", "[begin]");
                      return [].map
                        .call(c, function(e) {
                          var r = m(e, a);
                          if (!r || !e.hasAttribute("begin")) return null;
                          var i = T(e.getAttribute("begin"), n),
                            c = T(e.getAttribute("dur"), n),
                            h = T(e.getAttribute("end"), n);
                          if (null === i) throw E(e);
                          if (null === h) {
                            if (null === c) throw E(e);
                            h = i + c;
                          }
                          var p = new s.default(i - t, h - t, r);
                          p.id = Object(l.generateCueId)(p.startTime, p.endTime, p.text);
                          var v = d[e.getAttribute("region")],
                            g = o[e.getAttribute("style")];
                          (p.position = 10), (p.size = 80);
                          var b = (function(e, t) {
                              var r = "http://www.w3.org/ns/ttml#styling";
                              return [
                                "displayAlign",
                                "textAlign",
                                "color",
                                "backgroundColor",
                                "fontSize",
                                "fontFamily"
                              ].reduce(function(i, n) {
                                var s = y(t, r, n) || y(e, r, n);
                                return s && (i[n] = s), i;
                              }, {});
                            })(v, g),
                            S = b.textAlign;
                          if (S) {
                            var k = f[S];
                            k && (p.lineAlign = k), (p.align = S);
                          }
                          return u(p, b), p;
                        })
                        .filter(function(e) {
                          return null !== e;
                        });
                    })(p, b)
                  );
                } catch (e) {
                  d(e);
                }
              } else d(new Error("Could not parse IMSC1 mdat"));
            }
            function v(e, t, r) {
              var i = e.getElementsByTagName(t)[0];
              return i ? [].slice.call(i.querySelectorAll(r)) : [];
            }
            function g(e) {
              return e.reduce(function(e, t) {
                var r = t.getAttribute("xml:id");
                return r && (e[r] = t), e;
              }, {});
            }
            function m(e, t) {
              return [].slice.call(e.childNodes).reduce(function(e, r, i) {
                var n;
                return "br" === r.nodeName && i
                  ? e + "\n"
                  : null !== (n = r.childNodes) && void 0 !== n && n.length
                    ? m(r, t)
                    : t
                      ? e + r.textContent.trim().replace(/\s+/g, " ")
                      : e + r.textContent;
              }, "");
            }
            function y(e, t, r) {
              return e.hasAttributeNS(t, r) ? e.getAttributeNS(t, r) : null;
            }
            function E(e) {
              return new Error("Could not parse ttml timestamp " + e);
            }
            function T(e, t) {
              if (!e) return null;
              var r = Object(n.parseTimeStamp)(e);
              return (
                null === r &&
                  (c.test(e)
                    ? (r = (function(e, t) {
                        var r = c.exec(e),
                          i = (0 | r[4]) + (0 | r[5]) / t.subFrameRate;
                        return 3600 * (0 | r[1]) + 60 * (0 | r[2]) + (0 | r[3]) + i / t.frameRate;
                      })(e, t))
                    : h.test(e) &&
                      (r = (function(e, t) {
                        var r = h.exec(e),
                          i = Number(r[1]);
                        switch (r[2]) {
                          case "h":
                            return 3600 * i;
                          case "m":
                            return 60 * i;
                          case "ms":
                            return 1e3 * i;
                          case "f":
                            return i / t.frameRate;
                          case "t":
                            return i / t.tickRate;
                        }
                        return i;
                      })(e, t))),
                r
              );
            }
          },
          "./src/utils/logger.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "enableLogs", function() {
                return o;
              }),
              r.d(t, "logger", function() {
                return l;
              });
            var i = function() {},
              n = { trace: i, debug: i, log: i, warn: i, info: i, error: i },
              s = n;
            function a(e) {
              var t = self.console[e];
              return t ? t.bind(self.console, "[" + e + "] >") : i;
            }
            function o(e) {
              if ((self.console && !0 === e) || "object" == typeof e) {
                !(function(e) {
                  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
                    r[i - 1] = arguments[i];
                  r.forEach(function(t) {
                    s[t] = e[t] ? e[t].bind(e) : a(t);
                  });
                })(e, "debug", "log", "info", "warn", "error");
                try {
                  s.log();
                } catch (e) {
                  s = n;
                }
              } else s = n;
            }
            var l = n;
          },
          "./src/utils/mediakeys-helper.ts": function(e, t, r) {
            "use strict";
            var i;
            r.r(t),
              r.d(t, "KeySystems", function() {
                return i;
              }),
              r.d(t, "requestMediaKeySystemAccess", function() {
                return n;
              }),
              (function(e) {
                (e.WIDEVINE = "com.widevine.alpha"), (e.PLAYREADY = "com.microsoft.playready");
              })(i || (i = {}));
            var n =
              "undefined" != typeof self && self.navigator && self.navigator.requestMediaKeySystemAccess
                ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator)
                : null;
          },
          "./src/utils/mediasource-helper.ts": function(e, t, r) {
            "use strict";
            function i() {
              return self.MediaSource || self.WebKitMediaSource;
            }
            r.r(t),
              r.d(t, "getMediaSource", function() {
                return i;
              });
          },
          "./src/utils/mp4-tools.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "bin2str", function() {
                return o;
              }),
              r.d(t, "readUint16", function() {
                return l;
              }),
              r.d(t, "readUint32", function() {
                return u;
              }),
              r.d(t, "writeUint32", function() {
                return d;
              }),
              r.d(t, "findBox", function() {
                return c;
              }),
              r.d(t, "parseSegmentIndex", function() {
                return h;
              }),
              r.d(t, "parseInitSegment", function() {
                return f;
              }),
              r.d(t, "getStartDTS", function() {
                return p;
              }),
              r.d(t, "getDuration", function() {
                return v;
              }),
              r.d(t, "computeRawDurationFromSamples", function() {
                return g;
              }),
              r.d(t, "offsetStartDTS", function() {
                return m;
              }),
              r.d(t, "segmentValidRange", function() {
                return y;
              }),
              r.d(t, "appendUint8Array", function() {
                return E;
              });
            var i = r("./src/utils/typed-array.ts"),
              n = r("./src/loader/fragment.ts"),
              s = Math.pow(2, 32) - 1,
              a = [].push;
            function o(e) {
              return String.fromCharCode.apply(null, e);
            }
            function l(e, t) {
              "data" in e && ((t += e.start), (e = e.data));
              var r = (e[t] << 8) | e[t + 1];
              return r < 0 ? 65536 + r : r;
            }
            function u(e, t) {
              "data" in e && ((t += e.start), (e = e.data));
              var r = (e[t] << 24) | (e[t + 1] << 16) | (e[t + 2] << 8) | e[t + 3];
              return r < 0 ? 4294967296 + r : r;
            }
            function d(e, t, r) {
              "data" in e && ((t += e.start), (e = e.data)),
                (e[t] = r >> 24),
                (e[t + 1] = (r >> 16) & 255),
                (e[t + 2] = (r >> 8) & 255),
                (e[t + 3] = 255 & r);
            }
            function c(e, t) {
              var r,
                i,
                n,
                s = [];
              if (!t.length) return s;
              "data" in e ? ((r = e.data), (i = e.start), (n = e.end)) : ((i = 0), (n = (r = e).byteLength));
              for (var l = i; l < n; ) {
                var d = u(r, l),
                  h = d > 1 ? l + d : n;
                if (o(r.subarray(l + 4, l + 8)) === t[0])
                  if (1 === t.length) s.push({ data: r, start: l + 8, end: h });
                  else {
                    var f = c({ data: r, start: l + 8, end: h }, t.slice(1));
                    f.length && a.apply(s, f);
                  }
                l = h;
              }
              return s;
            }
            function h(e) {
              var t = c(e, ["moov"])[0],
                r = t ? t.end : null,
                i = c(e, ["sidx"]);
              if (!i || !i[0]) return null;
              var n = [],
                s = i[0],
                a = s.data[0],
                o = 0 === a ? 8 : 16,
                d = u(s, o);
              (o += 4), (o += 0 === a ? 8 : 16), (o += 2);
              var h = s.end + 0,
                f = l(s, o);
              o += 2;
              for (var p = 0; p < f; p++) {
                var v = o,
                  g = u(s, v);
                v += 4;
                var m = 2147483647 & g;
                if (1 == (2147483648 & g) >>> 31)
                  return console.warn("SIDX has hierarchical references (not supported)"), null;
                var y = u(s, v);
                (v += 4),
                  n.push({
                    referenceSize: m,
                    subsegmentDuration: y,
                    info: { duration: y / d, start: h, end: h + m - 1 }
                  }),
                  (h += m),
                  (o = v += 4);
              }
              return {
                earliestPresentationTime: 0,
                timescale: d,
                version: a,
                referencesCount: f,
                references: n,
                moovEndOffset: r
              };
            }
            function f(e) {
              for (var t = [], r = c(e, ["moov", "trak"]), i = 0; i < r.length; i++) {
                var s = r[i],
                  a = c(s, ["tkhd"])[0];
                if (a) {
                  var l = a.data[a.start],
                    d = 0 === l ? 12 : 20,
                    h = u(a, d),
                    f = c(s, ["mdia", "mdhd"])[0];
                  if (f) {
                    var p = u(f, (d = 0 === (l = f.data[f.start]) ? 12 : 20)),
                      v = c(s, ["mdia", "hdlr"])[0];
                    if (v) {
                      var g = o(v.data.subarray(v.start + 8, v.start + 12)),
                        m = { soun: n.ElementaryStreamTypes.AUDIO, vide: n.ElementaryStreamTypes.VIDEO }[g];
                      if (m) {
                        var y = c(s, ["mdia", "minf", "stbl", "stsd"])[0],
                          E = void 0;
                        y && (E = o(y.data.subarray(y.start + 12, y.start + 16))),
                          (t[h] = { timescale: p, type: m }),
                          (t[m] = { timescale: p, id: h, codec: E });
                      }
                    }
                  }
                }
              }
              return (
                c(e, ["moov", "mvex", "trex"]).forEach(function(e) {
                  var r = u(e, 4),
                    i = t[r];
                  i && (i.default = { duration: u(e, 12), flags: u(e, 20) });
                }),
                t
              );
            }
            function p(e, t) {
              return (
                c(t, ["moof", "traf"]).reduce(function(t, r) {
                  var i = c(r, ["tfdt"])[0],
                    n = i.data[i.start],
                    s = c(r, ["tfhd"]).reduce(function(t, r) {
                      var s = u(r, 4),
                        a = e[s];
                      if (a) {
                        var o = u(i, 4);
                        1 === n && ((o *= Math.pow(2, 32)), (o += u(i, 8)));
                        var l = o / (a.timescale || 9e4);
                        if (isFinite(l) && (null === t || l < t)) return l;
                      }
                      return t;
                    }, null);
                  return null !== s && isFinite(s) && (null === t || s < t) ? s : t;
                }, null) || 0
              );
            }
            function v(e, t) {
              for (var r = 0, i = 0, s = 0, a = c(e, ["moof", "traf"]), o = 0; o < a.length; o++) {
                var l = a[o],
                  d = c(l, ["tfhd"])[0],
                  f = t[u(d, 4)];
                if (f) {
                  var p = f.default,
                    v = u(d, 0) | (null == p ? void 0 : p.flags),
                    m = null == p ? void 0 : p.duration;
                  8 & v && (m = u(d, 2 & v ? 12 : 8));
                  for (var y = f.timescale || 9e4, E = c(l, ["trun"]), T = 0; T < E.length; T++)
                    !(r = g(E[T])) && m && (r = m * u(E[T], 4)),
                      f.type === n.ElementaryStreamTypes.VIDEO
                        ? (i += r / y)
                        : f.type === n.ElementaryStreamTypes.AUDIO && (s += r / y);
                }
              }
              if (0 === i && 0 === s) {
                var b = h(e);
                if (null != b && b.references)
                  return b.references.reduce(function(e, t) {
                    return e + t.info.duration || 0;
                  }, 0);
              }
              return i || s;
            }
            function g(e) {
              var t = u(e, 0),
                r = 8;
              1 & t && (r += 4), 4 & t && (r += 4);
              for (var i = 0, n = u(e, 4), s = 0; s < n; s++)
                256 & t && ((i += u(e, r)), (r += 4)), 512 & t && (r += 4), 1024 & t && (r += 4), 2048 & t && (r += 4);
              return i;
            }
            function m(e, t, r) {
              c(t, ["moof", "traf"]).forEach(function(t) {
                c(t, ["tfhd"]).forEach(function(i) {
                  var n = u(i, 4),
                    a = e[n];
                  if (a) {
                    var o = a.timescale || 9e4;
                    c(t, ["tfdt"]).forEach(function(e) {
                      var t = e.data[e.start],
                        i = u(e, 4);
                      if (0 === t) d(e, 4, i - r * o);
                      else {
                        (i *= Math.pow(2, 32)), (i += u(e, 8)), (i -= r * o), (i = Math.max(i, 0));
                        var n = Math.floor(i / (s + 1)),
                          a = Math.floor(i % (s + 1));
                        d(e, 4, n), d(e, 8, a);
                      }
                    });
                  }
                });
              });
            }
            function y(e) {
              var t = { valid: null, remainder: null },
                r = c(e, ["moof"]);
              if (!r) return t;
              if (r.length < 2) return (t.remainder = e), t;
              var n = r[r.length - 1];
              return (
                (t.valid = Object(i.sliceUint8)(e, 0, n.start - 8)),
                (t.remainder = Object(i.sliceUint8)(e, n.start - 8)),
                t
              );
            }
            function E(e, t) {
              var r = new Uint8Array(e.length + t.length);
              return r.set(e), r.set(t, e.length), r;
            }
          },
          "./src/utils/output-filter.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "default", function() {
                return i;
              });
            var i = (function() {
              function e(e, t) {
                (this.timelineController = void 0),
                  (this.cueRanges = []),
                  (this.trackName = void 0),
                  (this.startTime = null),
                  (this.endTime = null),
                  (this.screen = null),
                  (this.timelineController = e),
                  (this.trackName = t);
              }
              var t = e.prototype;
              return (
                (t.dispatchCue = function() {
                  null !== this.startTime &&
                    (this.timelineController.addCues(
                      this.trackName,
                      this.startTime,
                      this.endTime,
                      this.screen,
                      this.cueRanges
                    ),
                    (this.startTime = null));
                }),
                (t.newCue = function(e, t, r) {
                  (null === this.startTime || this.startTime > e) && (this.startTime = e),
                    (this.endTime = t),
                    (this.screen = r),
                    this.timelineController.createCaptionsTrack(this.trackName);
                }),
                (t.reset = function() {
                  (this.cueRanges = []), (this.startTime = null);
                }),
                e
              );
            })();
          },
          "./src/utils/texttrack-utils.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "sendAddTrackEvent", function() {
                return n;
              }),
              r.d(t, "addCueToTrack", function() {
                return s;
              }),
              r.d(t, "clearCurrentCues", function() {
                return a;
              }),
              r.d(t, "removeCuesInRange", function() {
                return o;
              }),
              r.d(t, "getCuesInRange", function() {
                return l;
              });
            var i = r("./src/utils/logger.ts");
            function n(e, t) {
              var r;
              try {
                r = new Event("addtrack");
              } catch (e) {
                (r = document.createEvent("Event")).initEvent("addtrack", !1, !1);
              }
              (r.track = e), t.dispatchEvent(r);
            }
            function s(e, t) {
              var r = e.mode;
              if (("disabled" === r && (e.mode = "hidden"), e.cues && !e.cues.getCueById(t.id)))
                try {
                  if ((e.addCue(t), !e.cues.getCueById(t.id))) throw new Error("addCue is failed for: " + t);
                } catch (r) {
                  i.logger.debug("[texttrack-utils]: " + r);
                  var n = new self.TextTrackCue(t.startTime, t.endTime, t.text);
                  (n.id = t.id), e.addCue(n);
                }
              "disabled" === r && (e.mode = r);
            }
            function a(e) {
              var t = e.mode;
              if (("disabled" === t && (e.mode = "hidden"), e.cues))
                for (var r = e.cues.length; r--; ) e.removeCue(e.cues[r]);
              "disabled" === t && (e.mode = t);
            }
            function o(e, t, r) {
              var i = e.mode;
              if (("disabled" === i && (e.mode = "hidden"), e.cues && e.cues.length > 0))
                for (var n = l(e.cues, t, r), s = 0; s < n.length; s++) e.removeCue(n[s]);
              "disabled" === i && (e.mode = i);
            }
            function l(e, t, r) {
              var i = [],
                n = (function(e, t) {
                  if (t < e[0].startTime) return 0;
                  var r = e.length - 1;
                  if (t > e[r].endTime) return -1;
                  for (var i = 0, n = r; i <= n; ) {
                    var s = Math.floor((n + i) / 2);
                    if (t < e[s].startTime) n = s - 1;
                    else {
                      if (!(t > e[s].startTime && i < r)) return s;
                      i = s + 1;
                    }
                  }
                  return e[i].startTime - t < t - e[n].startTime ? i : n;
                })(e, t);
              if (n > -1)
                for (var s = n, a = e.length; s < a; s++) {
                  var o = e[s];
                  if (o.startTime >= t && o.endTime <= r) i.push(o);
                  else if (o.startTime > r) return i;
                }
              return i;
            }
          },
          "./src/utils/time-ranges.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              (t.default = {
                toString: function(e) {
                  for (var t = "", r = e.length, i = 0; i < r; i++)
                    t += "[" + e.start(i).toFixed(3) + "," + e.end(i).toFixed(3) + "]";
                  return t;
                }
              });
          },
          "./src/utils/timescale-conversion.ts": function(e, t, r) {
            "use strict";
            function i(e, t, r, i) {
              void 0 === r && (r = 1), void 0 === i && (i = !1);
              var n = e * t * r;
              return i ? Math.round(n) : n;
            }
            function n(e, t, r, n) {
              return void 0 === r && (r = 1), void 0 === n && (n = !1), i(e, t, 1 / r, n);
            }
            function s(e, t) {
              return void 0 === t && (t = !1), i(e, 1e3, 1 / 9e4, t);
            }
            function a(e, t) {
              return void 0 === t && (t = 1), i(e, 9e4, 1 / t);
            }
            r.r(t),
              r.d(t, "toTimescaleFromBase", function() {
                return i;
              }),
              r.d(t, "toTimescaleFromScale", function() {
                return n;
              }),
              r.d(t, "toMsFromMpegTsClock", function() {
                return s;
              }),
              r.d(t, "toMpegTsClockFromTimescale", function() {
                return a;
              });
          },
          "./src/utils/typed-array.ts": function(e, t, r) {
            "use strict";
            function i(e, t, r) {
              return Uint8Array.prototype.slice ? e.slice(t, r) : new Uint8Array(Array.prototype.slice.call(e, t, r));
            }
            r.r(t),
              r.d(t, "sliceUint8", function() {
                return i;
              });
          },
          "./src/utils/vttcue.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              (t.default = (function() {
                if ("undefined" != typeof self && self.VTTCue) return self.VTTCue;
                var e = ["", "lr", "rl"],
                  t = ["start", "middle", "end", "left", "right"];
                function r(e, t) {
                  if ("string" != typeof t) return !1;
                  if (!Array.isArray(e)) return !1;
                  var r = t.toLowerCase();
                  return !!~e.indexOf(r) && r;
                }
                function i(e) {
                  return r(t, e);
                }
                function n(e) {
                  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
                    r[i - 1] = arguments[i];
                  for (var n = 1; n < arguments.length; n++) {
                    var s = arguments[n];
                    for (var a in s) e[a] = s[a];
                  }
                  return e;
                }
                function s(t, s, a) {
                  var o = this,
                    l = { enumerable: !0 };
                  o.hasBeenReset = !1;
                  var u = "",
                    d = !1,
                    c = t,
                    h = s,
                    f = a,
                    p = null,
                    v = "",
                    g = !0,
                    m = "auto",
                    y = "start",
                    E = 50,
                    T = "middle",
                    b = 50,
                    S = "middle";
                  Object.defineProperty(
                    o,
                    "id",
                    n({}, l, {
                      get: function() {
                        return u;
                      },
                      set: function(e) {
                        u = "" + e;
                      }
                    })
                  ),
                    Object.defineProperty(
                      o,
                      "pauseOnExit",
                      n({}, l, {
                        get: function() {
                          return d;
                        },
                        set: function(e) {
                          d = !!e;
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "startTime",
                      n({}, l, {
                        get: function() {
                          return c;
                        },
                        set: function(e) {
                          if ("number" != typeof e) throw new TypeError("Start time must be set to a number.");
                          (c = e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "endTime",
                      n({}, l, {
                        get: function() {
                          return h;
                        },
                        set: function(e) {
                          if ("number" != typeof e) throw new TypeError("End time must be set to a number.");
                          (h = e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "text",
                      n({}, l, {
                        get: function() {
                          return f;
                        },
                        set: function(e) {
                          (f = "" + e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "region",
                      n({}, l, {
                        get: function() {
                          return p;
                        },
                        set: function(e) {
                          (p = e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "vertical",
                      n({}, l, {
                        get: function() {
                          return v;
                        },
                        set: function(t) {
                          var i = (function(t) {
                            return r(e, t);
                          })(t);
                          if (!1 === i) throw new SyntaxError("An invalid or illegal string was specified.");
                          (v = i), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "snapToLines",
                      n({}, l, {
                        get: function() {
                          return g;
                        },
                        set: function(e) {
                          (g = !!e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "line",
                      n({}, l, {
                        get: function() {
                          return m;
                        },
                        set: function(e) {
                          if ("number" != typeof e && "auto" !== e)
                            throw new SyntaxError("An invalid number or illegal string was specified.");
                          (m = e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "lineAlign",
                      n({}, l, {
                        get: function() {
                          return y;
                        },
                        set: function(e) {
                          var t = i(e);
                          if (!t) throw new SyntaxError("An invalid or illegal string was specified.");
                          (y = t), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "position",
                      n({}, l, {
                        get: function() {
                          return E;
                        },
                        set: function(e) {
                          if (e < 0 || e > 100) throw new Error("Position must be between 0 and 100.");
                          (E = e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "positionAlign",
                      n({}, l, {
                        get: function() {
                          return T;
                        },
                        set: function(e) {
                          var t = i(e);
                          if (!t) throw new SyntaxError("An invalid or illegal string was specified.");
                          (T = t), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "size",
                      n({}, l, {
                        get: function() {
                          return b;
                        },
                        set: function(e) {
                          if (e < 0 || e > 100) throw new Error("Size must be between 0 and 100.");
                          (b = e), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    Object.defineProperty(
                      o,
                      "align",
                      n({}, l, {
                        get: function() {
                          return S;
                        },
                        set: function(e) {
                          var t = i(e);
                          if (!t) throw new SyntaxError("An invalid or illegal string was specified.");
                          (S = t), (this.hasBeenReset = !0);
                        }
                      })
                    ),
                    (o.displayState = void 0);
                }
                return (
                  (s.prototype.getCueAsHTML = function() {
                    return self.WebVTT.convertCueToDOMTree(self, this.text);
                  }),
                  s
                );
              })());
          },
          "./src/utils/vttparser.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "parseTimeStamp", function() {
                return s;
              }),
              r.d(t, "fixLineBreaks", function() {
                return c;
              }),
              r.d(t, "VTTParser", function() {
                return h;
              });
            var i = r("./src/utils/vttcue.ts"),
              n = (function() {
                function e() {}
                return (
                  (e.prototype.decode = function(e, t) {
                    if (!e) return "";
                    if ("string" != typeof e) throw new Error("Error - expected string data.");
                    return decodeURIComponent(encodeURIComponent(e));
                  }),
                  e
                );
              })();
            function s(e) {
              function t(e, t, r, i) {
                return 3600 * (0 | e) + 60 * (0 | t) + (0 | r) + parseFloat(i || 0);
              }
              var r = e.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
              return r ? (parseFloat(r[2]) > 59 ? t(r[2], r[3], 0, r[4]) : t(r[1], r[2], r[3], r[4])) : null;
            }
            var a = (function() {
              function e() {
                this.values = Object.create(null);
              }
              var t = e.prototype;
              return (
                (t.set = function(e, t) {
                  this.get(e) || "" === t || (this.values[e] = t);
                }),
                (t.get = function(e, t, r) {
                  return r ? (this.has(e) ? this.values[e] : t[r]) : this.has(e) ? this.values[e] : t;
                }),
                (t.has = function(e) {
                  return e in this.values;
                }),
                (t.alt = function(e, t, r) {
                  for (var i = 0; i < r.length; ++i)
                    if (t === r[i]) {
                      this.set(e, t);
                      break;
                    }
                }),
                (t.integer = function(e, t) {
                  /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
                }),
                (t.percent = function(e, t) {
                  if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
                    var r = parseFloat(t);
                    if (r >= 0 && r <= 100) return this.set(e, r), !0;
                  }
                  return !1;
                }),
                e
              );
            })();
            function o(e, t, r, i) {
              var n = i ? e.split(i) : [e];
              for (var s in n)
                if ("string" == typeof n[s]) {
                  var a = n[s].split(r);
                  2 === a.length && t(a[0], a[1]);
                }
            }
            var l = new i.default(0, 0, ""),
              u = "middle" === l.align ? "middle" : "center";
            function d(e, t, r) {
              var i = e;
              function n() {
                var t = s(e);
                if (null === t) throw new Error("Malformed timestamp: " + i);
                return (e = e.replace(/^[^\sa-zA-Z-]+/, "")), t;
              }
              function d() {
                e = e.replace(/^\s+/, "");
              }
              if ((d(), (t.startTime = n()), d(), "--\x3e" !== e.substr(0, 3)))
                throw new Error("Malformed time stamp (time stamps must be separated by '--\x3e'): " + i);
              (e = e.substr(3)),
                d(),
                (t.endTime = n()),
                d(),
                (function(e, t) {
                  var i = new a();
                  o(
                    e,
                    function(e, t) {
                      var n;
                      switch (e) {
                        case "region":
                          for (var s = r.length - 1; s >= 0; s--)
                            if (r[s].id === t) {
                              i.set(e, r[s].region);
                              break;
                            }
                          break;
                        case "vertical":
                          i.alt(e, t, ["rl", "lr"]);
                          break;
                        case "line":
                          (n = t.split(",")),
                            i.integer(e, n[0]),
                            i.percent(e, n[0]) && i.set("snapToLines", !1),
                            i.alt(e, n[0], ["auto"]),
                            2 === n.length && i.alt("lineAlign", n[1], ["start", u, "end"]);
                          break;
                        case "position":
                          (n = t.split(",")),
                            i.percent(e, n[0]),
                            2 === n.length &&
                              i.alt("positionAlign", n[1], ["start", u, "end", "line-left", "line-right", "auto"]);
                          break;
                        case "size":
                          i.percent(e, t);
                          break;
                        case "align":
                          i.alt(e, t, ["start", u, "end", "left", "right"]);
                      }
                    },
                    /:/,
                    /\s/
                  ),
                    (t.region = i.get("region", null)),
                    (t.vertical = i.get("vertical", ""));
                  var n = i.get("line", "auto");
                  "auto" === n && -1 === l.line && (n = -1),
                    (t.line = n),
                    (t.lineAlign = i.get("lineAlign", "start")),
                    (t.snapToLines = i.get("snapToLines", !0)),
                    (t.size = i.get("size", 100)),
                    (t.align = i.get("align", u));
                  var s = i.get("position", "auto");
                  "auto" === s &&
                    50 === l.position &&
                    (s =
                      "start" === t.align || "left" === t.align
                        ? 0
                        : "end" === t.align || "right" === t.align
                          ? 100
                          : 50),
                    (t.position = s);
                })(e, t);
            }
            function c(e) {
              return e.replace(/<br(?: \/)?>/gi, "\n");
            }
            var h = (function() {
              function e() {
                (this.state = "INITIAL"),
                  (this.buffer = ""),
                  (this.decoder = new n()),
                  (this.regionList = []),
                  (this.cue = null),
                  (this.oncue = void 0),
                  (this.onparsingerror = void 0),
                  (this.onflush = void 0);
              }
              var t = e.prototype;
              return (
                (t.parse = function(e) {
                  var t = this;
                  function r() {
                    var e = t.buffer,
                      r = 0;
                    for (e = c(e); r < e.length && "\r" !== e[r] && "\n" !== e[r]; ) ++r;
                    var i = e.substr(0, r);
                    return "\r" === e[r] && ++r, "\n" === e[r] && ++r, (t.buffer = e.substr(r)), i;
                  }
                  e && (t.buffer += t.decoder.decode(e, { stream: !0 }));
                  try {
                    var n = "";
                    if ("INITIAL" === t.state) {
                      if (!/\r\n|\n/.test(t.buffer)) return this;
                      var s = (n = r()).match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                      if (!s || !s[0]) throw new Error("Malformed WebVTT signature.");
                      t.state = "HEADER";
                    }
                    for (var a = !1; t.buffer; ) {
                      if (!/\r\n|\n/.test(t.buffer)) return this;
                      switch ((a ? (a = !1) : (n = r()), t.state)) {
                        case "HEADER":
                          /:/.test(n) ? o(n, function(e, t) {}, /:/) : n || (t.state = "ID");
                          continue;
                        case "NOTE":
                          n || (t.state = "ID");
                          continue;
                        case "ID":
                          if (/^NOTE($|[ \t])/.test(n)) {
                            t.state = "NOTE";
                            break;
                          }
                          if (!n) continue;
                          if (((t.cue = new i.default(0, 0, "")), (t.state = "CUE"), -1 === n.indexOf("--\x3e"))) {
                            t.cue.id = n;
                            continue;
                          }
                        case "CUE":
                          if (!t.cue) {
                            t.state = "BADCUE";
                            continue;
                          }
                          try {
                            d(n, t.cue, t.regionList);
                          } catch (e) {
                            (t.cue = null), (t.state = "BADCUE");
                            continue;
                          }
                          t.state = "CUETEXT";
                          continue;
                        case "CUETEXT":
                          var l = -1 !== n.indexOf("--\x3e");
                          if (!n || (l && (a = !0))) {
                            t.oncue && t.cue && t.oncue(t.cue), (t.cue = null), (t.state = "ID");
                            continue;
                          }
                          if (null === t.cue) continue;
                          t.cue.text && (t.cue.text += "\n"), (t.cue.text += n);
                          continue;
                        case "BADCUE":
                          n || (t.state = "ID");
                      }
                    }
                  } catch (e) {
                    "CUETEXT" === t.state && t.cue && t.oncue && t.oncue(t.cue),
                      (t.cue = null),
                      (t.state = "INITIAL" === t.state ? "BADWEBVTT" : "BADCUE");
                  }
                  return this;
                }),
                (t.flush = function() {
                  var e = this;
                  try {
                    if (
                      ((e.cue || "HEADER" === e.state) && ((e.buffer += "\n\n"), e.parse()),
                      "INITIAL" === e.state || "BADWEBVTT" === e.state)
                    )
                      throw new Error("Malformed WebVTT signature.");
                  } catch (t) {
                    e.onparsingerror && e.onparsingerror(t);
                  }
                  return e.onflush && e.onflush(), this;
                }),
                e
              );
            })();
          },
          "./src/utils/webvtt-parser.ts": function(e, t, r) {
            "use strict";
            r.r(t),
              r.d(t, "generateCueId", function() {
                return c;
              }),
              r.d(t, "parseWebVTT", function() {
                return h;
              });
            var i = r("./src/polyfills/number.ts"),
              n = r("./src/utils/vttparser.ts"),
              s = r("./src/demux/id3.ts"),
              a = r("./src/utils/timescale-conversion.ts"),
              o = r("./src/remux/mp4-remuxer.ts"),
              l = /\r\n|\n\r|\n|\r/g,
              u = function(e, t, r) {
                return void 0 === r && (r = 0), e.substr(r, t.length) === t;
              },
              d = function(e) {
                for (var t = 5381, r = e.length; r; ) t = (33 * t) ^ e.charCodeAt(--r);
                return (t >>> 0).toString();
              };
            function c(e, t, r) {
              return d(e.toString()) + d(t.toString()) + d(r);
            }
            function h(e, t, r, d, h, f, p, v) {
              var g,
                m = new n.VTTParser(),
                y = Object(s.utf8ArrayToStr)(new Uint8Array(e))
                  .trim()
                  .replace(l, "\n")
                  .split("\n"),
                E = [],
                T = Object(a.toMpegTsClockFromTimescale)(t, r),
                b = "00:00.000",
                S = 0,
                k = 0,
                A = !0,
                w = !1;
              (m.oncue = function(e) {
                var t = d[h],
                  r = d.ccOffset,
                  i = (S - T) / 9e4;
                if (
                  (null != t &&
                    t.new &&
                    (void 0 !== k
                      ? (r = d.ccOffset = t.start)
                      : (function(e, t, r) {
                          var i = e[t],
                            n = e[i.prevCC];
                          if (!n || (!n.new && i.new))
                            return (e.ccOffset = e.presentationOffset = i.start), void (i.new = !1);
                          for (; null !== (s = n) && void 0 !== s && s.new; ) {
                            var s;
                            (e.ccOffset += i.start - n.start), (i.new = !1), (n = e[(i = n).prevCC]);
                          }
                          e.presentationOffset = r;
                        })(d, h, i)),
                  i && (r = i - d.presentationOffset),
                  w)
                ) {
                  var n = e.endTime - e.startTime,
                    s = Object(o.normalizePts)(9e4 * (e.startTime + r - k), 9e4 * f) / 9e4;
                  (e.startTime = s), (e.endTime = s + n);
                }
                var a = e.text.trim();
                (e.text = decodeURIComponent(encodeURIComponent(a))),
                  e.id || (e.id = c(e.startTime, e.endTime, a)),
                  e.endTime > 0 && E.push(e);
              }),
                (m.onparsingerror = function(e) {
                  g = e;
                }),
                (m.onflush = function() {
                  g ? v(g) : p(E);
                }),
                y.forEach(function(e) {
                  if (A) {
                    if (u(e, "X-TIMESTAMP-MAP=")) {
                      (A = !1),
                        (w = !0),
                        e
                          .substr(16)
                          .split(",")
                          .forEach(function(e) {
                            u(e, "LOCAL:") ? (b = e.substr(6)) : u(e, "MPEGTS:") && (S = parseInt(e.substr(7)));
                          });
                      try {
                        k =
                          (function(e) {
                            var t = parseInt(e.substr(-3)),
                              r = parseInt(e.substr(-6, 2)),
                              n = parseInt(e.substr(-9, 2)),
                              s = e.length > 9 ? parseInt(e.substr(0, e.indexOf(":"))) : 0;
                            if (
                              !(
                                Object(i.isFiniteNumber)(t) &&
                                Object(i.isFiniteNumber)(r) &&
                                Object(i.isFiniteNumber)(n) &&
                                Object(i.isFiniteNumber)(s)
                              )
                            )
                              throw Error("Malformed X-TIMESTAMP-MAP: Local:" + e);
                            return (t += 1e3 * r), (t += 6e4 * n) + 36e5 * s;
                          })(b) / 1e3;
                      } catch (e) {
                        (w = !1), (g = e);
                      }
                      return;
                    }
                    "" === e && (A = !1);
                  }
                  m.parse(e + "\n");
                }),
                m.flush();
            }
          },
          "./src/utils/xhr-loader.ts": function(e, t, r) {
            "use strict";
            r.r(t);
            var i = r("./src/utils/logger.ts"),
              n = r("./src/loader/load-stats.ts"),
              s = /^age:\s*[\d.]+\s*$/m,
              a = (function() {
                function e(e) {
                  (this.xhrSetup = void 0),
                    (this.requestTimeout = void 0),
                    (this.retryTimeout = void 0),
                    (this.retryDelay = void 0),
                    (this.config = null),
                    (this.callbacks = null),
                    (this.context = void 0),
                    (this.loader = null),
                    (this.stats = void 0),
                    (this.xhrSetup = e ? e.xhrSetup : null),
                    (this.stats = new n.LoadStats()),
                    (this.retryDelay = 0);
                }
                var t = e.prototype;
                return (
                  (t.destroy = function() {
                    (this.callbacks = null), this.abortInternal(), (this.loader = null), (this.config = null);
                  }),
                  (t.abortInternal = function() {
                    var e = this.loader;
                    self.clearTimeout(this.requestTimeout),
                      self.clearTimeout(this.retryTimeout),
                      e &&
                        ((e.onreadystatechange = null),
                        (e.onprogress = null),
                        4 !== e.readyState && ((this.stats.aborted = !0), e.abort()));
                  }),
                  (t.abort = function() {
                    var e;
                    this.abortInternal(),
                      null !== (e = this.callbacks) &&
                        void 0 !== e &&
                        e.onAbort &&
                        this.callbacks.onAbort(this.stats, this.context, this.loader);
                  }),
                  (t.load = function(e, t, r) {
                    if (this.stats.loading.start) throw new Error("Loader can only be used once.");
                    (this.stats.loading.start = self.performance.now()),
                      (this.context = e),
                      (this.config = t),
                      (this.callbacks = r),
                      (this.retryDelay = t.retryDelay),
                      this.loadInternal();
                  }),
                  (t.loadInternal = function() {
                    var e = this.config,
                      t = this.context;
                    if (e) {
                      var r = (this.loader = new self.XMLHttpRequest()),
                        i = this.stats;
                      (i.loading.first = 0), (i.loaded = 0);
                      var n = this.xhrSetup;
                      try {
                        if (n)
                          try {
                            n(r, t.url);
                          } catch (e) {
                            r.open("GET", t.url, !0), n(r, t.url);
                          }
                        r.readyState || r.open("GET", t.url, !0);
                        var s = this.context.headers;
                        if (s) for (var a in s) r.setRequestHeader(a, s[a]);
                      } catch (e) {
                        return void this.callbacks.onError({ code: r.status, text: e.message }, t, r);
                      }
                      t.rangeEnd && r.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)),
                        (r.onreadystatechange = this.readystatechange.bind(this)),
                        (r.onprogress = this.loadprogress.bind(this)),
                        (r.responseType = t.responseType),
                        self.clearTimeout(this.requestTimeout),
                        (this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), e.timeout)),
                        r.send();
                    }
                  }),
                  (t.readystatechange = function() {
                    var e = this.context,
                      t = this.loader,
                      r = this.stats;
                    if (e && t) {
                      var n = t.readyState,
                        s = this.config;
                      if (!r.aborted && n >= 2)
                        if (
                          (self.clearTimeout(this.requestTimeout),
                          0 === r.loading.first &&
                            (r.loading.first = Math.max(self.performance.now(), r.loading.start)),
                          4 === n)
                        ) {
                          (t.onreadystatechange = null), (t.onprogress = null);
                          var a = t.status;
                          if (a >= 200 && a < 300) {
                            var o, l;
                            if (
                              ((r.loading.end = Math.max(self.performance.now(), r.loading.first)),
                              (l =
                                "arraybuffer" === e.responseType
                                  ? (o = t.response).byteLength
                                  : (o = t.responseText).length),
                              (r.loaded = r.total = l),
                              !this.callbacks)
                            )
                              return;
                            var u = this.callbacks.onProgress;
                            if ((u && u(r, e, o, t), !this.callbacks)) return;
                            var d = { url: t.responseURL, data: o };
                            this.callbacks.onSuccess(d, r, e, t);
                          } else
                            r.retry >= s.maxRetry || (a >= 400 && a < 499)
                              ? (i.logger.error(a + " while loading " + e.url),
                                this.callbacks.onError({ code: a, text: t.statusText }, e, t))
                              : (i.logger.warn(
                                  a + " while loading " + e.url + ", retrying in " + this.retryDelay + "..."
                                ),
                                this.abortInternal(),
                                (this.loader = null),
                                self.clearTimeout(this.retryTimeout),
                                (this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay)),
                                (this.retryDelay = Math.min(2 * this.retryDelay, s.maxRetryDelay)),
                                r.retry++);
                        } else
                          self.clearTimeout(this.requestTimeout),
                            (this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), s.timeout));
                    }
                  }),
                  (t.loadtimeout = function() {
                    i.logger.warn("timeout while loading " + this.context.url);
                    var e = this.callbacks;
                    e && (this.abortInternal(), e.onTimeout(this.stats, this.context, this.loader));
                  }),
                  (t.loadprogress = function(e) {
                    var t = this.stats;
                    (t.loaded = e.loaded), e.lengthComputable && (t.total = e.total);
                  }),
                  (t.getCacheAge = function() {
                    var e = null;
                    if (this.loader && s.test(this.loader.getAllResponseHeaders())) {
                      var t = this.loader.getResponseHeader("age");
                      e = t ? parseFloat(t) : null;
                    }
                    return e;
                  }),
                  e
                );
              })();
            t.default = a;
          }
        }).default;
      }),
      (e.exports = i()));
  },
  function(e, t, r) {
    e.exports = r(24);
  },
  function(e) {
    e.exports = JSON.parse(
      '{"play":"Play","pause":"Pause","autoplay":"Autoplay","imagePreview":"Image Preview","settings":"Settings","quality":"Quality","speed":"Speed","speedNormal":"Normal","close":"close","advertisement":"advertisement","stopCast":"Stop Casting","seconds":"seconds","mute":"Mute","unmute":"Unmute","fullScreen":"Full screen","exitFullScreen":"Exit full screen","widescreenOn":"Cinema mode","widescreenOff":"Default mode","copyLink":"Copy link","copyLinkDone":"Copied","showVideoDetails":"Show video details","hideVideoDetails":"Hide video details","copyVideoUrl":"Copy Video URL","copyVideoUrlCurrentTime":"Copy Video URL from Current Time","copyEmbedCode":"Copy Embed Code","keyboardHelp":"Keyboard Help","playerVersion":"Player version","keyHelpHeader":"Player Keyboard Shortcuts","keyHelpSpace":"Handle Pause / Play","keyHelpFKey":"Handle turning on / off Player Fullscreen","keyHelpMKey":"Handle Mute / Unmute","keyHelpUpKey":"Handle increasing volume","keyHelpDownKey":"Handle lowering volume","keyHelpLeftKey":"Handle skip time for 5 seconds backwards","keyHelpRightKey":"Handle skip time for 5 seconds forward","keyHelpPUpKey":"Handle speeding up video","keyHelpPDownKey":"Handle slowing down video","keyHelpWKey":"Handle turning on / off Player Widescreen","keyHelpCKey":"Handle turning on / off Video Thumbnails","shareTabName":"Share","shareTabText":"Share this video with your friends","replayTabName":"Replay Video","replayTabText":"Replay this video from beginning","casting":"Casting to","skipVideoAd":"Skip Ad","skipVideoAdAfter":"Skip Ad in","Related Videos":"Related Videos","Trending":"Trending","bestRecentTabName":"Best Recent","fromCurrentTime":"from current time","hide":"Hide","MEDIA_ERR_ABORTED":"You aborted the video playback.","MEDIA_ERR_NETWORK":"A network error caused the video download to fail part-way.","MEDIA_ERR_DECODE":"The video playback was aborted due to a corruption problem or because the video used features your browser did not support.","MEDIA_ERR_SRC_NOT_SUPPORTED":"The video could not be loaded, either because the server or network failed or because the format is not supported.","MEDIA_ERR":"An unknown error occurred."}'
    );
  },
  function(e, t, r) {
    !(function(e) {
      "use strict";
      function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          t &&
            (i = i.filter(function(t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            r.push.apply(r, i);
        }
        return r;
      }
      function r(e) {
        for (var r = 1; r < arguments.length; r++) {
          var i = null != arguments[r] ? arguments[r] : {};
          r % 2
            ? t(Object(i), !0).forEach(function(t) {
                o(e, t, i[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
              : t(Object(i)).forEach(function(t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                });
        }
        return e;
      }
      function i(e) {
        return (i =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function(e) {
                return typeof e;
              }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              })(e);
      }
      function n(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function s(e, t) {
        for (var r = 0; r < t.length; r++) {
          var i = t[r];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      function a(e, t, r) {
        return t && s(e.prototype, t), r && s(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
      }
      function o(e, t, r) {
        return (
          t in e
            ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 })
            : (e[t] = r),
          e
        );
      }
      function l(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError("Super expression must either be null or a function");
        (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          t && d(e, t);
      }
      function u(e) {
        return (u = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function(e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
      }
      function d(e, t) {
        return (d =
          Object.setPrototypeOf ||
          function(e, t) {
            return (e.__proto__ = t), e;
          })(e, t);
      }
      function c(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return (function(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        })(e);
      }
      function h(e) {
        var t = (function() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
          } catch (e) {
            return !1;
          }
        })();
        return function() {
          var r,
            i = u(e);
          if (t) {
            var n = u(this).constructor;
            r = Reflect.construct(i, arguments, n);
          } else r = i.apply(this, arguments);
          return c(this, r);
        };
      }
      function f(e) {
        return (
          (function(e) {
            if (Array.isArray(e)) return p(e);
          })(e) ||
          (function(e) {
            if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"])
              return Array.from(e);
          })(e) ||
          (function(e, t) {
            if (e) {
              if ("string" == typeof e) return p(e, t);
              var r = Object.prototype.toString.call(e).slice(8, -1);
              return (
                "Object" === r && e.constructor && (r = e.constructor.name),
                "Map" === r || "Set" === r
                  ? Array.from(e)
                  : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                    ? p(e, t)
                    : void 0
              );
            }
          })(e) ||
          (function() {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, i = new Array(t); r < t; r++) i[r] = e[r];
        return i;
      }
      function v() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return {
          id: e.id || null,
          adId: e.adId || null,
          sequence: e.sequence || null,
          apiFramework: e.apiFramework || null,
          universalAdIds: [],
          creativeExtensions: []
        };
      }
      var g = [
        "ADCATEGORIES",
        "ADCOUNT",
        "ADPLAYHEAD",
        "ADSERVINGID",
        "ADTYPE",
        "APIFRAMEWORKS",
        "APPBUNDLE",
        "ASSETURI",
        "BLOCKEDADCATEGORIES",
        "BREAKMAXADLENGTH",
        "BREAKMAXADS",
        "BREAKMAXDURATION",
        "BREAKMINADLENGTH",
        "BREAKMINDURATION",
        "BREAKPOSITION",
        "CLICKPOS",
        "CLICKTYPE",
        "CLIENTUA",
        "CONTENTID",
        "CONTENTPLAYHEAD",
        "CONTENTURI",
        "DEVICEIP",
        "DEVICEUA",
        "DOMAIN",
        "EXTENSIONS",
        "GDPRCONSENT",
        "IFA",
        "IFATYPE",
        "INVENTORYSTATE",
        "LATLONG",
        "LIMITADTRACKING",
        "MEDIAMIME",
        "MEDIAPLAYHEAD",
        "OMIDPARTNER",
        "PAGEURL",
        "PLACEMENTTYPE",
        "PLAYERCAPABILITIES",
        "PLAYERSIZE",
        "PLAYERSTATE",
        "PODSEQUENCE",
        "REGULATIONS",
        "SERVERSIDE",
        "SERVERUA",
        "TRANSACTIONID",
        "UNIVERSALADID",
        "VASTVERSIONS",
        "VERIFICATIONVENDORS"
      ];
      function m(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = [],
          n = T(e);
        for (var s in (!t.ERRORCODE || r.isCustomCode || /^[0-9]{3}$/.test(t.ERRORCODE) || (t.ERRORCODE = 900),
        (t.CACHEBUSTING = A(Math.round(1e8 * Math.random()).toString())),
        (t.TIMESTAMP = new Date().toISOString()),
        (t.RANDOM = t.random = t.CACHEBUSTING),
        t))
          t[s] = k(t[s]);
        for (var a in n) {
          var o = n[a];
          "string" == typeof o && i.push(y(o, t));
        }
        return i;
      }
      function y(e, t) {
        var r = (e = E(e, t)).match(/[^[\]]+(?=])/g);
        if (!r) return e;
        var i = r.filter(function(e) {
          return g.indexOf(e) > -1;
        });
        return 0 === i.length
          ? e
          : E(
              e,
              (i = i.reduce(function(e, t) {
                return (e[t] = -1), e;
              }, {}))
            );
      }
      function E(e, t) {
        var r = e;
        for (var i in t) {
          var n = t[i];
          r = r.replace(new RegExp("(?:\\[|%%)(".concat(i, ")(?:\\]|%%)"), "g"), n);
        }
        return r;
      }
      function T(e) {
        return Array.isArray(e)
          ? e.map(function(e) {
              return e && e.hasOwnProperty("url") ? e.url : e;
            })
          : e;
      }
      function b(e, t) {
        for (var r = 0; r < t.length; r++) if (S(t[r], e)) return !0;
        return !1;
      }
      function S(e, t) {
        if (e && t) {
          var r = Object.getOwnPropertyNames(e),
            i = Object.getOwnPropertyNames(t);
          return r.length === i.length && e.id === t.id && e.url === t.url;
        }
        return !1;
      }
      function k(e) {
        return encodeURIComponent(e).replace(/[!'()*]/g, function(e) {
          return "%".concat(e.charCodeAt(0).toString(16));
        });
      }
      function A(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8,
          r = String(e);
        return r.length < t
          ? w(0, t - r.length, !1)
              .map(function() {
                return "0";
              })
              .join("") + r
          : r;
      }
      function w(e, t, r) {
        for (var i = [], n = e < t, s = r ? (n ? t + 1 : t - 1) : t, a = e; n ? a < s : a > s; n ? a++ : a--) i.push(a);
        return i;
      }
      var R = {
        track: function(e, t, r) {
          m(e, t, r).forEach(function(e) {
            "undefined" != typeof window && null !== window && (new Image().src = e);
          });
        },
        resolveURLTemplates: m,
        extractURLsFromTemplates: T,
        containsTemplateObject: b,
        isTemplateObjectEqual: S,
        encodeURIComponentRFC3986: k,
        replaceUrlMacros: y,
        leftpad: A,
        range: w,
        isNumeric: function(e) {
          return !isNaN(parseFloat(e)) && isFinite(e);
        },
        flatten: function e(t) {
          return t.reduce(function(t, r) {
            return t.concat(Array.isArray(r) ? e(r) : r);
          }, []);
        },
        joinArrayOfUniqueTemplateObjs: function() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            r = Array.isArray(e) ? e : [],
            i = Array.isArray(t) ? t : [];
          return r.concat(i).reduce(function(e, t) {
            return b(t, e) || e.push(t), e;
          }, []);
        }
      };
      function C(e) {
        return -1 !== ["true", "TRUE", "True", "1"].indexOf(e);
      }
      var L = {
        childByName: function(e, t) {
          var r = e.childNodes;
          for (var i in r) {
            var n = r[i];
            if (n.nodeName === t) return n;
          }
        },
        childrenByName: function(e, t) {
          var r = [],
            i = e.childNodes;
          for (var n in i) {
            var s = i[n];
            s.nodeName === t && r.push(s);
          }
          return r;
        },
        resolveVastAdTagURI: function(e, t) {
          if (!t) return e;
          if (0 === e.indexOf("//")) {
            var r = location.protocol;
            return "".concat(r).concat(e);
          }
          if (-1 === e.indexOf("://")) {
            var i = t.slice(0, t.lastIndexOf("/"));
            return "".concat(i, "/").concat(e);
          }
          return e;
        },
        parseBoolean: C,
        parseNodeText: function(e) {
          return e && (e.textContent || e.text || "").trim();
        },
        copyNodeAttribute: function(e, t, r) {
          var i = t.getAttribute(e);
          i && r.setAttribute(e, i);
        },
        parseAttributes: function(e) {
          for (var t = e.attributes, r = {}, i = 0; i < t.length; i++) r[t[i].nodeName] = t[i].nodeValue;
          return r;
        },
        parseDuration: function(e) {
          if (null == e) return -1;
          if (R.isNumeric(e)) return parseInt(e);
          var t = e.split(":");
          if (3 !== t.length) return -1;
          var r = t[2].split("."),
            i = parseInt(r[0]);
          2 === r.length && (i += parseFloat("0.".concat(r[1])));
          var n = parseInt(60 * t[1]),
            s = parseInt(60 * t[0] * 60);
          return isNaN(s) || isNaN(n) || isNaN(i) || n > 3600 || i > 60 ? -1 : s + n + i;
        },
        splitVAST: function(e) {
          var t = [],
            r = null;
          return (
            e.forEach(function(i, n) {
              if ((i.sequence && (i.sequence = parseInt(i.sequence, 10)), i.sequence > 1)) {
                var s = e[n - 1];
                if (s && s.sequence === i.sequence - 1) return void (r && r.push(i));
                delete i.sequence;
              }
              (r = [i]), t.push(r);
            }),
            t
          );
        },
        assignAttributes: function(e, t) {
          if (e)
            for (var r in e) {
              var i = e[r];
              if (i.nodeName && i.nodeValue && t.hasOwnProperty(i.nodeName)) {
                var n = i.nodeValue;
                "boolean" == typeof t[i.nodeName] && (n = C(n)), (t[i.nodeName] = n);
              }
            }
        },
        mergeWrapperAdData: function(e, t) {
          (e.errorURLTemplates = t.errorURLTemplates.concat(e.errorURLTemplates)),
            (e.impressionURLTemplates = t.impressionURLTemplates.concat(e.impressionURLTemplates)),
            (e.extensions = t.extensions.concat(e.extensions)),
            t.viewableImpression.length > 0 &&
              (e.viewableImpression = [].concat(f(e.viewableImpression), f(t.viewableImpression))),
            (e.followAdditionalWrappers = t.followAdditionalWrappers),
            (e.allowMultipleAds = t.allowMultipleAds),
            (e.fallbackOnNoAd = t.fallbackOnNoAd);
          var r = (t.creatives || []).filter(function(e) {
              return e && "companion" === e.type;
            }),
            i = r.reduce(function(e, t) {
              return (
                (t.variations || []).forEach(function(t) {
                  (t.companionClickTrackingURLTemplates || []).forEach(function(t) {
                    R.containsTemplateObject(t, e) || e.push(t);
                  });
                }),
                e
              );
            }, []);
          e.creatives = r.concat(e.creatives);
          var n = t.videoClickTrackingURLTemplates && t.videoClickTrackingURLTemplates.length,
            s = t.videoCustomClickURLTemplates && t.videoCustomClickURLTemplates.length;
          e.creatives.forEach(function(e) {
            if (t.trackingEvents && t.trackingEvents[e.type])
              for (var r in t.trackingEvents[e.type]) {
                var a = t.trackingEvents[e.type][r];
                Array.isArray(e.trackingEvents[r]) || (e.trackingEvents[r] = []),
                  (e.trackingEvents[r] = e.trackingEvents[r].concat(a));
              }
            "linear" === e.type &&
              (n &&
                (e.videoClickTrackingURLTemplates = e.videoClickTrackingURLTemplates.concat(
                  t.videoClickTrackingURLTemplates
                )),
              s &&
                (e.videoCustomClickURLTemplates = e.videoCustomClickURLTemplates.concat(
                  t.videoCustomClickURLTemplates
                )),
              !t.videoClickThroughURLTemplate ||
                (null !== e.videoClickThroughURLTemplate && void 0 !== e.videoClickThroughURLTemplate) ||
                (e.videoClickThroughURLTemplate = t.videoClickThroughURLTemplate)),
              "companion" === e.type &&
                i.length &&
                (e.variations || []).forEach(function(e) {
                  e.companionClickTrackingURLTemplates = R.joinArrayOfUniqueTemplateObjs(
                    e.companionClickTrackingURLTemplates,
                    i
                  );
                });
          }),
            t.adVerifications && (e.adVerifications = e.adVerifications.concat(t.adVerifications)),
            t.blockedAdCategories && (e.blockedAdCategories = e.blockedAdCategories.concat(t.blockedAdCategories));
        }
      };
      function D(e, t) {
        var r = (function() {
          var e = v(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
          return {
            id: e.id,
            adId: e.adId,
            sequence: e.sequence,
            apiFramework: e.apiFramework,
            type: "companion",
            required: null,
            variations: []
          };
        })(t);
        return (
          (r.required = e.getAttribute("required") || null),
          (r.variations = L.childrenByName(e, "Companion").map(function(e) {
            var t = (function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return {
                id: e.id || null,
                adType: "companionAd",
                width: e.width || 0,
                height: e.height || 0,
                assetWidth: e.assetWidth || null,
                assetHeight: e.assetHeight || null,
                expandedWidth: e.expandedWidth || null,
                expandedHeight: e.expandedHeight || null,
                apiFramework: e.apiFramework || null,
                adSlotID: e.adSlotID || null,
                pxratio: e.pxratio || "1",
                renderingMode: e.renderingMode || "default",
                staticResources: [],
                htmlResources: [],
                iframeResources: [],
                adParameters: null,
                xmlEncoded: null,
                altText: null,
                companionClickThroughURLTemplate: null,
                companionClickTrackingURLTemplates: [],
                trackingEvents: {}
              };
            })(L.parseAttributes(e));
            (t.htmlResources = L.childrenByName(e, "HTMLResource").reduce(function(e, t) {
              var r = L.parseNodeText(t);
              return r ? e.concat(r) : e;
            }, [])),
              (t.iframeResources = L.childrenByName(e, "IFrameResource").reduce(function(e, t) {
                var r = L.parseNodeText(t);
                return r ? e.concat(r) : e;
              }, [])),
              (t.staticResources = L.childrenByName(e, "StaticResource").reduce(function(e, t) {
                var r = L.parseNodeText(t);
                return r ? e.concat({ url: r, creativeType: t.getAttribute("creativeType") || null }) : e;
              }, [])),
              (t.altText = L.parseNodeText(L.childByName(e, "AltText")) || null);
            var r = L.childByName(e, "TrackingEvents");
            r &&
              L.childrenByName(r, "Tracking").forEach(function(e) {
                var r = e.getAttribute("event"),
                  i = L.parseNodeText(e);
                r &&
                  i &&
                  (Array.isArray(t.trackingEvents[r]) || (t.trackingEvents[r] = []), t.trackingEvents[r].push(i));
              }),
              (t.companionClickTrackingURLTemplates = L.childrenByName(e, "CompanionClickTracking").map(function(e) {
                return { id: e.getAttribute("id") || null, url: L.parseNodeText(e) };
              })),
              (t.companionClickThroughURLTemplate = L.parseNodeText(L.childByName(e, "CompanionClickThrough")) || null);
            var i = L.childByName(e, "AdParameters");
            return (
              i && ((t.adParameters = L.parseNodeText(i)), (t.xmlEncoded = i.getAttribute("xmlEncoded") || null)), t
            );
          })),
          r
        );
      }
      function _(e) {
        return "linear" === e.type;
      }
      function I(e, t) {
        var r,
          i = (function() {
            var e = v(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
            return {
              id: e.id,
              adId: e.adId,
              sequence: e.sequence,
              apiFramework: e.apiFramework,
              type: "linear",
              duration: 0,
              skipDelay: null,
              mediaFiles: [],
              mezzanine: null,
              interactiveCreativeFile: null,
              closedCaptionFiles: [],
              videoClickThroughURLTemplate: null,
              videoClickTrackingURLTemplates: [],
              videoCustomClickURLTemplates: [],
              adParameters: null,
              icons: [],
              trackingEvents: {}
            };
          })(t);
        i.duration = L.parseDuration(L.parseNodeText(L.childByName(e, "Duration")));
        var n = e.getAttribute("skipoffset");
        if (null == n) i.skipDelay = null;
        else if ("%" === n.charAt(n.length - 1) && -1 !== i.duration) {
          var s = parseInt(n, 10);
          i.skipDelay = i.duration * (s / 100);
        } else i.skipDelay = L.parseDuration(n);
        var a = L.childByName(e, "VideoClicks");
        if (a) {
          var o = L.childByName(a, "ClickThrough");
          (i.videoClickThroughURLTemplate = o ? { id: o.getAttribute("id") || null, url: L.parseNodeText(o) } : null),
            L.childrenByName(a, "ClickTracking").forEach(function(e) {
              i.videoClickTrackingURLTemplates.push({ id: e.getAttribute("id") || null, url: L.parseNodeText(e) });
            }),
            L.childrenByName(a, "CustomClick").forEach(function(e) {
              i.videoCustomClickURLTemplates.push({ id: e.getAttribute("id") || null, url: L.parseNodeText(e) });
            });
        }
        var l = L.childByName(e, "AdParameters");
        l && (i.adParameters = L.parseNodeText(l)),
          L.childrenByName(e, "TrackingEvents").forEach(function(e) {
            L.childrenByName(e, "Tracking").forEach(function(e) {
              var t = e.getAttribute("event"),
                n = L.parseNodeText(e);
              if (t && n) {
                if ("progress" === t) {
                  if (!(r = e.getAttribute("offset"))) return;
                  t =
                    "%" === r.charAt(r.length - 1)
                      ? "progress-".concat(r)
                      : "progress-".concat(Math.round(L.parseDuration(r)));
                }
                Array.isArray(i.trackingEvents[t]) || (i.trackingEvents[t] = []), i.trackingEvents[t].push(n);
              }
            });
          }),
          L.childrenByName(e, "MediaFiles").forEach(function(e) {
            L.childrenByName(e, "MediaFile").forEach(function(e) {
              i.mediaFiles.push(
                (function(e) {
                  var t = {
                    id: null,
                    fileURL: null,
                    fileSize: 0,
                    deliveryType: "progressive",
                    mimeType: null,
                    mediaType: null,
                    codec: null,
                    bitrate: 0,
                    minBitrate: 0,
                    maxBitrate: 0,
                    width: 0,
                    height: 0,
                    apiFramework: null,
                    scalable: null,
                    maintainAspectRatio: null
                  };
                  (t.id = e.getAttribute("id")),
                    (t.fileURL = L.parseNodeText(e)),
                    (t.deliveryType = e.getAttribute("delivery")),
                    (t.codec = e.getAttribute("codec")),
                    (t.mimeType = e.getAttribute("type")),
                    (t.mediaType = e.getAttribute("mediaType") || "2D"),
                    (t.apiFramework = e.getAttribute("apiFramework")),
                    (t.fileSize = parseInt(e.getAttribute("fileSize") || 0)),
                    (t.bitrate = parseInt(e.getAttribute("bitrate") || 0)),
                    (t.minBitrate = parseInt(e.getAttribute("minBitrate") || 0)),
                    (t.maxBitrate = parseInt(e.getAttribute("maxBitrate") || 0)),
                    (t.width = parseInt(e.getAttribute("width") || 0)),
                    (t.height = parseInt(e.getAttribute("height") || 0));
                  var r = e.getAttribute("scalable");
                  r && "string" == typeof r && (t.scalable = L.parseBoolean(r));
                  var i = e.getAttribute("maintainAspectRatio");
                  return i && "string" == typeof i && (t.maintainAspectRatio = L.parseBoolean(i)), t;
                })(e)
              );
            });
            var t = L.childByName(e, "InteractiveCreativeFile");
            t &&
              (i.interactiveCreativeFile = (function(e) {
                var t = (function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  return {
                    type: e.type || null,
                    apiFramework: e.apiFramework || null,
                    variableDuration: L.parseBoolean(e.variableDuration),
                    fileURL: null
                  };
                })(L.parseAttributes(e));
                return (t.fileURL = L.parseNodeText(e)), t;
              })(t));
            var r = L.childByName(e, "ClosedCaptionFiles");
            r &&
              L.childrenByName(r, "ClosedCaptionFile").forEach(function(e) {
                var t = (function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  return { type: e.type || null, language: e.language || null, fileURL: null };
                })(L.parseAttributes(e));
                (t.fileURL = L.parseNodeText(e)), i.closedCaptionFiles.push(t);
              });
            var n,
              s,
              a,
              o = L.childByName(e, "Mezzanine"),
              l = ((n = o),
              (s = {}),
              (a = !1),
              ["delivery", "type", "width", "height"].forEach(function(e) {
                n && n.getAttribute(e) ? (s[e] = n.getAttribute(e)) : (a = !0);
              }),
              a ? null : s);
            if (l) {
              var u = {
                id: null,
                fileURL: null,
                delivery: null,
                codec: null,
                type: null,
                width: 0,
                height: 0,
                fileSize: 0,
                mediaType: "2D"
              };
              (u.id = o.getAttribute("id")),
                (u.fileURL = L.parseNodeText(o)),
                (u.delivery = l.delivery),
                (u.codec = o.getAttribute("codec")),
                (u.type = l.type),
                (u.width = parseInt(l.width, 10)),
                (u.height = parseInt(l.height, 10)),
                (u.fileSize = parseInt(o.getAttribute("fileSize"), 10)),
                (u.mediaType = o.getAttribute("mediaType") || "2D"),
                (i.mezzanine = u);
            }
          });
        var u = L.childByName(e, "Icons");
        return (
          u &&
            L.childrenByName(u, "Icon").forEach(function(e) {
              i.icons.push(
                (function(e) {
                  var t = {
                    program: null,
                    height: 0,
                    width: 0,
                    xPosition: 0,
                    yPosition: 0,
                    apiFramework: null,
                    offset: null,
                    duration: 0,
                    type: null,
                    staticResource: null,
                    htmlResource: null,
                    iframeResource: null,
                    pxratio: "1",
                    iconClickThroughURLTemplate: null,
                    iconClickTrackingURLTemplates: [],
                    iconViewTrackingURLTemplate: null
                  };
                  (t.program = e.getAttribute("program")),
                    (t.height = parseInt(e.getAttribute("height") || 0)),
                    (t.width = parseInt(e.getAttribute("width") || 0)),
                    (t.xPosition = (function(e) {
                      return -1 !== ["left", "right"].indexOf(e) ? e : parseInt(e || 0);
                    })(e.getAttribute("xPosition"))),
                    (t.yPosition = (function(e) {
                      return -1 !== ["top", "bottom"].indexOf(e) ? e : parseInt(e || 0);
                    })(e.getAttribute("yPosition"))),
                    (t.apiFramework = e.getAttribute("apiFramework")),
                    (t.pxratio = e.getAttribute("pxratio") || "1"),
                    (t.offset = L.parseDuration(e.getAttribute("offset"))),
                    (t.duration = L.parseDuration(e.getAttribute("duration"))),
                    L.childrenByName(e, "HTMLResource").forEach(function(e) {
                      (t.type = e.getAttribute("creativeType") || "text/html"), (t.htmlResource = L.parseNodeText(e));
                    }),
                    L.childrenByName(e, "IFrameResource").forEach(function(e) {
                      (t.type = e.getAttribute("creativeType") || 0), (t.iframeResource = L.parseNodeText(e));
                    }),
                    L.childrenByName(e, "StaticResource").forEach(function(e) {
                      (t.type = e.getAttribute("creativeType") || 0), (t.staticResource = L.parseNodeText(e));
                    });
                  var r = L.childByName(e, "IconClicks");
                  return (
                    r &&
                      ((t.iconClickThroughURLTemplate = L.parseNodeText(L.childByName(r, "IconClickThrough"))),
                      L.childrenByName(r, "IconClickTracking").forEach(function(e) {
                        t.iconClickTrackingURLTemplates.push({
                          id: e.getAttribute("id") || null,
                          url: L.parseNodeText(e)
                        });
                      })),
                    (t.iconViewTrackingURLTemplate = L.parseNodeText(L.childByName(e, "IconViewTracking"))),
                    t
                  );
                })(e)
              );
            }),
          i
        );
      }
      function x(e, t) {
        var r = (function() {
          var e = v(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
          return {
            id: e.id,
            adId: e.adId,
            sequence: e.sequence,
            apiFramework: e.apiFramework,
            type: "nonlinear",
            variations: [],
            trackingEvents: {}
          };
        })(t);
        return (
          L.childrenByName(e, "TrackingEvents").forEach(function(e) {
            var t, i;
            L.childrenByName(e, "Tracking").forEach(function(e) {
              (t = e.getAttribute("event")),
                (i = L.parseNodeText(e)),
                t &&
                  i &&
                  (Array.isArray(r.trackingEvents[t]) || (r.trackingEvents[t] = []), r.trackingEvents[t].push(i));
            });
          }),
          L.childrenByName(e, "NonLinear").forEach(function(e) {
            var t = {
              id: null,
              width: 0,
              height: 0,
              expandedWidth: 0,
              expandedHeight: 0,
              scalable: !0,
              maintainAspectRatio: !0,
              minSuggestedDuration: 0,
              apiFramework: "static",
              adType: "nonLinearAd",
              type: null,
              staticResource: null,
              htmlResource: null,
              iframeResource: null,
              nonlinearClickThroughURLTemplate: null,
              nonlinearClickTrackingURLTemplates: [],
              adParameters: null
            };
            (t.id = e.getAttribute("id") || null),
              (t.width = e.getAttribute("width")),
              (t.height = e.getAttribute("height")),
              (t.expandedWidth = e.getAttribute("expandedWidth")),
              (t.expandedHeight = e.getAttribute("expandedHeight")),
              (t.scalable = L.parseBoolean(e.getAttribute("scalable"))),
              (t.maintainAspectRatio = L.parseBoolean(e.getAttribute("maintainAspectRatio"))),
              (t.minSuggestedDuration = L.parseDuration(e.getAttribute("minSuggestedDuration"))),
              (t.apiFramework = e.getAttribute("apiFramework")),
              L.childrenByName(e, "HTMLResource").forEach(function(e) {
                (t.type = e.getAttribute("creativeType") || "text/html"), (t.htmlResource = L.parseNodeText(e));
              }),
              L.childrenByName(e, "IFrameResource").forEach(function(e) {
                (t.type = e.getAttribute("creativeType") || 0), (t.iframeResource = L.parseNodeText(e));
              }),
              L.childrenByName(e, "StaticResource").forEach(function(e) {
                (t.type = e.getAttribute("creativeType") || 0), (t.staticResource = L.parseNodeText(e));
              });
            var i = L.childByName(e, "AdParameters");
            i && (t.adParameters = L.parseNodeText(i)),
              (t.nonlinearClickThroughURLTemplate = L.parseNodeText(L.childByName(e, "NonLinearClickThrough"))),
              L.childrenByName(e, "NonLinearClickTracking").forEach(function(e) {
                t.nonlinearClickTrackingURLTemplates.push({
                  id: e.getAttribute("id") || null,
                  url: L.parseNodeText(e)
                });
              }),
              r.variations.push(t);
          }),
          r
        );
      }
      function O(e) {
        var t = [];
        return (
          e.forEach(function(e) {
            var r = P(e);
            r && t.push(r);
          }),
          t
        );
      }
      function P(e) {
        if ("#comment" === e.nodeName) return null;
        var t,
          r = { name: null, value: null, attributes: {}, children: [] },
          i = e.attributes,
          n = e.childNodes;
        if (((r.name = e.nodeName), e.attributes))
          for (var s in i)
            if (i.hasOwnProperty(s)) {
              var a = i[s];
              a.nodeName && a.nodeValue && (r.attributes[a.nodeName] = a.nodeValue);
            }
        for (var o in n)
          if (n.hasOwnProperty(o)) {
            var l = P(n[o]);
            l && r.children.push(l);
          }
        if (
          0 === r.children.length ||
          (1 === r.children.length && ["#cdata-section", "#text"].indexOf(r.children[0].name) >= 0)
        ) {
          var u = L.parseNodeText(e);
          "" !== u && (r.value = u), (r.children = []);
        }
        return null === (t = r).value && 0 === Object.keys(t.attributes).length && 0 === t.children.length ? null : r;
      }
      function M(e) {
        var t = [];
        return (
          e.forEach(function(e) {
            var r,
              i = {
                id: e.getAttribute("id") || null,
                adId: F(e),
                sequence: e.getAttribute("sequence") || null,
                apiFramework: e.getAttribute("apiFramework") || null
              },
              n = [];
            L.childrenByName(e, "UniversalAdId").forEach(function(e) {
              var t = { idRegistry: e.getAttribute("idRegistry") || "unknown", value: L.parseNodeText(e) };
              n.push(t);
            });
            var s = L.childByName(e, "CreativeExtensions");
            for (var a in (s && (r = O(L.childrenByName(s, "CreativeExtension"))), e.childNodes)) {
              var o = e.childNodes[a],
                l = void 0;
              switch (o.nodeName) {
                case "Linear":
                  l = I(o, i);
                  break;
                case "NonLinearAds":
                  l = x(o, i);
                  break;
                case "CompanionAds":
                  l = D(o, i);
              }
              l && (n && (l.universalAdIds = n), r && (l.creativeExtensions = r), t.push(l));
            }
          }),
          t
        );
      }
      function F(e) {
        return e.getAttribute("AdID") || e.getAttribute("adID") || e.getAttribute("adId") || null;
      }
      var N = {
        Wrapper: { subElements: ["VASTAdTagURI", "Impression"] },
        BlockedAdCategories: { attributes: ["authority"] },
        InLine: { subElements: ["AdSystem", "AdTitle", "Impression", "AdServingId", "Creatives"] },
        Category: { attributes: ["authority"] },
        Pricing: { attributes: ["model", "currency"] },
        Verification: { oneOfinLineResources: ["JavaScriptResource", "ExecutableResource"], attributes: ["vendor"] },
        UniversalAdId: { attributes: ["idRegistry"] },
        JavaScriptResource: { attributes: ["apiFramework", "browserOptional"] },
        ExecutableResource: { attributes: ["apiFramework", "type"] },
        Tracking: { attributes: ["event"] },
        Creatives: { subElements: ["Creative"] },
        Creative: { subElements: ["UniversalAdId"] },
        Linear: { subElements: ["MediaFiles", "Duration"] },
        MediaFiles: { subElements: ["MediaFile"] },
        MediaFile: { attributes: ["delivery", "type", "width", "height"] },
        Mezzanine: { attributes: ["delivery", "type", "width", "height"] },
        NonLinear: {
          oneOfinLineResources: ["StaticResource", "IFrameResource", "HTMLResource"],
          attributes: ["width", "height"]
        },
        Companion: {
          oneOfinLineResources: ["StaticResource", "IFrameResource", "HTMLResource"],
          attributes: ["width", "height"]
        },
        StaticResource: { attributes: ["creativeType"] },
        Icons: { subElements: ["Icon"] },
        Icon: { oneOfinLineResources: ["StaticResource", "IFrameResource", "HTMLResource"] }
      };
      function B(e, t) {
        if (N[e.nodeName] && N[e.nodeName].attributes) {
          var r = N[e.nodeName].attributes.filter(function(t) {
            return !e.getAttribute(t);
          });
          r.length > 0 && V({ name: e.nodeName, parentName: e.parentNode.nodeName, attributes: r }, t);
        }
      }
      function U(e, t, r) {
        var i = N[e.nodeName],
          n = !r && "Wrapper" !== e.nodeName;
        if (i && !n) {
          if (i.subElements) {
            var s = i.subElements.filter(function(t) {
              return !L.childByName(e, t);
            });
            s.length > 0 && V({ name: e.nodeName, parentName: e.parentNode.nodeName, subElements: s }, t);
          }
          r &&
            i.oneOfinLineResources &&
            (i.oneOfinLineResources.some(function(t) {
              return L.childByName(e, t);
            }) ||
              V({ name: e.nodeName, parentName: e.parentNode.nodeName, oneOfResources: i.oneOfinLineResources }, t));
        }
      }
      function H(e) {
        return e.children && 0 !== e.children.length;
      }
      function V(e, t) {
        var r = e.name,
          i = e.parentName,
          n = e.attributes,
          s = e.subElements,
          a = e.oneOfResources,
          o = "Element '".concat(r, "'");
        t("VAST-warning", {
          message: (o += n
            ? " missing required attribute(s) '".concat(n.join(", "), "' ")
            : s
              ? " missing required sub element(s) '".concat(s.join(", "), "' ")
              : a
                ? " must provide one of the following '".concat(a.join(", "), "' ")
                : " is empty"),
          parentElement: i,
          specVersion: 4.1
        });
      }
      var K = {
        verifyRequiredValues: function e(t, r, i) {
          if (t && t.nodeName)
            if (("InLine" === t.nodeName && (i = !0), B(t, r), H(t))) {
              U(t, r, i);
              for (var n = 0; n < t.children.length; n++) e(t.children[n], r, i);
            } else 0 === L.parseNodeText(t).length && V({ name: t.nodeName, parentName: t.parentNode.nodeName }, r);
        },
        hasSubElements: H,
        emitMissingValueWarning: V,
        verifyRequiredAttributes: B,
        verifyRequiredSubElements: U
      };
      function W(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = r.allowMultipleAds,
          n = r.followAdditionalWrappers,
          s = e.childNodes;
        for (var a in s) {
          var o = s[a];
          if (-1 !== ["Wrapper", "InLine"].indexOf(o.nodeName) && ("Wrapper" !== o.nodeName || !1 !== n)) {
            if (
              (L.copyNodeAttribute("id", e, o),
              L.copyNodeAttribute("sequence", e, o),
              L.copyNodeAttribute("adType", e, o),
              "Wrapper" === o.nodeName)
            )
              return { ad: Y(o, t), type: "WRAPPER" };
            if ("InLine" === o.nodeName) return { ad: G(o, t, { allowMultipleAds: i }), type: "INLINE" };
          }
        }
      }
      function G(e, t) {
        return !1 === (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).allowMultipleAds &&
          e.getAttribute("sequence")
          ? null
          : j(e, t);
      }
      function j(e, t) {
        var r = [];
        t && K.verifyRequiredValues(e, t);
        var i = e.childNodes,
          n = (function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
              id: e.id || null,
              sequence: e.sequence || null,
              adType: e.adType || null,
              adServingId: null,
              categories: [],
              expires: null,
              viewableImpression: [],
              system: null,
              title: null,
              description: null,
              advertiser: null,
              pricing: null,
              survey: null,
              errorURLTemplates: [],
              impressionURLTemplates: [],
              creatives: [],
              extensions: [],
              adVerifications: [],
              blockedAdCategories: [],
              followAdditionalWrappers: !0,
              allowMultipleAds: !1,
              fallbackOnNoAd: null
            };
          })(L.parseAttributes(e));
        for (var s in i) {
          var a = i[s];
          switch (a.nodeName) {
            case "Error":
              n.errorURLTemplates.push(L.parseNodeText(a));
              break;
            case "Impression":
              n.impressionURLTemplates.push({ id: a.getAttribute("id") || null, url: L.parseNodeText(a) });
              break;
            case "Creatives":
              n.creatives = M(L.childrenByName(a, "Creative"));
              break;
            case "Extensions":
              var o = L.childrenByName(a, "Extension");
              (n.extensions = O(o)), n.adVerifications.length || (r = z(o));
              break;
            case "AdVerifications":
              n.adVerifications = q(L.childrenByName(a, "Verification"));
              break;
            case "AdSystem":
              n.system = { value: L.parseNodeText(a), version: a.getAttribute("version") || null };
              break;
            case "AdTitle":
              n.title = L.parseNodeText(a);
              break;
            case "AdServingId":
              n.adServingId = L.parseNodeText(a);
              break;
            case "Category":
              n.categories.push({ authority: a.getAttribute("authority") || null, value: L.parseNodeText(a) });
              break;
            case "Expires":
              n.expires = parseInt(L.parseNodeText(a), 10);
              break;
            case "ViewableImpression":
              n.viewableImpression.push(X(a));
              break;
            case "Description":
              n.description = L.parseNodeText(a);
              break;
            case "Advertiser":
              n.advertiser = { id: a.getAttribute("id") || null, value: L.parseNodeText(a) };
              break;
            case "Pricing":
              n.pricing = {
                value: L.parseNodeText(a),
                model: a.getAttribute("model") || null,
                currency: a.getAttribute("currency") || null
              };
              break;
            case "Survey":
              n.survey = L.parseNodeText(a);
              break;
            case "BlockedAdCategories":
              n.blockedAdCategories.push({ authority: a.getAttribute("authority") || null, value: L.parseNodeText(a) });
          }
        }
        return r.length && (n.adVerifications = n.adVerifications.concat(r)), n;
      }
      function Y(e, t) {
        var r = j(e, t),
          i = e.getAttribute("followAdditionalWrappers"),
          n = e.getAttribute("allowMultipleAds"),
          s = e.getAttribute("fallbackOnNoAd");
        (r.followAdditionalWrappers = !i || L.parseBoolean(i)),
          (r.allowMultipleAds = !!n && L.parseBoolean(n)),
          (r.fallbackOnNoAd = s ? L.parseBoolean(s) : null);
        var a = L.childByName(e, "VASTAdTagURI");
        if (
          (a
            ? (r.nextWrapperURL = L.parseNodeText(a))
            : (a = L.childByName(e, "VASTAdTagURL")) && (r.nextWrapperURL = L.parseNodeText(L.childByName(a, "URL"))),
          r.creatives.forEach(function(e) {
            if (-1 !== ["linear", "nonlinear"].indexOf(e.type)) {
              if (e.trackingEvents) {
                r.trackingEvents || (r.trackingEvents = {}),
                  r.trackingEvents[e.type] || (r.trackingEvents[e.type] = {});
                var t = function(t) {
                  var i = e.trackingEvents[t];
                  Array.isArray(r.trackingEvents[e.type][t]) || (r.trackingEvents[e.type][t] = []),
                    i.forEach(function(i) {
                      r.trackingEvents[e.type][t].push(i);
                    });
                };
                for (var i in e.trackingEvents) t(i);
              }
              e.videoClickTrackingURLTemplates &&
                (Array.isArray(r.videoClickTrackingURLTemplates) || (r.videoClickTrackingURLTemplates = []),
                e.videoClickTrackingURLTemplates.forEach(function(e) {
                  r.videoClickTrackingURLTemplates.push(e);
                })),
                e.videoClickThroughURLTemplate && (r.videoClickThroughURLTemplate = e.videoClickThroughURLTemplate),
                e.videoCustomClickURLTemplates &&
                  (Array.isArray(r.videoCustomClickURLTemplates) || (r.videoCustomClickURLTemplates = []),
                  e.videoCustomClickURLTemplates.forEach(function(e) {
                    r.videoCustomClickURLTemplates.push(e);
                  }));
            }
          }),
          r.nextWrapperURL)
        )
          return r;
      }
      function q(e) {
        var t = [];
        return (
          e.forEach(function(e) {
            var r = {
                resource: null,
                vendor: null,
                browserOptional: !1,
                apiFramework: null,
                type: null,
                parameters: null,
                trackingEvents: {}
              },
              i = e.childNodes;
            for (var n in (L.assignAttributes(e.attributes, r), i)) {
              var s = i[n];
              switch (s.nodeName) {
                case "JavaScriptResource":
                case "ExecutableResource":
                  (r.resource = L.parseNodeText(s)), L.assignAttributes(s.attributes, r);
                  break;
                case "VerificationParameters":
                  r.parameters = L.parseNodeText(s);
              }
            }
            var a = L.childByName(e, "TrackingEvents");
            a &&
              L.childrenByName(a, "Tracking").forEach(function(e) {
                var t = e.getAttribute("event"),
                  i = L.parseNodeText(e);
                t &&
                  i &&
                  (Array.isArray(r.trackingEvents[t]) || (r.trackingEvents[t] = []), r.trackingEvents[t].push(i));
              }),
              t.push(r);
          }),
          t
        );
      }
      function z(e) {
        var t = null,
          r = [];
        return (
          e.some(function(e) {
            return (t = L.childByName(e, "AdVerifications"));
          }),
          t && (r = q(L.childrenByName(t, "Verification"))),
          r
        );
      }
      function X(e) {
        var t = {};
        t.id = e.getAttribute("id") || null;
        var r = e.childNodes;
        for (var i in r) {
          var n = r[i],
            s = n.nodeName,
            a = L.parseNodeText(n);
          if (("Viewable" === s || "NotViewable" === s || "ViewUndetermined" === s) && a) {
            var o = s.toLowerCase();
            Array.isArray(t[o]) || (t[o] = []), t[o].push(a);
          }
        }
        return t;
      }
      var Q = (function() {
          function e() {
            n(this, e), (this._handlers = []);
          }
          return (
            a(e, [
              {
                key: "on",
                value: function(e, t) {
                  if ("function" != typeof t)
                    throw new TypeError("The handler argument must be of type Function. Received type ".concat(i(t)));
                  if (!e) throw new TypeError("The event argument must be of type String. Received type ".concat(i(e)));
                  return this._handlers.push({ event: e, handler: t }), this;
                }
              },
              {
                key: "once",
                value: function(e, t) {
                  return this.on(
                    e,
                    (function(e, t, r) {
                      var i = { fired: !1, wrapFn: void 0 };
                      function n() {
                        i.fired || (e.off(t, i.wrapFn), (i.fired = !0), r.bind(e).apply(void 0, arguments));
                      }
                      return (i.wrapFn = n), n;
                    })(this, e, t)
                  );
                }
              },
              {
                key: "off",
                value: function(e, t) {
                  return (
                    (this._handlers = this._handlers.filter(function(r) {
                      return r.event !== e || r.handler !== t;
                    })),
                    this
                  );
                }
              },
              {
                key: "emit",
                value: function(e) {
                  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
                    r[i - 1] = arguments[i];
                  var n = !1;
                  return (
                    this._handlers.forEach(function(t) {
                      "*" === t.event && ((n = !0), t.handler.apply(t, [e].concat(r))),
                        t.event === e && ((n = !0), t.handler.apply(t, r));
                    }),
                    n
                  );
                }
              },
              {
                key: "removeAllListeners",
                value: function(e) {
                  return e
                    ? ((this._handlers = this._handlers.filter(function(t) {
                        return t.event !== e;
                      })),
                      this)
                    : ((this._handlers = []), this);
                }
              },
              {
                key: "listenerCount",
                value: function(e) {
                  return this._handlers.filter(function(t) {
                    return t.event === e;
                  }).length;
                }
              },
              {
                key: "listeners",
                value: function(e) {
                  return this._handlers.reduce(function(t, r) {
                    return r.event === e && t.push(r.handler), t;
                  }, []);
                }
              },
              {
                key: "eventNames",
                value: function() {
                  return this._handlers.map(function(e) {
                    return e.event;
                  });
                }
              }
            ]),
            e
          );
        })(),
        J = {
          get: function(e, t, r) {
            r(new Error("Please bundle the library for node to use the node urlHandler"));
          }
        },
        $ = 12e4;
      function Z() {
        try {
          var e = new window.XMLHttpRequest();
          return "withCredentials" in e ? e : null;
        } catch (e) {
          return null;
        }
      }
      function ee(e, t, r) {
        var i = r ? 408 : e.status,
          n = r
            ? "XHRURLHandler: Request timed out after ".concat(e.timeout, " ms (").concat(i, ")")
            : "XHRURLHandler: ".concat(e.statusText, " (").concat(i, ")");
        t(new Error(n), null, { statusCode: i });
      }
      var te = {
          get: function(e, t, r) {
            if ("https:" === window.location.protocol && 0 === e.indexOf("http://"))
              return r(new Error("XHRURLHandler: Cannot go from HTTPS to HTTP."));
            try {
              var i = Z();
              i.open("GET", e),
                (i.timeout = t.timeout || $),
                (i.withCredentials = t.withCredentials || !1),
                i.overrideMimeType && i.overrideMimeType("text/xml"),
                (i.onload = function() {
                  return (function(e, t) {
                    200 === e.status
                      ? t(null, e.responseXML, { byteLength: e.response.length, statusCode: e.status })
                      : ee(e, t, !1);
                  })(i, r);
                }),
                (i.onerror = function() {
                  return ee(i, r, !1);
                }),
                (i.onabort = function() {
                  return ee(i, r, !1);
                }),
                (i.ontimeout = function() {
                  return ee(i, r, !0);
                }),
                i.send();
            } catch (e) {
              r(new Error("XHRURLHandler: Unexpected error"));
            }
          },
          supported: function() {
            return !!Z();
          }
        },
        re = {
          get: function(e, t, r) {
            return (
              r || ("function" == typeof t && (r = t), (t = {})),
              "undefined" == typeof window || null === window
                ? J.get(e, t, r)
                : te.supported()
                  ? te.get(e, t, r)
                  : r(
                      new Error(
                        "Current context is not supported by any of the default URLHandlers. Please provide a custom URLHandler"
                      )
                    )
            );
          }
        },
        ie = 0,
        ne = 0,
        se = function(e, t) {
          !e || !t || e <= 0 || t <= 0 || (ne = (ne * ie + (8 * e) / t) / ++ie);
        },
        ae = { ERRORCODE: 900, extensions: [] },
        oe = (function(e) {
          l(r, e);
          var t = h(r);
          function r() {
            var e;
            return (
              n(this, r),
              ((e = t.call(this)).remainingAds = []),
              (e.parentURLs = []),
              (e.errorURLTemplates = []),
              (e.rootErrorURLTemplates = []),
              (e.maxWrapperDepth = null),
              (e.URLTemplateFilters = []),
              (e.fetchingOptions = {}),
              (e.parsingOptions = {}),
              e
            );
          }
          return (
            a(r, [
              {
                key: "addURLTemplateFilter",
                value: function(e) {
                  "function" == typeof e && this.URLTemplateFilters.push(e);
                }
              },
              {
                key: "removeURLTemplateFilter",
                value: function() {
                  this.URLTemplateFilters.pop();
                }
              },
              {
                key: "countURLTemplateFilters",
                value: function() {
                  return this.URLTemplateFilters.length;
                }
              },
              {
                key: "clearURLTemplateFilters",
                value: function() {
                  this.URLTemplateFilters = [];
                }
              },
              {
                key: "trackVastError",
                value: function(e, t) {
                  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)
                    i[n - 2] = arguments[n];
                  this.emit("VAST-error", Object.assign.apply(Object, [{}, ae, t].concat(i))), R.track(e, t);
                }
              },
              {
                key: "getErrorURLTemplates",
                value: function() {
                  return this.rootErrorURLTemplates.concat(this.errorURLTemplates);
                }
              },
              {
                key: "getEstimatedBitrate",
                value: function() {
                  return ne;
                }
              },
              {
                key: "fetchVAST",
                value: function(e) {
                  var t = this,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                    i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                    n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                  return new Promise(function(s, a) {
                    t.URLTemplateFilters.forEach(function(t) {
                      e = t(e);
                    }),
                      t.parentURLs.push(e);
                    var o = Date.now();
                    t.emit("VAST-resolving", {
                      url: e,
                      previousUrl: i,
                      wrapperDepth: r,
                      maxWrapperDepth: t.maxWrapperDepth,
                      timeout: t.fetchingOptions.timeout,
                      wrapperAd: n
                    }),
                      t.urlHandler.get(e, t.fetchingOptions, function(n, l) {
                        var u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                          d = Math.round(Date.now() - o),
                          c = Object.assign({ url: e, previousUrl: i, wrapperDepth: r, error: n, duration: d }, u);
                        t.emit("VAST-resolved", c), se(u.byteLength, d), n ? a(n) : s(l);
                      });
                  });
                }
              },
              {
                key: "initParsingStatus",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  (this.errorURLTemplates = []),
                    (this.fetchingOptions = { timeout: e.timeout || $, withCredentials: e.withCredentials }),
                    (this.maxWrapperDepth = e.wrapperLimit || 10),
                    (this.parentURLs = []),
                    (this.parsingOptions = { allowMultipleAds: e.allowMultipleAds }),
                    (this.remainingAds = []),
                    (this.rootErrorURLTemplates = []),
                    (this.rootURL = ""),
                    (this.urlHandler = e.urlHandler || e.urlhandler || re),
                    (this.vastVersion = null),
                    se(e.byteLength, e.requestDuration);
                }
              },
              {
                key: "getRemainingAds",
                value: function(e) {
                  var t = this;
                  if (0 === this.remainingAds.length)
                    return Promise.reject(new Error("No more ads are available for the given VAST"));
                  var r = e ? R.flatten(this.remainingAds) : this.remainingAds.shift();
                  return (
                    (this.errorURLTemplates = []),
                    (this.parentURLs = []),
                    this.resolveAds(r, { wrapperDepth: 0, url: this.rootURL }).then(function(e) {
                      return t.buildVASTResponse(e);
                    })
                  );
                }
              },
              {
                key: "getAndParseVAST",
                value: function(e) {
                  var t = this,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  return (
                    this.initParsingStatus(r),
                    this.URLTemplateFilters.forEach(function(t) {
                      e = t(e);
                    }),
                    (this.rootURL = e),
                    this.fetchVAST(e).then(function(i) {
                      return (
                        (r.previousUrl = e),
                        (r.isRootVAST = !0),
                        (r.url = e),
                        t.parse(i, r).then(function(e) {
                          return t.buildVASTResponse(e);
                        })
                      );
                    })
                  );
                }
              },
              {
                key: "parseVAST",
                value: function(e) {
                  var t = this,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  return (
                    this.initParsingStatus(r),
                    (r.isRootVAST = !0),
                    this.parse(e, r).then(function(e) {
                      return t.buildVASTResponse(e);
                    })
                  );
                }
              },
              {
                key: "buildVASTResponse",
                value: function(e) {
                  var t,
                    r = {
                      ads:
                        (t = { ads: e, errorURLTemplates: this.getErrorURLTemplates(), version: this.vastVersion })
                          .ads || [],
                      errorURLTemplates: t.errorURLTemplates || [],
                      version: t.version || null
                    };
                  return this.completeWrapperResolving(r), r;
                }
              },
              {
                key: "parseVastXml",
                value: function(e, t) {
                  var r = t.isRootVAST,
                    i = void 0 !== r && r,
                    n = t.url,
                    s = void 0 === n ? null : n,
                    a = t.wrapperDepth,
                    o = void 0 === a ? 0 : a,
                    l = t.allowMultipleAds,
                    u = t.followAdditionalWrappers;
                  if (!e || !e.documentElement || "VAST" !== e.documentElement.nodeName)
                    throw (this.emit("VAST-ad-parsed", { type: "ERROR", url: s, wrapperDepth: o }),
                    new Error("Invalid VAST XMLDocument"));
                  var d = [],
                    c = e.documentElement.childNodes,
                    h = e.documentElement.getAttribute("version");
                  for (var f in (i && h && (this.vastVersion = h), c)) {
                    var p = c[f];
                    if ("Error" === p.nodeName) {
                      var v = L.parseNodeText(p);
                      i ? this.rootErrorURLTemplates.push(v) : this.errorURLTemplates.push(v);
                    } else if ("Ad" === p.nodeName) {
                      if (this.vastVersion && parseFloat(this.vastVersion) < 3) l = !0;
                      else if (!1 === l && d.length > 1) break;
                      var g = W(p, this.emit.bind(this), { allowMultipleAds: l, followAdditionalWrappers: u });
                      g.ad
                        ? (d.push(g.ad),
                          this.emit("VAST-ad-parsed", {
                            type: g.type,
                            url: s,
                            wrapperDepth: o,
                            adIndex: d.length - 1,
                            vastVersion: h
                          }))
                        : this.trackVastError(this.getErrorURLTemplates(), { ERRORCODE: 101 });
                    }
                  }
                  return d;
                }
              },
              {
                key: "parse",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.url,
                    i = void 0 === r ? null : r,
                    n = t.resolveAll,
                    s = void 0 === n || n,
                    a = t.wrapperSequence,
                    o = void 0 === a ? null : a,
                    l = t.previousUrl,
                    u = void 0 === l ? null : l,
                    d = t.wrapperDepth,
                    c = void 0 === d ? 0 : d,
                    h = t.isRootVAST,
                    f = void 0 !== h && h,
                    p = t.followAdditionalWrappers,
                    v = t.allowMultipleAds,
                    g = [];
                  this.vastVersion && parseFloat(this.vastVersion) < 3 && f && (v = !0);
                  try {
                    g = this.parseVastXml(e, {
                      isRootVAST: f,
                      url: i,
                      wrapperDepth: c,
                      allowMultipleAds: v,
                      followAdditionalWrappers: p
                    });
                  } catch (e) {
                    return Promise.reject(e);
                  }
                  return (
                    1 === g.length && null != o && (g[0].sequence = o),
                    !1 === s && ((this.remainingAds = L.splitVAST(g)), (g = this.remainingAds.shift())),
                    this.resolveAds(g, { wrapperDepth: c, previousUrl: u, url: i })
                  );
                }
              },
              {
                key: "resolveAds",
                value: function() {
                  var e = this,
                    t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                    r = arguments.length > 1 ? arguments[1] : void 0,
                    i = r.wrapperDepth,
                    n = r.previousUrl,
                    s = r.url,
                    a = [];
                  return (
                    (n = s),
                    t.forEach(function(t) {
                      var r = e.resolveWrappers(t, i, n);
                      a.push(r);
                    }),
                    Promise.all(a).then(function(t) {
                      var r = R.flatten(t);
                      if (!r && e.remainingAds.length > 0) {
                        var a = e.remainingAds.shift();
                        return e.resolveAds(a, { wrapperDepth: i, previousUrl: n, url: s });
                      }
                      return r;
                    })
                  );
                }
              },
              {
                key: "resolveWrappers",
                value: function(e, t, r) {
                  var i = this;
                  return new Promise(function(n) {
                    var s;
                    if ((t++, !e.nextWrapperURL)) return delete e.nextWrapperURL, n(e);
                    if (t >= i.maxWrapperDepth || -1 !== i.parentURLs.indexOf(e.nextWrapperURL))
                      return (e.errorCode = 302), delete e.nextWrapperURL, n(e);
                    (e.nextWrapperURL = L.resolveVastAdTagURI(e.nextWrapperURL, r)),
                      i.URLTemplateFilters.forEach(function(t) {
                        e.nextWrapperURL = t(e.nextWrapperURL);
                      });
                    var a = null !== (s = i.parsingOptions.allowMultipleAds) && void 0 !== s ? s : e.allowMultipleAds,
                      o = e.sequence;
                    i.fetchVAST(e.nextWrapperURL, t, r, e)
                      .then(function(s) {
                        return i
                          .parse(s, {
                            url: e.nextWrapperURL,
                            previousUrl: r,
                            wrapperSequence: o,
                            wrapperDepth: t,
                            followAdditionalWrappers: e.followAdditionalWrappers,
                            allowMultipleAds: a
                          })
                          .then(function(t) {
                            if ((delete e.nextWrapperURL, 0 === t.length)) return (e.creatives = []), n(e);
                            t.forEach(function(t) {
                              t && L.mergeWrapperAdData(t, e);
                            }),
                              n(t);
                          });
                      })
                      .catch(function(t) {
                        (e.errorCode = 301), (e.errorMessage = t.message), n(e);
                      });
                  });
                }
              },
              {
                key: "completeWrapperResolving",
                value: function(e) {
                  if (0 === e.ads.length) this.trackVastError(e.errorURLTemplates, { ERRORCODE: 303 });
                  else
                    for (var t = e.ads.length - 1; t >= 0; t--) {
                      var r = e.ads[t];
                      (r.errorCode || 0 === r.creatives.length) &&
                        (this.trackVastError(
                          r.errorURLTemplates.concat(e.errorURLTemplates),
                          { ERRORCODE: r.errorCode || 303 },
                          { ERRORMESSAGE: r.errorMessage || "" },
                          { extensions: r.extensions },
                          { system: r.system }
                        ),
                        e.ads.splice(t, 1));
                    }
                }
              }
            ]),
            r
          );
        })(Q),
        le = null,
        ue = {
          data: {},
          length: 0,
          getItem: function(e) {
            return this.data[e];
          },
          setItem: function(e, t) {
            (this.data[e] = t), (this.length = Object.keys(this.data).length);
          },
          removeItem: function(e) {
            delete this.data[e], (this.length = Object.keys(this.data).length);
          },
          clear: function() {
            (this.data = {}), (this.length = 0);
          }
        },
        de = (function() {
          function e() {
            n(this, e), (this.storage = this.initStorage());
          }
          return (
            a(e, [
              {
                key: "initStorage",
                value: function() {
                  if (le) return le;
                  try {
                    le =
                      "undefined" != typeof window && null !== window
                        ? window.localStorage || window.sessionStorage
                        : null;
                  } catch (e) {
                    le = null;
                  }
                  return (le && !this.isStorageDisabled(le)) || (le = ue).clear(), le;
                }
              },
              {
                key: "isStorageDisabled",
                value: function(e) {
                  var t = "__VASTStorage__";
                  try {
                    if ((e.setItem(t, t), e.getItem(t) !== t)) return e.removeItem(t), !0;
                  } catch (e) {
                    return !0;
                  }
                  return e.removeItem(t), !1;
                }
              },
              {
                key: "getItem",
                value: function(e) {
                  return this.storage.getItem(e);
                }
              },
              {
                key: "setItem",
                value: function(e, t) {
                  return this.storage.setItem(e, t);
                }
              },
              {
                key: "removeItem",
                value: function(e) {
                  return this.storage.removeItem(e);
                }
              },
              {
                key: "clear",
                value: function() {
                  return this.storage.clear();
                }
              }
            ]),
            e
          );
        })(),
        ce = (function() {
          function e(t, r, i) {
            n(this, e),
              (this.cappingFreeLunch = t || 0),
              (this.cappingMinimumTimeInterval = r || 0),
              (this.defaultOptions = { withCredentials: !1, timeout: 0 }),
              (this.vastParser = new oe()),
              (this.storage = i || new de()),
              void 0 === this.lastSuccessfulAd && (this.lastSuccessfulAd = 0),
              void 0 === this.totalCalls && (this.totalCalls = 0),
              void 0 === this.totalCallsTimeout && (this.totalCallsTimeout = 0);
          }
          return (
            a(e, [
              {
                key: "getParser",
                value: function() {
                  return this.vastParser;
                }
              },
              {
                key: "lastSuccessfulAd",
                get: function() {
                  return this.storage.getItem("vast-client-last-successful-ad");
                },
                set: function(e) {
                  this.storage.setItem("vast-client-last-successful-ad", e);
                }
              },
              {
                key: "totalCalls",
                get: function() {
                  return this.storage.getItem("vast-client-total-calls");
                },
                set: function(e) {
                  this.storage.setItem("vast-client-total-calls", e);
                }
              },
              {
                key: "totalCallsTimeout",
                get: function() {
                  return this.storage.getItem("vast-client-total-calls-timeout");
                },
                set: function(e) {
                  this.storage.setItem("vast-client-total-calls-timeout", e);
                }
              },
              {
                key: "hasRemainingAds",
                value: function() {
                  return this.vastParser.remainingAds.length > 0;
                }
              },
              {
                key: "getNextAds",
                value: function(e) {
                  return this.vastParser.getRemainingAds(e);
                }
              },
              {
                key: "get",
                value: function(e) {
                  var t = this,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    i = Date.now();
                  return (
                    (r = Object.assign({}, this.defaultOptions, r)).hasOwnProperty("resolveAll") || (r.resolveAll = !1),
                    this.totalCallsTimeout < i
                      ? ((this.totalCalls = 1), (this.totalCallsTimeout = i + 36e5))
                      : this.totalCalls++,
                    new Promise(function(n, s) {
                      if (t.cappingFreeLunch >= t.totalCalls)
                        return s(
                          new Error(
                            "VAST call canceled – FreeLunch capping not reached yet "
                              .concat(t.totalCalls, "/")
                              .concat(t.cappingFreeLunch)
                          )
                        );
                      var a = i - t.lastSuccessfulAd;
                      if (a < 0) t.lastSuccessfulAd = 0;
                      else if (a < t.cappingMinimumTimeInterval)
                        return s(
                          new Error(
                            "VAST call canceled – (".concat(
                              t.cappingMinimumTimeInterval,
                              ")ms minimum interval reached"
                            )
                          )
                        );
                      t.vastParser
                        .getAndParseVAST(e, r)
                        .then(function(e) {
                          return n(e);
                        })
                        .catch(function(e) {
                          return s(e);
                        });
                    })
                  );
                }
              }
            ]),
            e
          );
        })(),
        he = (function(e) {
          l(i, e);
          var t = h(i);
          function i(e, r, s) {
            var a,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            for (var l in (n(this, i),
            ((a = t.call(this)).ad = r),
            (a.creative = s),
            (a.variation = o),
            (a.muted = !1),
            (a.impressed = !1),
            (a.skippable = !1),
            (a.trackingEvents = {}),
            (a.lastPercentage = 0),
            (a._alreadyTriggeredQuartiles = {}),
            (a.emitAlwaysEvents = [
              "creativeView",
              "start",
              "firstQuartile",
              "midpoint",
              "thirdQuartile",
              "complete",
              "resume",
              "pause",
              "rewind",
              "skip",
              "closeLinear",
              "close"
            ]),
            a.creative.trackingEvents)) {
              var u = a.creative.trackingEvents[l];
              a.trackingEvents[l] = u.slice(0);
            }
            return (
              _(a.creative) ? a._initLinearTracking() : a._initVariationTracking(),
              e &&
                a.on("start", function() {
                  e.lastSuccessfulAd = Date.now();
                }),
              a
            );
          }
          return (
            a(i, [
              {
                key: "_initLinearTracking",
                value: function() {
                  (this.linear = !0),
                    (this.skipDelay = this.creative.skipDelay),
                    this.setDuration(this.creative.duration),
                    (this.clickThroughURLTemplate = this.creative.videoClickThroughURLTemplate),
                    (this.clickTrackingURLTemplates = this.creative.videoClickTrackingURLTemplates);
                }
              },
              {
                key: "_initVariationTracking",
                value: function() {
                  if (((this.linear = !1), (this.skipDelay = -1), this.variation)) {
                    for (var e in this.variation.trackingEvents) {
                      var t = this.variation.trackingEvents[e];
                      this.trackingEvents[e]
                        ? (this.trackingEvents[e] = this.trackingEvents[e].concat(t.slice(0)))
                        : (this.trackingEvents[e] = t.slice(0));
                    }
                    "nonLinearAd" === this.variation.adType
                      ? ((this.clickThroughURLTemplate = this.variation.nonlinearClickThroughURLTemplate),
                        (this.clickTrackingURLTemplates = this.variation.nonlinearClickTrackingURLTemplates),
                        this.setDuration(this.variation.minSuggestedDuration))
                      : (function(e) {
                          return "companionAd" === e.adType;
                        })(this.variation) &&
                        ((this.clickThroughURLTemplate = this.variation.companionClickThroughURLTemplate),
                        (this.clickTrackingURLTemplates = this.variation.companionClickTrackingURLTemplates));
                  }
                }
              },
              {
                key: "setDuration",
                value: function(e) {
                  (this.assetDuration = e),
                    (this.quartiles = {
                      firstQuartile: Math.round(25 * this.assetDuration) / 100,
                      midpoint: Math.round(50 * this.assetDuration) / 100,
                      thirdQuartile: Math.round(75 * this.assetDuration) / 100
                    });
                }
              },
              {
                key: "setProgress",
                value: function(e) {
                  var t = this,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    i = this.skipDelay || -1;
                  if (
                    (-1 === i ||
                      this.skippable ||
                      (i > e
                        ? this.emit("skip-countdown", i - e)
                        : ((this.skippable = !0), this.emit("skip-countdown", 0))),
                    this.assetDuration > 0)
                  ) {
                    var n = Math.round((e / this.assetDuration) * 100),
                      s = [];
                    if (e > 0) {
                      s.push("start");
                      for (var a = this.lastPercentage; a < n; a++) s.push("progress-".concat(a + 1, "%"));
                      for (var o in (s.push("progress-".concat(Math.round(e))), this.quartiles))
                        this.isQuartileReached(o, this.quartiles[o], e) &&
                          (s.push(o), (this._alreadyTriggeredQuartiles[o] = !0));
                      this.lastPercentage = n;
                    }
                    s.forEach(function(e) {
                      t.track(e, { macros: r, once: !0 });
                    }),
                      e < this.progress && this.track("rewind", { macros: r });
                  }
                  this.progress = e;
                }
              },
              {
                key: "isQuartileReached",
                value: function(e, t, r) {
                  var i = !1;
                  return t <= r && !this._alreadyTriggeredQuartiles[e] && (i = !0), i;
                }
              },
              {
                key: "setMuted",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  this.muted !== e && this.track(e ? "mute" : "unmute", { macros: t }), (this.muted = e);
                }
              },
              {
                key: "setPaused",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  this.paused !== e && this.track(e ? "pause" : "resume", { macros: t }), (this.paused = e);
                }
              },
              {
                key: "setFullscreen",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  this.fullscreen !== e && this.track(e ? "fullscreen" : "exitFullscreen", { macros: t }),
                    (this.fullscreen = e);
                }
              },
              {
                key: "setExpand",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  this.expanded !== e &&
                    (this.track(e ? "expand" : "collapse", { macros: t }),
                    this.track(e ? "playerExpand" : "playerCollapse", { macros: t })),
                    (this.expanded = e);
                }
              },
              {
                key: "setSkipDelay",
                value: function(e) {
                  "number" == typeof e && (this.skipDelay = e);
                }
              },
              {
                key: "trackImpression",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.impressed ||
                    ((this.impressed = !0),
                    this.trackURLs(this.ad.impressionURLTemplates, e),
                    this.track("creativeView", { macros: e }));
                }
              },
              {
                key: "error",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                  this.trackURLs(this.ad.errorURLTemplates, e, { isCustomCode: t });
                }
              },
              {
                key: "errorWithCode",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                  this.error({ ERRORCODE: e }, t),
                    console.log("The method errorWithCode is deprecated, please use vast tracker error method instead");
                }
              },
              {
                key: "complete",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("complete", { macros: e });
                }
              },
              {
                key: "notUsed",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("notUsed", { macros: e }), (this.trackingEvents = []);
                }
              },
              {
                key: "otherAdInteraction",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("otherAdInteraction", { macros: e });
                }
              },
              {
                key: "acceptInvitation",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("acceptInvitation", { macros: e });
                }
              },
              {
                key: "adExpand",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("adExpand", { macros: e });
                }
              },
              {
                key: "adCollapse",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("adCollapse", { macros: e });
                }
              },
              {
                key: "minimize",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("minimize", { macros: e });
                }
              },
              {
                key: "verificationNotExecuted",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  if (!this.ad || !this.ad.adVerifications || !this.ad.adVerifications.length)
                    throw new Error("No adVerifications provided");
                  if (!e) throw new Error("No vendor provided, unable to find associated verificationNotExecuted");
                  var r = this.ad.adVerifications.find(function(t) {
                    return t.vendor === e;
                  });
                  if (!r) throw new Error("No associated verification element found for vendor: ".concat(e));
                  var i = r.trackingEvents;
                  if (i && i.verificationNotExecuted) {
                    var n = i.verificationNotExecuted;
                    this.trackURLs(n, t), this.emit("verificationNotExecuted", { trackingURLTemplates: n });
                  }
                }
              },
              {
                key: "overlayViewDuration",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  (t.ADPLAYHEAD = e), this.track("overlayViewDuration", { macros: t });
                }
              },
              {
                key: "close",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track(this.linear ? "closeLinear" : "close", { macros: e });
                }
              },
              {
                key: "skip",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("skip", { macros: e });
                }
              },
              {
                key: "load",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  this.track("loaded", { macros: e });
                }
              },
              {
                key: "click",
                value: function() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  this.clickTrackingURLTemplates &&
                    this.clickTrackingURLTemplates.length &&
                    this.trackURLs(this.clickTrackingURLTemplates, t);
                  var i = this.clickThroughURLTemplate || e,
                    n = r({}, t);
                  if (i) {
                    this.progress && (n.ADPLAYHEAD = this.progressFormatted());
                    var s = R.resolveURLTemplates([i], n)[0];
                    this.emit("clickthrough", s);
                  }
                }
              },
              {
                key: "track",
                value: function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.macros,
                    i = void 0 === r ? {} : r,
                    n = t.once,
                    s = void 0 !== n && n;
                  "closeLinear" === e && !this.trackingEvents[e] && this.trackingEvents.close && (e = "close");
                  var a = this.trackingEvents[e],
                    o = this.emitAlwaysEvents.indexOf(e) > -1;
                  a ? (this.emit(e, { trackingURLTemplates: a }), this.trackURLs(a, i)) : o && this.emit(e, null),
                    s &&
                      (delete this.trackingEvents[e],
                      o && this.emitAlwaysEvents.splice(this.emitAlwaysEvents.indexOf(e), 1));
                }
              },
              {
                key: "trackURLs",
                value: function(e) {
                  var t,
                    i,
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    s = r({}, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                  this.linear &&
                    (this.creative &&
                      this.creative.mediaFiles &&
                      this.creative.mediaFiles[0] &&
                      this.creative.mediaFiles[0].fileURL &&
                      (s.ASSETURI = this.creative.mediaFiles[0].fileURL),
                    this.progress && (s.ADPLAYHEAD = this.progressFormatted())),
                    null !== (t = this.creative) &&
                      void 0 !== t &&
                      null !== (i = t.universalAdIds) &&
                      void 0 !== i &&
                      i.length &&
                      (s.UNIVERSALADID = this.creative.universalAdIds
                        .map(function(e) {
                          return e.idRegistry.concat(" ", e.value);
                        })
                        .join(",")),
                    this.ad &&
                      (this.ad.sequence && (s.PODSEQUENCE = this.ad.sequence),
                      this.ad.adType && (s.ADTYPE = this.ad.adType),
                      this.ad.adServingId && (s.ADSERVINGID = this.ad.adServingId),
                      this.ad.categories &&
                        this.ad.categories.length &&
                        (s.ADCATEGORIES = this.ad.categories
                          .map(function(e) {
                            return e.value;
                          })
                          .join(",")),
                      this.ad.blockedAdCategories &&
                        this.ad.blockedAdCategories.length &&
                        (s.BLOCKEDADCATEGORIES = this.ad.blockedAdCategories)),
                    R.track(e, s, n);
                }
              },
              {
                key: "convertToTimecode",
                value: function(e) {
                  var t = 1e3 * e,
                    r = Math.floor(t / 36e5),
                    i = Math.floor((t / 6e4) % 60),
                    n = Math.floor((t / 1e3) % 60),
                    s = Math.floor(t % 1e3);
                  return ""
                    .concat(R.leftpad(r, 2), ":")
                    .concat(R.leftpad(i, 2), ":")
                    .concat(R.leftpad(n, 2), ".")
                    .concat(R.leftpad(s, 3));
                }
              },
              {
                key: "progressFormatted",
                value: function() {
                  return this.convertToTimecode(this.progress);
                }
              }
            ]),
            i
          );
        })(Q);
      (e.VASTClient = ce),
        (e.VASTParser = oe),
        (e.VASTTracker = he),
        Object.defineProperty(e, "__esModule", { value: !0 });
    })(t);
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Fullscreen Off" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 469.333 469.333" xml:space="preserve"><g><path d="M160,0h-21.333C132.771,0,128,4.771,128,10.667V128H10.667C4.771,128,0,132.771,0,138.667V160 c0,5.896,4.771,10.667,10.667,10.667H160c5.896,0,10.667-4.771,10.667-10.667V10.667C170.667,4.771,165.896,0,160,0z"></path><path d="M458.667,128H341.333V10.667C341.333,4.771,336.563,0,330.667,0h-21.333c-5.896,0-10.667,4.771-10.667,10.667V160 c0,5.896,4.771,10.667,10.667,10.667h149.333c5.896,0,10.667-4.771,10.667-10.667v-21.333 C469.333,132.771,464.563,128,458.667,128z"></path><path d="M458.667,298.667H309.333c-5.896,0-10.667,4.771-10.667,10.667v149.333c0,5.896,4.771,10.667,10.667,10.667h21.333 c5.896,0,10.667-4.771,10.667-10.667V341.333h117.333c5.896,0,10.667-4.771,10.667-10.667v-21.333 C469.333,303.437,464.563,298.667,458.667,298.667z"></path><path d="M160,298.667H10.667C4.771,298.667,0,303.437,0,309.333v21.333c0,5.896,4.771,10.667,10.667,10.667H128v117.333 c0,5.896,4.771,10.667,10.667,10.667H160c5.896,0,10.667-4.771,10.667-10.667V309.333 C170.667,303.437,165.896,298.667,160,298.667z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Fullscreen On" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 469.333 469.333" xml:space="preserve"><g><path d="M160,0H10.667C4.771,0,0,4.771,0,10.667V160c0,5.896,4.771,10.667,10.667,10.667H32c5.896,0,10.667-4.771,10.667-10.667 V42.667H160c5.896,0,10.667-4.771,10.667-10.667V10.667C170.667,4.771,165.896,0,160,0z"></path><path d="M458.667,0H309.333c-5.896,0-10.667,4.771-10.667,10.667V32c0,5.896,4.771,10.667,10.667,10.667h117.333V160 c0,5.896,4.771,10.667,10.667,10.667h21.333c5.896,0,10.667-4.771,10.667-10.667V10.667C469.333,4.771,464.563,0,458.667,0z"></path><path d="M458.667,298.667h-21.333c-5.896,0-10.667,4.771-10.667,10.667v117.333H309.333c-5.896,0-10.667,4.771-10.667,10.667 v21.333c0,5.896,4.771,10.667,10.667,10.667h149.333c5.896,0,10.667-4.771,10.667-10.667V309.333 C469.333,303.437,464.563,298.667,458.667,298.667z"></path><path d="M160,426.667H42.667V309.333c0-5.896-4.771-10.667-10.667-10.667H10.667C4.771,298.667,0,303.437,0,309.333v149.333 c0,5.896,4.771,10.667,10.667,10.667H160c5.896,0,10.667-4.771,10.667-10.667v-21.333 C170.667,431.438,165.896,426.667,160,426.667z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Sound On" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 508.514 508.514" xml:space="preserve"><g><path d="M271.483,0.109c-5.784-0.54-12.554,0.858-20.531,5.689c0,0-132.533,115.625-138.286,121.314 H39.725c-17.544,0.032-31.782,14.27-31.782,31.814v194.731c0,17.607,14.239,31.782,31.782,31.782h72.941 c5.753,5.753,138.286,117.277,138.286,117.277c7.977,4.799,14.747,6.229,20.531,5.689c11.76-1.112,20.023-10.965,22.534-21.358 c0.127-1.017,0.127-464.533-0.032-465.55C291.506,11.074,283.211,1.222,271.483,0.109z"></path><path d="M342.962,309.798c-7.85,3.973-10.997,13.508-7.087,21.358c2.829,5.53,8.422,8.74,14.207,8.74 c2.384,0,4.799-0.572,7.151-1.684c32.132-16.209,52.091-48.341,52.091-83.938s-19.959-67.728-52.091-83.938 c-7.85-3.973-17.385-0.795-21.358,7.056c-3.909,7.85-0.763,17.385,7.087,21.358c21.326,10.743,34.579,32.005,34.579,55.524 S364.288,299.055,342.962,309.798z"></path><path d="M339.72,59.32c-8.486-1.716-17.004,3.941-18.593,12.522c-1.716,8.645,3.909,17.004,12.522,18.688 c78.312,15.256,135.139,84.128,135.139,163.743S411.962,402.761,333.65,418.017c-8.613,1.684-14.239,10.011-12.554,18.656 c1.494,7.596,8.136,12.84,15.542,12.84l3.083-0.318c93.218-18.148,160.851-100.147,160.851-194.922S432.938,77.5,339.72,59.32z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Sound Off" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 508.528 508.528" xml:space="preserve"><g><path d="M263.54,0.116c-5.784-0.54-12.554,0.858-20.531,5.689c0,0-132.533,115.625-138.317,121.314H31.782 C14.239,127.15,0,141.389,0,158.933v194.731c0,17.607,14.239,31.782,31.782,31.782h72.941 c5.784,5.753,138.317,117.277,138.317,117.277c7.977,4.799,14.747,6.229,20.531,5.689c11.76-1.112,20.023-10.965,22.534-21.358 c0.095-1.017,0.095-464.533-0.064-465.55C283.563,11.081,275.268,1.228,263.54,0.116z"></path><path d="M447.974,254.28l54.857-54.857c7.596-7.564,7.596-19.864,0-27.428 c-7.564-7.564-19.864-7.564-27.428,0l-54.857,54.888l-54.888-54.888c-7.532-7.564-19.864-7.564-27.397,0 c-7.564,7.564-7.564,19.864,0,27.428l54.857,54.857l-54.857,54.888c-7.564,7.532-7.564,19.864,0,27.396 c7.532,7.564,19.864,7.564,27.396,0l54.888-54.857l54.857,54.857c7.564,7.564,19.864,7.564,27.428,0 c7.564-7.532,7.564-19.864,0-27.396L447.974,254.28z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Cogwheel" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 54 54" xml:space="preserve"><g><path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.475,0.475-0.997,0.574-1.352,0.574c-0.5,0-0.997-0.196-1.364-0.539C33.324,8.984,33,8.534,33,7.832V2.78 C33,1.247,31.753,0,30.22,0H23.78C22.247,0,21,1.247,21,2.78v5.052c0,1.218-0.997,1.945-1.961,1.945c-0.354,0-0.876-0.1-1.351-0.574 l-3.571-3.571c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966 l3.572,3.571c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.438C0,31.752,1.247,33,2.78,33 h5.052c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.571c0.475-0.475,0.997-0.574,1.352-0.574 c0.963,0,1.96,0.728,1.96,1.945v5.051C21,52.752,22.247,54,23.78,54h6.439c1.533,0,2.78-1.248,2.78-2.781v-5.051 c0-1.218,0.997-1.945,1.96-1.945c0.354,0,0.877,0.1,1.352,0.574l3.571,3.571c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.248,2.78-2.781V23.78C54,22.247,52.753,21,51.22,21z M34,27c0,3.859-3.141,7-7,7 s-7-3.141-7-7s3.141-7,7-7S34,23.141,34,27z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Pause Icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 535.578 535.578" xml:space="preserve" aria-labelledby="title"><title id="title">Pause Icon</title><g><path d="M231.6,516.278c0,10.658-8.641,19.3-19.3,19.3H106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3 c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z"></path><path d="M448.728,516.278c0,10.658-8.641,19.3-19.3,19.3h-106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3 c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Play Icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.307 443.306" style="enable-background:new 0 0 443.307 443.306;" xml:space="preserve" aria-labelledby="title"><title id="title">Play Icon</title><g><path d="M415.934,212.799L36.788,2.097C32.411-0.377,28.65-0.661,25.51,1.242c-3.14,1.902-4.708,5.328-4.708,10.276V431.78 c0,4.952,1.569,8.381,4.708,10.284c3.14,1.902,6.901,1.622,11.278-0.855l379.146-210.703c4.381-2.478,6.571-5.434,6.571-8.856 C422.505,218.224,420.314,215.274,415.934,212.799z"></path></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve"><path class="st0" d="M3,7.9v16.2h26V7.9H3z M26.6,21.7H5.4V10.3h21.1V21.7z"></path></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve"><path class="st0" d="M0,6v20h32V6H0z M29,23H3V9h26V23z"></path></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Replay" x="0px" y="0px" viewBox="0 0 74.999 74.999" xml:space="preserve"><g><path d="M33.511,71.013c15.487,0,28.551-10.563,32.375-24.859h9.113L61.055,22L47.111,46.151h8.006 c-3.44,8.563-11.826,14.628-21.605,14.628c-12.837,0-23.28-10.443-23.28-23.28c0-12.836,10.443-23.28,23.28-23.28 c6.604,0,12.566,2.768,16.809,7.196l5.258-9.108c-5.898-5.176-13.619-8.32-22.065-8.32C15.034,3.987,0,19.019,0,37.5 C-0.002,55.981,15.03,71.013,33.511,71.013z"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.9 21.9" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 21.9 21.9"><path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0 c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4 s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3 s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7 s-0.1-0.5-0.3-0.7L14.1,11.3z"></path></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve"><style type="text/css"> .st0{opacity:0.9;fill:#FFFFFF;enable-background:new ;} .st1{enable-background:new ;} .st2{fill:#FFFFFF;} </style><g><path class="st0" d="M267.8,12.8c-89.2,0-168.3,48.5-209.1,122.4L0,76.5v165.8h165.8l-71.4-71.4c33.2-63.8,96.9-107.1,173.4-107.1 C372.3,63.8,459,150.4,459,255s-86.7,191.2-191.2,191.2c-84.1,0-153-53.5-181.1-127.5H33.2c28,102,122.4,178.5,234.6,178.5 C402.9,497.2,510,387.6,510,255S400.4,12.8,267.8,12.8z"></path><g class="st1"><path class="st2" d="M219.1,290.6l30.2-3.1c0.9,6.8,3.4,12.2,7.6,16.2c4.2,4,9.1,6,14.6,6c6.3,0,11.7-2.6,16-7.7 c4.4-5.1,6.6-12.9,6.6-23.2c0-9.7-2.2-17-6.5-21.8c-4.3-4.8-10-7.3-17-7.3c-8.7,0-16.5,3.8-23.4,11.5l-24.6-3.6l15.5-82.2h80v28.3 h-57.1l-4.7,26.8c6.7-3.4,13.6-5.1,20.7-5.1c13.4,0,24.8,4.9,34.1,14.6c9.3,9.8,14,22.4,14,38c0,13-3.8,24.6-11.3,34.8 c-10.3,13.9-24.5,20.9-42.8,20.9c-14.6,0-26.5-3.9-35.6-11.7C226.4,314.3,220.9,303.8,219.1,290.6z"></path></g></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve"><style type="text/css"> .st0{opacity:0.9;fill:#FFFFFF;enable-background:new ;} .st1{enable-background:new ;} .st2{fill:#FFFFFF;} </style><g><path class="st0" d="M0,255c0,132.6,107.1,242.2,242.2,242.2c112.2,0,206.5-76.5,234.6-178.5h-53.6c-28,74-96.9,127.5-181,127.5 C137.7,446.2,51,359.5,51,255S137.7,63.8,242.2,63.8c76.5,0,140.2,43.3,173.4,107.1l-71.4,71.4H510V76.5l-58.6,58.6 C410.6,61.2,331.5,12.8,242.2,12.8C109.6,12.8,0,122.4,0,255z"></path><g class="st1"><path class="st2" d="M187.1,292.3l30.2-3.1c0.9,6.8,3.4,12.2,7.6,16.2c4.2,4,9.1,6,14.6,6c6.3,0,11.7-2.6,16-7.7 c4.4-5.1,6.6-12.9,6.6-23.2c0-9.7-2.2-17-6.5-21.8c-4.3-4.8-10-7.3-17-7.3c-8.7,0-16.5,3.8-23.4,11.5l-24.6-3.6l15.5-82.2h80v28.3 h-57.1l-4.7,26.8c6.7-3.4,13.6-5.1,20.7-5.1c13.4,0,24.8,4.9,34.1,14.6c9.3,9.8,14,22.4,14,38c0,13-3.8,24.6-11.3,34.8 c-10.3,13.9-24.5,20.9-42.8,20.9c-14.6,0-26.5-3.9-35.6-11.7C194.4,316,188.9,305.5,187.1,292.3z"></path></g></g></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 459 459" style="enable-background:new 0 0 459 459;" xml:space="preserve"><style type="text/css"> .st0{fill:#FFFFFF;} </style><polygon class="st0" points="59,153 59,306 161,306 288.5,433.5 288.5,25.5 161,153 "></polygon><path class="st0" d="M403.2,229.5c0-45.9-25.5-84.1-63.8-102v204C377.8,313.6,403.2,275.4,403.2,229.5z"></path></svg>';
  },
  function(e, t) {
    e.exports =
      '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 459 459" style="enable-background:new 0 0 459 459;" xml:space="preserve"><style type="text/css"> .st0{fill:#FFFFFF;} </style><g><g id="volume-up"><path class="st0" d="M0,153v153h102l127.5,127.5v-408L102,153H0z M344.2,229.5c0-45.9-25.5-84.1-63.8-102v204 C318.8,313.6,344.2,275.4,344.2,229.5z M280.5,5.1v53.5c74,23,127.5,89.2,127.5,170.9s-53.5,147.9-127.5,170.9v53.5 c102-23,178.5-114.8,178.5-224.4S382.5,28,280.5,5.1z"></path></g></g></svg>';
  },
  function(e) {
    e.exports = JSON.parse(
      '{"play":"Воспроизвести","pause":"Пауза","autoplay":"Автозапуск","imagePreview":"Предпросмотр","settings":"Настройки","quality":"Качество","speed":"Скорость","speedNormal":"Нормальная","close":"Закрыть","advertisement":"Реклама","stopCast":"Остановить кастинг","seconds":"секунды","mute":"Выключить звук","unmute":"Включить звук","fullScreen":"Полноэкранный режим","exitFullScreen":"Выйти из полноэкранного режима","widescreenOn":"Режим Кино","widescreenOff":"Обычный режим","copyLink":"Скопировать ссылку","copyLinkDone":"Скопировано","copyVideoUrl":"Скопировать ссылку","copyVideoUrlCurrentTime":"Скопировать ссылку на видео с текущего момента","copyEmbedCode":"Скопировать Embed код","keyboardHelp":"Помощь по работе с клавиатурой","playerVersion":"Версия плеера","keyHelpHeader":"Клавиатурные сокращения","keyHelpSpace":"Воспроизвести / пауза","keyHelpFKey":"Включить / выключить полноэкранный режим","keyHelpMKey":"Включить / выключить звук","keyHelpUpKey":"Сделать звук громче","keyHelpDownKey":"Сделать звук тише","keyHelpLeftKey":"Вернуться на 5 секунд назад","keyHelpRightKey":"Перемотать на 5 секунд вперед","keyHelpPUpKey":"Увелчить скорость видео","keyHelpPDownKey":"Уменьшит скорость видео","keyHelpWKey":"Включить / выключить режим кино","keyHelpCKey":"Включить / выключить предварительный просмотр","shareTabName":"Поделиться","shareTabText":"Поделиться с вашими друзьями","replayTabName":"Повторить видео","replayTabText":"Повторить видео с начала","casting":"Кастинг","skipVideoAd":"Пропустить","skipVideoAdAfter":"Пропустить через","Related Videos":"Рекомендуемое","Trending":"Популярное","fromCurrentTime":"с текущего момента","hide":"Скрыть","MEDIA_ERR_ABORTED":"Вы прервали воспроизведение видео.","MEDIA_ERR_NETWORK":"Сетевая ошибка вызвала проблему загрузки видео.","MEDIA_ERR_DECODE":"Воспроизведение видео было прервано из-за того, что видео было повреждено или из-за того, что видео не поддерживается вашим браузером.","MEDIA_ERR_SRC_NOT_SUPPORTED":"Невозможно загрузить видео, так как произошел сбой сервера или сети или формат видео не поддерживается.","MEDIA_ERR":"Произошла неизвестная ошибка."}'
    );
  },
  function(e) {
    e.exports = JSON.parse("{}");
  },
  function(e) {
    e.exports = JSON.parse(
      '{"play":"Abspielen","pause":"Pause","autoplay":"Automatisches Abspielen","imagePreview":"Bildvorschau","settings":"Einstellungen","quality":"Qualität","speed":"Geschwindigkeit","speedNormal":"Normal","close":"Schließen","advertisement":"Werbung","stopCast":"Hör auf zu gießen","seconds":"sekunden","mute":"Stumm","unmute":"Stummschaltung aufheben","fullScreen":"Vollbild","exitFullScreen":"Beenden Sie den Vollbildmodus","widescreenOn":"Kinomodus","widescreenOff":"Standardmodus","copyLink":"Link kopieren","copyLinkDone":"Kopiert","copyVideoUrl":"Kopiere die Video Adresse","copyVideoUrlCurrentTime":"Kopieren Sie die Video-URL aus der aktuellen Zeit","copyEmbedCode":"Kopiere Einbettungscode","keyboardHelp":"Tastaturhilfe","playerVersion":"Spielerversion","keyHelpHeader":"Player-Tastaturkürzel","keyHelpSpace":"Abspielen / Pause","keyHelpFKey":"Vollbild ein- / ausschalten","keyHelpMKey":"Stumm / Stummschaltung aufheben","keyHelpUpKey":"Lautstärke erhöhen","keyHelpDownKey":"Lautstärke verringern","keyHelpLeftKey":"Zeit für 5 Sekunden rückwärts überspringen","keyHelpRightKey":"Behandeln Sie die Sprungzeit 5 Sekunden vorwärts","keyHelpPUpKey":"Video beschleunigen","keyHelpPDownKey":"Video verlangsamen","keyHelpWKey":"Ein- / Ausschalten des Breitbildschirms","keyHelpCKey":"Ein- / Ausschalten von Video-Miniaturansichten","shareTabName":"Teilen","shareTabText":"Teile dieses Video mit deinen Freunden","replayTabName":"Video wiedergeben","replayTabText":"Wiederholen Sie dieses Video von Anfang an","casting":"Casting zu","skipVideoAd":"Überspringen","skipVideoAdAfter":"Anzeige überspringen","Related Videos":"Ähnliche Videos","Trending":"Trend","bestRecentTabName":"Beste Neueste","fromCurrentTime":"von der aktuellen Zeit","hide":"Ausblenden","MEDIA_ERR_ABORTED":"Sie haben die Videowiedergabe abgebrochen.","MEDIA_ERR_NETWORK":"Ein Netzwerkfehler führte dazu, dass der Video-Download teilweise fehlschlug.","MEDIA_ERR_DECODE":"Die Videowiedergabe wurde aufgrund eines Beschädigungsproblems oder aufgrund der von Ihrem Browser nicht unterstützten Funktionen des verwendeten Videos abgebrochen.","MEDIA_ERR_SRC_NOT_SUPPORTED":"Das Video konnte nicht geladen werden, entweder weil der Server oder das Netzwerk ausgefallen sind oder weil das Format nicht unterstützt wird.","MEDIA_ERR":"Ein unbekannter Fehler ist aufgetreten."}'
    );
  },
  function(e) {
    e.exports = JSON.parse(
      '{"name":"pelmet-player","description":"Video player for pelmet projects","license":"ISC","author":"","repository":{"type":"git","url":"git@git.xcroco.com:javascript/video-player.git"},"version":"1.5.33","main":"dist/bundle.js","scripts":{"build":"npm install && npm run fix-es6 && webpack --config webpack.config.js --mode=production","fix-es6":"./node_modules/.bin/babel node_modules/vast-client/ -d node_modules/vast-client/","reformat":"lint-staged","server":"http-server dist/","start":"npm install && npm run fix-es6 && webpack --config webpack.config.js --watch","test":"karma start karma.conf.js","version":"npm run build && git add dist/"},"dependencies":{"@dailymotion/vast-client":"^4.0.0","hls.js":"^1.0.7","html-webpack-plugin":"^3.2.0","karma":"^6.3.4","sass":"^1.46.0"},"devDependencies":{"@babel/core":"^7.14.6","@babel/preset-env":"^7.14.7","@types/chai":"^4.2.21","@types/hls.js":"^0.12.6","@types/mocha":"^5.2.7","@types/node":"^10.17.60","awesome-typescript-loader":"^5.2.1","babel-cli":"^6.26.0","babel-core":"^6.26.3","babel-loader":"^7.1.5","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-preset-env":"^1.7.0","babel-preset-es2015":"^6.24.1","chai":"^4.3.4","classnames":"^2.3.1","compression-webpack-plugin":"^6.1.1","copy-webpack-plugin":"^5.0.5","css-loader":"^1.0.1","http-server":"^0.12.3","husky":"^1.3.1","jasmine-core":"^3.8.0","karma-chai":"^0.1.0","karma-chrome-launcher":"^2.2.0","karma-jasmine":"^1.1.2","karma-mocha":"^2.0.1","karma-typescript":"^5.5.1","keycode-js":"^1.0.4","lint-staged":"^7.3.0","mocha":"^8.4.0","prettier":"1.13.7","prettier-package-json":"^1.6.0","rxjs":"^6.6.7","sass-loader":"^7.3.1","source-map-loader":"^0.2.4","style-loader":"^0.22.1","svg-inline-loader":"^0.8.2","terser-webpack-plugin":"^4.2.3","ts-node":"^7.0.1","typescript":"^2.9.2","vast-client":"^2.5.1","webpack":"^4.46.0","webpack-cli":"^3.3.12"},"husky":{"hooks":{"pre-commit":"lint-staged"}},"lint-staged":{"linters":{"*.{js,json,md,scss,ts}":["prettier --write --print-width 120","git add"],"*package.json":["prettier-package-json --write --print-width 120","git add"]}}}'
    );
  },
  ,
  function(e, t) {
    (t.KEY_CANCEL = 3),
      (t.KEY_HELP = 6),
      (t.KEY_BACK_SPACE = 8),
      (t.KEY_TAB = 9),
      (t.KEY_CLEAR = 12),
      (t.KEY_RETURN = 13),
      (t.KEY_ENTER = 14),
      (t.KEY_SHIFT = 16),
      (t.KEY_CONTROL = 17),
      (t.KEY_ALT = 18),
      (t.KEY_PAUSE = 19),
      (t.KEY_CAPS_LOCK = 20),
      (t.KEY_ESCAPE = 27),
      (t.KEY_SPACE = 32),
      (t.KEY_PAGE_UP = 33),
      (t.KEY_PAGE_DOWN = 34),
      (t.KEY_END = 35),
      (t.KEY_HOME = 36),
      (t.KEY_LEFT = 37),
      (t.KEY_UP = 38),
      (t.KEY_RIGHT = 39),
      (t.KEY_DOWN = 40),
      (t.KEY_PRINTSCREEN = 44),
      (t.KEY_INSERT = 45),
      (t.KEY_DELETE = 46),
      (t.KEY_0 = 48),
      (t.KEY_1 = 49),
      (t.KEY_2 = 50),
      (t.KEY_3 = 51),
      (t.KEY_4 = 52),
      (t.KEY_5 = 53),
      (t.KEY_6 = 54),
      (t.KEY_7 = 55),
      (t.KEY_8 = 56),
      (t.KEY_9 = 57),
      (t.KEY_SEMICOLON = 59),
      (t.KEY_EQUALS = 61),
      (t.KEY_A = 65),
      (t.KEY_B = 66),
      (t.KEY_C = 67),
      (t.KEY_D = 68),
      (t.KEY_E = 69),
      (t.KEY_F = 70),
      (t.KEY_G = 71),
      (t.KEY_H = 72),
      (t.KEY_I = 73),
      (t.KEY_J = 74),
      (t.KEY_K = 75),
      (t.KEY_L = 76),
      (t.KEY_M = 77),
      (t.KEY_N = 78),
      (t.KEY_O = 79),
      (t.KEY_P = 80),
      (t.KEY_Q = 81),
      (t.KEY_R = 82),
      (t.KEY_S = 83),
      (t.KEY_T = 84),
      (t.KEY_U = 85),
      (t.KEY_V = 86),
      (t.KEY_W = 87),
      (t.KEY_X = 88),
      (t.KEY_Y = 89),
      (t.KEY_Z = 90),
      (t.KEY_LEFT_CMD = 91),
      (t.KEY_RIGHT_CMD = 93),
      (t.KEY_CONTEXT_MENU = 93),
      (t.KEY_NUMPAD0 = 96),
      (t.KEY_NUMPAD1 = 97),
      (t.KEY_NUMPAD2 = 98),
      (t.KEY_NUMPAD3 = 99),
      (t.KEY_NUMPAD4 = 100),
      (t.KEY_NUMPAD5 = 101),
      (t.KEY_NUMPAD6 = 102),
      (t.KEY_NUMPAD7 = 103),
      (t.KEY_NUMPAD8 = 104),
      (t.KEY_NUMPAD9 = 105),
      (t.KEY_MULTIPLY = 106),
      (t.KEY_ADD = 107),
      (t.KEY_SEPARATOR = 108),
      (t.KEY_SUBTRACT = 109),
      (t.KEY_DECIMAL = 110),
      (t.KEY_DIVIDE = 111),
      (t.KEY_F1 = 112),
      (t.KEY_F2 = 113),
      (t.KEY_F3 = 114),
      (t.KEY_F4 = 115),
      (t.KEY_F5 = 116),
      (t.KEY_F6 = 117),
      (t.KEY_F7 = 118),
      (t.KEY_F8 = 119),
      (t.KEY_F9 = 120),
      (t.KEY_F10 = 121),
      (t.KEY_F11 = 122),
      (t.KEY_F12 = 123),
      (t.KEY_F13 = 124),
      (t.KEY_F14 = 125),
      (t.KEY_F15 = 126),
      (t.KEY_F16 = 127),
      (t.KEY_F17 = 128),
      (t.KEY_F18 = 129),
      (t.KEY_F19 = 130),
      (t.KEY_F20 = 131),
      (t.KEY_F21 = 132),
      (t.KEY_F22 = 133),
      (t.KEY_F23 = 134),
      (t.KEY_F24 = 135),
      (t.KEY_NUM_LOCK = 144),
      (t.KEY_SCROLL_LOCK = 145),
      (t.KEY_COMMA = 188),
      (t.KEY_PERIOD = 190),
      (t.KEY_SLASH = 191),
      (t.KEY_BACK_QUOTE = 192),
      (t.KEY_OPEN_BRACKET = 219),
      (t.KEY_BACK_SLASH = 220),
      (t.KEY_CLOSE_BRACKET = 221),
      (t.KEY_QUOTE = 222),
      (t.KEY_META = 224);
  },
  ,
  ,
  ,
  ,
  ,
  function(e, t, r) {
    "use strict";
    r.r(t);
    var i = (function() {
        function e(e) {
          void 0 === e && (e = null),
            (this.element = null),
            "string" == typeof e ? this.create(e) : (this.element = e || null);
        }
        return (
          (e.prototype.create = function(e) {
            return void 0 === e && (e = "div"), (this.element = document.createElement(e)), this;
          }),
          (e.prototype.addClass = function(e) {
            return e && this.element.classList.add(e), this;
          }),
          (e.prototype.removeClass = function(e) {
            return this.element.classList.remove(e), this;
          }),
          (e.prototype.hasClass = function(e) {
            return void 0 === e && (e = ""), this.element.classList.contains(e);
          }),
          (e.prototype.attr = function(e, t) {
            return void 0 === t && (t = ""), this.element.setAttribute(e, t), this;
          }),
          (e.prototype.style = function(e, t) {
            return void 0 === t && (t = ""), (this.element.style[e] = t), this;
          }),
          (e.prototype.text = function(e) {
            return void 0 === e && (e = ""), (this.element.innerText = e), this;
          }),
          (e.prototype.html = function(e) {
            return (this.element.innerHTML = e), this;
          }),
          (e.prototype.on = function(e, t, r) {
            return void 0 === r && (r = !1), this.element.addEventListener(e, t, r), this;
          }),
          (e.prototype.hide = function() {
            return this.style("display", "none"), this;
          }),
          (e.prototype.show = function() {
            return this.style("display", "block"), this;
          }),
          (e.prototype.isVisible = function() {
            return !(0 === this.element.offsetWidth && 0 === this.element.offsetHeight);
          }),
          (e.prototype.remove = function() {
            try {
              return this.element.parentNode.removeChild(this.element), !0;
            } catch (e) {
              return !1;
            }
          }),
          (e.prototype.add = function(e) {
            return null === e || (e.get ? this.element.appendChild(e.get()) : this.addArray(e)), this;
          }),
          (e.prototype.addNative = function(e) {
            return this.element.appendChild(e), this;
          }),
          (e.prototype.addList = function(t, r) {
            var i = t.map(function(t) {
              return t ? new e("li").add(t) : null;
            });
            return this.add(new e("ul").addArray(i).addClass(r)), this;
          }),
          (e.prototype.addArray = function(e) {
            var t = this;
            return (
              e.map(function(e) {
                e && t.add(e);
              }),
              this
            );
          }),
          (e.prototype.clearChilds = function() {
            for (; this.element.firstChild; ) this.element.removeChild(this.element.firstChild);
            return this;
          }),
          (e.prototype.getHtml = function() {
            return this.element.innerHTML;
          }),
          (e.prototype.get = function() {
            return this.element;
          }),
          e
        );
      })(),
      n = function() {
        !(function() {
          if ("function" == typeof window.CustomEvent) return !1;
          function e(e, t) {
            t = t || { bubbles: !1, cancelable: !1, detail: void 0 };
            var r = document.createEvent("CustomEvent");
            return r.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), r;
          }
          (e.prototype = window.Event.prototype),
            (window.CustomEvent = e),
            Object.assign ||
              Object.defineProperty(Object, "assign", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(e) {
                  if (null == e) throw new TypeError("Cannot convert first argument to object");
                  for (var t = Object(e), r = 1; r < arguments.length; r++) {
                    var i = arguments[r];
                    if (null != i) {
                      i = Object(i);
                      for (var n = Object.keys(Object(i)), s = 0, a = n.length; s < a; s++) {
                        var o = n[s],
                          l = Object.getOwnPropertyDescriptor(i, o);
                        void 0 !== l && l.enumerable && (t[o] = i[o]);
                      }
                    }
                  }
                  return t;
                }
              });
        })();
      },
      s = "IDLE",
      a = "LOADING",
      o = "LOADED",
      l = "PLAYING",
      u = "PAUSED",
      d = "ENDED",
      c = "ERROR",
      h = (function() {
        function e(e) {
          this.playerState = e;
        }
        return (
          (e.prototype.play = function() {}),
          (e.prototype.pause = function() {}),
          (e.prototype.load = function() {}),
          (e.prototype.stop = function() {}),
          (e.prototype.getCurrentMediaTime = function() {
            return 0;
          }),
          (e.prototype.getMediaDuration = function() {
            return 100;
          }),
          (e.prototype.setTarget = function() {}),
          (e.prototype.updateDisplayMessage = function() {}),
          (e.prototype.mute = function() {}),
          (e.prototype.unMute = function() {}),
          (e.prototype.setVolume = function(e) {}),
          (e.prototype.getError = function() {
            return null;
          }),
          (e.prototype.getErrorObject = function() {
            return null;
          }),
          (e.prototype.isMuted = function() {
            return !1;
          }),
          (e.prototype.seekTo = function(e) {}),
          (e.prototype.handlePlayPause = function() {
            this.playerState.state.getValue() !== l ? this.play() : this.pause();
          }),
          (e.prototype.loaded = function() {
            var e = this.playerState.state.getValue();
            e === l || e === u || e === o || this.load();
          }),
          (e.prototype.setNewVideo = function(e, t) {
            void 0 === t && (t = 0);
          }),
          e
        );
      })(),
      f = (function() {
        var e =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function(e, t) {
              e.__proto__ = t;
            }) ||
          function(e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          };
        return function(t, r) {
          function i() {
            this.constructor = t;
          }
          e(t, r), (t.prototype = null === r ? Object.create(r) : ((i.prototype = r.prototype), new i()));
        };
      })(),
      p = (function(e) {
        function t(t, r, i) {
          var n = e.call(this, r) || this;
          return (
            (n.video = t),
            (n.playerState = r),
            (n.player = i),
            n.video.addEventListener("timeupdate", function() {
              return n.timeUpdate();
            }),
            n.video.addEventListener("loadedmetadata", function() {
              (n.player.isReduced =
                n.player.options.reduceVideo.enabled &&
                (n.player.qualitySelector.activeSource.src === n.video.src ||
                  (n.player.options.hls &&
                    n.player.isBrandPrerollShown &&
                    n.video.src !== n.player.options.brandPreroll.url))),
                n.player.isReduced &&
                  (n.video.duration <= n.player.options.reduceVideo.duration
                    ? ((n.player.reducedVideoDuration = n.video.duration), (n.player.reducedVideoStartTime = 0))
                    : ((n.player.reducedVideoDuration = n.player.options.reduceVideo.duration),
                      n.player.options.reduceVideo.startTime + n.player.options.reduceVideo.duration > n.video.duration
                        ? (n.player.reducedVideoStartTime = n.video.duration - n.player.options.reduceVideo.duration)
                        : (n.player.reducedVideoStartTime = n.player.options.reduceVideo.startTime))),
                n.timeUpdate(),
                n.playerState.state.next(o);
            }),
            n.video.addEventListener("ended", function() {
              return n.playerState.state.next(d);
            }),
            n.video.addEventListener("pause", function() {
              return n.playerState.state.getValue() !== c && n.playerState.state.next(u);
            }),
            n.video.addEventListener("playing", function() {
              n.playerState.state.next(l), n.player.playButtonOverlay && n.player.playButtonOverlay.hide();
            }),
            n.video.addEventListener("waiting", function() {
              return n.playerState.state.next(a);
            }),
            n.video.addEventListener("error", function() {
              return n.playerState.state.next(c);
            }),
            n
          );
        }
        return (
          f(t, e),
          (t.prototype.play = function() {
            var e = this;
            if (
              (this.player.isReduced &&
                this.player.reducedVideoStartTime + this.player.reducedVideoDuration <= this.player.video.currentTime &&
                (this.player.video.currentTime = this.player.reducedVideoStartTime),
              !this.player.clickContextMenu.isActive)
            ) {
              var t = this.video.play();
              return (
                this.player.options.videoEndOverlay.enabled && (this.player.videoEndedOverlay.isRendered = !1),
                void 0 !== t &&
                  t
                    .then(function() {
                      e.playerState.state.next(l),
                        e.player.playButtonOverlay && e.player.playButtonOverlay.hide(),
                        e.player.videoEndOverlay &&
                          e.player.videoEndedOverlay.enabled &&
                          e.player.videoEndedOverlay.hide();
                    })
                    .catch(function(e) {}),
                t
              );
            }
            this.player.clickContextMenu.isActive = !1;
          }),
          (t.prototype.pause = function() {
            this.player.options.videoEndOverlay.enabled ||
              this.player.ads.enabled ||
              this.player.vastHandler.renderPlayButtonOverlay(),
              this.player.clickContextMenu.isActive
                ? (this.player.clickContextMenu.isActive = !1)
                : this.playerState.state.getValue() === l &&
                  (this.seeking || (this.video.pause(), this.playerState.state.next(u)));
          }),
          (t.prototype.stop = function() {
            this.video.pause();
          }),
          (t.prototype.load = function() {
            this.playerState.state.next(a), this.video.load();
          }),
          (t.prototype.seekTo = function(e) {
            e >= 0 && (this.video.currentTime = e);
          }),
          (t.prototype.mute = function() {
            this.video.muted = !0;
          }),
          (t.prototype.unMute = function() {
            this.video.muted = !1;
          }),
          (t.prototype.setVolume = function(e) {
            if (this.video && e)
              try {
                this.video.volume = e;
              } catch (e) {
                this.player.log(e);
              }
          }),
          (t.prototype.changeQuality = function(e) {
            var t = this.video.currentTime;
            (this.video.src = e), (this.video.currentTime = t);
          }),
          (t.prototype.setNewVideo = function(e, t) {
            void 0 === t && (t = 0), (this.video.src = e), (this.video.currentTime = t);
          }),
          (t.prototype.getError = function() {
            if (!this.video.error || 1 === this.video.error.code) return this.player.lang.get("MEDIA_ERR");
            switch (this.video.error.code) {
              case this.video.error.MEDIA_ERR_ABORTED:
                return this.player.lang.get("MEDIA_ERR_ABORTED");
              case this.video.error.MEDIA_ERR_NETWORK:
                return this.player.lang.get("MEDIA_ERR_NETWORK");
              case this.video.error.MEDIA_ERR_DECODE:
                return this.player.lang.get("MEDIA_ERR_DECODE");
              case this.video.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                return this.player.lang.get("MEDIA_ERR_SRC_NOT_SUPPORTED");
              default:
                return this.player.lang.get("MEDIA_ERR");
            }
          }),
          (t.prototype.getErrorObject = function() {
            var e = this.player.qualitySelector.activeSource.src,
              t = this.getHostnameFromUrl(),
              r = this.player.qualitySelector.activeSource.desc;
            if (!this.player.vastHandler.isShown)
              return {
                errorCode: 2,
                errorMessage: this.player.lang.get("MEDIA_ERR"),
                videoId: this.player.vastHandler.vastFileURL,
                videoQuality: "",
                cdnNodeIp: ""
              };
            if (!this.video.error)
              return {
                errorCode: 0,
                errorMessage: this.player.lang.get("MEDIA_ERR"),
                videoId: e,
                videoQuality: r,
                cdnNodeIp: t
              };
            if (!this.video.error.code)
              return {
                errorCode: 0,
                errorMessage: this.player.lang.get("MEDIA_ERR"),
                videoId: e,
                videoQuality: r,
                cdnNodeIp: t
              };
            switch (this.video.error.code) {
              case this.video.error.MEDIA_ERR_ABORTED:
                return {
                  errorCode: this.video.error.code,
                  errorMessage: this.player.lang.get("MEDIA_ERR_ABORTED"),
                  videoId: e,
                  videoQuality: r,
                  cdnNodeIp: t
                };
              case this.video.error.MEDIA_ERR_NETWORK:
                return {
                  errorCode: this.video.error.code,
                  errorMessage: this.player.lang.get("MEDIA_ERR_NETWORK"),
                  videoId: e,
                  videoQuality: r,
                  cdnNodeIp: ""
                };
              case this.video.error.MEDIA_ERR_DECODE:
                return {
                  errorCode: this.video.error.code,
                  errorMessage: this.player.lang.get("MEDIA_ERR_DECODE"),
                  videoId: e,
                  videoQuality: r,
                  cdnNodeIp: t
                };
              case this.video.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                return {
                  errorCode: this.video.error.code,
                  errorMessage: this.player.lang.get("MEDIA_ERR_SRC_NOT_SUPPORTED"),
                  videoId: e,
                  videoQuality: r,
                  cdnNodeIp: t
                };
              default:
                return {
                  errorCode: this.video.error.code,
                  errorMessage: this.player.lang.get("MEDIA_ERR"),
                  videoId: e,
                  videoQuality: r,
                  cdnNodeIp: t
                };
            }
          }),
          (t.prototype.getHostnameFromUrl = function() {
            var e = document.createElement("a");
            return (e.href = this.player.qualitySelector.activeSource.src), e.hostname;
          }),
          (t.prototype.timeUpdate = function() {
            this.player.isReduced &&
              this.video.currentTime >= this.player.reducedVideoStartTime + this.player.reducedVideoDuration &&
              (this.player.pause(), this.player.playerState.state.next(d)),
              isNaN(this.video.duration) || this.playerState.currentTime.next(this.video.currentTime);
          }),
          t
        );
      })(h);
    function v(e) {
      return e && "object" == typeof e && !Array.isArray(e) && !0;
    }
    function g(e, t) {
      var r, i;
      if (v(e) && v(t))
        for (var n in t)
          v(t[n])
            ? (e[n] || Object.assign(e, (((r = {})[n] = {}), r)), g(e[n], t[n]))
            : Object.assign(e, (((i = {})[n] = t[n]), i));
      return e;
    }
    function m(e) {
      return JSON.parse(JSON.stringify(e));
    }
    var y = r(4),
      E = r.n(y),
      T = r(5),
      b = r.n(T),
      S = r(6),
      k = r.n(S),
      A = r(7),
      w = r.n(A),
      R = r(8),
      C = r.n(R),
      L = r(9),
      D = r.n(L),
      _ = r(10),
      I = r.n(_),
      x = r(11),
      O = r.n(x),
      P = r(12),
      M = r.n(P),
      F = r(13),
      N = r.n(F),
      B = r(14),
      U = r.n(B),
      H = r(15),
      V = r.n(H),
      K = r(16),
      W = r.n(K),
      G = r(17),
      j = r.n(G),
      Y = r(18),
      q = r.n(Y),
      z = function(e) {
        return new i().create("span").html(e);
      },
      X = z(E.a),
      Q = z(b.a),
      J = z(k.a),
      $ = z(w.a),
      Z = z(C.a),
      ee = z(D.a),
      te = z(I.a),
      re = z(N.a),
      ie = z(U.a),
      ne = z(O.a),
      se = z(M.a),
      ae = z(V.a),
      oe = z(W.a),
      le = z(j.a),
      ue = z(q.a),
      de = (function() {
        function e(e) {
          (this.player = e),
            (this.localStorageKey = ""),
            (this.active = !1),
            (this.player = e),
            (this.config = { enabled: !1, active: !1, handleSave: function(e) {} }),
            (this.button = null),
            (this.buttonWrapper = null);
        }
        return (
          (e.prototype.getToggleBtn = function(e) {
            var t = this,
              r = new i().create("button").addClass(e);
            return (
              r.on("click", function() {
                return t.handleToggle();
              }),
              r
            );
          }),
          (e.prototype.getLine = function(e, t, r) {
            return new i()
              .create("li")
              .add(
                new i()
                  .create("span")
                  .addClass(e)
                  .text(t)
              )
              .add(r);
          }),
          (e.prototype.handleToggle = function() {
            (this.active = !this.active),
              this.player.storage.save(this.localStorageKey, this.active, this.config.handleSave),
              this.setState();
          }),
          (e.prototype.setState = function() {
            this.active ? this.button.addClass("switch-btn-active") : this.button.removeClass("switch-btn-active");
          }),
          (e.prototype.getBtn = function() {
            return this.config.enabled ? this.buttonWrapper : null;
          }),
          (e.prototype.getDefaultState = function() {
            return this.player.storage.load(this.localStorageKey, this.config.active, this.config.handleSave);
          }),
          e
        );
      })(),
      ce = (function() {
        var e =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function(e, t) {
              e.__proto__ = t;
            }) ||
          function(e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          };
        return function(t, r) {
          function i() {
            this.constructor = t;
          }
          e(t, r), (t.prototype = null === r ? Object.create(r) : ((i.prototype = r.prototype), new i()));
        };
      })(),
      he = (function(e) {
        function t(t) {
          var r = e.call(this, t) || this;
          return (
            (r.player = t),
            (r.localStorageKey = "html5PlayerHideThumbs"),
            (r.config = r.player.options.imagePreview),
            r.config.enabled && r.player.options.thumbBase && ((r.active = r.getDefaultState()), r.render()),
            r
          );
        }
        return (
          ce(t, e),
          (t.prototype.render = function() {
            (this.button = this.getToggleBtn("hide-thumbs-btn")),
              (this.buttonWrapper = this.getLine(
                "label-hidethumbs",
                this.player.lang.get("imagePreview"),
                this.button
              )),
              this.setState();
          }),
          t
        );
      })(de),
      fe = (function() {
        var e =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function(e, t) {
              e.__proto__ = t;
            }) ||
          function(e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          };
        return function(t, r) {
          function i() {
            this.constructor = t;
          }
          e(t, r), (t.prototype = null === r ? Object.create(r) : ((i.prototype = r.prototype), new i()));
        };
      })(),
      pe = (function(e) {
        function t(t) {
          var r = e.call(this, t) || this;
          return (
            (r.player = t),
            (r.localStorageKey = "html5PlayerAutoplay"),
            (r.config = r.player.options.autoplay),
            r.config.enabled && ((r.active = r.getDefaultState()), r.render()),
            r
          );
        }
        return (
          fe(t, e),
          (t.prototype.render = function() {
            (this.button = this.getToggleBtn("autoplay-on-off")),
              (this.buttonWrapper = this.getLine("label-autoplay", this.player.lang.get("autoplay"), this.button)),
              this.setState();
          }),
          t
        );
      })(de),
      ve = (function() {
        function e(e) {
          (this.player = e), (this.cogEnabled = !1), this.render();
        }
        return (
          (e.prototype.render = function() {
            var e = this;
            (this.wrapper = new i().create("div").addClass("settings-wrapper")),
              this.wrapper.on("click", function(e) {
                return e.stopPropagation();
              }),
              (this.settingsBtnWrapper = new i()
                .create("div")
                .addClass("settings-button-wrapper")
                .addClass("tooltip-button")
                .attr("data-tooltip", this.player.lang.get("settings"))),
              (this.settingsBtn = new i().create("button").html(Z.getHtml())),
              (this.settingsHD = new i()
                .create("span")
                .addClass("settings-hd")
                .text("HD")
                .hide()),
              this.settingsBtnWrapper.add(this.settingsBtn).add(this.settingsHD),
              (this.settingsWrapper = new i()
                .create("div")
                .addClass("video-settings-wrapper")
                .hide()),
              this.renderMainSettings(),
              this.settingsBtnWrapper.on("click", function() {
                e.player.playerState.isAdvertise.getValue() ||
                  ((e.cogEnabled = !e.cogEnabled),
                  e.cogEnabled ? e.settingsBtn.addClass("cog-active") : e.settingsBtn.removeClass("cog-active"),
                  e.updateRateQualityButtons(),
                  e.toggleSettings());
              }),
              document.addEventListener("click", function() {
                e.settingsWrapper.hide();
              }),
              this.renderQualitySettings(),
              this.renderPlayrateSettings(),
              document.addEventListener("click", function() {
                e.settingsBtn.removeClass("cog-active"),
                  e.settingsWrapper.hide(),
                  e.settingsQualityWrapper.hide(),
                  e.settingsPlayRateWrapper.hide();
              }),
              this.wrapper
                .add(this.settingsBtnWrapper)
                .add(this.settingsWrapper)
                .add(this.settingsQualityWrapper)
                .add(this.settingsPlayRateWrapper),
              this.backFromPlayRate.on("click", function() {
                e.settingsPlayRateWrapper.hide(), e.updateRateQualityButtons(), e.settingsWrapper.show();
              }),
              this.backFromQuality.on("click", function() {
                e.settingsQualityWrapper.hide(), e.updateRateQualityButtons(), e.settingsWrapper.show();
              }),
              this.toggleHDTag();
          }),
          (e.prototype.getSpeedName = function() {
            return (
              (this.playbackRateTitle = this.player.playbackRate.getCurrentSpeed()),
              1 === this.playbackRateTitle ? this.player.lang.get("speedNormal") : this.playbackRateTitle
            );
          }),
          (e.prototype.renderMainSettings = function() {
            var e = this,
              t = [];
            (this.qualityButton = new i()
              .create("button")
              .addClass("actual-quality")
              .text(this.player.qualitySelector.getSourceTitle())),
              (this.speedButton = new i()
                .create("button")
                .addClass("actual-speed")
                .text(this.getSpeedName())),
              (t[0] = new i()
                .create("li")
                .add(
                  new i()
                    .create("span")
                    .addClass("label-quality")
                    .text(this.player.lang.get("quality"))
                )
                .add(this.qualityButton)),
              (t[1] = new i()
                .create("li")
                .add(
                  new i()
                    .create("span")
                    .addClass("label-speed")
                    .text(this.player.lang.get("speed"))
                )
                .add(this.speedButton)),
              this.settingsWrapper.add(
                new i()
                  .create("ul")
                  .add(this.renderHideThumbs())
                  .add(this.renderAutoplay())
                  .add(t[0])
                  .add(t[1])
              ),
              this.qualityButton.on("click", function() {
                e.settingsWrapper.hide(), e.settingsQualityWrapper.show();
              }),
              this.speedButton.on("click", function() {
                e.settingsWrapper.hide(), e.settingsPlayRateWrapper.show();
              });
          }),
          (e.prototype.updateRateQualityButtons = function() {
            this.qualityButton.text(this.player.qualitySelector.getSourceTitle()),
              this.speedButton.text(this.getSpeedName());
          }),
          (e.prototype.renderHideThumbs = function() {
            return (
              (this.hideThumbs = new he(this.player)), this.player.touchModeEnabled ? null : this.hideThumbs.getBtn()
            );
          }),
          (e.prototype.renderAutoplay = function() {
            return (this.autoplay = new pe(this.player)), this.autoplay.getBtn();
          }),
          (e.prototype.renderQualitySettings = function() {
            (this.settingsQualityWrapper = new i()
              .create("div")
              .addClass("video-quality-settings-wrapper")
              .hide()),
              (this.backFromQuality = new i()
                .create("button")
                .addClass("quality-back-button")
                .text(this.player.lang.get("settings")));
            var e = [];
            (e[0] = new i()
              .create("li")
              .addClass("back-button-wrapper")
              .add(this.backFromQuality)),
              (e[1] = new i()
                .create("li")
                .addClass("inner-type-settings-wrapper")
                .add(this.player.qualitySelector.getRenderedSelector())),
              this.settingsQualityWrapper.add(
                new i()
                  .create("ul")
                  .add(e[0])
                  .add(e[1])
              );
          }),
          (e.prototype.renderPlayrateSettings = function() {
            (this.settingsPlayRateWrapper = new i()
              .create("div")
              .addClass("video-playback-settings-wrapper")
              .hide()),
              (this.backFromPlayRate = new i()
                .create("button")
                .addClass("playrate-back-button")
                .text(this.player.lang.get("settings")));
            var e = [];
            (e[0] = new i()
              .create("li")
              .addClass("back-button-wrapper")
              .add(this.backFromPlayRate)),
              (e[1] = new i()
                .create("li")
                .addClass("inner-type-settings-wrapper")
                .add(this.player.playbackRate.getRenderedSelector())),
              this.settingsPlayRateWrapper.add(
                new i()
                  .create("ul")
                  .add(e[0])
                  .add(e[1])
              );
          }),
          (e.prototype.getSettingsWrapper = function() {
            return this.wrapper;
          }),
          (e.prototype.toggleSettings = function() {
            this.settingsWrapper.isVisible() ||
            this.settingsPlayRateWrapper.isVisible() ||
            this.settingsQualityWrapper.isVisible()
              ? (this.settingsWrapper.hide(), this.settingsPlayRateWrapper.hide(), this.settingsQualityWrapper.hide())
              : this.settingsWrapper.show();
          }),
          (e.prototype.toggleHDTag = function() {
            parseInt(this.player.qualitySelector.getSourceTitle(), 10) >= 720
              ? this.settingsHD.show()
              : this.settingsHD.hide();
          }),
          e
        );
      })(),
      ge = (function() {
        function e(e) {
          (this.player = e), (this.speeds = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2]), (this.currentSpeed = 3), this.render();
        }
        return (
          (e.prototype.render = function() {
            (this.speedSelector = new i().create("ul").addClass("video-playbackrate-menu")), this.renderList();
          }),
          (e.prototype.renderList = function() {
            var e = this;
            this.speeds.forEach(function(t, r) {
              var n = t;
              1 === t && (n = e.player.lang.get("speedNormal"));
              var s = new i().create("li").text(n.toString());
              s.on("click", function() {
                return e.changeSpeed(r);
              }),
                r === e.currentSpeed && s.addClass("active"),
                e.speedSelector.add(s);
            });
          }),
          (e.prototype.clearList = function() {
            this.speedSelector.clearChilds();
          }),
          (e.prototype.getRenderedSelector = function() {
            return this.speedSelector;
          }),
          (e.prototype.videoSpeedUp = function() {
            this.currentSpeed === this.speeds.length - 1 || this.changeSpeed(this.currentSpeed + 1);
          }),
          (e.prototype.videoSpeedDown = function() {
            0 === this.currentSpeed || this.changeSpeed(this.currentSpeed - 1);
          }),
          (e.prototype.changeSpeed = function(e) {
            (this.currentSpeed = e),
              (this.player.video.playbackRate = this.speeds[e]),
              this.clearList(),
              this.renderList(),
              this.player.settings.settingsWrapper.hide();
          }),
          (e.prototype.getCurrentSpeed = function() {
            return this.speeds[this.currentSpeed];
          }),
          (e.prototype.reset = function() {
            this.changeSpeed(3);
          }),
          e
        );
      })(),
      me = r(0),
      ye = r.n(me),
      Ee = (function() {
        function e(e) {
          (this.player = e), (this.localStorageKey = "html5PlayerQuality"), this.setInitSource(), this.render();
        }
        return (
          (e.prototype.setInitSource = function() {
            var e = null,
              t = null,
              r = this.player.storage.load(this.localStorageKey, null);
            this.player.options.hls &&
            (ye.a.isSupported() || this.player.video.canPlayType("application/vnd.apple.mpegurl"))
              ? this.player.options.sources.hls.forEach(function(i, n) {
                  r && i.desc === r && (t = n), i.active && (e = n);
                })
              : this.player.options.sources.mp4.forEach(function(i, n) {
                  r && i.desc === r && (t = n), i.active && (e = n);
                }),
              (this.sourceIndex = t || e || 0),
              this.player.options.hls &&
              (ye.a.isSupported() || this.player.video.canPlayType("application/vnd.apple.mpegurl"))
                ? (this.activeSource = this.player.options.sources.hls[this.sourceIndex] || { src: "", desc: "" })
                : (this.activeSource = this.player.options.sources.mp4[this.sourceIndex] || { src: "", desc: "" });
          }),
          (e.prototype.getSource = function() {
            return this.activeSource.src;
          }),
          (e.prototype.getSourceTitle = function() {
            return this.activeSource.desc;
          }),
          (e.prototype.render = function() {
            (this.qualitySelector = new i().create("ul").addClass("video-quality-menu")), this.renderList();
          }),
          (e.prototype.renderList = function() {
            var e = this;
            ye.a.isSupported() && this.player.options.hls
              ? this.player.options.sources.hls.forEach(function(t, r) {
                  if (t.src) {
                    var n = new i().create("li").text(t.desc);
                    n.on("click", function() {
                      return e.changeQuality(r);
                    }),
                      r === e.sourceIndex && n.addClass("active"),
                      e.qualitySelector.add(n);
                  }
                })
              : this.player.options.sources.mp4.forEach(function(t, r) {
                  if (t.src) {
                    var n = new i().create("li").text(t.desc);
                    n.on("click", function() {
                      return e.changeQuality(r);
                    }),
                      r === e.sourceIndex && n.addClass("active"),
                      e.qualitySelector.add(n);
                  }
                });
          }),
          (e.prototype.clearList = function() {
            this.qualitySelector.html("");
          }),
          (e.prototype.getRenderedSelector = function() {
            return this.qualitySelector;
          }),
          (e.prototype.changeQuality = function(e) {
            var t = this.player.video.currentTime,
              r = this.player.playerState.state.getValue() === l;
            (this.sourceIndex = e),
              ye.a.isSupported() && this.player.options.hls
                ? (this.activeSource = this.player.options.sources.hls[e])
                : (this.activeSource = this.player.options.sources.mp4[e]),
              r && this.player.playerHandler.pause(),
              this.player.options.hls
                ? (this.player.hls.destroy(),
                  (this.player.hls = new ye.a()),
                  this.player.hls.loadSource(this.activeSource.src),
                  this.player.hls.attachMedia(this.player.video))
                : this.player.playerHandler.changeQuality(this.activeSource.src),
              this.player.storage.save(this.localStorageKey, this.activeSource.desc),
              this.player.playbackRate.reset(),
              r && this.player.playerHandler.play(),
              this.clearList(),
              this.renderList(),
              this.player.settings.settingsWrapper.hide(),
              this.player.settings.toggleHDTag(),
              (this.player.video.currentTime = t);
          }),
          e
        );
      })(),
      Te = (function() {
        function e(e) {
          (this.player = e),
            (this.fullScreenEnabled = !!(
              document.fullscreenEnabled ||
              document.mozFullScreenEnabled ||
              document.msFullscreenEnabled ||
              document.webkitSupportsFullscreen ||
              document.webkitFullscreenEnabled ||
              document.createElement("video").webkitRequestFullScreen ||
              this.player.video.webkitSupportsFullscreen
            )),
            this.render(),
            this.setupEvents();
        }
        return (
          (e.prototype.render = function() {
            (this.fullscreenWrapperBtn = new i()
              .create("div")
              .addClass("fullscreen-button-wrapper")
              .addClass("tooltip-button")
              .addClass("tooltip-far-right")
              .attr("data-tooltip", this.player.lang.get("fullScreen"))),
              (this.fullscreen = new i()
                .create("button")
                .addClass("video-fullscreen")
                .html(Q.getHtml())),
              this.fullscreenWrapperBtn.add(this.fullscreen),
              this.fullScreenEnabled || this.fullscreenWrapperBtn.hide();
          }),
          (e.prototype.getBtn = function() {
            return this.fullscreenWrapperBtn;
          }),
          (e.prototype.setupEvents = function() {
            var e = this;
            this.fullscreenWrapperBtn.on("click", function() {
              return e.handleFullscreen();
            }),
              document.addEventListener("fullscreenchange", function() {
                e.setFullscreenData(!(!document.fullScreen && !document.fullscreenElement));
              }),
              document.addEventListener("webkitfullscreenchange", function() {
                e.setFullscreenData(!!document.webkitIsFullScreen);
              }),
              document.addEventListener("mozfullscreenchange", function() {
                e.setFullscreenData(!!document.mozFullScreen);
              }),
              document.addEventListener("msfullscreenchange", function() {
                e.setFullscreenData(!!document.msFullscreenElement);
              }),
              this.player.video.addEventListener("loadedmetadata", function(t) {
                (document.fullscreenEnabled || e.player.video.webkitSupportsFullscreen) &&
                  ((e.fullScreenEnabled = !0), e.fullscreenWrapperBtn.show());
              }),
              /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                !window.MSStream &&
                window.addEventListener("orientationchange", function() {
                  return e.handleScreenOrientationChange();
                }),
              void 0 !== screen.orientation &&
                screen.orientation.addEventListener("change", function() {
                  return e.handleScreenOrientationChange();
                }),
              this.player.playerState.isCasting.subscribe(function(t) {
                t && e.fullScreenEnabled ? e.fullscreenWrapperBtn.hide() : e.fullscreenWrapperBtn.show();
              });
          }),
          (e.prototype.handleScreenOrientationChange = function() {
            -90 === window.orientation || 90 === window.orientation
              ? this.turnOnFullScreen()
              : this.turnOffFullScreen();
          }),
          (e.prototype.handleFullscreen = function() {
            this.isFullScreen() ? this.turnOffFullScreen() : this.turnOnFullScreen();
          }),
          (e.prototype.turnOffFullScreen = function() {
            window.fullScreen && document.exitFullscreen
              ? document.exitFullscreen()
              : document.mozCancelFullScreen
                ? document.mozCancelFullScreen()
                : document.webkitCancelFullScreen
                  ? document.webkitCancelFullScreen()
                  : document.msExitFullscreen && document.msExitFullscreen(),
              this.setFullscreenData(!1);
          }),
          (e.prototype.turnOnFullScreen = function() {
            var e = this.player.containerWrapper.get();
            try {
              if (e.requestFullscreen) e.requestFullscreen();
              else if (e.mozRequestFullScreen) e.mozRequestFullScreen();
              else if (e.webkitRequestFullscreen) e.webkitRequestFullscreen();
              else {
                if (!e.msRequestFullscreen)
                  return this.player.video.webkitSupportsFullscreen
                    ? void this.player.video.webkitEnterFullscreen()
                    : void 0;
                e.msRequestFullscreen();
              }
              this.setFullscreenData(!0);
            } catch (e) {
              this.player.log(e);
            }
          }),
          (e.prototype.isFullScreen = function() {
            return !!(
              document.fullScreen ||
              document.webkitIsFullScreen ||
              document.mozFullScreen ||
              document.msFullscreenElement ||
              document.fullscreenElement
            );
          }),
          (e.prototype.setFullscreenData = function(e) {
            this.player.vastHandler.isActive &&
              this.player.vastHandler.vastTracker &&
              this.player.vastHandler.vastTracker.setFullscreen(e),
              e
                ? (this.player.container.addClass("fullscreen"),
                  this.fullscreen.html(X.getHtml()),
                  this.fullscreenWrapperBtn.attr("data-tooltip", this.player.lang.get("exitFullScreen")),
                  this.player.playerState.isFullscreen.next(!0))
                : (this.player.container.removeClass("fullscreen"),
                  this.fullscreen.html(Q.getHtml()),
                  this.fullscreenWrapperBtn.attr("data-tooltip", this.player.lang.get("fullScreen")),
                  this.player.playerState.isFullscreen.next(!1));
          }),
          e
        );
      })(),
      be = 0.05,
      Se = "html5PlayerVolumeMuted",
      ke = "html5PlayerVolume",
      Ae = (function() {
        function e(e) {
          (this.player = e), (this.volumeDrag = !1), this.render(), this.setupEvents();
        }
        return (
          (e.prototype.render = function() {
            (this.wrapper = new i().create("div").addClass("video-volume")),
              (this.mute = new i()
                .create("button")
                .addClass("video-volume-mute")
                .addClass("muted")
                .html(J.getHtml())),
              (this.btnWrapper = new i()
                .create("div")
                .addClass("mute-button-wrapper")
                .addClass("tooltip-button")),
              this.btnWrapper.add(this.mute),
              (this.volumeActual = new i().create("div").addClass("volume-range-actual")),
              (this.volume = new i()
                .create("div")
                .addClass("volume-range-progress")
                .add(this.volumeActual));
            var e = new i()
              .create("div")
              .addClass("volume-range")
              .add(this.volume);
            this.wrapper.add(this.btnWrapper).add(e), this.setupDefaultState();
          }),
          (e.prototype.setupDefaultState = function() {
            this.setMute(this.player.storage.load(Se, !1, null));
            var e = this.player.storage.load(ke, 1, null);
            this.player.video.muted ? this.uiRenderVolume(e) : this.setVolume(e);
          }),
          (e.prototype.getVolumeBar = function() {
            return this.wrapper;
          }),
          (e.prototype.setupEvents = function() {
            var e = this;
            this.btnWrapper.on("click", function() {
              return e.setMute(!e.player.playerState.isMuted.getValue());
            }),
              this.player.video.addEventListener("volumechange", function() {
                return e.volumeChanged();
              }),
              this.volume.on("mousedown", function(t) {
                (e.volumeDrag = !0), e.player.container.addClass("setting-volume"), e.updateVolumeBar(t);
              }),
              document.addEventListener("mouseup", function(t) {
                e.volumeDrag &&
                  ((e.volumeDrag = !1),
                  setTimeout(function() {
                    return e.player.container.removeClass("setting-volume");
                  }, 300),
                  e.updateVolumeBar(t));
              }),
              document.addEventListener("mousemove", function(t) {
                e.volumeDrag && e.updateVolumeBar(t);
              }),
              this.player.playerState.isMuted.subscribe(function(t) {
                return e.uiRenderMute(t);
              }),
              this.player.playerState.volume.subscribe(function(t) {
                return e.uiRenderVolume(t);
              });
          }),
          (e.prototype.setMuteByKey = function() {
            this.player.video.muted
              ? (this.setVolume(this.player.video.volume),
                this.uiRenderVolume(this.player.video.volume),
                this.setMute(!1))
              : this.setMute(!0);
          }),
          (e.prototype.setMute = function(e) {
            e ? this.player.playerHandler.mute() : this.player.playerHandler.unMute(),
              this.player.playerState.isCasting.getValue() || this.player.storage.save(Se, e),
              this.player.playerState.isMuted.next(e);
          }),
          (e.prototype.volumeChanged = function() {
            this.player.video.muted
              ? this.uiRenderVolume(0)
              : (this.setVolume(this.player.video.volume),
                this.uiRenderVolume(this.player.video.volume),
                this.setMute(0 === this.player.video.volume));
          }),
          (e.prototype.setVolume = function(e) {
            this.player.playerHandler.setVolume(e),
              this.player.playerState.volume && this.setMute(!1),
              this.player.playerState.isCasting.getValue() || this.player.storage.save(ke, e);
          }),
          (e.prototype.uiRenderMute = function(e) {
            this.mute.html(e ? $.getHtml() : J.getHtml()),
              this.btnWrapper.attr("data-tooltip", this.player.lang.get(e ? "unmute" : "mute"));
          }),
          (e.prototype.uiRenderVolume = function(e) {
            this.volumeActual.style("width", 100 * e + "%");
          }),
          (e.prototype.updateVolumeBar = function(e) {
            var t = Math.ceil(e.clientX - this.volume.get().getBoundingClientRect().left);
            t < 0 && (t = 0), t > this.volume.get().offsetWidth && (t = this.volume.get().offsetWidth);
            var r = t / this.volume.get().offsetWidth;
            this.setVolume(r), this.uiRenderVolume(r);
          }),
          (e.prototype.volumeIncrease = function() {
            if (1 !== this.player.video.volume || this.player.video.muted)
              if (this.player.video.muted) this.setVolume(be), this.uiRenderVolume(be), this.setMute(!1);
              else if (this.player.video.volume + be >= 1) this.setVolume(1), this.uiRenderVolume(1);
              else {
                var e = this.player.video.volume + be;
                this.setVolume(e), this.uiRenderVolume(e);
              }
            else;
          }),
          (e.prototype.volumeDecrease = function() {
            if (this.player.video.muted);
            else if (this.player.video.volume - be <= 0) this.setVolume(0), this.uiRenderVolume(0), this.setMute(!0);
            else {
              var e = this.player.video.volume - be;
              this.setVolume(e), this.uiRenderVolume(e);
            }
          }),
          e
        );
      })(),
      we = (function() {
        function e(e) {
          (this.player = e),
            (this.player = e),
            (this.video = this.player.video),
            (this.baseThumb = this.player.options.thumbBase),
            (this.thumbsCount = this.player.options.thumbsCount),
            (this.currentThumb = -1),
            (this.debounce = 0),
            (this.timeDrag = !1),
            (this.timeChangeModifier = 5),
            this.render(),
            this.setupEvents();
        }
        return (
          (e.prototype.render = function() {
            (this.wrapper = new i().create("div").addClass("video-progress")),
              (this.thumbnailWrapper = new i().create("div").addClass("video-thumbnail-preview-wrapper")),
              (this.thumbnail = new i().create("img").addClass("video-thumbnail-preview")),
              (this.mouseTime = new i().create("span").addClass("video-thumbnail-preview-time")),
              this.thumbnailWrapper.add(this.thumbnail).add(this.mouseTime),
              this.thumbnailWrapper.hide(),
              (this.progressWrapper = new i().create("div").addClass("video-progress-bar")),
              (this.buffer = new i().create("span").addClass("video-progress-bar-buffer")),
              (this.mouseBar = new i().create("span").addClass("video-progress-bar-mouse")),
              (this.progress = new i().create("span").addClass("video-progress-bar-progress")),
              this.progressWrapper
                .add(this.buffer)
                .add(this.mouseBar)
                .add(this.progress),
              this.wrapper.add(this.thumbnailWrapper).add(this.progressWrapper),
              (this.timerWrapper = new i().create("div").addClass("video-timer")),
              (this.currentTime = new i().create("span").text("0:00")),
              (this.totalTime = new i().create("span").text("0:00")),
              this.timerWrapper
                .add(this.currentTime)
                .add(new i().create("span").text(" / "))
                .add(this.totalTime);
          }),
          (e.prototype.getProgressBar = function() {
            return this.wrapper;
          }),
          (e.prototype.getTimer = function() {
            return this.timerWrapper;
          }),
          (e.prototype.setupEvents = function() {
            var e = this;
            this.progressWrapper.on("mousedown", function(t) {
              return e.handleStartSeekEvent(t);
            }),
              this.progressWrapper.on("touchstart", function(t) {
                return e.handleStartSeekEvent(t.touches[0]);
              }),
              document.addEventListener("mouseup", function(t) {
                return e.handleEndSeekEvent(t);
              }),
              document.addEventListener("touchend", function(t) {
                return e.handleEndSeekEvent(t.changedTouches[0]);
              }),
              document.addEventListener("mousemove", function(t) {
                return e.handleSeekingEvent(t);
              }),
              document.addEventListener("touchmove", function(t) {
                return e.handleSeekingEvent(t.touches[0]);
              }),
              this.wrapper.on("mousemove", function(t) {
                return e.handleMouseOver(t);
              }),
              this.wrapper.on("mouseover", function(t) {
                return e.handleMouseOver(t);
              }),
              this.wrapper.on("mouseout", function() {
                return (e.debounce = setTimeout(e.handleMouseOut(), 100));
              }),
              this.thumbnailWrapper.on("click", function(t) {
                return e.handleClick(t);
              }),
              this.video.addEventListener("progress", function() {
                return e.buffered();
              }),
              this.player.playerState.currentTime.subscribe(function(t) {
                e.timeUpdate(t);
              });
          }),
          (e.prototype.handleStartSeekEvent = function(e) {
            this.player.playerState.isAdvertise.getValue() ||
              ((this.timeDrag = !0),
              this.player.container.addClass("video-seeking"),
              this.updateTimeBar(e),
              (this.video.playbackRate = 0));
          }),
          (e.prototype.handleEndSeekEvent = function(e) {
            this.player.playerState.isAdvertise.getValue() ||
              (this.timeDrag &&
                ((this.timeDrag = !1),
                this.player.container.removeClass("video-seeking"),
                this.updateTimeBar(e),
                (this.video.playbackRate = this.player.playbackRate.getCurrentSpeed())));
          }),
          (e.prototype.handleSeekingEvent = function(e) {
            this.player.playerState.isAdvertise.getValue() || (this.timeDrag && this.updateTimeBar(e));
          }),
          (e.prototype.handleClick = function(e) {
            if (!this.player.playerState.isAdvertise.getValue()) {
              var t =
                Math.floor(e.clientX - this.player.container.get().getBoundingClientRect().left) /
                this.progressWrapper.get().offsetWidth;
              this.player.isReduced
                ? this.player.playerHandler.seekTo(
                    this.player.reducedVideoStartTime + t * this.player.reducedVideoDuration
                  )
                : this.player.playerHandler.seekTo(t * this.video.duration);
            }
          }),
          (e.prototype.timeUpdate = function(e) {
            var t;
            void 0 === e && (e = 0),
              isNaN(this.video.duration) ||
                (this.player.controlsBottomLeft.style("opacity", "1"),
                this.player.isReduced
                  ? this.totalTime.text(this.formatTime(this.player.reducedVideoDuration))
                  : this.totalTime.text(this.formatTime(this.video.duration))),
              (t = this.player.isReduced
                ? (this.progressWrapper.get().offsetWidth * (e - this.player.reducedVideoStartTime)) /
                  this.player.reducedVideoDuration
                : (this.progressWrapper.get().offsetWidth * e) / this.video.duration) <= 0 &&
                0 !== this.video.currentTime &&
                (t = 1),
              this.progress.style("width", t.toFixed(3) + "px"),
              this.player.isReduced
                ? this.currentTime.text(this.formatTime(e - this.player.reducedVideoStartTime))
                : this.currentTime.text(this.formatTime(e));
          }),
          (e.prototype.videoTimeForwards = function() {
            if (!this.player.playerState.isAdvertise.getValue()) {
              var e = this.video.currentTime,
                t = this.video.duration;
              t.isNaN ||
                e === t ||
                (this.player.isReduced
                  ? e + this.timeChangeModifier >= this.player.reducedVideoStartTime + this.player.reducedVideoDuration
                    ? ((this.video.currentTime = this.player.reducedVideoStartTime + this.player.reducedVideoDuration),
                      this.timeUpdate())
                    : ((this.video.currentTime = e + this.timeChangeModifier), this.timeUpdate(this.video.currentTime))
                  : e + this.timeChangeModifier >= t
                    ? ((this.video.currentTime = t), this.timeUpdate())
                    : ((this.video.currentTime = e + this.timeChangeModifier),
                      this.timeUpdate(this.video.currentTime)));
            }
          }),
          (e.prototype.videoTimeBackwards = function() {
            if (!this.player.playerState.isAdvertise.getValue()) {
              var e = this.video.currentTime;
              this.video.duration.isNaN ||
                0 === e ||
                (this.player.isReduced
                  ? e - this.timeChangeModifier <= this.player.reducedVideoStartTime
                    ? ((this.video.currentTime = this.player.reducedVideoStartTime), this.timeUpdate())
                    : ((this.video.currentTime = e - this.timeChangeModifier), this.timeUpdate(this.video.currentTime))
                  : e - this.timeChangeModifier <= 0
                    ? ((this.video.currentTime = 0), this.timeUpdate())
                    : ((this.video.currentTime = e - this.timeChangeModifier),
                      this.timeUpdate(this.video.currentTime)));
            }
          }),
          (e.prototype.updateTimeBar = function(e) {
            var t = Math.floor(e.clientX - this.player.container.get().getBoundingClientRect().left);
            if (
              (t < 0 && (t = 1),
              t > this.progressWrapper.get().offsetWidth && (t = this.progressWrapper.get().offsetWidth),
              this.progress.style("width", t + "px"),
              !this.timeDrag)
            ) {
              var r = t / this.progressWrapper.get().offsetWidth;
              this.player.isReduced
                ? this.player.playerHandler.seekTo(
                    r * this.player.reducedVideoDuration + this.player.reducedVideoStartTime
                  )
                : this.player.playerHandler.seekTo(r * this.video.duration);
            }
          }),
          (e.prototype.updateTimeBarOnResize = function() {
            var e;
            this.video.duration &&
              (this.player.isReduced
                ? ((e =
                    (this.video.currentTime - this.player.reducedVideoStartTime) / this.player.reducedVideoDuration),
                  this.player.playerHandler.seekTo(
                    this.player.reducedVideoStartTime + e * this.player.reducedVideoDuration
                  ))
                : ((e = this.video.currentTime / this.video.duration),
                  this.player.playerHandler.seekTo(e * this.video.duration)));
          }),
          (e.prototype.buffered = function() {
            var e = this.video.buffered.length > 0;
            if (this.video.buffered && e && this.video.buffered.length) {
              var t = this.video.duration;
              if (t > 0)
                for (var r = 0, i = this.video.buffered.length - 1; r < i; r++) {
                  var n = this.video.buffered.start(this.video.buffered.length - 1 - r);
                  if (n < this.video.currentTime && n < t) {
                    if (this.player.isReduced) {
                      var s = this.video.buffered.end(this.video.buffered.length - 1 - r),
                        a =
                          (((s =
                            s - this.player.reducedVideoStartTime > 0 ? s - this.player.reducedVideoStartTime : 0) -
                            this.player.reducedVideoStartTime) /
                            (this.player.reducedVideoStartTime + this.player.reducedVideoDuration)) *
                          100;
                      (a = a > 100 ? 100 : a), this.buffer.style("width", a + "%");
                    } else
                      this.buffer.style(
                        "width",
                        (this.video.buffered.end(this.video.buffered.length - 1 - r) / t) * 100 + "%"
                      );
                    break;
                  }
                }
            }
          }),
          (e.prototype.handleMouseOver = function(e) {
            if (!this.player.playerState.isAdvertise.getValue()) {
              var t = Math.floor(e.clientX - this.player.container.get().getBoundingClientRect().left);
              this.mouseBar.style("width", t + "px"), this.showThumbnail(t);
            }
          }),
          (e.prototype.handleMouseOut = function() {
            clearTimeout(this.debounce), this.mouseBar.style("width", "0px"), this.thumbnailWrapper.hide();
          }),
          (e.prototype.showThumbnail = function(e) {
            var t;
            this.player.settings.hideThumbs.active &&
              !this.player.touchModeEnabled &&
              this.baseThumb &&
              ((this.player.options.brandPreroll.enabled &&
                this.player.options.brandPreroll.url === this.player.video.src) ||
                ((t = this.player.isReduced
                  ? Math.floor(
                      (((e / this.progressWrapper.get().offsetWidth) * this.player.reducedVideoDuration +
                        this.player.reducedVideoStartTime) /
                        this.video.duration) *
                        this.thumbsCount
                    )
                  : Math.floor(e / (this.progressWrapper.get().offsetWidth / this.thumbsCount))) !==
                  this.currentThumb &&
                  (0 === t && (t = 1),
                  t > this.thumbsCount && (t = 1),
                  this.thumbnail.attr("src", this.baseThumb.replace("{THUMB_ID}", t.toString())),
                  (this.currentThumb = t)),
                this.player.isReduced
                  ? this.mouseTime.text(
                      this.formatTime(
                        Math.floor((this.player.reducedVideoDuration / this.progressWrapper.get().offsetWidth) * e)
                      )
                    )
                  : this.mouseTime.text(
                      this.formatTime(Math.floor((this.video.duration / this.progressWrapper.get().offsetWidth) * e))
                    ),
                this.thumbnailWrapper.show(),
                this.setThumbnailPosition(e)));
          }),
          (e.prototype.setThumbnailPosition = function(e) {
            var t = e - this.thumbnailWrapper.get().offsetWidth / 2;
            t < 0 && (t = 0),
              t + this.thumbnailWrapper.get().offsetWidth > this.wrapper.get().offsetWidth &&
                (t = this.wrapper.get().offsetWidth - this.thumbnailWrapper.get().offsetWidth),
              this.thumbnailWrapper.style("left", t + "px");
          }),
          (e.prototype.formatTime = function(e) {
            e = e < 0 ? 0 : e;
            var t = Math.floor(e % 60),
              r = Math.floor((e / 60) % 60),
              i = Math.floor(e / 3600);
            return (
              (isNaN(e) || e === 1 / 0) && (i = r = t = "-"),
              (r = (i >= 1 && r < 10 ? "0" + r : r) + ":"),
              (i = i > 0 ? i + ":" : "") + r + (t = t < 10 ? "0" + t : t)
            );
          }),
          e
        );
      })(),
      Re = (function() {
        var e =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function(e, t) {
              e.__proto__ = t;
            }) ||
          function(e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          };
        return function(t, r) {
          function i() {
            this.constructor = t;
          }
          e(t, r), (t.prototype = null === r ? Object.create(r) : ((i.prototype = r.prototype), new i()));
        };
      })(),
      Ce = (function(e) {
        function t(t, r, i) {
          var n = e.call(this, i) || this;
          return (n.remotePlayer = t), (n.remotePlayerController = r), (n.playerState = i), n;
        }
        return (
          Re(t, e),
          (t.prototype.play = function() {
            console.log("Play ChromeCast", this.remotePlayer, this.remotePlayerController),
              this.remotePlayerController.playOrPause();
          }),
          (t.prototype.pause = function() {
            console.log("Pause ChromeCast", this.remotePlayer, this.remotePlayerController),
              this.remotePlayerController.playOrPause();
          }),
          (t.prototype.load = function() {}),
          (t.prototype.seekTo = function(e) {
            (this.remotePlayer.currentTime = e), this.remotePlayerController.seek();
          }),
          (t.prototype.mute = function() {
            this.remotePlayer.isMuted || this.remotePlayerController.muteOrUnmute();
          }),
          (t.prototype.unMute = function() {
            this.remotePlayer.isMuted && this.remotePlayerController.muteOrUnmute();
          }),
          (t.prototype.setVolume = function(e) {
            (this.remotePlayer.volumeLevel = e), this.remotePlayerController.setVolumeLevel();
          }),
          (t.prototype.changeQuality = function(e) {
            console.log("chromecast not support change quality!");
          }),
          (t.prototype.timeUpdate = function() {}),
          t
        );
      })(h),
      Le = "IDLE",
      De = "LOADING",
      _e = "LOADED",
      Ie = "PLAYING",
      xe = "PAUSED",
      Oe = "STOPPED",
      Pe = (function() {
        function e(e) {
          (this.player = e),
            (this.apiInitialized = !1),
            (this.hasReceiver = !1),
            (this.playerHandler = new Me(this)),
            (this.tryAgainTimer = 1e3),
            this.player.options.chromeCastEnabled &&
              ((this.wrapper = new i().create("div").addClass("chromecast-button-wrapper")),
              (this.btn = new i(document.createElement("google-cast-launcher")).text("")),
              this.player.controlsBottomRight.add(this.wrapper.add(this.btn)),
              (this.remotePlayer = null),
              (this.timer = null),
              this.isAvailable());
        }
        return (
          (e.prototype.isAvailable = function() {
            var e = this;
            try {
              "undefined" != typeof cast && chrome.cast && chrome.cast.isAvailable
                ? this.initializeApi()
                : setTimeout(function() {
                    e.isAvailable(), (e.tryAgainTimer = 2 * e.tryAgainTimer);
                  }, this.tryAgainTimer);
            } catch (e) {
              this.player.log(e);
            }
          }),
          (e.prototype.initializeApi = function() {
            var e = this;
            cast.framework.CastContext.getInstance().setOptions({
              receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
              autoJoinPolicy: chrome.cast.AutoJoinPolicy.PAGE_SCOPED
            }),
              (this.remotePlayer = new cast.framework.RemotePlayer()),
              (this.remotePlayerController = new cast.framework.RemotePlayerController(this.remotePlayer)),
              this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED,
                this.switchPlayer.bind(this)
              ),
              this.player.playerState.isCasting.subscribe(function(t) {
                e.player.titleText.text(
                  t
                    ? e.player.lang.get("casting") + " " + e.castSession.getCastDevice().friendlyName
                    : e.player.options.title
                );
              });
          }),
          (e.prototype.switchPlayer = function() {
            this.player.playerState.state.next(Le);
            var e = cast.framework.CastContext.getInstance().getCurrentSession();
            (this.castSession = e),
              cast &&
                cast.framework &&
                (this.remotePlayer.isConnected && e ? this.setupRemotePlayer(e) : this.stopSession());
          }),
          (e.prototype.toggleOverlay = function(e) {
            e ? this.player.container.addClass("chromecasting") : this.player.container.removeClass("chromecasting");
          }),
          (e.prototype.setupRemotePlayer = function(e) {
            var t = this;
            (this.castSession = e),
              this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED,
                function() {
                  return t.remotePlayer.isPaused
                    ? t.player.playerState.state.next(xe)
                    : t.player.playerState.state.next(Ie);
                }
              ),
              this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED,
                function() {
                  t.player.playerHandler.playerState.currentTime.next(t.remotePlayer.currentTime),
                    !0 !== t.player.playerState.isCasting.getValue() && t.player.playerState.isCasting.next(!0),
                    t.player.playerState.state.getValue() === Ie ||
                      t.remotePlayer.isPaused ||
                      t.player.playerState.state.next(Ie),
                    setTimeout(function() {
                      return t.incrementMediaTimeHandler();
                    }, 1e3);
                }
              ),
              this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED,
                function() {
                  return t.player.playerState.isMuted.next(t.remotePlayer.isMuted);
                }
              ),
              this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED,
                function() {
                  return t.player.playerState.volume.next(t.remotePlayer.volumeLevel);
                }
              );
            var r = {
              play: function() {
                return t.play();
              },
              pause: function() {
                return t.pause();
              },
              stop: function() {
                return t.stop();
              },
              load: function() {
                return t.cast();
              },
              getCurrentMediaTime: function() {
                return t.getCurrentMediaTime();
              },
              getMediaDuration: function() {
                return t.getMediaDuration();
              },
              updateDisplayMessage: function() {
                return t.updateDisplayMessage();
              },
              mute: function() {
                return t.mute();
              },
              unMute: function() {
                return t.unMute();
              },
              isMuted: function() {
                return t.isMuted();
              },
              seekTo: function(e) {
                return t.seekTo(e);
              }
            };
            this.playerHandler.setTarget(r),
              this.player.playerHandler.stop(),
              (this.player.playerHandler = new Ce(
                this.remotePlayer,
                this.remotePlayerController,
                this.player.playerState
              )),
              this.remotePlayer.isMuted && this.playerHandler.mute(),
              this.playerHandler.play();
          }),
          (e.prototype.cast = function() {
            this.player.playerState.state.next(De),
              (this.castSession = cast.framework.CastContext.getInstance().getCurrentSession());
            var e = new chrome.cast.media.MediaInfo(this.player.qualitySelector.getSource(), "video/mp4");
            (e.metadata = new chrome.cast.media.GenericMediaMetadata()),
              (e.metadata.metadataType = chrome.cast.media.MetadataType.GENERIC),
              (e.metadata.title = document.title),
              (e.metadata.images = [{ url: this.player.options.poster }]);
            var t = new chrome.cast.media.LoadRequest(e);
            this.castSession.loadMedia(t);
          }),
          (e.prototype.incrementMediaTimeHandler = function() {
            var e = this.remotePlayer.currentTime,
              t = this.remotePlayer.duration;
            null !== this.remotePlayer.playerState
              ? 0 !== t &&
                this.player.playerState.state.getValue() === Ie &&
                (e >= t
                  ? this.stopCasting()
                  : !0 !== this.player.playerState.isCasting.getValue() && this.player.playerState.isCasting.next(!0))
              : this.stopCasting();
          }),
          (e.prototype.stopCasting = function() {
            if (this.player.options.chromeCastEnabled) {
              clearInterval(this.timer), this.remotePlayerController.stop();
              try {
                cast.framework.CastContext.getInstance()
                  .getCurrentSession()
                  .endSession(!0);
              } catch (e) {
                this.player.log("[WARN] " + e);
              }
              this.toggleOverlay(!1),
                this.player.playerState.state.next(Le),
                this.player.playerState.isCasting.next(!1);
            }
          }),
          (e.prototype.stopSession = function() {
            this.pause(),
              (this.currentMediaTime = 0),
              clearInterval(this.timer),
              this.player.playerState.state.next(Le),
              this.player.playerState.isCasting.next(!1),
              this.player.volume.setupDefaultState(),
              (this.player.playerHandler = this.player.playerHandlerLocal);
          }),
          (e.prototype.isCasting = function() {
            return (
              null !== this.remotePlayer &&
              (this.remotePlayer.isConnected && this.player.playerState.state.getValue() !== Le)
            );
          }),
          (e.prototype.castError = function(e) {
            switch (e.code) {
              case chrome.cast.ErrorCode.API_NOT_INITIALIZED:
                return "The API is not initialized." + (e.description ? " :" + e.description : "");
              case chrome.cast.ErrorCode.CANCEL:
                return "The operation was canceled by the user" + (e.description ? " :" + e.description : "");
              case chrome.cast.ErrorCode.CHANNEL_ERROR:
                return "A channel to the receiver is not available." + (e.description ? " :" + e.description : "");
              case chrome.cast.ErrorCode.EXTENSION_MISSING:
                return "The Cast extension is not available." + (e.description ? " :" + e.description : "");
              case chrome.cast.ErrorCode.INVALID_PARAMETER:
                return "The parameters to the operation were not valid." + (e.description ? " :" + e.description : "");
              case chrome.cast.ErrorCode.RECEIVER_UNAVAILABLE:
                return (
                  "No receiver was compatible with the session request." + (e.description ? " :" + e.description : "")
                );
              case chrome.cast.ErrorCode.SESSION_ERROR:
                return (
                  "A session could not be created, or a session was invalid." +
                  (e.description ? " :" + e.description : "")
                );
              case chrome.cast.ErrorCode.TIMEOUT:
                return "The operation timed out." + (e.description ? " :" + e.description : "");
            }
          }),
          (e.prototype.play = function() {
            this.remotePlayer.isPaused
              ? this.player.playerState.state.next(xe)
              : this.remotePlayer.isConnected && this.player.playerState.state.next(Ie);
          }),
          (e.prototype.pause = function() {
            !this.remotePlayer.isPaused && this.remotePlayer.isConnected
              ? this.player.playerState.state.next(Ie)
              : this.remotePlayer.isConnected && this.player.playerState.state.next(xe);
          }),
          (e.prototype.stop = function() {
            try {
              this.castSession.endSession(!0);
            } catch (e) {}
          }),
          (e.prototype.getCurrentMediaTime = function() {
            return this.remotePlayer.currentTime;
          }),
          (e.prototype.getMediaDuration = function() {
            return this.remotePlayer.duration;
          }),
          (e.prototype.updateDisplayMessage = function() {}),
          (e.prototype.mute = function() {
            this.remotePlayer.isMuted || this.remotePlayerController.muteOrUnmute();
          }),
          (e.prototype.unMute = function() {
            this.remotePlayer.isMuted && this.remotePlayerController.muteOrUnmute();
          }),
          (e.prototype.isMuted = function() {
            return this.remotePlayer.isMuted;
          }),
          (e.prototype.seekTo = function(e) {
            (this.remotePlayer.currentTime = e), this.remotePlayerController.seek();
          }),
          e
        );
      })(),
      Me = (function() {
        function e(e) {
          (this.castPlayer = e), (this.target = {});
        }
        return (
          (e.prototype.setTarget = function(e) {
            this.target = e;
          }),
          (e.prototype.play = function() {
            this.castPlayer.playerState === Ie ||
            this.castPlayer.playerState === xe ||
            this.castPlayer.playerState === _e
              ? (this.target.play(),
                (this.castPlayer.playerState = Ie),
                this.seeking ||
                  ((this.castPlayer.player.seeking = !1),
                  (this.castPlayer.player.playing = !0),
                  (this.castPlayer.videoChange = !1),
                  this.updateDisplayMessage()))
              : this.load();
          }),
          (e.prototype.pause = function() {
            this.castPlayer.playerState === Ie &&
              (this.seeking ||
                this.videoChange ||
                ((this.castPlayer.player.playing = !1),
                this.target.pause(),
                (this.castPlayer.playerState = xe),
                this.updateDisplayMessage()));
          }),
          (e.prototype.stop = function() {
            this.target.stop(), (this.castPlayer.playerState = Oe), this.updateDisplayMessage();
          }),
          (e.prototype.load = function() {
            (this.castPlayer.playerState = De), this.target.load(), this.updateDisplayMessage();
          }),
          (e.prototype.loaded = function() {
            (this.castPlayer.currentMediaDuration = this.getMediaDuration()),
              (this.castPlayer.playerState = _e),
              this.castPlayer.currentMediaTime > 0 && this.seekTo(this.castPlayer.currentMediaTime),
              this.play(),
              this.updateDisplayMessage();
          }),
          (e.prototype.getCurrentMediaTime = function() {
            return this.target.getCurrentMediaTime();
          }),
          (e.prototype.getMediaDuration = function() {
            return this.target.getMediaDuration();
          }),
          (e.prototype.updateDisplayMessage = function() {
            this.target.updateDisplayMessage();
          }),
          (e.prototype.mute = function() {
            this.target.mute();
          }),
          (e.prototype.unMute = function() {
            this.target.unMute();
          }),
          (e.prototype.isMuted = function() {
            return this.target.isMuted();
          }),
          (e.prototype.seekTo = function(e) {
            this.target.seekTo(e), this.updateDisplayMessage();
          }),
          e
        );
      })(),
      Fe = (function() {
        function e(e) {
          var t = this;
          (this.player = e),
            (this.enabled = !1),
            (this.enabled = this.isAdsEnabledCheck()),
            this.enabled &&
              (this.player.video.addEventListener("pause", function() {
                t.player.vastHandler.isActive ||
                  !t.player.vastHandler.isShown ||
                  t.player.clickContextMenu.isActive ||
                  t.show();
              }),
              this.player.video.addEventListener("playing", function() {
                return t.hide();
              }));
        }
        return (
          (e.prototype.isAdsEnabledCheck = function() {
            return (
              !!this.player.options.videoEndOverlay.enabled ||
              (!!this.player.options.interstitialAd.enabled && !!this.player.options.interstitialAd.url1)
            );
          }),
          (e.prototype.render = function() {
            var e = this;
            if (this.player.isAdsEnabled) {
              this.wrapper = new i().create("div").addClass("video-extra-overlay");
              var t = new i().create("div").addClass("video-extra-wrapper"),
                r = new i()
                  .create("button")
                  .addClass("video-extra-close")
                  .text(this.player.lang.get("close") + " [X]");
              t
                .add(new i().create("p").text(this.player.lang.get("advertisement")))
                .add(r)
                .add(this.getRenderedIframe(this.player.options.interstitialAd.url1)),
                this.player.options.interstitialAd.url2 &&
                  (t.add(this.getRenderedIframe(this.player.options.interstitialAd.url2)),
                  this.wrapper.addClass("video-extra-double")),
                r.on("click", function(t) {
                  return e.closeAndPlay(t);
                }),
                this.wrapper.on("click", function(t) {
                  return e.closeAndPlay(t);
                }),
                t.add(
                  new i()
                    .create("button")
                    .text(this.player.lang.get("stopCast"))
                    .addClass("chrome-cast-stop")
                    .on("click", function() {
                      e.player.chromecast.stopCasting();
                    })
                ),
                this.wrapper.add(t),
                this.player.container.add(this.wrapper);
            } else this.player.isAdsEnabled = !0;
          }),
          (e.prototype.getRenderedIframe = function(e) {
            return new i()
              .create("div")
              .addClass("video-extra-info")
              .add(
                new i()
                  .create("iframe")
                  .attr("src", e)
                  .attr("scrolling", "no")
              );
          }),
          (e.prototype.closeAndPlay = function(e) {
            this.player.chromecast.isCasting() || (this.wrapper.remove(), this.player.play());
          }),
          (e.prototype.hide = function() {
            void 0 !== this.wrapper && this.wrapper.remove();
          }),
          (e.prototype.show = function() {
            var e = this;
            if (
              0 !== this.player.video.currentTime &&
              (!this.player.isReduced || this.player.video.currentTime !== this.player.reducedVideoStartTime)
            ) {
              if (this.player.options.videoEndOverlay.enabled && this.player.options.videoEndOverlay.url)
                return this.player.videoEndedOverlay.contentLoaded
                  ? void this.player.videoEndedOverlay.show()
                  : void this.player.videoEndedOverlay
                      .loadContent()
                      .then(function(e) {
                        return JSON.parse(e);
                      })
                      .then(function(t) {
                        e.player.videoEndedOverlay.setData(t), (e.player.videoEndedOverlay.contentLoaded = !0);
                      })
                      .then(function() {
                        0 !== e.player.startTimeFromSearchParams &&
                          e.player.startTimeFromSearchParams === e.player.video.currentTime &&
                          (e.player.isVASTComplete = !1),
                          e.player.videoEndedOverlay.overlayEndWrapper &&
                            e.player.playerState.state.getValue() !== l &&
                            (e.player.videoEndedOverlay.overlayEndWrapper &&
                              e.player.startTimeFromSearchParams !== e.player.video.currentTime &&
                              (e.player.videoEndedOverlay.overlayEndWrapper.show(),
                              e.player.isMobile || e.player.titleWrapper.hide()),
                            e.player.videoEndedOverlay.updateVideoData(),
                            e.player.videoEndedOverlay.refreshRelated());
                      })
                      .catch(function(t) {
                        if (
                          ((e.player.options.videoEndOverlay.enabled = !1),
                          e.player.log("VideoEndOverlay was switched off. Ads mode was turned on."),
                          !e.player.playerState.isAdvertise.getValue() &&
                            e.enabled &&
                            !1 === e.player.firstStart &&
                            e.player.playerState.state.getValue() !== c)
                        ) {
                          if (e.player.video.ended && e.player.options.videoEndOverlay.enabled) return;
                          e.render();
                        }
                      });
              if (
                !this.player.playerState.isAdvertise.getValue() &&
                this.enabled &&
                !1 === this.player.firstStart &&
                this.player.playerState.state.getValue() !== c
              ) {
                if (this.player.video.ended && this.player.options.videoEndOverlay.enabled) return;
                this.render();
              }
            }
          }),
          e
        );
      })(),
      Ne = (function() {
        function e(e) {
          var t = this;
          (this.player = e),
            (this.isRendered = !1),
            (this.player = e),
            this.player.video.addEventListener("pause", function() {
              return t.show();
            }),
            this.player.video.addEventListener("playing", function() {
              return t.hide();
            });
        }
        return (
          (e.prototype.render = function() {
            var e = this;
            if (!this.isRendered) {
              this.overlayWrapper = new i().create("div").addClass("video-play-overlay");
              var t = new i().create("div").addClass("overlay-play-button-wrapper"),
                r = new i().create("button").addClass("overlay-play-button");
              t.add(r),
                r.html(te.getHtml()),
                this.overlayWrapper.on("click", function(t) {
                  return e.closeAndPlay(t);
                }),
                this.overlayWrapper.add(t),
                this.player.container.add(this.overlayWrapper),
                (this.isRendered = !0);
            }
          }),
          (e.prototype.closeAndPlay = function(e) {
            this.player.chromecast.isCasting() || this.player.handlePlayPause(e);
          }),
          (e.prototype.show = function() {
            (this.player.ads.enabled && !this.player.firstStart) ||
              (this.player.vastHandler.isActive && this.player.playerState.currentTime.getValue()) ||
              this.render();
          }),
          (e.prototype.hide = function() {
            this.player.playerState.state.getValue() === l &&
              void 0 !== this.overlayWrapper &&
              this.overlayWrapper.remove();
          }),
          e
        );
      })(),
      Be = (function() {
        function e(e) {
          var t = this;
          (this.player = e),
            (this.videoData = []),
            (this.contentLoaded = !1),
            (this.activeTab = 0),
            (this.isRendered = !1),
            (this.amount = 0),
            (this.columns = 0),
            (this.rows = 0),
            (this.isCurrentTime = !1),
            (this.isOverlayWasHidden = !1),
            (this.updateVideoData = function() {
              t.getVideosAmount();
              for (
                var e = document.querySelectorAll(".related-list-wrapper"),
                  r = t.columns > 4 ? 4 : t.columns,
                  i = t.rows > 4 ? 4 : t.rows,
                  n = 0,
                  s = e.length;
                n < s;
                n++
              ) {
                (e[n].style.width = r * t.image.width + "px"),
                  (e[n].style.height = i * t.image.height + "px"),
                  e[n].parentNode.classList.add("end-body-thumbs"),
                  (e[n].parentNode.style.width = r * t.image.width + "px");
              }
            }),
            (this.refreshRelated = function() {
              if (t.videoData[0] && t.videoData[0].videos) {
                var e = t.videoData[0].videos,
                  r = (t.getVideosAmount(), t.getRelatedVideos(e)),
                  i = document.querySelector(".end-body");
                i && (i.innerHTML = t.renderEndBodyItem(r).getHtml()), t.updateVideoData();
              }
            }),
            (this.activeTab = this.player.options.videoEndOverlay.activeTab),
            (this.isRequestSent = !1),
            this.player.video.addEventListener("playing", function() {
              return t.hide();
            }),
            this.player.video.addEventListener("ended", function() {
              return t.show();
            }),
            this.player.video.addEventListener("timeupdate", function() {
              return t.contentPreloadListener();
            }),
            (this.image = this.player.options.videoEndOverlay.imageSize),
            (this.lastIndex = 0),
            (this.updateLink = this.debounce(this.updateLink, 0, !1));
        }
        return (
          (e.prototype.render = function() {
            document.querySelector(".video-player").getBoundingClientRect().height;
            (this.overlayEndWrapper = new i("div")
              .create("div")
              .addClass("video-end-overlay")
              .hide()),
              (this.overlayEndInner = new i("div").addClass("video-end-inner-wrapper")),
              (this.overlayEndHeader = new i("div").addClass("video-end-header")),
              (this.overlayEndBody = new i("div").addClass("video-end-body")),
              this.player.options.videoEndOverlay.enabled && this.player.container.add(this.overlayEndWrapper),
              this.endOverlayJSONRender();
          }),
          (e.prototype.setData = function(e) {
            e.forEach(function(e) {
              "Related Videos" === e.name && e.videos.reverse();
            }),
              (this.videoData = e),
              this.isRendered || (this.render(), this.player.vastHandler.isShown || (this.isRendered = !0)),
              this.player.video.ended && this.show();
          }),
          (e.prototype.setTab = function(e) {
            this.endHeaderButtons[this.activeTab].removeClass("active"),
              this.endHeaderButtons[e].addClass("active"),
              this.endBodyWrappers[this.activeTab].hide(),
              this.endBodyWrappers[e].show(),
              (this.activeTab = e);
          }),
          (e.prototype.closeAndPlay = function() {
            this.player.isReduced && (this.player.video.currentTime = this.player.reducedVideoStartTime),
              (this.isRendered = !1),
              this.player.playerState.state.next(l),
              this.hide(),
              this.player.play();
          }),
          (e.prototype.loadContent = function() {
            var e = this;
            return new Promise(function(t, r) {
              var i = new XMLHttpRequest();
              i.open("GET", e.player.options.videoEndOverlay.url),
                (i.onload = function() {
                  i.status >= 200 && i.status < 300 ? t(i.response) : r({ status: i.status, statusText: i.statusText });
                }),
                (i.onerror = function() {
                  r({ status: i.status, statusText: i.statusText });
                }),
                (e.isRequestSent = !0),
                i.send();
            });
          }),
          (e.prototype.show = function() {
            var e = this;
            (this.player.isReduced && this.player.video.currentTime === this.player.reducedVideoStartTime) ||
              (this.player.isVASTComplete
                ? (this.player.isVASTComplete = !1)
                : 0 !== this.player.video.currentTime &&
                  (!this.player.isBrandPrerollShown ||
                  (0 !== this.player.video.currentTime &&
                    this.player.video.currentTime !== this.player.getStartTime() &&
                    (this.player.isSourceVideoShown || this.player.video.currentTime !== this.player.video.duration))
                    ? (this.contentLoaded || this.isRequestSent
                        ? this.overlayEndWrapper &&
                          (this.overlayEndWrapper.show(),
                          (this.isRendered = !0),
                          this.player.isMobile || this.player.titleWrapper.hide())
                        : this.loadContent()
                            .then(function(e) {
                              return JSON.parse(e);
                            })
                            .then(function(t) {
                              e.setData(t), e.stopLoadingContent();
                            })
                            .catch(function(t) {
                              if (
                                ((e.player.options.videoEndOverlay.enabled = !1),
                                e.player.log("VideoEndOverlay was switched off. Ads mode was turned on."),
                                !e.player.playerState.isAdvertise.getValue() &&
                                  e.player.ads.enabled &&
                                  !1 === e.player.firstStart &&
                                  e.player.playerState.state.getValue() !== c)
                              ) {
                                if (e.player.video.ended && e.player.options.videoEndOverlay.enabled) return;
                                e.player.ads.render();
                              }
                            }),
                      this.updateVideoData(),
                      this.refreshRelated(),
                      (this.amount = this.getVideosAmount()))
                    : setTimeout(function() {
                        e.player.isBrandPrerollShown = !1;
                      }, 1e3)));
          }),
          (e.prototype.hide = function() {
            void 0 !== this.overlayEndWrapper &&
              (this.overlayEndWrapper.hide(), this.isOverlayWasHidden || this.player.titleWrapper.show());
          }),
          (e.prototype.hideOverlay = function() {
            (this.player.options.videoEndOverlay.enabled = !1),
              (this.player.ads.enabled = !1),
              this.player.vastHandler.renderPlayButtonOverlay(),
              this.player.vastHandler.setupPlayPauseEventsHandler(),
              (this.isOverlayWasHidden = !0),
              this.hide(),
              this.player.titleWrapper.hide(),
              this.player.copyLinkWrapper.hide(),
              this.endHeaderButtons[this.activeTab].removeClass("active"),
              (this.activeTab = 0),
              this.setTab(this.activeTab);
          }),
          (e.prototype.endOverlayJSONRender = function() {
            var e = this;
            (this.endHeaderButtons = []),
              (this.endBodyWrappers = []),
              this.videoData.map(function(t) {
                e.endHeaderButtons.push(e.renderEndHeaderItem(t.name)),
                  e.endBodyWrappers.push(e.renderEndBodyItem(t.videos));
              }),
              this.endHeaderButtons.push(this.renderEndHeaderItem("shareTabName")),
              this.endHeaderButtons.push(this.renderHideHeaderItem("hide")),
              this.endHeaderButtons.push(this.renderEndHeaderCloseItem()),
              this.endBodyWrappers.push(this.renderShareTab()),
              this.endBodyWrappers.push(this.renderReplayTab()),
              this.overlayEndHeader.addArray(this.endHeaderButtons),
              this.overlayEndBody.addArray(this.endBodyWrappers),
              this.overlayEndInner.addArray([this.overlayEndHeader, this.overlayEndBody]),
              this.overlayEndWrapper.add(this.overlayEndInner),
              this.setTab(this.activeTab),
              this.endHeaderButtons.forEach(function(t, r) {
                return t.on("click", function(t) {
                  r < e.endHeaderButtons.length - 1 && e.setTab(r);
                });
              }),
              (this.refreshButton = document.querySelector(".refresh-related-button")),
              this.refreshButton.addEventListener("click", this.refreshRelated),
              window.addEventListener("resize", function() {
                var t = e.getVideosAmount();
                e.amount !== t && (e.updateVideoData(), e.refreshRelated(), (e.amount = t));
              }),
              (this.hideButton = document.querySelector(".hide-btn")),
              this.hideButton.addEventListener("click", function() {
                return e.hideOverlay();
              }),
              (this.closeButton = document.querySelector(".end-btn-close")),
              this.closeButton.addEventListener("click", function() {
                e.close();
              });
          }),
          (e.prototype.close = function() {
            this.hide(),
              (this.player.isReduced
              ? this.player.reducedVideoStartTime + this.player.reducedVideoDuration <= this.player.video.currentTime
              : this.player.video.duration - this.player.video.currentTime == 0)
                ? this.closeAndPlay()
                : (this.player.play(), (this.isRendered = !1));
          }),
          (e.prototype.getVideosAmount = function() {
            var e = document.querySelector(".video-end-inner-wrapper");
            if (!e) return 0;
            var t = e.getBoundingClientRect(),
              r = t.width - 20,
              i = t.height - 70;
            return (
              (this.columns = Math.floor(r / this.image.width)),
              (this.rows = Math.floor(i / this.image.height)),
              (this.columns = this.columns > 4 ? 4 : this.columns),
              (this.rows = this.rows > 4 ? 4 : this.rows),
              this.columns * this.rows
            );
          }),
          (e.prototype.getRelatedVideos = function(e) {
            for (var t = [], r = 0, i = this.getVideosAmount(); r < i; r++)
              this.lastIndex >= e.length && (this.lastIndex = 0), t.push(e[this.lastIndex]), this.lastIndex++;
            return t;
          }),
          (e.prototype.renderEndHeaderItem = function(e) {
            return "Related Videos" === e
              ? new i("button")
                  .addClass("end-btn")
                  .addArray([
                    new i("span").text(this.player.lang.get(e)),
                    new i("span").addClass("refresh-related-button").html(re.getHtml())
                  ])
              : new i("button").addClass("end-btn").text(this.player.lang.get(e));
          }),
          (e.prototype.renderHideHeaderItem = function(e) {
            return new i("button")
              .addClass("end-btn")
              .addClass("hide-btn")
              .text(this.player.lang.get(e));
          }),
          (e.prototype.renderEndHeaderCloseItem = function() {
            return new i("span").addClass("end-btn-close").html(ie.getHtml());
          }),
          (e.prototype.renderEndBodyItem = function(e) {
            var t = this,
              r = e.map(function(e) {
                if (e && e.thumbSrc) return t.renderVideoItem(e);
              });
            return new i("div")
              .addClass("end-body")
              .hide()
              .addList(r, "related-list-wrapper");
          }),
          (e.prototype.renderVideoItem = function(e) {
            return new i("div")
              .addClass("end-video-wrapper")
              .style("backgroundImage", 'url("' + (e.thumbSrc || "") + '")')
              .addArray([
                new i("p").addClass("end-thumb-name").text(e.videoName || ""),
                new i("div").addClass("end-video-link-wrapper").add(
                  new i("a")
                    .attr("href", e.videoLink || "")
                    .attr("target", "_parent")
                    .add(new i("div").addClass("end-video-link-icon").html(te.getHtml()))
                )
              ]);
          }),
          (e.prototype.renderReplayTab = function() {
            var e = this,
              t = new i("div").addClass("end-replay-button-wrapper"),
              r = new i("p").text(this.player.lang.get("replayTabText")),
              n = new i("button").addClass("replay-button");
            return (
              t.addArray([r, n]),
              n.html(re.getHtml()),
              n.on("click", function() {
                return e.closeAndPlay();
              }),
              new i("div")
                .addClass("end-body")
                .hide()
                .add(t)
            );
          }),
          (e.prototype.renderShareTab = function() {
            var e = this,
              t = new i("div").addClass("end-share-wrapper"),
              r = new i("div").addClass(this.player.options.videoEndOverlay.shareClass),
              n = new i("textarea")
                .addClass("video-end-copy-link-area")
                .text(this.player.options.copyUrl || location.href)
                .on("click", function(e) {
                  return e.target.select();
                }),
              s = new i("div").addClass("video-end-copy-checkbox-container").addArray([
                new i("label")
                  .text(this.player.lang.get("fromCurrentTime"))
                  .addClass("video-end-copy-checkbox-wrapper")
                  .addArray([
                    new i("input").attr("type", "checkbox"),
                    new i("span").addClass("video-end-copy-checkbox-mark")
                  ])
                  .on("click", function(t) {
                    return e.updateLink();
                  })
              ]),
              a = new i("div")
                .addClass("video-end-copy")
                .text(this.player.lang.get("copyLink"))
                .on("click", function(t) {
                  return e.copyLink();
                }),
              o = new i("div").addClass("video-end-copy-container").addArray([s, a]);
            return (
              t.addArray([r, n, o]),
              new i("div")
                .addClass("end-body")
                .hide()
                .add(t)
            );
          }),
          (e.prototype.contentPreloadListener = function() {
            var e = this;
            this.contentLoaded ||
              this.player.playerState.isAdvertise.getValue() ||
              (this.player.video.duration - this.player.video.currentTime <= 20 &&
                this.loadContent()
                  .then(function(e) {
                    return JSON.parse(e);
                  })
                  .then(function(t) {
                    e.setData(t);
                  })
                  .then(function() {
                    e.stopLoadingContent();
                  })
                  .catch(function() {
                    (e.player.options.videoEndOverlay.enabled = !1),
                      e.player.log("VideoEndOverlay was switched off. Ads mode was turned on."),
                      e.stopLoadingContent();
                  }));
          }),
          (e.prototype.stopLoadingContent = function() {
            var e = this;
            (this.contentLoaded = !0),
              this.player.video.removeEventListener("timeupdate", function() {
                return e.contentPreloadListener();
              });
          }),
          (e.prototype.updateLink = function() {
            this.isCurrentTime = !this.isCurrentTime;
            var e = document.querySelector(".video-end-copy-link-area");
            if (this.isCurrentTime) {
              var t = "t=" + parseInt(this.player.video.currentTime);
              if ("function" == typeof URLSearchParams) {
                var r = new URLSearchParams(location.search);
                r.set("t", parseInt(this.player.video.currentTime).toString()), (t = r.toString());
              }
              e.value = (this.player.options.copyUrl || location.origin + location.pathname) + "?" + t;
            } else e.value = this.player.options.copyUrl || location.href;
          }),
          (e.prototype.debounce = function(e, t, r) {
            var i;
            return function() {
              var n = this,
                s = arguments,
                a = function() {
                  (i = null), r || e.apply(n, s);
                },
                o = r && !i;
              clearTimeout(i), (i = setTimeout(a, t)), o && e.apply(n, s);
            };
          }),
          (e.prototype.copyLink = function() {
            document.querySelector(".video-end-copy-link-area").select(), document.execCommand("copy");
          }),
          e
        );
      })(),
      Ue = r(1),
      He = (function() {
        function e(e) {
          (this.player = e),
            (this.iconIsShowing = !1),
            (this.description = ""),
            (this.player = e),
            this.setupKeyEvents(),
            this.renderIconOverlay();
        }
        return (
          (e.prototype.renderIconOverlay = function() {
            (this.overlayWrapper = new i()
              .create("div")
              .addClass("video-play-overlay")
              .hide()),
              (this.iconWrapper = new i().create("div").addClass("overlay-play-button-wrapper")),
              (this.icon = new i()
                .create("div")
                .addClass("overlay-play-button")
                .addClass("video-play-overlay-icon")),
              (this.descriptionWrapper = new i()
                .create("div")
                .addClass("overlay-icon-description")
                .hide()),
              (this.descriptionSpan = new i().create("span")),
              this.iconWrapper.add(this.icon),
              this.descriptionSpan.text(this.description),
              this.descriptionWrapper.add(this.descriptionSpan),
              this.overlayWrapper.add(this.iconWrapper),
              this.overlayWrapper.add(this.descriptionWrapper),
              this.player.container.add(this.overlayWrapper);
          }),
          (e.prototype.setIcon = function(e) {
            switch (e) {
              case "down":
                this.icon.html(le.getHtml());
                break;
              case "up":
                this.icon.html(ue.getHtml());
                break;
              case "left":
                this.icon.html(ae.getHtml());
                break;
              case "right":
                this.icon.html(oe.getHtml());
                break;
              default:
                this.icon.html("");
            }
          }),
          (e.prototype.showIcon = function() {
            var e = this;
            "" === this.description ? this.descriptionWrapper.hide() : this.descriptionWrapper.show(),
              this.iconIsShowing ||
                ((this.iconIsShowing = !0),
                this.overlayWrapper.show(),
                this.overlayWrapper.style("opacity", "1"),
                this.overlayWrapper.style("transform", "scale(1.0)"),
                setTimeout(function() {
                  e.hideIcon();
                }, 400));
          }),
          (e.prototype.hideIcon = function() {
            var e = this;
            this.overlayWrapper.style("opacity", "0"),
              this.overlayWrapper.style("transform", "scale(1.2)"),
              setTimeout(function() {
                e.overlayWrapper.hide(),
                  e.overlayWrapper.style("transform", "scale(1.0)"),
                  (e.iconIsShowing = !1),
                  setTimeout(function() {
                    e.overlayWrapper.style("transform", "scale(1.2)");
                  }, 200);
              }, 200);
          }),
          (e.prototype.setupKeyEvents = function() {
            var e = this,
              t = !1,
              r = !1;
            this.player.containerWrapper.on("mouseover", function(e) {
              r || (r = !0);
            }),
              this.player.containerWrapper.on("mouseleave", function(e) {
                r && (r = !1);
              }),
              document.body.addEventListener("click", function(e) {
                t = r;
              }),
              document.activeElement.addEventListener("keydown", function(r) {
                t && e.handleKeySwitch(r);
              });
          }),
          (e.prototype.handleKeySwitch = function(e) {
            switch (e.keyCode) {
              case Ue.KEY_SPACE:
                e.preventDefault(), this.player.showControlsBar(4e3), this.player.handlePlayPauseOnKey();
                break;
              case Ue.KEY_F:
                e.preventDefault(),
                  this.player.showControlsBar(4e3),
                  this.player.fullscreen.handleFullscreen(),
                  this.player.fullscreen.isFullScreen();
                break;
              case Ue.KEY_C:
              case Ue.KEY_W:
                break;
              case Ue.KEY_M:
                e.preventDefault(), this.player.showControlsBar(4e3), this.player.volume.setMuteByKey();
                break;
              case Ue.KEY_UP:
                e.preventDefault(),
                  this.player.showControlsBar(4e3),
                  this.player.volume.volumeIncrease(),
                  (this.description = Math.round(100 * this.player.video.volume) + "%"),
                  this.descriptionSpan.text(this.description),
                  this.setIcon("up"),
                  this.showIcon();
                break;
              case Ue.KEY_DOWN:
                e.preventDefault(),
                  this.player.showControlsBar(4e3),
                  this.player.volume.volumeDecrease(),
                  (this.description = Math.round(100 * this.player.video.volume) + "%"),
                  this.descriptionSpan.text(this.description),
                  this.setIcon("down"),
                  this.showIcon();
                break;
              case Ue.KEY_LEFT:
                e.preventDefault(),
                  this.player.showControlsBar(4e3),
                  this.player.progressBar.videoTimeBackwards(),
                  (this.description = ""),
                  this.descriptionSpan.text(this.description),
                  this.setIcon("left"),
                  this.showIcon();
                break;
              case Ue.KEY_RIGHT:
                e.preventDefault(),
                  this.player.showControlsBar(4e3),
                  this.player.progressBar.videoTimeForwards(),
                  (this.description = ""),
                  this.descriptionSpan.text(this.description),
                  this.setIcon("right"),
                  this.showIcon();
                break;
              case Ue.KEY_PAGE_UP:
                e.preventDefault(), this.player.showControlsBar(4e3), this.player.playbackRate.videoSpeedUp();
                break;
              case Ue.KEY_PAGE_DOWN:
                e.preventDefault(), this.player.showControlsBar(4e3), this.player.playbackRate.videoSpeedDown();
            }
          }),
          (e.prototype.handleKeyMessages = function(e, t) {
            switch ((void 0 === t && (t = null), e)) {
              case "rightKeyPushed":
                this.player.log("Key Pushed: " + t);
                break;
              case "notDefinedKey":
                this.player.log("Not useful key pressed.");
                break;
              case "isMaxed":
                this.player.log("Already maxed attribute: " + t);
                break;
              case "isMinimized":
                this.player.log("Already minimized attribute: " + t);
                break;
              case "stateChange":
                this.player.log("New state: " + t);
                break;
              case "stateAlready":
                this.player.log("Already in state: " + t);
                break;
              default:
                this.player.log("You broke it. Unknown KeyHandler Error.");
            }
          }),
          e
        );
      })(),
      Ve = (function() {
        var e =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function(e, t) {
              e.__proto__ = t;
            }) ||
          function(e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          };
        return function(t, r) {
          function i() {
            this.constructor = t;
          }
          e(t, r), (t.prototype = null === r ? Object.create(r) : ((i.prototype = r.prototype), new i()));
        };
      })(),
      Ke = (function(e) {
        function t(t) {
          var r = e.call(this, t) || this;
          return (
            (r.player = t),
            (r.player = t),
            (r.localStorageKey = "html5PlayerWideScreen"),
            (r.config = r.player.options.widescreen),
            r.config.enabled && ((r.active = r.getDefaultState()), r.render(), r.isLogged() && r.setupEvents()),
            r
          );
        }
        return (
          Ve(t, e),
          (t.prototype.render = function() {
            (this.buttonWrapper = new i()
              .create("div")
              .addClass("widescreen-button-wrapper")
              .addClass("tooltip-button")),
              (this.button = new i().create("button").addClass("video-widescreen")),
              this.setState(),
              this.buttonWrapper.add(this.button),
              this.config.handleAction(this.active);
          }),
          (t.prototype.setupEvents = function() {
            var e = this;
            this.buttonWrapper.on("click", function() {
              e.handleToggle(), e.config.handleAction(e.active);
            }),
              this.player.playerState.isCasting.subscribe(function(t) {
                t ? e.buttonWrapper.hide() : e.buttonWrapper.show();
              }),
              this.player.playerState.isFullscreen.subscribe(function(t) {
                t ? e.buttonWrapper.hide() : e.buttonWrapper.show();
              });
          }),
          (t.prototype.setState = function() {
            this.button.html(this.active ? ne.getHtml() : se.getHtml()),
              this.buttonWrapper.attr(
                "data-tooltip",
                this.player.lang.get(this.active ? "widescreenOff" : "widescreenOn")
              ),
              this.player.playerState.isWidescreen.next(this.active);
          }),
          (t.prototype.isLogged = function() {
            return -1 !== document.cookie.indexOf("uLogged");
          }),
          t
        );
      })(de),
      We = (function() {
        function e() {
          (this.prefix = "_playerErrors"), (this.timestamp = +new Date()), (this.errors = {});
        }
        return (
          (e.prototype.get = function() {
            try {
              var e = JSON.parse(localStorage.getItem(this.prefix));
              return (this.errors = this.check(e)), this.errors;
            } catch (e) {
              return console.log("[PLAYER LOG]", "LocalStorage is unavailable."), null;
            }
          }),
          (e.prototype.check = function(e) {
            var t = this,
              r = {};
            return (
              Object.keys(e).forEach(function(i) {
                e[i] > t.timestamp && (r[i] = e[i]);
              }),
              r
            );
          }),
          (e.prototype.isReported = function(e) {
            return (0 | this.errors[e.errorCode]) > this.timestamp;
          }),
          (e.prototype.add = function(e) {
            this.errors[e.errorCode] = this.timestamp + 36e5;
          }),
          (e.prototype.update = function() {
            try {
              localStorage.setItem(this.prefix, JSON.stringify(this.errors));
            } catch (e) {
              console.log("[PLAYER LOG]", "LocalStorage is unavailable.");
            }
          }),
          e
        );
      })(),
      Ge = (function() {
        function e() {
          this.localStorageAvailable = "undefined" != typeof Storage;
        }
        return (
          (e.prototype.save = function(e, t, r) {
            this.localStorageAvailable && localStorage.setItem(e, t), r && r(t);
          }),
          (e.prototype.load = function(e, t, r) {
            if (r) return this.save(e, t), t;
            if (this.localStorageAvailable && !r) {
              var i = localStorage.getItem(e);
              return null === i ? t : this._parseValue(t, i);
            }
            return t;
          }),
          (e.prototype._parseValue = function(e, t) {
            try {
              return "number" == typeof e ? JSON.parse(t) : "boolean" == typeof e ? !0 === JSON.parse(t) : t;
            } catch (t) {
              return e;
            }
          }),
          e
        );
      })(),
      je = (function() {
        function e(e) {
          (this.player = e), (this.touchSeekDirection = null), (this.fullscreenTimer = +new Date()), this.render();
        }
        return (
          (e.prototype.render = function() {
            (this.wrapper = new i().create("div").addClass("gestures-events-overlay")),
              this.player.container.add(this.wrapper),
              this.setupEvents();
          }),
          (e.prototype.setupEvents = function() {
            var e = this;
            (this.wrapper.clickCount = 0),
              this.wrapper.on("click", function(t) {
                return e.handleClick(t);
              }),
              this.wrapper.on("dblclick", function(t) {
                return e.handleMultiClick(t, 1);
              });
          }),
          (e.prototype.handleClick = function(e) {
            var t = this;
            this.player.settings.settingsWrapper.isVisible() ||
              (clearTimeout(this.wrapper.clickTimeout),
              this.wrapper.clickCount++,
              (this.wrapper.clickTimeout = setTimeout(function() {
                1 === t.wrapper.clickCount ? t.handleSingleClick(e) : t.handleMultiClick(e, t.wrapper.clickCount),
                  (t.wrapper.clickCount = 0);
              }, 300)),
              this.wrapper.clickCount > 1 && this.handleMultiClickProgress(e, this.wrapper.clickCount));
          }),
          (e.prototype.handleMultiClickProgress = function(e, t) {
            this.player.touchModeEnabled && this.touchSeekPreview(e, t);
          }),
          (e.prototype.handleMultiClick = function(e, t) {
            if (this.player.touchModeEnabled) this.touchSeek(t), (this.touchSeekDirection = null);
            else {
              var r = +new Date();
              if (r - this.fullscreenTimer < 1e3) return;
              (this.fullscreenTimer = r), this.player.fullscreen.handleFullscreen();
            }
          }),
          (e.prototype.handleSingleClick = function(e) {
            this.player.touchModeEnabled
              ? this.player.container.hasClass("mouse-over")
                ? this.player.hideControlsBar()
                : this.player.showControlsBar(4e3)
              : this.player.handlePlayPause();
          }),
          (e.prototype.touchSeekPreview = function(e, t) {
            var r = this.wrapper.get().offsetWidth / 2,
              i = e.clientX < r ? "left" : "right";
            null === this.touchSeekDirection || this.touchSeekDirection === i
              ? this.renderTouchSeekPreview(t, i)
              : (this.touchSeek(t), (this.wrapper.clickCount = 0)),
              (this.touchSeekDirection = i);
          }),
          (e.prototype.touchSeek = function(e) {
            this.player.seek(this.getSeekTime(e, this.touchSeekDirection));
            try {
              this.touchSeekPreviewElement.remove(), (this.touchSeekPreviewElement = null);
            } catch (e) {
              console.log(e);
            }
          }),
          (e.prototype.getSeekTime = function(e, t) {
            var r = 10 * (e - 1);
            return "left" === t && (r *= -1), r;
          }),
          (e.prototype.renderTouchSeekPreview = function(e, t) {
            this.touchSeekPreviewElement
              ? this.touchSeekPreviewElementText.text(this.getSeekTime(e, t) + " " + this.player.lang.get("seconds"))
              : ((this.touchSeekPreviewElement = new i().create("div").addClass("touch-seek-preview")),
                this.wrapper.add(this.touchSeekPreviewElement),
                "right" === t
                  ? this.touchSeekPreviewElement.addClass("right")
                  : this.touchSeekPreviewElement.removeClass("right"),
                (this.touchSeekPreviewElementIconsWrapper = new i().create("div").addClass("icons-wrapper")),
                (this.touchSeekPreviewElementIconFirst = new i().create("div").addClass("icon-single")),
                (this.touchSeekPreviewElementIconSecond = new i().create("div").addClass("icon-single")),
                (this.touchSeekPreviewElementIconThird = new i().create("div").addClass("icon-single")),
                this.touchSeekPreviewElementIconFirst.html(te.getHtml()),
                this.touchSeekPreviewElementIconSecond.html(te.getHtml()),
                this.touchSeekPreviewElementIconThird.html(te.getHtml()),
                this.touchSeekPreviewElementIconsWrapper
                  .add(this.touchSeekPreviewElementIconFirst)
                  .add(this.touchSeekPreviewElementIconSecond)
                  .add(this.touchSeekPreviewElementIconThird),
                (this.touchSeekPreviewElementText = new i()
                  .create("span")
                  .text(this.getSeekTime(e, t) + " " + this.player.lang.get("seconds"))),
                this.touchSeekPreviewElement
                  .add(this.touchSeekPreviewElementIconsWrapper)
                  .add(this.touchSeekPreviewElementText));
          }),
          e
        );
      })(),
      Ye = (function() {
        function e() {}
        return (
          (e.prototype.get = function(e) {
            return new Promise(function(t, r) {
              var i = new XMLHttpRequest();
              i.open("GET", e),
                (i.onload = function() {
                  i.status >= 200 && i.status < 300 ? t(i.response) : r({ status: i.status, statusText: i.statusText });
                }),
                (i.onerror = function() {
                  r({ status: i.status, statusText: i.statusText });
                }),
                i.send();
            });
          }),
          (e.prototype.post = function(e) {
            return new Promise(function(t, r) {
              var i = new XMLHttpRequest();
              i.open("POST", e.url),
                (i.onload = function() {
                  i.status >= 200 && i.status < 300 ? t(i.response) : r({ status: i.status, statusText: i.statusText });
                }),
                (i.onerror = function() {
                  r({ status: i.status, statusText: i.statusText });
                }),
                e.headers &&
                  Object.keys(e.headers).forEach(function(t) {
                    i.setRequestHeader(t, e.headers[t]);
                  });
              var n,
                s = e.params;
              s &&
                "object" == typeof s &&
                (n = Object.keys(s)
                  .map(function(e) {
                    return encodeURIComponent(e) + "=" + encodeURIComponent(s[e]);
                  })
                  .join("&")),
                i.send(n);
            });
          }),
          e
        );
      })(),
      qe = r(2),
      ze = r(19),
      Xe = r(20),
      Qe = r(21),
      Je = { en: qe, ru: ze, es: Xe, de: Qe },
      $e = (function() {
        function e(e) {
          (this.texts = {}), this.setTextSource(e);
        }
        return (
          (e.prototype.get = function(e) {
            return this.texts[e] || e;
          }),
          (e.prototype.setTextSource = function(e) {
            var t = Je[e] || qe;
            this.texts = g(qe, t);
          }),
          e
        );
      })(),
      Ze = function(e) {
        var t = document.createElement("textarea");
        (t.value = e),
          document.body.appendChild(t),
          t.select(),
          document.execCommand("copy"),
          document.body.removeChild(t);
      },
      et = (function() {
        function e(e) {
          (this.player = e), (this.isActive = !1), this.render();
        }
        return (
          (e.prototype.render = function() {
            this.renderContextMenu(), this.renderKeyboardHelp(), this.setupEvents();
          }),
          (e.prototype.renderContextMenu = function() {
            (this.contextWrapper = new i("div").addClass("context-menu-wrapper").hide()),
              (this.contextInnerWrapper = new i("div").addClass("context-inner-wrapper")),
              (this.contextLinksWrapper = new i("div").addClass("context-links-wrapper")),
              (this.copyVideoUrlButton = new i("button").text(this.player.lang.get("copyVideoUrl"))),
              (this.copyVideoUrlCurrentButton = new i("button").text(this.player.lang.get("copyVideoUrlCurrentTime"))),
              (this.copyEmbedButton = new i("button").text(this.player.lang.get("copyEmbedCode"))),
              (this.keyboardHelpButton = new i("button").text(this.player.lang.get("keyboardHelp"))),
              this.player.options.copyEmbedUrl || (this.copyEmbedButton = null),
              this.contextLinksWrapper.addList([
                this.copyVideoUrlButton,
                this.copyVideoUrlCurrentButton,
                this.copyEmbedButton,
                this.keyboardHelpButton
              ]),
              (this.versionWrapper = new i("div").addClass("player-version-wrapper")),
              (this.versionText = new i("p").text(this.player.lang.get("playerVersion") + ": " + this.player.version)),
              this.versionWrapper.add(this.versionText),
              this.contextInnerWrapper.addArray([this.contextLinksWrapper, this.versionWrapper]),
              this.contextWrapper.add(this.contextInnerWrapper),
              this.player.container.add(this.contextWrapper);
          }),
          (e.prototype.renderKeyboardHelp = function() {
            (this.keyboardHelpWrapper = new i("div").addClass("keyhelp-wrapper").hide()),
              (this.keyboardHelpHeader = new i("div").addClass("keyhelp-header-wrapper")),
              (this.keyboardHelpHeaderText = new i("p").text("" + this.player.lang.get("keyHelpHeader"))),
              (this.keyboardHelpCloseWrapper = new i("div").addClass("keyhelp-close")),
              this.keyboardHelpCloseWrapper.addArray([new i("span"), new i("span")]),
              this.keyboardHelpHeader.addArray([this.keyboardHelpHeaderText, this.keyboardHelpCloseWrapper]),
              (this.keyCodeListWrapper = new i("div").addClass("keyhelp-inner-wrapper")),
              this.keyCodeListWrapper
                .addList([
                  this.renderKey("SPACE", "keyHelpSpace"),
                  this.renderKey("F", "keyHelpFKey"),
                  this.renderKey("M", "keyHelpMKey"),
                  this.renderKey("↑", "keyHelpUpKey"),
                  this.renderKey("↓", "keyHelpDownKey")
                ])
                .addList([
                  this.renderKey("←", "keyHelpLeftKey"),
                  this.renderKey("→", "keyHelpRightKey"),
                  this.renderKey("Page Up", "keyHelpPUpKey"),
                  this.renderKey("Page Down", "keyHelpPDownKey")
                ]),
              this.keyboardHelpWrapper.addArray([this.keyboardHelpHeader, this.keyCodeListWrapper]),
              this.player.container.add(this.keyboardHelpWrapper);
          }),
          (e.prototype.renderKey = function(e, t) {
            return [
              new i("div").addClass("key-holder").add(new i("p").text(e)),
              new i("p").text(this.player.lang.get(t))
            ];
          }),
          (e.prototype.setupEvents = function() {
            var e = this;
            document.addEventListener("click", function() {
              return e.closeContextMenu();
            }),
              this.contextWrapper.on("click", function(e) {
                return e.stopPropagation();
              }),
              this.player.containerWrapper.on("contextmenu", function(t) {
                "textarea" === t.target.type || "input" === t.target.type || e.player.touchModeEnabled
                  ? e.closeContextMenu()
                  : e.openContextMenu(t);
              }),
              this.keyboardHelpButton.on("click", function() {
                return e.openKeyHelp();
              }),
              this.keyboardHelpCloseWrapper.on("click", function() {
                return e.closeKeyHelp();
              }),
              this.copyVideoUrlButton.on("click", function() {
                Ze(e.player.options.copyUrl || location.href), e.closeContextMenu();
              }),
              this.copyVideoUrlCurrentButton.on("click", function() {
                Ze(e.getCurrentCopyLink()), e.closeContextMenu();
              }),
              this.copyEmbedButton &&
                this.copyEmbedButton.on("click", function() {
                  Ze(e.player.options.copyEmbedUrl), e.closeContextMenu();
                });
          }),
          (e.prototype.closeContextMenu = function() {
            this.contextWrapper.hide();
          }),
          (e.prototype.getCurrentCopyLink = function() {
            var e = "t=" + parseInt(this.player.video.currentTime);
            if ("function" == typeof URLSearchParams) {
              var t = new URLSearchParams(location.search);
              t.set("t", parseInt(this.player.video.currentTime).toString()), (e = t.toString());
            }
            return (this.player.options.copyUrl || location.origin + location.pathname) + "?" + e;
          }),
          (e.prototype.openContextMenu = function(e) {
            if (this.player.videoEndedOverlay) {
              if (
                this.player.videoEndedOverlay.isRendered ||
                (this.player.vastHandler.isActive && this.player.video.currentTime > 0)
              )
                return;
            } else if (this.player.vastHandler.isActive && this.player.video.currentTime > 0) return;
            (this.isActive = !0),
              (this.cursor_offset_top = Math.ceil(e.clientY - this.player.container.get().getBoundingClientRect().top)),
              (this.cursor_offset_bottom = -(
                Math.ceil(e.clientY - this.player.container.get().getBoundingClientRect().top) -
                this.player.containerWrapper.get().offsetHeight
              )),
              (this.cursor_offset_left = Math.ceil(
                e.clientX - this.player.container.get().getBoundingClientRect().left
              )),
              (this.cursor_offset_right = -(
                Math.ceil(e.clientX - this.player.container.get().getBoundingClientRect().left) -
                this.player.containerWrapper.get().offsetWidth
              )),
              this.contextWrapper.show(),
              this.contextWrapper.style("top", this.cursor_offset_top + "px"),
              this.contextWrapper.style("left", this.cursor_offset_left + "px"),
              this.cursor_offset_left < this.cursor_offset_right
                ? (this.contextInnerWrapper.style("left", "0"), this.contextInnerWrapper.style("right", null))
                : (this.contextInnerWrapper.style("left", null), this.contextInnerWrapper.style("right", "0")),
              this.cursor_offset_top < this.cursor_offset_bottom
                ? (this.contextInnerWrapper.style("top", "0"), this.contextInnerWrapper.style("bottom", null))
                : (this.contextInnerWrapper.style("top", null), this.contextInnerWrapper.style("bottom", "0")),
              e.preventDefault();
          }),
          (e.prototype.closeKeyHelp = function() {
            this.contextWrapper.hide(), this.keyboardHelpWrapper.hide();
          }),
          (e.prototype.openKeyHelp = function() {
            this.contextWrapper.hide(), this.keyboardHelpWrapper.show();
          }),
          e
        );
      })(),
      tt = {
        hls: !1,
        width: 720,
        height: 405,
        maxPlayerHeight: 600,
        minPlayerHeight: 350,
        reduceVideo: { enabled: !1, startTime: 0, duration: 300 },
        sources: { hls: [], mp4: [] },
        poster: "",
        title: "",
        videoEndOverlay: {
          imageSize: { width: 240, height: 135 },
          activeTab: 0,
          enabled: !1,
          url: "",
          content: function(e) {},
          shareClass: ""
        },
        thumbBase: "",
        imagePreview: { enabled: !0, active: !0, handleSave: function(e) {} },
        autoplay: { enabled: !0, active: !1, handleSave: function(e) {} },
        widescreen: { enabled: !1, active: !1, handleAction: function(e) {}, handleSave: function(e) {} },
        interstitialAd: { enabled: !1, url1: "", url2: "" },
        thumbsCount: 15,
        chromeCastEnabled: !0,
        logo: "",
        logoLink: "",
        language: "en",
        copyUrl: "",
        copyEmbedUrl: "",
        startTime: 0,
        brandPreroll: { enabled: !1, url: "", viewLimit: 0 },
        prerollAd: { enabled: !1, vastURL: "", firstRoll: 1, rollPeriod: 1, skipDelay: 5 },
        detailsButton: { enabled: !1, selector: "" },
        onEndCallback: function() {},
        showCopyLink: !1,
        debugUrl: ""
      },
      rt = r(22),
      it = function(e, t) {
        return (it =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function(e, t) {
              e.__proto__ = t;
            }) ||
          function(e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          })(e, t);
      };
    function nt(e, t) {
      function r() {
        this.constructor = e;
      }
      it(e, t), (e.prototype = null === t ? Object.create(t) : ((r.prototype = t.prototype), new r()));
    }
    function st(e) {
      return "function" == typeof e;
    }
    var at = !1,
      ot = {
        Promise: void 0,
        set useDeprecatedSynchronousErrorHandling(e) {
          e && new Error().stack;
          at = e;
        },
        get useDeprecatedSynchronousErrorHandling() {
          return at;
        }
      };
    function lt(e) {
      setTimeout(function() {
        throw e;
      }, 0);
    }
    var ut = {
        closed: !0,
        next: function(e) {},
        error: function(e) {
          if (ot.useDeprecatedSynchronousErrorHandling) throw e;
          lt(e);
        },
        complete: function() {}
      },
      dt = (function() {
        return (
          Array.isArray ||
          function(e) {
            return e && "number" == typeof e.length;
          }
        );
      })();
    var ct = (function() {
        function e(e) {
          return (
            Error.call(this),
            (this.message = e
              ? e.length +
                " errors occurred during unsubscription:\n" +
                e
                  .map(function(e, t) {
                    return t + 1 + ") " + e.toString();
                  })
                  .join("\n  ")
              : ""),
            (this.name = "UnsubscriptionError"),
            (this.errors = e),
            this
          );
        }
        return (e.prototype = Object.create(Error.prototype)), e;
      })(),
      ht = (function() {
        function e(e) {
          (this.closed = !1),
            (this._parentOrParents = null),
            (this._subscriptions = null),
            e && ((this._ctorUnsubscribe = !0), (this._unsubscribe = e));
        }
        return (
          (e.prototype.unsubscribe = function() {
            var t;
            if (!this.closed) {
              var r,
                i = this,
                n = i._parentOrParents,
                s = i._ctorUnsubscribe,
                a = i._unsubscribe,
                o = i._subscriptions;
              if (((this.closed = !0), (this._parentOrParents = null), (this._subscriptions = null), n instanceof e))
                n.remove(this);
              else if (null !== n)
                for (var l = 0; l < n.length; ++l) {
                  n[l].remove(this);
                }
              if (st(a)) {
                s && (this._unsubscribe = void 0);
                try {
                  a.call(this);
                } catch (e) {
                  t = e instanceof ct ? ft(e.errors) : [e];
                }
              }
              if (dt(o)) {
                l = -1;
                for (var u = o.length; ++l < u; ) {
                  var d = o[l];
                  if (null !== (r = d) && "object" == typeof r)
                    try {
                      d.unsubscribe();
                    } catch (e) {
                      (t = t || []), e instanceof ct ? (t = t.concat(ft(e.errors))) : t.push(e);
                    }
                }
              }
              if (t) throw new ct(t);
            }
          }),
          (e.prototype.add = function(t) {
            var r = t;
            if (!t) return e.EMPTY;
            switch (typeof t) {
              case "function":
                r = new e(t);
              case "object":
                if (r === this || r.closed || "function" != typeof r.unsubscribe) return r;
                if (this.closed) return r.unsubscribe(), r;
                if (!(r instanceof e)) {
                  var i = r;
                  (r = new e())._subscriptions = [i];
                }
                break;
              default:
                throw new Error("unrecognized teardown " + t + " added to Subscription.");
            }
            var n = r._parentOrParents;
            if (null === n) r._parentOrParents = this;
            else if (n instanceof e) {
              if (n === this) return r;
              r._parentOrParents = [n, this];
            } else {
              if (-1 !== n.indexOf(this)) return r;
              n.push(this);
            }
            var s = this._subscriptions;
            return null === s ? (this._subscriptions = [r]) : s.push(r), r;
          }),
          (e.prototype.remove = function(e) {
            var t = this._subscriptions;
            if (t) {
              var r = t.indexOf(e);
              -1 !== r && t.splice(r, 1);
            }
          }),
          (e.EMPTY = (function(e) {
            return (e.closed = !0), e;
          })(new e())),
          e
        );
      })();
    function ft(e) {
      return e.reduce(function(e, t) {
        return e.concat(t instanceof ct ? t.errors : t);
      }, []);
    }
    var pt = (function() {
        return "function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random();
      })(),
      vt = (function(e) {
        function t(r, i, n) {
          var s = e.call(this) || this;
          switch (
            ((s.syncErrorValue = null),
            (s.syncErrorThrown = !1),
            (s.syncErrorThrowable = !1),
            (s.isStopped = !1),
            arguments.length)
          ) {
            case 0:
              s.destination = ut;
              break;
            case 1:
              if (!r) {
                s.destination = ut;
                break;
              }
              if ("object" == typeof r) {
                r instanceof t
                  ? ((s.syncErrorThrowable = r.syncErrorThrowable), (s.destination = r), r.add(s))
                  : ((s.syncErrorThrowable = !0), (s.destination = new gt(s, r)));
                break;
              }
            default:
              (s.syncErrorThrowable = !0), (s.destination = new gt(s, r, i, n));
          }
          return s;
        }
        return (
          nt(t, e),
          (t.prototype[pt] = function() {
            return this;
          }),
          (t.create = function(e, r, i) {
            var n = new t(e, r, i);
            return (n.syncErrorThrowable = !1), n;
          }),
          (t.prototype.next = function(e) {
            this.isStopped || this._next(e);
          }),
          (t.prototype.error = function(e) {
            this.isStopped || ((this.isStopped = !0), this._error(e));
          }),
          (t.prototype.complete = function() {
            this.isStopped || ((this.isStopped = !0), this._complete());
          }),
          (t.prototype.unsubscribe = function() {
            this.closed || ((this.isStopped = !0), e.prototype.unsubscribe.call(this));
          }),
          (t.prototype._next = function(e) {
            this.destination.next(e);
          }),
          (t.prototype._error = function(e) {
            this.destination.error(e), this.unsubscribe();
          }),
          (t.prototype._complete = function() {
            this.destination.complete(), this.unsubscribe();
          }),
          (t.prototype._unsubscribeAndRecycle = function() {
            var e = this._parentOrParents;
            return (
              (this._parentOrParents = null),
              this.unsubscribe(),
              (this.closed = !1),
              (this.isStopped = !1),
              (this._parentOrParents = e),
              this
            );
          }),
          t
        );
      })(ht),
      gt = (function(e) {
        function t(t, r, i, n) {
          var s,
            a = e.call(this) || this;
          a._parentSubscriber = t;
          var o = a;
          return (
            st(r)
              ? (s = r)
              : r &&
                ((s = r.next),
                (i = r.error),
                (n = r.complete),
                r !== ut &&
                  (st((o = Object.create(r)).unsubscribe) && a.add(o.unsubscribe.bind(o)),
                  (o.unsubscribe = a.unsubscribe.bind(a)))),
            (a._context = o),
            (a._next = s),
            (a._error = i),
            (a._complete = n),
            a
          );
        }
        return (
          nt(t, e),
          (t.prototype.next = function(e) {
            if (!this.isStopped && this._next) {
              var t = this._parentSubscriber;
              ot.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable
                ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe()
                : this.__tryOrUnsub(this._next, e);
            }
          }),
          (t.prototype.error = function(e) {
            if (!this.isStopped) {
              var t = this._parentSubscriber,
                r = ot.useDeprecatedSynchronousErrorHandling;
              if (this._error)
                r && t.syncErrorThrowable
                  ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe())
                  : (this.__tryOrUnsub(this._error, e), this.unsubscribe());
              else if (t.syncErrorThrowable)
                r ? ((t.syncErrorValue = e), (t.syncErrorThrown = !0)) : lt(e), this.unsubscribe();
              else {
                if ((this.unsubscribe(), r)) throw e;
                lt(e);
              }
            }
          }),
          (t.prototype.complete = function() {
            var e = this;
            if (!this.isStopped) {
              var t = this._parentSubscriber;
              if (this._complete) {
                var r = function() {
                  return e._complete.call(e._context);
                };
                ot.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable
                  ? (this.__tryOrSetError(t, r), this.unsubscribe())
                  : (this.__tryOrUnsub(r), this.unsubscribe());
              } else this.unsubscribe();
            }
          }),
          (t.prototype.__tryOrUnsub = function(e, t) {
            try {
              e.call(this._context, t);
            } catch (e) {
              if ((this.unsubscribe(), ot.useDeprecatedSynchronousErrorHandling)) throw e;
              lt(e);
            }
          }),
          (t.prototype.__tryOrSetError = function(e, t, r) {
            if (!ot.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
            try {
              t.call(this._context, r);
            } catch (t) {
              return ot.useDeprecatedSynchronousErrorHandling
                ? ((e.syncErrorValue = t), (e.syncErrorThrown = !0), !0)
                : (lt(t), !0);
            }
            return !1;
          }),
          (t.prototype._unsubscribe = function() {
            var e = this._parentSubscriber;
            (this._context = null), (this._parentSubscriber = null), e.unsubscribe();
          }),
          t
        );
      })(vt);
    var mt = (function() {
      return ("function" == typeof Symbol && Symbol.observable) || "@@observable";
    })();
    function yt(e) {
      return e;
    }
    function Et(e) {
      return 0 === e.length
        ? yt
        : 1 === e.length
          ? e[0]
          : function(t) {
              return e.reduce(function(e, t) {
                return t(e);
              }, t);
            };
    }
    var Tt = (function() {
      function e(e) {
        (this._isScalar = !1), e && (this._subscribe = e);
      }
      return (
        (e.prototype.lift = function(t) {
          var r = new e();
          return (r.source = this), (r.operator = t), r;
        }),
        (e.prototype.subscribe = function(e, t, r) {
          var i = this.operator,
            n = (function(e, t, r) {
              if (e) {
                if (e instanceof vt) return e;
                if (e[pt]) return e[pt]();
              }
              return e || t || r ? new vt(e, t, r) : new vt(ut);
            })(e, t, r);
          if (
            (i
              ? n.add(i.call(n, this.source))
              : n.add(
                  this.source || (ot.useDeprecatedSynchronousErrorHandling && !n.syncErrorThrowable)
                    ? this._subscribe(n)
                    : this._trySubscribe(n)
                ),
            ot.useDeprecatedSynchronousErrorHandling &&
              n.syncErrorThrowable &&
              ((n.syncErrorThrowable = !1), n.syncErrorThrown))
          )
            throw n.syncErrorValue;
          return n;
        }),
        (e.prototype._trySubscribe = function(e) {
          try {
            return this._subscribe(e);
          } catch (t) {
            ot.useDeprecatedSynchronousErrorHandling && ((e.syncErrorThrown = !0), (e.syncErrorValue = t)),
              !(function(e) {
                for (; e; ) {
                  var t = e,
                    r = t.closed,
                    i = t.destination,
                    n = t.isStopped;
                  if (r || n) return !1;
                  e = i && i instanceof vt ? i : null;
                }
                return !0;
              })(e)
                ? console.warn(t)
                : e.error(t);
          }
        }),
        (e.prototype.forEach = function(e, t) {
          var r = this;
          return new (t = bt(t))(function(t, i) {
            var n;
            n = r.subscribe(
              function(t) {
                try {
                  e(t);
                } catch (e) {
                  i(e), n && n.unsubscribe();
                }
              },
              i,
              t
            );
          });
        }),
        (e.prototype._subscribe = function(e) {
          var t = this.source;
          return t && t.subscribe(e);
        }),
        (e.prototype[mt] = function() {
          return this;
        }),
        (e.prototype.pipe = function() {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          return 0 === e.length ? this : Et(e)(this);
        }),
        (e.prototype.toPromise = function(e) {
          var t = this;
          return new (e = bt(e))(function(e, r) {
            var i;
            t.subscribe(
              function(e) {
                return (i = e);
              },
              function(e) {
                return r(e);
              },
              function() {
                return e(i);
              }
            );
          });
        }),
        (e.create = function(t) {
          return new e(t);
        }),
        e
      );
    })();
    function bt(e) {
      if ((e || (e = ot.Promise || Promise), !e)) throw new Error("no Promise impl found");
      return e;
    }
    var St = (function() {
        function e() {
          return (
            Error.call(this), (this.message = "object unsubscribed"), (this.name = "ObjectUnsubscribedError"), this
          );
        }
        return (e.prototype = Object.create(Error.prototype)), e;
      })(),
      kt = (function(e) {
        function t(t, r) {
          var i = e.call(this) || this;
          return (i.subject = t), (i.subscriber = r), (i.closed = !1), i;
        }
        return (
          nt(t, e),
          (t.prototype.unsubscribe = function() {
            if (!this.closed) {
              this.closed = !0;
              var e = this.subject,
                t = e.observers;
              if (((this.subject = null), t && 0 !== t.length && !e.isStopped && !e.closed)) {
                var r = t.indexOf(this.subscriber);
                -1 !== r && t.splice(r, 1);
              }
            }
          }),
          t
        );
      })(ht),
      At = (function(e) {
        function t(t) {
          var r = e.call(this, t) || this;
          return (r.destination = t), r;
        }
        return nt(t, e), t;
      })(vt),
      wt = (function(e) {
        function t() {
          var t = e.call(this) || this;
          return (t.observers = []), (t.closed = !1), (t.isStopped = !1), (t.hasError = !1), (t.thrownError = null), t;
        }
        return (
          nt(t, e),
          (t.prototype[pt] = function() {
            return new At(this);
          }),
          (t.prototype.lift = function(e) {
            var t = new Rt(this, this);
            return (t.operator = e), t;
          }),
          (t.prototype.next = function(e) {
            if (this.closed) throw new St();
            if (!this.isStopped)
              for (var t = this.observers, r = t.length, i = t.slice(), n = 0; n < r; n++) i[n].next(e);
          }),
          (t.prototype.error = function(e) {
            if (this.closed) throw new St();
            (this.hasError = !0), (this.thrownError = e), (this.isStopped = !0);
            for (var t = this.observers, r = t.length, i = t.slice(), n = 0; n < r; n++) i[n].error(e);
            this.observers.length = 0;
          }),
          (t.prototype.complete = function() {
            if (this.closed) throw new St();
            this.isStopped = !0;
            for (var e = this.observers, t = e.length, r = e.slice(), i = 0; i < t; i++) r[i].complete();
            this.observers.length = 0;
          }),
          (t.prototype.unsubscribe = function() {
            (this.isStopped = !0), (this.closed = !0), (this.observers = null);
          }),
          (t.prototype._trySubscribe = function(t) {
            if (this.closed) throw new St();
            return e.prototype._trySubscribe.call(this, t);
          }),
          (t.prototype._subscribe = function(e) {
            if (this.closed) throw new St();
            return this.hasError
              ? (e.error(this.thrownError), ht.EMPTY)
              : this.isStopped
                ? (e.complete(), ht.EMPTY)
                : (this.observers.push(e), new kt(this, e));
          }),
          (t.prototype.asObservable = function() {
            var e = new Tt();
            return (e.source = this), e;
          }),
          (t.create = function(e, t) {
            return new Rt(e, t);
          }),
          t
        );
      })(Tt),
      Rt = (function(e) {
        function t(t, r) {
          var i = e.call(this) || this;
          return (i.destination = t), (i.source = r), i;
        }
        return (
          nt(t, e),
          (t.prototype.next = function(e) {
            var t = this.destination;
            t && t.next && t.next(e);
          }),
          (t.prototype.error = function(e) {
            var t = this.destination;
            t && t.error && this.destination.error(e);
          }),
          (t.prototype.complete = function() {
            var e = this.destination;
            e && e.complete && this.destination.complete();
          }),
          (t.prototype._subscribe = function(e) {
            return this.source ? this.source.subscribe(e) : ht.EMPTY;
          }),
          t
        );
      })(wt),
      Ct = (function(e) {
        function t(t) {
          var r = e.call(this) || this;
          return (r._value = t), r;
        }
        return (
          nt(t, e),
          Object.defineProperty(t.prototype, "value", {
            get: function() {
              return this.getValue();
            },
            enumerable: !0,
            configurable: !0
          }),
          (t.prototype._subscribe = function(t) {
            var r = e.prototype._subscribe.call(this, t);
            return r && !r.closed && t.next(this._value), r;
          }),
          (t.prototype.getValue = function() {
            if (this.hasError) throw this.thrownError;
            if (this.closed) throw new St();
            return this._value;
          }),
          (t.prototype.next = function(t) {
            e.prototype.next.call(this, (this._value = t));
          }),
          t
        );
      })(wt),
      Lt = function() {
        (this.state = new Ct(s)),
          (this.currentTime = new Ct(0)),
          (this.isCasting = new Ct(!1)),
          (this.isAdvertise = new Ct(!1)),
          (this.isMuted = new Ct(!1)),
          (this.isWidescreen = new Ct(!1)),
          (this.isFullscreen = new Ct(!1)),
          (this.volume = new Ct(1));
      },
      Dt = r(3),
      _t = (function() {
        function e(e) {
          var t = this;
          (this.player = e),
            (this.isLoaded = new Ct(!1)),
            (this.isReadyToInit = !1),
            (this.ads = []),
            (this.overlay = null),
            (this.skipAdBtn = null),
            (this.skipTime = 0),
            (this.vastClient = null),
            (this.vastTracker = null),
            (this.firstRollCounter = 0),
            (this.rollPeriodCounter = 0),
            (this.firstRollPrefix = "_vastFirstRoll"),
            (this.rollPeriodPrefix = "_vastRollPeriod"),
            (this.isActive = !1),
            (this.isShown = !1),
            (this.isVastSkipped = !1),
            (this.isSkipButtonClicked = !1),
            (this.isClicked = !1),
            (this.skipAdBtnIsActive = !0),
            (this.playButtonOverlayWrapper = null),
            (this.vastFileURL = ""),
            e.options.prerollAd.enabled &&
            e.options.prerollAd &&
            "object" == typeof e.options.prerollAd &&
            e.options.prerollAd.vastURL &&
            this.isVASTAllowed()
              ? ((this.isReadyToInit = !0), this.fetchVastFile())
              : (this.isLoaded.next(!0),
                (this.isShown = !0),
                (this.isVastSkipped = !0),
                this.player.options.brandPreroll.enabled &&
                  ((this.timer = setTimeout(function() {
                    t.player.continueAfterVAST(!0);
                  }, 0)),
                  (this.timer = null))),
            this.player.playerState.isAdvertise.subscribe(function(e) {
              return e ? t.player.container.addClass("playing-vast") : t.player.container.removeClass("playing-vast");
            });
        }
        return (
          (e.prototype.isVASTAllowed = function() {
            return (
              (this.firstRollCounter = this.getFirstRoll()),
              (this.rollPeriodCounter = this.getRollPeriod()),
              this.firstRollCounter < this.player.options.prerollAd.firstRoll
                ? (this.firstRollCounter++, this.setFirstRoll(this.firstRollCounter), !1)
                : this.firstRollCounter === this.player.options.prerollAd.firstRoll
                  ? (this.firstRollCounter++, this.setFirstRoll(this.firstRollCounter), !0)
                  : (this.rollPeriodCounter >= this.player.options.prerollAd.rollPeriod &&
                      ((this.rollPeriodCounter = -1), this.setRollPeriod(this.rollPeriodCounter)),
                    -1 === this.rollPeriodCounter
                      ? (this.rollPeriodCounter++, !0)
                      : (this.rollPeriodCounter++, this.setRollPeriod(this.rollPeriodCounter), !1))
            );
          }),
          (e.prototype.setFirstRoll = function(t) {
            e.setCookie(this.firstRollPrefix, t, 0);
          }),
          (e.prototype.setRollPeriod = function(t) {
            e.setCookie(this.rollPeriodPrefix, t, 0);
          }),
          (e.getCookie = function(e) {
            var t = ("; " + document.cookie).split("; " + e + "=");
            return 2 === t.length
              ? t
                  .pop()
                  .split(";")
                  .shift()
              : null;
          }),
          (e.setCookie = function(e, t, r) {
            var i = "";
            if (r) {
              var n = +new Date() + 60 * r * 60 * 1e3;
              i = "; expires=" + new Date(n).toUTCString();
            }
            document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + i + "; path=/";
          }),
          (e.prototype.getFirstRoll = function() {
            return +e.getCookie(this.firstRollPrefix);
          }),
          (e.prototype.getRollPeriod = function() {
            return +e.getCookie(this.rollPeriodPrefix);
          }),
          (e.prototype.fetchVastFile = function() {
            var e = this;
            (this.vastClient = new Dt.VASTClient()),
              this.vastClient
                .get(this.player.options.prerollAd.vastURL, { withCredentials: !0, timeout: 5e3 })
                .then(function(t) {
                  (e.ads = t.ads),
                    e.player.isAutoplay() ? e.setVideoAd() : e.setNextAdWatch(),
                    e.isLoaded.next(!0),
                    (e.isActive = !0);
                })
                .catch(function(t) {
                  e.player.log("VAST config loading error"),
                    e.setRollPeriod(e.rollPeriodCounter),
                    (e.isReadyToInit = !1),
                    e.player.playButtonOverlay.show(),
                    (e.isActive = !1),
                    (e.isSkipButtonClicked = !0),
                    e.player.titleText.text(e.player.options.title),
                    e.showUITopElements(),
                    (e.player.isVASTComplete = !1),
                    (e.player.isAdsEnabled = !e.player.options.videoEndOverlay.enabled),
                    setTimeout(function() {
                      e.player.playerState.state.next(d);
                    }, 50),
                    e.player.playerState.state.getValue() === s &&
                      (e.playButtonOverlayWrapper ? e.playButtonOverlayWrapper.show() : e.renderPlayButtonOverlay()),
                    e.player.isAutoplay()
                      ? (e.removePlayButton(),
                        setTimeout(function() {
                          e.player.continueAfterVAST(!1);
                        }, 55))
                      : e.player.continueAfterVAST(!1);
                });
          }),
          (e.prototype.setVideoAd = function() {
            var e = this,
              t = this.getNextAd();
            if (t) {
              this.hideUITopElements(), this.player.titleText.text(t.title);
              var r = t.creatives[0];
              if (r && r.mediaFiles[0]) {
                var i = this.player.playerState.currentTime.getValue() || 0;
                this.player.isHls && this.player.hls.destroy(),
                  (this.vastFileURL = r.mediaFiles[0].fileURL),
                  -1 !== this.vastFileURL.indexOf(".m3u8")
                    ? this.player.video.canPlayType("application/vnd.apple.mpegurl")
                      ? (this.player.video.src = this.vastFileURL)
                      : ye.a.isSupported() &&
                        ((this.player.hls = new ye.a()),
                        this.player.hls.loadSource(this.vastFileURL),
                        this.player.hls.attachMedia(this.player.video),
                        this.player.hls.on(ye.a.Events.ERROR, function(t, r) {
                          switch ((r.fatal && e.player.playerState.state.next(c), r.details)) {
                            case ye.a.ErrorDetails.FRAG_LOAD_ERROR:
                          }
                        }))
                    : this.player.playerHandler.setNewVideo(this.vastFileURL),
                  this.renderOverlay(r),
                  this.player.playerState.isAdvertise.next(!0),
                  (this.vastTracker = new Dt.VASTTracker(this.vastClient, t, t.creatives[0])),
                  this.setupVastEvents();
                var n = this.player.playerState.currentTime.subscribe(function(t) {
                    e.refreshSkipCounter(t.toFixed(0)), e.vastTracker.setProgress(t);
                  }),
                  s = this.player.playerState.state.subscribe(function(t) {
                    (t !== d && t !== c) ||
                      (t === d &&
                        (e.setRollPeriod(e.rollPeriodCounter),
                        (e.isReadyToInit = !1),
                        (e.isActive = !1),
                        e.vastTracker.complete(!0),
                        e.removePlayButton()),
                      t === c && (e.vastTracker.errorWithCode(405), e.player.uiRenderError("")),
                      e.player.playerHandler.setNewVideo(e.player.qualitySelector.getSource(), i),
                      e.player.playerState.isAdvertise.next(!1),
                      (e.skipTime = 0),
                      e.overlay.remove(),
                      (e.player.isVASTComplete = !0),
                      e.player.isAutoplay()
                        ? setTimeout(function() {
                            e.player.continueAfterVAST(!1);
                          }, 55)
                        : e.player.continueAfterVAST(!1),
                      e.player.titleText.text(e.player.options.title),
                      e.showUITopElements(),
                      e.player.playerHandler.play(),
                      s.unsubscribe(),
                      n.unsubscribe());
                  });
                this.vastTracker.trackImpression();
              }
            }
          }),
          (e.prototype.setupVastEvents = function() {
            var e = this;
            this.player.video.addEventListener("volumechange", function(t) {
              e.vastTracker.setMuted(t.target.muted);
            }),
              this.player.video.addEventListener("play", function() {
                0 !== e.player.video.currentTime && e.vastTracker.setPaused(!1);
              }),
              this.player.video.addEventListener("pause", function() {
                e.vastTracker.setPaused(!0);
              }),
              this.vastTracker.on("firstQuartile", function() {}),
              this.vastTracker.on("midpoint", function() {}),
              this.vastTracker.on("thirdQuartile", function() {});
          }),
          (e.prototype.getNextAd = function() {
            var e = Math.floor(Math.random() * this.ads.length);
            return this.ads[e] ? this.ads[e] : null;
          }),
          (e.prototype.setNextAdWatch = function() {
            this.setPreRollAd();
          }),
          (e.prototype.setPreRollAd = function() {
            var e = this,
              t = this.player.playerState.state.subscribe(function() {
                e.player.playerState.state.getValue() === l && (e.playNextAd(), t && t.unsubscribe());
              });
          }),
          (e.prototype.playNextAd = function() {
            this.player.playerHandler.pause(), this.setVideoAd(), this.player.playerHandler.play();
          }),
          (e.prototype.renderOverlay = function(e) {
            var t = this;
            (this.skipTime = e.skipDelay || this.player.options.prerollAd.skipDelay),
              this.skipTime > this.player.options.prerollAd.skipDelay &&
                (this.skipTime = this.player.options.prerollAd.skipDelay),
              this.skipTime &&
                ((this.skipAdBtn = new i("button")
                  .addClass("disabled")
                  .hide()
                  .on("click", function() {
                    return t.skipAd();
                  })),
                this.refreshSkipCounter()),
              (this.overlay = new i("div").addClass("vast-overlay").add([
                new i("a")
                  .attr("href", e.videoClickThroughURLTemplate.url)
                  .attr("target", "_blank")
                  .on("click", function() {
                    return t.handleAdClick();
                  }),
                this.skipAdBtn
              ])),
              this.player.container.add(this.overlay),
              this.setupPlayPauseEventsHandler();
          }),
          (e.prototype.setupPlayPauseEventsHandler = function() {
            var e = this;
            this.player.playerState.state.subscribe(function(t) {
              t === l &&
                (e.player.video.style.removeProperty("display"),
                e.skipAdBtn && e.showSkipButton(),
                e.playButtonOverlayWrapper && e.playButtonOverlayWrapper.hide()),
                t === u &&
                  e.player.video.duration !== e.player.video.currentTime &&
                  (e.playButtonOverlayWrapper ? e.playButtonOverlayWrapper.show() : e.renderPlayButton()),
                t === d && e.player.playButtonOverlay.hide();
            });
          }),
          (e.prototype.hideSkipButton = function() {
            this.skipAdBtn.hide();
          }),
          (e.prototype.showSkipButton = function() {
            this.skipAdBtn.show();
          }),
          (e.prototype.refreshSkipCounter = function(e) {
            void 0 === e && (e = 0);
            var t = "";
            if (this.skipTime > 0) {
              var r = this.skipTime - e;
              r > 0
                ? (t = "" + r)
                : (this.skipAdBtn.removeClass("disabled"), this.setRollPeriod(this.rollPeriodCounter));
            }
            this.skipAdBtnIsActive && +t > 0
              ? this.skipAdBtn.text(this.player.lang.get("skipVideoAdAfter") + " " + t)
              : this.skipAdBtn.text("" + this.player.lang.get("skipVideoAd")),
              this.skipTime - e <= 0 && (this.skipAdBtnIsActive = !1);
          }),
          (e.prototype.canSkip = function() {
            return this.skipTime > 0 && this.skipTime - this.player.playerState.currentTime.getValue().toFixed(0) <= 0;
          }),
          (e.prototype.handleAdClick = function() {
            this.player.playerHandler.pause(),
              (this.isActive = !0),
              this.skipAdBtn.removeClass("disabled").text("" + this.player.lang.get("skipVideoAd")),
              (this.isClicked = !0),
              this.vastTracker.click(),
              this.renderPlayButton();
          }),
          (e.prototype.renderPlayButton = function() {
            this.player.isMobile && this.renderPlayButtonOverlay();
          }),
          (e.prototype.renderPlayButtonOverlay = function() {}),
          (e.prototype.removePlayButton = function() {
            this.playButtonOverlayWrapper && this.playButtonOverlayWrapper.remove();
          }),
          (e.prototype.skipAd = function() {
            var e = this;
            this.canSkip() &&
              ((this.isActive = !1),
              (this.isSkipButtonClicked = !0),
              this.player.titleText.text(this.player.options.title),
              this.showUITopElements(),
              this.vastTracker.skip(),
              (this.player.isVASTComplete = !1),
              (this.player.isAdsEnabled = !this.player.options.videoEndOverlay.enabled),
              this.removePlayButton(),
              this.player.hls && this.player.hls.destroy(),
              setTimeout(function() {
                e.player.playerState.state.next(d);
              }, 50));
          }),
          (e.prototype.hideUITopElements = function() {
            this.player.titleWrapper.hide(), this.player.copyLinkWrapper.hide();
          }),
          (e.prototype.showUITopElements = function() {
            this.player.titleWrapper.show(), this.player.copyLinkWrapper.show();
          }),
          e
        );
      })(),
      It = (function() {
        function e(e) {
          this.player = e;
        }
        return (
          (e.prototype.getCurrentTime = function() {
            return this.player.playerState.currentTime.getValue();
          }),
          (e.prototype.pause = function() {
            this.player.playerHandler.pause();
          }),
          (e.prototype.play = function() {
            this.player.playerHandler.play();
          }),
          e
        );
      })(),
      xt = (function() {
        function e(e, t) {
          (this.playerWrapperWidthBuffer = 0),
            (this.isReduced = !1),
            (this.reducedVideoStartTime = 0),
            (this.brandPrerollCounter = 0),
            (this.brandPrerollCounterPrefix = "_brandPrerollCounter"),
            (this.version = "0.0.0"),
            (this.isBrandPrerollShown = !1),
            (this.isSourceVideoShown = !1),
            (this.videoDetailsIsShown = !1),
            (this.isVideoDetailsShown = !1),
            (this.isHls = !1),
            (this.isVASTComplete = !1),
            (this.isAdsEnabled = !0),
            (this.version = rt.version),
            new n(),
            (this.optionsDefault = m(tt)),
            (this.options = g(m(tt), t)),
            (this.wrapper = document.getElementById(e)),
            (this.firstStart = !0),
            (this.storage = new Ge()),
            (this.touchModeEnabled = matchMedia("(pointer:coarse)").matches || !1),
            (this.lang = new $e(this.options.language)),
            (this.http = new Ye()),
            (this.playerState = new Lt()),
            (this.api = new It(this)),
            (this.isVideoDetailsShown = this.storage.load("_isVideoDetailsShown", !1)),
            (this.isMobile = !!(
              navigator.userAgent.match(/Android/i) ||
              navigator.userAgent.match(/webOS/i) ||
              navigator.userAgent.match(/iPhone/i) ||
              navigator.userAgent.match(/iPad/i) ||
              navigator.userAgent.match(/iPod/i) ||
              navigator.userAgent.match(/BlackBerry/i) ||
              navigator.userAgent.match(/Windows Phone/i)
            )),
            (this.isEndCallbackFired = !1);
        }
        return (
          (e.prototype.init = function() {
            var e = this;
            this.updatePlayerOptions(), this.renderVideoDetailsButton();
            var t = !!document.createElement("video").canPlayType("video/mp4");
            return (
              this.renderPlayerBase(),
              (this.playerHandlerLocal = new p(this.video, this.playerState, this)),
              (this.playerHandler = this.playerHandlerLocal),
              this.renderPlayerUI(),
              this.uiToggleBuffering(!0),
              this.checkBrandPreroll(),
              this.options.hls
                ? (ye.a.isSupported()
                    ? ((this.hls = new ye.a()),
                      this.hls.loadSource(this.qualitySelector.activeSource.src),
                      this.hls.attachMedia(this.video),
                      (this.isHls = !0),
                      this.hls.on(ye.a.Events.ERROR, function(t, r) {
                        r.response && 404 === r.response.code && e.handleHLSNetworkError();
                      }),
                      this.initVAST())
                    : this.video.canPlayType("application/vnd.apple.mpegurl")
                      ? ((this.video.src = this.qualitySelector.activeSource.src), this.initVAST())
                      : this.uiRenderError("Your browser does not support HLS videos!"),
                  this.api)
                : (t ? this.initVAST() : this.uiRenderError("Your browser does not support mp4 videos!"), this.api)
            );
          }),
          (e.prototype.renderVideoDetailsButton = function() {
            var e = this;
            document.addEventListener("DOMContentLoaded", function() {
              e.isMobile &&
                e.options.detailsButton.enabled &&
                ((e.videoDetailsHTMLElement = document.querySelector(e.options.detailsButton.selector)),
                e.videoDetailsHTMLElement &&
                  ((e.showDetailsButton = new i("p")
                    .addClass("show-details-inner")
                    .addClass("copy-link-inactive")
                    .text(e.lang.get("showVideoDetails"))),
                  (e.showDetailsButtonWrapper = new i("div").addClass("show-details-wrapper").add(e.showDetailsButton)),
                  e.showDetailsButtonWrapper.hide(),
                  e.container.add(e.showDetailsButtonWrapper),
                  e.showDetailsButtonWrapper.on("click", function() {
                    (e.isVideoDetailsShown = !e.isVideoDetailsShown),
                      e.storage.save("_isVideoDetailsShown", e.isVideoDetailsShown),
                      e.isVideoDetailsShown
                        ? ((e.videoDetailsHTMLElement.style.display = "block"),
                          e.showDetailsButton.text(e.lang.get("hideVideoDetails")))
                        : ((e.videoDetailsHTMLElement.style.display = "none"),
                          e.showDetailsButton.text(e.lang.get("showVideoDetails")));
                  }),
                  e.playerState.state.subscribe(function(t) {
                    t === l && e.video.style.removeProperty("display"),
                      t !== u || e.videoDetailsIsShown || e.showDetailsButtonWrapper.show(),
                      (t === l ||
                        0 === e.video.currentTime ||
                        e.vastHandler.isActive ||
                        e.video.src === e.options.brandPreroll.url) &&
                        e.showDetailsButtonWrapper.hide();
                  }))),
                e.showVideoDetails();
            });
          }),
          (e.prototype.showVideoDetails = function() {
            this.isMobile &&
              this.isVideoDetailsShown &&
              ((this.videoDetailsHTMLElement = document.querySelector(this.options.detailsButton.selector)),
              this.videoDetailsHTMLElement && (this.videoDetailsHTMLElement.style.display = "block"));
          }),
          (e.prototype.updatePlayerOptions = function() {
            (this.reducedVideoStartTime = this.options.reduceVideo.startTime),
              (this.reducedVideoDuration = this.options.reduceVideo.duration),
              !this.options.interstitialAd.enabled &&
                this.options.videoEndOverlay.enabled &&
                (this.options.interstitialAd.enabled = !0);
            var e = /Trident.*rv[ :]*11\./.test(navigator.userAgent),
              t = /SMART-TV/.test(navigator.userAgent);
            (e || t) && (this.options.prerollAd.enabled = !1);
          }),
          (e.prototype.getCookie = function(e) {
            var t = ("; " + document.cookie).split("; " + e + "=");
            return 2 === t.length
              ? t
                  .pop()
                  .split(";")
                  .shift()
              : null;
          }),
          (e.prototype.getBrandPrerollCounter = function() {
            return +this.getCookie(this.brandPrerollCounterPrefix) || 0;
          }),
          (e.prototype.setBrandPrerollCounter = function(e) {
            this.setCookie(this.brandPrerollCounterPrefix, e, 0);
          }),
          (e.prototype.setCookie = function(e, t, r) {
            var i = "";
            if (r) {
              var n = +new Date() + 60 * r * 60 * 1e3;
              i = "; expires=" + new Date(n).toUTCString();
            }
            document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + i + "; path=/";
          }),
          (e.prototype.checkBrandPreroll = function() {
            this.options.brandPreroll.url || (this.options.brandPreroll.enabled = !1);
          }),
          (e.prototype.initVAST = function() {
            var e = this;
            (this.vastHandler = new _t(this)),
              this.vastHandler.isLoaded.subscribe(function(t) {
                t &&
                  e.playerState.state.subscribe(function(t) {
                    t === c && e.handleError(), t === o && e.initVideo(), t === d && e.continueAfterBrandPreroll();
                  });
              });
          }),
          (e.prototype.continueAfterVAST = function(e) {
            var t = this;
            if (
              ((this.vastHandler.isShown = !0),
              this.options.brandPreroll.enabled &&
                this.options.brandPreroll.viewLimit > 0 &&
                ((this.brandPrerollCounter = this.getBrandPrerollCounter()),
                this.vastHandler.isVastSkipped && this.brandPrerollCounter++,
                this.brandPrerollCounter > this.options.brandPreroll.viewLimit &&
                  (this.options.brandPreroll.enabled = !1),
                this.setBrandPrerollCounter(this.brandPrerollCounter)),
              this.isBrandPrerollisAllowed())
            )
              return (
                (this.video.src = this.options.brandPreroll.url),
                e || this.playerHandler.play(),
                this.showControlsBar(4e3),
                void (this.isBrandPrerollShown = !0)
              );
            (this.isSourceVideoShown = !0),
              this.hls && this.hls.detachMedia(),
              ye.a.isSupported() && this.options.hls
                ? ((this.isBrandPrerollShown = !0),
                  (this.hls = new ye.a()),
                  this.hls.loadSource(this.qualitySelector.activeSource.src),
                  this.hls.attachMedia(this.video),
                  (this.vastHandler.isShown = !0),
                  this.showControlsBar(4e3),
                  this.isAutoplay() && this.playerHandler.play(),
                  this.hls.on(ye.a.Events.ERROR, function(e, r) {
                    r.response && 404 === r.response.code && t.handleHLSNetworkError();
                  }))
                : ((this.isBrandPrerollShown = !0),
                  (this.video.src = this.qualitySelector.activeSource.src),
                  this.isAutoplay() && this.playerHandler.play());
          }),
          (e.prototype.isBrandPrerollisAllowed = function() {
            return (
              this.options.brandPreroll.enabled &&
              this.options.brandPreroll.url &&
              this.vastHandler.isVastSkipped &&
              !this.vastHandler.isSkipButtonClicked
            );
          }),
          (e.prototype.continueAfterBrandPreroll = function() {
            var e = this;
            this.options.brandPreroll.enabled ||
              (this.options.prerollAd.enabled && !this.vastHandler.isVastSkipped) ||
              (this.isSourceVideoShown = !0),
              this.isSourceVideoShown
                ? this.isEndCallbackFired ||
                  "function" != typeof this.options.onEndCallback ||
                  (this.options.onEndCallback(), (this.isEndCallbackFired = !0))
                : ((this.isSourceVideoShown = !0),
                  this.isBrandPrerollShown &&
                    this.options.brandPreroll.enabled &&
                    this.options.brandPreroll.url &&
                    ((this.options.brandPreroll.enabled = !1),
                    this.hls && this.hls.detachMedia(),
                    this.playButtonOverlay && this.playButtonOverlay.hide(),
                    ye.a.isSupported() && this.options.hls
                      ? ((this.hls = new ye.a()),
                        this.hls.loadSource(this.qualitySelector.activeSource.src),
                        this.hls.attachMedia(this.video),
                        this.playerHandler.play(),
                        this.showControlsBar(4e3),
                        this.hls.on(ye.a.Events.ERROR, function(t, r) {
                          r.response && 404 === r.response.code && e.handleHLSNetworkError();
                        }))
                      : ((this.video.src = this.qualitySelector.activeSource.src), this.playerHandler.play())));
          }),
          (e.prototype.initVideo = function() {
            var e = this;
            if (
              (this.setPlayerSize(),
              this.video.currentTime ||
                (this.vastHandler.isReadyToInit || this.isBrandPrerollisAllowed()
                  ? (this.video.currentTime = 0)
                  : (this.video.currentTime = this.options.startTime || this.getStartTime() || 0)),
              this.isAutoplay())
            )
              try {
                this.playerHandlerLocal.play().catch(function(t) {
                  "NotAllowedError" === t.name && e.renderIfAutoplayIsDisabled();
                });
              } catch (e) {
                this.log(e), this.renderIfAutoplayIsDisabled();
              }
            else this.renderIfAutoplayIsDisabled();
          }),
          (e.prototype.renderIfAutoplayIsDisabled = function() {
            !this.video.ended ||
            !this.options.videoEndOverlay.enabled ||
            (this.isReduced && this.video.currentTime === this.reducedVideoStartTime)
              ? (this.ads.show(), this.playButtonOverlay.show())
              : this.videoEndedOverlay.show();
          }),
          (e.prototype.renderPlayerBase = function() {
            var e = this;
            (this.container = new i().create("figure")),
              (this.containerWrapper = new i()
                .create("div")
                .addClass("video-player")
                .add(this.container)),
              (this.playbackRate = new ge(this));
            var t = new i()
              .create("video")
              .hide()
              .attr("preload", "metadata");
            this.container.add(t),
              t.attr("playsinline", null),
              (this.video = t.get()),
              (this.qualitySelector = new Ee(this)),
              (this.video.src = this.qualitySelector.getSource()),
              (this.poster = new i()
                .create("div")
                .addClass("poster")
                .style("backgroundImage", 'url("' + this.options.poster + '")')),
              this.container.add(this.poster),
              this.touchModeEnabled && this.container.addClass("touch-mode"),
              this.poster.on("click", function() {
                return e.handlePlayPause();
              }),
              this.container.on("mousemove", function() {
                e.touchModeEnabled ||
                  (e.handleMouseOver(),
                  (e.controlsContainerTimer = window.setTimeout(function() {
                    e.handleMouseOut();
                  }, 2e3)));
              }),
              this.handleMouseOver(),
              this.container.on("mousedown", function() {
                return e.container.addClass("mouse-down");
              }),
              document.addEventListener("mouseup", function() {
                return e.container.removeClass("mouse-down");
              }),
              (this.setPlayerSize = this.throttle(this.setPlayerSize, 100)),
              window.addEventListener("resize", function() {
                e.setPlayerSize();
              }),
              this.playerState.isWidescreen.subscribe(function() {
                return setTimeout(function() {
                  return e.setPlayerSize();
                }, 25);
              }),
              this.playerState.isFullscreen.subscribe(function() {
                return setTimeout(function() {
                  return e.setPlayerSize();
                }, 25);
              });
          }),
          (e.prototype.throttle = function(e, t) {
            var r,
              i,
              n = !1;
            return function s() {
              if (n) return (r = arguments), void (i = this);
              e.apply(this, arguments),
                (n = !0),
                setTimeout(function() {
                  (n = !1), r && (s.apply(i, r), (r = i = null));
                }, t);
            };
          }),
          (e.prototype.renderPlayerUI = function() {
            var e = this;
            (this.titleText = new i("p").addClass("title-inner").text(this.options.title)),
              (this.titleWrapper = new i("div").addClass("video-title-wrapper").add(this.titleText)),
              this.options.title && this.container.add(this.titleWrapper),
              this.options.showCopyLink &&
                ((this.copyLink = new i("p")
                  .addClass("copy-link-inner")
                  .addClass("copy-link-inactive")
                  .text(this.lang.get("copyLink"))),
                (this.copyLinkWrapper = new i("div").addClass("copy-link-wrapper").add(this.copyLink)),
                this.container.add(this.copyLinkWrapper),
                this.copyLinkWrapper.on("click", function() {
                  Ze(e.options.copyUrl),
                    e.copyLink.text(e.lang.get("copyLinkDone")),
                    e.copyLink.removeClass("copy-link-inactive"),
                    e.copyLink.addClass("copy-link-active"),
                    setTimeout(function() {
                      e.copyLink.text(e.lang.get("copyLink")),
                        e.copyLink.removeClass("copy-link-active"),
                        e.copyLink.addClass("copy-link-inactive");
                    }, 1e3);
                })),
              this.uiRenderBuffering(),
              (this.controlsContainer = new i().create("div").addClass("control-bar")),
              this.container.add(this.controlsContainer),
              (this.progressBar = new we(this)),
              this.controlsContainer.add(this.progressBar.getProgressBar()),
              this.isMobile &&
                (this.controlsContainer.hide(),
                this.playerState.state.subscribe(function(t) {
                  t === l && (e.video.style.removeProperty("display"), e.controlsContainer.show());
                })),
              (this.controlsBottomContainer = new i().create("div").addClass("control-bar-bottom")),
              (this.controlsBottomLeft = new i()
                .create("div")
                .addClass("control-bar-left-wrapper")
                .style("opacity", "0")),
              (this.controlsBottomRight = new i().create("div").addClass("control-bar-right-wrapper")),
              this.controlsBottomContainer.add(this.controlsBottomLeft).add(this.controlsBottomRight),
              this.renderPlayPause(),
              this.controlsBottomLeft.add(this.progressBar.getTimer()),
              (this.volume = new Ae(this)),
              this.controlsBottomLeft.add(this.volume.getVolumeBar()),
              (this.chromecast = new Pe(this)),
              (this.settings = new ve(this)),
              this.controlsBottomRight.add(this.settings.getSettingsWrapper()),
              this.renderWidescreen(),
              this.renderFullscreen(),
              this.controlsContainer.add(this.controlsBottomContainer),
              new i(this.wrapper).clearChilds().add(this.containerWrapper),
              this.setPlayerSize(),
              (this.keyBindHandler = new He(this)),
              this.options.logo && this.container.add(this.renderWatermark()),
              (this.ads = new Fe(this)),
              (this.playButtonOverlay = new Ne(this)),
              this.options.videoEndOverlay.enabled && (this.videoEndedOverlay = new Be(this)),
              (this.videoGesturesOverlay = new je(this)),
              (this.clickContextMenu = new et(this));
          }),
          (e.prototype.renderPlayPause = function() {
            var e = this;
            (this.playPauseBtnWrapper = new i()
              .create("div")
              .addClass("play-pause-button-wrapper")
              .addClass("tooltip-button")
              .addClass("tooltip-far-left")),
              (this.playPauseBtn = new i().create("button").addClass("play-pause-button")),
              this.uiRenderPause(),
              this.controlsBottomLeft.add(this.playPauseBtnWrapper.add(this.playPauseBtn)),
              this.playPauseBtnWrapper.on("click", function() {
                return e.playerHandler.handlePlayPause();
              }),
              this.playerState.state.subscribe(function(t) {
                t === l
                  ? (e.uiRenderPlay(),
                    e.video.style.removeProperty("display"),
                    e.playButtonOverlay && e.playButtonOverlay.hide())
                  : e.uiRenderPause();
              });
          }),
          (e.prototype.renderFullscreen = function() {
            (this.fullscreen = new Te(this)), this.controlsBottomRight.add(this.fullscreen.getBtn());
          }),
          (e.prototype.renderWidescreen = function() {
            this.options.widescreen.enabled &&
              ((this.widescreen = new Ke(this)), this.controlsBottomRight.add(this.widescreen.getBtn()));
          }),
          (e.prototype.renderWatermark = function() {
            return (
              (this.watermark = new i()
                .create("a")
                .addClass("watermark")
                .add(new i().create("img").attr("src", this.options.logo))),
              this.options.logoLink && this.watermark.attr("href", this.options.logoLink).attr("target", "_blank"),
              this.watermark
            );
          }),
          (e.prototype.handlePlayPauseOnKey = function() {
            this.video.paused
              ? (this.play(),
                this.options.videoEndOverlay.enabled &&
                  this.videoEndedOverlay &&
                  (this.videoEndedOverlay.isRendered = !1))
              : this.pause();
          }),
          (e.prototype.handlePlayPause = function() {
            this.video.paused
              ? (this.play(), this.options.videoEndOverlay.enabled && (this.videoEndedOverlay.isRendered = !1))
              : this.pause();
          }),
          (e.prototype.setPlayerSize = function() {
            var e = this.video.videoWidth || this.options.width || 240,
              t = this.video.videoHeight || this.options.height || 240,
              r = Math.max(e, t) / Math.min(e, t),
              n = this.containerWrapper.get().offsetWidth,
              s = Math.round((9 * n) / 16),
              a = new i(this.video);
            (e = Math.floor(s * r)),
              (t = s),
              this.progressBar.updateTimeBarOnResize(),
              this.playerState.isFullscreen.getValue()
                ? (a.style("width", "100%"), a.style("height", "100%"))
                : (a.style("width", e + "px"), a.style("height", t + "px")),
              this.aspectRatioFix ||
                ((this.aspectRatioFix = new i().create("div").addClass("aspect-ratio-fix")),
                this.containerWrapper.add(this.aspectRatioFix)),
              this.aspectRatioFix.style("height", t + "px");
          }),
          (e.prototype.play = function() {
            this.playerHandler.play();
          }),
          (e.prototype.pause = function() {
            this.playerHandler.pause();
          }),
          (e.prototype.handleVideoClick = function(e) {
            var t = this;
            if (
              !(
                this.settings.settingsWrapper.isVisible() ||
                this.settings.settingsPlayRateWrapper.isVisible() ||
                this.settings.settingsQualityWrapper.isVisible()
              )
            ) {
              var r = e.target;
              null == r.getAttribute("data-dblclick") &&
                (r.setAttribute("data-dblclick", 1),
                setTimeout(function() {
                  1 == r.getAttribute("data-dblclick") && t.handlePlayPause(), r.removeAttribute("data-dblclick");
                }, 300));
            }
          }),
          (e.prototype.getStartTime = function() {
            return (
              (this.startTimeFromSearchParams = +this.getStartTimeFromSearchParams()),
              this.isReduced
                ? this.reducedVideoStartTime <= this.startTimeFromSearchParams &&
                  this.reducedVideoStartTime + this.reducedVideoDuration > this.startTimeFromSearchParams
                  ? ((this.reducedVideoStartTime = this.startTimeFromSearchParams), this.reducedVideoStartTime)
                  : this.reducedVideoStartTime || 0
                : this.startTimeFromSearchParams
            );
          }),
          (e.prototype.getStartTimeFromSearchParams = function() {
            return ("function" == typeof URLSearchParams && new URLSearchParams(location.search).get("t")) || 0;
          }),
          (e.prototype.handleMouseOver = function() {
            clearTimeout(this.controlsContainerTimer), this.container.addClass("mouse-over");
          }),
          (e.prototype.handleMouseOut = function() {
            clearTimeout(this.controlsContainerTimer),
              this.video.paused || this.video.ended || this.container.removeClass("mouse-over");
          }),
          (e.prototype.seek = function(e) {
            var t = this.video.currentTime + e;
            t < 0 && (t = 0), t > this.video.duration && (t = this.video.duration), (this.video.currentTime = t);
          }),
          (e.prototype.showControlsBar = function(e) {
            var t = this;
            clearTimeout(this.controlsContainerTimer),
              this.container.addClass("mouse-over"),
              e &&
                (this.controlsContainerTimer = window.setTimeout(function() {
                  return t.hideControlsBar();
                }, e));
          }),
          (e.prototype.hideControlsBar = function() {
            clearTimeout(this.controlsContainerTimer),
              this.video.paused || this.video.ended || this.container.removeClass("mouse-over");
          }),
          (e.prototype.uiRenderPlay = function() {
            this.playPauseBtn.html(ee.getHtml()),
              this.container.removeClass("is-paused").addClass("is-playing"),
              this.playPauseBtn.removeClass("is-paused").addClass("is-playing"),
              this.playPauseBtnWrapper.attr("data-tooltip", this.lang.get("pause")),
              this.playButtonOverlay.hide(),
              this.firstStart && (this.poster.hide(), this.playButtonOverlay.hide(), (this.firstStart = !1)),
              this.touchModeEnabled && this.showControlsBar(4e3),
              this.vastHandler.isActive && this.playButtonOverlay.hide();
          }),
          (e.prototype.uiRenderPause = function() {
            if (this.vastHandler && this.vastHandler.isActive)
              return this.playButtonOverlay.hide(), void this.renderPauseIcon();
            "LOADING" !== this.playerState.state.value && this.renderPauseIcon();
          }),
          (e.prototype.renderPauseIcon = function() {
            this.playPauseBtn.html(te.getHtml()),
              this.container.removeClass("is-playing").addClass("is-paused"),
              this.playPauseBtn.removeClass("is-playing").addClass("is-paused"),
              this.playPauseBtnWrapper.attr("data-tooltip", this.lang.get("play"));
            var e = new CustomEvent("html5PlayerOnPause");
            window.dispatchEvent(e);
          }),
          (e.prototype.isAutoplay = function() {
            return (!this.options.autoplay.enabled && this.options.autoplay.active) || this.settings.autoplay.active;
          }),
          (e.prototype.uiRenderError = function(e) {
            this.errorBox
              ? e
                ? this.errorBox.text(e)
                : this.errorBox.remove()
              : (this.log("[ERROR] - " + e),
                (this.errorBox = new i()
                  .create("div")
                  .addClass("video-error")
                  .text(e)),
                this.container.add(this.errorBox));
          }),
          (e.prototype.uiRenderBuffering = function() {
            var e = this;
            this.bufferingSpinnerWrapper ||
              ((this.bufferingSpinnerWrapper = new i().create("div").addClass("video-buffering-spinner-wrapper")),
              this.container.add(this.bufferingSpinnerWrapper),
              (this.bufferingSpinner = new i().create("div").addClass("video-buffering-spinner")),
              this.bufferingSpinnerWrapper.add(this.bufferingSpinner),
              this.playerState.state.subscribe(function(t) {
                return e.uiToggleBuffering(t === a);
              }));
          }),
          (e.prototype.uiToggleBuffering = function(e) {
            e ? this.bufferingSpinner.show() : this.bufferingSpinner.hide();
          }),
          (e.prototype.handleHLSNetworkError = function() {
            var e = this,
              t = this.qualitySelector.activeSource.src,
              r = (this.getHostnameFromUrl(), this.qualitySelector.activeSource.desc),
              i = this.options.debugUrl,
              n = {
                errorCode: 4,
                errorMessage:
                  "The video could not be loaded, either because the server or network failed or because the format is not supported.",
                videoId: t,
                videoQuality: r,
                cdnNodeIp: ""
              },
              s = new We();
            this.bufferingSpinnerWrapper.hide(),
              this.uiRenderError(
                "The video could not be loaded, either because the server or network failed or because the format is not supported."
              ),
              s.isReported(n) ||
                (s.add(n),
                s.update(),
                this.http
                  .post({ url: i, params: n, headers: { "Content-type": "application/x-www-form-urlencoded" } })
                  .catch(function(t) {
                    e.log(t);
                  }));
          }),
          (e.prototype.getHostnameFromUrl = function() {
            var e = document.createElement("a");
            return (e.href = this.qualitySelector.activeSource.src), e.hostname;
          }),
          (e.prototype.handleError = function() {
            var e = this,
              t = this.playerHandler.getError();
            if (
              !(
                (/firefox/i.test(navigator.userAgent) && /An unknown error occurred/gi.test(t)) ||
                "You aborted the video playback." === t
              )
            ) {
              this.uiRenderError(t);
              var r = this.options.debugUrl;
              if (r) {
                var i = this.playerHandler.getErrorObject(),
                  n = new We();
                n.isReported(i) ||
                  (n.add(i),
                  n.update(),
                  this.http
                    .post({ url: r, params: i, headers: { "Content-type": "application/x-www-form-urlencoded" } })
                    .catch(function(t) {
                      e.log(t);
                    }));
              }
            }
          }),
          (e.prototype.log = function(e) {
            (/firefox/i.test(navigator.userAgent) && /An unknown error occurred/gi.test(e)) ||
              console.log("[PLAYER LOG]:", e);
          }),
          e
        );
      })();
    window.VideoPlayer = xt;
  }
]);
//# sourceMappingURL=bundle.js.map
